(function ()
{
    'use strict';

    angular
        .module('app.parametres.employes.profil', ["xeditable"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.employes.profil', {
            url      : '/profil/:token',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/parametres/employes/profil/profil.html',
                    controller : 'profilController as vm'
                }
            },
            resolve  : {
                Employe    : function (msApi, $stateParams)
                {
					if($stateParams.token!=0)
						return msApi.resolve('profil.details@get',{'IDEmploye': $stateParams.token});
					else
						return 0;
                },
                Permissions    : function (msApi)
                {
                    return msApi.resolve('profil.permissions@get');
                },
                Droits    : function (msApi)
                {
                    return msApi.resolve('profil.droits@get');
                }/*,
                APE    : function (msApi)
                {
                    return msApi.resolve('profil.APE@get');
                },
                Activites    : function (msApi)
                {
                    return msApi.resolve('profil.Activites@get');
                },
				Commandes: function (msApi, $stateParams)
				{
					return msApi.resolve('commandes.commandes@get',{'IDContact': $stateParams.token});
				},
				Employes: function (msApi)
				{
					return msApi.resolve('commandes.Employes@get');
				}*/
            },
            bodyClass: 'profil'
        });


        // Api
        msApiProvider.register('profil.details', ['/datas/employes/details.json']);
        msApiProvider.register('profil.permissions', ['/datas/employes/getPermissions.json']);
        msApiProvider.register('profil.droits', ['/datas/employes/getDroitsFormat.json']);
       /* msApiProvider.register('profil.APE', ['/datas/contacts/getAPE.json']);
        msApiProvider.register('profil.Activites', ['/datas/contacts/getActivites.json']);
        msApiProvider.register('commandes.commandes', ['datas/commandes/getAllcommandes.json']);
        msApiProvider.register('commandes.Employes', ['datas/employes/getEmployes.json']);*/

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.parametres.employes.profil')
        .controller('AboutDialogController', ProfilDialogController)
		.config(function($mdDateLocaleProvider) {
			$mdDateLocaleProvider.months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
			$mdDateLocaleProvider.shortMonths = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Jui', 'Aout', 'Sep', 'Oct', 'Nov', 'Déc'];
			$mdDateLocaleProvider.days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi','Jeudi','Vendredi','Samedi'];
			$mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', 'Me','Je','Ve','Sa'];
			$mdDateLocaleProvider.firstDayOfWeek = 1;
			$mdDateLocaleProvider.formatDate = function(date) {
			   var m = moment(date);
			   return m.isValid()? m.format('DD/MM/YYYY') : '';
			};
		});

    /** @ngInject */
    function ProfilDialogController($mdDialog, employe, permissions, Droits, IDEmploye, page, $rootScope, datas, $mdToast, $http, $scope, $element,$location)
    {
		
		var vm = this;
		vm.employe = angular.copy(employe);
		vm.droits = Droits.data;
		vm.Permission = $rootScope.Permission;
		// vm.droits= vm.droits.split(',');
		// console.log(vm.droits);
		vm.employe.Commission = parseInt(vm.employe.Commission);
		
		
		// vm.droits = vm.employe.Droits.split(',');
		// console.log(vm.droits);
		
		if(vm.employe.UniquementSesValeurs == true)
			vm.employe.UniquementSesValeurs = 1;
		
		if(vm.employe.VoirNotificationsAutres == true)
			vm.employe.VoirNotificationsAutres = 1;
		
		vm.permissions = angular.copy(permissions);
		vm.IDEmploye = angular.copy(IDEmploye);
		
		vm.datastoEdit = angular.copy(datas);
		
		vm.go = function(url){
			if(typeof vm.employe == "undefined" || typeof vm.employe.IDEmploye == "undefined")
			$location.path(url);
			vm.closeDialog();
		};
		
		if(typeof vm.datastoEdit == "undefined"){
			vm.datastoEdit = {"IDEmploye":vm.employe.IDEmploye, "Telephones":[], "Sites":[]};
		}
		
					
		$scope.searchTerm;
		$scope.clearSearchTerm = function() {
			$scope.searchTerm = '';
		};
		$element.find('input').on('keydown', function(ev) {
			ev.stopPropagation();
		});
				  
		vm.horaires = [
			'00:00',
			'00:30',
			'01:00',
			'01:30',
			'02:00',
			'02:30',
			'03:00',
			'03:30',
			'04:00',
			'04:30',
			'05:00',
			'05:30',
			'06:00',
			'06:30',
			'07:00',
			'07:30',
			'08:00',
			'08:30',
			'09:00',
			'09:30',
			'10:00',
			'10:30',
			'11:00',
			'11:30',
			'12:00',
			'12:30',
			'13:00',
			'13:30',
			'14:00',
			'14:30',
			'15:00',
			'15:30',
			'16:00',
			'16:30',
			'17:00',
			'17:30',
			'18:00',
			'18:30',
			'19:00',
			'19:30',
			'20:00',
			'20:30',
			'21:00',
			'21:30',
			'22:00',
			'22:30',
			'23:00',
			'23:30'
		];
  
        vm.saveEmploye = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/employes/setEmploye.json",JSON.stringify(vm.employe))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					if(response.data.data.error){
						$mdToast.show(
						  $mdToast.simple()
							.textContent(response.data.data.error.message)
							.position('bottom right' )
							.hideDelay(3000)
						);
						vm.showSpinner = 0;
					}
					else{
						$mdDialog.hide(response.data);
						vm.showSpinner = 0;
					}
				}
			}, function () {});		

        }
		
        vm.saveAdresses = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/employes/setAdresses.json",JSON.stringify(vm.datastoEdit)).then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});		

        }
		
        vm.saveVehicules = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/employes/setVehicule.json",JSON.stringify(vm.datastoEdit)).then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});		

        }
		
		$scope.$on('g-places-autocomplete:select', function (event, param) {
			var regex = /<span.*?<\/span>/g
			var matches = [];
			var match = regex.exec(param.adr_address);
			while (match != null) {
				matches.push(match[0]);
				match = regex.exec(param.adr_address);
			}
			
			var regex = /class=".*?">/g
			var matchesClass = [];
			var match = regex.exec(matches);
			while (match != null) {
				matchesClass.push(match[0]);
				match = regex.exec(matches);
			}
			
			 vm.datastoEdit.Adresse = "";
			 vm.datastoEdit.CP = "";
			 vm.datastoEdit.Ville = "";
			 vm.datastoEdit.Pays = "";
			for (var key = 0; key < matchesClass.length; key++ ) {
				var val = matchesClass[key].match('".*?"');
				switch (val[0]){
					case '"street-address"' : vm.datastoEdit.Adresse = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
					case '"postal-code"' : vm.datastoEdit.CP = matches[key].match('>.*?<')[0].replace('<','').replace('>',''); break;
					case '"locality"' : vm.datastoEdit.Ville = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
					case '"country-name"' : vm.datastoEdit.Pays = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
				}
			}

		});
			
			
        vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 

		

		function html_entity_decode(texte) {
			texte = texte.replace(/&quot;/g,'"'); // 34 22
			texte = texte.replace(/&amp;/g,'&'); // 38 26	
			texte = texte.replace(/&#39;/g,"'"); // 39 27
			texte = texte.replace(/&lt;/g,'<'); // 60 3C
			texte = texte.replace(/&gt;/g,'>'); // 62 3E
			texte = texte.replace(/&circ;/g,'^'); // 94 5E
			texte = texte.replace(/&lsquo;/g,'‘'); // 145 91
			texte = texte.replace(/&rsquo;/g,'’'); // 146 92
			texte = texte.replace(/&ldquo;/g,'“'); // 147 93
			texte = texte.replace(/&rdquo;/g,'”'); // 148 94
			texte = texte.replace(/&bull;/g,'•'); // 149 95
			texte = texte.replace(/&ndash;/g,'–'); // 150 96
			texte = texte.replace(/&mdash;/g,'—'); // 151 97
			texte = texte.replace(/&tilde;/g,'˜'); // 152 98
			texte = texte.replace(/&trade;/g,'™'); // 153 99
			texte = texte.replace(/&scaron;/g,'š'); // 154 9A
			texte = texte.replace(/&rsaquo;/g,'›'); // 155 9B
			texte = texte.replace(/&oelig;/g,'œ'); // 156 9C
			texte = texte.replace(/&#357;/g,''); // 157 9D
			texte = texte.replace(/&#382;/g,'ž'); // 158 9E
			texte = texte.replace(/&Yuml;/g,'Ÿ'); // 159 9F
			texte = texte.replace(/&nbsp;/g,' '); // 160 A0
			texte = texte.replace(/&iexcl;/g,'¡'); // 161 A1
			texte = texte.replace(/&cent;/g,'¢'); // 162 A2
			texte = texte.replace(/&pound;/g,'£'); // 163 A3
			texte = texte.replace(/&curren;/g,' '); // 164 A4
			texte = texte.replace(/&yen;/g,'¥'); // 165 A5
			texte = texte.replace(/&brvbar;/g,'¦'); // 166 A6
			texte = texte.replace(/&sect;/g,'§'); // 167 A7
			texte = texte.replace(/&uml;/g,'¨'); // 168 A8
			texte = texte.replace(/&copy;/g,'©'); // 169 A9
			texte = texte.replace(/&ordf;/g,'ª'); // 170 AA
			texte = texte.replace(/&laquo;/g,'«'); // 171 AB
			texte = texte.replace(/&not;/g,'¬'); // 172 AC
			texte = texte.replace(/&shy;/g,'­'); // 173 AD
			texte = texte.replace(/&reg;/g,'®'); // 174 AE
			texte = texte.replace(/&macr;/g,'¯'); // 175 AF
			texte = texte.replace(/&deg;/g,'°'); // 176 B0
			texte = texte.replace(/&plusmn;/g,'±'); // 177 B1
			texte = texte.replace(/&sup2;/g,'²'); // 178 B2
			texte = texte.replace(/&sup3;/g,'³'); // 179 B3
			texte = texte.replace(/&acute;/g,'´'); // 180 B4
			texte = texte.replace(/&micro;/g,'µ'); // 181 B5
			texte = texte.replace(/&para/g,'¶'); // 182 B6
			texte = texte.replace(/&middot;/g,'·'); // 183 B7
			texte = texte.replace(/&cedil;/g,'¸'); // 184 B8
			texte = texte.replace(/&sup1;/g,'¹'); // 185 B9
			texte = texte.replace(/&ordm;/g,'º'); // 186 BA
			texte = texte.replace(/&raquo;/g,'»'); // 187 BB
			texte = texte.replace(/&frac14;/g,'¼'); // 188 BC
			texte = texte.replace(/&frac12;/g,'½'); // 189 BD
			texte = texte.replace(/&frac34;/g,'¾'); // 190 BE
			texte = texte.replace(/&iquest;/g,'¿'); // 191 BF
			texte = texte.replace(/&Agrave;/g,'À'); // 192 C0
			texte = texte.replace(/&Aacute;/g,'Á'); // 193 C1
			texte = texte.replace(/&Acirc;/g,'Â'); // 194 C2
			texte = texte.replace(/&Atilde;/g,'Ã'); // 195 C3
			texte = texte.replace(/&Auml;/g,'Ä'); // 196 C4
			texte = texte.replace(/&Aring;/g,'Å'); // 197 C5
			texte = texte.replace(/&AElig;/g,'Æ'); // 198 C6
			texte = texte.replace(/&Ccedil;/g,'Ç'); // 199 C7
			texte = texte.replace(/&Egrave;/g,'È'); // 200 C8
			texte = texte.replace(/&Eacute;/g,'É'); // 201 C9
			texte = texte.replace(/&Ecirc;/g,'Ê'); // 202 CA
			texte = texte.replace(/&Euml;/g,'Ë'); // 203 CB
			texte = texte.replace(/&Igrave;/g,'Ì'); // 204 CC
			texte = texte.replace(/&Iacute;/g,'Í'); // 205 CD
			texte = texte.replace(/&Icirc;/g,'Î'); // 206 CE
			texte = texte.replace(/&Iuml;/g,'Ï'); // 207 CF
			texte = texte.replace(/&ETH;/g,'Ð'); // 208 D0
			texte = texte.replace(/&Ntilde;/g,'Ñ'); // 209 D1
			texte = texte.replace(/&Ograve;/g,'Ò'); // 210 D2
			texte = texte.replace(/&Oacute;/g,'Ó'); // 211 D3
			texte = texte.replace(/&Ocirc;/g,'Ô'); // 212 D4
			texte = texte.replace(/&Otilde;/g,'Õ'); // 213 D5
			texte = texte.replace(/&Ouml;/g,'Ö'); // 214 D6
			texte = texte.replace(/&times;/g,'×'); // 215 D7
			texte = texte.replace(/&Oslash;/g,'Ø'); // 216 D8
			texte = texte.replace(/&Ugrave;/g,'Ù'); // 217 D9
			texte = texte.replace(/&Uacute;/g,'Ú'); // 218 DA
			texte = texte.replace(/&Ucirc;/g,'Û'); // 219 DB
			texte = texte.replace(/&Uuml;/g,'Ü'); // 220 DC
			texte = texte.replace(/&Yacute;/g,'Ý'); // 221 DD
			texte = texte.replace(/&THORN;/g,'Þ'); // 222 DE
			texte = texte.replace(/&szlig;/g,'ß'); // 223 DF
			texte = texte.replace(/&agrave;/g,'à'); // 224 E0
			texte = texte.replace(/&aacute;/g,'á'); // 225 E1
			texte = texte.replace(/&acirc;/g,'â'); // 226 E2
			texte = texte.replace(/&atilde;/g,'ã'); // 227 E3
			texte = texte.replace(/&auml;/g,'ä'); // 228 E4
			texte = texte.replace(/&aring;/g,'å'); // 229 E5
			texte = texte.replace(/&aelig;/g,'æ'); // 230 E6
			texte = texte.replace(/&ccedil;/g,'ç'); // 231 E7
			texte = texte.replace(/&egrave;/g,'è'); // 232 E8
			texte = texte.replace(/&eacute;/g,'é'); // 233 E9
			texte = texte.replace(/&ecirc;/g,'ê'); // 234 EA
			texte = texte.replace(/&euml;/g,'ë'); // 235 EB
			texte = texte.replace(/&igrave;/g,'ì'); // 236 EC
			texte = texte.replace(/&iacute;/g,'í'); // 237 ED
			texte = texte.replace(/&icirc;/g,'î'); // 238 EE
			texte = texte.replace(/&iuml;/g,'ï'); // 239 EF
			texte = texte.replace(/&eth;/g,'ð'); // 240 F0
			texte = texte.replace(/&ntilde;/g,'ñ'); // 241 F1
			texte = texte.replace(/&ograve;/g,'ò'); // 242 F2
			texte = texte.replace(/&oacute;/g,'ó'); // 243 F3
			texte = texte.replace(/&ocirc;/g,'ô'); // 244 F4
			texte = texte.replace(/&otilde;/g,'õ'); // 245 F5
			texte = texte.replace(/&ouml;/g,'ö'); // 246 F6
			texte = texte.replace(/&divide;/g,'÷'); // 247 F7
			texte = texte.replace(/&oslash;/g,'ø'); // 248 F8
			texte = texte.replace(/&ugrave;/g,'ù'); // 249 F9
			texte = texte.replace(/&uacute;/g,'ú'); // 250 FA
			texte = texte.replace(/&ucirc;/g,'û'); // 251 FB
			texte = texte.replace(/&uuml;/g,'ü'); // 252 FC
			texte = texte.replace(/&yacute;/g,'ý'); // 253 FD
			texte = texte.replace(/&thorn;/g,'þ'); // 254 FE
			texte = texte.replace(/&yuml;/g,'ÿ'); // 255 FF
			return texte;
		}


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.parametres.employes.profil')
        .controller('AvatarDialogController', AvatarDialogController)
		.config(function ($mdDateLocaleProvider) {
			$mdDateLocaleProvider.formatDate = function (date) {
				return date ? moment(date).format('DD/MM/YYYY') : '';
			};

			$mdDateLocaleProvider.parseDate = function (dateString) {
				var m = moment(dateString, 'DD/MM/YYYY', true);
				return m.isValid() ? m.toDate() : new Date(NaN);
			};
		});

    /** @ngInject */
    function AvatarDialogController($mdDialog, Employe, $mdToast, $http, $element)
    {
		
		var vm = this;
		vm.employe = angular.copy(Employe);
		
		vm.selectImage = function(event){
			$mdDialog.show({
                controller         : 'ImageDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/parametres/images/dialogs/images-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : event,
                clickOutsideToClose: true,
				multiple : true,
                locals             : {
					link : "employes/uploadAvatar",
					Params : vm.employe,
					multipleUpload : false,
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					vm.employe.Avatar = response.url;
				}
			});
		}
		
		
        vm.saveAvatar = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/employes/saveAvatar.json",JSON.stringify(vm.employe))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					if(response.data.error){
						$mdToast.show(
						  $mdToast.simple()
							.textContent(response.data.error.message)
							.position('bottom right' )
							.hideDelay(3000)
						);
						vm.showSpinner = 0;
					}
					else{
						vm.employe.Avatar = response.data.data;
						// vm.employe
						$mdDialog.hide(vm.employe);
						vm.showSpinner = 0;
					}
				}
			}, function () {});	

        }
		
        vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts.profil', ["xeditable"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.contacts.profil', {
            url      : '/profil/:token',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/contacts/profil/profil.html',
                    controller : 'profilContactController as vm'
                }
            },
            resolve  : {
                Contact    : function (msApi, $stateParams)
                {
                    return msApi.resolve('profilContact.details@get',{'IDContact': $stateParams.token});
                },
				// Commandes: function (msApi, $stateParams)
				// {
					// return msApi.resolve('commandes.commandes@get',{'IDContact': $stateParams.token, 'Commandes': "all"});
				// },
				employesSimple: function (msApi)
				{
					return msApi.resolve('employes.simpleListe@get');
				},
				Courriers: function (msApi, $stateParams)
				{
					return msApi.resolve('courriers.courriers@get',{'IDContact': $stateParams.token});
				},
				/* Alertes: function (msApi, $stateParams)
				{
					return msApi.resolve('profilContact.Alertes@get',{'IDContact': $stateParams.token});
				}, */
                Structures    : function (msApi)
                {
                    return msApi.resolve('profilContact.structures@get');
                },
                APE    : function (msApi)
                {
                    return msApi.resolve('profilContact.APE@get');
                },
                Activites    : function (msApi)
                {
                    return msApi.resolve('profilContact.Activites@get');
                },
				Fabricants: function (msApi)
				{
					return msApi.resolve('commandes.fabricants@get');
				},
				Employes: function (msApi)
				{
					return msApi.resolve('commandes.Employes@get');
				},
				Dialog: function (msApi)
				{
					return false;
				}
            },
            bodyClass: 'profil'
        });


        // Api
        msApiProvider.register('profilContact.details', ['/datas/contacts/details.json']);
        // msApiProvider.register('commandes.commandes', ['datas/commandes/getAllcommandes.json']);
        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
        msApiProvider.register('courriers.courriers', ['datas/courriers/getCourriers.json']);
        msApiProvider.register('profilContact.structures', ['/datas/contacts/getStructures.json']);
        msApiProvider.register('profilContact.APE', ['/datas/contacts/getAPE.json']);
        msApiProvider.register('profilContact.Activites', ['/datas/contacts/getActivites.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
        msApiProvider.register('commandes.Employes', ['datas/employes/getEmployes.json']);
        // msApiProvider.register('profilContact.Alertes', ['datas/alertes/getAlertes.json']);

    }

})();
(function () {
    'use strict';

    angular.module('app.contacts.profil').controller('ContactDocumentDialogController', ContactDocumentDialogController);

    /** @ngInject */
    function ContactDocumentDialogController(Document, IDContact, $http, $mdDialog) {
        var vm = this;
        vm.document = angular.copy(Document || {});
        vm.document.IDContact = Number(IDContact);
        vm.categories = ['Administratif', 'Commercial', 'Comptable', 'Contrat', 'Courrier', 'Juridique', 'Technique', 'Autre'];
        vm.document.Categorie = vm.document.Categorie || 'Autre';
        vm.dateDocument = vm.document.DateDocument ? new Date(vm.document.DateDocument + 'T00:00:00') : null;
        vm.busy = false; vm.error = '';
        function formatDate(date) {
            if (!date || isNaN(date.getTime())) return '';
            function pad(value) { return ('0' + value).slice(-2); }
            return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
        }
        vm.annuler = function () { if (!vm.busy) $mdDialog.cancel(); };
        vm.enregistrer = function (form) {
            if (vm.busy || form.$invalid) return;
            if (!vm.document.IDDocument && !vm.file) { vm.error = 'Sélectionner le fichier du document.'; return; }
            if (vm.file && (vm.file.size > 20 * 1024 * 1024 || !/\.(pdf|jpe?g|png|txt|csv|docx?|xlsx?|odt|ods)$/i.test(vm.file.name))) {
                vm.error = 'Le format du fichier n’est pas autorisé ou sa taille dépasse 20 Mo.'; return;
            }
            vm.document.DateDocument = formatDate(vm.dateDocument);
            var data = new FormData(); data.append('data', angular.toJson(vm.document));
            if (vm.file) data.append('file', vm.file);
            vm.error = ''; vm.busy = true;
            $http.post('/datas/documents/editDocument.json', data, {headers:{'Content-Type':undefined},transformRequest:angular.identity})
                .then(function (response) {
                    if (!response.data || response.data.error || !response.data.data) {
                        vm.error = response.data && response.data.error && response.data.error.message || 'Enregistrement refusé.'; return;
                    }
                    $mdDialog.hide(response.data.data);
                }, function () { vm.error = 'Enregistrement impossible.'; })
                .finally(function () { vm.busy = false; });
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.parametres.employes.profil')
        .controller('DeleteEmployeDialogController', DeleteEmployeDialogController);

    /** @ngInject */
    function DeleteEmployeDialogController($mdDialog, Employe, Employes, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		
		vm.employe = angular.copy(Employe);
		vm.employes = angular.copy(Employes);
		
  
        vm.deleteEmploye = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/employes/deleteEmploye.json",JSON.stringify(vm.employe))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});		

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.parametres.droits.droits', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.parametres_droits_droits', {
                url    : '/administration/droits',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/parametres/droits/droits/droits.html',
                        controller : 'DroitsController as vm'
                    }
                },
				resolve: {
					Droits: function (msApi)
					{
						return msApi.resolve('droits.droits@get',{'logs': true});
					},
					Permissions: function (msApi)
					{
                    return msApi.resolve('droits.permissions@get');
					}
				}
            });
			
        msApiProvider.register('droits.droits', ['datas/employes/getDroits.json']);
        msApiProvider.register('droits.permissions', ['datas/employes/getPermissions.json']);

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.parametres.droits.droits')
        .controller('PermissionDialogController', PermissionDialogController);

    /** @ngInject */
    function PermissionDialogController($mdDialog, Permission, Permissions, Droits, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		
		vm.permission = angular.copy(Permission);
		vm.permissions = angular.copy(Permissions);
		vm.droits = angular.copy(Droits);
		
  
        vm.savePermission = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/employes/editPermission.json",JSON.stringify(vm.permission))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.parametres.droits.droits')
        .controller('DroitDialogController', DroitDialogController);

    /** @ngInject */
    function DroitDialogController($mdDialog, Droit, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		vm.droit = angular.copy(Droit);
		
  
        vm.saveDroit = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/employes/editDroit.json",JSON.stringify(vm.droit))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});		

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 
    }
})();
(function () {
    'use strict';

    angular.module('app.contacts.profil').controller('ContactDocumentsController', ContactDocumentsController);

    /** @ngInject */
    function ContactDocumentsController($scope, $rootScope, $http, $mdDialog, $mdToast, $window, $compile, $location, DTOptionsBuilder, DTColumnBuilder) {
        var vm = this;
        vm.contact = $scope.vm.contact;
        vm.rows = [];
        vm.recordsTotal = 0;
        vm.dtInstance = {};
        vm.filterSave = [];
        vm.categories = ['Administratif', 'Commercial', 'Comptable', 'Contrat', 'Courrier', 'Juridique', 'Technique', 'Autre'];

        vm.droits = function (action) {
            if ($rootScope.Permission === 'Super Admin') return true;
            var droit = 'gestion.contacts.documents' + (action ? '.' + action : '');
            return ($rootScope.droits || []).indexOf(droit) !== -1;
        };
        function toast(message) { $mdToast.show($mdToast.simple().textContent(message).position('bottom right').hideDelay(4000)); }
        function erreur(response) {
            var detail = response && response.data && (response.data.error || (response.data.data && response.data.data.error));
            toast(detail && detail.message || 'Action impossible.');
        }
        function renderTexte(data, type) {
            var value = data === null || data === undefined ? '' : String(data);
            return type === 'display' ? value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') : value;
        }
        function renderDate(data, type) {
            if (type === 'display' && /^\d{4}-\d{2}-\d{2}/.test(data || '')) return data.slice(0, 10).split('-').reverse().join('/');
            return renderTexte(data, type);
        }
        function recharger() { if (vm.dtInstance.reloadData) vm.dtInstance.reloadData(null, false); }

        vm.telecharger = function (document) {
            if (document) $window.open('/datas/documents/telecharger.json?IDDocument=' + encodeURIComponent(document.IDDocument), '_blank');
        };
        vm.editer = function (event, ligne) {
            if (!vm.droits('edition')) return;
            var ouvrir = function (detail) {
                $mdDialog.show({
                    controller:'ContactDocumentDialogController', controllerAs:'vm',
                    templateUrl:'app/main/contacts/profil/tabs/documents/dialogs/document-dialog.html',
                    parent:angular.element(window.document.body), targetEvent:event,
                    clickOutsideToClose:false, multiple:true,
                    locals:{Document:detail || {}, IDContact:Number(vm.contact.IDContact)}
                }).then(function () { recharger(); toast(detail && detail.IDDocument ? 'Le document a été modifié.' : 'Le document a été ajouté.'); }, angular.noop);
            };
            if (!ligne) return ouvrir({});
            $http.get('/datas/documents/getDocument.json', {params:{IDDocument:ligne.IDDocument, IDContact:vm.contact.IDContact}})
                .then(function (response) { ouvrir(response.data.data); }, erreur);
        };
        vm.supprimer = function (event, document) {
            if (!vm.droits('suppression') || !document) return;
            $mdDialog.show($mdDialog.confirm().title('Supprimer ce document ?')
                .textContent('Le document « ' + document.Titre + ' » sera supprimé de la fiche du contact.')
                .targetEvent(event).theme('md-warn').ok('Supprimer').cancel('Annuler')).then(function () {
                    $http.post('/datas/documents/deleteDocument.json', {IDDocument:document.IDDocument, IDContact:vm.contact.IDContact})
                        .then(function (response) { if (response.data.error) return erreur(response); recharger(); toast('Le document a été supprimé.'); }, erreur);
                }, angular.noop);
        };

        vm.dtColumns = [
            DTColumnBuilder.newColumn('Titre').withTitle('<div class="table-header"><span class="column-title">Document</span></div>').renderWith(renderTexte),
            DTColumnBuilder.newColumn('Categorie').withTitle('<div class="table-header"><span class="column-title">Catégorie</span></div>').withOption('width','130px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('DateDocument').withTitle('<div class="table-header"><span class="column-title">Date</span></div>').withOption('width','110px').renderWith(renderDate),
            DTColumnBuilder.newColumn('Reference').withTitle('<div class="table-header"><span class="column-title">Référence</span></div>').withOption('width','150px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('NomOriginal').withTitle('<div class="table-header"><span class="column-title">Fichier</span></div>').renderWith(renderTexte),
            DTColumnBuilder.newColumn('DateCreation').withTitle('<div class="table-header"><span class="column-title">Ajouté le</span></div>').withOption('width','110px').renderWith(renderDate),
            DTColumnBuilder.newColumn(null).withTitle('<div class="table-header"><span class="column-title"></span></div>').withOption('width','50px').notSortable().withOption('searchable',false)
                .renderWith(function (data, type, row, meta) {
                    vm.rows[meta.row] = row;
                    if (type !== 'display') return '';
                    var ref = 'documentsVm.rows[' + meta.row + ']';
                    return '<md-menu style="float:right"><md-button class="md-icon-button" aria-label="Actions" ng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3">' +
                        '<md-menu-item><md-button ng-click="documentsVm.telecharger(' + ref + ')">Télécharger</md-button></md-menu-item>' +
                        '<md-menu-item><md-button ng-click="documentsVm.editer($event,' + ref + ')" ng-disabled="!documentsVm.droits(\'edition\')">Modifier</md-button></md-menu-item>' +
                        '<md-divider></md-divider><md-menu-item><md-button ng-click="documentsVm.supprimer($event,' + ref + ')" ng-disabled="!documentsVm.droits(\'suppression\') || ' + ref + '.NombreOperations > 0">Supprimer</md-button></md-menu-item>' +
                        '</md-menu-content></md-menu>';
                })
        ];
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {dataSrc:'data', url:'/datas/documents/getDocumentsContact.json?IDContact=' + encodeURIComponent(vm.contact.IDContact), type:'GET'})
            .withDataProp('data').withOption('processing',true).withOption('serverSide',true)
            .withOption('bStateSave',true).withOption('iCookieDuration',60*60*12)
            .withOption('stateSaveCallback', function (settings, data) { localStorage.setItem('documentsContactTable', JSON.stringify(data)); })
            .withOption('stateLoadCallback', function () {
                try { var saved = JSON.parse(localStorage.getItem('documentsContactTable')); return saved && saved.columns.length === vm.dtColumns.length ? saved : null; }
                catch (ignore) { return null; }
            })
            .withOption('stateLoadParams', function (settings, data) { vm.filterSave = data.columns || []; })
            .withOption('columnDefs',[{targets:[0,6],responsivePriority:1}])
            .withOption('responsive',{details:{display:$.fn.dataTable.Responsive.display.childRowImmediate,type:'none',target:''}})
            .withOption('pagingType','simple').withOption('lengthMenu',[25,50,100]).withPaginationType('simple')
            .withOption('dom','rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('headerCallback', function (header) { if (!vm.headerCompiled) { vm.headerCompiled = true; $compile(angular.element(header).contents())($scope); } })
            .withOption('createdRow', function (row) { $compile(angular.element(row).contents())($scope); })
            .withOption('drawCallback', function () { vm.recordsTotal = this.api().page.info().recordsTotal; $scope.$evalAsync(); })
            .withOption('initComplete', function () {
                var api = this.api();
                angular.forEach(vm.filterSave, function (value, key) {
                    var parts = value.search.search.split('~');
                    angular.element(api.table().header()).find('tr:eq(1) th').eq(key).find('input,select')
                        .each(function (index) { angular.element(this).val(parts[index] || ''); });
                });
            })
            .withLightColumnFilter({
                '0':{html:'input',type:'text',location:$location},
                '1':{html:'select',values:[{value:'',label:'--'}].concat(vm.categories.map(function (categorie) { return {value:categorie,label:categorie}; })),regex:true,location:$location},
                '2':{html:'range',type:'date',location:$location},
                '3':{html:'input',type:'text',location:$location},
                '4':{html:'input',type:'text',location:$location},
                '5':{html:'range',type:'date',location:$location},
                '6':{html:'clear'}
            })
            .withLanguage({
                'sProcessing':'<md-progress-linear md-mode="indeterminate"></md-progress-linear>',
                'sLengthMenu':'Afficher _MENU_ éléments','sInfo':"Affichage de l'élément _START_ à _END_ sur _TOTAL_",
                'sInfoEmpty':"Affichage de l'élément 0 à 0 sur 0",'sInfoFiltered':'(filtré de _MAX_ éléments au total)',
                'sLoadingRecords':'Chargement en cours...','sZeroRecords':'Aucun élément à afficher','sEmptyTable':'Aucun document disponible',
                'oPaginate':{'sFirst':'Premier','sPrevious':'Précédent','sNext':'Suivant','sLast':'Dernier'}
            }).withOption('order',[2,'desc']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.profil')
        .controller('EchangesContactDialogController', EchangesContactDialogController)
		.config(function($mdDateLocaleProvider) {
			$mdDateLocaleProvider.months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
			$mdDateLocaleProvider.shortMonths = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Jui', 'Aout', 'Sep', 'Oct', 'Nov', 'Déc'];
			$mdDateLocaleProvider.days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi','Jeudi','Vendredi','Samedi'];
			$mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', 'Me','Je','Ve','Sa'];
			$mdDateLocaleProvider.firstDayOfWeek = 1;
			$mdDateLocaleProvider.formatDate = function(date) {
				if(date)
					return moment(date).format('DD/MM/YYYY');
				else
					return ""
			};
		})
		.filter('DateFormat', function myDateFormat($filter){
		  return function(text){
			var  tempdate= new Date(text);
			return $filter('date')(tempdate, "dd/MM/yyyy HH:mm");
		  }
		})
		.filter('split', function() {
			return function(input) {
				var html = "";
				angular.forEach(JSON.parse(input),function(v){
					if(html != "")
						html += ", ";
					html += v;
				});
				return html;
			}
		});
    /** @ngInject */
    function EchangesContactDialogController(Echange,$mdDialog,$sce)
    {
		
		var vm = this;
		vm.echange = angular.copy(Echange);
		vm.link = $sce.trustAsResourceUrl("https://crm.exodream.com/datas/contacts/getExchangeBody/"+vm.echange.IDContacts_Echange);
		 // 
		vm.resizeIframe = function(obj) {
			var newheight;
			var newwidth;

			if(document.getElementById){
				newheight = document.getElementById(obj).contentWindow.document .body.scrollHeight;
				newwidth = document.getElementById(obj).contentWindow.document .body.scrollWidth;
			}

			document.getElementById(obj).height = (newheight) + "px";
			document.getElementById(obj).width = (newwidth) + "px";
	
        }
		
        vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts.profil')
        .controller('AboutContactDialogController', AboutContactDialogController)
		.config(function($mdDateLocaleProvider) {
			$mdDateLocaleProvider.months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
			$mdDateLocaleProvider.shortMonths = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Jui', 'Aout', 'Sep', 'Oct', 'Nov', 'Déc'];
			$mdDateLocaleProvider.days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi','Jeudi','Vendredi','Samedi'];
			$mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', 'Me','Je','Ve','Sa'];
			$mdDateLocaleProvider.firstDayOfWeek = 1;
			$mdDateLocaleProvider.formatDate = function(date) {
				if(date)
					return moment(date).format('DD/MM/YYYY');
				else
					return ""
			};
		});

    /** @ngInject */
    function AboutContactDialogController($mdDialog, contact, structures, APE, Activites, page, datas, $http, $scope, $element)
    {
		
		var vm = this;
		vm.contact = angular.copy(contact);
		vm.structures = angular.copy(structures);
		vm.APE = angular.copy(APE);
		
		vm.webregex = RegExp('^((https?|ftp)://)?([a-z]+[.])?[a-z0-9-]+([.][a-z]{1,6}){1,2}(/.*[?].*)?$', 'i');
		 
		vm.datastoEdit = angular.copy(datas);
		vm.structures_selected = vm.contact.legales.Structure;
		
		vm.select_structure = function(structure){vm.structures_selected = structure;}
		
		if(typeof vm.datastoEdit == "undefined"){
			vm.datastoEdit = {"IDContact":vm.contact.IDContact, "Telephones":[null], "Emails":[]};
		}
		
					
		$scope.searchTerm;
		$scope.clearSearchTerm = function() {
			$scope.searchTerm = '';
		};
		$element.find('input').on('keydown', function(ev) {
			ev.stopPropagation();
		});
				  
		vm.horaires = [
			'00:00',
			'00:30',
			'01:00',
			'01:30',
			'02:00',
			'02:30',
			'03:00',
			'03:30',
			'04:00',
			'04:30',
			'05:00',
			'05:30',
			'06:00',
			'06:30',
			'07:00',
			'07:30',
			'08:00',
			'08:30',
			'09:00',
			'09:30',
			'10:00',
			'10:30',
			'11:00',
			'11:30',
			'12:00',
			'12:30',
			'13:00',
			'13:30',
			'14:00',
			'14:30',
			'15:00',
			'15:30',
			'16:00',
			'16:30',
			'17:00',
			'17:30',
			'18:00',
			'18:30',
			'19:00',
			'19:30',
			'20:00',
			'20:30',
			'21:00',
			'21:30',
			'22:00',
			'22:30',
			'23:00',
			'23:30'
		];
		
		/*vm.initSiteArray = function(){
			vm.siteArray = [];
			angular.forEach(vm.contact.Sites, function(value, key) {
				vm.siteArray.push('Sites['+key+']');
			});
		}
		vm.initSiteArray();
	
		$scope.status = [];
		vm.testSiteExist = function(url, index) {
			var siteArray = 'Sites['+index+']';
			$http.post("/datas/sites/testSiteExist.json",JSON.stringify({'url':url, "IDContact":vm.contact.IDContact}))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$scope.employeForm[siteArray].$setValidity("newURLFailed", false);
					$scope.status[index] = response.data.error.message;
				}
				else{					
					$scope.employeForm[siteArray].$setValidity("newURLFailed", true);
				}
			});	
			
		};*/


        vm.saveContact = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/contacts/setContact.json",JSON.stringify(vm.contact))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
        vm.saveIBAN = function()
        {
			
			vm.showSpinner = 1;
			$http.post("/datas/contacts/setIBAN.json",JSON.stringify(vm.datastoEdit)).then(function (response, status, headers, config) {
				if(response.data.error){
					$scope.employeForm.URL.$setValidity("URLFailed", false);
					$scope.status = response.data.error.message;
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});	

        }
		
        vm.saveSiteInternet = function()
        {
			
			vm.showSpinner = 1;
			$http.post("/datas/contacts/setSiteInternet.json",JSON.stringify(vm.datastoEdit)).then(function (response, status, headers, config) {
				if(response.data.error){
					$scope.employeForm.URL.$setValidity("URLFailed", false);
					$scope.status = response.data.error.message;
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
        vm.saveAdresses = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/contacts/setAdresses.json",JSON.stringify(vm.datastoEdit)).then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
        vm.saveCoordonnees = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/contacts/setCoordonnees.json",JSON.stringify(vm.datastoEdit)).then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});	

        }
      
	  
		$scope.$on('g-places-autocomplete:select', function (event, param) {
			var regex = /<span.*?<\/span>/g
			var matches = [];
			var match = regex.exec(param.adr_address);
			while (match != null) {
				matches.push(match[0]);
				match = regex.exec(param.adr_address);
			}
			
			var regex = /class=".*?">/g
			var matchesClass = [];
			var match = regex.exec(matches);
			while (match != null) {
				matchesClass.push(match[0]);
				match = regex.exec(matches);
			}
			
			 vm.datastoEdit.Adresse = "";
			 vm.datastoEdit.CP = "";
			 vm.datastoEdit.Ville = "";
			 vm.datastoEdit.Pays = "";
			for (var key = 0; key < matchesClass.length; key++ ) {
				var val = matchesClass[key].match('".*?"');
				switch (val[0]){
					case '"street-address"' : vm.datastoEdit.Adresse = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
					case '"postal-code"' : vm.datastoEdit.CP = matches[key].match('>.*?<')[0].replace('<','').replace('>',''); break;
					case '"locality"' : vm.datastoEdit.Ville = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
					case '"country-name"' : vm.datastoEdit.Pays = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
				}
			}

		});
			
			
        vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 

		

		function html_entity_decode(texte) {
			texte = texte.replace(/&quot;/g,'"'); // 34 22
			texte = texte.replace(/&amp;/g,'&'); // 38 26	
			texte = texte.replace(/&#39;/g,"'"); // 39 27
			texte = texte.replace(/&lt;/g,'<'); // 60 3C
			texte = texte.replace(/&gt;/g,'>'); // 62 3E
			texte = texte.replace(/&circ;/g,'^'); // 94 5E
			texte = texte.replace(/&lsquo;/g,'‘'); // 145 91
			texte = texte.replace(/&rsquo;/g,'’'); // 146 92
			texte = texte.replace(/&ldquo;/g,'“'); // 147 93
			texte = texte.replace(/&rdquo;/g,'”'); // 148 94
			texte = texte.replace(/&bull;/g,'•'); // 149 95
			texte = texte.replace(/&ndash;/g,'–'); // 150 96
			texte = texte.replace(/&mdash;/g,'—'); // 151 97
			texte = texte.replace(/&tilde;/g,'˜'); // 152 98
			texte = texte.replace(/&trade;/g,'™'); // 153 99
			texte = texte.replace(/&scaron;/g,'š'); // 154 9A
			texte = texte.replace(/&rsaquo;/g,'›'); // 155 9B
			texte = texte.replace(/&oelig;/g,'œ'); // 156 9C
			texte = texte.replace(/&#357;/g,''); // 157 9D
			texte = texte.replace(/&#382;/g,'ž'); // 158 9E
			texte = texte.replace(/&Yuml;/g,'Ÿ'); // 159 9F
			texte = texte.replace(/&nbsp;/g,' '); // 160 A0
			texte = texte.replace(/&iexcl;/g,'¡'); // 161 A1
			texte = texte.replace(/&cent;/g,'¢'); // 162 A2
			texte = texte.replace(/&pound;/g,'£'); // 163 A3
			texte = texte.replace(/&curren;/g,' '); // 164 A4
			texte = texte.replace(/&yen;/g,'¥'); // 165 A5
			texte = texte.replace(/&brvbar;/g,'¦'); // 166 A6
			texte = texte.replace(/&sect;/g,'§'); // 167 A7
			texte = texte.replace(/&uml;/g,'¨'); // 168 A8
			texte = texte.replace(/&copy;/g,'©'); // 169 A9
			texte = texte.replace(/&ordf;/g,'ª'); // 170 AA
			texte = texte.replace(/&laquo;/g,'«'); // 171 AB
			texte = texte.replace(/&not;/g,'¬'); // 172 AC
			texte = texte.replace(/&shy;/g,'­'); // 173 AD
			texte = texte.replace(/&reg;/g,'®'); // 174 AE
			texte = texte.replace(/&macr;/g,'¯'); // 175 AF
			texte = texte.replace(/&deg;/g,'°'); // 176 B0
			texte = texte.replace(/&plusmn;/g,'±'); // 177 B1
			texte = texte.replace(/&sup2;/g,'²'); // 178 B2
			texte = texte.replace(/&sup3;/g,'³'); // 179 B3
			texte = texte.replace(/&acute;/g,'´'); // 180 B4
			texte = texte.replace(/&micro;/g,'µ'); // 181 B5
			texte = texte.replace(/&para/g,'¶'); // 182 B6
			texte = texte.replace(/&middot;/g,'·'); // 183 B7
			texte = texte.replace(/&cedil;/g,'¸'); // 184 B8
			texte = texte.replace(/&sup1;/g,'¹'); // 185 B9
			texte = texte.replace(/&ordm;/g,'º'); // 186 BA
			texte = texte.replace(/&raquo;/g,'»'); // 187 BB
			texte = texte.replace(/&frac14;/g,'¼'); // 188 BC
			texte = texte.replace(/&frac12;/g,'½'); // 189 BD
			texte = texte.replace(/&frac34;/g,'¾'); // 190 BE
			texte = texte.replace(/&iquest;/g,'¿'); // 191 BF
			texte = texte.replace(/&Agrave;/g,'À'); // 192 C0
			texte = texte.replace(/&Aacute;/g,'Á'); // 193 C1
			texte = texte.replace(/&Acirc;/g,'Â'); // 194 C2
			texte = texte.replace(/&Atilde;/g,'Ã'); // 195 C3
			texte = texte.replace(/&Auml;/g,'Ä'); // 196 C4
			texte = texte.replace(/&Aring;/g,'Å'); // 197 C5
			texte = texte.replace(/&AElig;/g,'Æ'); // 198 C6
			texte = texte.replace(/&Ccedil;/g,'Ç'); // 199 C7
			texte = texte.replace(/&Egrave;/g,'È'); // 200 C8
			texte = texte.replace(/&Eacute;/g,'É'); // 201 C9
			texte = texte.replace(/&Ecirc;/g,'Ê'); // 202 CA
			texte = texte.replace(/&Euml;/g,'Ë'); // 203 CB
			texte = texte.replace(/&Igrave;/g,'Ì'); // 204 CC
			texte = texte.replace(/&Iacute;/g,'Í'); // 205 CD
			texte = texte.replace(/&Icirc;/g,'Î'); // 206 CE
			texte = texte.replace(/&Iuml;/g,'Ï'); // 207 CF
			texte = texte.replace(/&ETH;/g,'Ð'); // 208 D0
			texte = texte.replace(/&Ntilde;/g,'Ñ'); // 209 D1
			texte = texte.replace(/&Ograve;/g,'Ò'); // 210 D2
			texte = texte.replace(/&Oacute;/g,'Ó'); // 211 D3
			texte = texte.replace(/&Ocirc;/g,'Ô'); // 212 D4
			texte = texte.replace(/&Otilde;/g,'Õ'); // 213 D5
			texte = texte.replace(/&Ouml;/g,'Ö'); // 214 D6
			texte = texte.replace(/&times;/g,'×'); // 215 D7
			texte = texte.replace(/&Oslash;/g,'Ø'); // 216 D8
			texte = texte.replace(/&Ugrave;/g,'Ù'); // 217 D9
			texte = texte.replace(/&Uacute;/g,'Ú'); // 218 DA
			texte = texte.replace(/&Ucirc;/g,'Û'); // 219 DB
			texte = texte.replace(/&Uuml;/g,'Ü'); // 220 DC
			texte = texte.replace(/&Yacute;/g,'Ý'); // 221 DD
			texte = texte.replace(/&THORN;/g,'Þ'); // 222 DE
			texte = texte.replace(/&szlig;/g,'ß'); // 223 DF
			texte = texte.replace(/&agrave;/g,'à'); // 224 E0
			texte = texte.replace(/&aacute;/g,'á'); // 225 E1
			texte = texte.replace(/&acirc;/g,'â'); // 226 E2
			texte = texte.replace(/&atilde;/g,'ã'); // 227 E3
			texte = texte.replace(/&auml;/g,'ä'); // 228 E4
			texte = texte.replace(/&aring;/g,'å'); // 229 E5
			texte = texte.replace(/&aelig;/g,'æ'); // 230 E6
			texte = texte.replace(/&ccedil;/g,'ç'); // 231 E7
			texte = texte.replace(/&egrave;/g,'è'); // 232 E8
			texte = texte.replace(/&eacute;/g,'é'); // 233 E9
			texte = texte.replace(/&ecirc;/g,'ê'); // 234 EA
			texte = texte.replace(/&euml;/g,'ë'); // 235 EB
			texte = texte.replace(/&igrave;/g,'ì'); // 236 EC
			texte = texte.replace(/&iacute;/g,'í'); // 237 ED
			texte = texte.replace(/&icirc;/g,'î'); // 238 EE
			texte = texte.replace(/&iuml;/g,'ï'); // 239 EF
			texte = texte.replace(/&eth;/g,'ð'); // 240 F0
			texte = texte.replace(/&ntilde;/g,'ñ'); // 241 F1
			texte = texte.replace(/&ograve;/g,'ò'); // 242 F2
			texte = texte.replace(/&oacute;/g,'ó'); // 243 F3
			texte = texte.replace(/&ocirc;/g,'ô'); // 244 F4
			texte = texte.replace(/&otilde;/g,'õ'); // 245 F5
			texte = texte.replace(/&ouml;/g,'ö'); // 246 F6
			texte = texte.replace(/&divide;/g,'÷'); // 247 F7
			texte = texte.replace(/&oslash;/g,'ø'); // 248 F8
			texte = texte.replace(/&ugrave;/g,'ù'); // 249 F9
			texte = texte.replace(/&uacute;/g,'ú'); // 250 FA
			texte = texte.replace(/&ucirc;/g,'û'); // 251 FB
			texte = texte.replace(/&uuml;/g,'ü'); // 252 FC
			texte = texte.replace(/&yacute;/g,'ý'); // 253 FD
			texte = texte.replace(/&thorn;/g,'þ'); // 254 FE
			texte = texte.replace(/&yuml;/g,'ÿ'); // 255 FF
			return texte;
		}


		vm.activites  = Activites;
		vm.querySearch   = querySearch;

		vm.newActivity = newActivity;

		function newActivity(item, $index) {
			vm.activites.push({
			  value: item.toLowerCase(),
			  display: item
			});
			vm.contact.Activites[$index] = item;
		}

		function querySearch (query) {
			var results = query ? vm.activites.filter( createFilterFor(query) ) : vm.activites, deferred;
			return results;
		}

		function createFilterFor(query) {
		  var lowercaseQuery = angular.lowercase(query);

		  return function filterFn(state) {
			return (state.value.indexOf(lowercaseQuery) === 0);
		  };

		}
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.frais.edition', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
		// app.commandes.edition
            .state('app.collaborateurs_frais.edition', {
                url    : '/edition/:token',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/collaborateurs/frais/edition/editionfrais.html',
                        controller : 'editionfraisController as vm'
                    }
                },
               resolve  : {
                   employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.listeCollaborateursEdit@get');
                    },
                    RaisonSociale: function (msApi)
                    {
                        return msApi.resolve('contacts.RaisonSociale@get');
                    },
                    AdressesContacts: function (msApi)
                    {
                        return msApi.resolve('contacts.AdressesContacts@get');
                    },
                   AdressesEmploye: function (msApi)
                    {
                        return msApi.resolve('employes.getAdressesEmploye@get');
                    },
                    Responsables: function (msApi)
                    {
                        return msApi.resolve('contacts.Responsables@get');
                    },
                    Vehicules: function (msApi)
                    {
                        return msApi.resolve('contacts.Vehicules@get');
                    },
                    Listefrais: function (msApi, $stateParams)
                    {
                        return msApi.resolve('employes.getDetailsFrais@get',{'IDEmployes_NoteFrais': $stateParams.token});
                    }
                },
                bodyClass: 'frais'
            });
        
        msApiProvider.register('employes.listeCollaborateursEdit', ['datas/employes/listeCollaborateursEdit.json']);
        msApiProvider.register('contacts.RaisonSociale', ['datas/contacts/getAllRaisonSociale.json']);
        msApiProvider.register('contacts.Vehicules', ['datas/employes/getVehicules.json']);
        msApiProvider.register('contacts.AdressesContacts', ['datas/contacts/getAllAdresses.json']);
        msApiProvider.register('contacts.Responsables', ['datas/contacts/getAllResponsables.json']);
        msApiProvider.register('employes.getDetailsFrais', ['datas/employes/getDetailsFrais.json']);
        msApiProvider.register('employes.getAdressesEmploye', ['datas/employes/getAdressesEmploye.json']);

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.frais.edition')
        .controller('NoteFraisDialogController', NoteFraisDialogController);

    /** @ngInject */
    function NoteFraisDialogController($mdDialog, employesSimple, IDEmployes_NoteFrais, Note, RaisonSociale, AdressesContacts, AdressesEmploye, Vehicules, Responsables, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		
		vm.employesSimple = angular.copy(employesSimple);
		vm.contacts = angular.copy(RaisonSociale.data);
		vm.adressesContacts = angular.copy(AdressesContacts.data);
		vm.responsables = angular.copy(Responsables.data);
		vm.adressesEmploye = angular.copy(AdressesEmploye.data);
		vm.note = angular.copy(Note);
		vm.vehicules = angular.copy(Vehicules.data);
		
		vm.files = "";
		
		if(typeof vm.note == "undefined")
			vm.note = {IDEmployes_NoteFrais:IDEmployes_NoteFrais, Date:"", Type:"", InvitesExterne : []};
  
        vm.savenote = function()
        {
			vm.showSpinner = 1;
			if(typeof vm.note.AdresseDepart == "object"){
				 vm.note.AdresseDepart =  vm.note.AdresseDepart.formatted_address;
			}
			if(typeof vm.note.AdresseArrivee == "object"){
				 vm.note.AdresseArrivee =  vm.note.AdresseArrivee.formatted_address;
			}
			
			var fd = new FormData();			 
			fd.append("data", angular.toJson(vm.note));
			
			var files = $('#file')[0].files;
			
			if(files.length > 0 ){
				$(files).each(function(key,value){
					fd.append('file'+key,files[key]);
				});
			}
			var config = { headers: {'Content-Type': undefined},
						   transformRequest: angular.identity
						 }
						 
			$http.post("/datas/employes/editNote.json", fd, config)
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 
		
		/* $scope.$on('g-places-autocomplete:select', function (event, param) {
			var regex = /<span.*?<\/span>/g
			var matches = [];
			var match = regex.exec(param.adr_address);
			while (match != null) {
				matches.push(match[0]);
				match = regex.exec(param.adr_address);
			}
			
			var regex = /class=".*?">/g
			var matchesClass = [];
			var match = regex.exec(matches);
			while (match != null) {
				matchesClass.push(match[0]);
				match = regex.exec(matches);
			}
			
			 // vm.datastoEdit.Adresse = "";
			 // vm.datastoEdit.CP = "";
			 // vm.datastoEdit.Ville = "";
			 // vm.datastoEdit.Pays = "";
			for (var key = 0; key < matchesClass.length; key++ ) {
				var val = matchesClass[key].match('".*?"');
			
				switch (val[0]){
					case '"street-address"' : vm.note.Adresse = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
					case '"postal-code"' : vm.note.CP = matches[key].match('>.*?<')[0].replace('<','').replace('>',''); break;
					case '"locality"' : vm.note.Ville = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
					case '"country-name"' : vm.note.Pays = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
				}
			}
			console.log($(this));
			console.log(event);
			console.log(param);

		}); */
		
		function html_entity_decode(texte) {
			texte = texte.replace(/&quot;/g,'"'); // 34 22
			texte = texte.replace(/&amp;/g,'&'); // 38 26	
			texte = texte.replace(/&#39;/g,"'"); // 39 27
			texte = texte.replace(/&lt;/g,'<'); // 60 3C
			texte = texte.replace(/&gt;/g,'>'); // 62 3E
			texte = texte.replace(/&circ;/g,'^'); // 94 5E
			texte = texte.replace(/&lsquo;/g,'‘'); // 145 91
			texte = texte.replace(/&rsquo;/g,'’'); // 146 92
			texte = texte.replace(/&ldquo;/g,'“'); // 147 93
			texte = texte.replace(/&rdquo;/g,'”'); // 148 94
			texte = texte.replace(/&bull;/g,'•'); // 149 95
			texte = texte.replace(/&ndash;/g,'–'); // 150 96
			texte = texte.replace(/&mdash;/g,'—'); // 151 97
			texte = texte.replace(/&tilde;/g,'˜'); // 152 98
			texte = texte.replace(/&trade;/g,'™'); // 153 99
			texte = texte.replace(/&scaron;/g,'š'); // 154 9A
			texte = texte.replace(/&rsaquo;/g,'›'); // 155 9B
			texte = texte.replace(/&oelig;/g,'œ'); // 156 9C
			texte = texte.replace(/&#357;/g,''); // 157 9D
			texte = texte.replace(/&#382;/g,'ž'); // 158 9E
			texte = texte.replace(/&Yuml;/g,'Ÿ'); // 159 9F
			texte = texte.replace(/&nbsp;/g,' '); // 160 A0
			texte = texte.replace(/&iexcl;/g,'¡'); // 161 A1
			texte = texte.replace(/&cent;/g,'¢'); // 162 A2
			texte = texte.replace(/&pound;/g,'£'); // 163 A3
			texte = texte.replace(/&curren;/g,' '); // 164 A4
			texte = texte.replace(/&yen;/g,'¥'); // 165 A5
			texte = texte.replace(/&brvbar;/g,'¦'); // 166 A6
			texte = texte.replace(/&sect;/g,'§'); // 167 A7
			texte = texte.replace(/&uml;/g,'¨'); // 168 A8
			texte = texte.replace(/&copy;/g,'©'); // 169 A9
			texte = texte.replace(/&ordf;/g,'ª'); // 170 AA
			texte = texte.replace(/&laquo;/g,'«'); // 171 AB
			texte = texte.replace(/&not;/g,'¬'); // 172 AC
			texte = texte.replace(/&shy;/g,'­'); // 173 AD
			texte = texte.replace(/&reg;/g,'®'); // 174 AE
			texte = texte.replace(/&macr;/g,'¯'); // 175 AF
			texte = texte.replace(/&deg;/g,'°'); // 176 B0
			texte = texte.replace(/&plusmn;/g,'±'); // 177 B1
			texte = texte.replace(/&sup2;/g,'²'); // 178 B2
			texte = texte.replace(/&sup3;/g,'³'); // 179 B3
			texte = texte.replace(/&acute;/g,'´'); // 180 B4
			texte = texte.replace(/&micro;/g,'µ'); // 181 B5
			texte = texte.replace(/&para/g,'¶'); // 182 B6
			texte = texte.replace(/&middot;/g,'·'); // 183 B7
			texte = texte.replace(/&cedil;/g,'¸'); // 184 B8
			texte = texte.replace(/&sup1;/g,'¹'); // 185 B9
			texte = texte.replace(/&ordm;/g,'º'); // 186 BA
			texte = texte.replace(/&raquo;/g,'»'); // 187 BB
			texte = texte.replace(/&frac14;/g,'¼'); // 188 BC
			texte = texte.replace(/&frac12;/g,'½'); // 189 BD
			texte = texte.replace(/&frac34;/g,'¾'); // 190 BE
			texte = texte.replace(/&iquest;/g,'¿'); // 191 BF
			texte = texte.replace(/&Agrave;/g,'À'); // 192 C0
			texte = texte.replace(/&Aacute;/g,'Á'); // 193 C1
			texte = texte.replace(/&Acirc;/g,'Â'); // 194 C2
			texte = texte.replace(/&Atilde;/g,'Ã'); // 195 C3
			texte = texte.replace(/&Auml;/g,'Ä'); // 196 C4
			texte = texte.replace(/&Aring;/g,'Å'); // 197 C5
			texte = texte.replace(/&AElig;/g,'Æ'); // 198 C6
			texte = texte.replace(/&Ccedil;/g,'Ç'); // 199 C7
			texte = texte.replace(/&Egrave;/g,'È'); // 200 C8
			texte = texte.replace(/&Eacute;/g,'É'); // 201 C9
			texte = texte.replace(/&Ecirc;/g,'Ê'); // 202 CA
			texte = texte.replace(/&Euml;/g,'Ë'); // 203 CB
			texte = texte.replace(/&Igrave;/g,'Ì'); // 204 CC
			texte = texte.replace(/&Iacute;/g,'Í'); // 205 CD
			texte = texte.replace(/&Icirc;/g,'Î'); // 206 CE
			texte = texte.replace(/&Iuml;/g,'Ï'); // 207 CF
			texte = texte.replace(/&ETH;/g,'Ð'); // 208 D0
			texte = texte.replace(/&Ntilde;/g,'Ñ'); // 209 D1
			texte = texte.replace(/&Ograve;/g,'Ò'); // 210 D2
			texte = texte.replace(/&Oacute;/g,'Ó'); // 211 D3
			texte = texte.replace(/&Ocirc;/g,'Ô'); // 212 D4
			texte = texte.replace(/&Otilde;/g,'Õ'); // 213 D5
			texte = texte.replace(/&Ouml;/g,'Ö'); // 214 D6
			texte = texte.replace(/&times;/g,'×'); // 215 D7
			texte = texte.replace(/&Oslash;/g,'Ø'); // 216 D8
			texte = texte.replace(/&Ugrave;/g,'Ù'); // 217 D9
			texte = texte.replace(/&Uacute;/g,'Ú'); // 218 DA
			texte = texte.replace(/&Ucirc;/g,'Û'); // 219 DB
			texte = texte.replace(/&Uuml;/g,'Ü'); // 220 DC
			texte = texte.replace(/&Yacute;/g,'Ý'); // 221 DD
			texte = texte.replace(/&THORN;/g,'Þ'); // 222 DE
			texte = texte.replace(/&szlig;/g,'ß'); // 223 DF
			texte = texte.replace(/&agrave;/g,'à'); // 224 E0
			texte = texte.replace(/&aacute;/g,'á'); // 225 E1
			texte = texte.replace(/&acirc;/g,'â'); // 226 E2
			texte = texte.replace(/&atilde;/g,'ã'); // 227 E3
			texte = texte.replace(/&auml;/g,'ä'); // 228 E4
			texte = texte.replace(/&aring;/g,'å'); // 229 E5
			texte = texte.replace(/&aelig;/g,'æ'); // 230 E6
			texte = texte.replace(/&ccedil;/g,'ç'); // 231 E7
			texte = texte.replace(/&egrave;/g,'è'); // 232 E8
			texte = texte.replace(/&eacute;/g,'é'); // 233 E9
			texte = texte.replace(/&ecirc;/g,'ê'); // 234 EA
			texte = texte.replace(/&euml;/g,'ë'); // 235 EB
			texte = texte.replace(/&igrave;/g,'ì'); // 236 EC
			texte = texte.replace(/&iacute;/g,'í'); // 237 ED
			texte = texte.replace(/&icirc;/g,'î'); // 238 EE
			texte = texte.replace(/&iuml;/g,'ï'); // 239 EF
			texte = texte.replace(/&eth;/g,'ð'); // 240 F0
			texte = texte.replace(/&ntilde;/g,'ñ'); // 241 F1
			texte = texte.replace(/&ograve;/g,'ò'); // 242 F2
			texte = texte.replace(/&oacute;/g,'ó'); // 243 F3
			texte = texte.replace(/&ocirc;/g,'ô'); // 244 F4
			texte = texte.replace(/&otilde;/g,'õ'); // 245 F5
			texte = texte.replace(/&ouml;/g,'ö'); // 246 F6
			texte = texte.replace(/&divide;/g,'÷'); // 247 F7
			texte = texte.replace(/&oslash;/g,'ø'); // 248 F8
			texte = texte.replace(/&ugrave;/g,'ù'); // 249 F9
			texte = texte.replace(/&uacute;/g,'ú'); // 250 FA
			texte = texte.replace(/&ucirc;/g,'û'); // 251 FB
			texte = texte.replace(/&uuml;/g,'ü'); // 252 FC
			texte = texte.replace(/&yacute;/g,'ý'); // 253 FD
			texte = texte.replace(/&thorn;/g,'þ'); // 254 FE
			texte = texte.replace(/&yuml;/g,'ÿ'); // 255 FF
			return texte;
		}

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites.liste',
            [
                'datatables', 'datatables.fixedheader'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.sites', {
                url      : '/sites',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/sites/sites/sites.html',
                        controller : 'SitesController as vm'
                    }
                },
                resolve  : {
					Commandes: function (msApi)
                    {
                        return msApi.resolve('commandes.commandes@get');
                    },
                    Contacts: function (msApi)
                    {
                        return msApi.resolve('commandes.contacts@get');
                    },
					employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.simpleListe@get');
                    },
					Fabricants: function (msApi)
					{
						return msApi.resolve('commandes.fabricants@get');
					},
					cmsListeUsedSimple: function (msApi)
                    {
                        return msApi.resolve('sites.getcmsListeUsed@get');
                    }
                },
                bodyClass: 'sites'
            });
			
        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
		msApiProvider.register('contacts.contacts', ['datas/contacts/getAll.json']);
        msApiProvider.register('commandes.commandes', ['datas/commandes/getAllcommandes.json']);
        msApiProvider.register('sites.getcmsListeUsed', ['datas/sites/getcmsListeUsed.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites.liste')
        .controller('optionsSiteDialogController', optionsSiteDialogController)
		.filter('exactFilter', function() {
			return function(items, field, value) {
				if (!items) return [];
				return items.filter(function(item) {
					return item[field] === value; 
				});
			};
		});
		
    /** @ngInject */
    function optionsSiteDialogController($mdDialog, Contacts, Commandes, $rootScope, SiteWeb, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		vm.SiteWeb = angular.copy(SiteWeb);
        vm.contacts = Contacts.data;
        vm.commandes = Commandes.data;
	
	
		if(vm.SiteWeb.ListeIDCommandes != null){
			vm.SiteWeb.ListeIDCommandes = toString(vm.SiteWeb.ListeIDCommandes);
			if (vm.SiteWeb.ListeIDCommandes.includes(",")) {
				vm.SiteWeb.ListeIDCommandes = vm.SiteWeb.ListeIDCommandes.split(",");
			} else {
				vm.SiteWeb.ListeIDCommandes = [vm.SiteWeb.ListeIDCommandes];
			}
		}
		else
			vm.SiteWeb.ListeIDCommandes = [];
		
		vm.SiteWeb.ListeIDCommandes.forEach(function(valeur, index, tableau) {
			tableau[index] = String(valeur).replace(' ', '');
		});

		vm.customFilter = function(commande) {
			return commande.IDContact == vm.SiteWeb.IDContact; 
		};
		
		vm.sortByNumber = function(commande) {
			return -1 * parseInt(commande.IDCommande);
		};

		$scope.status = [];
		
		vm.testSiteExist = function(url) {
			$http.post("/datas/sites/testSiteExist.json",JSON.stringify({'url':url, "IDContact":vm.SiteWeb.IDContact}))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$scope.siteOptionsForm['URL'].$setValidity("newURLFailed", false);
					$scope.status = response.data.error.message;
				}
				else{					
					$scope.siteOptionsForm['URL'].$setValidity("newURLFailed", true);
				}
			}, function () {});
			
		};
		

	
        vm.saveSiteWeb = function()
        {
			vm.showSpinner = 1;
					   
			$http.post("/datas/sites/editSiteWeb.json", JSON.stringify(vm.SiteWeb))
			.then(function (response, status, headers, config) {
			
				if(response.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
					// $mdDialog.hide(response);
				}
				else{
					$mdDialog.hide(response);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        }  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.parametres.employes.profil')
        .controller('profilController', profilController);

    /** @ngInject */
    function profilController(Employe, Permissions, Droits, $rootScope, $mdToast, $location, $mdDialog, $document, $http, $scope, $element, $filter, $window, $state, DTColumnBuilder, DTOptionsBuilder, $compile)
    {
        var vm = this;
		
        vm.IDEmploye = $rootScope.id;
        vm.employe = Employe.data;
		
		
		vm.convertDate = function (inputFormat, hour , day ) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			
			var days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else if(day)
				return days[d.getDay()] + " "+[pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
		
		vm.go = function(url){
			if(vm.IDEmploye == vm.employe.IDEmploye)
				$location.path(window.history.back());
			else
				$location.path(url);
		};
		
		if(typeof $rootScope.id == "undefined")
			vm.go('/');
		
        vm.permissions = Permissions.data;
        // vm.APE = APE.data;
        // vm.Activites = Activites.data;
		// vm.text_add_post = "";
        // vm.commandes = Commandes.data;
        // vm.employes = Employes.data;
        
		
		if(typeof vm.employe == "undefined"){
			vm.employe = {};
			$mdDialog.show({
                controller         : 'AboutDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/parametres/employes/profil/dialogs/about/generales-dialog.html',
                parent             : angular.element(document.body),
				clickOutsideToClose: false,
                locals             : {
                    employe : vm.employe,
					IDEmploye: vm.IDEmploye,
                    permissions : vm.permissions,
					Droits: Droits,
					page : 'generales',
					datas : ''
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					vm.employe = response.data;
					$mdToast.show(
					  $mdToast.simple()
						.textContent("Compte créé !")
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			});
		}

		vm.statuses = [
			{value: "0", text: 'Bloqué'},
			{value: "1", text: "Activé"},
			{value: "2", text: 'Corbeille'}
		]; 

		vm.updateStatus = function(){
			$http.post("/datas/employes/setStatus.json", JSON.stringify(vm.employe));
			$mdToast.show(
			  $mdToast.simple()
				.textContent('Etat modifié !')
				.position('bottom right' )
				.hideDelay(3000)
			);
		}
				
				
     	vm.deleteAdresse = function(ev, datas){
			var confirm = $mdDialog.confirm()
                .title('Êtes-vous sûr de vouloir supprimer cette adresse ?')
                .htmlContent("L'adresse <b>" + datas.NomAdresse + '</b> va être supprimée')
                .ariaLabel('Supprimer cette adresse')
                .targetEvent(ev)
                .theme('md-warn')
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {
				$http.post("/datas/employes/deleteAdresse.json", JSON.stringify(datas)).then(function (response, status, headers, config) {
					if(response.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.title("Une erreur s'est produite")
							.textContent(response.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.employe = response.data.data;
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Adresse supprimée !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				}, function () {});
            });
		};
				
     	vm.deleteVehicule = function(ev, datas){
			var confirm = $mdDialog.confirm()
                .title('Êtes-vous sûr de vouloir supprimer ce véhicule ?')
                .htmlContent("Le véhicule <b>" + datas.Marque + " " + datas.Modele + '</b> va être supprimé')
                .ariaLabel('Supprimer cet véhicule')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {
				$http.post("/datas/employes/deleteVehicule.json", JSON.stringify(datas)).then(function (response, status, headers, config) {
					if(response.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.title("Une erreur s'est produite")
							.textContent(response.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.employe = response.data.data;
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Véhicule supprimé !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				}, function () {});
            });
		};
		
		vm.editer = function (ev, page, datas){
			$mdDialog.show({
                controller         : 'AboutDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/parametres/employes/profil/dialogs/about/'+ page +'-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    employe : vm.employe,
					IDEmploye: vm.IDEmploye,
                    permissions : vm.permissions,
					Droits: Droits,
					page : page,
					datas : datas
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					// console.log($rootScope);
					// console.log(response);
					if(response.data.IDEmploye == $rootScope.id){
						$rootScope.Nom = response.data.Nom;
						$rootScope.Prenom = response.data.Prenom;
						$rootScope.Email = response.data.Email;
						$rootScope.Avatar = response.data.Avatar+"?"+Math.random();
					}
					vm.employe = response.data;
					$mdToast.show(
					  $mdToast.simple()
						.textContent("Compte modifié !")
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			});
		}
		
		
		vm.avatar = function (ev, datas){
			$mdDialog.show({
                controller         : 'AvatarDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/parametres/employes/profil/dialogs/image/avatar-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
				fullscreen : true,
                locals             : {
					Employe : datas
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					vm.employe = response;
					if(response.IDEmploye == $rootScope.id){
						$rootScope.Avatar = response.Avatar+"?"+Math.random();
					}
					$mdToast.show(
					  $mdToast.simple()
						.textContent("Votre photo de profil a été modifiée !")
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			});
		}
		
		
		function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
		}
		
		vm.dtInstance = {};
    		
		vm.dtOptions = DTOptionsBuilder.newOptions()
		.withOption('ajax', {
			 dataSrc: 'datas',
			 url: 'datas/analyse/getLogs.json?IDEmploye='+ vm.employe.IDEmploye,
			 type: 'GET'
		})
		.withDataProp('data')
		.withOption('processing', true)
		.withOption('serverSide', true)
		/*.withOption('columnDefs',  [
			{
				// Target the id column
				targets: 0,
				responsivePriority: 1,
			},
			{
				// Target the id column
				targets: 1,
				responsivePriority: 2,
			},
			{
				// Target the price column
				targets: 4,
				responsivePriority: 2,
			},        {
				// Target the actions column
				targets           : 6,
				responsivePriority: 1,
			}
		])*/
		.withOption('responsive', {
			details: {
				display: $.fn.dataTable.Responsive.display.childRowImmediate,
				type: 'none',
				target: ''
			}
		})
		.withOption('pagingType', 'simple')
		.withOption('lengthMenu', [50, 100, 250])
		.withPaginationType('simple')
		.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
		.withOption('createdRow', function(row, data, dataIndex) {
			$compile(angular.element(row).contents())($scope);
		})
		.withOption('headerCallback', function(header) {
			if (!vm.headerCompiled) {
				vm.headerCompiled = true;
				$compile(angular.element(header).contents())($scope);
			}
		})
		.withOption('initComplete', function(settings, json) {
			var api = this.api();
			vm.searchBox = angular.element('body').find('#logs-search');
			
			if ( vm.searchBox.length > 0 )
			{
				vm.searchBox.on('keyup', function (event)
				{
					localStorage.setItem('logsSearch', vm.search);
					api.search(vm.search).draw();
				});
				if(vm.search != null)
					vm.searchBox.trigger('keyup');
			}
			
			vm.recordsTotal = json.recordsTotal;
			/*if(vm.filterStatus == null || vm.filterStatus == "all"){
				api.column(4).search('', true, false, false ).draw();
			}
			else
				api.column(4).search(vm.filterStatus, true, false, false ).draw();*/
		  }
		)
		.withLanguage({
		  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
		  'processing':'test',
			"sSearch":         "Rechercher&nbsp;:",
			"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
			"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
			"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
			"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			"sInfoPostFix":    "",
			"sLoadingRecords": "Chargement en cours...",
			"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
			"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
			"oPaginate": {
				"sFirst":      "Premier",
				"sPrevious":   "Pr&eacute;c&eacute;dent",
				"sNext":       "Suivant",
				"sLast":       "Dernier"
			},
			"oAria": {
				"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
				"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
			}
		})
		.withOption('order', [0, 'DESC']);;

			
		vm.dtColumns = [
			DTColumnBuilder.newColumn('IDLog').withTitle('<div class="table-header"><span class="column-title">N°</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('Utilisateur').withTitle('<div class="table-header"><span class="column-title">Employé</div></div>').withOption('width', '170px'),
			DTColumnBuilder.newColumn('Type').withTitle('<div class="table-header"><span class="column-title">Gravité</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
						switch(data){
							case "danger": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-red-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span>'; break;
							case "success": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-green-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
							case "warning": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-orange-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
							case "info": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-blue-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
						}
				   return html;
				}
				return data;
				
			}),
			DTColumnBuilder.newColumn('Titre').withTitle('<div class="table-header"><span class="column-title">Message</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
				var html = '<strong class="md-subhead font-weight-600">'+data+'</strong>';
				if(full.Message) 
					html += '<br><span >'+full.Message+'</span>';
				
				return html;
			}),
			DTColumnBuilder.newColumn('Date').withTitle('<div class="table-header"><span class="column-title">Date</div></div>').withOption('width', '130px').renderWith(function(data, type, full){
				return convertDate(data);
			}),
			
		];
		
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.parametres.regles_bancaires', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider
            .state('app.regles_bancaires', {
                url: '/parametres/regles-bancaires',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/parametres/regles_bancaires/regles-bancaires.html',
                        controller: 'ReglesBancairesController as vm'
                    }
                },
                resolve: {
                    ReglesBancaires: function (msApi)
                    {
                        return msApi.resolve('regles_bancaires.regles@get');
                    }
                },
                bodyClass: 'regles-bancaires'
            });

        msApiProvider.register('regles_bancaires.regles', ['datas/reglesbanque/getRegles.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.parametres.regles_bancaires')
        .controller('RegleBancaireDialogController', RegleBancaireDialogController);

    /** @ngInject */
    function RegleBancaireDialogController(Regle, $http, $mdDialog)
    {
        var vm = this;
        vm.regle = Regle || {
            Libelle: '', Motif: '', Champ: 'Libellé et référence', Correspondance: 'Contient',
            Categorie: 'Autre', StatutPropose: 'À valider', Priorite: 100, Actif: 1
        };
        vm.champs = ['Libellé', 'Référence', 'Libellé et référence'];
        vm.correspondances = ['Contient', 'Commence par', 'Égale'];
        vm.categories = ['Frais bancaires', 'Frais juridiques et contentieux', 'Location bâtiment', 'Assurance véhicules', 'Assurance homme clé', 'Prévoyance dirigeant', 'Mutuelle dirigeant', 'Retraite dirigeant', 'Épargne salariale', 'Protection sociale salariés', 'Mutuelle des salariés', 'Sécurité et alarme', 'Salaires', 'Cotisations sociales', 'Impôts et taxes', 'Virement interne', 'Autre'];
        vm.statuts = ['À valider', 'En attente de pièce'];
        vm.busy = false;
        vm.erreur = '';
        vm.annuler = function () { $mdDialog.cancel(); };
        vm.enregistrer = function (form)
        {
            if (form.$invalid || vm.busy) return;
            vm.busy = true; vm.erreur = '';
            $http.post('/datas/reglesbanque/saveRegle.json', vm.regle).then(function (response)
            {
                if (response.data.error) {
                    vm.erreur = response.data.error.message;
                    return;
                }
                $mdDialog.hide(response.data);
            }, function (response)
            {
                vm.erreur = response && response.data && response.data.error ? response.data.error.message : 'Enregistrement impossible.';
            }).finally(function () { vm.busy = false; });
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.parametres.employes.employes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.employes', {
                url    : '/administration/employes',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/parametres/employes/employes/employes.html',
                        controller : 'EmployesController as vm'
                    }
                },
				resolve: {
					Employes: function (msApi)
					{
						return msApi.resolve('employes.employes@get',{'logs': true});
					}
				}
            });
			
        msApiProvider.register('employes.employes', ['datas/employes/getEmployes.json']);

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.parametres.employes.employes')
        .controller('EmployesController', EmployesController);

    /** @ngInject */
    function EmployesController($scope, Employes, msUtils, $rootScope, $mdDialog, $mdToast, $document, $mdMenu, $location, $http)
    {
        var vm = this;

        // Data
        vm.employes = Employes.data;
		vm.IDEmploye = $rootScope.id;
        vm.filterStatus = '';
        vm.listType = 'all';
        vm.listOrder = 'Prenom';
        vm.listOrderAsc = false;
		
        // Methods
        vm.supprimerEmployes = supprimerEmployes;
		

        //////////


		vm.go = function (url){
			$location.path(url);
		}
		
		/* vm.ajouterEmploye = function ($event){
				$mdDialog.show({
                controller         : 'AboutDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/parametres/employes/profil/dialogs/about/generales-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : $event,
				clickOutsideToClose: false,
                locals             : {
                    employe : {],
					IDEmploye: vm.IDEmploye,
                    permissions : vm.permissions, A COMPLETER
					page : 'generales',
					datas : ''
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					vm.employe = response.data;
					$mdToast.show(
					  $mdToast.simple()
						.textContent("Compte créé !")
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			});
		} */
		
        function supprimerEmployes($event, employe)
        {
			
			$mdDialog.show({
                controller         : 'DeleteEmployeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/parametres/employes/employes/dialogs/delete-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : $event,
                clickOutsideToClose: true,
                locals             : {
                    Employe : employe,
					Employes: vm.employes
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					vm.employes.splice(vm.employes.indexOf(employe), 1);
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Le compte a été supprimé !')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			});
			
	  
        }
		
		vm.detailsEmployes = function (employe){
			$location.path('/administration/employes/profil/'+employe.IDEmploye);
		}

		
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.parametres',
            [
				'ngFileUpload',
                'app.parametres',
                'app.parametres.employes',
                'app.parametres.droits',
				'app.parametres.regles_bancaires',
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
     
		
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.parametres')
        .controller('ImageDialogController', ImageDialogController);

    /** @ngInject */
    function ImageDialogController($mdDialog, link, Params, multipleUpload, Upload, $mdToast, $http, $timeout, $scope, $element,$location)
    {
		
		var vm = this;
		vm.multipleUpload = multipleUpload;
		
		$scope.$watch('files', function () {
			$scope.upload($scope.files);
		});
		$scope.$watch('file', function () {
			if ($scope.file != null) {
				$scope.files = [$scope.file]; 
			}
		});
		$scope.log = '';

		$scope.upload = function (files) {
			if (files){
			  var file = files;
			  if (!file.$error) {
				Upload.upload({
					url: '/datas/'+link+'.json',
					data: {
					  file: file,
					  params: Params  
					}
				}).then(function (resp) {
					
					if(resp.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.title("Une erreur s'est produite")
							.textContent(resp.data.error.message)
							.ok('OK')
						);
					}
					else{
						$mdDialog.hide(resp.data.data.success);
					}
				}, function (response) {
				
				}, function (evt) {
					  vm.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
				});
			  }
			}
		};
		
		/*
		if(typeof vm.post == "undefined"){
			vm.post = {'postTypes_selected':'', 'Bouton':'Aucun'};
		}
		else{
			vm.post.DateFinEvenement = new Date(vm.post.DateFinEvenement);
			vm.post.DateDebutEvenement = new Date(vm.post.DateDebutEvenement);
		}
		vm.postTypes_selected = vm.post.postTypes_selected;
		
		vm.select_postTypes = function(postTypes){vm.post.postTypes_selected = postTypes;}
		
		
		vm.selectImage = function(event){
			$mdDialog.show({
                controller         : 'ImageDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/images/dialogs/images-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : event,
                clickOutsideToClose: true,
				multiple : true,
                locals             : {
					Post : "",
					PostTypes : ""
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					vm.posts = response.datas;
					$mdToast.show(
					  $mdToast.simple()
						.textContent("Votre actualité a été créée/modifiée !")
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			});
		}
		
        vm.savePost = function()
        {
			console.log(JSON.stringify(vm.post));
			vm.showSpinner = 1;
			$http.post("/datas/posts/setPost.json",JSON.stringify(vm.post))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					if(response.data.error){
						$mdToast.show(
						  $mdToast.simple()
							.textContent(response.data.error.message)
							.position('bottom right' )
							.hideDelay(3000)
						);
						vm.showSpinner = 0;
					}
					else{
						$mdDialog.hide(response.data);
						vm.showSpinner = 0;
					}
				}
			});		

        }
		*/
		
        vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 

		

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.parametres.droits.droits')
        .controller('DroitsController', DroitsController);

    /** @ngInject */
    function DroitsController($scope, Droits, Permissions, msUtils, $rootScope, $mdDialog, $mdToast, $document, $mdMenu, $location, $http)
    {
        var vm = this;

        // Data
        vm.droits = Droits.data;
        vm.permissions = Permissions.data;
		
		vm.IDEmploye = $rootScope.id;
        vm.filterStatus = '';
        vm.listType = 'all';
        vm.listOrder = 'Prenom';
        vm.listOrderAsc = false;
		
        // Methods
        // vm.supprimerDroit = supprimerDroit;
        vm.supprimerPermission = supprimerPermission;
		

        //////////


		vm.go = function (url){
			$location.path(url);
		}
		
		// vm.editerDroit = function (ev, droit){
			// $mdDialog.show({
                // controller         : 'DroitDialogController',
                // controllerAs       : 'vm',
                // templateUrl        : 'app/main/parametres/droits/droits/dialogs/droit-dialog.html',
                // parent             : angular.element(document.body),
                // targetEvent        : ev,
                // clickOutsideToClose: true,
                // locals             : {
                   // Droit : droit
                // }
            // }).then(function (response)
            // {
				// if(typeof response != "undefined"){
					// vm.droits = response.data;
					// $mdToast.show(
					  // $mdToast.simple()
						// .textContent("Droit modifié !")
						// .position('bottom right' )
						// .hideDelay(3000)
					// );
				// }
			// });
		// }
		
		vm.editerPermission = function (ev, permission){
			$mdDialog.show({
                controller         : 'PermissionDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/parametres/droits/droits/dialogs/permission-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Permission : permission,
                    Permissions : vm.permissions,
					Droits: vm.droits
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					vm.permissions = response.data;
					if(typeof permission.IDPermission!="undefined")
						$mdToast.show(
						  $mdToast.simple()
							.textContent("La permission a été modifiée !")
							.position('bottom right' )
							.hideDelay(3000)
						);
					else
					$mdToast.show(
					  $mdToast.simple()
						.textContent("La permission a été créée !")
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			});
		}
		
		
		/* function supprimerDroit(ev, droit) {
			var confirm = $mdDialog.confirm()
				  .title('Êtes-vous sur de vouloir supprimer ce droit ?')
				  .textContent('Le droit "'+ droit.title +'" sera supprimé définitvement')
				  .targetEvent(ev)
				  .ok('Supprimer')
				  .cancel('Annuler');

			$mdDialog.show(confirm).then(function() {
				$http.post("/datas/employes/deleteDroit.json",JSON.stringify(droit))
				.then(function (response, status, headers, config) {
					if(response.data.error){
						$mdToast.show(
						  $mdToast.simple()
							.textContent(response.data.error.message)
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
					else{
						$mdToast.show(
						  $mdToast.simple()
							.textContent(response.data.success.message)
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				});
			});
		} */
		
		function supprimerPermission(ev, permission) {
			var confirm = $mdDialog.confirm()
				  .title('Êtes-vous sur de vouloir supprimer cette permission ?')
				  .textContent('La permission "'+ permission.Permission +'" sera supprimée définitvement')
				  .targetEvent(ev)
				  .ok('Supprimer')
                  .theme('md-warn')
				  .cancel('Annuler');

			$mdDialog.show(confirm).then(function() {
				$http.post("/datas/employes/deletePermission.json",JSON.stringify(permission))
				.then(function (response, status, headers, config) {
					if(response.data.error){
						$mdToast.show(
						  $mdToast.simple()
							.textContent(response.data.error.message)
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
					else{
						vm.permissions = response.data.data;
						$mdToast.show(
						  $mdToast.simple()
							.textContent('La permission a été supprimée')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				}, function () {});
			}, function () {});
		}
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.courriers.edition', ["xeditable",'ui.tinymce'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.courriers.edition', {
                url      : '/edition/:IDCourrier',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/courriers/courrier/courrier.html',
                        controller : 'CourrierEditionController as vm'
                    }
                },
                resolve  : {
                    Courrier: function (msApi, $stateParams)
                    {
                        return msApi.resolve('courrier.edition@get',{'IDCourrier': $stateParams.IDCourrier});
                    },
                    Contacts: function (msApi)
                    {
                        return msApi.resolve('courrier.contacts@get');
                    },
					Employes: function (msApi)
					{
						return msApi.resolve('courrier.employes@get');
					},
					Villes: function (msApi)
					{
						return msApi.resolve('courrier.villes@get');
					}
                },
                bodyClass: 'courriers'
            });

        // Translation

        // Api
				
			
        msApiProvider.register('courrier.employes', ['datas/employes/getEmployes.json']);
        msApiProvider.register('courrier.edition', ['datas/courriers/getCourrier.json']);
        msApiProvider.register('courrier.contacts', ['datas/contacts/getContactsSimplifies.json']);
        msApiProvider.register('courrier.villes', ['datas/contacts/getVillesContacts.json']);
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.courriers.edition')
        .controller('DestinatairesCourrierDialogController', DestinatairesCourrier);

    /** @ngInject */
    function DestinatairesCourrier($mdDialog, $http, $scope, $element, Contacts, Destinataires, Employes, Villes)
    {
		
		var vm = this;
		vm.contacts = Contacts;
		vm.employes = Employes;
		vm.villes = Villes;
		vm.destinataires = angular.copy(Destinataires);
		
		$scope.openSelectSearch = function(id){
			setTimeout(function() {$(id).focus();},200);
		}


		if(typeof vm.destinataires == "undefined")			
			vm.destinataires = {};
		
		if(typeof vm.destinataires.Total == "undefined")	
			if(vm.destinataires.Type == "Saisir")
				vm.destinataires.Total = 1;
			else				
				vm.destinataires.Total = vm.contacts.length;
		
		if(typeof vm.destinataires.TypeResponsable == "undefined")			
			vm.destinataires.TypeResponsable = ['Principal','Secondaire'];
		
		if(typeof vm.destinataires.IDSelectResponsables == "undefined")			
			vm.destinataires.IDSelectResponsables = [];
		
		if(typeof vm.destinataires.SelectResponsables == "undefined")			
			vm.destinataires.SelectResponsables = [];
		
		$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
			vm.destinataires.Total = list.length;
		};

		$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
		};

		$scope.isIndeterminate = function() {
			return (vm.destinataires.IDSelectResponsables.length !== 0 &&
			vm.destinataires.IDSelectResponsables.length !== vm.destinataires.SelectResponsables.length);
		};

		$scope.isChecked = function() {
			return vm.destinataires.IDSelectResponsables.length === vm.destinataires.SelectResponsables.length;
		};

		$scope.toggleAll = function() {
			if (vm.destinataires.IDSelectResponsables.length === vm.destinataires.SelectResponsables.length) {
				vm.destinataires.IDSelectResponsables = [];
			} else if (vm.destinataires.IDSelectResponsables.length === 0 || vm.destinataires.IDSelectResponsables.length > 0) {
				angular.forEach(vm.destinataires.SelectResponsables, function(ContactResponsables, key) {
					if ( vm.destinataires.IDSelectResponsables.indexOf(ContactResponsables.IDContact_Responsables) === -1)
						vm.destinataires.IDSelectResponsables.push(ContactResponsables.IDContact_Responsables);
				});
				// vm.destinataires.IDSelectResponsables = vm.destinataires.SelectResponsables.slice(0);
				// console.log(vm.destinataires.IDSelectResponsables);
			}
			vm.destinataires.Total = vm.destinataires.IDSelectResponsables.length;
		};
		
		var hack = 0;
		vm.totalSelect = function(){
			// hack++;
			// if(hack>4){
				vm.destinataires.Total = 0;
				vm.destinataires.IDsSelect = "";
				vm.destinataires.IDSelectResponsables = [];
				vm.destinataires.SelectResponsables  = [];
				if(vm.destinataires.Type == "Saisir")
					vm.destinataires.Total = 1;
				else
				if(vm.destinataires.Type != "Aucune"){
					angular.forEach(vm.contacts, function(value, key) {
						
						if( 
							(typeof vm.destinataires.IDContacts == "undefined" || vm.destinataires.IDContacts.length == 0 || vm.destinataires.IDContacts.includes(value.IDContact))
							&&
							(typeof vm.destinataires.IDEmployes == "undefined" || vm.destinataires.IDEmployes.length == 0 || vm.destinataires.IDEmployes.indexOf(value.IDEmploye)>=0)
							&&
							(typeof vm.destinataires.Villes == "undefined" || vm.destinataires.Villes.length == 0 || vm.destinataires.Villes.indexOf(value.IDVille)>=0)
							&&
							(typeof vm.destinataires.Statuts == "undefined" || vm.destinataires.Statuts.length == 0 || vm.destinataires.Statuts.indexOf(value.Status)>=0)
						){
							vm.destinataires.IDsSelect += value.IDContact + ";"
							
							angular.forEach(value.ContactResponsables, function(ContactResponsables, key) {
								if(vm.destinataires.TypeResponsable.indexOf(ContactResponsables.PrincipalOuSecondaire) > -1){
									ContactResponsables.RaisonSociale = value.RaisonSocial;
									vm.destinataires.IDSelectResponsables.push(ContactResponsables.IDContact_Responsables);
									vm.destinataires.SelectResponsables.push(ContactResponsables);
								}
							});
							vm.destinataires.Total = vm.destinataires.IDSelectResponsables.length;
							
						}
						
					});
					// console.log(vm.destinataires.SelectResponsables);
				} 
			// } 
		}
		
        vm.saveDestinataires = function()
        {
			vm.showSpinner = 1;
			$mdDialog.hide(vm.destinataires);

        }

        vm.closeDialog = function()
        {
            $mdDialog.hide();
        }
		
		$scope.searchTerm;
		$scope.searchVille;
		
		$scope.clearSearchTerm = function() {
			$scope.searchTerm = '';
		};
		
		$scope.clearSearchVille = function() {
			$scope.searchVille = '';
		};
	
		$element.find('input').on('keydown', function(ev) {
			ev.stopPropagation();
		});

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.courriers.edition')
        .controller('CourrierDialogController', CourrierDialogController);

    /** @ngInject */
    function CourrierDialogController($mdDialog, $http, $scope, $element, Contenu, Titre)
    {
		
		$scope.tinymceOptions = {
			plugins: [
			  "advlist autolink lists link image charmap print preview hr anchor pagebreak",
			  "searchreplace wordcount visualblocks visualchars code fullscreen",
			  "insertdatetime  nonbreaking save table contextmenu directionality",
			  "emoticons template paste textcolor colorpicker textpattern"
			],
			menubar:false,
			toolbar1: "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink",
			toolbar2: "preview | hr forecolor backcolor emoticons image table removeformat code",
			document_base_url : '/datas/images/courriers/',
			remove_script_host : false,
			convert_urls: false,
			paste_data_images: true,
			height : "200",
			file_picker_types: 'image',
			automatic_uploads: false,
			file_picker_callback: function(callback, value, meta) {
				
				if (meta.filetype =="image") {
					jQuery("#fileupload").trigger("click");
					$("#fileupload").unbind('change');
				
					jQuery("#fileupload").on("change", function() {
						var file = this.files[0];
						var reader = new FileReader();

						var fd = new FormData();
						var files = file;
						fd.append("file",files);
						fd.append('filetype',meta.filetype);

						var filename = "";
									
						jQuery.ajax({
							url: "/datas/courriers/uploadImage",
							type: "post",
							data: fd,
							contentType: false,
							processData: false,
							async: false,
							success: function(response){
								filename = response;
							}
						});
								 
						 reader.onload = function(e) {
							callback(filename);
						 };
						reader.readAsDataURL(file);
					});
				}		
			}	
		};
			
		var vm = this;
		vm.contenu = angular.copy(Contenu);
		vm.titre = Titre;
		
		if(typeof vm.contenu == "undefined")			
			vm.contenu = "";
		
  
        vm.saveContenu = function()
        {
			vm.showSpinner = 1;
			$mdDialog.hide(vm.contenu);

        }

        vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.courriers.courriers', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.courriers', {
                url    : '/courriers',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/courriers/courriers/courriers.html',
                        controller : 'CourriersController as vm'
                    }
                },
				resolve: {
					Courriers: function (msApi)
					{
						return msApi.resolve('courriers.courriers@get',{"logs":true});
					},
                    Employes: function (msApi)
                    {
                        return msApi.resolve('courriers.Employes@get');
                    }
				}
            });
			
        msApiProvider.register('courriers.courriers', ['datas/courriers/getCourriers.json']);
        msApiProvider.register('courriers.Employes', ['datas/employes/getEmployes.json']);

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.courriers.courriers')
        .controller('DestinatairesCourriersDialogController', DestinatairesCourriersDialogController);

    /** @ngInject */
    function DestinatairesCourriersDialogController($mdDialog, $http, $scope, $element,  Courrier, $window)
    {
		
		var vm = this;
		vm.courrier = angular.copy(Courrier);
		$http.post("/datas/courriers/getCourrierDestinataire.json",JSON.stringify(vm.courrier))
		.then(function (response, status, headers, config) {
			if(response.data.error){
				$mdDialog.show(
				  $mdDialog.alert()
					.clickOutsideToClose(false)
					.title("Une erreur s'est produite")
					.textContent(response.data.error.message)
					.ok('OK')
				);
			}
			else{
				vm.destinataires = response.data.data;
			}
		}, function () {});

		vm.closeDialog = function()
		{
			$mdDialog.hide();
		} 
	

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.courriers.courriers')
        .controller('CourriersDialogController', CourriersDialogController);

    /** @ngInject */
    function CourriersDialogController($mdDialog, $http, $scope, $element,  Courrier, $window)
    {
		
		var vm = this;
		vm.courrier = angular.copy(Courrier);
		

		vm.closeDialog = function()
		{
			$mdDialog.hide();
		} 
		
		$('#table').basictable(); 

    }
	
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.produits',
            [
                // 3rd Party Dependencies
                // 'wipImageZoom',
                'datatables'
                // 'flow',
                // 'nvd3',
                // 'textAngular',
                // 'uiGmapgoogle-maps',
                // 'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.produits', {
                url      : '/administration/produits',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/commandes/produits/produits.html',
                        controller : 'ProduitsController as vm'
                    }
                },
                resolve  : {
                    // Produits: function (msApi)
                    // {
                        // return msApi.resolve('commandes.produits@get');
                    // },
                    Fabricants: function (msApi)
                    {
                        return msApi.resolve('commandes.fabricants@get');
                    },
                    Categories: function (msApi)
                    {
                        return msApi.resolve('commandes.arbocategories@get');
                    }
                },
                bodyClass: 'commandes'
            });

        // Api
        // msApiProvider.register('commandes.produits', ['datas/commandes/getAllproduits.json']);
        msApiProvider.register('commandes.arbocategories', ['datas/commandes/getArboCagetories.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.produits')
        .controller('ProduitsDialogController', ProfilDialogController);

    /** @ngInject */
    function ProfilDialogController($mdDialog, $http, $scope, $element, categorie, Categories)
    {
		
		var vm = this;
		vm.categorie = angular.copy(categorie);
		vm.categories = angular.copy(Categories);
		
					
		$scope.searchTerm;
		$scope.clearSearchTerm = function() {
			$scope.searchTerm = '';
		};
		
		$element.find('input').on('keydown', function(ev) {
			ev.stopPropagation();
		});
		
		$scope.openSelectSearch = function(id){
			setTimeout(function() {$(id).focus();},200);
		}

  
		vm.getNumber = function(num) {
			return new Array(num);   
		}
		
        vm.saveCategorie = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/commandes/setCategorie.json",JSON.stringify(vm.categorie))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }

        vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.fournisseurs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.fournisseurs', {
                url    : '/achats/fournisseurs',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/commandes/fournisseurs/fournisseurs.html',
                        controller : 'fournisseursController as vm'
                    }
                },
                resolve  : {
                   // employesSimple: function (msApi)
                    // {
                        // return msApi.resolve('employes.listeCollaborateursEdit@get');
                    // }
                },
                bodyClass: 'fournisseurs'
            });
        
        // msApiProvider.register('employes.listeCollaborateursEdit', ['datas/employes/listeCollaborateursEdit.json']);
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.commandes.fournisseurs')
        .controller('fournisseursDialogController', fournisseursDialogController);

    /** @ngInject */
    function fournisseursDialogController($mdDialog, $rootScope, Fournisseur, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		vm.Fournisseur = angular.copy(Fournisseur);
		
		if(vm.Fournisseur=="")
			vm.Fournisseur = {Actif:1};
		
		/* vm.Permission = $rootScope.Permission;
		vm.dateMin = new Date();
		
		if($rootScope.Permission=='Super Admin')
			vm.dateMin.setDate(vm.dateMin.getDate() -60); 
		else
			vm.dateMin.setDate(vm.dateMin.getDate() + 2); 
		
		if(vm.Fournisseur=="")
			vm.Fournisseur = {DateDebut:null, DateFin:null};
		
		vm.convertDate = convertDate;

		function convertDate(inputFormat, hour , day ) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			
			var days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Dimanche'];

			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else if(day)
				return days[d.getDay()] + " "+[pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
		vm.congesValide = false;
		vm.congesTrouve = "";
		
		vm.testCongesExist = function(conges){
			if(typeof conges == "undefined" || typeof conges.DateDebut == "undefined" || typeof conges.HeureFin == "undefined" || typeof conges.DateFin == "undefined" || typeof conges.DateFin == "undefined"){
				vm.congesValide = false;
				vm.congesTrouve = "";
			}
			else{
				$http.post("/datas/employes/congesExist.json", conges).then(function (response, status, headers, config) {
					if(response.data.data != false){
						vm.congesTrouve = response.data.data;
						vm.congesValide = false;	
					}
					else{
						vm.congesValide = true;
						vm.congesTrouve = "";
					}
				}, function () {});
			}		
		}
		 */
	
	
        vm.saveFournisseur = function()
        {
			vm.showSpinner = 1;
			
			var fd = new FormData();			 
			fd.append("data", angular.toJson(vm.Fournisseur));
			
			/* var files = $('#file')[0].files;
			
			
			if(files.length > 0 ){
			   fd.append('file',files[0]);
			} */
			var config = { headers: {'Content-Type': undefined},
						   transformRequest: angular.identity
						 }
						   
			$http.post("/datas/commandes/editFournisseur.json", fd, config)
			.then(function (response, status, headers, config) {
			
				if(response.data.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
					$mdDialog.hide(response.data);
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        }  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.factures',
            [
				'wt.responsive',
                // 3rd Party Dependencies
                // 'wipImageZoom',
               
                // 'flow',
                // 'nvd3',
                // 'textAngular',
                // 'uiGmapgoogle-maps',
                // 'xeditable'
            ]
        )
        .config(config);

	
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.factures', {
                url      : '/commandes/factures',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/commandes/factures/factures.html',
                        controller : 'FacturesController as vm'
                    }
                },
                resolve  : {
                    Factures: function (msApi)
                    {
                        return msApi.resolve('commandes.factures@get');
                    },
                    nbrFacturesParEtats: function (msApi)
                    {
                        return msApi.resolve('commandes.nbrFacturesParEtats@get');
                    },
                    Employes: function (msApi)
                    {
                        return msApi.resolve('commandes.Employes@get');
                    },
					employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.simpleListe@get');
                    },
                    Fabricants: function (msApi)
                    {
                        return msApi.resolve('commandes.fabricants@get');
                    }
                },
                bodyClass: 'factures'
            });

        // Api
        msApiProvider.register('commandes.nbrFacturesParEtats', ['datas/commandes/getNbrFacturesParEtats.json']);
        msApiProvider.register('commandes.factures', ['datas/commandes/getAllFactures.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
        msApiProvider.register('commandes.Employes', ['datas/employes/getEmployes.json']);
        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
		
    }
})();

(function () {
    'use strict';
    angular.module('app.commandes.factures').controller('TransmissionFactureController', TransmissionFactureController);
    /** @ngInject */
    function TransmissionFactureController(Document, $rootScope, $http, $mdDialog) {
        var vm = this;
        vm.document = Document; vm.canal = 'email'; vm.contacts = []; vm.busy = false; vm.error = ''; vm.resultat = null;
        vm.autorise = function () {
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf('gestion.commandes.factures.envoi') !== -1;
        };
        vm.dejaEnvoye = !!Document.EmailSend && Document.EmailSend !== '0000-00-00 00:00:00' && Document.EmailSend !== '0000-00-00';
        vm.avecEmail = function () { return vm.canal !== 'plateforme'; };
        vm.fermer = function () {
            if (!vm.busy) { if (vm.resultat) $mdDialog.hide(vm.resultat); else $mdDialog.cancel(); }
        };
        $http.get('/datas/contacts/getContactInfoByID.json', {params:{IDContact:Document.IDContact}}).then(function (response) {
            vm.contacts = (response.data.data || []).filter(function (contact) { return !!contact.Email; });
        }, function () { vm.contactError = 'Impossible de charger les destinataires.'; });
        vm.envoyer = function (form) {
            if (!vm.autorise() || vm.busy || vm.resultat || form.$invalid ||
                (vm.avecEmail() && (!vm.IDContact_Responsables || (vm.dejaEnvoye && !vm.confirmerRenvoi)))) return;
            vm.error = ''; vm.busy = true;
            var canalEnvoi = vm.canal;
            var payload = {IDCommande:Document.IDCommande, IDPaiement:Document.IDCommandes_Paiement,
                IDContact_Responsables:vm.IDContact_Responsables, Canal:vm.canal};
            // L'envoi email seul conserve le contrôleur déjà utilisé par le CRM.
            var request = vm.canal === 'email' ? $http.get('/datas/commandes/sendFacture.json', {params:payload}) :
                $http.post('/datas/commandes/transmettreFacture.json', payload);
            request.then(function (response) {
                if (response.data.error) { vm.error = response.data.error.message || 'Envoi refusé.'; return; }
                if (canalEnvoi === 'email') { $mdDialog.hide(response.data); return; }
                vm.resultat = response.data.data;
                if (!vm.resultat || !vm.resultat.Canaux) {
                    vm.resultat = {Canaux:[]};
                    vm.error = 'Réponse incomplète : vérifier les statuts avant de relancer un envoi.';
                }
            }, function () {
                // Une interruption réseau ne prouve pas que le document n'a pas été envoyé.
                vm.resultat = {Canaux:[]};
                vm.error = 'Réponse non reçue. Fermer et vérifier les statuts avant de relancer l’envoi.';
            }).finally(function () { vm.busy = false; });
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.commandes.factures')
        .controller('ContactsSendFactureController', ContactsSendFactureController);

		
    /** @ngInject */
    function ContactsSendFactureController($mdDialog, $http, $scope, $element, contacts, NumeroFacture, RaisonSocial, $mdToast)
    {
		
		var vm = this;
		vm.contacts = contacts;
		vm.NumeroFacture = NumeroFacture;
		vm.RaisonSocial = RaisonSocial;
		
		vm.EnvoiEmail = true;
        vm.EnvoiPlateforme = false;
		
		vm.generateAcompteFacture = function(contact){
            if ((!vm.EnvoiEmail && !vm.EnvoiPlateforme) || vm.confirmationEnCours) return;
            if (vm.EnvoiEmail && (!contact || !contact.Email)) return;
            var envoi = vm.EnvoiEmail ? angular.copy(contact) : {};
            vm.confirmationEnCours = true;
            envoi.EnvoiEmail = vm.EnvoiEmail;
            envoi.EnvoiPlateforme = vm.EnvoiPlateforme;
            var message = vm.EnvoiEmail ? "Un email va être envoyé à " + contact.Email : "";
            if (vm.EnvoiPlateforme) message += (message ? " et la facture sera transmise à SuperPDP." : "La facture sera transmise à SuperPDP.");
			var confirm = $mdDialog.confirm()
			  .title(vm.EnvoiEmail ?
                  ' Envoyer la facture à ' + contact.Civilite + " " + contact.Prenom + " " + contact.Nom + " (" + contact.Fonction + ") ?" :
                  'Transmettre la facture ' + vm.NumeroFacture + ' à SuperPDP ?')
			  .textContent(message)
			  .ariaLabel("Envoyer")
			  // .targetEvent(ev)
				.multiple(true)
				.theme('md-warn')
			  .ok("Envoyer")
			  .cancel('Annuler');
		
			$mdDialog.show(confirm).then(function () {
				$mdDialog.hide(envoi);
			}, angular.noop).finally(function () { vm.confirmationEnCours = false; });
			
		}
	
		vm.closeDialog = function()
		{
			$mdDialog.hide();
		}  

    }
	
})();

(function ()
{
    'use strict';

    angular
        .module('app.commandes.commandes',
            [
				'wt.responsive',
                // 3rd Party Dependencies
                // 'wipImageZoom',
               
                // 'flow',
                // 'nvd3',
                // 'textAngular',
                // 'uiGmapgoogle-maps',
                // 'xeditable'
            ]
        )
        .config(config);

	
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.commandes', {
                url      : '/commandes',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/commandes/commandes/commandes.html',
                        controller : 'CommandesController as vm'
                    }
                },
                resolve  : {
                    Commandes: function (msApi)
                    {
                        return msApi.resolve('commandes.commandes@get');
                    },
                    nbrCommandesParEtats: function (msApi)
                    {
                        return msApi.resolve('commandes.nbrCommandesParEtats@get');
                    },
                    Employes: function (msApi)
                    {
                        return msApi.resolve('commandes.Employes@get');
                    },
					employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.simpleListe@get');
                    },
                    Fabricants: function (msApi)
                    {
                        return msApi.resolve('commandes.fabricants@get');
                    },
					simpleListeCommandes: function (msApi)
                    {
                        return msApi.resolve('contacts.simpleListeCommandes@get');
                    }
                },
                bodyClass: 'commandes'
            });

        // Api
        msApiProvider.register('commandes.nbrCommandesParEtats', ['datas/commandes/getNbrCommandesParEtats.json']);
        msApiProvider.register('commandes.commandes', ['datas/commandes/getAllcommandes.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
        msApiProvider.register('commandes.Employes', ['datas/employes/getEmployes.json']);
        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
        msApiProvider.register('contacts.simpleListeCommandes', ['datas/contacts/simpleListeCommandes.json']);
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.commandes')
        .controller('DialogOptionsCommandeController', DialogOptionsCommandeController);

		
    /** @ngInject */
    function DialogOptionsCommandeController($mdDialog, $http, $scope, $element, Commande, $window, $mdToast)
    {
		
		var vm = this;
		vm.commande = angular.copy(Commande);
		console.log(vm.commande.DateValidation);
		
		if(vm.commande.DateValidation == "" || vm.commande.DateValidation == "0000-00-00")
			vm.commande.DateValidation = null;
		if(vm.commande.DateSignature == "" || vm.commande.DateSignature == "0000-00-00")
			vm.commande.DateSignature = null;
		if(vm.commande.DateRenouvellement == "" || vm.commande.DateRenouvellement == "0000-00-00")
			vm.commande.DateRenouvellement = null;
		
		vm.webregex = RegExp('^((https?|ftp)://)?([a-z]+[.])?[a-z0-9-]+([.][a-z]{1,6}){1,2}(/.*[?].*)?$', 'i');
		console.log(vm.commande);
		vm.saveCommande = function(){
		 $http.post("/datas/commandes/setOptionsCommande.json",JSON.stringify(vm.commande))
			.then(function (response, status, headers, config) {
				$mdToast.show(
				  $mdToast.simple()
					.textContent('Le commande a été modifiée !')
					.position('bottom right' )
					.hideDelay(3000)
				);
				$mdDialog.hide(response.data);
			}, function () {});
		}
			
	
		vm.closeDialog = function()
		{
			$mdDialog.cancel();
		}  
		
		vm.loadSites = function(){
			$http.post("/datas/contacts/getSitesContact.json",JSON.stringify(vm.commande))
			.then(function (response, status, headers, config) {
				vm.sites = response.data.data;
			}, function () {});				
		}
		vm.loadSites();

		vm.addwebsite = function(url) {
			$http.post("/datas/contacts/addSite.json",JSON.stringify({'url':url, "IDContact":vm.commande.IDContact}))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$scope.optionsCommandeForm.newURL.$setValidity("newURLFailed", false);
					$scope.status = response.data.error.message;
				}
				else{					
					$scope.optionsCommandeForm.newURL.$setValidity("newURLFailed", true);
					vm.addsite = 0; vm.newURL = '';
					$mdToast.show(
					  $mdToast.simple()
						.position('bottom right')
						.textContent('Site internet ajouté')
						.hideDelay(3000)
					);
					vm.loadSites();
				}
			}, function () {});
			
		};

    }
	
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.commandes')
        .controller('CommandesDialogController', CommandesDialogController);

    /** @ngInject */
    function CommandesDialogController($mdDialog,paramVM, Fabricants, $http, $scope, $element, IDCommande, $window, $rootScope, $mdToast)
    {
		
		var vm = this;
		vm.permission = $rootScope.Permission;
		vm.idUser = $rootScope.id;
		vm.IDCommande = angular.copy(IDCommande);
		vm.Fabricants = angular.copy(Fabricants.data);
		vm.FabTemp = null;
		vm.FabEdit = 0;
		vm.prelevement = 0;
		paramVM.reload = false;
		
		
		vm.isDateBefore = function(dateToTest) {
			if(typeof dateToTest == "undefined" || dateToTest == "0000-00-00" || dateToTest=="")
				return false;
			
			var referenceDate = new Date("2024-12-19");
			
			return new Date(dateToTest) < referenceDate; // Comparaison des dates
		};
		
		vm.fabEdit = function(edit){
			if(edit){
				// Fabricant.edit = 1; 
				vm.FabEdit = 1;
				vm.FabTemp = angular.copy(vm.commande.Fabricants);
			}
			else{
				vm.commande.Fabricants = angular.copy(vm.FabTemp);
				// Fabricant.edit = 0; 
				vm.FabEdit = 0;
				vm.FabTemp = null;
			}
		}
		
		vm.isFormValid = function (formName){
            if ( $scope[formName] && $scope[formName].$valid )
            {
                return $scope[formName].$valid;
            }
        }
		
		vm.nl2br = function  (str, is_xhtml) {
			if (typeof str === 'undefined' || str === null) {
				return '';
			}
			var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
			return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
		}

		$http.get("/datas/commandes/getCommande.json?IDCommande="+vm.IDCommande)
		.then(function (response, status, headers, config) {
			vm.commande = response.data.data;
			vm.TotalPaiement = 0;
			angular.forEach(vm.commande.paiements, function(value, key) {		
				vm.TotalPaiement = vm.TotalPaiement + (parseFloat(value.Montant));
			});
			vm.TotalPaiement = Math.round(vm.TotalPaiement *100)/100;
			
			if(vm.commande.Prelevement == 1 && vm.commande.IDCommande_IBAN==0)
				vm.prelevement = 1;
			
		}, function () {});	

		vm.add_months = function (dt, n) {
			var date = new Date(dt);
			return new Date(date.setMonth(date.getMonth() + n));      
		}
	 
	 
		vm.getDevisSigne = function (ev, IDCommande, NumeroCommande){
			$window.open("/datas/files/devis_signes/"+IDCommande+"-"+NumeroCommande+".pdf", '_blank');
		}
		
		vm.getDevis = function (ev, IDCommande, prelevement){
			if(prelevement ==1){
				var confirm = $mdDialog.confirm()
					  .title('Attention, IBAN du contact manquant !')
					  .textContent("L'IBAN sera obligatoire pour valider une commande par prélévement")
					  .ariaLabel('IBAN manquant')
					  .targetEvent(ev)
						.multiple(true)
					  .clickOutsideToClose(true)
					.parent(angular.element("#invoice"))
					  .ok('Continuer')
					  .cancel('Annuler');
					  
					$mdDialog.show(confirm).then(function() {
						 $mdDialog.show({
						  controller: DialogDevisController,
							templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
							multiple:true,
							parent             : angular.element("#invoice"),
						  targetEvent: ev,
						  clickOutsideToClose:true
						})
						.then(function(result) {
							var lien = "/datas/commandes/devis.json?IDCommande="+IDCommande;
							
							if(result.indexOf("Conditions Générales de Ventes")>=0)
								lien +="&cgv=1";
							else
								lien +="&cgv=0";
							if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
								lien +="&retractation=1";
							else
								lien +="&retractation=0";
							
							$window.open(lien, '_blank');
						}, function() {
					});
				}, function() {}); 
			}
			else{
			   $mdDialog.show({
					  controller: DialogDevisController,
						templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
                parent             : angular.element("#invoice"),
					  targetEvent: ev,
					multiple:true,
					  clickOutsideToClose:true
					})
					.then(function(result) {
						var lien = "/datas/commandes/devis.json?IDCommande="+IDCommande;
						
						if(result.indexOf("Conditions Générales de Ventes")>=0)
							lien +="&cgv=1";
						else
							lien +="&cgv=0";
						if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
							lien +="&retractation=1";
						else
							lien +="&retractation=0";
						
						$window.open(lien, '_blank');
					}, function() {
				});
			}
		}
		function DialogDevisController($scope, $mdDialog) {
			$scope.hide = function() {
			  $mdDialog.hide();
			};
			
			$scope.items = ["Conditions Générales de Ventes", "Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>", "Cahier des charges fonctionnel"];
			$scope.selected = ["Conditions Générales de Ventes"];

			$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
			};

			$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
			};
		  
			$scope.cancel = function() {
			  $mdDialog.cancel();
			};

			$scope.answer = function(result) {
			  $mdDialog.hide(result);
			};
		}
		 vm.getFacture = function (ev, IDCommande, DateRenouvellement, Etat, DateFacturation, TotalTTC)
        {
			if(Etat != "Facturée"/*  && Etat != "Signée" */){
				$http.get("/datas/commandes/getCommande.json?IDCommande="+IDCommande)
				.then(function (response, status, headers, config) {
					var comde = response.data.data;
					var produit_a_renouveler = [];
					
					angular.forEach(comde.produits, function (value, key) {
						if(value.Renouvellement > 0 ){
							produit_a_renouveler.push({'Produit':value.Produit,'Renouvellement':value.Renouvellement});
						}
						
						angular.forEach(value.SousProduitsSelect, function (v, k) {
							if(v.Renouvellement > 0 ){
								produit_a_renouveler.push({'Produit':v.Produit,'Renouvellement':v.Renouvellement});
							}
						});
					});
					
					if(produit_a_renouveler.length > 0 && TotalTTC>0){
						$mdDialog.show({
							multiple:true,
						  controller: 'DialogFactureController',
							templateUrl        : 'app/main/commandes/commande/dialogs/facture-dialog.html',
							parent             : angular.element("#invoice"),
						  targetEvent: ev,
						  clickOutsideToClose:true,
							locals             : {
								Renouvellement : DateRenouvellement,
								produit_a_renouveler : produit_a_renouveler
							}
						})
						.then(function(result) {
							Etat = "Facturée";
							DateFacturation = Date.now();
							if(typeof result != "undefined"){
								var d = new Date(result),
								month = '' + (d.getMonth() + 1),
								day = '' + d.getDate(),
								year = d.getFullYear();

								if (month.length < 2) month = '0' + month;
								if (day.length < 2) day = '0' + day;
								
								DateRenouvellement = [year, month, day].join('-');
							}
							// writeCommande();
							$mdToast.show(
							  $mdToast.simple()
								.textContent('La commande a été facturée !')
								.position('bottom right' )
								.hideDelay(3000)
							);
							
							$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
							paramVM.reload = true;
							 // vm.dtInstance.reloadData();
						
						}, function() {
						});
					}
					else{
						
						if(TotalTTC<0)
							var confirm = $mdDialog.confirm().multiple(true)
							  .title(' Souhaitez-vous faire un avoir ? ')
							  .textContent("Une fois l'avoir généré, cette commande ne pourra plus être modifiée.")
							  .ariaLabel("Générer l'avoir")
							  .targetEvent(ev)
								.theme('md-warn')
							  .ok("Générer l'avoir")
							  .cancel('Annuler');
						else
							var confirm = $mdDialog.confirm().multiple(true)
							  .title(' Souhaitez-vous facturer cette commande ? ')
							  .textContent('Une fois facturée, cette commande ne pourra plus être modifiée. ')
							  .ariaLabel('Facturer la commande')
							  .targetEvent(ev)
								.theme('md-warn')
							  .ok('Générer la facture')
							  .cancel('Annuler');
							  
						$mdDialog.show(confirm).then(function () {
						  	  
								$mdToast.show(
								  $mdToast.simple()
									.textContent('La commande a été facturée !')
									.position('bottom right' )
									.hideDelay(3000)
								);
								
								$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
								paramVM.reload = true;
								 // vm.dtInstance.reloadData();
						}, function () {
						});
					  
					} 
				}, function () {});	
			}
			else{
				/* if(Etat == "Signée"){
					Etat = "Facturée";
					DateFacturation = Date.now();
				} */
				$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
					 // vm.dtInstance.reloadData();
			}
		
        }
		
		vm.getFactureAcompte = function (ev, commande){
			
			$http.get("/datas/commandes/getCommande.json?IDCommande="+commande)
			.then(function (response, status, headers, config) {
				// console.log(response.data.data);
				$mdDialog.show({
                parent             : angular.element("#invoice"),
					targetEvent        : ev,
				multiple:true,
					controller         : 'DialogFactureAcompteController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commandes/dialogs/acompte-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande : response.data.data,
						Paiements : response.data.data.paiements,
						dtInstance : ""
					}
				});
				
				paramVM.reload = true;
					 // vm.dtInstance.reloadData();
			}, function () {});
		}
		
	 	vm.add_post = function(){
			if(vm.text_add_post){
				var date = new Date();
				var h=date.getHours();
				if (h<10) {h = "0" + h}
				var m=date.getMinutes();
				if (m<10) {m = "0" + m}
				
				$http.post("/datas/commandes/setNote.json", JSON.stringify({"Note":vm.text_add_post, "IDCommande":vm.commande.IDCommande})).then(function (response, status, headers, config) {
					// vm.contact = response.data.data;
					console.log(response);
					// vm.loader = 0;
				
					vm.commande.notes.unshift({"Note":vm.text_add_post, IDNote: response.data.IDNote, "IDEmploye" : $rootScope.id,"Utilisateur":$rootScope.Prenom+' '+$rootScope.Nom, "DateCreation":"Posté à "+h+':'+m});
	
					vm.text_add_post = "";
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Votre commentaire a été ajouté !')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}, function () {});
				
				/* vm.commande.notes.unshift({"Note":vm.text_add_post, "IDEmploye" : $rootScope.IDEmploye,"Utilisateur":$rootScope.Prenom+' '+$rootScope.Nom, "DateCreation":"Posté à "+h+':'+m});
				$http.post("/datas/commandes/setNote.json", JSON.stringify({"Note":vm.text_add_post, "IDCommande":vm.commande.IDCommande}));
				vm.text_add_post = "";
				$mdToast.show(
				  $mdToast.simple()
					.textContent('Votre commentaire a été ajouté !')
					.position('bottom right' )
					.hideDelay(3000)
				); */
			}
			else{
				$mdToast.show(
				  $mdToast.simple()
					.textContent("Vous n'avez pas saisie de texte...")
					.position('bottom right' )
					.hideDelay(3000)
				);
			}
		};
		
	 	vm.edit_post = function(note){
			if(note.Note){
				var date = new Date();
				var h=date.getHours();
				if (h<10) {h = "0" + h}
				var m=date.getMinutes();
				if (m<10) {m = "0" + m}
				
				if(note.Note != note.Temp){
					note.DateModification = "Modifié à "+h+':'+m; 
					
					$http.post("/datas/commandes/setNote.json", JSON.stringify({"Note":note.Note, "IDNote":note.IDNote}));
					vm.text_add_post = "";
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Votre commentaire a été modifié !')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
				note.Edit = 0; 
			}
			else{
				$mdToast.show(
				  $mdToast.simple()
					.textContent("Vous n'avez pas saisie de texte...")
					.position('bottom right' )
					.hideDelay(3000)
				);
			}
		};
		
		vm.getNumber = function(num) {
			return new Array(num);   
		}

		
		
		vm.closeDialog = function()
		{
			$mdDialog.hide(paramVM.reload);
		} 
		
	/* 	vm.generateFacture = function (IDCommande)
		{
			$window.open("/datas/commandes/facture.json?IDCommande="+vm.IDCommande, '_blank');
			Commande.Etat = "Facturée";
			Commande.DateFacturation = new Date();
		} */
		
		// vm.getDevis = function (IDCommande)
		// {
			// $window.open("/datas/commandes/devis.json?IDCommande="+vm.IDCommande, '_blank');
		// }
			
		$('#invoice-table').basictable();
		
		vm.showLogs = function(ev, Commande){
			$mdDialog.show({
                parent             : angular.element("#invoice"),
                targetEvent        : ev,
                controller         : 'DialogLogsCommandeController',
                controllerAs       : 'vm',
                multiple       : 'true',
                templateUrl        : 'app/main/commandes/commande/dialogs/logs-dialog.html',
                clickOutsideToClose: true,
                locals             : {
					Commande : Commande
                }
            }).then(function(result) {}, function () {
			});
		}
		
		
		vm.updateFabricants = function (){
			vm.showSpinner = 1;
			 $http.post("/datas/commandes/updateFabricants.json",JSON.stringify(vm.commande))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.multiple(true)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					vm.commande = response.data.data;
						$mdToast.show(
						  $mdToast.simple()
							.textContent('La marge a été recalculée !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					
					vm.showSpinner = 0;
				}
				paramVM.reload = true;
			}, function () {});	
		}

    }
	
	!function(t){t.fn.basictable=function(a){var e=function(a,e){var r=[];if(e.tableWrap&&a.wrap('<div class="bt-wrapper"></div>'),e.header){var i="";i=a.find("thead tr th").length?"thead th":a.find("tbody tr th").length?"tbody tr th":a.find("th").length?"tr:first th":"tr:first td",t.each(a.find(i),function(){var a=t(this),e=parseInt(a.attr("colspan"),10)||1,n=a.closest("tr").index();r[n]||(r[n]=[]);for(var i=0;i<e;i++)r[n].push(a)})}t.each(a.find("tbody tr"),function(){n(t(this),r,e)}),t.each(a.find("tfoot tr"),function(){n(t(this),r,e)})},n=function(a,e,n){a.children().each(function(){var a=t(this);if(""!==a.html()&&"&nbsp;"!==a.html()||n.showEmptyCells){for(var r=a.index(),i="",o=0;o<e.length;o++){0!=o&&(i+=": "),i+=e[o][r].text()}a.attr("data-th",i),n.contentWrap&&!a.children().hasClass("bt-content")&&a.wrapInner('<span class="bt-content" />')}else a.addClass("bt-hide")})},r=function(a,e){e.forceResponsive?null!==e.breakpoint&&t(window).width()<=e.breakpoint||null!==e.containerBreakpoint&&a.parent().width()<=e.containerBreakpoint?i(a,e):o(a,e):a.removeClass("bt").outerWidth()>a.parent().width()?i(a,e):o(a,e)},i=function(t,a){t.addClass("bt"),a.header||t.addClass("bt--no-header"),a.tableWrap&&t.parent(".bt-wrapper").addClass("active")},o=function(t,a){t.removeClass("bt bt--no-header"),a.tableWrap&&t.parent(".bt-wrapper").removeClass("active")},s=function(a,e){var n;a.removeClass("bt bt--no-header"),a.find("td").removeAttr("data-th"),e.tableWrap&&a.unwrap(),e.contentWrap&&(n=a,t.each(n.find("td"),function(){var a=t(this),e=a.children(".bt-content").html();a.html(e)})),a.removeData("basictable")};this.each(function(){var n=t(this);if(0===n.length||n.data("basictable")){if(n.data("basictable")){var l=n.data("basictable");"destroy"===a?s(n,l):"restart"===a?(s(n,l),n.data("basictable",l),e(n,l),r(n,l)):"start"===a?i(n,l):"stop"===a?o(n,l):r(n,l)}return!1}var c=t.extend({},t.fn.basictable.defaults,a),d={breakpoint:c.breakpoint,containerBreakpoint:c.containerBreakpoint,contentWrap:c.contentWrap,forceResponsive:c.forceResponsive,noResize:c.noResize,tableWrap:c.tableWrap,showEmptyCells:c.showEmptyCells,header:c.header};null===d.breakpoint&&null===d.containerBreakpoint&&(d.breakpoint=568),n.data("basictable",d),e(n,n.data("basictable")),d.noResize||(r(n,n.data("basictable")),t(window).bind("resize.basictable",function(){var t;(t=n).data("basictable")&&r(t,t.data("basictable"))}))})},t.fn.basictable.defaults={breakpoint:null,containerBreakpoint:null,contentWrap:!0,forceResponsive:!0,noResize:!1,tableWrap:!1,showEmptyCells:!1,header:!0}}(jQuery);

})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.commandes')
        .controller('DialogFactureAcompteController', FactureAcompteController);

		
    /** @ngInject */
    function FactureAcompteController($mdDialog, $http, $scope, $element, Paiements, Commande, $window, $mdToast, dtInstance)
    {
		
		var vm = this;
		vm.paiements = Paiements;
		vm.commande = Commande;
		vm.TotalPaiement = 0;
		
		vm.isDateBefore = function(dateToTest) {
			if(typeof dateToTest == "undefined" || dateToTest == "0000-00-00" || dateToTest=="")
				return false;
			
			var referenceDate = new Date("2024-12-19");
			
			return new Date(dateToTest) < referenceDate; // Comparaison des dates
		};
  
		angular.forEach(Paiements, function(value, key) {
		  vm.TotalPaiement += value.Montant;
		});

		
		vm.generateAcompteFacture = function(ev, Paiement, Commande){
		
			var produit_a_renouveler = [];
				
			angular.forEach(Commande.produits, function (value, key) {
				if(value.Renouvellement > 0 ){
					produit_a_renouveler.push({'Produit':value.Produit,'Renouvellement':value.Renouvellement});
				}
				angular.forEach(value.SousProduitsSelect, function (v, k) {
					if(v.Renouvellement > 0 ){
						produit_a_renouveler.push({'Produit':v.Produit,'Renouvellement':v.Renouvellement});
					}
				});
			});
			
			if(produit_a_renouveler.length > 0 && Commande.DateRenouvellement == "0000-00-00"){
				$mdDialog.show({
					  controller: 'DialogFactureController',
						templateUrl        : 'app/main/commandes/commande/dialogs/facture-dialog.html',
					  parent: angular.element(document.body),
					  targetEvent: ev,
					  clickOutsideToClose:true,
						locals             : {
							Renouvellement : Commande.DateRenouvellement,
							produit_a_renouveler : produit_a_renouveler
						}
					})
					.then(function(result) {
						// Commande.Etat = "Facturée";
						// Commande.EtatAffiche = "Facturée";
						// Commande.DateFacturation = Date.now();
						if(typeof result != "undefined"){
							var d = new Date(result),
							month = '' + (d.getMonth() + 1),
							day = '' + d.getDate(),
							year = d.getFullYear();

							if (month.length < 2) month = '0' + month;
							if (day.length < 2) day = '0' + day;
							
							Commande.DateRenouvellement = [year, month, day].join('-');
						}
						// writeCommande();
						$mdToast.show(
						  $mdToast.simple()
							.textContent("L'échéance a été facturée !")
							.position('bottom right' )
							.hideDelay(3000)
						);
						/* if(dtInstance != "")
							dtInstance.reloadData(); */
						Paiement.FactureAc = 1;
						Paiement.DateFactureAc = new Date();
						$window.open("/datas/commandes/afacture.json?IDCommande="+vm.commande.IDCommande+"&IDPaiement="+Paiement.IDCommandes_Paiement+'&DateRenouvellement='+Commande.DateRenouvellement, '_blank');
					
					}, function() {
					});
				
			}
			else{
			
				$mdToast.show(
				  $mdToast.simple()
					.textContent("L'échéance a été facturée !")
					.position('bottom right' )
					.hideDelay(3000)
				);
				var lien = "/datas/commandes/afacture.json?IDCommande="+vm.commande.IDCommande+"&IDPaiement="+Paiement.IDCommandes_Paiement;
				Paiement.FactureAc = 1;
				Paiement.DateFactureAc = new Date();
				$window.open(lien, '_blank');
			}
		}
		
		vm.getFacture = function (ev, Commande)
        {
			if(Commande.Etat != "Facturée"/*  && Commande.Etat != "Signée" */){
				var produit_a_renouveler = [];
				
				angular.forEach(Commande.produits, function (value, key) {
					if(value.Renouvellement > 0 ){
						produit_a_renouveler.push({'Produit':value.Produit,'Renouvellement':value.Renouvellement});
					}
					angular.forEach(value.SousProduitsSelect, function (v, k) {
						if(v.Renouvellement > 0 ){
							produit_a_renouveler.push({'Produit':v.Produit,'Renouvellement':v.Renouvellement});
						}
					});
				});
				
				if(produit_a_renouveler.length > 0 && Commande.TotalTTC>0){
					$mdDialog.show({
					  controller: 'DialogFactureController',
						templateUrl        : 'app/main/commandes/commande/dialogs/facture-dialog.html',
					  parent: angular.element(document.body),
					  targetEvent: ev,
					  clickOutsideToClose:true,
						locals             : {
							Renouvellement : Commande.DateRenouvellement,
							produit_a_renouveler : produit_a_renouveler
						}
					})
					.then(function(result) {
						Commande.Etat = "Facturée";
						Commande.EtatAffiche = "Facturée";
						Commande.DateFacturation = Date.now();
						if(typeof result != "undefined"){
							var d = new Date(result),
							month = '' + (d.getMonth() + 1),
							day = '' + d.getDate(),
							year = d.getFullYear();

							if (month.length < 2) month = '0' + month;
							if (day.length < 2) day = '0' + day;
							
							Commande.DateRenouvellement = [year, month, day].join('-');
						}
						// writeCommande();
						$mdToast.show(
						  $mdToast.simple()
							.textContent('La commande a été facturée !')
							.position('bottom right' )
							.hideDelay(3000)
						);
						if(dtInstance != "")
							dtInstance.reloadData();
						
						$window.open("/datas/commandes/facture.json?IDCommande="+Commande.IDCommande+'&DateRenouvellement='+Commande.DateRenouvellement, '_blank');
					
					}, function() {
					});
				}
				else{
			
					if(Commande.TotalTTC<0)
						var confirm = $mdDialog.confirm()
						  .title(' Souhaitez-vous faire un avoir ? ')
						  .textContent("Une fois l'avoir généré, cette commande ne pourra plus être modifiée.")
						  .ariaLabel("Générer l'avoir")
						  .targetEvent(ev)
							.theme('md-warn')
						  .ok("Générer l'avoir")
						  .cancel('Annuler');
					else
						var confirm = $mdDialog.confirm()
						  .title(' Souhaitez-vous facturer cette commande ? ')
						  .textContent('Une fois facturée, cette commande ne pourra plus être modifiée. ')
						  .ariaLabel('Facturer la commande')
						  .targetEvent(ev)
							.theme('md-warn')
						  .ok('Générer la facture')
						  .cancel('Annuler');

						$mdDialog.show(confirm).then(function () {
							 if(Commande.Etat == "Signée"){
								Commande.EtatAffiche = "Facturée";
								Commande.Etat = "Facturée";
								Commande.DateFacturation = Date.now();
							}
							if(dtInstance != "")
								dtInstance.reloadData();
							$window.open("/datas/commandes/facture.json?IDCommande="+Commande.IDCommande+'&DateRenouvellement='+Commande.DateRenouvellement, '_blank');
						}, function () {
					});
					
					
				}
			}
			else{
				/* if(Etat == "Signée"){
					Etat = "Facturée";
					DateFacturation = Date.now();
				} */
				$window.open("/datas/commandes/facture.json?IDCommande="+Commande.IDCommande+'&DateRenouvellement='+Commande.DateRenouvellement, '_blank');
					 // vm.dtInstance.reloadData();
			}
		
        }
		
		vm.closeDialog = function()
		{
			console.log('test');
			$mdDialog.hide();
		}  

    }
	
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition', ["xeditable",'ui.sortable', 'ngMaterialCollapsible'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.commandes.edition', {
                url      : '/edition/:token/:IDContact',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/commandes/commande/edition.html',
                        controller : 'EditionController as vm'
                    }
                },
                resolve  : {
                    Commande: function (msApi, $stateParams)
                    {
                        return msApi.resolve('commandes.commande@get',{'IDCommande': $stateParams.token, 'simplifiePaiements':true});
                    },
                    Contacts: function (msApi)
                    {
                        return msApi.resolve('commandes.contacts@get');
                    },
                    Produits: function (msApi)
                    {
                        return msApi.resolve('commandes.produitscategories@get');
                    },
                    Villes: function (msApi)
                    {
                        return msApi.resolve('adresses.villes@get');
                    },
                    Departements: function (msApi)
                    {
                        return msApi.resolve('adresses.departements@get');
                    },
                    Regions: function (msApi)
                    {
                        return msApi.resolve('adresses.regions@get');
                    },
                    IDContact: function (msApi, $stateParams)
                    {
                        return $stateParams.IDContact;
                    }
                },
                bodyClass: 'commandes'
            })
			.state('app.commandes_nouvelle', {
                url      : '/commandes/nouvelle/:IDContact',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/commandes/commande/edition.html',
                        controller : 'EditionController as vm'
                    }
                },
                resolve  : {
                    Commande: function (msApi, $stateParams)
                    {
                        
                    },
                    Contacts: function (msApi)
                    {
                        return msApi.resolve('commandes.contacts@get');
                    },
                    Produits: function (msApi)
                    {
                        return msApi.resolve('commandes.produitscategories@get');
                    },
                    Villes: function (msApi)
                    {
                        return msApi.resolve('adresses.villes@get');
                    },
                    Departements: function (msApi)
                    {
                        return msApi.resolve('adresses.departements@get');
                    },
                    Regions: function (msApi)
                    {
                        return msApi.resolve('adresses.regions@get');
                    },
                    IDContact: function (msApi, $stateParams)
                    {
                        return $stateParams.IDContact;
                    }
                },
                bodyClass: 'commandes'
            });

        // Translation

        // Api
        msApiProvider.register('commandes.commande', ['datas/commandes/getCommande.json']);
        msApiProvider.register('commandes.contacts', ['datas/contacts/getAll.json']);
        msApiProvider.register('commandes.produitscategories', ['datas/commandes/getAllproduitsParCategorie.json']);
        msApiProvider.register('adresses.villes', ['datas/adresses/getVilles.json']);
        msApiProvider.register('adresses.departements', ['datas/adresses/getDepartements.json']);
        msApiProvider.register('adresses.regions', ['datas/adresses/getRegions.json']);
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition')
        .controller('DialogValideController', DialogValideController);

    /** @ngInject */
	
	
	function DialogValideController($scope, $mdDialog, Commande) {
		
		var vm = this;
	
		
		vm.commande = angular.copy(Commande);

		// $scope.dateSignature = new Date();
		$scope.date = new Date();
		
		if(typeof vm.commande.DateValidation == "undefined" || vm.commande.DateValidation == "0000-00-00")
			vm.commande.DateValidation = $scope.date ;
		
	/* 	
		if(typeof Renouvellement != "undefined" && Renouvellement!="0000-00-00"  && Renouvellement!="" )
			$scope.result = new Date(Renouvellement);
		else
			$scope.result = new Date(); */
	
		// $scope.date.setMonth($scope.date.getMonth() + 6);
		// $scope.result.setYear($scope.result.getFullYear() + 1);
		
		// $scope.date.setDate(1);
		// $scope.date.setMonth(0);
		
			
		$scope.hide = function() {
		  $mdDialog.hide();
		};
		
		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		$scope.answer = function() {
		  $mdDialog.hide(vm.commande);
		};
	  }
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition')
        .controller('DialogSignatureController', DialogSignatureController)
		.directive('validFile',function(){
		  return {
			require:'ngModel',
			link:function(scope,el,attrs,ngModel){
			  //change event is fired when file is selected
			  el.bind('change',function(){
				scope.$apply(function(){
				  ngModel.$setViewValue(el.val());
				  ngModel.$render();
				});
			  });
			}
		  }
		});
	function DialogSignatureController($scope, $mdDialog, Commande, $http, $mdToast) {

		var vm = this;
	
		
		vm.commande = angular.copy(Commande);
		
		
		$scope.dateSignature = new Date();

		$scope.date = new Date();
		
		if(typeof vm.commande.DateSignature == "undefined" || vm.commande.DateSignature == "0000-00-00"){
			vm.commande.DateSignature = new Date() ;
		}
		if(typeof vm.commande.DateRenouvellement == "undefined"){
			// vm.commande.DateRenouvellement = $scope.date ;
		}
	/* 	
		if(typeof Renouvellement != "undefined" && Renouvellement!="0000-00-00"  && Renouvellement!="" )
			$scope.result = new Date(Renouvellement);
		else
			$scope.result = new Date(); */
	
		// $scope.date.setMonth($scope.date.getMonth() + 6);
		// $scope.result.setYear($scope.result.getFullYear() + 1);
		
		// $scope.dateSignature.setDate($scope.dateSignature.getDate()-15);
		$scope.date.setDate(1);
		$scope.date.setMonth(0);
		
			
		$scope.hide = function() {
		  $mdDialog.hide();
		};
		
		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		vm.saveSignature = function() {
			vm.showSpinner = 1;
			
			var fd = new FormData();			 
			fd.append("data", angular.toJson(vm.commande));
			
			var files = $('#file')[0].files;
			
			
			if(files.length > 0 ){
			   fd.append('file',files[0]);
			}
			var config = { headers: {'Content-Type': undefined},
						   transformRequest: angular.identity
						 }
			
			$http.post("/datas/commandes/uploadDevis.json", fd, config)
			.then(function (response, status, headers, config) {
				if(response.data.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
				}
				else{
					 $mdDialog.hide(vm.commande);
					vm.showSpinner = 0;
				}
			}, function () {});


		 
		};
	  }
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition')
        .controller('ProduitsCommandeDialogController', ProduitsCommande);

    /** @ngInject */
    function ProduitsCommande($mdDialog, $http, $scope, $element, Produits)
    {
		// console.log(Produits);
		var vm = this;
		vm.produits = angular.copy(Produits);	
		
		vm.listeProduits = {SousCategories:vm.produits};	
		vm.oldListeProduits = [];
		
		vm.changeCategorie = function(categorie){
			vm.oldListeProduits.push(vm.listeProduits) ;
			vm.listeProduits = categorie;
		}
		
		vm.PrecCategorie = function(categorie){
			vm.listeProduits = vm.oldListeProduits[vm.oldListeProduits.length-1];
			vm.oldListeProduits.splice(-1, 1);
		}
		
		vm.changeProduit = function( nouveauproduit, NbrSousProduits){
			// console.log(nouveauproduit);
			var produit = {};
			if(NbrSousProduits == 0){
				if(nouveauproduit == 0){
					produit = 0;
				}
				else{		
					produit = nouveauproduit;
				/* 	produit.IDProduit = nouveauproduit.IDProduit;
					produit.PrixVenteHT = nouveauproduit.PrixVenteHT;
					produit.PrixVenteHTDefault = nouveauproduit.PrixVenteHT;
					produit.PrixVenteFinalHT = nouveauproduit.PrixVenteHT;
					produit.Produit = nouveauproduit.Produit;
					produit.NoteCommande = nouveauproduit.NoteCommande;
					// produit.PrixAchatHT = nouveauproduit.PrixAchatHT;
					produit.ValeurAchat = nouveauproduit.ValeurAchat;
					produit.Reconduction = nouveauproduit.Reconduction;
					produit.ModePrixVente = nouveauproduit.ModePrixVente;
					produit.PourcentageVentePrixHTAutreProduit = nouveauproduit.PourcentageVentePrixHTAutreProduit;
					produit.Renouvellement = nouveauproduit.Renouvellement;
					produit.RenouvellementDefaut = nouveauproduit.RenouvellementDefaut;
					produit.PrixSpecifiques = nouveauproduit.PrixSpecifiques;
					produit.Fabricants = nouveauproduit.Fabricants;
					produit.Plugin = nouveauproduit.Plugin;
					produit.PrixIncrementeParDuree = nouveauproduit.PrixIncrementeParDuree;
					produit.FinancementInterdit = nouveauproduit.FinancementInterdit; */
						
					
				}
				
				// console.log(produit);
				
				$mdDialog.hide(produit);	
			}	
			else{
				// console.log(nouveauproduit);
				$mdDialog.hide(nouveauproduit);	
			}
		}
	
        vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition')
        .controller('PluginProduitDialogController', PluginProduit)
		.filter('thousandsSeparator', function () {
			return function (input) {
				if (isNaN(input)) return input; // Vérifie si l'entrée est un nombre
				return parseInt(input, 10).toLocaleString('fr-FR'); // Formate avec séparateurs
			};
		});

    /** @ngInject */
    function PluginProduit($mdDialog, $http, $scope, $element, Produit, Villes, Departements, Regions, $timeout, $mdToast )
    {
		
		var vm = this;
		vm.produit = angular.copy(Produit);	
		// console.log(vm.produit);
			// console.log(vm.produit.PrixVenteHT);
		vm.villes = angular.copy(Villes);	
		vm.departements = angular.copy(Departements);	
		vm.regions = angular.copy(Regions);	
		vm.zone = "lieu";
		vm.rayon = '';
		vm.totalLocalites = "";
		
		if(vm.produit.Renouvellement == "-1")
			vm.produit.Renouvellement = 12;
		
		vm.showMore = {
			veryhard: false,
			challenging : false,
			departements : false,
			regions : false,
			hard: false,
			medium: false,
			easy: false
		};

		vm.searchTerm = '';
		vm.clearSearchTerm = function() {
            vm.searchTerm = ''; // Réinitialiser le terme de recherche
        };
		
		vm.openSelectSearch = function (selector) {
			const interval = setInterval(function() {
				const input = document.querySelector(selector);
				if (input && input.offsetParent !== null) {
					input.focus();
					clearInterval(interval); // Arrêter l’intervalle dès que l’élément est trouvé
				}
			}, 100); // Vérifier toutes les 100 ms

			// Arrêter après un délai maximum pour éviter des boucles infinies
			vm.addLabelsToOptgroups();
			
			setTimeout(function(){clearInterval(interval)}, 2000); // 2 secondes max
		};
		
		vm.addLabelsToOptgroups = function () {
			// Rechercher tous les optgroups
			const optgroups = document.querySelectorAll('md-optgroup');

			optgroups.forEach(function(optgroup){
				// Vérifier si un label est déjà présent
				if (!optgroup.querySelector('label.md-container-ignore')) {
					// Récupérer l'attribut "label" de l'optgroup
					const labelText = optgroup.getAttribute('label');
					if (labelText) {
						// Créer un nouvel élément <label>
						const label = document.createElement('label');
						label.className = 'md-container-ignore';
						label.setAttribute('aria-hidden', 'true');
						label.textContent = labelText;

						// Insérer le label dans l'optgroup
						optgroup.prepend(label);
					}
				}
			});
		};


		vm.departementFilter = function (departement) {
			// Vérifier si la recherche est vide
			if (!vm.searchTerm || vm.searchTerm.trim() === "") {
				return true; // Pas de filtre si le champ de recherche est vide
			}

			const search = vm.searchTerm.toLowerCase();

			// Filtrer en fonction de NomDepartement ou CodeDepartement
			return (
				(departement.NomDepartement && departement.NomDepartement.toLowerCase().includes(search)) ||
				(departement.CodeDepartement && departement.CodeDepartement.toLowerCase().includes(search))
			);
		};
		
		vm.regionFilter = function (region) {
			// Vérifier si la recherche est vide
			if (!vm.searchTerm || vm.searchTerm.trim() === "") {
				return true; // Pas de filtre si le champ de recherche est vide
			}

			const search = vm.searchTerm.toLowerCase();

			// Filtrer en fonction de NomRegion ou CodeRegion
			return (
				(region.NomRegion && region.NomRegion.toLowerCase().includes(search)) ||
				(region.CodeRegion && region.CodeRegion.toLowerCase().includes(search))
			);
		};

		$element.find('input').on('keydown', function(ev) {
			ev.stopPropagation();
		});
		
		// console.log(Produit);
		if(typeof vm.produit.Parametres == "undefined" || vm.produit.Parametres == null)
			vm.produit.Parametres = {"ComplementDeCommande":false, "requetes":[{'service':null, 'action':[]}],"localites":[], "total" : {"nbrRequetes":0,"nbrPopulation":0, "nbrLocalites":{"veryhard":0,"departements":0,"regions":0,"challenging":0,"hard":0,"medium":0,"easy":0}, "price":{"departement":0,"regions":0,"veryhard":0,"challenging":0,"hard":0,"medium":0,"easy":0}}};
		
		if(typeof vm.produit.Parametres.ComplementDeCommande == "undefined")
			vm.produit.Parametres.ComplementDeCommande = false;
		
		if(typeof vm.produit.Parametres.total.nbrLocalites.regions == "undefined"){
			vm.produit.Parametres.total.nbrLocalites.regions = 0;
			vm.produit.Parametres.total.price.regions = 0;
		}
		
		vm.updateLocalitesCount = function () {
		  // Initialisation des catégories avec des tableaux vides
			vm.produit.Parametres.total.nbrLocalites = {
				veryhard: [],
				departements: [],
				regions: [],
				challenging: [],
				hard: [],
				medium: [],
				easy: [],
			};

			// Utilisation d'un ensemble temporaire pour suivre les localités uniques
			var localitesCount = new Map();

			// **Première passe** : Ajouter toutes les localités incluses
			vm.produit.Parametres.localites.forEach(function (ville) {
				if (ville.inclus === true) {
					if(!ville.NomDepartement && !ville.NomRegion){
					// Ajouter la ville principale
						if (!localitesCount.has(ville.IDVille)) {
							localitesCount.set(ville.IDVille, {
							  NomVille: ville.NomVille,
							  CodePostal: ville.CodePostal,
							  Population: ville.Population,
							  IDDepartement: ville.IDDepartement,
							  IDRegion: ville.IDRegion,
							  IDRegionAncienne: ville.IDRegionAncienne,
							});
						}

						// Ajouter les sous-localités
						if (ville.rayon && ville.rayon.villes) {
							ville.rayon.villes.forEach(function (sousVille) {
								if (!localitesCount.has(sousVille.IDVille)) {
									localitesCount.set(sousVille.IDVille, {
										NomVille: sousVille.NomVille,
										CodePostal: sousVille.CodePostal,
										Population: sousVille.Population,
										IDDepartement: sousVille.IDDepartement,
										IDRegion: sousVille.IDRegion,
										IDRegionAncienne: sousVille.IDRegionAncienne,
									});
								}
							});
						}
					}
					else if(ville.NomRegion){
						vm.produit.Parametres.total.nbrLocalites.regions.push(ville);
					}
					else{
						vm.produit.Parametres.total.nbrLocalites.departements.push(ville);
					} 
				}
			});

			// **Deuxième passe** : Supprimer les localités des villes exclues
			vm.produit.Parametres.localites.forEach(function (ville) {
				if (ville.inclus === false) {
					if(!ville.NomDepartement && !ville.NomRegion){
						// Supprimer la ville principale
						if (localitesCount.has(ville.IDVille)) {
							localitesCount.delete(ville.IDVille);
						}

						// Supprimer les sous-localités
						if (ville.rayon && ville.rayon.villes) {
							ville.rayon.villes.forEach(function (sousVille) {
								if (localitesCount.has(sousVille.IDVille)) {
									localitesCount.delete(sousVille.IDVille);
								}
							});
						}
					}
					else if(!ville.NomRegion){
						localitesCount.forEach(function(value, key) {
							if (value.IDDepartement === ville.IDDepartement) {
								// console.log('Deleting:', key, value);
								localitesCount.delete(key);
							}
						});

						// Supprimer les sous-localités
						if (ville.rayon && ville.rayon.villes) {
							ville.rayon.villes.forEach(function (sousVille) {
								localitesCount.forEach(function(value, key) {
									if (value.IDDepartement === sousVille.IDDepartement) {
										// console.log('Deleting:', key, value);
										localitesCount.delete(key);
									}
								});
							});
						}
					} 
					else{
						
						// console.log(ville);
						// console.log(localitesCount);
						
						vm.produit.Parametres.total.nbrLocalites.departements.forEach(function(value, key) {
							if (value.IDRegion === ville.IDRegion || value.IDRegionAncienne === ville.IDRegion) {
								// console.log('Deleting:', key, value);
								vm.produit.Parametres.total.nbrLocalites.departements.splice(key, 1);
							}
						});
						
						localitesCount.forEach(function(value, key) {
						// console.log(value);
							if (value.IDRegion === ville.IDRegion || value.IDRegionAncienne === ville.IDRegion) {
								// console.log('Deleting:', key, value);
								localitesCount.delete(key);
							}
						});

						// Supprimer les sous-localités
						if (ville.rayon && ville.rayon.villes) {
							ville.rayon.villes.forEach(function (sousVille) {
								localitesCount.forEach(function(value, key) {
									if (value.IDRegion === sousVille.IDRegion || sousVille.IDRegionAncienne === sousVille.IDRegion) {
										// console.log('Deleting:', key, value);
										localitesCount.delete(key);
									}
								});
							});
						}
					} 
				}
			});

			// **Catégorisation des localités**
			localitesCount.forEach(function (details) {
				
				if (details.Population > 200000) {
					vm.produit.Parametres.total.nbrLocalites.veryhard.push(details);
				} else if (details.Population > 100000) {
					vm.produit.Parametres.total.nbrLocalites.challenging.push(details);
				} else if (details.Population > 20000) {
					vm.produit.Parametres.total.nbrLocalites.hard.push(details);
				} else if (details.Population > 5000) {
					vm.produit.Parametres.total.nbrLocalites.medium.push(details);
				} else {
					vm.produit.Parametres.total.nbrLocalites.easy.push(details);
				}
			});
			
			vm.totalLocalites = vm.produit.Parametres.total.nbrLocalites.departements.length + vm.produit.Parametres.total.nbrLocalites.regions.length + vm.produit.Parametres.total.nbrLocalites.veryhard.length + vm.produit.Parametres.total.nbrLocalites.challenging.length + vm.produit.Parametres.total.nbrLocalites.hard.length + vm.produit.Parametres.total.nbrLocalites.medium.length + vm.produit.Parametres.total.nbrLocalites.easy.length;
			
			// console.log(vm.totalLocalites);
			if(vm.totalLocalites>0)
				$scope.horizontalStepper.horizontalStep2.$setValidity("localites", true);
			else
				$scope.horizontalStepper.horizontalStep2.$setValidity("localites", false);
			// console.log($scope.horizontalStepper.horizontalStep2);
			
		};
		
		
		vm.coef = {"maintenance": 0, "requete":95, "mot": 0.5, "departements":1.1, "regions":1.2, "veryhard":1.2, "challenging":1.1, "hard":1, "medium":0.8, "easy":0.028};
		
		vm.calculatePrice = function () {
			vm.getTotalPopulationAdjusted();
			
			var populationEasy = 0;
			if(vm.produit.Parametres.total.nbrLocalites.easy.length>0)
				vm.produit.Parametres.total.nbrLocalites.easy.forEach(function (details) {
					populationEasy += parseInt(details.Population);
				});
			// console.log(vm.produit.Parametres.total.nbrLocalites.departements);
			// console.log(vm.produit.Parametres.total.nbrLocalites.regions);
			
			const requetes = vm.produit.Parametres.requetes.length;
			const actions = vm.produit.Parametres.requetes.reduce(function (sum, req) {
			  return sum + req.action.length;
			}, 0);
			const localitesVeryHard = vm.produit.Parametres.total.nbrLocalites.veryhard.length;
			const localitesDepartement = vm.produit.Parametres.total.nbrLocalites.departements.length;
			const localitesRegions = vm.produit.Parametres.total.nbrLocalites.regions.length;
			const localitesChallenging = vm.produit.Parametres.total.nbrLocalites.challenging.length;
			const localitesHard = vm.produit.Parametres.total.nbrLocalites.hard.length;
			const localitesMedium = vm.produit.Parametres.total.nbrLocalites.medium.length;
			const localitesEasy = vm.produit.Parametres.total.nbrLocalites.easy.length;

			// Calcul du prix
			const basePrice = (requetes + (actions * vm.coef.mot)) * vm.coef.requete ;
			// console.log(localitesEasy);
			// console.log(vm.coef.easy);
			const locationMultiplier =
				localitesVeryHard * vm.coef.veryhard +
				localitesChallenging * vm.coef.challenging +
				localitesDepartement * vm.coef.departements +
				localitesRegions * vm.coef.regions +
				localitesHard * vm.coef.hard +
				localitesMedium * vm.coef.medium;
				

			var price =  (vm.coef.maintenance + basePrice * locationMultiplier + localitesEasy * vm.coef.easy) / 12 * vm.produit.Renouvellement;
			// console.log((vm.coef.maintenance + basePrice * locationMultiplier + localitesEasy * vm.coef.easy / vm.coef.requete));
			// console.log((vm.coef.maintenance + basePrice * locationMultiplier));
			if(isNaN(price)) price = 0;
			
			vm.produit.Parametres.total.price.veryhard = basePrice * localitesVeryHard * vm.coef.veryhard / 12 * vm.produit.Renouvellement;
			vm.produit.Parametres.total.price.challenging = basePrice * localitesChallenging * vm.coef.challenging / 12 * vm.produit.Renouvellement;
			vm.produit.Parametres.total.price.departements = basePrice * localitesDepartement * vm.coef.departements / 12 * vm.produit.Renouvellement;
			vm.produit.Parametres.total.price.regions = basePrice * localitesRegions * vm.coef.regions / 12 * vm.produit.Renouvellement;
			vm.produit.Parametres.total.price.hard = basePrice * localitesHard * vm.coef.hard / 12 * vm.produit.Renouvellement;
			vm.produit.Parametres.total.price.medium = basePrice * localitesMedium * vm.coef.medium / 12 * vm.produit.Renouvellement;
			// vm.produit.Parametres.total.price.easy = localitesEasy * vm.coef.easy  / 12 * vm.produit.Renouvellement;
			vm.produit.Parametres.total.price.easy = populationEasy * vm.coef.easy  / 12 * vm.produit.Renouvellement; // uniquement en ads -> base = 5000 € / haut rhin
			
			vm.produit.Parametres.total.price.veryhard = isNaN(vm.produit.Parametres.total.price.veryhard) ? 0 : Math.round(vm.produit.Parametres.total.price.veryhard*100)/100;
			vm.produit.Parametres.total.price.challenging = isNaN(vm.produit.Parametres.total.price.challenging) ? 0 : Math.round(vm.produit.Parametres.total.price.challenging*100)/100;
			vm.produit.Parametres.total.price.departements = isNaN(vm.produit.Parametres.total.price.departements) ? 0 : Math.round(vm.produit.Parametres.total.price.departements*100)/100;
			vm.produit.Parametres.total.price.regions = isNaN(vm.produit.Parametres.total.price.regions) ? 0 : Math.round(vm.produit.Parametres.total.price.regions*100)/100;
			vm.produit.Parametres.total.price.hard = isNaN(vm.produit.Parametres.total.price.hard) ? 0 : Math.round(vm.produit.Parametres.total.price.hard*100)/100;
			vm.produit.Parametres.total.price.medium = isNaN(vm.produit.Parametres.total.price.medium) ? 0 : Math.round(vm.produit.Parametres.total.price.medium*100)/100;
			vm.produit.Parametres.total.price.easy = isNaN(vm.produit.Parametres.total.price.easy) ? 0 : Math.round(vm.produit.Parametres.total.price.easy*100)/100;
			
			
			if(!vm.produit.Parametres.ComplementDeCommande)
				price += 500 / 12 * vm.produit.Renouvellement;	
			
			vm.produit.PrixAchatHT = 0;
			
			angular.forEach(vm.produit.Fabricants, function (v, k) {
				if(v.Fabricant=="Google") {
					v.PrixAchatHT = v.PrixAchatHTCalc = Math.round(vm.produit.Parametres.total.price.easy / 2 * 100) /100;	
				}
				vm.produit.PrixAchatHT += v.PrixAchatHTCalc;
			});
			// console.log(vm.produit);
			// vm.produit.PrixAchatHT = Math.round(vm.produit.Parametres.total.price.easy / 2 * 100) /100;			
			vm.produit.PrixVenteHTDefault = vm.produit.PrixVenteFinalHT = vm.produit.PrixVenteHT = Math.round(price*100)/100; // Arrondi à deux décimales
		};

		vm.getTotalPopulationAdjusted = function () {
			var totalPopulation = 0;
			var excludedDepartments = vm.produit.Parametres.localites
				.filter(function (localite) {
					return !localite.inclus && localite.IDDepartement && localite.NomDepartement; // Exclure les départements non inclus
				})
				.map(function (localite) {
					return localite.IDDepartement; // Obtenir les IDs des départements exclus
				});
				
			var excludedRegions = vm.produit.Parametres.localites
				.filter(function (localite) {
					return !localite.inclus && localite.IDRegion && localite.NomRegion; // Exclure les départements non inclus
				})
				.map(function (localite) {
					return localite.IDRegion; // Obtenir les IDs des départements exclus
				});
			
			var excludedVilles = new Set();
			vm.produit.Parametres.localites.forEach(function (ville) {
				if (!ville.inclus) {
					// Ajouter la ville principale exclue
					excludedVilles.add(ville.IDVille);

					// Ajouter les sous-villes dans le rayon exclu
					if (ville.rayon && ville.rayon.villes) {
						ville.rayon.villes.forEach(function (sousVille) {
							excludedVilles.add(sousVille.IDVille);
						});
					}
				}
			});
			// console.log(excludedVilles);
			// Parcourir les localités principales
			vm.produit.Parametres.localites.forEach(function (ville) {
				// Ignorer les villes appartenant à un département exclu
				
				if (ville.inclus) {
					// Ajouter la population de la ville principale incluse
					if (ville.rayon && ville.rayon.villes && ville.rayon.distance > 0) {
						// Ajouter les sous-localités incluses
						ville.rayon.villes.forEach(function (sousVille) {
							if (!excludedDepartments.includes(sousVille.IDDepartement) && !excludedRegions.includes(sousVille.IDRegion)  && !excludedRegions.includes(sousVille.IDRegionAncienne) && ville.inclus && !excludedVilles.has(sousVille.IDVille)) {
								// console.log(sousVille);
								totalPopulation += parseInt(sousVille.Population, 10) || 0;
							}
						});
					} else {
						if (!excludedDepartments.includes(ville.IDDepartement) && !excludedRegions.includes(ville.IDRegion)  && !excludedRegions.includes(ville.IDRegionAncienne) && ville.inclus && !excludedVilles.has(ville.IDVille))
							totalPopulation += parseInt(ville.Population, 10) || 0;
					}
				}
				
			});

			vm.produit.Parametres.total.nbrPopulation = totalPopulation;
		};

		vm.getLocaliteNames = function (localites) {
			// Vérifiez si localites est un tableau, sinon retournez une chaîne vide
			if (!Array.isArray(localites)) {
				return "";
			}

			return localites.map(function (localite) {
				// return localite.NomVille + " (" + localite.CodePostal + ")";
				return localite.NomVille + " (" + localite.Population.toLocaleString() + " hab.)";
			}).join(", ");
		};

		vm.getDepartementsNames = function (localites) {
			if (!Array.isArray(localites)) {
				return "";
			}

			return localites.map(function (localite) {
				// return localite.NomVille + " (" + localite.CodePostal + ")";
				return localite.CodeDepartement + " - " + localite.NomDepartement;
			}).join(", ");
		};

		vm.getRegionsNames = function (localites) {
			if (!Array.isArray(localites)) {
				return "";
			}

			return localites.map(function (localite) {
				// return localite.NomVille + " (" + localite.CodePostal + ")";
				return localite.CodeRegion + " - " + localite.NomRegion;
			}).join(", ");
		};

		vm.initGoogleMap = function () {
		  // Initialiser la carte
		  vm.map = new google.maps.Map(document.getElementById('map'), {
			center: { lat: 48.1114915, lng: 7.39238455 }, // Exemple : Colmar
			zoom: 10,
		  });

		  // Ajouter les localités incluses et exclues
		  vm.updateGoogleMap();
		};

		var bounds = null;

		vm.updateGoogleMap = function () {
		  // Supprimer tous les anciens marqueurs, cercles et polygones
		  if (vm.mapOverlays) {
			vm.mapOverlays.forEach(function (overlay) {
			  overlay.setMap(null);
			});
		  }
		  vm.mapOverlays = [];

		  var infowindow = new google.maps.InfoWindow(); // Une seule instance pour réutilisation
		  bounds = new google.maps.LatLngBounds(); // Limites de la carte pour ajuster le zoom


			var excludedDepartments = vm.produit.Parametres.localites
				.filter(function (localite) {
					return !localite.inclus && localite.IDDepartement && localite.NomDepartement; // Exclure les départements non inclus
				})
				.map(function (localite) {
					return localite.IDDepartement; // Obtenir les IDs des départements exclus
				});
				
			var excludedRegions = vm.produit.Parametres.localites
				.filter(function (localite) {
					return !localite.inclus && localite.IDRegion && localite.NomRegion; // Exclure les départements non inclus
				})
				.map(function (localite) {
					return localite.IDRegion; // Obtenir les IDs des départements exclus
				});

	
			var excludedVilles = new Set();
			vm.produit.Parametres.localites.forEach(function (ville) {
				if (!ville.inclus) {
					// Ajouter la ville principale exclue
					excludedVilles.add(ville.IDVille);

					// Ajouter les sous-villes dans le rayon exclu
					if (ville.rayon && ville.rayon.villes) {
						ville.rayon.villes.forEach(function (sousVille) {
							excludedVilles.add(sousVille.IDVille);
						});
					}
				}
			});
			
			 var polygonPromises = [];
			 
			// Parcourir les localités
			vm.produit.Parametres.localites.forEach(function (ville) {
			  // console.log(ville);
			  
				var color = ville.inclus ? '#169cd9' : '#dc3545'; // Vert (inclus) et rouge (exclus)
				
				if(!ville.NomDepartement && !ville.NomRegion){
					// Ajouter un marqueur pour la ville principale
					var marker = new google.maps.Marker({
						  position: { lat: parseFloat(ville.Latitude), lng: parseFloat(ville.Longitude) },
						  map: vm.map,
						  title: ville.NomVille + ' (' + ville.CodePostal + ')',
					});
					marker.addListener("mouseover", function () {
						  infowindow.setContent('<strong>' + ville.NomVille + '</strong> (' + ville.CodePostal + ')');
						  infowindow.open(vm.map, marker);
					});
					marker.addListener("mouseout", function () {
						infowindow.close();
					});
					vm.mapOverlays.push(marker);
					bounds.extend(marker.getPosition()); // Ajouter à la limite de la carte

					// Ajouter un cercle pour le rayon
					if (ville.rayon && ville.rayon.distance) {
					  var circle = new google.maps.Circle({
						map: vm.map,
						center: { lat: parseFloat(ville.Latitude), lng: parseFloat(ville.Longitude) },
						radius: ville.rayon.distance * 1000, // Rayon en mètres
						strokeColor: color,
						strokeOpacity: 0.8,
						strokeWeight: 2,
						fillColor: color,
						fillOpacity: 0.2,
					  });
					  vm.mapOverlays.push(circle);
					  bounds.union(circle.getBounds()); // Ajouter le cercle aux limites
					}

					// Ajouter les sous-localités dans le rayon
					if (ville.rayon && ville.rayon.villes) {
						  ville.rayon.villes.forEach(function (sousVille) {
							  // console.log(ville);
							if (!excludedDepartments.includes(sousVille.IDDepartement) && !excludedRegions.includes(sousVille.IDRegion) && !excludedRegions.includes(sousVille.IDRegionAncienne) && ville.inclus && !excludedVilles.has(sousVille.IDVille)) {
								var sousMarker = new google.maps.Marker({
								  position: { lat: parseFloat(sousVille.Latitude), lng: parseFloat(sousVille.Longitude) },
								  map: vm.map,
								  icon: {
									path: google.maps.SymbolPath.CIRCLE,
									scale: 5,
									fillColor: color,
									fillOpacity: 1,
									strokeWeight: 1,
								  },
								  title: sousVille.NomVille + ' (' + sousVille.CodePostal + ') - ' + sousVille.Population + ' habitants',
								});
								sousMarker.addListener("mouseover", function () {
								  infowindow.setContent(
									'<strong>' + sousVille.NomVille + '</strong> (' + sousVille.CodePostal + ')<br>Population : ' +
									  sousVille.Population.toLocaleString()
								  );
								  infowindow.open(vm.map, sousMarker);
								});
								sousMarker.addListener("mouseout", function () {
								  infowindow.close();
								});
								vm.mapOverlays.push(sousMarker);
								bounds.extend(sousMarker.getPosition()); // Ajouter à la limite de la carte
							}
						});
					}

				// Charger et ajouter un polygone depuis Nominatim
					var polygonPromise = vm.fetchPolygonFromNominatim(ville).then(function (polygonData) {
						  if (polygonData) {
							  // console.log(polygonData);
								var polygon = new google.maps.Polygon({
								  paths: polygonData,
								  strokeColor: color,
								  strokeOpacity: 0.8,
								  strokeWeight: 2,
								  fillColor: color,
								  fillOpacity: 0.3,
								  map: vm.map,
								});
								polygon.addListener("mouseover", function () {
								  infowindow.setContent('<strong>' + ville.NomVille + '</strong> (' + ville.CodePostal + ')');
								  infowindow.setPosition({ lat: parseFloat(ville.Latitude), lng: parseFloat(ville.Longitude) });
								  infowindow.open(vm.map);
								});
								polygon.addListener("mouseout", function () {
								  infowindow.close();
								});
								vm.mapOverlays.push(polygon);

								// Ajouter chaque point du polygone aux limites
								polygon.getPath().forEach(function (point) {
								  bounds.extend(point);
								});

								// Ajuster les limites pour inclure le polygone
								vm.map.fitBounds(bounds);
								ville.Polygon = polygonData;
						  }
					});
					polygonPromises.push(polygonPromise);
				}
				else if(!ville.NomRegion){
					var polygonPromise = vm.fetchPolygonFromNominatim(ville).then(function (polygonData) {
						  if (polygonData) {
								var polygon = new google.maps.Polygon({
								  paths: polygonData,
								  strokeColor: color,
								  strokeOpacity: 0.8,
								  strokeWeight: 3,
								  fillColor: color,
								  fillOpacity: ville.inclus ? 0.0 : 0.3 ,
								  map: vm.map,
								});
								polygon.addListener("mouseover", function () {
								  infowindow.setContent('<strong>' + ville.NomDepartement + '</strong> (' + ville.CodeDepartement + ')');
								  // infowindow.setPosition({ lat: parseFloat(ville.Latitude), lng: parseFloat(ville.Longitude) });
								  infowindow.open(vm.map);
								});
								polygon.addListener("mouseout", function () {
								  infowindow.close();
								});
								vm.mapOverlays.push(polygon);

								// Ajouter chaque point du polygone aux limites
								polygon.getPath().forEach(function (point) {
								  bounds.extend(point);
								});

								// Ajuster les limites pour inclure le polygone
								vm.map.fitBounds(bounds);
								ville.Polygon = polygonData;
						  }
					});
					// console.log(ville);
					polygonPromises.push(polygonPromise);
				}
				else{
					var polygonPromise = vm.fetchPolygonFromNominatim(ville).then(function (polygonData) {
						  if (polygonData) {
								var polygon = new google.maps.Polygon({
								  paths: polygonData,
								  strokeColor: color,
								  strokeOpacity: 0.8,
								  strokeWeight: 3,
								  fillColor: color,
								  fillOpacity: ville.inclus ? 0.0 : 0.3 ,
								  map: vm.map,
								});
								polygon.addListener("mouseover", function () {
								  infowindow.setContent('<strong>' + ville.NomRegion + '</strong> (' + ville.CodeRegion + ')');
								  // infowindow.setPosition({ lat: parseFloat(ville.Latitude), lng: parseFloat(ville.Longitude) });
								  infowindow.open(vm.map);
								});
								polygon.addListener("mouseout", function () {
								  infowindow.close();
								});
								vm.mapOverlays.push(polygon);

								// Ajouter chaque point du polygone aux limites
								polygon.getPath().forEach(function (point) {
								  bounds.extend(point);
								});

								// Ajuster les limites pour inclure le polygone
								vm.map.fitBounds(bounds);
								ville.Polygon = polygonData;
						  }
					});
					polygonPromises.push(polygonPromise);
				}
			});

			// Ajuster le zoom pour inclure tous les marqueurs, cercles, et polygones
			Promise.all(polygonPromises).then(function () {
				if (!bounds.isEmpty()) {
					vm.map.fitBounds(bounds);
				}
				// vm.generateStaticMapUrl(); // Générer la carte statique après avoir terminé
				
			});
			

		};
		

		
		vm.generateStaticMapUrl = function () {
			const apiKey = "AIzaSyDY9wd5MNOMRTachw0v2dPX-EDs25SKkdI"; // Remplacez par votre clé API Google Maps
			// const mapCenter = { lat: 48.1114915, lng: 7.39238455 };
			// const mapZoom = 13;
			const mapSize = "1280x1280";
			const scale = 2;

			const pathParams = [];
			const markerParams = [];
			const bounds = { minLat: 90, maxLat: -90, minLng: 180, maxLng: -180 };

			// Récupérer les départements et villes exclus
			const excludedDepartments = vm.produit.Parametres.localites
				.filter(function (localite) { return !localite.inclus && localite.IDDepartement; })
				.map(function (localite) { return localite.IDDepartement; });
				
			const excludedRegions = vm.produit.Parametres.localites
				.filter(function (localite) { return !localite.inclus && localite.IDRegion && localite.IDRegionAncienne; })
				.map(function (localite) { return localite.IDRegion; });

			const excludedVilles = new Set();
			vm.produit.Parametres.localites.forEach(function (ville) {
				if (!ville.inclus) {
					excludedVilles.add(ville.IDVille);

					// Ajouter les sous-villes dans le rayon exclu
					if (ville.rayon && ville.rayon.villes) {
						ville.rayon.villes.forEach(function (sousVille) {
							excludedVilles.add(sousVille.IDVille);
						});
					}
				}
			});

			function updateBounds(lat, lng) {
				if (lat !== undefined && lng !== undefined) { // Vérifie que lat et lng ne sont pas null/undefined
					bounds.minLat = Math.min(bounds.minLat, lat);
					bounds.maxLat = Math.max(bounds.maxLat, lat);
					bounds.minLng = Math.min(bounds.minLng, lng);
					bounds.maxLng = Math.max(bounds.maxLng, lng);
				}
			}

			vm.produit.Parametres.localites.forEach(function (ville) {
				const color = ville.inclus ? "0x169cd9ff" : "0xdc3545ff";
				const fillColor = ville.inclus ? "0x169cd980" : "0xdc354580"; // Remplissage pour cercles inclus/exclus

				// Approximation du cercle avec un polygone circulaire
				if (ville.rayon && ville.rayon.distance) {
					const steps = 72; // Nombre de segments pour approximer le cercle
					const radiusKm = ville.rayon.distance; // Rayon en km
					const latitude = parseFloat(ville.Latitude);
					const longitude = parseFloat(ville.Longitude);

					const circlePath = [];
					for (var i = 0; i < steps; i++) {
						const angle = (i / steps) * 2 * Math.PI;

						// Ajuster le rayon en degrés pour latitude et longitude
						const deltaLat = (radiusKm / 111.32) * Math.cos(angle); // 1° latitude ≈ 111.32 km
						const deltaLng = (radiusKm / (111.32 * Math.cos(latitude * Math.PI / 180))) * Math.sin(angle); // Ajusté par latitude

						const lat = latitude + deltaLat;
						const lng = longitude + deltaLng;
						circlePath.push(lat + "," + lng);
						updateBounds(lat, lng);
					}
					circlePath.push(circlePath[0]); // Fermer le cercle
					pathParams.push("color:" + color + "|weight:2|fillcolor:" + fillColor + "|" + circlePath.join("|"));
				}

				// Ajouter un marqueur pour la ville principale
				if (ville.NomVille && !excludedVilles.has(ville.IDVille)) {
					markerParams.push("size:mid|color:" + (ville.inclus ? "orange" : "red") + "|label:" + ville.NomVille.charAt(0) + "|" + ville.Latitude + "," + ville.Longitude);
					console.log(ville);
					updateBounds(parseFloat(ville.Latitude), parseFloat(ville.Longitude));
				}

				// Ajouter les sous-marqueurs dans le rayon
				if (ville.rayon && ville.rayon.villes) {
					ville.rayon.villes.forEach(function (sousVille) {
						if (!excludedDepartments.includes(sousVille.IDDepartement)&& !excludedRegions.includes(sousVille.IDRegion) && !excludedVilles.has(sousVille.IDVille)) {
							const sousMarkerColor = ville.inclus ? "orange" : "red";
							markerParams.push(
								"size:small|color:" + sousMarkerColor + "|" + parseFloat(sousVille.Latitude) + "," + parseFloat(sousVille.Longitude)
							);
							updateBounds(parseFloat(sousVille.Latitude), parseFloat(sousVille.Longitude));
						}
					});
				}
				
				// Ajouter les polygones pour les contours des villes
				if (!ville.NomDepartement && !ville.NomRegion && ville.Polygon && ville.rayon.distance <= 0) {
					
					const simplifiedPolygon = simplifyPolygon(ville.Polygon, 10); // Réduit les points pour optimiser l'URL

					const polygonPath = simplifiedPolygon.map(function (point) {
						updateBounds(point.lat, point.lng);
						return point.lat + "," + point.lng;
					}).join("|");
					pathParams.push("color:" + color + "|weight:2|fillcolor:" + fillColor + "|" + polygonPath);
				}

				// Ajouter les polygones pour les contours des départements
				// console.log(ville);
				if ((ville.NomDepartement || ville.NomRegion) && ville.Polygon) {
					const simplifiedPolygon = simplifyPolygon(ville.Polygon, 100); // Réduit les points pour optimiser l'URL
					const polygonPath = simplifiedPolygon.map(function (point) {
						updateBounds(point.lat, point.lng);
						return point.lat + "," + point.lng;
					}).join("|");
					const polygonFillColor = ville.inclus ? "0x00000000" : fillColor; // **Pas de remplissage pour départements inclus**
					pathParams.push("color:" + color + "|weight:3|fillcolor:" + polygonFillColor + "|" + polygonPath);
				}
			});
			
			const centerLat = (bounds.minLat + bounds.maxLat) / 2;
			const centerLng = (bounds.minLng + bounds.maxLng) / 2;
			const zoomLevel = calculateZoom(bounds, mapSize); // Calcul du zoom optimal

			const staticMapUrl = "https://maps.googleapis.com/maps/api/staticmap?center=" +
				centerLat + "," + centerLng +
				"&zoom=" + zoomLevel +
				"&size=" + mapSize +
				"&scale=" + scale +
				"&" + pathParams.map(function (param) { return "path=" + encodeURIComponent(param); }).join("&") +
				"&" + markerParams.map(function (param) { return "markers=" + encodeURIComponent(param); }).join("&") +
				"&key=" + apiKey;
				
			console.log(staticMapUrl);
			vm.produit.Parametres.ImgMap = staticMapUrl;
		};

		// Fonction pour calculer le zoom optimal
		function calculateZoom(bounds, mapSize) {
			const latDiff = bounds.maxLat - bounds.minLat;
			const lngDiff = bounds.maxLng - bounds.minLng;

			const latZoom = Math.floor(Math.log2(360 / latDiff) * Math.pow(mapSize / 256, 0.5));
			const lngZoom = Math.floor(Math.log2(360 / lngDiff) * Math.pow(mapSize / 256, 0.5));

			return Math.min(latZoom, lngZoom); // Prendre le zoom minimum pour ajuster à la vue
		}

		// Fonction de simplification des polygones
		function simplifyPolygon(polygon, tolerance) {
			return polygon.filter(function (_, index) {
				return index % tolerance === 0; // Garder un point tous les `tolerance`
			});
		}


		
		// Fonction pour récupérer les polygones depuis Nominatim
		vm.fetchPolygonFromNominatim = function (city) {
			return new Promise(function (resolve, reject) {
				if (city.Polygon) {
					if (typeof city.Polygon === "object" && city.Polygon !== null) {
						return resolve(city.Polygon);
					} else {
						return resolve(JSON.parse(city.Polygon));
					}
				} else {
					var URL = "";
					if (city.NomDepartement) {
						URL = "/datas/adresses/getDetailsDepartement.json";
						var data = {"IDDepartement": city.IDDepartement};
					} else if (city.NomRegion) {
						URL = "/datas/adresses/getDetailsRegion.json";
						var data = {"IDRegion": city.IDRegion};
					} else {
						URL = "/datas/adresses/getDetailsVille.json";
						var data = {"IDVille": city.IDVille};
					}

					$http.get(URL, { params: data })
						.then(function (response) {
							if (response.data && response.data.data && response.data.data.Polygon) {
								resolve(response.data.data.Polygon);
							} else {
								// Si aucun polygone n'est trouvé dans la base, passer à Nominatim
								const cityName = city.NomDepartement
									? city.NomDepartement + ", France"
									: city.NomRegion
									? city.NomRegion + ", France"
									: city.CodePostal.length > 13
									? city.NomVille + ", France"
									: city.CodePostal + "," + city.NomVille + ", France";

								const apiUrl =
									"https://nominatim.openstreetmap.org/search.php?q=" +
									encodeURIComponent(cityName) +
									"&polygon_geojson=1&format=json";

								fetch(apiUrl)
									.then(function (response) {
										return response.json();
									})
									.then(function (data) {
										if (data.length > 0 && data[0].geojson) {
											const geojson = data[0].geojson;
											var polygonPaths;

											if (geojson.type === "Polygon") {
												polygonPaths = geojson.coordinates[0].map(function (coord) {
													return { lat: coord[1], lng: coord[0] };
												});
											} else if (geojson.type === "MultiPolygon") {
												polygonPaths = [];
												geojson.coordinates.forEach(function (polygon) {
													const paths = polygon[0].map(function (coord) {
														return { lat: coord[1], lng: coord[0] };
													});
													polygonPaths.push(paths);
												});
											}

											if (polygonPaths) {
												// Sauvegarder le polygone
												const tmpCity = angular.copy(city);
												tmpCity.Polygon = polygonPaths;

												fetch("/datas/adresses/savePolygon", {
													method: "POST",
													headers: { "Content-Type": "application/json" },
													body: JSON.stringify(tmpCity),
												}).catch(function (error) {
													console.error(
														"Erreur lors de l'enregistrement du polygone :",
														error
													);
												});

												resolve(polygonPaths);
											} else {
												resolve(null);
											}
										} else {
											resolve(null); // Aucun polygone trouvé
										}
									})
									.catch(function (error) {
										console.error("Erreur lors de la requête Nominatim :", error);
										reject(error);
									});
							}
						})
						.catch(function (error) {
							console.error("Erreur lors de la requête HTTP :", error);
							reject(error);
						});
				}
			});
		};

		setTimeout(function () {
		  vm.initGoogleMap();
		}, 500);
  
		$scope.$watch('vm.produit.Parametres.localites', function (newVal, oldVal) {
			if (vm.map && newVal !== oldVal) {
				// Vérifiez si la modification est pertinente pour la carte
				const isRelevantChange = JSON.stringify(newVal) !== JSON.stringify(oldVal);
				if (isRelevantChange) {
					vm.updateGoogleMap();
				}
			}
		}, true);
	
		vm.getCumulativePopulation = function (ville) {
			if (!ville || !Array.isArray(ville.rayon.villes)) return 0;
			
			if(ville.rayon.distance == 0)
				var populationVille = parseInt(ville.Population, 10) || 0;
			else
				var populationVille = 0;

			if(ville.rayon.distance > 0)
				var populationSousLocalites = ville.rayon.villes.reduce(function (total, localite) {
					return total + (parseInt(localite.Population, 10) || 0);
				}, 0);
			else
				var populationSousLocalites = 0;
			
			// Retourner le total (ville principale + sous-localités)
			return populationVille + populationSousLocalites;
		};
		
		
		vm.querySearch = function (query) {
			var results = query ? vm.villes.filter(createFilterFor(query)) : vm.villes;
			return results;
		};

		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query.replace('-', ' '));

			var accent = [
				/[\300-\306]/g, /[\340-\346]/g, // A, a
				/[\310-\313]/g, /[\350-\353]/g, // E, e
				/[\314-\317]/g, /[\354-\357]/g, // I, i
				/[\322-\330]/g, /[\362-\370]/g, // O, o
				/[\331-\334]/g, /[\371-\374]/g, // U, u
				/[\321]/g, /[\361]/g, // N, n
				/[\307]/g, /[\347]/g, // C, c
			];
			var noaccent = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];

			// Supprimer les accents dans la requête
			for (var i = 0; i < accent.length; i++) {
				lowercaseQuery = lowercaseQuery.replace(accent[i], noaccent[i]);
			}

			// Remplacer "œ" par "oe" ET "oe" par "œ" pour couvrir tous les cas
			var normalizedQueries = [
				lowercaseQuery.replace(/œ/g, 'oe'), // transformer "œ" en "oe"
				lowercaseQuery.replace(/oe/g, 'œ')  // transformer "oe" en "œ"
			];

			return function filterFn(state) {
				if (!state.NomVille || !state.CodePostal) {
					return false;
				}

				// Normaliser NomVille
				var lowercaseStateName = angular.lowercase(state.NomVille);
				for (var i = 0; i < accent.length; i++) {
					lowercaseStateName = lowercaseStateName.replace(accent[i], noaccent[i]);
				}

				// Remplacer "œ" par "oe" ET "oe" par "œ" pour garantir la correspondance
				var normalizedStateNames = [
					lowercaseStateName.replace(/œ/g, 'oe'),
					lowercaseStateName.replace(/oe/g, 'œ')
				];

				// Vérifier si l'une des versions normalisées correspond
				return normalizedQueries.some(function (queryVariant) {
					return normalizedStateNames.some(function (stateVariant) {
						return stateVariant.indexOf(queryVariant) >= 0;
					});
				}) || state.CodePostal.indexOf(lowercaseQuery) >= 0;
			};
		}
		
		// Fonction pour calculer la distance entre deux points (Haversine Formula)
		function calculateDistance(lat1, lon1, lat2, lon2) {
			const R = 6371; // Rayon moyen de la Terre en km
			const dLat = (lat2 - lat1) * Math.PI / 180;
			const dLon = (lon2 - lon1) * Math.PI / 180;
			const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
					  Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
					  Math.sin(dLon / 2) * Math.sin(dLon / 2);
			const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			return R * c;
		}
		
		
		/*********************/
		
		function mergeLocalites(localites) {
			const merged = new Map();

			localites.forEach(function (ville) {
				const key = ville.NomVille; // Utiliser le nom de la ville comme clé

				if (merged.has(key)) {
					// Ville déjà présente, fusionner les codes postaux et la population
					const existing = merged.get(key);
					if (!Array.isArray(existing.CodePostal)) {
						existing.CodePostal = [existing.CodePostal]; // Convertir en tableau si nécessaire
					}
					if (!existing.CodePostal.includes(ville.CodePostal)) {
						existing.CodePostal.push(ville.CodePostal);
					}
					// La population est ajoutée seulement si elle n'a pas été comptée
					if (existing.Population === 0 && ville.Population > 0) {
						existing.Population = ville.Population;
					}
				} else {
					// Nouvelle ville, ajouter directement
					merged.set(key, Object.assign({}, ville, {
						CodePostal: [ville.CodePostal], // Stocker les codes postaux comme tableau
					}));
				}
			});

			return Array.from(merged.values());
		}

		// Recherche des villes dans le rayon
		vm.addLocalites = function (InclureOrExclure) {
			if ((!vm.ville || !vm.ville.Latitude || !vm.ville.Longitude) &&  !vm.departement &&  !vm.region) {
				$mdToast.show(
				  $mdToast
					.simple()
					.textContent('Veuillez sélectionner une ville ou un département valide.')
					.position('bottom right')
					.hideDelay(3000)
				);
				return;
			}



			if (vm.zone != "departement" && vm.zone != "region") {
				vm.ville.rayon = { distance: vm.rayon || 0, villes: [] };
				if (vm.zone === "rayon") {
					vm.localites = vm.villes
					.map(function (ville) {
						// Crée une copie de l'objet "ville" et ajoute la propriété "distance"
						var clonedVille = Object.assign({}, ville);
						clonedVille.distance = calculateDistance(
							vm.ville.Latitude,
							vm.ville.Longitude,
							ville.Latitude,
							ville.Longitude
						);
						return clonedVille;
					})
					.filter(function (ville) {
						return ville.distance <= vm.rayon;
					})
					.sort(function (a, b) {
						return a.distance - b.distance;
					});

					// Fusionner les localités par NomVille
					vm.localites = mergeLocalites(vm.localites);

					vm.ville.rayon.villes = angular.copy(vm.localites);
				}

				if (!vm.produit.Parametres.localites) {
					vm.produit.Parametres.localites = [];
				}

				// console.log(vm.produit.Parametres.localites);
				const alreadyIncluded = vm.produit.Parametres.localites.some(function (inclure) {
					return inclure.IDVille == vm.ville.IDVille;
				});

				vm.ville.inclus = InclureOrExclure;
				if (!alreadyIncluded) {
					vm.produit.Parametres.localites.push(vm.ville);
				} else {
					
					$mdToast.show(
					  $mdToast
						.simple()
						.textContent('Cette ville est déjà incluse dans les localités.')
						.position('bottom right')
						.hideDelay(3000)
					);
				}
			}
			else if(vm.zone != "region"){
				
				const alreadyIncluded = vm.produit.Parametres.localites.some(function (inclure) {
					return inclure.NomDepartement == vm.departement.NomDepartement;
				});
				if (!alreadyIncluded) {
					vm.departement.inclus = InclureOrExclure;
					vm.produit.Parametres.localites.push(vm.departement);
					vm.departement = "";
				} else {
					// console.log(vm.produit.Parametres.localites);
					// console.log(vm.departement);
					
					$mdToast.show(
					  $mdToast
						.simple()
						.textContent('Ce département est déjà inclus dans les localités.')
						.position('bottom right')
						.hideDelay(3000)
					);
				}
				
			}
			else{
				
				const alreadyIncluded = vm.produit.Parametres.localites.some(function (inclure) {
					return inclure.NomRegion == vm.region.NomRegion;
				});
				if (!alreadyIncluded) {
					vm.region.inclus = InclureOrExclure;
					vm.produit.Parametres.localites.push(vm.region);
					vm.region = "";
				} else {
					// console.log(vm.produit.Parametres.localites);
					// console.log(vm.departement);
					
					$mdToast.show(
					  $mdToast
						.simple()
						.textContent('Cette région est déjà inclus dans les localités.')
						.position('bottom right')
						.hideDelay(3000)
					);
				}
				
			}
			vm.updateLocalitesCount();
			vm.calculatePrice();
		};
		
		
		/**********************/
		
		
		vm.updateRequetesCount = function() {
		// Calcul du total des requêtes
			vm.produit.Parametres.total.nbrRequetes = vm.produit.Parametres.requetes.reduce(function(total, requete) {
			  if (requete.service && requete.service.trim()) {
				// Compter le produit/service uniquement s'il est non vide
				const validActions = requete.action.filter(function(action) {
				  return action && action.trim(); // Filtrer les actions non vides
				});
				return total + 1 + validActions.length;
			  }
			  return total; // Ne pas compter les produits/services vides
			}, 0);
			vm.calculatePrice();
		};

		vm.clearRayonIfLieu = function () {
			if (vm.zone === 'lieu') {
				vm.rayon = ''; // Vider le champ rayon
			}
			else vm.rayon = 10;
		};

		// Supprimer une localité complète
		vm.removeLocalite = function (localite) {
			const index = vm.produit.Parametres.localites.indexOf(localite);
			if (index > -1) {
				vm.produit.Parametres.localites.splice(index, 1);
			}
			vm.updateLocalitesCount();
			vm.calculatePrice();
		};

		// Supprimer une sous-localité
		vm.removeSousLocalite = function (localite, sousLocalite) {
			const index = localite.rayon.villes.indexOf(sousLocalite);
			if (index > -1) {
				localite.rayon.villes.splice(index, 1);
			}
			vm.updateLocalitesCount();
			vm.calculatePrice();
		};

		


		vm.produit.Parametres.localites.forEach(function (ville) {
			ville.isExpanded = false;
		});

		
		vm.duplicateService = function (service) {
		  // Cloner profondément l'objet service
		  var clonedService = angular.copy(service);
		  
		  // Ajouter le clone à la liste des requêtes
		  vm.produit.Parametres.requetes.push(clonedService);

		  // Mettre à jour le compteur des requêtes
		  vm.updateRequetesCount();
		};

		
		vm.sendForm = function (ev)
        {
			// ev.stopPropagation();
            // vm.showSpinner = 1;
            // vm.createloader = 1;
			captureMap();
			// 
        }
		
		
		function captureMap() {
			
			vm.createloader = 1;
			const mapElement = document.getElementById("map");
			const originalContainer = document.getElementById("original-container");
			const cloneContainer = document.getElementById("clone-container");

			// Déplacer la carte dans le clone-container
			cloneContainer.appendChild(mapElement);
			cloneContainer.style.display = "block"; // Rendre le conteneur visible pour la capture
			// Attendre que la carte soit rendue
			google.maps.event.trigger(vm.map, "resize");
		
			if (!bounds.isEmpty()) {
				vm.map.fitBounds(bounds);
			}
				
			setTimeout(function () {
				html2canvas(cloneContainer, {
					useCORS: true,
				}).then(function (canvas) {
					vm.produit.Parametres.ImgMap = canvas.toDataURL("image/png");
					// console.log("Image capturée :", imageData);

					// Rendre le conteneur invisible et restaurer la carte à sa position d'origine
					cloneContainer.style.display = "none";
					originalContainer.appendChild(mapElement);
					$mdDialog.hide(vm.produit);
					vm.createloader = 0;
				}).catch(function (error) {
					console.error("Erreur lors de la capture :", error);

					// En cas d'erreur, restaurer immédiatement la carte
					cloneContainer.style.display = "none";
					originalContainer.appendChild(mapElement);
					vm.createloader = 0;
				});
			}, 1500);

			// Forcer un rechargement de la carte dans le nouveau conteneur si nécessaire
			
		}
		
        setTimeout(function () {
			vm.updateLocalitesCount();
		}, 200);
		
		vm.calculatePrice();
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition')
        .controller('PaiementCommandeDialogController', PaiementCommande)
		.config(function ($mdDateLocaleProvider) {
			$mdDateLocaleProvider.formatDate = function (date) {
				return date ? moment(date).format('DD/MM/YYYY') : '';
			};

			$mdDateLocaleProvider.parseDate = function (dateString) {
				var m = moment(dateString, 'DD/MM/YYYY', true);
				return m.isValid() ? m.toDate() : new Date(NaN);
			};
		});
		


    /** @ngInject */
    function PaiementCommande($mdDialog, $http, $scope, $element, Paiement, Commande)
    {
		
		var vm = this;
		vm.paiement = angular.copy(Paiement);
		if(vm.paiement && vm.paiement.MontantGrenkeHT !== null && typeof vm.paiement.MontantGrenkeHT !== 'undefined')
			vm.paiement.MontantGrenkeHT = parseFloat(vm.paiement.MontantGrenkeHT);


		// if(typeof vm.paiement == "undefined")			
			// vm.paiement = {'DatePaiement' : new Date()};
		var daysAvailableThisMonth = [29, 30,31];
		vm.onlyDateAllow = function(date) {
			var day = date.getDate();
			return daysAvailableThisMonth.indexOf(day) <= -1;
		};
		
        vm.savePaiement = function()
        {
			vm.showSpinner = 1;
			
			if(vm.paiement.Type=="Solde"){
				var solde = Commande.TotalTTC;
				
				if(Commande.paiements.length > 1){
					for(var i=0;i<Commande.paiements.length;i++)
						if(Commande.paiements[i].Type!="Solde")
							solde -= Commande.paiements[i].Montant;
					vm.paiement.Montant = solde;
				}
				else if(Commande.paiements.length > 0)
					vm.paiement.Montant = solde - Commande.paiements[0].Montant;
				else
					vm.paiement.Montant = solde;
					
				// console.log(vm.paiement.Montant);
				// var test = '$$hashKey';
				// console.log(vm.paiement.test);
				// console.log(solde);
				vm.eurotoppercent();
			}
			
			if(vm.paiement.Type=="Mensualité"){
				// console.log(Commande.paiements);
				var solde = Commande.TotalTTC;
			// console.log(vm.paiement);
			// console.log(Commande.paiements);
				if(Commande.paiements.length > 0){
					for(var i=0;i<Commande.paiements.length;i++)
						if(Commande.paiements[i].Type!="Mensualité" && Commande.paiements[i].IDCommandes_Paiement!=vm.paiement.IDCommandes_Paiement)
							solde -= Commande.paiements[i].Montant;
					// console.log(solde);
					vm.paiement.Montant = solde;
				}
				else
					vm.paiement.Montant = solde;
					// vm.paiement.Montant = Commande.paiements[0].Montant;
				
				// vm.paiement.Montant = solde;
				vm.eurotoppercent();
			}
			
			
			if(vm.paiement.Type=="Financement"){
				vm.paiement.MontantGrenkeHT = parseFloat(vm.paiement.MontantGrenkeHT);
				vm.paiement.Montant = Commande.TotalTTC;
		
				vm.eurotoppercent();
			}
			else
				vm.paiement.MontantGrenkeHT = null;
			
			$mdDialog.hide(vm.paiement);

        }

        vm.percenttoeuro = function(){
			vm.paiement.Montant = Math.round(Commande.TotalTTC*vm.paiement.Percent)/100;
		}
		
        vm.eurotoppercent = function(){
			vm.paiement.Percent = Math.round(vm.paiement.Montant*10000/Commande.TotalTTC)/100;			
		}
		
        vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition')
        .controller('OptionsCommandeDialogController', OptionsCommande);

    /** @ngInject */
    function OptionsCommande($mdDialog, $http, $scope, $element, Produit)
    {
		
		var vm = this;
		vm.produit = angular.copy(Produit);	
		
		$scope.selected = vm.produit.SousProduitsSelect;
		if(typeof $scope.selected == "undefined")
			$scope.selected = [];
		// console.log($scope.selected);
		$scope.toggle = function (item, list) {
			
			function ctrl(o){
				return o.IDProduit === item.IDProduit;
			}
			
			var obj = list.find(ctrl);
			var idx = list.indexOf(obj);
			
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
		};



		$scope.exists = function (item, list) {
			function ctrl(o){
				return o.IDProduit === item.IDProduit;
			}
			
			var obj = list.find(ctrl);
			return typeof obj !== "undefined";
		};

		$scope.isIndeterminate = function() {
			return ($scope.selected.length !== 0 && $scope.selected.length !== vm.produit.SousProduits.length);
		};

		$scope.isChecked = function() {
			return $scope.selected.length === vm.produit.SousProduits.length;
		};

		$scope.toggleAll = function() {
			if ($scope.selected.length === vm.produit.SousProduits.length) {
				$scope.selected = [];
			} else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
				$scope.selected = vm.produit.SousProduits.slice(0);
			}
		};
  
		
        vm.saveProduit = function()
        {
			// console.log($scope.selected);
			vm.showSpinner = 1;
			$mdDialog.hide($scope.selected);

        } 

        vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition')
        .controller('DialogLogsCommandeController', DialogLogsCommandeController);

    /** @ngInject */
	
	
	function DialogLogsCommandeController($scope, $mdDialog, Commande) {
		var vm = this;
		
		vm.commande = angular.copy(Commande);
	
		$scope.convertDate = function (inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
		
		
		$scope.hide = function() {
		  $mdDialog.hide();
		};
		
		vm.closeDialog = function()
        {
            $mdDialog.cancel();
        } 
		
		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		$scope.answer = function(result) {
		  $mdDialog.hide(result);
		};
	  }
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition')
        .controller('DialogIbanController', DialogIbanController);

    /** @ngInject */
	
	
	function DialogIbanController($scope, $mdDialog, $http, Commande) {
		var vm = this;
		
		vm.commande = angular.copy(Commande);
		vm.IBAN = [];
		vm.newIBAN = {'IDContact':vm.commande.IDContact};
		vm.addIBAN=0;
		
		$http.get("datas/contacts/getIBAN.json?IDContact="+Commande.IDContact)
		.then(function (response, status, headers, config) {
			vm.IBAN = response.data.data;
			if(vm.IBAN.length<=0)
				vm.addIBAN=1;
		}, function () {});
		
		
		
		$scope.hide = function() {
		  $mdDialog.hide();
		};

		vm.selectIBAN = function(IBAN)
        {
			vm.showSpinner = 1;
		
			vm.commande.IDCommande_IBAN = IBAN.IDCommande_IBAN;
			vm.commande.IBAN = IBAN.IBAN;
			vm.commande.BIC = IBAN.BIC;
			vm.commande.Domiciliation = IBAN.Domiciliation;
			vm.commande.Titulaire = IBAN.Titulaire;
								
			$mdDialog.hide(vm.commande);

        }
		
		vm.saveIBAN = function()
        {
			vm.showSpinner = 1;
			
			$http.post("/datas/commandes/setIBAN.json",JSON.stringify(vm.newIBAN))
			.then(function (response, status, headers, config) {
				vm.IBAN = response.data.data;
				angular.forEach(vm.IBAN, function(v){
					
					if(v.IBAN == vm.newIBAN.IBAN){
						vm.commande.IDCommande_IBAN = v.IDCommande_IBAN;
						vm.commande.IBAN = v.IBAN;
						vm.commande.BIC = v.BIC;
						vm.commande.Domiciliation = v.Domiciliation;
						vm.commande.Titulaire = v.Titulaire;
						$mdDialog.hide(vm.commande);
					}
				});
				
				vm.addIBAN=0;
				vm.showSpinner = 0;
				vm.newIBAN = {'IDContact':vm.commande.IDContact};
			}, function () {});
			
        }
		
		 vm.closeDialog = function()
        {
            $mdDialog.hide();
        } 
		
		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		$scope.answer = function(result) {
		  $mdDialog.hide(result);
		};
	  }
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition')
        .controller('DialogFactureController', DialogFactureController);

    /** @ngInject */
	
	
	function DialogFactureController($scope, $mdDialog, Renouvellement, produit_a_renouveler) {
		$scope.hide = function() {
		  $mdDialog.hide();
		};
		
		$scope.produit_a_renouveler = produit_a_renouveler;
		
		var renouvelement_min = 500;
		
		angular.forEach(produit_a_renouveler, function(v,k){
			if(v.Renouvellement < renouvelement_min)
				renouvelement_min = v.Renouvellement;
		});
			console.log(Renouvellement);
			console.log(renouvelement_min);

		$scope.date = new Date();
		
		if(typeof Renouvellement != "undefined" && Renouvellement!="0000-00-00"  && Renouvellement!="" )
			$scope.result = new Date(Renouvellement);
		else{
			$scope.result = new Date();
			$scope.result.setMonth($scope.result.getMonth() + renouvelement_min);
		}
		
		$scope.date.setDate(1);
		$scope.date.setMonth(0);
		
		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		$scope.answer = function(result) {
		  $mdDialog.hide(result);
		};
	  }
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.cdc', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.cdc', {
                url    : '/parametres/cdc',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/commandes/cdc/cdc.html',
                        controller : 'cdcController as vm'
                    }
                },
                resolve  : {
                   /* employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.listeCollaborateursEdit@get');
                    } */
                },
                bodyClass: 'cdc'
            });
        
        // msApiProvider.register('employes.listeCollaborateursEdit', ['datas/employes/listeCollaborateursEdit.json']);
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.cdc')
        .controller('cdcDialogController', cdcDialogController);

    /** @ngInject */
    function cdcDialogController($mdDialog, $rootScope, Bloc, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		vm.Bloc = angular.copy(Bloc);
		
		if(vm.Bloc=="")
			vm.Bloc = {Actif:1};
		
		/* vm.Permission = $rootScope.Permission;
		vm.dateMin = new Date();
		
		if($rootScope.Permission=='Super Admin')
			vm.dateMin.setDate(vm.dateMin.getDate() -60); 
		else
			vm.dateMin.setDate(vm.dateMin.getDate() + 2); 
		
		if(vm.CDC=="")
			vm.CDC = {DateDebut:null, DateFin:null};
		
		vm.convertDate = convertDate;

		function convertDate(inputFormat, hour , day ) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			
			var days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Dimanche'];

			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else if(day)
				return days[d.getDay()] + " "+[pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
		vm.congesValide = false;
		vm.congesTrouve = "";
		
		vm.testCongesExist = function(conges){
			if(typeof conges == "undefined" || typeof conges.DateDebut == "undefined" || typeof conges.HeureFin == "undefined" || typeof conges.DateFin == "undefined" || typeof conges.DateFin == "undefined"){
				vm.congesValide = false;
				vm.congesTrouve = "";
			}
			else{
				$http.post("/datas/employes/congesExist.json", conges).then(function (response, status, headers, config) {
					if(response.data.data != false){
						vm.congesTrouve = response.data.data;
						vm.congesValide = false;	
					}
					else{
						vm.congesValide = true;
						vm.congesTrouve = "";
					}
				}, function () {});
			}		
		}
		 */
	
	
        vm.saveBloc = function()
        {
			vm.showSpinner = 1;
			
			var fd = new FormData();			 
			fd.append("data", angular.toJson(vm.Bloc));
			
			/* var files = $('#file')[0].files;
			
			
			if(files.length > 0 ){
			   fd.append('file',files[0]);
			} */
			var config = { headers: {'Content-Type': undefined},
						   transformRequest: angular.identity
						 }
						   
			$http.post("/datas/commandes/editCDCBloc.json", fd, config)
			.then(function (response, status, headers, config) {
			
				if(response.data.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
					$mdDialog.hide(response.data);
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        }  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.frais.frais', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.collaborateurs_frais', {
                url    : '/collaborateurs/frais',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/collaborateurs/frais/liste/frais.html',
                        controller : 'fraisController as vm'
                    }
                },
                resolve  : {
                   employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.listeCollaborateursEdit@get');
                    }
                },
                bodyClass: 'frais'
            });
        
        msApiProvider.register('employes.listeCollaborateursEdit', ['datas/employes/listeCollaborateursEdit.json']);
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.frais.frais')
        .controller('fraisController', fraisController);

    /** @ngInject */
    function fraisController(employesSimple, $mdDialog, $http, $mdToast, $rootScope , $window, DTOptionsBuilder, $state, DTColumnBuilder, $compile, $scope, $location  )
    {
        var vm = this;


		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		vm.recordsTotal = 0;
		vm.search = localStorage.getItem('colabfraisSearch');
		
		
		function convertDate(inputFormat, hour, day ) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
		$scope.selected = [];
		
		$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
		};
		
		$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
		};
		
		$scope.isIndeterminate = function() {
			return ($scope.selected.length !== 0 &&
				$scope.selected.length !== $('.dataTable md-checkbox').length - 1);
		};
		
		$scope.isChecked = function() {
			return $scope.selected.length === $('.dataTable md-checkbox').length - 1;
		};
		
		$scope.toggleAll = function() {
			if ($scope.selected.length === $('.dataTable md-checkbox').length - 1) {
				$scope.selected = [];
			} else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
				$scope.selected = [];
				$('.dataTable md-checkbox').each(function(k, v){
					if(typeof $(v).attr('data-val') != "undefined")
						$scope.selected.push(parseInt($(v).attr('data-val')));
				});
			}
		};

	
		vm.exportFrais = function (ev, type)
        {
			$window.open("/datas/employes/exportFrais.json?type="+type+'&selected='+$scope.selected, '_blank');
        }
		
		vm.editFrais = function (ev, IDEmployes_NoteFraisDetail){
			$location.path('/collaborateurs/frais/edition/' + IDEmployes_NoteFraisDetail);
		
		}
		
		vm.apercuFrais = function (ev, IDEmployes_NoteFraisDetail){
			alert('apercu');
		}
		
		vm.ajouterFrais = function ()
        {
            $state.go('app.collaborateurs_frais.edition');
        }
		
		vm.deleteFrais = function (ev, IDEmployes_NoteFrais)
        {
		 	var commandeObj = {IDEmployes_NoteFrais:IDEmployes_NoteFrais};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer cette note de frais ?')
                .htmlContent('La note N°<b>' + IDEmployes_NoteFrais + '</b>' + ' va être supprimée.')
                .ariaLabel('Supprimer une note')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/employes/deleteFrais.json", JSON.stringify(commandeObj)).then(function (response, status, headers, config) {  
					vm.dtInstance.reloadData();
					$mdToast.show(
					  $mdToast.simple()
						.textContent('La note de frais a été supprimée.')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}, function () {});
				
            }, function () {});
        }
		
		vm.setRemboursee = function(note){$http.post("/datas/employes/setNoteRemboursee.json",JSON.stringify({'IDEmployes_NoteFrais':note})).then(function (response, status, headers, config) {  vm.dtInstance.reloadData();}, function () {});}
		vm.setNonRemboursee = function(note){$http.post("/datas/employes/setNoteNonRemboursee.json",JSON.stringify({'IDEmployes_NoteFrais':note})).then(function (response, status, headers, config) {  vm.dtInstance.reloadData();}, function () {});}
		
		vm.filterSave = [];
        vm.dtInstance = {};
		
		 vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'datas',
				 url: 'datas/employes/getFrais.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'dataTableColabFrais', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
				  $('.scrollable').animate({
					scrollTop: 0
				  }, 'slow');
			})
			.withOption('stateLoadCallback', function (oSettings) {
				var columnLoad = JSON.parse( localStorage.getItem('dataTableColabFrais') );
				// if( columnLoad != null && columnLoad.columns[3].search.search == "")
					// columnLoad.columns[3].search.search = 1;
				return columnLoad;
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('aoSearchCols',   [
			  null,
			  null,
			  null,
			  // { "sSearch": "0" },
			  null,
			  null,
			  null
			])
			.withOption('columnDefs',  [
				{
                    // Target the price column
                    targets: 6,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },
				{
                    // Target the price column
                    targets: 7,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },
				{
                    // Target the price column
                    targets: 8,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },
				
                 {
                    targets: 0,
                    responsivePriority: 0,
                },   
                {
                    targets: 1,
                    responsivePriority: 2,
                },   
                {
                    targets: 2,
                    responsivePriority: 2,
                },   
                {
                    targets: 3,
                    responsivePriority: 1,
                },   
                {
                    targets: 4,
                    responsivePriority: 1,
                },    
				{
                    targets           : 11,
                    responsivePriority: 0,
                } 
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
					var api = this.api();
						vm.searchBox = angular.element('body').find('#colabfrais-search');

					angular.forEach(vm.filterSave, function(value, key) {
						var cpt = key+1;
						if(typeof value.search.search == "string" && value.search.search.includes("~")){
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
							
						} else{
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
						}
					}); 
				
					if ( vm.searchBox.length > 0 )
					{
						var timeout = null;
						vm.searchBox.on('keyup', function (event)
						{
							clearTimeout(timeout);
							timeout = setTimeout(function () {
								api.search(vm.search).draw();
							}, 500);
						});
					}
					
					vm.recordsTotal = json.recordsTotal;
				}
			)
			.withLightColumnFilter({
				  "1": {
					"html": "input",
					"type": "text",
					// "location": $location
				  },
				  "2": {
					"html": "select",
					"values": [{'value':"", 'label':"--"}].concat(employesSimple.data),
					// "location": $location,
					"regex":true
				  },
				  "3": {
					"html": "range",
					"type": "date",
					// "location": $location
				  },
				  "4": {
					"html": "range",
					"type": "date",
					// "location": $location
				  },
				  "5": {
					"html": "range",
					"type": "input",
					// "location": $location
				  },
				  "6": {
					"html": "range",
					"type": "input",
					// "location": $location
				  },
				  "7": {
					"html": "range",
					"type": "input",
					// "location": $location
				  },
				  "8": {
					"html": "range",
					"type": "input",
					// "location": $location
				  },
				  "9": {
					"html": "range",
					"type": "date",
					// "location": $location
				  },
				  "10": {
					"html": "select",
					"values": [
						{value: '', label: '--'}, 
						{value: 'A rembourser', label: 'A rembourser'}, 
						{value: 'Remboursée', label: 'Remboursée'}
					],
					// "location": $location,
					"regex":true
				  },
				  "11": {
					"html": "clear"
				  }
			  })
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('order', [1, 'desc']);
			// .withLightColumnFilter({
			/* 	  "0": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "1": {
					"html": "select",
					"values": employesSimple.data,
					"regex":true,
					"location": $location
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '0', label: 'Non traitée'}, 
						{value: '1', label: 'Traitée'}, 
					],
					"location": $location,
					"regex":true
				  },
				  "2": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "5": {
					"html": "clear"
				  } */
			// });
			  


		vm.dtColumns = [
			DTColumnBuilder.newColumn('IDEmployes_NoteFrais').notSortable().withTitle('<div class="table-header"><span class="column-title"> <md-checkbox aria-label="Tout sélectionner" ng-checked="isChecked()" md-indeterminate="isIndeterminate()" ng-click="toggleAll()"></md-checkbox></div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				return '<md-checkbox aria-label="Sélectionner le '+data+'" data-val="'+data+'" ng-checked="exists('+data+', selected)" ng-click="toggle('+data+', selected)"></md-checkbox>';
			  
			}),
			DTColumnBuilder.newColumn('IDEmployes_NoteFrais').withTitle('<div class="table-header"><span class="column-title">N°</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('IDEmploye').withTitle('<div class="table-header"><span class="column-title">Collaborateur</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				var html = '';
				if(full.CompteSupprime!=0)
					html += '<md-tooltip md-direction="left" >Compte supprimé</md-tooltip>';
				html += '<span class="" >'+ full.Compte +'</span>';
				return html;
			}),
			DTColumnBuilder.newColumn('DateDebut').withTitle('<div class="table-header"><span class="column-title">Début</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data);
			}),
			DTColumnBuilder.newColumn('DateFin').withTitle('<div class="table-header"><span class="column-title">Fin</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data);
			}),
				DTColumnBuilder.newColumn('TotalKM').withTitle('<div class="table-header"><span class="column-title">Total KM</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
				return data + " km";
			}),
				DTColumnBuilder.newColumn('TotalHT').withTitle('<div class="table-header"><span class="column-title">HT</div></div>').withOption('width', '120px'),
				DTColumnBuilder.newColumn('TotalTVA').withTitle('<div class="table-header"><span class="column-title">TVA</div></div>').withOption('width', '120px'),
				DTColumnBuilder.newColumn('TotalTTC').withTitle('<div class="table-header"><span class="column-title">TTC</div></div>').withOption('width', '120px'),
			
			DTColumnBuilder.newColumn('DateModification').withTitle('<div class="table-header"><span class="column-title">Dernière modification</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data, true);
			}),
			DTColumnBuilder.newColumn('Statut').withTitle('<div class="table-header"><span class="column-title">Statut</div></div>').withOption('width', '150px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
						if(data == "Remboursée")
							 return'<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-green-bg white-fg"  style="text-transform:capitalize; display:inline-block ">Remboursée</span>'; 
						else
							return '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-orange-bg white-fg"  style="text-transform:capitalize;display:inline-block ">À Rembourser</span> '; 
						
					
				   return html;
				}
				return data;
				
			}),
			DTColumnBuilder.newColumn(null).withTitle('').notSortable().withOption('width', '50px').renderWith(function(data, type, full){
				 var html = 
				 '<md-menu style="float: right;">'+
					'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
							'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
						'</md-button>'+
						'<md-menu-content width="3">';
						
			
			if($rootScope.id==full.IDEmploye && full.Statut != "Remboursée"){
				html +='<md-menu-item> '+
					"<md-button ng-click='vm.editFrais($event, \""+full.IDEmployes_NoteFrais+"\")'> "+
						'Modifier '+
					'</md-button>'+
				'</md-menu-item>'+
				'<md-menu-item> '+
					"<md-button ng-click='vm.deleteFrais($event, \""+full.IDEmployes_NoteFrais+"\")'  ng-disabled='\""+full.Statut+"\" == \"Remboursée\"'>"+
						'Supprimer '+
					'</md-button>'+
				'</md-menu-item>';
			}
			else{
				html +='<md-menu-item> '+
					"<md-button ng-click='vm.editFrais($event, \""+full.IDEmployes_NoteFrais+"\")'> "+
						'Consulter '+
					'</md-button>'+
				'</md-menu-item>';
			}
			
			if($rootScope.Permission=="Super Admin"){
				html += '<md-divider ></md-divider>'+
						'<md-menu-item>'+
						'<md-menu>'+
							'<md-button ng-click="$mdMenu.open()">Validation</md-button>'+
							'<md-menu-content>'+
								'<md-menu-item >'+
									'<md-button '+ ((full.Statut ==  "Remboursée") ? "disabled":"") +' ng-click="vm.setRemboursee('+full.IDEmployes_NoteFrais+')" >'+
										'Passer en remboursée'+
									'</md-button>'+
								'</md-menu-item>'+
								'<md-menu-item >'+
									'<md-button '+ ((full.Statut == "À Rembourser") ? "disabled":"") +' ng-click="vm.setNonRemboursee('+full.IDEmployes_NoteFrais+')">'+
										'Passer en non-remboursée'+
									'</md-button>'+
								'</md-menu-item>'+
							'</md-menu-content>'+
						'</md-menu>'+
					'</md-menu-item>';
			}
			
		/* 	if(full.DateRenouvellement!="0000-00-00" && full.DateRenouvellement != "1970-01-01")
							
									 */
			
						
						
				html +='</md-menu-content>'+
					'</md-menu>';
					
				return html;
			}),
		];
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.frais.edition')
        .controller('editionfraisController', editionfraisController);

    /** @ngInject */
    function editionfraisController($mdDialog, $state, Listefrais, $http, $rootScope, $mdToast, employesSimple, RaisonSociale, AdressesContacts, Vehicules, Responsables, AdressesEmploye, $window, DTOptionsBuilder, DTColumnBuilder, $compile, $scope, $location  )
    {
        var vm = this;
		
		vm.Listefrais = angular.copy(Listefrais.data);
		/* 
		if(typeof vm.Listefrais.Notes != "undefined")
			angular.forEach(vm.Listefrais.Notes, function(k,v){
				console.log(k);
				k.Justificatifs = (array)(k.Justificatifs);
			});
		
		console.log(vm.Listefrais); */
		
		vm.convertDate = function (inputFormat, hour) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
		
		vm.gotoNotesDeFrais = function(){
			$state.go('app.collaborateurs_frais');
		}
		
		vm.supprimerNote = function (ev, Note)
        {
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer cette dépense ?')
                .htmlContent('La dépense <b>' + Note.Type + ' ' + Note.Label + '</b>' + ' va être supprimée.')
                .ariaLabel('Supprimer une note')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/employes/deleteDepenseFrais.json", JSON.stringify(Note)).then(function (response, status, headers, config) {  
					vm.Listefrais = response.data.data;
					$mdToast.show(
					  $mdToast.simple()
						.textContent('La dépense a été supprimée.')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}, function () {});
				
            }, function () {});
        }
		
		vm.editerNote = function (ev, note){
			$mdDialog.show({
                controller         : 'NoteFraisDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/collaborateurs/frais/edition/dialogs/note-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    employesSimple : employesSimple,
                    RaisonSociale : RaisonSociale,
                    Vehicules : Vehicules,
                    AdressesContacts : AdressesContacts,
                    AdressesEmploye : AdressesEmploye,
                    Responsables : Responsables,
					IDEmployes_NoteFrais : vm.Listefrais.IDEmployes_NoteFrais,
                    Note : note
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					vm.Listefrais = response.data;
					if(typeof note!="undefined")
						$mdToast.show(
						  $mdToast.simple()
							.textContent("La dépense a été modifiée !")
							.position('bottom right' )
							.hideDelay(3000)
						);
					else
					$mdToast.show(
					  $mdToast.simple()
						.textContent("La dépense a été ajoutée !")
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			});
		}
		
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.documents', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.collaborateurs_documents', {
                url    : '/collaborateurs/documents',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/collaborateurs/documents/documents.html',
                        controller : 'documentsController as vm'
                    }
                },
                resolve  : {
                   employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.listeCollaborateursEdit@get');
                    }
                },
                bodyClass: 'documents'
            });
        
        msApiProvider.register('employes.listeCollaborateursEdit', ['datas/employes/listeCollaborateursEdit.json']);
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.documents')
        .controller('DocumentDialogController', DocumentDialogController);

    /** @ngInject */
    function DocumentDialogController($mdDialog, employesSimple, Document, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		vm.employesSimple = angular.copy(employesSimple);
		vm.document = angular.copy(Document);
		
		vm.files = "";
		
		if( vm.document == ""){
			vm.document = {'IDEmploye':0};
		}
		

        vm.saveDocument = function()
        {
			vm.showSpinner = 1;
			
			var fd = new FormData();			 
			fd.append("data", angular.toJson(vm.document));
			
			var files = $('#file')[0].files;
			
			
			if(files.length > 0 ){
			   fd.append('file',files[0]);
			}
			var config = { headers: {'Content-Type': undefined},
						   transformRequest: angular.identity
						 }
			
			$http.post("/datas/employes/editDocument.json", fd, config)
			.then(function (response, status, headers, config) {
				if(response.data.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        }  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.conges', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.collaborateurs_conges', {
                url    : '/collaborateurs/conges',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/collaborateurs/conges/conges.html',
                        controller : 'congesController as vm'
                    }
                },
                resolve  : {
                   employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.listeCollaborateursEdit@get');
                    }
                },
                bodyClass: 'conges'
            });
        
        msApiProvider.register('employes.listeCollaborateursEdit', ['datas/employes/listeCollaborateursEdit.json']);
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.conges')
        .controller('CongesCollabDialogController', CongesCollabDialogController);

    /** @ngInject */
    function CongesCollabDialogController($mdDialog, employesSimple, $rootScope, Conge, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		vm.employesSimple = angular.copy(employesSimple);
		vm.conge = angular.copy(Conge);
		vm.Permission = $rootScope.Permission;
		vm.dateMin = new Date();
		
		if($rootScope.Permission=='Super Admin')
			vm.dateMin.setDate(vm.dateMin.getDate() -60); 
		else
			vm.dateMin.setDate(vm.dateMin.getDate() + 2); 
		
		if(vm.conge=="")
			vm.conge = {DateDebut:null, DateFin:null};
		
		vm.convertDate = convertDate;

		function convertDate(inputFormat, hour , day ) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			
			var days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Dimanche'];

			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else if(day)
				return days[d.getDay()] + " "+[pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
		vm.congesValide = false;
		vm.congesTrouve = "";
		
		vm.testCongesExist = function(conges){
			if(typeof conges == "undefined" || typeof conges.DateDebut == "undefined" || typeof conges.HeureFin == "undefined" || typeof conges.DateFin == "undefined" || typeof conges.DateFin == "undefined"){
				vm.congesValide = false;
				vm.congesTrouve = "";
			}
			else{
				$http.post("/datas/employes/congesExist.json", conges).then(function (response, status, headers, config) {
					if(response.data.data != false){
						vm.congesTrouve = response.data.data;
						vm.congesValide = false;	
					}
					else{
						vm.congesValide = true;
						vm.congesTrouve = "";
					}
				}, function () {});
			}		
		}
		
	
	
        vm.saveConge = function()
        {
			vm.showSpinner = 1;
			
			var fd = new FormData();			 
			fd.append("data", angular.toJson(vm.conge));
			
			/* var files = $('#file')[0].files;
			
			
			if(files.length > 0 ){
			   fd.append('file',files[0]);
			} */
			var config = { headers: {'Content-Type': undefined},
						   transformRequest: angular.identity
						 }
						   
			$http.post("/datas/employes/editConge.json", fd, config)
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        }  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.activites', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.collaborateurs_activites', {
                url    : '/collaborateurs/activites',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/collaborateurs/activites/activites.html',
                        controller : 'ActivitesController as vm'
                    }
                },
                resolve  : {
                   employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.listeCollaborateursEdit@get');
                    }
                },
                bodyClass: 'activites'
            });
        
        msApiProvider.register('employes.listeCollaborateursEdit', ['datas/employes/listeCollaborateursEdit.json']);
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.activites')
        .controller('ActivitesCollabDialogController', ActivitesCollabDialogController);

    /** @ngInject */
    function ActivitesCollabDialogController($mdDialog, employesSimple, congeApresMidi, congeMatin, Activite, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		vm.employesSimple = angular.copy(employesSimple);
		vm.activite = angular.copy(Activite);
		vm.congeApresMidi = angular.copy(congeApresMidi);
		vm.congeMatin = angular.copy(congeMatin);
		
		
		vm.convertHour = convertHour;
			
		function convertHour(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getHours()), pad(d.getMinutes())].join(':');
		}
		
		angular.forEach(vm.activite.TranchesHeures, function(value, key){
			value.start = new Date("1970-01-01 "+value.start);
			value.end = new Date("1970-01-01 "+value.end);
		});
	
		vm.convertDate = convertDate;
		function convertDate(inputFormat, hour , day ) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			
			var days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Dimanche'];

			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else if(day)
				return days[d.getDay()] + " "+[pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
	
	
        vm.saveActivite = function()
        {
			vm.showSpinner = 1;
			$http.post("/datas/employes/editActivite.json",JSON.stringify(vm.activite))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        }  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.analyse.emailstracking', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.parametres_emails', {
                url    : '/parametres/emailstracking',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/analyse/emails_tracking/emails_tracking.html',
                        controller : 'emailsTrackingController as vm'
                    }
                },
                resolve  : {
                   employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.listeCollaborateursEdit@get');
                    }
                },
                bodyClass: 'emails_tracking'
            });
        
        msApiProvider.register('employes.listeCollaborateursEdit', ['datas/employes/listeCollaborateursEdit.json']);
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.analyse.emailstracking')
        .controller('emailsTrackingDialogController', emailsTrackingDialogController);

    /** @ngInject */
    function emailsTrackingDialogController($mdDialog, $rootScope, Tracking, $mdToast, $http, $scope, $element)
    {
		
		var vm = this;
		vm.Tracking = angular.copy(Tracking);
		
		if(vm.Tracking=="")
			vm.Tracking = {Actif:1};
		
		/* vm.Permission = $rootScope.Permission;
		vm.dateMin = new Date();
		
		if($rootScope.Permission=='Super Admin')
			vm.dateMin.setDate(vm.dateMin.getDate() -60); 
		else
			vm.dateMin.setDate(vm.dateMin.getDate() + 2); 
		
		if(vm.Tracking=="")
			vm.Tracking = {DateDebut:null, DateFin:null};
		
		vm.convertDate = convertDate;

		function convertDate(inputFormat, hour , day ) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			
			var days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Dimanche'];

			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else if(day)
				return days[d.getDay()] + " "+[pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
		vm.congesValide = false;
		vm.congesTrouve = "";
		
		vm.testCongesExist = function(conges){
			if(typeof conges == "undefined" || typeof conges.DateDebut == "undefined" || typeof conges.HeureFin == "undefined" || typeof conges.DateFin == "undefined" || typeof conges.DateFin == "undefined"){
				vm.congesValide = false;
				vm.congesTrouve = "";
			}
			else{
				$http.post("/datas/employes/congesExist.json", conges).then(function (response, status, headers, config) {
					if(response.data.data != false){
						vm.congesTrouve = response.data.data;
						vm.congesValide = false;	
					}
					else{
						vm.congesValide = true;
						vm.congesTrouve = "";
					}
				}, function () {});
			}		
		}
		 */
	
	
        vm.saveTracking = function()
        {
			vm.showSpinner = 1;
			
			var fd = new FormData();			 
			fd.append("data", angular.toJson(vm.Tracking));
			
			/* var files = $('#file')[0].files;
			
			
			if(files.length > 0 ){
			   fd.append('file',files[0]);
			} */
			var config = { headers: {'Content-Type': undefined},
						   transformRequest: angular.identity
						 }
						   
			$http.post("/datas/analyse/editTracking.json", fd, config)
			.then(function (response, status, headers, config) {
			
				if(response.data.data.error){
					$mdToast.show(
					  $mdToast.simple()
						.textContent(response.data.data.error.message)
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.showSpinner = 0;
					$mdDialog.hide(response.data);
				}
				else{
					$mdDialog.hide(response.data);
					vm.showSpinner = 0;
				}
			}, function () {});

        }
		
		vm.closeDialog = function()
        {
            $mdDialog.hide();
        }  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.achats.factures', [
            'wt.responsive'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider
            .state('app.factures_achats', {
                url      : '/achats/factures?validationSuperPDP',
                reloadOnSearch: false,
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/achats/factures/factures-achats.html',
                        controller : 'FacturesAchatsController as vm'
                    }
                },
                resolve  : {
                    FacturesAchats: function (msApi)
                    {
                        return msApi.resolve('achats.factures@get');
                    },
                    nbrFacturesAchatsParEtats: function (msApi)
                    {
                        return msApi.resolve('achats.nbrFacturesParEtats@get');
                    }
                },
                bodyClass: 'factures-achats'
            });

        msApiProvider.register('achats.factures', ['datas/achats/getFactures.json']);
        msApiProvider.register('achats.nbrFacturesParEtats', ['datas/achats/getNbrFacturesParEtats.json']);
    }

})();

(function () {
    'use strict';
    angular.module('app.achats.factures').controller('FacturesAchatsStatutsMasseController', FacturesAchatsStatutsMasseController);
    /** @ngInject */
    function FacturesAchatsStatutsMasseController(Ids, $http, $mdDialog) {
        var vm = this;
        vm.ids = Ids || [];
        vm.etatsValidation = ['Brouillon', 'À valider', 'Validée', 'Refusée'];
        vm.etatsReglement = ['À payer', 'Partiellement réglée', 'Réglée', 'Échue', 'À imputer', 'Imputé', 'Partiellement remboursé', 'Remboursé'];
        vm.etatValidation = '';
        vm.statut = '';
        vm.busy = false;
        vm.error = '';
        vm.annuler = function () { if (!vm.busy) $mdDialog.cancel(); };
        vm.enregistrer = function () {
            if (vm.busy || !vm.ids.length || (!vm.etatValidation && !vm.statut)) return;
            vm.busy = true; vm.error = '';
            var data = new FormData();
            data.append('data', angular.toJson({IDs:vm.ids, EtatValidation:vm.etatValidation || null, Statut:vm.statut || null}));
            $http.post('/datas/achats/setStatutsFacturesMasse.json', data,
                {headers:{'Content-Type':undefined}, transformRequest:angular.identity}).then(function (response) {
                if (!response.data || response.data.error || !response.data.data) {
                    vm.error = response.data && response.data.error && response.data.error.message || 'Modification refusée.';
                    return;
                }
                $mdDialog.hide(response.data);
            }, function (response) {
                vm.error = response.data && response.data.error && response.data.error.message || 'Modification impossible.';
            }).finally(function () { vm.busy = false; });
        };
    }
})();

(function () {
    'use strict';
    angular.module('app.achats.factures').controller('FacturesAchatsImportController', FacturesAchatsImportController);

    /** @ngInject */
    function FacturesAchatsImportController($scope, $rootScope, $http, $mdDialog) {
        var vm = this, analyseSequence = 0;
        vm.busy = false; vm.busyAnalyse = false; vm.error = ''; vm.resultat = null;
        vm.formats = ['PDF', 'CSV']; vm.format = 'PDF'; vm.fournisseurs = [];
        vm.document = {TypeDocument:'Facture', Devise:'EUR', TotalHT:null, TotalTVA:null, TauxConversion:1, SourceTaux:'EUR'};
        vm.dates = {DateFacture:null, DateEcheance:null, DateTaux:null};
        vm.analyse = null; vm.avertissements = []; vm.fournisseurDetecte = null;

        vm.total = function () {
            if (vm.document.Devise !== 'EUR') {
                var taux = Number(vm.document.TauxConversion || 0);
                if (!taux) return 0;
                return Math.round((Number(vm.document.TotalHTDevise || 0) + Number(vm.document.TotalTVADevise || 0)) / taux * 100) / 100;
            }
            return Math.round((Number(vm.document.TotalHT || 0) + Number(vm.document.TotalTVA || 0)) * 100) / 100;
        };
        vm.totalOrigine = function () { return Math.round((Number(vm.document.TotalHTDevise || 0) + Number(vm.document.TotalTVADevise || 0)) * 100) / 100; };
        vm.autorise = function () {
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf('finance.achats.factures.import') !== -1;
        };
        vm.peutCreerFournisseur = function () {
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf('finance.achats.fournisseurs.validation') !== -1;
        };
        vm.fermer = function () {
            if (!vm.busy && !vm.busyAnalyse) {
                if (vm.resultat) $mdDialog.hide(vm.resultat);
                else $mdDialog.cancel();
            }
        };
        vm.changerFormat = function () {
            analyseSequence++;
            vm.file = null; vm.error = ''; vm.analyse = null; vm.avertissements = []; vm.fournisseurDetecte = null;
            vm.busyAnalyse = false;
        };
        vm.confiance = function (champ) {
            return vm.analyse && vm.analyse.Confiances ? Number(vm.analyse.Confiances[champ] || 0) : 0;
        };
        vm.actualiserTaux = function () {
            var date = formatDate(vm.dates.DateFacture), devise = String(vm.document.Devise || '').toUpperCase();
            vm.document.Devise = devise;
            if (devise === 'EUR') {
                vm.document.TauxConversion = 1; vm.document.SourceTaux = 'EUR'; vm.dates.DateTaux = vm.dates.DateFacture; return;
            }
            if (!/^[A-Z]{3}$/.test(devise) || !date) { vm.error = 'Renseigner une devise et une date de facture valides.'; return; }
            vm.error = ''; vm.busyAnalyse = true;
            $http.get('/datas/achats/getTauxChange.json', {params:{Devise:devise, Date:date}}).then(function (response) {
                var taux = response.data && response.data.data;
                if (!taux) { vm.error = 'Cours BCE introuvable.'; return; }
                vm.document.TauxConversion = Number(taux.TauxConversion);
                vm.document.SourceTaux = taux.SourceTaux;
                vm.dates.DateTaux = dateDepuisServeur(taux.DateTaux);
            }, function (response) { vm.error = messageErreur(response, 'Cours BCE introuvable. Saisissez-le manuellement.'); })
                .finally(function () { vm.busyAnalyse = false; });
        };

        $http.get('/datas/commandes/getAllFabricants.json').then(function (response) {
            vm.fournisseurs = response.data.data || [];
        }, function () { vm.error = 'Impossible de charger les fournisseurs.'; });

        $scope.$watch(function () { return vm.file; }, function (file, precedent) {
            if (file && file !== precedent && vm.format === 'PDF') vm.analyser();
        });

        vm.analyser = function () {
            if (vm.format !== 'PDF' || vm.busy || vm.busyAnalyse) return;
            vm.error = ''; vm.analyse = null; vm.avertissements = []; vm.fournisseurDetecte = null;
            if (!fichierValide(vm.file, /\.pdf$/i)) {
                vm.error = 'Choisir un PDF de 20 Mo maximum.'; return;
            }
            var sequence = ++analyseSequence, data = new FormData();
            data.append('file', vm.file);
            vm.busyAnalyse = true;
            $http.post('/datas/achats/analyserFacture.json', data, {
                headers:{'Content-Type':undefined}, transformRequest:angular.identity
            }).then(function (response) {
                if (sequence !== analyseSequence) return;
                if (!response.data || response.data.error || !response.data.data) {
                    vm.error = messageErreur(response, 'Analyse du PDF impossible. Les champs peuvent être saisis manuellement.'); return;
                }
                vm.analyse = response.data.data;
                vm.avertissements = vm.analyse.Avertissements || [];
                vm.fournisseurDetecte = vm.analyse.FournisseurDetecte || null;
                appliquerAnalyse(vm.analyse.Champs || {});
            }, function (response) {
                if (sequence === analyseSequence) vm.error = messageErreur(response, 'Analyse du PDF impossible. Les champs peuvent être saisis manuellement.');
            }).finally(function () {
                if (sequence === analyseSequence) vm.busyAnalyse = false;
            });
        };

        vm.creerFournisseur = function (event) {
            if (!vm.peutCreerFournisseur() || !vm.fournisseurDetecte || vm.busyAnalyse) return;
            var nom = vm.fournisseurDetecte.Fabricant;
            var confirmation = $mdDialog.confirm().multiple(true)
                .title('Créer ce fournisseur ?')
                .textContent('Créer « ' + nom + ' » dans le catalogue, puis le sélectionner pour cette facture ? Les informations détectées restent à contrôler.')
                .ariaLabel('Créer le fournisseur')
                .targetEvent(event)
                .ok('Créer')
                .cancel('Annuler');
            $mdDialog.show(confirmation).then(function () {
                vm.error = ''; vm.busyAnalyse = true;
                $http.post('/datas/achats/creerFournisseurImport.json', {data:angular.toJson(vm.fournisseurDetecte)}).then(function (response) {
                    if (!response.data || response.data.error || !response.data.data) {
                        vm.error = messageErreur(response, 'Création du fournisseur impossible.'); return;
                    }
                    var fournisseur = response.data.data;
                    if (!vm.fournisseurs.some(function (item) { return Number(item.IDFabricant) === Number(fournisseur.IDFabricant); })) {
                        vm.fournisseurs.push({IDFabricant:fournisseur.IDFabricant, Fabricant:fournisseur.Fabricant});
                        vm.fournisseurs.sort(function (a, b) { return (a.Fabricant || '').localeCompare(b.Fabricant || ''); });
                    }
                    vm.document.IDFabricant = fournisseur.IDFabricant;
                    if (vm.analyse && vm.analyse.Confiances) vm.analyse.Confiances.IDFabricant = 100;
                    vm.avertissements = vm.avertissements.filter(function (avertissement) {
                        return avertissement.indexOf('n’existe pas encore dans le catalogue') === -1;
                    });
                    vm.fournisseurDetecte = null;
                }, function (response) {
                    vm.error = messageErreur(response, 'Création du fournisseur impossible.');
                }).finally(function () { vm.busyAnalyse = false; });
            });
        };

        vm.importer = function (form) {
            if (!vm.autorise() || vm.busy || vm.busyAnalyse || vm.resultat || form.$invalid) return;
            vm.error = '';
            var extension = vm.format === 'CSV' ? /\.csv$/i : /\.pdf$/i;
            if (!fichierValide(vm.file, extension)) {
                vm.error = 'Choisir un fichier du format indiqué, de 20 Mo maximum.'; return;
            }
            var payload = {Format:vm.format};
            if (vm.format === 'PDF') {
                var dateFacture = formatDate(vm.dates.DateFacture), dateEcheance = formatDate(vm.dates.DateEcheance);
                if (!dateFacture || (vm.dates.DateEcheance && !dateEcheance)) {
                    vm.error = 'Saisir des dates valides.'; return;
                }
                var montantHT = vm.document.Devise === 'EUR' ? Number(vm.document.TotalHT) : Number(vm.document.TotalHTDevise);
                var montantTVA = vm.document.Devise === 'EUR' ? Number(vm.document.TotalTVA) : Number(vm.document.TotalTVADevise);
                if ((vm.document.TypeDocument === 'Facture' && (montantHT < 0 || montantTVA < 0)) ||
                    (vm.document.TypeDocument === 'Avoir' && (montantHT > 0 || montantTVA > 0))) {
                    vm.error = 'Les montants doivent être positifs pour une facture, négatifs pour un avoir.'; return;
                }
                payload.IDFabricant = vm.document.IDFabricant;
                payload.TypeDocument = vm.document.TypeDocument;
                payload.NumeroFacture = vm.document.NumeroFacture;
                payload.DateFacture = dateFacture;
                payload.DateEcheance = dateEcheance;
                payload.TotalHT = vm.document.TotalHT;
                payload.TotalTVA = vm.document.TotalTVA;
                payload.Devise = String(vm.document.Devise || 'EUR').toUpperCase();
                if (payload.Devise !== 'EUR') {
                    payload.TotalHTDevise = vm.document.TotalHTDevise;
                    payload.TotalTVADevise = vm.document.TotalTVADevise;
                    payload.TauxConversion = vm.document.TauxConversion;
                    payload.DateTaux = formatDate(vm.dates.DateTaux);
                    payload.SourceTaux = vm.document.SourceTaux || 'Manuel';
                    if (!payload.DateTaux || !(Number(payload.TauxConversion) > 0)) {
                        vm.error = 'Renseigner un taux de conversion positif et sa date.'; return;
                    }
                }
            }
            var data = new FormData();
            data.append('file', vm.file);
            data.append('data', angular.toJson(payload));
            vm.busy = true;
            $http.post('/datas/achats/importerFactures.json', data, {
                headers:{'Content-Type':undefined}, transformRequest:angular.identity
            }).then(function (response) {
                if (!response.data || response.data.error || !response.data.data) {
                    vm.error = messageErreur(response, 'Import refusé.'); return;
                }
                vm.resultat = response.data.data;
            }, function (response) {
                vm.error = messageErreur(response, 'Import impossible. Vérifier le contrôleur PHP.');
            }).finally(function () { vm.busy = false; });
        };

        function appliquerAnalyse(champs) {
            ['IDFabricant','TypeDocument','NumeroFacture','TotalHT','TotalTVA','Devise','TotalHTDevise','TotalTVADevise','TauxConversion','SourceTaux'].forEach(function (champ) {
                if (champs[champ] !== null && champs[champ] !== undefined && champs[champ] !== '') vm.document[champ] = champs[champ];
            });
            vm.dates.DateFacture = dateDepuisServeur(champs.DateFacture);
            vm.dates.DateEcheance = dateDepuisServeur(champs.DateEcheance);
            vm.dates.DateTaux = dateDepuisServeur(champs.DateTaux);
        }
        function fichierValide(file, extension) {
            return !!file && Number(file.size || 0) > 0 && Number(file.size || 0) <= 20 * 1024 * 1024 && extension.test(file.name || '');
        }
        function dateDepuisServeur(value) {
            if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
            var date = new Date(value + 'T00:00:00');
            return isNaN(date.getTime()) ? null : date;
        }
        function formatDate(date) {
            if (!date || typeof date.getTime !== 'function' || isNaN(date.getTime())) return '';
            function pad(value) { return ('0' + value).slice(-2); }
            return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
        }
        function messageErreur(response, defaut) {
            return response && response.data && response.data.error && response.data.error.message || defaut;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.achats.factures').controller('FournisseursSuperPDPValidationController', FournisseursSuperPDPValidationController);

    /** @ngInject */
    function FournisseursSuperPDPValidationController(Propositions, $http, $mdDialog, $mdToast) {
        var vm = this;
        vm.propositions = Propositions || [];
        vm.index = 0;
        vm.fournisseurs = [];
        vm.busy = false;
        vm.error = '';

        function initialise() {
            vm.proposition = vm.propositions[vm.index] || null;
            if (!vm.proposition) return;
            vm.choix = {
                Mode: vm.proposition.IDFabricantSuggere ? 'rattachement' : 'creation',
                IDFabricant: vm.proposition.IDFabricantSuggere || null,
                Fabricant: vm.proposition.NomCommercial || vm.proposition.NomFournisseur,
                Metier: 'Fournisseur'
            };
            vm.error = '';
        }

        $http.get('/datas/commandes/getAllFabricants.json').then(function (response) {
            vm.fournisseurs = response.data.data || [];
        }, function () {
            vm.error = 'Impossible de charger les fournisseurs existants.';
        });

        vm.precedent = function () {
            if (!vm.busy && vm.index > 0) { vm.index--; initialise(); }
        };
        vm.suivant = function () {
            if (!vm.busy && vm.index < vm.propositions.length - 1) { vm.index++; initialise(); }
        };
        vm.annuler = function () { if (!vm.busy) $mdDialog.cancel(); };
        vm.appliquer = function (form) {
            if (!vm.proposition || vm.busy || form.$invalid) return;
            if (vm.choix.Mode === 'rattachement' && !vm.choix.IDFabricant) {
                vm.error = 'Sélectionner le fournisseur à rattacher.'; return;
            }
            var payload = {
                IDSuperPDPFacture:vm.proposition.IDSuperPDPFacture,
                Mode:vm.choix.Mode,
                IDFabricant:vm.choix.IDFabricant,
                Fabricant:vm.choix.Fabricant,
                Metier:vm.choix.Metier
            };
            vm.busy = true; vm.error = '';
            $http.post('/datas/achats/validerFournisseurSuperPDP.json', payload).then(function (response) {
                if (!response.data || response.data.error || !response.data.data) {
                    vm.error = response.data && response.data.error && response.data.error.message || 'Validation refusée.'; return;
                }
                var resultat = response.data.data;
                if (resultat.Erreurs && resultat.Erreurs.length) {
                    vm.error = resultat.Erreurs.map(function (erreur) { return erreur.NumeroFacture + ' : ' + erreur.Message; }).join(' — ');
                    if (resultat.IDFabricant) {
                        vm.fournisseurs.push({IDFabricant:resultat.IDFabricant, Fabricant:vm.choix.Fabricant});
                        vm.choix.Mode = 'rattachement';
                        vm.choix.IDFabricant = resultat.IDFabricant;
                    }
                    return;
                }
                $mdToast.show($mdToast.simple()
                    .textContent((resultat.FournisseurCree ? 'Fournisseur créé. ' : 'Fournisseur rattaché. ') + Number(resultat.Importes || 0) + ' facture(s) importée(s).')
                    .position('bottom right').hideDelay(5000));
                vm.propositions.splice(vm.index, 1);
                if (!vm.propositions.length) { $mdDialog.hide(resultat); return; }
                if (vm.index >= vm.propositions.length) vm.index = vm.propositions.length - 1;
                initialise();
            }, function (response) {
                vm.error = response.data && response.data.error && response.data.error.message || 'Enregistrement impossible.';
            }).finally(function () { vm.busy = false; });
        };
        initialise();
    }
})();

(function () {
    'use strict';
    angular.module('app.achats.factures').controller('FactureAchatEditionController', FactureAchatEditionController);
    /** @ngInject */
    function FactureAchatEditionController(Document, StatutSeulement, LectureSeule, $rootScope, $http, $mdDialog) {
        var vm = this;
        vm.document = angular.copy(Document);
        vm.document.Devise = vm.document.Devise || 'EUR';
        vm.document.TauxConversion = Number(vm.document.TauxConversion || 1);
        vm.document.SourceTaux = vm.document.SourceTaux || (vm.document.Devise === 'EUR' ? 'EUR' : 'Manuel');
        vm.lectureSeule = LectureSeule === true;
        vm.dates = {};
        ["DateFacture","DateEcheance","DateTaux"].forEach(function (field) {
            vm.dates[field] = Document[field] ? new Date(Document[field] + 'T00:00:00') : null;
        });
        function formatDate(date) {
            if (!date || isNaN(date.getTime())) return '';
            function pad(value) { return ('0' + value).slice(-2); }
            return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
        }
        vm.statutSeulement = StatutSeulement;
        vm.busy = false; vm.error = ''; vm.fournisseurs = [];
        vm.etatsReglement = Document.TypeDocument === 'Avoir' ?
			['À imputer', 'Imputé', 'Partiellement remboursé', 'Remboursé'] :
            ['À payer', 'Partiellement réglée', 'Réglée', 'Échue'];
        vm.etatsValidation = ['Validée', 'Refusée'].indexOf(Document.EtatValidation) !== -1 ?
            [Document.EtatValidation] : ['Brouillon', 'À valider', 'Validée', 'Refusée'];
        vm.annuler = function () { if (!vm.busy) $mdDialog.cancel(); };
        vm.autorise = function () {
            var droit = 'finance.achats.factures.' + (vm.statutSeulement ? 'statut' : 'edition');
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf(droit) !== -1;
        };
        vm.modifiable = !Document.IDFactureAchat || (Document.Origine === 'Import manuel' &&
            ['Brouillon', 'À valider'].indexOf(Document.EtatValidation) !== -1 && !Number(Document.MontantRegle));
        vm.total = function () {
            if (vm.document.Devise !== 'EUR') {
                var taux = Number(vm.document.TauxConversion || 0);
                return taux ? Math.round((Number(vm.document.TotalHTDevise || 0) + Number(vm.document.TotalTVADevise || 0)) / taux * 100) / 100 : 0;
            }
            return Math.round((Number(vm.document.TotalHT || 0) + Number(vm.document.TotalTVA || 0)) * 100) / 100;
        };
        vm.totalOrigine = function () { return Math.round((Number(vm.document.TotalHTDevise || 0) + Number(vm.document.TotalTVADevise || 0)) * 100) / 100; };
        vm.actualiserTaux = function () {
            var date = formatDate(vm.dates.DateFacture), devise = String(vm.document.Devise || '').toUpperCase();
            vm.document.Devise = devise;
            if (devise === 'EUR') { vm.document.TauxConversion = 1; vm.document.SourceTaux = 'EUR'; vm.dates.DateTaux = vm.dates.DateFacture; return; }
            if (!/^[A-Z]{3}$/.test(devise) || !date) { vm.error = 'Renseigner une devise et une date de facture valides.'; return; }
            vm.error = ''; vm.busy = true;
            $http.get('/datas/achats/getTauxChange.json', {params:{Devise:devise, Date:date}}).then(function (response) {
                var taux = response.data && response.data.data;
                if (!taux) { vm.error = 'Cours BCE introuvable.'; return; }
                vm.document.TauxConversion = Number(taux.TauxConversion); vm.document.SourceTaux = taux.SourceTaux;
                vm.dates.DateTaux = taux.DateTaux ? new Date(taux.DateTaux + 'T00:00:00') : null;
            }, function () { vm.error = 'Cours BCE introuvable. Saisissez-le manuellement.'; }).finally(function () { vm.busy = false; });
        };
        if (!vm.lectureSeule && !vm.statutSeulement) $http.get('/datas/commandes/getAllFabricants.json').then(function (response) {
            vm.fournisseurs = response.data.data || [];
        }, function () { vm.error = 'Impossible de charger les fournisseurs.'; });
        vm.enregistrer = function (form) {
            if (vm.lectureSeule || !vm.autorise() || vm.busy || form.$invalid || (!vm.statutSeulement && !vm.modifiable)) return;
            var d = vm.document;
            if (!vm.statutSeulement) ["DateFacture","DateEcheance","DateTaux"].forEach(function (field) {
                d[field] = formatDate(vm.dates[field]);
            });
            vm.error = '';
            if (vm.statutSeulement && vm.etatsValidation.indexOf(d.EtatValidation) === -1) {
                vm.error = 'Transition de validation non autorisée.'; return;
            }
            if (vm.statutSeulement && vm.etatsReglement.indexOf(d.Statut) === -1) {
                vm.error = 'Statut de règlement non autorisé pour ce document.'; return;
            }
            if (!vm.statutSeulement) {
                if (!dateValide(d.DateFacture) || (d.DateEcheance && !dateValide(d.DateEcheance))) {
                    vm.error = 'Saisir les dates au format AAAA-MM-JJ.'; return;
                }
                var montantHT = d.Devise === 'EUR' ? Number(d.TotalHT) : Number(d.TotalHTDevise);
                var montantTVA = d.Devise === 'EUR' ? Number(d.TotalTVA) : Number(d.TotalTVADevise);
                if ((d.TypeDocument === 'Facture' && (montantHT < 0 || montantTVA < 0)) ||
                    (d.TypeDocument === 'Avoir' && (montantHT > 0 || montantTVA > 0))) {
                    vm.error = 'Les montants doivent être positifs pour une facture, négatifs pour un avoir.'; return;
                }
                if (d.Devise !== 'EUR' && (!(Number(d.TauxConversion) > 0) || !dateValide(d.DateTaux))) {
                    vm.error = 'Renseigner un taux de conversion positif et sa date.'; return;
                }
            }
            if (vm.file && (vm.file.size > 20 * 1024 * 1024 || !/\.pdf$/i.test(vm.file.name))) {
                vm.error = 'Le justificatif doit être un PDF de 20 Mo maximum.'; return;
            }
            var payload = vm.statutSeulement ?
                {IDFactureAchat:d.IDFactureAchat, EtatValidation:d.EtatValidation, Statut:d.Statut} :
                {IDFactureAchat:d.IDFactureAchat, IDFabricant:d.IDFabricant, TypeDocument:d.TypeDocument,
                    NumeroFacture:d.NumeroFacture, DateFacture:d.DateFacture, DateEcheance:d.DateEcheance,
                    TotalHT:d.TotalHT, TotalTVA:d.TotalTVA, Devise:d.Devise,
                    TotalHTDevise:d.TotalHTDevise, TotalTVADevise:d.TotalTVADevise,
                    TauxConversion:d.TauxConversion, DateTaux:d.DateTaux, SourceTaux:d.SourceTaux};
            var data = new FormData();
            data.append('data', angular.toJson(payload));
            if (vm.file && !vm.statutSeulement) data.append('file', vm.file);
            vm.busy = true;
            $http.post('/datas/achats/' + (vm.statutSeulement ? 'setStatutFacture' : 'editFacture') + '.json', data,
                {headers:{'Content-Type':undefined}, transformRequest:angular.identity}).then(function (response) {
                    if (!response.data || response.data.error || !response.data.data) { vm.error = (response.data && response.data.error && response.data.error.message) || 'Enregistrement refusé.'; return; }
                    $mdDialog.hide(response.data);
                }, function () { vm.error = 'Enregistrement impossible. Vérifier le contrôleur PHP.'; })
                .finally(function () { vm.busy = false; });
        };
        function dateValide(value) {
            if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
            var date = new Date(value + 'T12:00:00Z');
            return !isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        /*$translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['data/quick-panel/notes.json']);*/
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sites.liste')
        .controller('SitesController', SitesController)	;

    /** @ngInject */


    function SitesController(employesSimple, Fabricants, Contacts, Commandes, cmsListeUsedSimple, DTColumnBuilder, DTOptionsBuilder, $compile, $scope, $location, $mdDialog, $http , $element, $mdToast)
    {
		
		const formatter = new Intl.NumberFormat('fr-FR', {
			style: 'currency',
			currency: 'EUR',
			minimumFractionDigits:0
		});

        var vm = this;
		
		// vm.search = localStorage.getItem('sitesSearch');
		vm.date = new Date();
		vm.recordsTotal = 0;
	
	
		$scope.searchTerm;
		$scope.clearSearchTerm = function() {
			$scope.searchTerm = '';
		};
		$element.find('input').on('keydown', function(ev) {
			ev.stopPropagation();
		});
		
		function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');// + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
		}
		
		
		vm.detailsSiteWeb = function (IDSiteWeb){
			$location.path('/sites/details/'+IDSiteWeb);
		}
		
		
		vm.optionSiteWeb = function (ev, IDSiteWeb){
			$http.get("/datas/sites/getDetailsSite.json?IDSiteWeb="+IDSiteWeb)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					controller         : 'optionsSiteDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/sites/sites/dialogs/site-options-dialog.html',
					parent             : angular.element(document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						SiteWeb : response.data.data,
						Commandes : Commandes, 
						Contacts : Contacts, 
						
					}
				}).then(function (response)
				{
					if(typeof response != "undefined"){
						vm.dtInstance.reloadData();
						
						if(response.data.error){
						}
						else
						if(typeof IDSiteWeb!="undefined")
							$mdToast.show(
							  $mdToast.simple()
								.textContent("Votre site internet a été modifié !")
								.position('bottom right' )
								.hideDelay(3000)
							);
						else
						$mdToast.show(
						  $mdToast.simple()
							.textContent("Votre site internet a été créé et sera mise à jour dans la liste sous 24h.")
							.position('bottom right' )
							.hideDelay(3000)
						);
					} 
				});
			}, function () {});
		}
		
		
		vm.deleteSiteWeb = function (ev, IDSiteWeb, URL)
        {
		
		 	var trackingObj = {IDSiteWeb:IDSiteWeb};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer ce site internet ?')
                .htmlContent('Le site internet <b>' + URL + '</b>' + ' va être supprimée.<br> Toutes les données seront perdues')
                .ariaLabel("Supprimer le site internet")
                .targetEvent(ev)
                .theme('md-warn')
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/sites/deleteSiteWeb.json", JSON.stringify(trackingObj)).then(function (response, status, headers, config) {  
					vm.dtInstance.reloadData();
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Le site internet a été supprimé.')
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.dtInstance.reloadData();
				}, function () {});
				
            }, function () {});
        } 
		
		
		vm.openContactDialog = function (contact)
        {
			var contactObj = {IDContact:contact};
            $mdDialog.show({
                controller         : 'profilContactController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/contacts/profil/profil-dialog.html',
                parent             : angular.element(".commandes"),
                clickOutsideToClose: true,
				multiple:true,
				fullscreen:true,
				openFrom  : '#previewContact',
				closeTo  : '#previewContact',
                locals             : {
					Contact: contactObj,
					Fabricants: Fabricants,
					employesSimple: employesSimple,
					Structures: {},
					APE: {},
					Activites: {},
					Commandes: {},
					Alertes: {},
					Courriers: {},
					Employes: {},
					Dialog:1
                }
            });
        }
		
		vm.filterSave = [];
        vm.dtInstance = {};
    		
		vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'datas',
				 url: 'datas/sites/getSites.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('StateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('aoSearchCols',   [
			  null,
			  null,
			  null,
			  null,
			  null,
			  null,
			  { "sSearch": "En cours" },
			  null,
			])
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'DataTablesSites', JSON.stringify(oData) );
			})
			.withOption('stateLoadCallback', function (oSettings) {
				// console.log(localStorage.getItem('DataTablesSites'));
				return JSON.parse( localStorage.getItem('DataTablesSites') );
			})
			.withOption('drawCallback', function (o) {
				 /*  $('.scrollable').animate({  ??? GENANT D'APRES COLLABORATEURS
					scrollTop: 0
				  }, 'slow'); */
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
				// console.log(vm.filterSave);
			})
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			
			.withLightColumnFilter({
				   "0": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "1": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "2": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "3": {
					"html": "select",
					"values": cmsListeUsedSimple.data,
					"location": $location,
					"regex":true
				  },
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  } ,
				  "5": {
					"html": "range",
					"type": "date",
					"location": $location
				  } ,
				  "6": {
					"html": "select",
					"values": [
						// {value: '', label: '--'}, 
						{value: 'En cours', label: 'En cours'}, 
						{value: 'Terminé', label: 'Terminé'}, 
						{value: 'Pas de projet', label: 'Pas de projet'}
					],
					"location": $location,
					"regex":true
				  },
				  "7": {
					"html": "clear"
				  }
			  })
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
				var api = this.api();
                vm.searchBox = angular.element('body').find('#sites-search');
				
				angular.forEach(vm.filterSave, function(value, key) {
					var cpt = key+1;
					if(value.search.search.includes("~")){
						jQuery('.dataTableSites tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
						jQuery('.dataTableSites tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
						
					} else{
						jQuery('.dataTableSites tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
						jQuery('.dataTableSites tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
					}
				}); 
				
				
                if ( vm.searchBox.length > 0 )
                {
					var timeout = null;
                    vm.searchBox.on('keyup', function (event)
                    {
						clearTimeout(timeout);
						timeout = setTimeout(function () {
							api.search(vm.search).draw();
						}, 500);
                    });
                }
				
				vm.recordsTotal = json.recordsTotal;
			  }
			)
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('order', [0, 'desc']);
	
			
			vm.dtColumns = [
				DTColumnBuilder.newColumn('IDSiteWeb').withTitle('<div class="table-header"><span class="column-title">N°</div></div>').withOption('width', '70px'),
				DTColumnBuilder.newColumn('URL').withTitle('<div class="table-header"><span class="column-title">URL</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
					var html = '<a href="'+ data +'" target="_blank">'+data.replace('http://', '').replace('https://', '').replace('www.', '')+'</a>';
					return html;
				}),
				
				DTColumnBuilder.newColumn('RaisonSocial').withTitle('<div class="table-header"><span class="column-title">Contact</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
					// var html = '<a href="'+ data +'" target="_blank">'+data.replace('http://', '').replace('https://', '').replace('www.', '')+'</a>';
					return '<a ng-click="vm.openContactDialog('+ full.IDContact +')" href="#">'+data+"</a>";
					// return data;
				}),
				DTColumnBuilder.newColumn('CMS').withTitle('<div class="table-header"><span class="column-title">CMS</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
					// var html = '<a href="'+ data +'" target="_blank">'+data.replace('http://', '').replace('https://', '').replace('www.', '')+'</a>';
					var $return = data;
					// var $return = "<img src='/assets/images/logos/magento.png' width='100px'/>";
					switch (data){
						case "Joomla" : $return = "<img src='/assets/images/logos/joomla.png' width='100px'/>"; break;
						case "WordPress" : $return = "<img src='/assets/images/logos/wordpress.png' width='100px'/>"; break;
						case "PrestaShop" : $return = "<img src='/assets/images/logos/prestashop.svg' width='100px'/>"; break;
						case "CMS Made Simple" : $return = "<img src='/assets/images/logos/simple.png' width='100px'/>"; break;
						case "Website X5" : $return = "<img src='/assets/images/logos/websitex5.png' width='100px'/>"; break;
						case "Laravel" : $return = "<img src='/assets/images/logos/laravel.png' width='100px'/>"; break;
						case "Spip" : $return = "<img src='/assets/images/logos/spip.png' width='100px'/>"; break;
						case "Wix" : $return = "<img src='/assets/images/logos/wix.png' width='100px'/>"; break;
						case "Xara" : $return = "<img src='/assets/images/logos/xara.png' width='100px'/>"; break;
						case "Typo3" : $return = "<img src='/assets/images/logos/typo3.png' width='100px'/>"; break;
						case "Weebly" : $return = "<img src='/assets/images/logos/weebly.png' width='100px'/>"; break;
						case "Oxatis" : $return = "<img src='/assets/images/logos/oxatis.png' width='100px'/>"; break;
						case "Jimdo" : $return = "<img src='/assets/images/logos/jimdo.png' width='100px'/>"; break;
						case "Magento" : $return = "<img src='/assets/images/logos/magento.png' width='100px'/>"; break;
						case "Drupal" : $return = "<img src='/assets/images/logos/drupal.png' width='100px'/>"; break;
						case "Shopify" : $return = "<img src='/assets/images/logos/shopify.svg' width='100px'/>"; break;
						case "Duda" : $return = "<img src='/assets/images/logos/solocal.svg' width='100px'/>"; break;
					}
					return $return;
				}),
				/* DTColumnBuilder.newColumn('StatsContacts').withTitle('<div class="table-header"><span class="column-title">Site Exodream</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
					// var html = '<a href="'+ data +'" target="_blank">'+data.replace('http://', '').replace('https://', '').replace('www.', '')+'</a>';
					return "non";
				}),
				DTColumnBuilder.newColumn('StatsContacts').withTitle('<div class="table-header"><span class="column-title">Modules de stats</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
					// var html = '<a href="'+ data +'" target="_blank">'+data.replace('http://', '').replace('https://', '').replace('www.', '')+'</a>';
					return data;
				}), */
				
				DTColumnBuilder.newColumn('DateVerificationAcces').withTitle('<div class="table-header"><span class="column-title">Vérification site</div></div>').withOption('width', '130px').renderWith(function(data, type, full){
					if(data != "0000-00-00")
						return convertDate(data);
					else
						return "";
				}),
				DTColumnBuilder.newColumn('DateCrawlSEO').withTitle('<div class="table-header"><span class="column-title">Crawl SEO</div></div>').withOption('width', '130px').renderWith(function(data, type, full){
					if(data != "0000-00-00")
						return convertDate(data);
					else
						return "";
				}),
				DTColumnBuilder.newColumn('Termine').withTitle('<div class="table-header"><span class="column-title">Status</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
					if ( type === 'display' ){
						var html ="";
							
							switch(data){
								case "En cours": html = '<span class="p-5 pr-8 pl-8 brad-16 teal-700-bg white-fg" selected="true"><small>'+data+'</small></span>'; break;
								case "Terminé": html = '<span class="p-5 pr-8 pl-8 brad-16 md-brown-800-bg white-fg" selected="true"><small>'+data+'</small></span>'; break;
								case "Pas de projet": html = '<span class="p-5 pr-8 pl-8 brad-16 md-grey-500-bg white-fg" selected="true"><small>'+data+'</small></span>'; break;
							}
                       return html;
					}
					return data;
				}),
				DTColumnBuilder.newColumn('IDSiteWeb').withTitle('').notSortable().withOption('width', '60px').renderWith(function(data, type, full){
					return '<md-menu style="float: right;">'+
					'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
							'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
						'</md-button>'+

						'<md-menu-content width="3">'+
							'<md-menu-item >'+
								'<md-button ng-click="vm.detailsSiteWeb('+full.IDSiteWeb+', $event)" '+ ((full.Termine=="Pas de projet") ? "disabled" : "") +'>'+
									'Statistiques'+
								'</md-button>'+
							'</md-menu-item>'+

							'<md-divider ></md-divider>'+
							'<md-menu-item >'+
								'<md-button ng-click="vm.optionSiteWeb($event, '+full.IDSiteWeb+')" >'+
									'Options'+
								'</md-button>'+
							'</md-menu-item>'+
							'<md-menu-item> '+
								'<md-button ng-click="vm.deleteSiteWeb($event, '+full.IDSiteWeb+', \''+full.URL+'\')" '+((full.Termine!="Pas de projet") ? "disabled" : "")+'> '+
									'Supprimer '+
								'</md-button>'+
							'</md-menu-item>'+
						'</md-menu-content>'+
					'</md-menu>';
						
				}),
				
			];
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites.details', ['nvd3'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
		
        $stateProvider
            .state('app.sites.details', {
                url    : '/details/:token',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sites/details/details.html',
                        controller : 'SiteDetailsController as vm'
                    }
                },
                resolve: {
					employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.simpleListe@get');
                    },
					Fabricants: function (msApi)
					{
						return msApi.resolve('commandes.fabricants@get');
					},
                    detailsSite: function (msApi, $stateParams)
					{
						return msApi.resolve('detailsSite.details@get',{'IDSiteWeb': $stateParams.token});
					}
                }
            });

        msApiProvider.register('detailsSite.details', ['/datas/sites/getDetailsSite.json']);
        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sites.details')
        .controller('SiteDetailsController', SiteDetailsController);

    /** @ngInject */
    function SiteDetailsController(detailsSite,employesSimple, Fabricants, $state, fuseTheming, $mdDialog)
    {
        var vm = this;
		vm.detailsSite = detailsSite.data;
		
		vm.annee = new Date().getFullYear();
		vm.listeAnnees = Object.keys(vm.detailsSite.Contacts);
		vm.Contacts = angular.copy(vm.detailsSite.Contacts[vm.annee]);
		
		if(typeof vm.Contacts == "undefined")
			vm.Contacts = {};
			
		const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
		  "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"
		];
		
		vm.month_start = "Janvier";
		vm.year_start = new Date().getFullYear() -1;
		vm.month_end = "Janvier";
		vm.year_end = new Date().getFullYear();
		
		vm.monthNames = monthNames;
		
		var colors = ['#00bcd4','#039be5','#3f51b5','#673ab7'];
		var i = 0;
		
		// angular.forEach(vm.detailsSite.Contacts[vm.annee], function(Contacts, KContacts) {
			
			vm.Contacts.config = {
				refreshDataOnly: true,
				deepWatchData  : true
			};
			
			vm.Contacts.options = {};
			vm.Contacts.options.Telephones = {
				"chart": {
					"type": "discreteBarChart",
						x: function(d){return d.label;},
						y: function(d){return d.value},
					color                  : [colors[i]],
					height                 : 100,
					margin      : {
						top   : 0,
						right : 0,
						bottom: 0,
						left  : 0
					},
					noData : 'Aucune donnée',
					padding      : {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0
					},
					yAxis: {tickFormat: function(d){return (d>1) ? d+" appels" : d+" appel";}},
					xAxis: {
						tickFormat: function(d){
							return monthNames[d-1]+ " " + vm.annee;
							// console.log(d);
							// if (typeof d === 'string') {
								// d = parseFloat(d);
							// }
							// return d3.time.format("%m/%Y")(new Date(d));
						},
						rotateLabels: 30,
						showMaxMin: false
					},
					duration    : 800,
					useInteractiveGuideline: true,
					// interpolate : $rootScope.config.CourbesInterpolation,
					showLegend  : false,
					// isArea  :  $rootScope.config.CourbesArea,
					// yDomain: ydomain,
					// yDomain1: ydomain,
					showXAxis   : false,
					showYAxis   : false,
					interactiveLayer       : {
						tooltip: {
							gravity: 's',
							fixedTop : 100,
							classes: 'gravity-s' ,
							valueFormatter : function (d, i) {
								console.log(d);
								return d ;
							}
						}
					}
				}
			};
			
			vm.Contacts.options.Telephones.chart.color = [colors[i++]];
			
			vm.Contacts.options.Emails = angular.copy(vm.Contacts.options.Telephones);
			vm.Contacts.options.Emails.chart.color = [colors[i++]];
			vm.Contacts.options.Emails.chart.yAxis = {tickFormat: function(d){return (d>1) ? d+" e-mails" : d+" e-mail";}};
			
			vm.Contacts.options.Formulaires = angular.copy(vm.Contacts.options.Telephones);
			vm.Contacts.options.Formulaires.chart.color = [colors[i++]];
			vm.Contacts.options.Formulaires.chart.yAxis = {tickFormat: function(d){return (d>1) ? d+" formulaires" : d+" formulaire";}};
			
			vm.Contacts.options.Adresses = angular.copy(vm.Contacts.options.Telephones);
			vm.Contacts.options.Adresses.chart.color = [colors[i++]];
			vm.Contacts.options.Adresses.chart.yAxis = {tickFormat: function(d){return (d>1) ? d+" adresses" : d+" adresse";}};
			
			// console.log(vm.Contacts.options.Telephones);
			
		// });	
	
		vm.openContactDialog = function (contact)
		{
			var contactObj = {IDContact:contact};
			$mdDialog.show({
				controller         : 'profilContactController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/contacts/profil/profil-dialog.html',
				parent             : angular.element(".commandes"),
				clickOutsideToClose: true,
				multiple:true,
				fullscreen:true,
				openFrom  : '#previewContact',
				closeTo  : '#previewContact',
				locals             : {
					Contact: contactObj,
					Fabricants: Fabricants,
					employesSimple: employesSimple,
					Structures: {},
					APE: {},
					Activites: {},
					Commandes: {},
					Alertes: {},
					Courriers: {},
					Employes: {},
					Dialog:1
				}
			});
		}
			
		vm.chanegPeriode = function(range){
			
		}
		
		vm.changeAnne = function(range){
			vm.annee = range;
			// vm.Contacts = vm.detailsSite.Contacts[vm.annee];
			
			// console.log(range);
			// console.log( vm.detailsSite.Contacts[vm.annee].Telephones.data[0].values);
			
			angular.forEach(vm.detailsSite.Contacts[vm.annee].Telephones.data[0].values, function (chartData, index)
			{
				console.log(chartData);
				console.log(vm.Contacts);
				vm.Contacts.Telephones.data[0].values[index] = {
					label   : chartData.label,
					value: chartData.value
				};
			});
			
			
			angular.forEach(vm.detailsSite.Contacts[vm.annee].Emails.data[0].values, function (chartData, index)
			{
				vm.Contacts.Emails.data[0].values[index] = {
					label   : chartData.label,
					value: chartData.value
				};
			});
			
			angular.forEach(vm.detailsSite.Contacts[vm.annee].Adresses.data[0].values, function (chartData, index)
			{
				vm.Contacts.Adresses.data[0].values[index] = {
					label   : chartData.label,
					value: chartData.value
				};
			});
			
			angular.forEach(vm.detailsSite.Contacts[vm.annee].Formulaires.data[0].values, function (chartData, index)
			{
				vm.Contacts.Formulaires.data[0].values[index] = {
					label   : chartData.label,
					value: chartData.value
				};
			});

			/*for(var i=0; i<12; i++){
				// console.log(vm.detailsSite.Contacts[vm.annee].Telephones.data[0]);
				// sleep(0.5);
				console.log(vm.Contacts.options);
				// vm.Contacts.options.Telephones.data[0].values[i].value = vm.detailsSite.Contacts[vm.annee].Telephones.data[0].values[i].value;
				// vm.Contacts.options.Emails.data[0].values[i].value = vm.detailsSite.Contacts[vm.annee].Emails.data[0].values[i].value;
				// vm.Contacts.options.Adresses.data[0].values[i].value = vm.detailsSite.Contacts[vm.annee].Adresses.data[0].values[i].value;
				// vm.Contacts.options.Formulaires.data[0].values[i].value = vm.detailsSite.Contacts[vm.annee].Formulaires.data[0].values[i].value;
				// vm.Contacts.Telephones.data[0].values[1].value = 15;
				// vm.Contacts.Emails.data[0].values[i].value = vm.detailsSite.Contacts[vm.annee].Emails.data[0].values[i].value;
				// vm.Contacts.Formulaires.data[0].values[i].value = vm.detailsSite.Contacts[vm.annee].Formulaires.data[0].values[i].value;
				// vm.Contacts.Adresses.data[0].values[i].value = vm.detailsSite.Contacts[vm.annee].Adresses.data[0].values[i].value;
				// vm.statistiques.config.chart.data[0].values =  vm.statistiques.resume[vm.statistiques.config.currentCourbe].values[range];
			}*/
			
			
			// console.log(vm.Contacts.Telephones.data[0].values);
		}
		
		function sleep(seconds){
			var waitUntil = new Date().getTime() + seconds*1000;
			console.log(waitUntil);
			while(new Date().getTime() < waitUntil) true;
		}
		
		vm.returnSitesWeb = function () {
			$state.go('app.sites');
        }
		
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.parametres.regles_bancaires')
        .controller('ReglesBancairesController', ReglesBancairesController);

    /** @ngInject */
    function ReglesBancairesController(ReglesBancaires, $rootScope, $http, $mdDialog, $mdToast)
    {
        var vm = this;
        vm.regles = ReglesBancaires.data || [];
        vm.droits = function (action)
        {
            var droit = 'configuration.regles_bancaires' + (action ? '.' + action : '');
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf(droit) !== -1;
        };

        vm.editer = function (event, regle)
        {
            if (!vm.droits('edition')) return;
            $mdDialog.show({
                controller: 'RegleBancaireDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/parametres/regles_bancaires/dialogs/regle-dialog.html',
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {Regle: regle ? angular.copy(regle) : null}
            }).then(function (response)
            {
                vm.regles = response.data || [];
                toast(regle ? 'La règle a été modifiée.' : 'La règle a été créée.');
            }, angular.noop);
        };

        vm.supprimer = function (event, regle)
        {
            if (!vm.droits('suppression')) return;
            var confirm = $mdDialog.confirm()
                .title('Supprimer cette règle ?')
                .textContent('La règle « ' + regle.Libelle + ' » ne sera plus utilisée pour les prochains classements.')
                .targetEvent(event).theme('md-warn').ok('Supprimer').cancel('Annuler');
            $mdDialog.show(confirm).then(function ()
            {
                $http.post('/datas/reglesbanque/deleteRegle.json', {
                    IDRegleCategorisationBancaire: regle.IDRegleCategorisationBancaire
                }).then(function (response)
                {
                    if (response.data.error) return erreur(response);
                    vm.regles = response.data.data || [];
                    toast('La règle a été supprimée.');
                }, erreur);
            }, angular.noop);
        };

        function toast(message)
        {
            $mdToast.show($mdToast.simple().textContent(message).position('bottom right').hideDelay(4000));
        }

        function erreur(response)
        {
            var message = response && response.data && response.data.error && response.data.error.message;
            toast(message || 'Action impossible.');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.courriers.edition')
        .controller('CourrierEditionController', CourrierEditionController);
		
		angular.module('xeditable').factory('editableThemes', function() {
		  var themes = {
			//default
			'default': {
			  formTpl:      '<form class="editable-wrap"></form>',
			  noformTpl:    '<span class="editable-wrap"></span>',
			  controlsTpl:  '<span class="editable-controls"></span>',
			  inputTpl:     '',
			  errorTpl:     '<div class="editable-error" data-ng-if="$error" data-ng-bind-html="$error"></div>',
			  buttonsTpl:   '<span class="editable-buttons"></span>',
			  submitTpl:    '<button type="submit"><md-icon class="green-500-fg" md-font-icon="icon icon-checkbox-marked-circle"></md-icon></button>',
			  cancelTpl:    '<button type="button" ng-click="$form.$cancel()"><md-icon class="red-500-fg" md-font-icon="icon icon-close-circle"></md-icon></button>',
			  resetTpl:    '<button type="reset">clear</button>'
			}};

		  return themes;
		});



    /** @ngInject */
    function CourrierEditionController($scope, $document, $state, Courrier, Contacts, Employes, Villes, $mdToast,  $http, $element, $location, $mdDialog, $window, $sce)
    {
        var vm = this;
		

		vm.Etat = [
			{value: "0", text: 'En attente'},
			{value: "1", text: "Envoyé"}
		]; 
       
		vm.courrier = Courrier.data;
		vm.contacts = Contacts.data;
		vm.employes = Employes.data;
		vm.villes = Villes.data;
		
		
		if(!vm.courrier)
			vm.courrier = {};
		
		if(typeof vm.courrier.destinataires == "undefined")			
			vm.courrier.destinataires = {};
		
		if(typeof vm.courrier.destinataires.Type == "undefined")			
			vm.courrier.destinataires.Type = "Saisir";
		
		if(typeof vm.courrier.destinataires.Total == "undefined")		
			if(vm.courrier.destinataires.Type == "Saisir")
				vm.courrier.destinataires.Total = 1;
			else			
				vm.courrier.destinataires.Total = vm.contacts.length;
		
        /**
         * Save edition
         */
        vm.statutCourrier = function (ev) {
			if(vm.courrier.Envoye == 1){
				var confirm = $mdDialog.confirm()
					  .title('Souhaitez-vous marqué ce courrier comme envoyé ?')
					  .textContent('Une fois envoyé, vous ne pourrez plus le modifier.')
					  .targetEvent(ev)
					  .ok('Confirmer')
					  .cancel('Annuler');

				$mdDialog.show(confirm).then(function() {
					vm.saveCourrier();
				}, function() {
					vm.courrier.Envoye = 0;
				});
			}
			else
				vm.saveCourrier();
		}
		
		$scope.trustAsHtml = function(string) {
		return $sce.trustAsHtml(string);
	};

        vm.saveCourrier = function (ev) {
			$http.post("/datas/courriers/setCourrier.json",vm.courrier)
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					console.log(response);
					if(!vm.courrier.IDCourrier)
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Le courrier a été créé !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					else
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Le courrier a été modifié !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					
					vm.courrier = response.data.data;
					if(vm.courrier.Envoye == 1)					
						$state.go('app.courriers');
				}
			}, function () {});
	}
		
		vm.addDestinataire = function (ev)
        {
			
			$mdDialog.show({
				controller: 'DestinatairesCourrierDialogController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/courriers/courrier/dialogs/destinataires-dialog.html',
				parent             : angular.element(document.body),
				targetEvent        : ev,
				openFrom        : ev.currentTarget,
				clickOutsideToClose: true,
				locals             : {
					Contacts : vm.contacts,
					Destinataires : vm.courrier.destinataires,
					Employes: vm.employes,
					Villes: vm.villes
				}
			})
			.then(function(result) {
				if(typeof result != "undefined"){
					vm.courrier.destinataires = result;
					
					
					$http.post("/datas/courriers/setCourrier.json",JSON.stringify(vm.courrier))
					.then(function (response, status, headers, config) {
						if(response.data.error){
							$mdDialog.show(
							  $mdDialog.alert()
								.clickOutsideToClose(false)
								.title("Une erreur s'est produite")
								.textContent(response.data.error.message)
								.ok('OK')
							);
							vm.showSpinner = 0;
						}
						else{
							$mdToast.show(
							  $mdToast.simple()
								.textContent('Les destinataires ont été modifiés !')
								.position('bottom right' )
								.hideDelay(3000)
							);
						}
					}, function () {});
					
				}
			}, function() {
			});
		}	
		
		
		vm.editCourrier = function (ev, contenu, $type, Titre)
        {			
			$mdDialog.show({
				controller: 'CourrierDialogController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/courriers/courrier/dialogs/courrier-dialog.html',
				parent             : angular.element(document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				openFrom        : ev.currentTarget,
				locals             : {
					Contenu : contenu,
					Titre : Titre
				}
			})
			.then(function(result) {
				if(typeof result != "undefined"){
					vm.courrier[$type] = result;
					
					$http.post("/datas/courriers/setCourrier.json",JSON.stringify(vm.courrier))
					.then(function (response, status, headers, config) {
						if(response.data.error){
							$mdDialog.show(
							  $mdDialog.alert()
								.clickOutsideToClose(false)
								.title("Une erreur s'est produite")
								.textContent(response.data.error.message)
								.ok('OK')
							);
							vm.showSpinner = 0;
						}
						else{
					
							$mdToast.show(
							  $mdToast.simple()
								.textContent('Le contenu a été modifié !')
								.position('bottom right' )
								.hideDelay(3000)
							);
						}
					}, function () {});
				}
			}, function() {
			});
		}	
		
        vm.generateCourrier = function (ev)
        {
			var confirm = $mdDialog.confirm()
				.title('Comment souhaitez-vous générer le courrier ?')
				.targetEvent(ev)
				.ok('Avec adresses')
				.cancel('Sans adresse');

			$mdDialog.show(confirm).then(function() {
				var lien = "/datas/courriers/generer.json?IDCourrier="+vm.courrier.IDCourrier;
				$window.open(lien, '_blank');		
			}, function() {
				var lien = "/datas/courriers/generer.json?sansAdresse=1&IDCourrier="+vm.courrier.IDCourrier;
				$window.open(lien, '_blank');		
			});
			
        }
        
        vm.apercuCourrier = function (ev)
        {
			var apercu = "";
			
			if(apercu == true)
				var apercu = "&apercu=1";
			
			var lien = "/datas/courriers/generer.json?apercu=1&IDCourrier="+vm.courrier.IDCourrier + apercu;
			$window.open(lien, '_blank');				
        }
        
        /**
         * Go to editions page
         */
        vm.gotoCourriers = function ()
        {
			$state.go('app.courriers');
        }

		
		
    }
	
})();
(function ()
{
    'use strict';

    angular
        .module('app.courriers.courriers')
        .controller('CourriersController', CourriersController)
		.filter('DateFormat', function myDateFormat($filter){
		  return function(text){
			var  tempdate= new Date(text);
			return $filter('date')(tempdate, "dd/MM/yyyy HH:mm");
		  }
		});
    /** @ngInject */
    function CourriersController($scope, Courriers, msUtils, $rootScope, $mdDialog, $mdToast, $document, $mdMenu, $location, $http, $window)
    {
        var vm = this;

        // Data
        vm.courriers = Courriers.data;

		vm.go = function (url){
			$location.path(url);
		}
	
		
        vm.generateCourrier = function (courrier)
        {
			var lien = "/datas/courriers/generer.json?IDCourrier="+courrier.IDCourrier;
			$window.open(lien, '_blank');				
        }
		
		vm.dupliquerCourrier = function (courrier){
			$http.post("/datas/courriers/dupliquer.json", JSON.stringify(courrier))
			.then(function (response, status, headers, config) {
				vm.courriers = response.data.data;
			}, function () {});
		}
		
		vm.apercuCourrier = function (ev, courrier){
			$mdDialog.show({
                parent             : angular.element(document.body),
                targetEvent        : ev,
                controller         : 'CourriersDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/courriers/courriers/dialogs/apercu-dialog.html',
                clickOutsideToClose: true,
                locals             : {
					Courrier : courrier
                }
            });
		}
		
		vm.apercuDestinataires = function (ev, courrier){
			$mdDialog.show({
                parent             : angular.element(document.body),
                targetEvent        : ev,
                controller         : 'DestinatairesCourriersDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/courriers/courriers/dialogs/destinataires-dialog.html',
                clickOutsideToClose: true,
                locals             : {
					Courrier : courrier
                }
            });
		}
		
		vm.supprimercourriers = function (ev, courrier){
			var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer ce courrier ?')
                .htmlContent('<b>' + courrier.Objet + '</b>' + ' va être supprimé.')
                .ariaLabel('Supprimer un courrier')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				vm.courriers.splice(vm.courriers.indexOf(courrier), 1);
				$http.post("/datas/courriers/supprimer.json", JSON.stringify(courrier));
				$mdToast.show(
				  $mdToast.simple()
					.textContent('Courrier supprimé définitivement.')
					.position('bottom right' )
					.hideDelay(3000)
				);
            });
		}

		
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.profil')
        .controller('profilContactController', profilContactController)
		.filter('DateFormat', function myDateFormat($filter){
		  return function(text){
			var  tempdate= new Date(text);
			return $filter('date')(tempdate, "dd/MM/yyyy HH:mm");
		  }
		});

    /** @ngInject */
    function profilContactController(Contact, Structures, employesSimple, Fabricants, APE, Activites/*, Commandes/* , Alertes */, $mdSidenav, Dialog, Courriers, Employes, $rootScope, $mdToast, $location, $mdDialog, $document, $http, $scope, $element, $filter, $window, $state, DTColumnBuilder, DTOptionsBuilder, $compile)
    {
        var vm = this;
		vm.rows = [];

		if(typeof Contact.data != "undefined")
			vm.contact = Contact.data;
		else
			vm.contact = Contact;
		
		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		vm.idUser = $rootScope.id;
        vm.structures = Structures.data;
        vm.APE = APE.data;
        vm.Activites = Activites.data;
		vm.text_add_get = "";
        // vm.commandes = Commandes.data;
        vm.courriers = Courriers.data;
        /* vm.alertes = Alertes.data; */
        vm.employes = Employes.data;
		vm.dialog = Dialog;
        vm.loader = 1;
		
		if(Dialog){

			$http.get("/datas/contacts/getStructures.json").then(function (response, status, headers, config) {
				vm.structures = response.data.data;
			}, function () {});
			$http.get("/datas/contacts/getAPE.json").then(function (response, status, headers, config) {
				vm.APE = response.data.data;
			}, function () {});
			$http.get("/datas/contacts/getActivites.json").then(function (response, status, headers, config) {
				vm.Activites = response.data.data;
			}, function () {});
			$http.get("/datas/employes/getEmployes.json").then(function (response, status, headers, config) {
				vm.employes = response.data.data;
			}, function () {});
			
			$http.post("/datas/contacts/details.json", JSON.stringify({'IDContact': Contact.IDContact})).then(function (response, status, headers, config) {
				vm.contact = response.data.data;
				vm.loader = 0;
			}, function () {});
			/* $http.post("/datas/commandes/getAllcommandes.json", JSON.stringify({'IDContact': Contact.IDContact, 'Commandes': "all"})).then(function (response, status, headers, config) {
				vm.commandes = response.data.data;
			}, function () {}); */
			$http.post("/datas/courriers/getCourriers.json", JSON.stringify({'IDContact': Contact.IDContact})).then(function (response, status, headers, config) {
				vm.courriers = response.data.data;
			}, function () {});
			// $http.post("/datas/alertes/getAlertes.json", JSON.stringify({'IDContact': Contact.IDContact})).then(function (response, status, headers, config) {
				// vm.alertes = response.data.data;
			// }, function () {});
		}
	// console.log(Dialog);
	// console.log(Contact);
	// console.log(vm.contact);
			// console.log(vm.commandes);
        // msApiProvider.register('profilContact.details', ['/datas/contacts/details.json']);
        // msApiProvider.register('commandes.commandes', ['datas/commandes/getAllcommandes.json']);
        // msApiProvider.register('courriers.courriers', ['datas/courriers/getCourriers.json']);
		
		
		
		
		vm.toggleSidenav = function (sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		vm.setRenouvelee = function(commande){$http.post("/datas/commandes/setRenouvelee.json",JSON.stringify({'IDCommande':commande})).then(function (response, status, headers, config) {  vm.dtInstanceCommandesProfils.reloadData();}, function () {});}
		vm.setNonRenouvelee = function(commande){$http.post("/datas/commandes/setNonRenouvelee.json",JSON.stringify({'IDCommande':commande})).then(function (response, status, headers, config) {  vm.dtInstanceCommandesProfils.reloadData();}, function () {});}
		
        
		vm.go = function(url){$location.path(url);vm.cancel();};
		
		function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
		
		
		$scope.frequences = [
			{value: 0, text: 'Aucun'},
			{value: 1, text: 'Tous les mois'},
			{value: 2, text: 'Tous les 2 mois'},
			{value: 3, text: 'Tous les 3 mois'},
			{value: 4, text: 'Tous les 4 mois'},
			{value: 6, text: 'Tous les 6 mois'},
			{value: 12, text: 'Tous les 12 mois'}
		]; 

		$scope.showBilanFrequence = function() {
			var selected = $filter('filter')($scope.frequences, {value: vm.contact.Bilan});
			return (vm.contact.Bilan && selected.length) ? selected[0].text : 'Aucun';
		};
  
		$scope.searchTerm;
		$scope.clearSearchTerm = function() {
		$scope.searchTerm = '';
		};
		$element.find('input').on('keydown', function(ev) {
		  ev.stopPropagation();
		});

		vm.editOptions = function(ev, IDCommande){
			
		
			$http.get("/datas/commandes/getCommande.json?IDCommande="+IDCommande)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					parent             : angular.element("#profil-dialog"),
					targetEvent        : ev,
					controller         : 'DialogOptionsCommandeController',
					controllerAs       : 'vm',
					multiple : true,
					templateUrl        : 'app/main/commandes/commandes/dialogs/options-commande-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande :response.data.data
					}
				}).then(function(result) {
					 vm.dtInstanceCommandesProfils.reloadData();
				}, function () {});	
			}, function () {});
		}
		
		vm.getFactureAcompte = function (ev, commande){
			
			$http.get("/datas/commandes/getCommande.json?IDCommande="+commande)
			.then(function (response, status, headers, config) {
				// console.log(response.data.data);
				$mdDialog.show({
					 parent             : angular.element("#profil-dialog"),
					targetEvent        : ev,
					controller         : 'DialogFactureAcompteController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commandes/dialogs/acompte-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande : response.data.data,
						Paiements : response.data.data.paiements,
						dtInstanceCommandesProfils : vm.dtInstanceCommandesProfils
					}
				});
				
					 // vm.dtInstanceCommandesProfils.reloadData();
			}, function () {});
		}
/* 
		vm.getFactureAcompte = function (ev, Paiements, commande){
			$mdDialog.show({
				 parent             : angular.element("#profil-dialog"),
                targetEvent        : ev,
				multiple:true,
                controller         : 'DialogFactureAcompteController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/commandes/dialogs/acompte-dialog.html',
                clickOutsideToClose: true,
                locals             : {
					Paiements : Paiements,
					Commande : commande,
					dtInstanceCommandesProfils : vm.dtInstanceCommandesProfils
                }
			});
		}
		 */

		vm.deleteCommande = function (ev, commande, NumeroCommande)
        {
			var commandeObj = {IDCommande:commande};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer cette commande ?')
                .htmlContent('<b>La commande N°' + NumeroCommande + '</b>' + ' va être supprimée.')
                .ariaLabel('Supprimer une commande')
                .targetEvent(ev)
				.multiple(true)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/commandes/deleteCommande.json", JSON.stringify(commandeObj)).then(function (response, status, headers, config) {  
					if(response.data.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.title("Une erreur s'est produite")
							.textContent(response.data.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.dtInstanceCommandesProfils.reloadData();
						$mdToast.show(
						  $mdToast.simple()
							.textContent('La commande a été supprimée.')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				
				}, function () {});
				
            });
        }
		
		
		
		vm.apercuCourrier = function (ev, courrier){
			$mdDialog.show({
                parent             : angular.element("#profil-dialog"),
                targetEvent        : ev,
                controller         : 'CourriersDialogController',
                controllerAs       : 'vm',
				multiple :true,
                templateUrl        : 'app/main/courriers/courriers/dialogs/apercu-dialog.html',
                clickOutsideToClose: true,
                locals             : {
					Courrier : courrier
                }
            });
		}
		
		vm.apercuDestinataires = function (ev, courrier){
			$mdDialog.show({
                parent             : angular.element("#profil-dialog"),
                targetEvent        : ev,
                controller         : 'DestinatairesCourriersDialogController',
                controllerAs       : 'vm',
				multiple :true,
                templateUrl        : 'app/main/courriers/courriers/dialogs/destinataires-dialog.html',
                clickOutsideToClose: true,
                locals             : {
					Courrier : courrier
                }
            });
		}
		
		vm.dtInstanceCommandesProfils = {};
		vm.dtOptionsCommandesProfils = DTOptionsBuilder.newOptions()
		.withOption('ajax', {
			 dataSrc: 'data',
			 url: 'datas/commandes/getAllcommandes.json?IDContact='+vm.contact.IDContact+'&Commandes=all',
			 type: 'GET'
		})
		.withDataProp('data')
		.withOption('processing', true)
		.withOption('serverSide', true)
		.withOption('bStateSave', true)
		.withOption('iCookieDuration', 60*60*12)
		.withOption('stateSaveCallback', function (oSettings, oData) {
			localStorage.setItem( 'DataTablesCommandesProfil', JSON.stringify(oData) );
		})
		.withOption('drawCallback', function (o) {
		/* 	  $('.scrollable').animate({  ??? GENANT D'APRES COLLABORATEURS
				scrollTop: 0
			  }, 'slow'); */
		})
		.withOption('stateLoadCallback', function (oSettings) {
			return JSON.parse( localStorage.getItem('DataTablesCommandesProfil') );
		})
		.withOption('stateLoadParams', function( settings, data ) {
			vm.search= data.search.search;
			vm.filterSave = data.columns;
		})
		.withOption('columnDefs',   [
			{
				// Target the id column
				targets: 0,
				responsivePriority: 1,
			},
			{
				// Target the id column
				targets: 1,
				responsivePriority: 1,
			},
			{
				// Target the id column
				targets: 2,
				render : function (data, type)
				{
					if ( type === 'display' )
					{
						return convertDate(data);
					}

					return data;
				}
			},
			{
				// Target the price column
				targets: 4,
				"type": "num-fmt",
				render : function (data, type)
				{
					if ( type === 'display' )
					{
						return formatter.format(data);
					}

					return data;
				}
			},  
			{
				// Target the price column
				targets: 5,
				"type": "num-fmt",
				render : function (data, type)
				{
					if ( type === 'display' )
					{
						return formatter.format(data);
					}

					return data;
				}
			},        {
				// Target the actions column
				targets           : 8,
				responsivePriority: 1,
				filterable        : false,
				sortable          : false
			}
		])
		.withOption('responsive', {
			details: {
				display: $.fn.dataTable.Responsive.display.childRowImmediate,
				type: 'none',
				target: ''
			}
		})
		.withOption('pagingType', 'simple')
		.withOption('lengthMenu', [50, 100, 250])
		.withPaginationType('simple')
		.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
		.withOption('createdRow', function(row, data, dataIndex) {
			// Recompiling so we can bind Angular directive to the DT
			// console.log(row);
			$compile(angular.element(row).contents())($scope);
		})
		.withOption('headerCallback', function(header) {
			if (!vm.headerCompiled) {
				// Use this headerCompiled field to only compile header once
				vm.headerCompiled = true;
				$compile(angular.element(header).contents())($scope);
			}
		})
		.withOption('initComplete', function(settings, json) {
			var api = this.api();
				vm.searchBox = angular.element('body').find('#commandes-search');

			angular.forEach(vm.filterSave, function(value, key) {
				var cpt = key+1;
				if(value.search.search.includes("~")){
					jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
					jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
					
				} else{
					jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
					jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
				}
			}); 				
			
			if ( vm.searchBox.length > 0 )
			{
				var timeout = null;
				
				vm.searchBox.on('keyup', function (event)
				{
					clearTimeout(timeout);
					timeout = setTimeout(function () {
						api.search(vm.search).draw();
					}, 500);
				});
			}
			
			vm.recordsTotal = json.recordsTotal;
		  }
		)
		
		  
		.withLanguage({
		  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
		  'processing':'test',
			"sSearch":         "Rechercher&nbsp;:",
			"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
			"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
			"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
			"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			"sInfoPostFix":    "",
			"sLoadingRecords": "Chargement en cours...",
			"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
			"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
			"oPaginate": {
				"sFirst":      "Premier",
				"sPrevious":   "Pr&eacute;c&eacute;dent",
				"sNext":       "Suivant",
				"sLast":       "Dernier"
			},
			"oAria": {
				"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
				"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
			}
		})
		.withOption('fnRowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			 // $('td', nRow).unbind('click');
				// $('td', nRow).bind('click', function() {
				// console.log(nRow);
				// openContactDialog(aData);
				  // $scope.$apply(function() {
					// vm.expend(nRow, aData);
				// });  
			// });
			// return nRow;
		})
		.withOption('order', [0, 'desc']);


		vm.dtColumnsCommandesProfils = [
			DTColumnBuilder.newColumn('NumeroCommande').withTitle('<div class="table-header"><span class="column-title">N° Commande</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				var html = data;
				
				if(full.ComConsultants == 1)
					html += '<br><span class="blue-600-fg">Com-Consultants le '+convertDate(full.DateFacturation)+'</span>';	
				
				if(full.NumeroFacture)
					html += '<br><span> '+full.NumeroFacture+' - '+convertDate(full.DateFacturation)+'</span>';	
				
				// if(full.NomCommande && full.Etat != 'Facturée')
				if(full.NomCommande)
					html += '<em><br> '+full.NomCommande+'</em>';	
				
				return html;
			}),
			/* DTColumnBuilder.newColumn('NumeroFacture').withTitle('<div class="table-header"><span class="column-title">N° Facture</div></div>').withOption('width', '80px').renderWith(function(data, type, full){
				var html = "";
				
				
				if(full.NumeroFacture)
					html += data+'<br>'+convertDate(full.DateFacturation)+'</span>';	
				
				
				return html;
			}), */
			DTColumnBuilder.newColumn('RaisonSocial').withTitle('<div class="table-header"><span class="column-title">Client</div></div>').renderWith(function(data, type, full, meta ){
				return full.RaisonSocial;
			}),
			DTColumnBuilder.newColumn('DateCreation').withTitle('<div class="table-header"><span class="column-title">Date de création</div></div>').withOption('width', '120px').renderWith(function(data, type, full, meta ){
				if(data!="0000-00-00" && data != "1970-01-01")
					return convertDate(data);
				else
					return "";
			}),
			DTColumnBuilder.newColumn('IDEmploye').withTitle('<div class="table-header"><span class="column-title">Commercial</div></div>').withOption('width', '220px').renderWith(function(data, type, full, meta ){
			
				vm.rows[meta.row] = full;
				
				if ( type === 'display' ){
					var html ="";
						if(full.CommercialSupprime=="1")
							html += '<span class="grey-600-fg">'+full.Commercial+'<md-tooltip md-direction="left" >Compte supprimé</md-tooltip></span>';
						else{
							if(full.CommercialNonModifiable)
								html += '<span>'+full.Commercial+'</span>';
							else
								html += '<a href="#" editable-select="vm.rows['+meta.row+'].IDEmploye"  onaftersave="vm.saveCommercialCommandes('+meta.row+')" e-ng-options="s.IDEmploye.toString() as s.Civilite+\' \'+s.Prenom+\' \'+s.Nom for s in vm.employes"><span ng-bind-html="vm.showEmployes('+full.IDEmploye+')"></span></a>';
						}
				   return html;
				}
				return data;
			}),
			DTColumnBuilder.newColumn('MargeBrutHT').withTitle('<div class="table-header"><span class="column-title">Marge HT</div></div>').withOption('width', '100px'),
			DTColumnBuilder.newColumn('TotalHTRemise').withTitle('<div class="table-header"><span class="column-title">Total HT</div></div>').withOption('width', '100px'),
			DTColumnBuilder.newColumn('DateRenouvellement').withTitle('<div class="table-header"><span class="column-title">Date Renouv.</div></div>').withOption('width', '130px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					/*var html ="";
						
						switch(data){
							case "Brouillon": html = '<span class="p-5 pr-8 pl-8 brad-16 md-amber-500-bg white-fg" selected="true"><small>Brouillon</small></span>'; break;
							case "Annulée": html = '<span class="p-5 pr-8 pl-8 brad-16 grey-500-bg white-fg" selected="true"><small>Annulée</small></span>'; break;
							case "En attente": html = '<span class="p-5 pr-8 pl-8 brad-16 md-warn-bg white-fg" selected="true"><small>En attente</small></span>'; break;
							case "Validée": html = '<span class="p-5 pr-8 pl-8 brad-16 md-grey-500-bg white-fg" selected="true"><small>Validée</small></span>'; break;
							case "Signée": html = '<span class="p-5 pr-8 pl-8 brad-16 md-blue-grey-500-bg white-fg" nselected="true"><small>Signée</small></span>'; break;
							case "Com-Consultants": html = '<span class="p-5 pr-8 pl-8 brad-16 md-blue-500-bg white-fg" selected="true"><small>Com-Consultants le '+convertDate(full.DateFacturation)+'</small></span>'; break;
							case "Facturée": html = '<span class="p-5 pr-8 pl-8 brad-16 md-green-bg white-fg" selected="true"><small>Facturée le '+convertDate(full.DateFacturation)+'</small></span>'; break;
						}*/
					var timestamp = new Date().getTime() + (30 * 24 * 60 * 60 * 1000);
					var date = new Date(data);
					var dateDay = new Date();
					
					if(data!="0000-00-00" && data != "1970-01-01")
						if(full.Renouvellement != 1)
							if (dateDay >= date)
								return "<span class='red-700-fg'>"+convertDate(data)+"</span>";
							else if (timestamp > date)
								return "<span class='amber-700-fg'>"+convertDate(data)+"</span>";
							else
								return "<span>"+convertDate(data)+"</span>";
						else
							return "<span>"+convertDate(data)+"</span>";
					else
						return "";
				}
				return data;
			}),
			DTColumnBuilder.newColumn('EtatAffiche').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
						
						switch(data){
							case "Brouillon": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-amber-600-bg white-fg" ><small>Brouillon</small></span>'; break;
							case "Annulée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 grey-500-bg white-fg" ><small>Annulée</small></span>'; break;
							case "En attente": html = '<span class="tag p-5 pr-8 pl-8 brad-16 red-600-bg white-fg" ><small>En attente</small></span>'; break;
							case "Validée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-cyan-700-bg white-fg" ><small>Validée</small></span>'; break;
							case "Signée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-teal-600-bg white-fg" ><small>Signée</small></span>'; break;
							case "Com-Consultants": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-blue-500-bg white-fg" ><small>Com-Consultants le '+convertDate(full.DateFacturation)+'</small></span>'; break;
							case "Facturée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-green-bg white-fg" ><small>Facturée</small></span>'; break;
							case "Renouvelée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-green-900-bg white-fg" ><small>Renouvelée</small></span>'; break;
							case "A renouveler": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-orange-600-bg white-fg" ><small>A renouveler</small></span>'; break;
							case "Non renouvelée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-red-900-bg md-hue-2 white-fg" ><small>Non renouvelée</small></span>'; break;
						}
				   return html;
				}
				return data;
			}),
			DTColumnBuilder.newColumn('IDCommande').withTitle('<div class="table-header"><span class="column-title"></div></div>').withOption('width', '60px').renderWith(function(data, type, full){
				
				if(full.Prelevement == 1 && full.IDCommande_IBAN==0)
					var prelevement = 1;
				else
					var prelevement = 0;
			
				
				var html = '<md-menu style="float: right;">'+
						'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
							'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
						'</md-button>'+
						'<md-menu-content width="3">';
						
				html += '<md-menu-item>'+ 
							'<md-button ng-click="vm.DetailsCommande($event, '+full.IDCommande+')">'+ 
								'Aperçu commande'+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-divider >'+'</md-divider>';
				html += '<md-menu-item>'+
							'<md-button '+ ((full.Etat=='Facturée' || (full.Etat=='Signée' && full.Paiements.length <= 1) || full.Etat=='A renouveler' || full.Etat=='Renouvelée' || full.Etat=='Non renouvelée') ? "disabled":"") +' ng-click="vm.editCommande('+full.IDCommande+')">'+
								'Modifier'+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-menu-item>'+
							'<md-button ng-click="vm.dupliqueCommande('+full.IDCommande+')">'+
								'Dupliquer'+
							'</md-button>'+
						'</md-menu-item>';
						
				if($rootScope.Permission=='Super Admin')
				html += '<md-menu-item >'+
							'<md-button ng-click="vm.editOptions($event, '+full.IDCommande+')">'+
								'Options'+
							'</md-button>'+
						'</md-menu-item>';
						
						
						
				if(full.Etat=='Brouillon')
				html += 
						'<md-divider >'+'</md-divider>'+
						'<md-menu-item  >'+
							'<md-button ng-click="vm.deleteCommande($event, '+full.IDCommande+', '+full.NumeroCommande+')">'+
								'Supprimer'+
							'</md-button>'+
						'</md-menu-item>';
						
			
				
				if(full.Etat!="Brouillon"){		
					html += '<md-divider >'+'</md-divider>';
						
	 
					if(full.DateRenouvellement!="0000-00-00" && full.DateRenouvellement != "1970-01-01")
						html += '<md-menu-item>'+
									'<md-menu>'+
										'<md-button ng-click="$mdMenu.open()">Renouvellement</md-button>'+
										'<md-menu-content>'+
											'<md-menu-item >'+
												'<md-button '+ ((full.Renouvellement == 1) ? "disabled":"") +' ng-click="vm.setRenouvelee('+full.IDCommande+')" >'+
													'Passer en renouvelée'+
												'</md-button>'+
											'</md-menu-item>'+
											'<md-menu-item >'+
												'<md-button '+ ((full.Renouvellement == 2) ? "disabled":"") +' ng-click="vm.setNonRenouvelee('+full.IDCommande+')">'+
													'Passer en non-renouvelée'+
												'</md-button>'+
											'</md-menu-item>'+
										'</md-menu-content>'+
									'</md-menu>'+
								'</md-menu-item>'+
								'<md-divider ></md-divider>';
						
					html += '<md-menu-item>'+
								'<md-menu>'+
									'<md-button ng-click="$mdMenu.open()">Documents</md-button>'+
									'<md-menu-content>';
									
										if(full.Etat!='Facturée' && full.Etat!='Signée' && full.Etat!='Brouillon' && full.TotalTTC>=0)
										html += '<md-menu-item >'+
													'<md-button ng-click="vm.getDevis($event,'+full.IDCommande+', '+prelevement+')">'+
														'Générer le devis'+
													'</md-button>'+
												'</md-menu-item>';	
												
										if((full.Etat=='Facturée' || full.Etat=='Signée')){
										html += '<md-menu-item >'+
													'<md-button target=" _blank" ng-click="vm.getDevisSigne($event,'+full.IDCommande+', \''+full.NumeroCommande+'\')" ';
													
													if(full.DevisSigne!=true)
														html += 'disabled';
													
													html += '>'+
														'Voir le devis signé'+
													'</md-button>'+
												'</md-menu-item>';						
										}
													
										if(full.Etat!='Facturée' && full.Paiements.length<= 1 && full.Etat!='Brouillon' && full.TotalTTC<0)
										html += '<md-menu-item >'+
													'<md-button '+ ((full.Etat!='Signée' && full.Etat!='Validée') ? "disabled":"") +' ng-click="vm.getFacture(event, '+full.IDCommande+', \''+full.DateRenouvellement+'\', \''+full.Etat+'\', \''+full.DateFacturation+'\', \''+full.TotalTTC+'\')">'+
														"Générer l'avoir"+
													'</md-button>'+
												'</md-menu-item>';
												
										if(full.Etat!='Facturée' && full.Paiements.length <= 1 && full.Etat!='Brouillon'  && full.TotalTTC>=0)
										html += '<md-menu-item >'+
													'<md-button '+ ((full.Etat!='Signée' && full.Etat!='Validée') ? "disabled":"") +' ng-click="vm.getFacture(event, '+full.IDCommande+', \''+full.DateRenouvellement+'\', \''+full.Etat+'\', \''+full.DateFacturation+'\', '+full.TotalTTC+')">'+
														'Générer la facture'+
													'</md-button>'+
												'</md-menu-item>'; 
												
										if(full.Paiements.length > 1 && full.Etat!='Brouillon')
										html += '<md-menu-item  >'+
													'<md-button '+ ((full.Etat!='Signée' && full.Etat!='Validée' && full.Etat!='Facturée') ? "disabled":"") +' ng-click="vm.getFactureAcompte(event, '+full.IDCommande+', '+prelevement+')">'+
														'Facturations'+
													'</md-button>'+
												'</md-menu-item>'; 
										
										if(full.Etat=='Facturée' && full.Paiements.length <= 1 && full.Etat!='Brouillon')
										html += '<md-menu-item >'+
													'<md-button ng-click="vm.getFacture(event, '+full.IDCommande+', \''+full.DateRenouvellement+'\', \''+full.Etat+'\', \''+full.DateFacturation+'\', \''+full.TotalTTC+'\')">'+
														'Télécharger la facture'+
													'</md-button>'+
												'</md-menu-item>';
					
					html +=				'</md-menu-content>'+
								'</md-menu>'+
							'</md-menu-item>';
				}
				html += '</md-menu-content>'+'</md-menu>';
				return html;
			}),
		];
			
			
			
		vm.dtInstanceProduitsProfils = {};
		vm.dtOptionsProduitsProfils = DTOptionsBuilder.newOptions()
		.withOption('ajax', {
			 dataSrc: 'datas',
			 url: 'datas/commandes/getAllProductsContacts.json?IDContact='+vm.contact.IDContact,
			 type: 'GET'
		})
		.withDataProp('datas')
		.withOption('processing', true)
		.withOption('serverSide', true)
		.withOption('bStateSave', true)
		.withOption('iCookieDuration', 60*60*12)
		.withOption('stateSaveCallback', function (oSettings, oData) {
			localStorage.setItem( 'DataTablesProduitsProfil', JSON.stringify(oData) );
		})
		.withOption('drawCallback', function (o) {
		/* 	  $('.scrollable').animate({  ??? GENANT D'APRES COLLABORATEURS
				scrollTop: 0
			  }, 'slow'); */
		})
		.withOption('stateLoadCallback', function (oSettings) {
			return JSON.parse( localStorage.getItem('DataTablesProduitsProfil') );
		})
		.withOption('stateLoadParams', function( settings, data ) {
			vm.search= data.search.search;
			vm.filterSave = data.columns;
		})
		.withOption('columnDefs',   [
			{
				// Target the id column
				targets: 0,
				responsivePriority: 1,
			},
			// {
				// Target the id column
				// targets: 1,
				// responsivePriority: 1,
			// },
			{
				// Target the id column
				targets: 2,
				render : function (data, type)
				{
					if ( type === 'display' )
					{
						return convertDate(data);
					}

					return data;
				}
			},
			{
				// Target the price column
				targets: 4,
				"type": "num-fmt",
				render : function (data, type)
				{
					if ( type === 'display' )
					{
						return formatter.format(data);
					}

					return data;
				}
			},  
			{
				// Target the price column
				targets: 5,
				"type": "num-fmt",
				render : function (data, type)
				{
					if ( type === 'display' )
					{
						return formatter.format(data);
					}

					return data;
				}
			},        {
				// Target the actions column
				targets           : 7,
				responsivePriority: 1,
				filterable        : false,
				sortable          : false
			}
		]) 
		.withOption('responsive', {
			details: {
				display: $.fn.dataTable.Responsive.display.childRowImmediate,
				type: 'none',
				target: ''
			}
		})
		.withOption('pagingType', 'simple')
		.withOption('lengthMenu', [50, 100, 250])
		.withPaginationType('simple')
		.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
		.withOption('createdRow', function(row, data, dataIndex) {
			
			$compile(angular.element(row).contents())($scope);
		})
		
		.withOption('drawCallback', function(settings, json) {
				var api = this.api();
				vm.recordsProduitsEnCours = api.ajax.json().recordsProduitsEnCours;
			}
		)
		.withOption('headerCallback', function(header) {
			if (!vm.headerCompiled) {
				// Use this headerCompiled field to only compile header once
				vm.headerCompiled = true;
				$compile(angular.element(header).contents())($scope);
			}
		})
		.withOption('initComplete', function(settings, json) {
			/* var api = this.api();
				vm.searchBox = angular.element('body').find('#commandes-search');

			angular.forEach(vm.filterSave, function(value, key) {
				var cpt = key+1;
				if(value.search.search.includes("~")){
					jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
					jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
					
				} else{
					jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
					jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
				}
			}); 				
			
			if ( vm.searchBox.length > 0 )
			{
				var timeout = null;
				
				vm.searchBox.on('keyup', function (event)
				{
					clearTimeout(timeout);
					timeout = setTimeout(function () {
						api.search(vm.search).draw();
					}, 500);
				});
			}
			
			vm.recordsTotal = json.recordsTotal;*/
		  } 
		)
		
		  
		.withLanguage({
		  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
		  'processing':'test',
			"sSearch":         "Rechercher&nbsp;:",
			"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
			"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
			"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
			"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			"sInfoPostFix":    "",
			"sLoadingRecords": "Chargement en cours...",
			"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
			"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
			"oPaginate": {
				"sFirst":      "Premier",
				"sPrevious":   "Pr&eacute;c&eacute;dent",
				"sNext":       "Suivant",
				"sLast":       "Dernier"
			},
			"oAria": {
				"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
				"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
			}
		})
		.withOption('fnRowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			 // $('td', nRow).unbind('click');
				// $('td', nRow).bind('click', function() {
				// console.log(nRow);
				// openContactDialog(aData);
				  // $scope.$apply(function() {
					// vm.expend(nRow, aData);
				// });  
			// });
			// return nRow;
		})
		.withOption('order', [5, 'desc']);


		vm.dtColumnsProduitsProfils = [
			DTColumnBuilder.newColumn('NumeroCommande').withTitle('<div class="table-header"><span class="column-title">N° Commande</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				var html = '<a ng-click="vm.DetailsCommande($event, '+full.IDCommande+')" href="#">'+data+"</a>"
				// console.log(data);
				if(full.ComConsultants == 1)
					html += '<br><span class="blue-600-fg">Com-Consultants le '+convertDate(full.DateFacturation)+'</span>';	
				
				if(full.NumeroFacture)
					html += '<br><span> '+full.NumeroFacture+' - '+convertDate(full.DateFacturation)+'</span>';	
				
				// if(full.NomCommande && full.Etat != 'Facturée')
				if(full.NomCommande)
					html += '<em><br> '+full.NomCommande+'</em>';	
				
				return html;
			}),
			/* DTColumnBuilder.newColumn('NumeroFacture').withTitle('<div class="table-header"><span class="column-title">N° Facture</div></div>').withOption('width', '80px').renderWith(function(data, type, full){
				var html = "";
				
				
				if(full.NumeroFacture)
					html += data+'<br>'+convertDate(full.DateFacturation)+'</span>';	
				
				
				return html;
			}), */
			DTColumnBuilder.newColumn('Produit').withTitle('<div class="table-header"><span class="column-title">Produit</div></div>').renderWith(function(data, type, full, meta ){
				var html = full.Quantite +" X "+  full.Produit;
				// if(full.EtatProduit != 1)
				if(full.EtatProduit == null)		
					html += ' <small class="tag p-5 pr-8 pl-8 ml-8 brad-16 md-grey-bg white-fg" ><small>Ocasionnel</small></small>';
				if(full.EtatProduit == 0)
					html += ' <small class="tag p-5 pr-8 pl-8 ml-8 brad-16 md-red-900-bg md-hue-2 white-fg" ><small>Non dispo.</small></small>';
				
				return html;
			}),
			/* DTColumnBuilder.newColumn('RaisonSocial').withTitle('<div class="table-header"><span class="column-title">Contact</div></div>').renderWith(function(data, type, full, meta ){
				return full.RaisonSocial;
			}), */
			DTColumnBuilder.newColumn('Commercial').withTitle('<div class="table-header"><span class="column-title">Commercial</div></div>').withOption('width', '220px').renderWith(function(data, type, full, meta ){
			
				vm.rows[meta.row] = full;
				
				if ( type === 'display' ){
					var html ="";
						if(full.CommercialSupprime=="1")
							html += '<span class="grey-600-fg">'+full.Commercial+'<md-tooltip md-direction="left" >Compte supprimé</md-tooltip></span>';
						else{
							// if(full.CommercialNonModifiable)
								html += '<span>'+full.Commercial+'</span>';
							// else
								// html += '<a href="#" editable-select="vm.rows['+meta.row+'].IDEmploye"  onaftersave="vm.saveCommercialCommandes('+meta.row+')" e-ng-options="s.IDEmploye.toString() as s.Civilite+\' \'+s.Prenom+\' \'+s.Nom for s in vm.employes"><span ng-bind-html="vm.showEmployes('+full.IDEmploye+')"></span></a>';
						}
				   return html;
				}
				return data;
			}),
			DTColumnBuilder.newColumn('PrixVenteFinalHT').withTitle('<div class="table-header"><span class="column-title">Prix vente HT</div></div>').withOption('width', '100px').renderWith(function(data, type, full, meta ){
				if(parseInt(full.PrixVenteHTDefault) > parseInt(full.PrixVenteFinalHT))
					return full.PrixVenteFinalHT+" € <del class='red-900-fg'><small>"+full.PrixVenteHTDefault+" €</small></del>";
				else
					return full.PrixVenteFinalHT+" €";
			}),
			/* DTColumnBuilder.newColumn('Quantite').withTitle('<div class="table-header"><span class="column-title">Quantite</div></div>').renderWith(function(data, type, full, meta ){
				return full.Quantite;
			}), */
			DTColumnBuilder.newColumn('Renouvellement').withTitle('<div class="table-header"><span class="column-title">Mensualités</div></div>').renderWith(function(data, type, full, meta ){
				if(full.Renouvellement > 0)
					return full.Renouvellement +" mois";
				else
					return "--";
			}),
			 DTColumnBuilder.newColumn('DateRenouvellement').withTitle('<div class="table-header"><span class="column-title">Date de fin</div></div>').withOption('width', '120px').renderWith(function(data, type, full, meta ){
				if(data!="0000-00-00" && data != "1970-01-01")
					return convertDate(data);
				else
					return "--";
			}),
		 	
		 	DTColumnBuilder.newColumn('EtatCommande').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '100px').renderWith(function(data, type, full, meta ){
				if(full.Renouvellement > 0)
					if(data == 0)
						return '<small class="tag p-5 pr-8 pl-8 brad-16 md-blue-bg md-hue-2 white-fg" ><small>En cours</small></small>';
					else
						return '<small class="tag p-5 pr-8 pl-8 brad-16 md-grey-bg md-hue-2 white-fg" ><small>Terminé</small></small>';
				else
					return '<small class="tag p-5 pr-8 pl-8 brad-16 md-grey-bg md-hue-2 white-fg" ><small>Terminé</small></small>';
			}),
	
			DTColumnBuilder.newColumn('IDCommande').withTitle('<div class="table-header"><span class="column-title"></div></div>').withOption('width', '60px').renderWith(function(data, type, full){
				
				
				var html = '<md-menu style="float: right;">'+
						'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
							'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
						'</md-button>'+
						'<md-menu-content width="3">';
						
				html += '<md-menu-item>'+ 
							'<md-button ng-click="vm.DetailsCommande($event, '+full.IDCommande+')">'+ 
								'Aperçu commande'+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-divider >'+'</md-divider>';
				html += '<md-menu-item>'+
							'<md-button ng-click="vm.dupliqueCommande('+full.IDCommande+')">'+
								'Dupliquer commande'+
							'</md-button>'+
						'</md-menu-item>';			
			
				html += '</md-menu-content>'+'</md-menu>';
				return html; 
			}), 
		];	
			
		vm.dtInstanceAlertes = {};
    		
		vm.dtOptionsAlertes = DTOptionsBuilder.newOptions()
		.withOption('ajax', {
			 dataSrc: 'datas',
			 url: 'datas/alertes/getAlertes.json?IDContact='+ (Dialog ? Contact.IDContact : vm.contact.IDContact),
			 type: 'GET'
		})
		.withDataProp('data')
		.withOption('processing', true)
		.withOption('serverSide', true)
		.withOption('aoSearchCols',   [
		  null,
		  null,
		  null,
		  null,
		  null,
		  null
		])
		.withOption('columnDefs',  [
			/*{
				// Target the id column
				targets: 0,
				responsivePriority: 1,
			},
			{
				// Target the id column
				targets: 1,
				responsivePriority: 2,
			},*/    
			{
				targets: 0,
				responsivePriority: 1,
			},   
			{
				targets: 1,
				responsivePriority: 1,
			},   
			{
				targets: 2,
				responsivePriority: 1,
			},   
			{
				targets: 3,
				responsivePriority: 2,
			},   
			{
				targets: 4,
				responsivePriority: 1,
			},    
			{
				targets           : 5,
				responsivePriority: 0,
			}
		])
		.withOption('responsive', {
			details: {
				display: $.fn.dataTable.Responsive.display.childRowImmediate,
				type: 'none',
				target: ''
			}
		})
		.withOption('pagingType', 'simple')
		.withOption('lengthMenu', [50, 100, 250])
		.withPaginationType('simple')
		.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
		.withOption('createdRow', function(row, data, dataIndex) {
		// Recompiling so we can bind Angular directive to the DT
			$compile(angular.element(row).contents())($scope);
		})
		.withOption('headerCallback', function(header) {
			if (!vm.headerCompiled) {
				// Use this headerCompiled field to only compile header once
				vm.headerCompiled = true;
				$compile(angular.element(header).contents())($scope);
			}
		})
		.withOption('drawCallback', function(settings, json) {
				var api = this.api();
				vm.recordsLogsNonTraiteTotal = api.ajax.json().recordsNonTraiteTotal;
			}
		)
		.withLanguage({
		  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
		  'processing':'test',
			"sSearch":         "Rechercher&nbsp;:",
			"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
			"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
			"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
			"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			"sInfoPostFix":    "",
			"sLoadingRecords": "Chargement en cours...",
			"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
			"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
			"oPaginate": {
				"sFirst":      "Premier",
				"sPrevious":   "Pr&eacute;c&eacute;dent",
				"sNext":       "Suivant",
				"sLast":       "Dernier"
			},
			"oAria": {
				"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
				"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
			}
		})
		.withOption('order', [0, 'desc']);
		  
		  
		vm.Detailsnotification = function(ev, IDCommande, IDContact){
			if(IDCommande != 0){
				$mdDialog.show({
					parent             : angular.element("#profil-dialog"),
					targetEvent        : ev,
					controller         : 'CommandesDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commandes/dialogs/details-dialog.html',
					clickOutsideToClose: true,
					locals             : {
                    IDCommande : IDCommande,
					Fabricants : Fabricants,
					paramVM : vm
                },
				}).then(function(result) {
					if(result)
						vm.dtInstanceCommandesProfils.reloadData();
				}, function () {
					if(vm.reload){
						vm.dtInstanceCommandesProfils.reloadData();
						vm.reload = false;
					}
				});
			}
			else{
				$window.open("/contacts/profil/"+IDContact, '_blank');
			}
		};
		
		vm.Traiternotification = function(ev, IDAlerte){ 
			$http.post("/datas/alertes/getNotification.json",JSON.stringify({'IDAlerte' : IDAlerte}))
				.then(function (response, status, headers, config) {
					var notification = response.data.data;		
					if(notification.TypeAlerte == "Renouvellement"){
						$mdDialog.show({
							controller: DialogNotificationController,
							templateUrl: 'app/main/analyse/notifications/dialogs/dialog-renouvellement.html',
							parent             : angular.element("#profil-dialog"),
							targetEvent: ev,
							clickOutsideToClose:true,
							multiple:true,
							locals             : {
								notification : notification
							}
						})
						.then(function(answer) {
							notification = answer;
							$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
							.then(function (response, status, headers, config) {
								notification.Traite = 1; vm.dtInstanceAlertes.reloadData();
								$mdToast.show(
								  $mdToast.simple()
									.textContent('Notification traitée')
									.position('bottom right' )
									.hideDelay(3000)
								);
							}, function () {});	
						}, function() {
						});
					}
					else if(notification.TypeAlerte == "Devis"){
						$mdDialog.show({
							controller: DialogNotificationController,
							templateUrl: 'app/main/analyse/notifications/dialogs/dialog-devis.html',
							parent             : angular.element("#profil-dialog"),
							targetEvent: ev,
							clickOutsideToClose:true,
							multiple:true,
							locals             : {
								notification : notification
							}
						})
						.then(function(answer) {
							// console.log(notification);
							notification = answer;
							$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
							.then(function (response, status, headers, config) {
								notification.Traite = 1; vm.dtInstanceAlertes.reloadData();
								$mdToast.show(
								  $mdToast.simple()
									.textContent('Notification traitée')
									.position('bottom right' )
									.hideDelay(3000)
								);
							}, function () {});
						}, function() {
						});
					}
					else{
						$mdDialog.show({
							controller: DialogNotificationController,
							templateUrl: 'app/main/analyse/notifications/dialogs/dialog-default.html',
							parent             : angular.element("#profil-dialog"),
							targetEvent: ev,
							clickOutsideToClose:true,
							multiple:true,
							locals             : {
								notification : notification
							}
						})
						.then(function(answer) {
							// notification.satus = answer;
							notification = answer;
							$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
							.then(function (response, status, headers, config) {
								notification.Traite = 1; vm.dtInstanceAlertes.reloadData();
								$mdToast.show(
								  $mdToast.simple()
									.textContent('Notification traitée')
									.position('bottom right' )
									.hideDelay(3000)
								);
							}, function () {});	
						}, function() {
						});
						
					}
				}, function () {});
		};
		
			
		vm.dtColumnsAlertes = [
			DTColumnBuilder.newColumn('IDAlerte').withTitle('<div class="table-header"><span class="column-title">N°</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('Commercial').withTitle('<div class="table-header"><span class="column-title">Employé</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				var html = '';
				if(full.CommercialSupprime!=0)
					html += '<md-tooltip md-direction="left" >Commercial supprimé</md-tooltip>';
				html += '<span class="" >'+ full.Commercial +'</span>';
				return html;
			}),
			DTColumnBuilder.newColumn('Alerte').withTitle('<div class="table-header"><span class="column-title">Alerte</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ='<div class="flexbox-parent"><div layout="row"  layout-align="start center" style="min-width:200px">';
						switch(full.Type){
								case "Danger": html += '<md-icon flex="2" class="red-900-fg mr-16 hide-xs material-icons-outlined" >report_problem</md-icon>'; break;
								case "Warning": html += '<md-icon flex="2" class="orange-500-fg mr-16 hide-xs material-icons-outlined" >report_problem</md-icon>'; break;
								case "Info": html += '<md-icon flex="2" class="md-accent mr-16 hide-xs material-icons-outlined" >info</md-icon>'; break;
								case "Success": html += '<md-icon flex="2" class="green-800-fg mr-16 hide-xs material-icons-outlined" >info</md-icon>'; break;
						}
				   return html + '<p flex>'+data+'</p>' + '</div></div>';
				}
				return data;
				
			}),
			DTColumnBuilder.newColumn('Traite').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
					// console.log(data);
						if(data)
							 return'<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-green-bg white-fg" selected="true" style="text-transform:capitalize; display:inline-block ">Traitée</span>'; 
						else
							return '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-orange-bg white-fg" selected="true" style="text-transform:capitalize;display:inline-block ">Non traitée</span> '; 
						
					
				   return html;
				}
				return data;
				
			}),
			DTColumnBuilder.newColumn('Date').withTitle('<div class="table-header"><span class="column-title">Date</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data);
			}),
			DTColumnBuilder.newColumn(null).withTitle('').notSortable().withOption('width', '50px').renderWith(function(data, type, full){
				// console.log(JSON.stringify(full).replace("'","\'"));
				return '<md-menu style="float: right;">'+
				'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
						'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
					'</md-button>'+
					'<md-menu-content width="3">'+

						'<md-menu-item> '+
							'<md-button ng-click="vm.Traiternotification($event, '+full.IDAlerte+')" ng-disabled="\''+full.Traite+'\' == 1"> '+
							'	Traiter '+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-divider ></md-divider>'+
						'<md-menu-item> '+
							"<md-button ng-click='vm.Detailsnotification($event, \""+full.IDCommande+"\",\""+full.IDContact+"\")'> "+
								'Aperçu '+
							'</md-button>'+
						'</md-menu-item>'+
						
					'</md-menu-content>'+
				'</md-menu>';
					
			}),
		];


		vm.dtInstanceLogs = {};
    		
		vm.dtOptionsLogs = DTOptionsBuilder.newOptions()
		.withOption('ajax', {
			 dataSrc: 'datas',
			 url: 'datas/analyse/getLogs.json?IDContact='+ (Dialog ? Contact.IDContact : vm.contact.IDContact),
			 type: 'GET'
		})
		.withDataProp('data')
		.withOption('processing', true)
		.withOption('serverSide', true)		
		.withOption('responsive', {
			details: {
				display: $.fn.dataTable.Responsive.display.childRowImmediate,
				type: 'none',
				target: ''
			}
		})
		.withOption('pagingType', 'simple')
		.withOption('lengthMenu', [50, 100, 250])
		.withPaginationType('simple')
		.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
		.withOption('createdRow', function(row, data, dataIndex) {
			$compile(angular.element(row).contents())($scope);
		})
		.withOption('headerCallback', function(header) {
			if (!vm.headerCompiled) {
				vm.headerCompiled = true;
				$compile(angular.element(header).contents())($scope);
			}
		})
		
		.withOption('initComplete', function(settings, json) {
		/* 	var api = this.api();
			vm.searchBox = angular.element('body').find('#logs-search');
			
			if ( vm.searchBox.length > 0 )
			{
				vm.searchBox.on('keyup', function (event)
				{
					localStorage.setItem('logsSearch', vm.search);
					api.search(vm.search).draw();
				});
				if(vm.search != null)
					vm.searchBox.trigger('keyup');
			}
			
			vm.recordsTotal = json.recordsTotal; */
		  }
		)
		.withLanguage({
		  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
		  'processing':'test',
			"sSearch":         "Rechercher&nbsp;:",
			"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
			"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
			"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
			"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			"sInfoPostFix":    "",
			"sLoadingRecords": "Chargement en cours...",
			"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
			"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
			"oPaginate": {
				"sFirst":      "Premier",
				"sPrevious":   "Pr&eacute;c&eacute;dent",
				"sNext":       "Suivant",
				"sLast":       "Dernier"
			},
			"oAria": {
				"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
				"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
			}
		})
		.withOption('order', [0, 'desc']);

			
		vm.dtColumnsLogs = [
			DTColumnBuilder.newColumn('IDLog').withTitle('<div class="table-header"><span class="column-title">N°</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('Utilisateur').withTitle('<div class="table-header"><span class="column-title">Employé</div></div>').withOption('width', '170px'),
			DTColumnBuilder.newColumn('Titre').withTitle('<div class="table-header"><span class="column-title">Message</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
				var html = '<strong class="md-subhead font-weight-600">'+data+'</strong>';
				if(full.Message) 
					html += '<br><span >'+full.Message+'</span>';
				
				return html;
			}),
			DTColumnBuilder.newColumn('Type').withTitle('<div class="table-header"><span class="column-title">Gravité</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
						switch(data){
							case "danger": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-red-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span>'; break;
							case "success": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-green-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
							case "warning": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-orange-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
							case "info": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-blue-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
						}
				   return html;
				}
				return data;
				
			}),
			DTColumnBuilder.newColumn('Date').withTitle('<div class="table-header"><span class="column-title">Date</div></div>').withOption('width', '130px').renderWith(function(data, type, full){
				return convertDate(data);
			}),
			
		];
		
		
		vm.dtInstanceEchanges = {};
    		
		vm.dtOptionsEchanges = DTOptionsBuilder.newOptions()
		.withOption('ajax', {
			 dataSrc: 'datas',
			 url: 'datas/contacts/getExchanges.json?IDContact='+ (Dialog ? Contact.IDContact : vm.contact.IDContact),
			 type: 'GET'
		})
		.withDataProp('data')
		.withOption('processing', true)
		.withOption('serverSide', true)		
		.withOption('responsive', {
			details: {
				display: $.fn.dataTable.Responsive.display.childRowImmediate,
				type: 'none',
				target: ''
			}
		})
		.withOption('columnDefs',  [
			/*{
				// Target the id column
				targets: 0,
				responsivePriority: 1,
			},
			{
				// Target the id column
				targets: 1,
				responsivePriority: 2,
			},*/    
		/* 	{
				targets: 0,
				responsivePriority: 1,
			},    */
	/* 		 {
				targets: 1,
				responsivePriority: 0,
			},   */
			// {
				// targets: 2,
				// responsivePriority: 2,
			// },   
			/* {
				targets: 3,
				responsivePriority: 2,
			},   
			{
				targets: 4,
				responsivePriority: 2,
			},    
			{
				targets           : 4,
				responsivePriority: 1,
			},    
			{
				targets           : 5,
				responsivePriority: 1,
			},     */
			// {
				// targets           : 6,
				// responsivePriority: 1,
			// },    
			{
				targets           : 5,
				responsivePriority: 0,
			}
		])
		.withOption('pagingType', 'simple')
		.withOption('lengthMenu', [50, 100, 250])
		.withPaginationType('simple')
		.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
		.withOption('createdRow', function(row, data, dataIndex) {
			$compile(angular.element(row).contents())($scope);
		})
		.withOption('headerCallback', function(header) {
			if (!vm.headerCompiled) {
				vm.headerCompiled = true;
				$compile(angular.element(header).contents())($scope);
			}
		})
		
		.withOption('initComplete', function(settings, json) {
		/* 	var api = this.api();
			vm.searchBox = angular.element('body').find('#logs-search');
			
			if ( vm.searchBox.length > 0 )
			{
				vm.searchBox.on('keyup', function (event)
				{
					localStorage.setItem('logsSearch', vm.search);
					api.search(vm.search).draw();
				});
				if(vm.search != null)
					vm.searchBox.trigger('keyup');
			}
			
			vm.recordsTotal = json.recordsTotal; */
		  }
		)
		.withLanguage({
		  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
		  'processing':'test',
			"sSearch":         "Rechercher&nbsp;:",
			"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
			"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
			"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
			"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			"sInfoPostFix":    "",
			"sLoadingRecords": "Chargement en cours...",
			"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
			"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
			"oPaginate": {
				"sFirst":      "Premier",
				"sPrevious":   "Pr&eacute;c&eacute;dent",
				"sNext":       "Suivant",
				"sLast":       "Dernier"
			},
			"oAria": {
				"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
				"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
			}
		})
		.withOption('order', [0, 'desc']);

			
		vm.dtColumnsEchanges = [
			DTColumnBuilder.newColumn('Date').withTitle('<div class="table-header"><span class="column-title">Date</div></div>').withOption('width', '80px').renderWith(function(data, type, full){
				return convertDate(data);
			}),
			DTColumnBuilder.newColumn('Subject').withTitle('<div class="table-header"><span class="column-title">Objet</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				return "<a style='cursor:pointer' ng-click='vm.DetailsEchange($event, \""+full.IDContacts_Echange+"\",\""+full.IDContacts_Echange+"\")'>"+data+"</a>";
			}),
			DTColumnBuilder.newColumn('De').withTitle('<div class="table-header"><span class="column-title">De</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				var html = "";
				angular.forEach(JSON.parse(data),function(v){
					if(html != "")
						html += "<br>";
					html += v;
				});
				return html;
			}),
			DTColumnBuilder.newColumn('A').withTitle('<div class="table-header"><span class="column-title">À</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				var html = "";
				angular.forEach(JSON.parse(data),function(v){
					if(html != "")
						html += "<br>";
					html += v;
				});
				return html;
			}),
			DTColumnBuilder.newColumn('Unseen').withTitle('<div class="table-header"><span class="column-title" style="text-align:center">Non lu</div></div>').withOption('width', '80px').renderWith(function(data, type, full){
				var html = "<div style='text-align:center'>";
				// console.log(full);
				if(full.Attachments > 0)
					 html += ('<md-icon class="material-icons-outlined font-size-20">attach_file  <md-tooltip>'+full.Attachments+' pièce(s) jointe(s)</md-tooltip></md-icon>');
				 
				if(full.Unseen)					
					 html += ('<md-icon class="material-icons-outlined font-size-20 red-800-fg">visibility_off  <md-tooltip>non lu</md-tooltip></md-icon>');
			
				if(full.Answered)					
					html += ('<md-icon class="material-icons-outlined font-size-20  green-800-fg">mark_chat_read  <md-tooltip>répondu</md-tooltip></md-icon>');
				
				if(full.Flagged)					
					html += ('<md-icon class="material-icons-outlined font-size-20 red-800-fg">flag  <md-tooltip>en suivi</md-tooltip></md-icon> ');
				
				html += "</div>";
				return html;
			}),
			/* DTColumnBuilder.newColumn('Unseen').withTitle('<div class="table-header"><span class="column-title">Non lu</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				if(data)					
					return ('<md-icon class="material-icons-outlined font-size-20 red-800-fg">visibility_off</md-icon> ');
				else
					return "";
			}),
			DTColumnBuilder.newColumn('Answered').withTitle('<div class="table-header"><span class="column-title">Répondu</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				if(data)					
					return ('<md-icon class="material-icons-outlined font-size-20  green-800-fg">mark_chat_read</md-icon> ');
				else
					return "";
			}),
			DTColumnBuilder.newColumn('Flagged').withTitle('<div class="table-header"><span class="column-title">En suivi</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				if(data)					
					return ('<md-icon class="material-icons-outlined font-size-20 red-800-fg">flag</md-icon> ');
				else
					return "";
			}), */
		
			DTColumnBuilder.newColumn(null).withTitle('').notSortable().withOption('width', '50px').renderWith(function(data, type, full){
				// console.log(JSON.stringify(full).replace("'","\'"));
				return "<md-button style='float: right;' class='md-raised' ng-click='vm.DetailsEchange($event, \""+full.IDContacts_Echange+"\",\""+full.IDContacts_Echange+"\")'> "+
							'Détails '+
						'</md-button>';
					
			}),
			
		];
		
		vm.DetailsEchange = function(ev, IDContacts_Echange, IDContact){
			$http.get("/datas/contacts/getExchange.json?IDContacts_Echange="+IDContacts_Echange )
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					parent             : angular.element("#profil-dialog"),
					targetEvent        : ev,
					controller         : 'EchangesContactDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/contacts/profil/dialogs/about/echanges-dialog.html',
					clickOutsideToClose: true,
					fullscreen: true,
					multiple:true,
					locals             : {
						Echange : response.data.data,
					}
				}).then(function (response) {}, function () {});
			}, function () {});
		}
		
		vm.statuses = [
			{value: "Client", text: 'Client'},
			{value: "Prospect", text: 'Prospect'},
			{value: "Suspect", text: 'Suspect'},
			{value: "Fin d\'activité", text: "Fin d'activité"},
			{value: "Ancien client", text: 'Ancien client'},
			{value: "Annulé", text: 'Annulé'}
		]; 

		vm.updateStatus = function(){
			$http.post("/datas/contacts/setStatus.json", JSON.stringify(vm.contact));
			$mdToast.show(
			  $mdToast.simple()
				.textContent('Etat modifié !')
				.position('bottom right' )
				.hideDelay(3000)
			);
		}
		
		vm.updateBilanFrequence = function(){
			$http.post("/datas/contacts/setBilanFrequence.json", JSON.stringify(vm.contact));
			$mdToast.show(
			  $mdToast.simple()
				.textContent('Fréquence modifiée !')
				.position('bottom right' )
				.hideDelay(3000)
			);
		}
		
		vm.updateCommercial = function(){
			$http.post("/datas/contacts/setCommercial.json", JSON.stringify(vm.contact));
			$mdToast.show(
			  $mdToast.simple()
				.textContent('Commercial modifié !')
				.position('bottom right' )
				.hideDelay(3000)
			);
		}
		
		vm.cancel = function() {
		  $mdDialog.cancel();
		};
	
		vm.updateRaisonSociale = function(){
			$http.post("/datas/contacts/setRaisonSociale.json", JSON.stringify(vm.contact));
			$mdToast.show(
			  $mdToast.simple()
				.textContent('Raison sociale modifiée !')
				.position('bottom right' )
				.hideDelay(3000)
			);
		}
		
		vm.updateOpportunites = function(){
			$http.post("/datas/contacts/setOpportunites.json", JSON.stringify(vm.contact));
			$mdToast.show(
			  $mdToast.simple()
				.textContent('Opportunités modifiées !')
				.position('bottom right' )
				.hideDelay(3000)
			);
		}
		
		vm.updateNote = function(note){
			$http.post("/datas/contacts/updateNote.json", JSON.stringify(note));
			$mdToast.show(
			  $mdToast.simple()
				.textContent('Note modifiée !')
				.position('bottom right' )
				.hideDelay(3000)
			);
		}
		
		vm.add_post = function(){
			if(vm.text_add_post){
				var date = new Date();
				var h=date.getHours();
				if (h<10) {h = "0" + h}
				var m=date.getMinutes();
				if (m<10) {m = "0" + m}
				
				
				$http.post("/datas/contacts/setNote.json", JSON.stringify({"Note":vm.text_add_post, "IDContact":vm.contact.IDContact})).then(function (response, status, headers, config) {
					// vm.contact = response.data.data;
					// console.log(response);
					// vm.loader = 0;
					vm.contact.Notes.unshift({"Note":vm.text_add_post, IDNote: response.data.IDNote, "IDEmploye" : $rootScope.id, "Utilisateur":$rootScope.Prenom+' '+$rootScope.Nom, "DateCreation":"Posté à "+h+':'+m});

					vm.text_add_post = "";
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Votre commentaire a été ajouté !')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}, function () {});
			}
			else{
				$mdToast.show(
				  $mdToast.simple()
					.textContent("Vous n'avez pas saisie de texte...")
					.position('bottom right' )
					.hideDelay(3000)
				);
			}
		};
		
		vm.edit_post = function(note){
			if(note.Note){
				var date = new Date();
				var h=date.getHours();
				if (h<10) {h = "0" + h}
				var m=date.getMinutes();
				if (m<10) {m = "0" + m}
				
				if(note.Note != note.Temp){
					note.DateModification = "Modifié à "+h+':'+m; 
					
					$http.post("/datas/contacts/setNote.json", JSON.stringify({"Note":note.Note, "IDNote":note.IDNote}));
					vm.text_add_post = "";
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Votre commentaire a été modifié !')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
				note.Edit = 0; 
			}
			else{
				$mdToast.show(
				  $mdToast.simple()
					.textContent("Vous n'avez pas saisie de texte...")
					.position('bottom right' )
					.hideDelay(3000)
				);
			}
		};
		
		vm.deleteContact = function(ev, datas){
			var confirm = $mdDialog.confirm()
                .title('Êtes-vous sûr de vouloir supprimer ce contact ?')
				.multiple(true)
                .htmlContent('<b>' + datas.Prenom +' '+ datas.Nom + '</b> va être supprimé')
                .ariaLabel('Supprimer ce contact')
                .targetEvent(ev)
                .theme('md-warn')
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {
				$http.post("/datas/contacts/deleteContact.json", JSON.stringify(datas)).then(function (response, status, headers, config) {
					if(response.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.multiple(true)
							.clickOutsideToClose(false)
							.title("Une erreur s'est produite")
							.textContent(response.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.contact = response.data.data;
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Adresse supprimé !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				}, function () {});
            });

		};
		
		vm.showEmployes = function(commande){
			 var selected = $filter('filter')(vm.employes, {IDEmploye: commande.toString()}, true);
			return (commande && selected.length) ? selected[0].Civilite+' '+selected[0].Prenom+' '+selected[0].Nom : 'Non défini';
		}
		
		vm.showEmployesProfil = function(contact){
			if(typeof contact != "undefined"){
				// console.log(contact);
				var selected = $filter('filter')(
					vm.employes, 
					{IDEmploye: contact.IDEmploye.toString()}, 
				true);
				
				return (contact.IDEmploye && selected.length) ? selected[0].Civilite+' '+selected[0].Prenom+' '+selected[0].Nom : 'Non défini';
			}
		}


		vm.saveCommercialCommandes = function(row){
			 $http.post("/datas/commandes/setCommercial.json",JSON.stringify(vm.rows[row]))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
				}
				else{
					vm.dtInstanceCommandesProfils.reloadData();
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Le commercial de la commande '+vm.rows[row].NumeroCommande+' a été modifié.')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			}, function () {});	
		}
		
		vm.dupliqueCommande = function (IDCommande){
			$http.post("/datas/commandes/dupliquer.json",{'IDCommande':IDCommande})
			.then(function (response, status, headers, config) {
				editCommande(response.data.data.IDCommande);
			}, function () {});	
		}
		
        vm.ajouterCommande = ajouterCommande;
        vm.editCommande = editCommande;

        function editCommande(IDCommande)
        {
			$location.path('/commandes/edition/' + IDCommande +'/'+vm.contact.IDContact);
			vm.cancel();
        }
		
        function ajouterCommande()
        {
			$location.path('/commandes/nouvelle/'+vm.contact.IDContact);
			vm.cancel();
        }
		
       vm.getFacture = function (ev, IDCommande, DateRenouvellement, Etat, DateFacturation, TotalTTC)
        {
			if(Etat != "Facturée"/*  && Etat != "Signée" */){
				$http.get("/datas/commandes/getCommande.json?IDCommande="+IDCommande)
				.then(function (response, status, headers, config) {
					var comde = response.data.data;
					var produit_a_renouveler = [];
					
					angular.forEach(comde.produits, function (value, key) {
						if(value.Renouvellement > 0 ){
							produit_a_renouveler.push({'Produit':value.Produit,'Renouvellement':value.Renouvellement});
						}
						
						angular.forEach(value.SousProduitsSelect, function (v, k) {
							if(v.Renouvellement > 0 ){
								produit_a_renouveler.push({'Produit':v.Produit,'Renouvellement':v.Renouvellement});
							}
						});
					});
					
					if(produit_a_renouveler.length > 0 && TotalTTC>0){
						$mdDialog.show({
	   
					
						  controller: 'DialogFactureController',
							templateUrl        : 'app/main/commandes/commande/dialogs/facture-dialog.html',
						  parent: angular.element(document.body),
						  targetEvent: ev,
							multiple :true,
						  clickOutsideToClose:true,
							locals             : {
								Renouvellement : DateRenouvellement,
								produit_a_renouveler : produit_a_renouveler
							}
						})
						.then(function(result) {
								   
							Etat = "Facturée";
							DateFacturation = Date.now();
							if(typeof result != "undefined"){
								var d = new Date(result),
								month = '' + (d.getMonth() + 1),
								day = '' + d.getDate(),
								year = d.getFullYear();

								if (month.length < 2) month = '0' + month;
								if (day.length < 2) day = '0' + day;
								
								DateRenouvellement = [year, month, day].join('-');
							}
							// writeCommande();
							$mdToast.show(
							  $mdToast.simple()
								.textContent('La commande a été facturée !')
								.position('bottom right' )
								.hideDelay(3000)
							);
							
							$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
							 vm.dtInstanceCommandesProfils.reloadData();
						
						}, function() {
						});
					}
					else{
						
						
						if(TotalTTC<0)
							var confirm = $mdDialog.confirm()
							  .title(' Souhaitez-vous faire un avoir ? ')
							  .textContent("Une fois l'avoir généré, cette commande ne pourra plus être modifiée.")
							  .ariaLabel("Générer l'avoir")
							  .targetEvent(ev)
							.multiple(true)
								.theme('md-warn')
							  .ok("Générer l'avoir")
							  .cancel('Annuler');
						else
							var confirm = $mdDialog.confirm()
							  .title(' Souhaitez-vous facturer cette commande ? ')
							  .textContent('Une fois facturée, cette commande ne pourra plus être modifiée. ')
							  .ariaLabel('Facturer la commande')
							.multiple(true)
							  .targetEvent(ev)
								.theme('md-warn')
							  .ok('Générer la facture')
							  .cancel('Annuler');

						$mdDialog.show(confirm).then(function () {
						  	  
									
										   
											  
		
								$mdToast.show(
								  $mdToast.simple()
									.textContent('La commande a été facturée !')
									.position('bottom right' )
									.hideDelay(3000)
								);
								
								$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
								 vm.dtInstanceCommandesProfils.reloadData();
						}, function () {
						});
					  
					} 
	
				}, function () {});	
			}
			else{
				/* if(Etat == "Signée"){
					Etat = "Facturée";
					DateFacturation = Date.now();
				} */
				$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
					 // vm.dtInstance.reloadData();
			}
		
        }
		
		function DialogDevisController($scope, $mdDialog) {
			$scope.hide = function() {
			  $mdDialog.hide();
			};
			
			$scope.items = ["Conditions Générales de Ventes", "Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>", "Cahier des charges fonctionnel"];
			$scope.selected = ["Conditions Générales de Ventes"];

			$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
			};

			$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
			};
		  
			$scope.cancel = function() {
			  $mdDialog.cancel();
			};

			$scope.answer = function(result) {
			  $mdDialog.hide(result);
			};
		}
	
		vm.getFactureAcompte = function (ev, commande){
			
			$http.get("/datas/commandes/getCommande.json?IDCommande="+commande)
			.then(function (response, status, headers, config) {
				// console.log(response.data.data);
				$mdDialog.show({
					 parent             : angular.element("#profil-dialog"),
					targetEvent        : ev,
					controller         : 'DialogFactureAcompteController',
					controllerAs       : 'vm',
					multiple : true,
					templateUrl        : 'app/main/commandes/commandes/dialogs/acompte-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande : response.data.data,
						Paiements : response.data.data.paiements,
						dtInstance : vm.dtInstance
					}
				});
				
					 // vm.dtInstance.reloadData();
			}, function () {});
		}
		
		vm.getDevisSigne = function (ev, IDCommande, NumeroCommande){
			$window.open("/datas/files/devis_signes/"+IDCommande+"-"+NumeroCommande+".pdf", '_blank');
		}
		
		vm.getDevis = function (ev, IDCommande, prelevement){
		 
											 
						
	   
						
	
			if(prelevement ==1){
				var confirm = $mdDialog.confirm()
					  .title('Attention, IBAN du contact manquant !')
					  .textContent("L'IBAN sera obligatoire pour valider une commande par prélévement")
					  .ariaLabel('IBAN manquant')
					  .targetEvent(ev)
							.multiple(true)
					  .clickOutsideToClose(true)
					  .parent(angular.element(document.body))
					  .ok('Continuer')
					  .cancel('Annuler');
					  
					$mdDialog.show(confirm).then(function() {
						 $mdDialog.show({
						  controller: DialogDevisController,
							templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
						  parent: angular.element(document.body),
						  targetEvent: ev,
						  clickOutsideToClose:true
						})
						.then(function(result) {
							var lien = "/datas/commandes/devis.json?IDCommande="+IDCommande;
							
							if(result.indexOf("Conditions Générales de Ventes")>=0)
								lien +="&cgv=1";
							else
								lien +="&cgv=0";
							if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
								lien +="&retractation=1";
							else
								lien +="&retractation=0";
							
							$window.open(lien, '_blank');
						}, function() {
					});
				}, function() {}); 
			}
			else{
			   $mdDialog.show({
					  controller: DialogDevisController,
					 
						templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
					  parent: angular.element(document.body),
					  targetEvent: ev,
						multiple : true,
					  clickOutsideToClose:true
					})
					.then(function(result) {
						var lien = "/datas/commandes/devis.json?IDCommande="+IDCommande;
						
						if(result.indexOf("Conditions Générales de Ventes")>=0)
							lien +="&cgv=1";
						else
							lien +="&cgv=0";
						if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
							lien +="&retractation=1";
						else
							lien +="&retractation=0";
						
						$window.open(lien, '_blank');
					}, function() {
				});
			}
		}
		
		vm.deleteCommande = function (ev, commande, NumeroCommande)
        {
			var commandeObj = {IDCommande:commande};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer cette commande ?')
                .htmlContent('<b>La commande N°' + NumeroCommande + '</b>' + ' va être supprimée.')
                .ariaLabel('Supprimer une commande')
                .targetEvent(ev)
                .ok('Supprimer')
				.multiple(true)
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/commandes/deleteCommande.json", JSON.stringify(commandeObj)).then(function (response, status, headers, config) {  
					if(response.data.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.title("Une erreur s'est produite")
							.multiple(true)
							.textContent(response.data.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.dtInstanceCommandesProfils.reloadData();
						$mdToast.show(
						  $mdToast.simple()
							.textContent('La commande a été supprimée.')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				
				}, function () {});
				
            });
        }
		
		

		vm.editOptions = function(ev, IDCommande){
			
		
			$http.get("/datas/commandes/getCommande.json?IDCommande="+IDCommande)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					parent             : angular.element("#profil-dialog"),
					targetEvent        : ev,
					controller         : 'DialogOptionsCommandeController',
					controllerAs       : 'vm',
					multiple :true,
					templateUrl        : 'app/main/commandes/commandes/dialogs/options-commande-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande :response.data.data
					}
				}).then(function(result) {
					 vm.dtInstanceCommandesProfils.reloadData();
				}, function () {});	
			}, function () {});
		}
		

		vm.DetailsCommande = function(ev, IDCommande, Commande){
			$mdDialog.show({
                parent             : angular.element("#profil-dialog"),
                targetEvent        : ev,
				multiple:true,
                controller         : 'CommandesDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/commandes/dialogs/details-dialog.html',
                clickOutsideToClose: true,
                locals             : {
                    IDCommande : IDCommande,
					Fabricants : Fabricants,
					paramVM : vm
                },
            }).then(function(result) {
				if(result)
					vm.dtInstanceCommandesProfils.reloadData();
			}, function () {
				if(vm.reload){
					vm.dtInstanceCommandesProfils.reloadData();
					vm.reload = false;
				}
			});
		}
		
		vm.deleteAdresse = function(ev, datas){
			var confirm = $mdDialog.confirm()
                .title('Êtes-vous sûr de vouloir supprimer cette adresse ?')
                .htmlContent("L'adresse <b>" + datas.NomAdresse + '</b> va être supprimée')
                .ariaLabel('Supprimer cette adresse')
                .targetEvent(ev)
				.multiple(true)
                .theme('md-warn')
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {
				$http.post("/datas/contacts/deleteAdresse.json", JSON.stringify(datas)).then(function (response, status, headers, config) {
					if(response.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.multiple(true)
							.title("Une erreur s'est produite")
							.textContent(response.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.contact = response.data.data;
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Adresse supprimée !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				}, function () {});
            }, function () {});
		};
		
		vm.deleteSiteInternet = function(ev, datas){
			var confirm = $mdDialog.confirm()
                .title('Êtes-vous sûr de vouloir supprimer cette URL ?')
                .htmlContent("Le lien vers le site <b>" + datas.URL + '</b> va être supprimé')
                .ariaLabel('Supprimer cette URL')
                .targetEvent(ev)
				.multiple(true)
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {
				$http.post("/datas/contacts/deleteSiteInternet.json", JSON.stringify(datas)).then(function (response, status, headers, config) {
					if(response.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.multiple(true)
							.title("Une erreur s'est produite")
							.textContent(response.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.contact = response.data.data;
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Site internet supprimé !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				}, function () {});
            }, function () {});
		};
		
		vm.deleteIBAN = function(ev, datas){
			var confirm = $mdDialog.confirm()
                .title('Êtes-vous sûr de vouloir supprimer cet IBAN ?')
                .htmlContent("L'IBAN <b>" + datas.IBAN + '</b> va être supprimé. <br>Toutes les commandes non validées perdront cet IBAN.')
                .ariaLabel('Supprimer cet IBAN')
                .targetEvent(ev)
                .theme('md-warn')
				.multiple(true)
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {
				$http.post("/datas/contacts/deleteIBAN.json", JSON.stringify(datas)).then(function (response, status, headers, config) {
					if(response.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.multiple(true)
							.title("Une erreur s'est produite")
							.textContent(response.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.contact = response.data.data;
						$mdToast.show(
						  $mdToast.simple()
							.textContent('IBAN supprimé !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				}, function () {});
            }, function () {});
		};
		
		vm.editer = function (ev, page, datas){
			$mdDialog.show({
                controller         : 'AboutContactDialogController',
                controllerAs       : 'vm',
				multiple:true,
                templateUrl        : 'app/main/contacts/profil/dialogs/about/'+ page +'-dialog.html',
                parent             : angular.element("#profil-dialog"),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    contact : vm.contact,
                    structures : vm.structures,
                    APE : vm.APE,
                    Activites : vm.Activites,
					page : page,
					datas : datas
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					vm.contact = response.data;
					$mdToast.show(
					  $mdToast.simple()
						.textContent("Contact modifié !")
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			}, function () {});;
		}
		
		
    }

	function DialogNotificationController($scope, $mdDialog, notification) {
		$scope.notification = notification;

		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		// $scope.renouvele = function(answer) {
		  // $mdDialog.hide(answer);
		// };
		
		$scope.reponse = function(answer) {
		  $mdDialog.hide(answer);
		};
	  }
	  
})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.nouveau', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.contacts_nouveau', {
            url      : '/contacts/nouveau',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/contacts/nouveau/nouveau.html',
                    controller : 'nouveauController as vm'
                }
            },
            resolve  : {
                Structures    : function (msApi)
                {
                    return msApi.resolve('profil.structures@get');
                },
                APE    : function (msApi)
                {
                    return msApi.resolve('profil.APE@get');
                },
                Activites    : function (msApi)
                {
                    return msApi.resolve('profil.Activites@get');
                }
            },
            bodyClass: 'nouveau'
        });
		
		
        msApiProvider.register('profil.structures', ['/datas/contacts/getStructures.json']);
        msApiProvider.register('profil.APE', ['/datas/contacts/getAPE.json']);
        msApiProvider.register('profil.Activites', ['/datas/contacts/getActivites.json']);
		
		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts.nouveau')
        .controller('nouveauController', nouveauController);

    /** @ngInject */
    function nouveauController($mdDialog, Structures, APE,  $scope, $http, $location, Activites,$element)
    {
        var vm = this;
		
        vm.structures = Structures.data;
        vm.APE = APE.data;
        vm.activites = Activites.data;
		
		
		$scope.searchTerm;
		$scope.clearSearchTerm = function() {
			$scope.searchTerm = '';
		};
		$element.find('input').on('keydown', function(ev) {
			ev.stopPropagation();
		});

		vm.contact = {
			"Activites":[null],
			"Sites":[],
			"Horaires"   : {
				"Lundi" : {"Etat" : "Fermé", "Heures" : [{"de" :"", "a" :""}]},
				"Mardi" : {"Etat" : "Fermé", "Heures" : [{"de" :"", "a" :""}]},
				"Mercredi" : {"Etat" : "Fermé", "Heures" :  [{"de" :"", "a" :""}]},
				"Jeudi" : {"Etat" : "Fermé", "Heures" :  [{"de" :"", "a" :""}]},
				"Vendredi" : {"Etat" : "Fermé", "Heures" : [{"de" :"", "a" :""}]},
				"Samedi" : {"Etat" : "Fermé", "Heures" : [{"de" :"", "a" :""}]},
				"Dimanche" : { "Etat" : "Fermé", "Heures" : [{"de" :"", "a" :""}]}
			},
			"Telephones" : [null],
			"Emails" : [],
			"Structure":{}
		}
		
		vm.structures_selected = "";
		
		vm.select_structure = function(structure){vm.structures_selected = structure;}
		
		vm.sirenValide = false;
		vm.sirenTrouve = "";
		
		vm.testSirenExist = function(siren){
			if(typeof siren == "undefined" || siren.length != 9){
				vm.sirenValide = false;
				vm.sirenTrouve = "";
			}
			else{
				$http.get("/datas/contacts/sirenExist.json?siren="+siren).then(function (response, status, headers, config) {
					if(response.data.data != false){
						vm.sirenTrouve = response.data.data;
						vm.sirenValide = false;	
					}
					else{
						vm.sirenValide = true;
						vm.sirenTrouve = "";
					}
				}, function () {});
			}		
		}
		
		vm.horaires = [
			'00:00',
			'00:30',
			'01:00',
			'01:30',
			'02:00',
			'02:30',
			'03:00',
			'03:30',
			'04:00',
			'04:30',
			'05:00',
			'05:30',
			'06:00',
			'06:30',
			'07:00',
			'07:30',
			'08:00',
			'08:30',
			'09:00',
			'09:30',
			'10:00',
			'10:30',
			'11:00',
			'11:30',
			'12:00',
			'12:30',
			'13:00',
			'13:30',
			'14:00',
			'14:30',
			'15:00',
			'15:30',
			'16:00',
			'16:30',
			'17:00',
			'17:30',
			'18:00',
			'18:30',
			'19:00',
			'19:30',
			'20:00',
			'20:30',
			'21:00',
			'21:30',
			'22:00',
			'22:30',
			'23:00',
			'23:30'
		];
		
		vm.webregex = RegExp('^((https?|ftp)://)?([a-z]+[.])?[a-z0-9-]+([.][a-z]{1,6}){1,2}(/.*[?].*)?$', 'i');
		
		vm.initSiteArray = function(){
			vm.siteArray = [];
			angular.forEach(vm.contact.Sites, function(value, key) {
				vm.siteArray.push('Sites['+key+']');
			});
		}
		
		vm.initSiteArray();
	
		$scope.status = [];
		
		vm.testSiteExist = function(url, index) {
			var siteArray = 'Sites['+index+']';
			$http.post("/datas/sites/testSiteExist.json",JSON.stringify({'url':url, "IDContact":vm.contact.IDContact}))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$scope.horizontalStepper.horizontalStep3[siteArray].$setValidity("newURLFailed", false);
					$scope.status[index] = response.data.error.message;
				}
				else{					
					$scope.horizontalStepper.horizontalStep3[siteArray].$setValidity("newURLFailed", true);
				}
			}, function () {});
			
		};
		
        // Data
       /* vm.horizontalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.verticalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.basicForm = {};
        vm.formWizard = {};
        vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
        'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
        'WY').split(' ').map(function (state)
        {
            return {abbrev: state};
        });*/

        // Methods
        vm.sendForm = sendForm;
        // vm.showDataDialog = showDataDialog;
     /*   vm.submitHorizontalStepper = submitHorizontalStepper;
        vm.submitVerticalStepper = submitVerticalStepper;
*/
        //////////

        /**
         * Submit horizontal stepper data
         * @param event
         */
     /*   function submitHorizontalStepper(event)
        {
            // Show the model data in a dialog
            // vm.showDataDialog(event, vm.horizontalStepper);

            // Reset the form model
            vm.horizontalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit vertical stepper data
         *
         * @param event
         */
      /*  function submitVerticalStepper(event)
        {
            // Show the model data in a dialog
            // vm.showDataDialog(event, vm.verticalStepper);

            // Reset the form model
            vm.verticalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }*/

		 
		vm.goProfil = function(IDContact){
			$location.path("/contacts/profil/"+IDContact);
		}
		
        function sendForm(ev)
        {
            vm.showSpinner = 1;
            vm.createloader = 1;
			$http.post("/datas/contacts/addContact.json",JSON.stringify(vm.contact))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
					vm.createloader = 0;					
				}
				else{
					$location.path("/contacts/profil/"+response.data.IDContact);
				}
			}, function () {});		
        }
		
		  
		$scope.$on('g-places-autocomplete:select', function (event, param) {
			var regex = /<span.*?<\/span>/g
			var matches = [];
			var match = regex.exec(param.adr_address);
			while (match != null) {
				matches.push(match[0]);
				match = regex.exec(param.adr_address);
			}
			
			var regex = /class=".*?">/g
			var matchesClass = [];
			var match = regex.exec(matches);
			while (match != null) {
				matchesClass.push(match[0]);
				match = regex.exec(matches);
			}
			
			 vm.contact.Adresse = "";
			 vm.contact.CP = "";
			 vm.contact.Ville = "";
			 vm.contact.Pays = "";
			for (var key = 0; key < matchesClass.length; key++ ) {
				var val = matchesClass[key].match('".*?"');
				switch (val[0]){
					case '"street-address"' : vm.contact.Adresse = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
					case '"postal-code"' : vm.contact.CP = matches[key].match('>.*?<')[0].replace('<','').replace('>',''); break;
					case '"locality"' : vm.contact.Ville = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
					case '"country-name"' : vm.contact.Pays = html_entity_decode(matches[key].match('>.*?<')[0].replace('<','').replace('>','')); break;
				}
			}

		});
		
		function html_entity_decode(texte) {
			texte = texte.replace(/&quot;/g,'"'); // 34 22
			texte = texte.replace(/&amp;/g,'&'); // 38 26	
			texte = texte.replace(/&#39;/g,"'"); // 39 27
			texte = texte.replace(/&lt;/g,'<'); // 60 3C
			texte = texte.replace(/&gt;/g,'>'); // 62 3E
			texte = texte.replace(/&circ;/g,'^'); // 94 5E
			texte = texte.replace(/&lsquo;/g,'‘'); // 145 91
			texte = texte.replace(/&rsquo;/g,'’'); // 146 92
			texte = texte.replace(/&ldquo;/g,'“'); // 147 93
			texte = texte.replace(/&rdquo;/g,'”'); // 148 94
			texte = texte.replace(/&bull;/g,'•'); // 149 95
			texte = texte.replace(/&ndash;/g,'–'); // 150 96
			texte = texte.replace(/&mdash;/g,'—'); // 151 97
			texte = texte.replace(/&tilde;/g,'˜'); // 152 98
			texte = texte.replace(/&trade;/g,'™'); // 153 99
			texte = texte.replace(/&scaron;/g,'š'); // 154 9A
			texte = texte.replace(/&rsaquo;/g,'›'); // 155 9B
			texte = texte.replace(/&oelig;/g,'œ'); // 156 9C
			texte = texte.replace(/&#357;/g,''); // 157 9D
			texte = texte.replace(/&#382;/g,'ž'); // 158 9E
			texte = texte.replace(/&Yuml;/g,'Ÿ'); // 159 9F
			texte = texte.replace(/&nbsp;/g,' '); // 160 A0
			texte = texte.replace(/&iexcl;/g,'¡'); // 161 A1
			texte = texte.replace(/&cent;/g,'¢'); // 162 A2
			texte = texte.replace(/&pound;/g,'£'); // 163 A3
			texte = texte.replace(/&curren;/g,' '); // 164 A4
			texte = texte.replace(/&yen;/g,'¥'); // 165 A5
			texte = texte.replace(/&brvbar;/g,'¦'); // 166 A6
			texte = texte.replace(/&sect;/g,'§'); // 167 A7
			texte = texte.replace(/&uml;/g,'¨'); // 168 A8
			texte = texte.replace(/&copy;/g,'©'); // 169 A9
			texte = texte.replace(/&ordf;/g,'ª'); // 170 AA
			texte = texte.replace(/&laquo;/g,'«'); // 171 AB
			texte = texte.replace(/&not;/g,'¬'); // 172 AC
			texte = texte.replace(/&shy;/g,'­'); // 173 AD
			texte = texte.replace(/&reg;/g,'®'); // 174 AE
			texte = texte.replace(/&macr;/g,'¯'); // 175 AF
			texte = texte.replace(/&deg;/g,'°'); // 176 B0
			texte = texte.replace(/&plusmn;/g,'±'); // 177 B1
			texte = texte.replace(/&sup2;/g,'²'); // 178 B2
			texte = texte.replace(/&sup3;/g,'³'); // 179 B3
			texte = texte.replace(/&acute;/g,'´'); // 180 B4
			texte = texte.replace(/&micro;/g,'µ'); // 181 B5
			texte = texte.replace(/&para/g,'¶'); // 182 B6
			texte = texte.replace(/&middot;/g,'·'); // 183 B7
			texte = texte.replace(/&cedil;/g,'¸'); // 184 B8
			texte = texte.replace(/&sup1;/g,'¹'); // 185 B9
			texte = texte.replace(/&ordm;/g,'º'); // 186 BA
			texte = texte.replace(/&raquo;/g,'»'); // 187 BB
			texte = texte.replace(/&frac14;/g,'¼'); // 188 BC
			texte = texte.replace(/&frac12;/g,'½'); // 189 BD
			texte = texte.replace(/&frac34;/g,'¾'); // 190 BE
			texte = texte.replace(/&iquest;/g,'¿'); // 191 BF
			texte = texte.replace(/&Agrave;/g,'À'); // 192 C0
			texte = texte.replace(/&Aacute;/g,'Á'); // 193 C1
			texte = texte.replace(/&Acirc;/g,'Â'); // 194 C2
			texte = texte.replace(/&Atilde;/g,'Ã'); // 195 C3
			texte = texte.replace(/&Auml;/g,'Ä'); // 196 C4
			texte = texte.replace(/&Aring;/g,'Å'); // 197 C5
			texte = texte.replace(/&AElig;/g,'Æ'); // 198 C6
			texte = texte.replace(/&Ccedil;/g,'Ç'); // 199 C7
			texte = texte.replace(/&Egrave;/g,'È'); // 200 C8
			texte = texte.replace(/&Eacute;/g,'É'); // 201 C9
			texte = texte.replace(/&Ecirc;/g,'Ê'); // 202 CA
			texte = texte.replace(/&Euml;/g,'Ë'); // 203 CB
			texte = texte.replace(/&Igrave;/g,'Ì'); // 204 CC
			texte = texte.replace(/&Iacute;/g,'Í'); // 205 CD
			texte = texte.replace(/&Icirc;/g,'Î'); // 206 CE
			texte = texte.replace(/&Iuml;/g,'Ï'); // 207 CF
			texte = texte.replace(/&ETH;/g,'Ð'); // 208 D0
			texte = texte.replace(/&Ntilde;/g,'Ñ'); // 209 D1
			texte = texte.replace(/&Ograve;/g,'Ò'); // 210 D2
			texte = texte.replace(/&Oacute;/g,'Ó'); // 211 D3
			texte = texte.replace(/&Ocirc;/g,'Ô'); // 212 D4
			texte = texte.replace(/&Otilde;/g,'Õ'); // 213 D5
			texte = texte.replace(/&Ouml;/g,'Ö'); // 214 D6
			texte = texte.replace(/&times;/g,'×'); // 215 D7
			texte = texte.replace(/&Oslash;/g,'Ø'); // 216 D8
			texte = texte.replace(/&Ugrave;/g,'Ù'); // 217 D9
			texte = texte.replace(/&Uacute;/g,'Ú'); // 218 DA
			texte = texte.replace(/&Ucirc;/g,'Û'); // 219 DB
			texte = texte.replace(/&Uuml;/g,'Ü'); // 220 DC
			texte = texte.replace(/&Yacute;/g,'Ý'); // 221 DD
			texte = texte.replace(/&THORN;/g,'Þ'); // 222 DE
			texte = texte.replace(/&szlig;/g,'ß'); // 223 DF
			texte = texte.replace(/&agrave;/g,'à'); // 224 E0
			texte = texte.replace(/&aacute;/g,'á'); // 225 E1
			texte = texte.replace(/&acirc;/g,'â'); // 226 E2
			texte = texte.replace(/&atilde;/g,'ã'); // 227 E3
			texte = texte.replace(/&auml;/g,'ä'); // 228 E4
			texte = texte.replace(/&aring;/g,'å'); // 229 E5
			texte = texte.replace(/&aelig;/g,'æ'); // 230 E6
			texte = texte.replace(/&ccedil;/g,'ç'); // 231 E7
			texte = texte.replace(/&egrave;/g,'è'); // 232 E8
			texte = texte.replace(/&eacute;/g,'é'); // 233 E9
			texte = texte.replace(/&ecirc;/g,'ê'); // 234 EA
			texte = texte.replace(/&euml;/g,'ë'); // 235 EB
			texte = texte.replace(/&igrave;/g,'ì'); // 236 EC
			texte = texte.replace(/&iacute;/g,'í'); // 237 ED
			texte = texte.replace(/&icirc;/g,'î'); // 238 EE
			texte = texte.replace(/&iuml;/g,'ï'); // 239 EF
			texte = texte.replace(/&eth;/g,'ð'); // 240 F0
			texte = texte.replace(/&ntilde;/g,'ñ'); // 241 F1
			texte = texte.replace(/&ograve;/g,'ò'); // 242 F2
			texte = texte.replace(/&oacute;/g,'ó'); // 243 F3
			texte = texte.replace(/&ocirc;/g,'ô'); // 244 F4
			texte = texte.replace(/&otilde;/g,'õ'); // 245 F5
			texte = texte.replace(/&ouml;/g,'ö'); // 246 F6
			texte = texte.replace(/&divide;/g,'÷'); // 247 F7
			texte = texte.replace(/&oslash;/g,'ø'); // 248 F8
			texte = texte.replace(/&ugrave;/g,'ù'); // 249 F9
			texte = texte.replace(/&uacute;/g,'ú'); // 250 FA
			texte = texte.replace(/&ucirc;/g,'û'); // 251 FB
			texte = texte.replace(/&uuml;/g,'ü'); // 252 FC
			texte = texte.replace(/&yacute;/g,'ý'); // 253 FD
			texte = texte.replace(/&thorn;/g,'þ'); // 254 FE
			texte = texte.replace(/&yuml;/g,'ÿ'); // 255 FF
			return texte;
		}
		
		

		vm.newActivity = function (item, index) {
			vm.activites.push({
			  value: item.toLowerCase(),
			  display: item
			});
			
			var id = $(index.target).parents(".md-autocomplete-suggestions").attr('id');
			var classe = $(document).find(id.replace('ul-','#fl-input-')).parents('.activites').attr('class'); 
			
			vm.contact.Activites[classe.substring(0,classe.indexOf('a'))] = {
			  value: item.toLowerCase(),
			  display: item
			};
		}
	
	
		vm.querySearch = function (query) {
			var results = query ? vm.activites.filter( createFilterFor(query) ) : vm.activites, deferred;
			return results;
		}


		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query);
		    var accent = [
				/[\300-\306]/g, /[\340-\346]/g, // A, a
				/[\310-\313]/g, /[\350-\353]/g, // E, e
				/[\314-\317]/g, /[\354-\357]/g, // I, i
				/[\322-\330]/g, /[\362-\370]/g, // O, o
				/[\331-\334]/g, /[\371-\374]/g, // U, u
				/[\321]/g, /[\361]/g, // N, n
				/[\307]/g, /[\347]/g, // C, c
			];
			var noaccent = ['A','a','E','e','I','i','O','o','U','u','N','n','C','c'];
			 
			// var str = this;
			for(var i = 0; i < accent.length; i++){
				lowercaseQuery = lowercaseQuery.replace(accent[i], noaccent[i]);
			}
			
			
		  return function filterFn(state) {
			return (state.value.indexOf(lowercaseQuery) >= 0);
		  };

		}
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts.liste_produits',
            [
				'wt.responsive',
                // 3rd Party Dependencies
                // 'wipImageZoom',
               
                // 'flow',
                // 'nvd3',
                // 'textAngular',
                // 'uiGmapgoogle-maps',
                // 'xeditable'
            ]
        )
        .config(config);

	
    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.liste_produits', {
                url      : '/contacts/listeproduits',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/contacts/liste_produits/liste_produits.html',
                        controller : 'ListeProduitsController as vm'
                    }
                },
                resolve  : {
                    Factures: function (msApi)
                    {
                        return msApi.resolve('commandes.factures@get');
                    },
                    // nbrProduitsClientsParEtats: function (msApi)
                   /*  {
                        return msApi.resolve('commandes.nbrProduitsClientsParEtats@get');
                    }, */
                    Employes: function (msApi)
                    {
                        return msApi.resolve('commandes.Employes@get');
                    },
					employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.simpleListe@get');
                    },
                    Fabricants: function (msApi)
                    {
                        return msApi.resolve('commandes.fabricants@get');
                    }
                },
                bodyClass: 'factures'
            });

        // Api
        // msApiProvider.register('commandes.nbrProduitsClientsParEtats', ['datas/commandes/getNbrProduitsClientsParEtats.json']);
        msApiProvider.register('commandes.factures', ['datas/commandes/getAllFactures.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
        msApiProvider.register('commandes.Employes', ['datas/employes/getEmployes.json']);
        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts.liste_produits')
        .controller('ListeProduitsController', ListeProduitsController)	;

    /** @ngInject */


    function ListeProduitsController($state, employesSimple, Fabricants, Factures, $scope, $rootScope, $mdSidenav, Employes, $location, $mdDialog, $http, $mdToast, $window, $filter, $document, DTOptionsBuilder, DTColumnBuilder, $compile)
    {
		
		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		// console.log(Fabricants);
		
        var vm = this;
		vm.rows = [];
        // Data
        vm.factures = Factures.data;
        vm.employes = Employes.data;
		// vm.nbrProduitsClientsParEtats = nbrProduitsClientsParEtats.data;
		vm.showMarges = 0;
		
		// $http.get("datas/commandes/getNbrCommandesParEtats.json").then(function (response, status, headers, config) {vm.nbrProduitsClientsParEtats = response.data.data;}, function () {});
		
		
		vm.recordsTotal = 0;
		
        vm.filterChange = filterChange;
        vm.filterStatus = localStorage.getItem('produitsClientsStatus');
		if(vm.filterStatus == null)
			vm.filterStatus = '';
		
		// vm.filterChange(vm.filterStatus);
		
		vm.search = localStorage.getItem('produitsClientsSearch');
		vm.searchBox = "";
		
        vm.toggleSidenav = toggleSidenav;
		
		
		function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	

		function filterChange(type)
        {
// console.log(type);
            vm.filterStatus = type;
// console.log( vm.filterStatus);
			localStorage.setItem('produitsClientsStatus', type);

           /*  if ( type === '' )
            {
               vm.dtInstanceListeProduits.DataTable.column(6).search('', true, false, false ).draw();
            }
			else
				vm.dtInstanceListeProduits.DataTable.column(6).search(vm.filterStatus, true, false, false ).draw(); */
			// console.log(vm.filterStatus);
			$('.dataTable thead tr:nth-child(2) th:nth-child(8)').find('select').val(type);
			$('.dataTable thead tr:nth-child(2) th:nth-child(8)').find('select').trigger("change");
			// vm.dtInstanceListeProduits._renderer.rerender(); 
        }
		
		$(document).on('change', '.dataTable thead tr:nth-child(2) th:nth-child(8)', function(){
			// filterChange($(this).find('select').val());
			// console.log($(this).find('select').val());
			
            vm.filterStatus = $(this).find('select').val();
			// alert(vm.filterStatus);
			localStorage.setItem('produitsClientsStatus', $(this).find('select').val());
		});
		
		vm.openContactDialog = function (contact)
        {
			var contactObj = {IDContact:contact};
            $mdDialog.show({
                controller         : 'profilContactController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/contacts/profil/profil-dialog.html',
                parent             : angular.element($document.find('body')),
                clickOutsideToClose: true,
				multiple:true,
				fullscreen:true,
				openFrom  : '#previewContact',
				closeTo  : '#previewContact',
                locals             : {
					Contact: contactObj,
					Fabricants: Fabricants,
					employesSimple: employesSimple,
					Structures: {},
					APE: {},
					Activites: {},
					Commandes: {},
					Alertes: {},
					Courriers: {},
					Employes: {},
					Dialog:1
                }
            });
        }


		vm.filterSave = [];
        vm.dtInstanceListeProduits = {};
		
		vm.dtOptionsListeProduits = DTOptionsBuilder.newOptions()
		.withOption('ajax', {
			 dataSrc: 'datas',
			 url: 'datas/commandes/getAllProductsContacts.json',
			 type: 'GET'
		})
		.withDataProp('datas')
		.withOption('processing', true)
		.withOption('serverSide', true)
		.withOption('bStateSave', true)
		.withOption('iCookieDuration', 60*60*12)
		.withOption('stateSaveCallback', function (oSettings, oData) {
			localStorage.setItem( 'DataTablesProduitsProfil', JSON.stringify(oData) );
		})
		// .withOption('drawCallback', function (o) {
		/* 	  $('.scrollable').animate({  ??? GENANT D'APRES COLLABORATEURS
				scrollTop: 0
			  }, 'slow'); */
		// })
		.withOption('stateLoadCallback', function (oSettings) {
			return JSON.parse( localStorage.getItem('DataTablesProduitsProfil') );
		})
		.withOption('stateLoadParams', function( settings, data ) {
			vm.search= data.search.search;
			vm.filterSave = data.columns;
		})
		.withOption('columnDefs',   [
			{
				// Target the id column
				targets: 0,
				responsivePriority: 1,
			},
			// {
				// Target the id column
				// targets: 1,
				// responsivePriority: 1,
			// },
			{
				// Target the id column
				targets: 2,
				render : function (data, type)
				{
					if ( type === 'display' )
					{
						return convertDate(data);
					}

					return data;
				}
			},
			{
				// Target the price column
				targets: 4,
				"type": "num-fmt",
				render : function (data, type)
				{
					if ( type === 'display' )
					{
						return formatter.format(data);
					}

					return data;
				}
			},  
			{
				// Target the price column
				targets: 5,
				"type": "num-fmt",
				render : function (data, type)
				{
					if ( type === 'display' )
					{
						return formatter.format(data);
					}

					return data;
				}
			},        {
				// Target the actions column
				targets           : 8,
				responsivePriority: 1,
				filterable        : false,
				sortable          : false
			}
		]) 
		.withOption('responsive', {
			details: {
				display: $.fn.dataTable.Responsive.display.childRowImmediate,
				type: 'none',
				target: ''
			}
		})
		.withOption('pagingType', 'simple')
		.withOption('lengthMenu', [50, 100, 250])
		.withPaginationType('simple')
		.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
		.withOption('createdRow', function(row, data, dataIndex) {
			
			$compile(angular.element(row).contents())($scope);
		})
		
		.withOption('drawCallback', function(settings, json) {
				var api = this.api();
				vm.recordsProduitsEnCours = api.ajax.json().recordsProduitsEnCours;
				vm.recordsTotal = api.ajax.json().recordsProduitsEnCours + api.ajax.json().recordsProduitsTermines;
			}
		)
		.withLightColumnFilter({
		  "0": {
			"html": "input",
			"type": "text",
			"location": $location
		  },
		  "1": {
			"html": "input",
			"type": "text",
			"location": $location
		  },
		  "2": {
			"html": "input",
			"type": "text",
			"location": $location
		  },
		  "3": {
			"html": "select",
			"values": employesSimple.data,
			"location": $location,
			"regex":true
		  },
		  "4": {
			"html": "range",
			"type": "number",
			"location": $location
		  },
		  "5": {
			"html": "select",
			"values": [
				{value: '', label: '--'}, 
				{value: '24', label: '24 mois'}, 
				{value: '12', label: '12 mois'}, 
				{value: '11', label: '11 mois'}, 
				{value: '10', label: '10 mois'}, 
				{value: '9', label: '9 mois'}, 
				{value: '8', label: '8 mois'}, 
				{value: '7', label: '7 mois'}, 
				{value: '6', label: '6 mois'}, 
				{value: '5', label: '5 mois'}, 
				{value: '4', label: '4 mois'}, 
				{value: '3', label: '3 mois'}, 
				{value: '2', label: '2 mois'}, 
				{value: '1', label: '1 mois'}, 
				{value: '0', label: 'Sans'}, 
			],
			"location": $location,
			"regex":true
		  },
		  "7": {
			"html": "select",
			"values": [
				{value: '', label: '--'}, 
				{value: '0', label: 'En cours'}, 
				{value: '1', label: 'Terminés'}, 
			],
			"location": $location,
			"regex":true
		  },
		  "6": {
			"html": "range",
			"type": "date",
			"location": $location
		  },
		  "8": {
			"html": "clear",
			"status":"produitsClientsStatus"
		  }
	  })
		.withOption('headerCallback', function(header) {
			if (!vm.headerCompiled) {
				// Use this headerCompiled field to only compile header once
				vm.headerCompiled = true;
				$compile(angular.element(header).contents())($scope);
			}
		})
		.withOption('initComplete', function(settings, json) {
			var api = this.api();
				// vm.searchBox = angular.element('body').find('#commandes-search');

			angular.forEach(vm.filterSave, function(value, key) {
				var cpt = key+1;
				if(value.search.search.includes("~")){
					jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
					jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
					
				} else{
					jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
					jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
				}
			}); 				
			
			if ( vm.searchBox.length > 0 )
			{
				var timeout = null;
				
				vm.searchBox.on('keyup', function (event)
				{
					clearTimeout(timeout);
					timeout = setTimeout(function () {
						api.search(vm.search).draw();
					}, 500);
				});
			}
			
			// vm.recordsTotal = json.recordsTotal;
		  } 
		)
		
		  
		.withLanguage({
		  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
		  'processing':'test',
			"sSearch":         "Rechercher&nbsp;:",
			"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
			"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
			"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
			"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			"sInfoPostFix":    "",
			"sLoadingRecords": "Chargement en cours...",
			"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
			"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
			"oPaginate": {
				"sFirst":      "Premier",
				"sPrevious":   "Pr&eacute;c&eacute;dent",
				"sNext":       "Suivant",
				"sLast":       "Dernier"
			},
			"oAria": {
				"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
				"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
			}
		})
		.withOption('fnRowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
			 // $('td', nRow).unbind('click');
				// $('td', nRow).bind('click', function() {
				// console.log(nRow);
				// openContactDialog(aData);
				  // $scope.$apply(function() {
					// vm.expend(nRow, aData);
				// });  
			// });
			// return nRow;
		})
		.withOption('order', [6, 'desc']);


		vm.dtColumnsListeProduits = [
			DTColumnBuilder.newColumn('NumeroCommande').withTitle('<div class="table-header"><span class="column-title">N° Commande</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				var html = '<a ng-click="vm.DetailsCommande($event, '+full.IDCommande+')" href="#">'+data+"</a>"
				// console.log(data);
				if(full.ComConsultants == 1)
					html += '<br><span class="blue-600-fg">Com-Consultants le '+convertDate(full.DateFacturation)+'</span>';	
				
				if(full.NumeroFacture)
					html += '<br><span> '+full.NumeroFacture+' - '+convertDate(full.DateFacturation)+'</span>';	
				
				// if(full.NomCommande && full.Etat != 'Facturée')
				if(full.NomCommande)
					html += '<em><br> '+full.NomCommande+'</em>';	
				
				return html;
			}),
			/* DTColumnBuilder.newColumn('NumeroFacture').withTitle('<div class="table-header"><span class="column-title">N° Facture</div></div>').withOption('width', '80px').renderWith(function(data, type, full){
				var html = "";
				
				
				if(full.NumeroFacture)
					html += data+'<br>'+convertDate(full.DateFacturation)+'</span>';	
				
				
				return html;
			}), */
			DTColumnBuilder.newColumn('Produit').withTitle('<div class="table-header"><span class="column-title">Produit</div></div>').renderWith(function(data, type, full, meta ){
				var html = "<span>"+full.Quantite +" X "+  full.Produit+"</span>";
				// if(full.EtatProduit != 1)
				if(full.EtatProduit == null)		
					html += ' <small class=" p-5 pr-8 pl-8 ml-8 brad-16 md-grey-bg white-fg" ><small>Ocasionnel</small></small>';
				if(full.EtatProduit == 0)
					html += ' <small class=" p-5 pr-8 pl-8 ml-8 brad-16 md-red-900-bg md-hue-2 white-fg" ><small>Non dispo.</small></small>';
				
				return html;
			}),
			DTColumnBuilder.newColumn('RaisonSocial').withTitle('<div class="table-header"><span class="column-title">Contact</div></div>').withOption('width', '400px').renderWith(function(data, type, full, meta ){
				return '<a ng-click="vm.openContactDialog('+ full.IDContact +')" href="#">'+data+"</a>";
				// return full.RaisonSocial;
			}),
			DTColumnBuilder.newColumn('Commercial').withTitle('<div class="table-header"><span class="column-title">Commercial</div></div>').withOption('width', '220px').renderWith(function(data, type, full, meta ){
			
				vm.rows[meta.row] = full;
				
				if ( type === 'display' ){
					var html ="";
						if(full.CommercialSupprime=="1")
							html += '<span class="grey-600-fg">'+full.Commercial+'<md-tooltip md-direction="left" >Compte supprimé</md-tooltip></span>';
						else{
							// if(full.CommercialNonModifiable)
								html += '<span>'+full.Commercial+'</span>';
							// else
								// html += '<a href="#" editable-select="vm.rows['+meta.row+'].IDEmploye"  onaftersave="vm.saveCommercialCommandes('+meta.row+')" e-ng-options="s.IDEmploye.toString() as s.Civilite+\' \'+s.Prenom+\' \'+s.Nom for s in vm.employes"><span ng-bind-html="vm.showEmployes('+full.IDEmploye+')"></span></a>';
						}
				   return html;
				}
				return data;
			}),
			/* DTColumnBuilder.newColumn('Quantite').withTitle('<div class="table-header"><span class="column-title">Quantite</div></div>').renderWith(function(data, type, full, meta ){
				return full.Quantite;
			}), */
			
			DTColumnBuilder.newColumn('PrixVenteFinalHT').withTitle('<div class="table-header"><span class="column-title">Prix vente HT</div></div>').withOption('width', '100px').renderWith(function(data, type, full, meta ){
				if(parseInt(full.PrixVenteHTDefault) > parseInt(full.PrixVenteFinalHT))
					return full.PrixVenteFinalHT+" € <del class='red-900-fg'><small>"+full.PrixVenteHTDefault+" €</small></del>";
				else
					return full.PrixVenteFinalHT+" €";
			}),
			DTColumnBuilder.newColumn('Renouvellement').withTitle('<div class="table-header"><span class="column-title">Mensualités</div></div>').withOption('width', '100px').renderWith(function(data, type, full, meta ){
				if(full.Renouvellement > 0)
					return full.Renouvellement +" mois";
				else
					return "--";
			}),
			 DTColumnBuilder.newColumn('DateRenouvellement').withTitle('<div class="table-header"><span class="column-title">Date de fin</div></div>').withOption('width', '120px').renderWith(function(data, type, full, meta ){
				if(data!="0000-00-00" && data != "1970-01-01")
					return convertDate(data);
				else
					return "--";
			}),
		 	DTColumnBuilder.newColumn('EtatCommande').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '100px').renderWith(function(data, type, full, meta ){
				if(full.Renouvellement > 0)
					if(data == 0)
						return '<small class=" p-5 pr-8 pl-8 brad-16 md-blue-bg md-hue-2 white-fg" ><small>En cours</small></small>';
					else
						return '<small class=" p-5 pr-8 pl-8 brad-16 md-grey-bg md-hue-2 white-fg" ><small>Terminé</small></small>';
				else
					return '<small class=" p-5 pr-8 pl-8 brad-16 md-grey-bg md-hue-2 white-fg" ><small>Terminé</small></small>';
			}),
	
			DTColumnBuilder.newColumn('IDCommande').withTitle('<div class="table-header"><span class="column-title"></div></div>').withOption('width', '60px').renderWith(function(data, type, full){
				
				
				var html = '<md-menu style="float: right;">'+
						'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
							'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
						'</md-button>'+
						'<md-menu-content width="3">';
						
				html += '<md-menu-item>'+ 
							'<md-button ng-click="vm.DetailsCommande($event, '+full.IDCommande+')">'+ 
								'Aperçu commande'+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-divider >'+'</md-divider>';
				html += '<md-menu-item>'+
							'<md-button ng-click="vm.dupliqueCommande('+full.IDCommande+')">'+
								'Dupliquer commande'+
							'</md-button>'+
						'</md-menu-item>';			
			
				html += '</md-menu-content>'+'</md-menu>';
				return html; 
			}), 
		];	
			
			
		vm.showEmployes = function(commande){
			 var selected = $filter('filter')(vm.employes, {IDEmploye: commande.toString()}, true);
			return (commande && selected.length) ? selected[0].Civilite+' '+selected[0].Prenom+' '+selected[0].Nom : 'Non défini';
		}
		
		vm.dupliqueCommande = function (IDCommande){
			$http.post("/datas/commandes/dupliquer.json",{'IDCommande':IDCommande})
			.then(function (response, status, headers, config) {
				editCommande(response.data.data.IDCommande);
			}, function () {});	
		}
		
		
        vm.sendFactureEmail = function (ev, IDCommande, IDCommandes_Paiement, RaisonSocial, NumeroFacture, IDContact, EmailSend, EmailSendTo, IDContact_Responsables)
        {
			if(EmailSend!="0000-00-00 00:00:00"){
				var confirm = $mdDialog.confirm()
				  .title(' Cette facture a déjà été envoyée le ' + convertDate(EmailSend) + " à " + EmailSendTo)
				  .textContent("Souhaitez-vous la renvoyer à la même personne ou à quelqu'un d'autre ?")
				  .ariaLabel("Renvoyer la facture")
				  .targetEvent(ev)
					.theme('md-warn')
				  .ok("Renvoyer la facture")
				  .cancel('Annuler');
			
				$mdDialog.show(confirm).then(function () {
					vm.selectContactToSend(ev, IDCommande, IDCommandes_Paiement, RaisonSocial, NumeroFacture, IDContact, EmailSend, EmailSendTo, IDContact_Responsables);
				}, function () {
				});
			}
			else
				vm.selectContactToSend(ev, IDCommande, IDCommandes_Paiement, RaisonSocial, NumeroFacture, IDContact, EmailSend, EmailSendTo, IDContact_Responsables);
		}
		
		vm.selectContactToSend = function (ev, IDCommande, IDCommandes_Paiement, RaisonSocial, NumeroFacture, IDContact, EmailSend, EmailSendTo, IDContact_Responsables){
			$http.get("/datas/contacts/getContactInfoByID.json?IDContact="+IDContact)
            // La transmission dématérialisée ne dépend pas d'une adresse email.
            .catch(function () { return {data:{data:[]}}; })
			.then(function (response, status, headers, config) {
				var contacts = response.data.data || [];
				
				if(contacts){
					
					$mdDialog.show({
						controller: 'ContactsSendFactureController',
							templateUrl        : 'app/main/commandes/factures/dialogs/contacts-sendfactures-dialog.html',
							parent: angular.element(document.body),
							targetEvent: ev,
							controllerAs       : 'vm',
							clickOutsideToClose:true,
							locals             : {
								contacts : contacts,
								NumeroFacture : NumeroFacture,
								RaisonSocial : RaisonSocial
							}
						})
						.then(function(response) {
							
							if(typeof response != "undefined"){
								
								if(typeof response.data != "undefined" && response.data.error){
									$mdToast.show(
									  $mdToast.simple()
										.textContent(response.data.error.message)
										.position('bottom right' )
										.hideDelay(3000)
									);
									vm.showSpinner = 0;
								}
								else {
									(response.EnvoiPlateforme ?
                                        $http.post("/datas/commandes/transmettreFacture.json", {
                                            IDContact_Responsables: response.EnvoiEmail ? response.IDContact_Responsables : undefined,
                                            IDCommande: IDCommande, IDPaiement: IDCommandes_Paiement,
                                            Canal: response.EnvoiEmail ? "email_plateforme" : "plateforme"
                                        }) :
                                        $http.get("/datas/commandes/sendFacture.json?IDContact_Responsables="+response.IDContact_Responsables+"&IDCommande="+IDCommande+"&IDPaiement="+IDCommandes_Paiement))
										.then(function (response) {
                                            var error = response.data.error;
                                            if (response.config.url === "/datas/commandes/transmettreFacture.json" && !error) {
                                                var canaux = response.data.data && response.data.data.Canaux;
                                                if (!canaux || !canaux.length || canaux.some(function (canal) {
                                                    return ["Envoyé", "Transmise", "Acceptée"].indexOf(canal.Statut) === -1;
                                                })) {
                                                    error = {message: canaux && canaux.length ?
                                                        canaux.map(function (canal) { return canal.Canal + " : " + canal.Statut + (canal.Message ? " — " + canal.Message : ""); }).join(". ") :
                                                        "Réponse de transmission incomplète. Vérifier les statuts avant un nouvel envoi."};
                                                }
                                            }
                                            if (!error) vm.dtInstanceListeProduits.reloadData();
                                            $mdToast.show($mdToast.simple().textContent(error ? error.message : "Facture envoyée avec succès !")
                                                .position('bottom right').hideDelay(3000));
                                        }, function () {
                                            $mdToast.show($mdToast.simple().textContent("Réponse non reçue. Vérifier les statuts avant de renvoyer la facture.")
                                                .position('bottom right').hideDelay(5000));
                                        });	 
								}
			
							} 
							
							/* Etat = "Facturée";
							DateFacturation = Date.now();
							if(typeof result != "undefined"){
								var d = new Date(result),
								month = '' + (d.getMonth() + 1),
								day = '' + d.getDate(),
								year = d.getFullYear();

								if (month.length < 2) month = '0' + month;
								if (day.length < 2) day = '0' + day;
								
								DateRenouvellement = [year, month, day].join('-');
							}
							// writeCommande();
							$mdToast.show(
							  $mdToast.simple()
								.textContent('La commande a été facturée !')
								.position('bottom right' )
								.hideDelay(3000)
							);
							
							$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank'); */
							 vm.dtInstanceListeProduits.reloadData();
							console.log(contacts);
						
						}, function() {
						});
						
				 
				}
				else
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Aucun contact trouvé...')
						.position('bottom right' )
						.hideDelay(3000)
					);
				
			}, function () {});	 
		}
		
        vm.getFacture = function (ev, IDCommande, IDCommandes_Paiement)
        {
			console.log(IDCommandes_Paiement);
			if(IDCommandes_Paiement != 0)
				$window.open("/datas/commandes/afacture.json?IDCommande="+IDCommande+'&IDPaiement='+IDCommandes_Paiement, '_blank');
			else
				$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande, '_blank');
			/* if(Etat != "Facturée"/){
				$http.get("/datas/commandes/getCommande.json?IDCommande="+IDCommande)
				.then(function (response, status, headers, config) {
					var comde = response.data.data;
					var produit_a_renouveler = [];
					
					angular.forEach(comde.produits, function (value, key) {
						if(value.Renouvellement > 0 ){
							produit_a_renouveler.push({'Produit':value.Produit,'Renouvellement':value.Renouvellement});
						}
						
						angular.forEach(value.SousProduitsSelect, function (v, k) {
							if(v.Renouvellement > 0 ){
								produit_a_renouveler.push({'Produit':v.Produit,'Renouvellement':v.Renouvellement});
							}
						});
					});
					
					if(produit_a_renouveler.length > 0 && TotalTTC>0){
						$mdDialog.show({
						  controller: 'DialogFactureController',
							templateUrl        : 'app/main/commandes/commande/dialogs/facture-dialog.html',
						  parent: angular.element(document.body),
						  targetEvent: ev,
						  clickOutsideToClose:true,
							locals             : {
								Renouvellement : DateRenouvellement,
								produit_a_renouveler : produit_a_renouveler
							}
						})
						.then(function(result) {
							Etat = "Facturée";
							DateFacturation = Date.now();
							if(typeof result != "undefined"){
								var d = new Date(result),
								month = '' + (d.getMonth() + 1),
								day = '' + d.getDate(),
								year = d.getFullYear();

								if (month.length < 2) month = '0' + month;
								if (day.length < 2) day = '0' + day;
								
								DateRenouvellement = [year, month, day].join('-');
							}
							// writeCommande();
							$mdToast.show(
							  $mdToast.simple()
								.textContent('La commande a été facturée !')
								.position('bottom right' )
								.hideDelay(3000)
							);
							
							$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
							 vm.dtInstanceListeProduits.reloadData();
						
						}, function() {
						});
					}
					else{
						
						
						if(TotalTTC<0)
							var confirm = $mdDialog.confirm()
							  .title(' Souhaitez-vous faire un avoir ? ')
							  .textContent("Une fois l'avoir généré, cette commande ne pourra plus être modifiée.")
							  .ariaLabel("Générer l'avoir")
							  .targetEvent(ev)
								.theme('md-warn')
							  .ok("Générer l'avoir")
							  .cancel('Annuler');
						else
							var confirm = $mdDialog.confirm()
							  .title(' Souhaitez-vous facturer cette commande ? ')
							  .textContent('Une fois facturée, cette commande ne pourra plus être modifiée. ')
							  .ariaLabel('Facturer la commande')
							  .targetEvent(ev)
								.theme('md-warn')
							  .ok('Générer la facture')
							  .cancel('Annuler');

						$mdDialog.show(confirm).then(function () {
						  	  
								$mdToast.show(
								  $mdToast.simple()
									.textContent('La commande a été facturée !')
									.position('bottom right' )
									.hideDelay(3000)
								);
								
								$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
								 vm.dtInstanceListeProduits.reloadData();
						}, function () {
						});
					  
					}
				}, function () {});	 
			}
			else{
				$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
					 // vm.dtInstanceListeProduits.reloadData();
			}  */
		
        }
		
			  
		function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		function DialogDevisController($scope, $mdDialog) {
			$scope.hide = function() {
			  $mdDialog.hide();
			};
			
			$scope.items = ["Conditions Générales de Ventes", "Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>", "Cahier des charges fonctionnel"];
			$scope.selected = ["Conditions Générales de Ventes"];

			$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
			};

			$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
			};
		  
			$scope.cancel = function() {
			  $mdDialog.cancel();
			};

			$scope.answer = function(result) {
			  $mdDialog.hide(result);
			};
		}
	
		vm.getFactureAcompte = function (ev, commande){
			
			$http.get("/datas/commandes/getCommande.json?IDCommande="+commande)
			.then(function (response, status, headers, config) {
				// console.log(response.data.data);
				$mdDialog.show({
					 parent             : angular.element(document.body),
					targetEvent        : ev,
					controller         : 'DialogFactureAcompteController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commandes/dialogs/acompte-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande : response.data.data,
						Paiements : response.data.data.paiements,
						dtInstanceListeProduits : vm.dtInstanceListeProduits
					}
				});
				
					 // vm.dtInstanceListeProduits.reloadData();
			}, function () {});
		}
		
		vm.getDevisSigne = function (ev, IDCommande, NumeroCommande){
			// console.log(IDCommande);
			// console.log(NumeroCommande);
			$window.open("/datas/files/devis_signes/"+IDCommande+"-"+NumeroCommande+".pdf", '_blank');
		}
		
		vm.getDevis = function (ev, IDCommande, prelevement){
			if(prelevement ==1){
				var confirm = $mdDialog.confirm()
					  .title('Attention, IBAN du contact manquant !')
					  .textContent("L'IBAN sera obligatoire pour valider une commande par prélévement")
					  .ariaLabel('IBAN manquant')
					  .targetEvent(ev)
					  .clickOutsideToClose(true)
					  .parent(angular.element(document.body))
					  .ok('Continuer')
					  .cancel('Annuler');
					  
					$mdDialog.show(confirm).then(function() {
						 $mdDialog.show({
						  controller: DialogDevisController,
							templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
						  parent: angular.element(document.body),
						  targetEvent: ev,
						  clickOutsideToClose:true
						})
						.then(function(result) {
							var lien = "/datas/commandes/devis.json?IDCommande="+IDCommande;
							
							if(result.indexOf("Conditions Générales de Ventes")>=0)
								lien +="&cgv=1";
							else
								lien +="&cgv=0";
							if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
								lien +="&retractation=1";
							else
								lien +="&retractation=0";
							
							$window.open(lien, '_blank');
						}, function() {
					});
				}, function() {}); 
			}
			else{
			   $mdDialog.show({
					  controller: DialogDevisController,
						templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
					  parent: angular.element(document.body),
					  targetEvent: ev,
					  clickOutsideToClose:true
					})
					.then(function(result) {
						var lien = "/datas/commandes/devis.json?IDCommande="+IDCommande;
						
						if(result.indexOf("Conditions Générales de Ventes")>=0)
							lien +="&cgv=1";
						else
							lien +="&cgv=0";
						if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
							lien +="&retractation=1";
						else
							lien +="&retractation=0";
						
						$window.open(lien, '_blank');
					}, function() {
				});
			}
		}
		
		vm.deleteCommande = function (ev, commande, NumeroCommande)
        {
			var commandeObj = {IDCommande:commande};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer cette commande ?')
                .htmlContent('<b>La commande N°' + NumeroCommande + '</b>' + ' va être supprimée.')
                .ariaLabel('Supprimer une commande')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/commandes/deleteCommande.json", JSON.stringify(commandeObj)).then(function (response, status, headers, config) {  
					if(response.data.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.title("Une erreur s'est produite")
							.textContent(response.data.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.dtInstanceListeProduits.reloadData();
						$mdToast.show(
						  $mdToast.simple()
							.textContent('La commande a été supprimée.')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				}, function () {});
				
            });
        }
		
		

		vm.editOptions = function(ev, IDCommande){
			
		
		$http.get("/datas/commandes/getCommande.json?IDCommande="+IDCommande)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					parent             : angular.element(document.body),
					targetEvent        : ev,
					controller         : 'DialogOptionsCommandeController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commandes/dialogs/options-commande-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande :response.data.data
					}
				}).then(function(result) {
					 vm.dtInstanceListeProduits.reloadData();
				}, function () {});	
			}, function () {});
		}
		
		
		vm.DetailsCommande = function(ev, IDCommande){
			$mdDialog.show({
                parent             : angular.element(document.body),
                targetEvent        : ev,
                controller         : 'CommandesDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/commandes/dialogs/details-dialog.html',
                clickOutsideToClose: true,
                locals             : {
                    IDCommande : IDCommande,
					Fabricants : Fabricants,
					paramVM : vm
                },
            }).then(function(result) {
				if(result)
					vm.dtInstanceListeProduits.reloadData();
			}, function () {
				if(vm.reload){
					vm.dtInstanceListeProduits.reloadData();
					vm.reload = false;
				}
			});
		}
			
  
    }
	
	 
	  
})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts.corbeille',
            []
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.contacts_corbeille', {
            url    : '/contacts/corbeille',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/contacts/corbeille/corbeille.html',
                    controller : 'CorbeilleController as vm'
                }
            },
            resolve: {
                Corbeille: function (msApi)
                {
                    return msApi.resolve('contacts.corbeille@get');
                }
            }
        });


        // Api
        msApiProvider.register('contacts.corbeille', ['datas/contacts/getCorbeille.json']);


		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts.corbeille')
        .controller('CorbeilleController', CorbeilleController);

    /** @ngInject */
    function CorbeilleController($scope, Corbeille, msUtils, $mdDialog, $mdToast, $document, $mdMenu, $location, $http)
    {

        var vm = this;

        // Data
        vm.contacts = Corbeille.data;
        vm.filterStatus = '';
        vm.listType = 'all';
        vm.listOrder = 'RaisonSociale';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
		vm.tags = [];
		console.log(vm.contacts);
		vm.recordsTotal = vm.contacts.length;
        // Methods
        // vm.filterChange = filterChange;
        vm.detailsContact = detailsContact;
        vm.openContactDialog = openContactDialog;
        vm.restaurerContact = restaurerContact;
        vm.supprimerContact = supprimerContact;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

     
        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact)
        {
            $mdDialog.show({
                controller         : 'ContactDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/contacts/contacts/dialogs/contact/contact-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Contact : contact,
                    Contacts: vm.contacts
                }
            });
        }

		
        function supprimerContact(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer définitivement ce contact ?')
                .htmlContent('<b>' + contact.RaisonSocial + '</b>' + ' va être supprimé.')
                .ariaLabel('Supprimer un contact')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				vm.contacts.splice(vm.contacts.indexOf(contact), 1);
				$http.post("/datas/contacts/deleteCorbeille.json", JSON.stringify(contact));
				$mdToast.show(
				  $mdToast.simple()
					.textContent('Le contact a été supprimé !')
					.position('bottom right' )
					.hideDelay(3000)
				);
            },function(){});
        }
		
        function restaurerContact(contact, ev)
        {
			vm.contacts.splice(vm.contacts.indexOf(contact), 1);
			$http.post("/datas/contacts/restaurerContact.json", JSON.stringify(contact));
			$mdToast.show(
			  $mdToast.simple()
				.textContent('Le contact a été restauré !')
				.position('bottom right' )
				.hideDelay(3000)
			);
        }


        /**
         * Delete Selected Contacts
         */
        function deleteSelectedContacts(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the selected contacts?')
                .htmlContent('<b>' + vm.selectedContacts.length + ' selected</b>' + ' will be deleted.')
                .ariaLabel('delete contacts')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.selectedContacts.forEach(function (contact)
                {
                    deleteContact(contact);
                });

                vm.selectedContacts = [];

            });

        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectContact(contact, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedContacts.indexOf(contact) > -1 )
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            }
            else
            {
                vm.selectedContacts.push(contact);
            }
        }

        /**
         * Deselect contacts
         */
        function deselectContacts()
        {
            vm.selectedContacts = [];
        }

        /**
         * Sselect all contacts
         */
        function selectAllContacts()
        {
            vm.selectedContacts = $scope.filteredContacts;
        }


		vm.select = function (item)
        {
            vm.selected = item;
        }
		
		function detailsContact(contact){
			$location.path('/contacts/profil/'+contact.IDContact);
		}
		
		vm.go = function (url){
			$location.path(url);
		}

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts.liste',
            [
                // 3rd Party Dependencies
                'xeditable',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.contacts', {
            url    : '/contacts',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/contacts/contacts/contacts.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return 0;
                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                },
				employesSimple: function (msApi)
				{
					return msApi.resolve('employes.simpleListe@get');
				},
                Structures    : function (msApi)
                {
                    return msApi.resolve('profilContact.structures@get');
                },
                APE    : function (msApi)
                {
                    return msApi.resolve('profilContact.APE@get');
                },
                Activites    : function (msApi)
                {
                    return msApi.resolve('profilContact.Activites@get');
                },
				Employes: function (msApi)
				{
					return msApi.resolve('commandes.Employes@get');
				},
				Fabricants: function (msApi)
				{
					return msApi.resolve('commandes.fabricants@get');
				},
				simpleListeActivites: function (msApi)
				{
					return msApi.resolve('contacts.simpleListeActivites@get');
				},
				nbrContactsParEtats: function (msApi)
				{
					return msApi.resolve('contacts.nbrContactsParEtats@get');
				}
            }
        });


        // Api
        // msApiProvider.register('contacts.contacts', ['datas/contacts/getAll.json']);
        msApiProvider.register('contacts.user', ['datas/contacts/user.json']);
        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
        msApiProvider.register('profilContact.structures', ['/datas/contacts/getStructures.json']);
        msApiProvider.register('profilContact.APE', ['/datas/contacts/getAPE.json']);
        msApiProvider.register('profilContact.Activites', ['/datas/contacts/getActivites.json']);
        msApiProvider.register('commandes.Employes', ['datas/employes/getEmployes.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
        msApiProvider.register('contacts.simpleListeActivites', ['datas/contacts/simpleListeActivites.json']);
        msApiProvider.register('contacts.nbrContactsParEtats', ['datas/contacts/getNbrContactsParEtats.json']);


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts.liste')
        .controller('ContactsController', ContactsController)
		.filter('phoneNumber', function () {
			return function (number) {
				if (!number) { return ''; }
				number = String(number);
				number = number.replace(/[^0-9]*/g, '');
	 
				var area = "0" + number.substring(number.length-9, number.length);
				
				return area.replace(/(.{2})(?!$)/g,"$1 ");
			};
		}) 
		.controller('RightCtrl', function ($scope, $timeout, $mdSidenav, $log) {
			$scope.close = function () {
			  // Component lookup should always be available since we are not using `ng-if`
			  $mdSidenav('right').close()
				.then(function () {
				});
			};
	  });
    /** @ngInject */
    function ContactsController(simpleListeActivites, nbrContactsParEtats, employesSimple , Structures, APE, Fabricants, Activites, Employes, $scope, $mdSidenav, Contacts, User, msUtils, $mdToast,$mdDialog, $document, $mdMenu, $location, $http, DTOptionsBuilder, DTColumnBuilder, $compile)
    {
		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});

		
        var vm = this;

		vm.nbrContactsParEtats = nbrContactsParEtats.data;
		$http.get("datas/contacts/getNbrContactsParEtats.json").then(function (response, status, headers, config) {vm.nbrContactsParEtats = response.data.data;}, function () {});
		
		vm.recordsTotal = 0;
        // Data
        vm.contacts = Contacts.data;
        vm.user = User.data;
        vm.listType = 'all';
        vm.listOrder = 'RaisonSociale';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
		vm.tags = [];
		vm.search = localStorage.getItem('contactsSearch');
        // Methods
        vm.detailsContact = detailsContact;
        vm.openContactDialog = openContactDialog;
        vm.corbeilleContact = corbeilleContact;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
		vm.searchBox = "";
		
		
		
		vm.filterChange = filterChange;
        vm.filterStatus = localStorage.getItem('contactsStatus');
		
		if(vm.filterStatus == null)
			vm.filterStatus = '';
	// console.log(vm.filterStatus);

		function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
		
	
		vm.expend = function(tr, contact){
			// console.log('RightCtrl');
			var row = vm.dtInstance.DataTable.row( tr );
			if ( row.child.isShown() ) {
				// This row is already open - close it
				row.child.hide();
				angular.element(tr).next().removeClass('shown');
				angular.element(tr).removeClass('expend');
			}
			else {
				// Open this row
				row.child( format(row.data()) ).show();
				angular.element(tr).next().addClass('shown');
				angular.element(tr).addClass('expend');
			}
			
		}
	  
	  
		vm.filterSave = [];
        vm.dtInstance = {};
    		
		 vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'data',
				 url: 'datas/contacts/getAll.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'DataTablesContacts', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
				  // $('.scrollable').animate({  ??? GENANT D'APRES COLLABORATEURS
					// scrollTop: 0
				  // }, 'slow');
			})
			.withOption('stateLoadCallback', function (oSettings) {
				return JSON.parse( localStorage.getItem('DataTablesContacts') );
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('columnDefs',  [
                {
                    // Target the id column
                    targets: 0,
                    responsivePriority: 1,
                },
                {
                    // Target the id column
                    targets: 1,
                    responsivePriority: 2,
                },
                {
                    // Target the price column
                    targets: 4,
                    responsivePriority: 2,
                },        {
                    // Target the actions column
                    targets           : 7,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				// Recompiling so we can bind Angular directive to the DT
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					// Use this headerCompiled field to only compile header once
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
				var api = this.api();
                    vm.searchBox = angular.element('body').find('#contacts-search');

				angular.forEach(vm.filterSave, function(value, key) {
					var cpt = key+1;
					if(value.search.search.includes("~")){
						jQuery('.dataTableContacts tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
						jQuery('.dataTableContacts tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
						
					} else{
						jQuery('.dataTableContacts tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
						jQuery('.dataTableContacts tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
					}
				}); 

                if ( vm.searchBox.length > 0 )
                {
					var timeout = null;
					
                    vm.searchBox.on('keyup', function (event)
                    {
						clearTimeout(timeout);
						timeout = setTimeout(function () {
							api.search(vm.search).draw();
						}, 500);
                    });
                }
				
				vm.recordsTotal = json.recordsTotal;
				filterChange(vm.filterStatus);
			  }
			)
			.withLightColumnFilter({
				  "0": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "1": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "2": {
					"html": "input",
					"type": "tel",
					"location": $location
				  },
				  "3": {
					"html": "select",
					"values": simpleListeActivites.data,
					"location": $location,
					"regex":true
				  },
				
				  "4": {
					"html": "select",
					"values": [
						{value: '', label: '--'}, 
						{value: 'Client', label: 'Clients'}, 
						{value: 'Prospect', label: 'Prospects'}, 
						{value: 'Suspect', label: 'Suspects'}, 
						{value: "Fin d'activité", label: "Fin d'activité"	},
						{value: "Ancien client", label: 'Anciens clients'	},
						{value: "Annulé", label: 'Annulés'	},
						// {value: "Fermé", label: 'Fermés'	}
					],
					"location": $location,
					"regex":true
				  },
				  "5": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "6": {
					"html": "range",
					"type": "number",
					"location": $location
				  },
				  "7": {
					"html": "clear",
					"status":"contactsStatus",
				  }
			  }) 
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('fnRowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
				 $('td', nRow).unbind('click');
					$('td', nRow).bind('click', function() {
					// console.log(nRow);
					openContactDialog(aData);
                      // $scope.$apply(function() {
                        // vm.expend(nRow, aData);
                    // });  
                });
                return nRow;
            })
			.withOption('order', [0, 'DESC']);;
	
				
			vm.dtColumns = [
				DTColumnBuilder.newColumn('IDContact').withTitle('<div class="table-header"><span class="column-title">#</div></div>').withOption('width', '70px'),
				DTColumnBuilder.newColumn('RaisonSocial').withTitle('<div class="table-header"><span class="column-title">Raison sociale</div></div>').renderWith(function(data, type, full){
					var html = '<span class="text-truncate font-weight-600">'+ data.toUpperCase() +'</span>';
					if(full.CommercialSupprime!=0)
						html += '<md-tooltip md-direction="left" >Commercial supprimé</md-tooltip>';
					html += '<span class="" >Suivi par : '+ full.Commercial +'</span>';
					return html;
				}),
				DTColumnBuilder.newColumn('Numero').withTitle('<div class="table-header"><span class="column-title">Téléphone</div></div>').withOption('width', '115px').renderWith(function(data, type, full){
					if(typeof(data) != "undefined" && data!=null)
						return data.toString().replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
					else
						return "";
				}),
				DTColumnBuilder.newColumn('Activites').withTitle('<div class="table-header"><span class="column-title">Activités</div></div>'),
				DTColumnBuilder.newColumn('Status').withTitle('<div class="table-header"><span class="column-title">Status</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
					if ( type === 'display' ){
						var html ="";
							
							switch(data){
								case "Fermé": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-grey-500-bg white-fg" ><small>Fermé</small></span>'; break;
								case "Annulé": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-grey-500-bg white-fg" ><small>Annulé</small></span>'; break;
								case "Ancien client": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-warn-bg white-fg" ><small>Ancien client</small></span>'; break;
								case "Fin d'activité": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-grey-500-bg white-fg" ><small>Fin d\'activité</small></span>'; break;
								case "Suspect": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-blue-grey-500-bg white-fg" n><small>Suspect</small></span>'; break;
								case "Prospect": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-cyan-700-bg white-fg" ><small>Prospect</small></span>'; break;
								case "Client": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-green-bg white-fg" ><small>Client</small></span>'; break;
							}
                       return html;
					}
					return data;
				}),
				DTColumnBuilder.newColumn('DerniereCommande').withTitle('<div class="table-header"><span class="column-title">Dernière commande</div></div>').withOption('width', '90px').renderWith(function(data, type, full){
					if ( type === 'display' ){
						if(data != null)
							return convertDate(data);
					}
					return data;
				}),
				DTColumnBuilder.newColumn('CAHT').withTitle('<div class="table-header"><span class="column-title">CA HT</div></div>').withOption('width', '90px').renderWith(function(data, type, full){
					if ( type === 'display' ){
						return formatter.format(data);
					}
					return data;
				}),
				
				DTColumnBuilder.newColumn(null).withTitle('<div class="table-header"><span class="column-title"></div></div>').withOption('width', '60px').renderWith(function(data, type, full){
					return '<md-menu style="float: right;">'+
					'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
							'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
						'</md-button>'+

						'<md-menu-content width="3">'+
							'<md-menu-item>'+
								'<md-button ng-click="vm.detailsContact('+full.IDContact+', $event)">'+
									'Détails'+
								'</md-button>'+
							'</md-menu-item>'+

							'<md-divider ></md-divider>'+

							'<md-menu-item> '+
								'<md-button ng-click="vm.corbeilleContact({\'IDContact\':'+full.IDContact+', \'RaisonSocial\':\''+full.RaisonSocial.replace(/'/g, "\\'")+'\'}, $event)"> '+
									'Supprimer '+
								'</md-button>'+
							'</md-menu-item>'+
						'</md-menu-content>'+
					'</md-menu>';
						
				}),
			];
	
		function format ( contact ) {
			var html = '<div layout="row" layout-align="center center" ng-show="row.booleanVal" class="ng-scope layout-row layout-align-space-start-center"><div class="pb-16 pr-100"  >';
			
				if(typeof(contact.Prenom) != "undefined" && typeof(contact.Nom) != "undefined")
				html += '<p  class="mt-0"><strong>Contact général</strong></p> '+ contact.Civilite + ' ' +contact.Prenom+ ' ' +contact.Nom +'<br>';
				
				if(typeof contact.Numero !="undefined")
					html += '<a href="tel:'+contact.Numero+'">'+contact.Numero.toString().replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5') +'</a><br>';
				
				if(typeof contact.EmailPrive !="undefined")
					html += '<a href="mailto:'+contact.EmailPrive+'">'+contact.EmailPrive+'</a>';
				
				html+='</div>';
				html += '<div class="pb-16 pr-100" ><p  class="mt-0"><strong>Horaires</strong></p>'+
					contact.Horaires+
				'</div>';
				
				if(typeof contact.AdresseComplete !="undefined")
				html += '<div class="pb-16 pr-100"  >'+
					'<p  class="mt-0"><strong>'+contact.NomAdresse+'</strong></p> '+
					'<a href="https://www.google.com/maps/search/'+contact.RaisonSocial+'+'+contact.AdresseComplete+'/@'+contact.Latitude+','+contact.Longitude+',z=13" target="_blank">'+
						contact.Adresse+' <br> '+
						contact.CodePostal+' '+contact.Ville +
					'</a>'+
				'</div>'+
				'<div class="pb-16 pr-100" ><p  class="mt-0"><strong>Dates</strong></p> Inscription : '+contact.DateCreation+'<br>Modification : '+contact.DateModification+'</div>';
			html += '</div>';
			return html;
		}
        //////////

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.filterStatus = type;
			localStorage.setItem('contactsStatus', type);
			// console.log(vm.filterStatus);
          /*  if ( type === 'all' )
            {
               vm.dtInstance.DataTable.column(4).search('', true, false, false ).draw();
            }
			else
				vm.dtInstance.DataTable.column(4).search(vm.filterStatus, true, false, false ).draw();*/
			
			$('.dataTable thead tr:nth-child(2) th:nth-child(5)').find('select').val(type);
			$('.dataTable thead tr:nth-child(2) th:nth-child(5)').find('select').trigger("change");

        }

		$(document).on('change', '.dataTable thead tr:nth-child(2) th:nth-child(5)', function(){
			// filterChange($(this).find('select').val());
            vm.filterStatus = $(this).find('select').val();
			localStorage.setItem('contactsStatus', $(this).find('select').val());
			// console.log(vm.filterStatus);
		});
		
        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(contact)
        {
				
            $mdDialog.show({
                controller         : 'profilContactController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/contacts/profil/profil-dialog.html',
                parent             : angular.element($document.find('body')),
                clickOutsideToClose: true,
				multiple:true,
				fullscreen:true,
				openFrom  : '#previewContact',
				closeTo  : '#previewContact',
                locals             : {
					Contact: contact,
					Fabricants: Fabricants,
					Structures: Structures,
					employesSimple : employesSimple ,
					APE: APE,
					Activites: Activites,
					Commandes: {},
					Courriers: {},
					Alertes: {},
					Employes: Employes,
					Dialog:1
                }
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function corbeilleContact(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer ce contact ?')
                .htmlContent('<b>' + contact.RaisonSocial + '</b>' + ' va être supprimé.')
                .ariaLabel('Supprimer un contact')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/contacts/corbeille.json", JSON.stringify(contact));
				
				$mdToast.show(
				  $mdToast.simple()
					.textContent('Contact placé dans la corbeille.')
					.position('bottom right' )
					.hideDelay(3000)
				);
				vm.dtInstance.reloadData();
            },function(){});
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		vm.select = function (item)
        {
            vm.selected = item;
        }
		
		function detailsContact(IDContact){
			$location.path('/contacts/profil/'+IDContact);
		}
		
		vm.go = function (url){
			$location.path(url);
		}

    }
	function DialogNotificationController($scope, $mdDialog, notification) {
		$scope.notification = notification;

		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		// $scope.renouvele = function(answer) {
		  // $mdDialog.hide(answer);
		// };
		
		$scope.reponse = function(answer) {
		  $mdDialog.hide(answer);
		};
	  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.produits')
        .controller('ProduitsController', ProduitsController)	;

    /** @ngInject */
	
    function ProduitsController($state, Categories, Fabricants, $location, $mdDialog, $http, $mdToast, $filter, $mdSidenav, DTColumnBuilder, DTOptionsBuilder, $compile , $scope)
    {
        var vm = this;
        // Data
        // vm.produits = Produits.data;
        vm.categories = Categories.data;
        vm.fabricants = Fabricants.data;
		vm.editCategories = 0;
        vm.dtInstance = {};
		vm.search = localStorage.getItem('produitsSearch');
		
		vm.filterChange = filterChange;
        vm.filterStatus = localStorage.getItem('produitsStatus');
		
		if(vm.filterStatus == null)
			vm.filterStatus = '';
		
		
		var fabricantsFiltre = [{value: '', label: '--'}];
		for (var i=0; i< vm.fabricants.length; i++){
			fabricantsFiltre.push({'value' : vm.fabricants[i].IDFabricant, 'label' :  vm.fabricants[i].Fabricant});
		}
			
		// console.log( vm.fabricants);
		
		var categorieFiltre;
		categorieFiltre = parseCategorieFilter(categorieFiltre, vm.categories, -1);
		
	
		vm.CategoriesSelected = [];
		
		function parseCategorieFilter(categorieFiltre, categories, r){
			var s = "- ";
			r++;
			if (typeof categorieFiltre== "undefined"){
				categorieFiltre = [{value: '', label: '--'}];
				
			}
			
			for (var i=0; i< categories.length; i++){
				categorieFiltre.push({'value' : categories[i].IDCategorie, 'label' : s.repeat(r) +" "+ categories[i].Categorie});
				categorieFiltre = parseCategorieFilter(categorieFiltre, categories[i].SousCategories, r);
			}
			
			return categorieFiltre;
			
		}
		
		function filterChange(type)
        {

            vm.filterStatus = type;
			localStorage.setItem('produitsStatus', type);
			$('.dataTable thead tr:nth-child(2) th:nth-child(4)').find('select').val(type);
			$('.dataTable thead tr:nth-child(2) th:nth-child(4)').find('select').trigger("change");

        }

		$(document).on('change', '.dataTable thead tr:nth-child(2) th:nth-child(4)', function(){
            vm.filterStatus = $(this).find('select').val();
			localStorage.setItem('produitsStatus', $(this).find('select').val());
			// console.log(vm.filterStatus);
		});
		
		function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
		}
		
		
		vm.toggleSidenav = function (sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		vm.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
			// console.log(item);
			
			vm.dtInstance.DataTable.columns(4).search(list).draw();
				
		};

		vm.exists = function (item, list) {
			return list.indexOf(item) > -1;
		};

		vm.filterCategorie = function(element){
			if(vm.CategoriesSelected.length>0){
				if(element.IDCategories){
					var trouve = false;
					angular.forEach(element.IDCategories, function(value, key) {
						if(vm.CategoriesSelected.indexOf(value)>=0)
							trouve =  true;
					});
					return trouve ;
				}
				else return false;
			}
			else
				return true;
		};
		
		vm.getNumber = function(num) {
			return new Array(num);   
		}



		vm.dtOptions = DTOptionsBuilder.newOptions()
		.withOption('ajax', {
			 dataSrc: 'datas',
			 url: 'datas/commandes/getAllproduits.json',
			 type: 'GET'
		})
		.withDataProp('data')
		.withOption('processing', true)
		.withOption('serverSide', true)
		.withOption('bStateSave', true)
		.withOption('StateSave', true)
		.withOption('iCookieDuration', 60*60*12)
		.withOption('stateSaveCallback', function (oSettings, oData) {
			localStorage.setItem( 'DataTablesProduits', JSON.stringify(oData) );
		})
		.withOption('stateLoadCallback', function (oSettings) {
			return JSON.parse( localStorage.getItem('DataTablesProduits') );
		})
		.withOption('stateLoadParams', function( settings, data ) {
			vm.search= data.search.search;
			vm.filterSave = data.columns;
		})
		.withOption('responsive', {
			details: {
				display: $.fn.dataTable.Responsive.display.childRowImmediate,
				type: 'none',
				target: ''
			}
		})
		.withOption('pagingType', 'simple')
		.withOption('drawCallback', function (o) {
			 /*  $('.scrollable').animate({  ??? GENANT D'APRES COLLABORATEURS
				scrollTop: 0
			  }, 'slow'); */
		})
		
		.withLightColumnFilter({
			  "0": {
				"html": "input",
				"type": "text",
				// "location": $location
			  },
			  "1": {
				// "html": "select",
				// "values": employesSimple.data,
				// "location": $location,
				// "regex":true
			  },
			  "2": {
				"html": "input",
				"type": "text",
				// "location": $location
			  },
			  "3": {
				"html": "select",
				"values": categorieFiltre,
				// "location": $location,
				"regex":true
			  },
			  "7": {
				"html": "select",
				"values": fabricantsFiltre,
				// "location": $location,
				"regex":true
			  },
			  "5": {
				"html": "select",
				"values": [
					{value: '', label: '--'}, 
					{value: '0', label: 'Sans abonnement'}, 
					{value: '1', label: '1 mois'},
					{value: '2', label: '2 mois'},
					{value: '3', label: '3 mois'},
					{value: '4', label: '4 mois'},
					{value: '5', label: '5 mois'},
					{value: '6', label: '6 mois'},
					{value: '7', label: '7 mois'},
					{value: '8', label: '8 mois'},
					{value: '9', label: '9 mois'},
					{value: '10', label: '10 mois'},
					{value: '11', label: '11 mois'},
					{value: '12', label: '12 mois'},
				],
				// "location": $location,
				"regex":true
			  },
			  "6": {
				"html": "select",
				"values": [
					{value: '', label: '--'}, 
					{value: '0', label: 'Manuelle'}, 
					{value: '1', label: 'Automatique'},
				],
				// "location": $location,
				"regex":true
			  },
			  "4": {
				"html": "select",
				"values": [
					{value: '', label: '--'}, 
					{value: '0', label: 'En option'}, 
					{value: '1', label: 'Seul'},
				],
				// "location": $location,
				"regex":true
			  },
			  "8": {
				"html": "range",
				"type": "number",
				// "location": $location
			  },
			  "9": {
				"html": "range",
				"type": "number",
				// "location": $location
			  },
			  "11": {
				"html": "range",
				"type": "date",
				// "location": $location
			  },
			  "10": {
				"html": "select",
				"values": [
					{value: '', label: '--'}, 
					{value: '0', label: 'Désactivé'}, 
					{value: '1', label: 'Activé'},
				],
				// "location": $location,collaborateurs
				"regex":true
			  },
			  "12": {
				"html": "clear",
				"status":"produitsStatus",
			  }
		  })
		  .withOption('columnDefs',  [
			{
				// Target the id column
				targets: 0,
				responsivePriority: 1,
			},
			{
				// Target the id column
				targets: 1,
				responsivePriority: 2,
				filterable        : false,
				sortable          : false
			},
			{
				// Target the price column
				targets: 4,
				responsivePriority: 2,
			},        {
				// Target the actions column
				targets           : 12,
				responsivePriority: 1,
				filterable        : false,
				sortable          : false
			}
		])
		.withOption('lengthMenu', [50, 100, 250])
		.withPaginationType('simple')
		.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
		.withOption('createdRow', function(row, data, dataIndex) {
			$compile(angular.element(row).contents())($scope);
		})
		.withOption('headerCallback', function(header) {
			if (!vm.headerCompiled) {
				vm.headerCompiled = true;
				$compile(angular.element(header).contents())($scope);
			}
		})
		.withOption('initComplete', function(settings, json) {
			var api = this.api();
			vm.searchBox = angular.element('body').find('#produits-search');
			
			angular.forEach(vm.filterSave, function(value, key) {
				var cpt = key+1;
				if(value.search.search.includes("~")){
					jQuery('.dataTableProduits tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
					jQuery('.dataTableProduits tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
					
				} else{
					jQuery('.dataTableProduits tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
					jQuery('.dataTableProduits tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
				}
			}); 
			
			
			if ( vm.searchBox.length > 0 )
			{
				var timeout = null;
				vm.searchBox.on('keyup', function (event)
				{
					clearTimeout(timeout);
					timeout = setTimeout(function () {
						api.search(vm.search).draw();
					}, 500);
				});
			}
			
			vm.recordsTotal = json.recordsTotal;
			filterChange(vm.filterStatus);
		  }
		)
		.withLanguage({
		  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
		  'processing':'test',
			"sSearch":         "Rechercher&nbsp;:",
			"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
			"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
			"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
			"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			"sInfoPostFix":    "",
			"sLoadingRecords": "Chargement en cours...",
			"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
			"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
			"oPaginate": {
				"sFirst":      "Premier",
				"sPrevious":   "Pr&eacute;c&eacute;dent",
				"sNext":       "Suivant",
				"sLast":       "Dernier"
			},
			"oAria": {
				"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
				"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
			}
		})
		.withOption('order', [0, 'desc']);
	
		
		// vm.dtColumns = $scope.test(DTColumnBuilder, Config.data.Column);
	
		

		// vm.dtColumns = Config.data.Column;
			
		vm.dtColumns = [
			DTColumnBuilder.newColumn('IDProduit').withTitle('<div class="table-header"><span class="column-title">ID</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('Images').withTitle('<div class="table-header"><span class="column-title"></div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				if(data){
				data = JSON.parse(data);
				// return JSON.parse(data).length;
				}
				if(data.length>0)
					return '<img src="'+data[0]+'"/>';
				else
					return '<img src="/assets/images/ecommerce/product-image-placeholder.png"/>';
			}),
			 //
			DTColumnBuilder.newColumn('Produit').withTitle('<div class="table-header"><span class="column-title">Nom</div></div>').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html = "<a ng-href='/administration/produits/produit/" + full.IDProduit+"'>"+data+"</a><br>"+"<small>Réference : "+full.Reference;
					if(full.nbrOptions)
						html += " - "+full.nbrOptions+" Option(s)";
					if(full.prixDegressif)
						html += " - Prix dégressif </small>";
					if(full.ModePrixVente=='pourcent'){
						html += "<br>Prix de vente : "+full.PourcentageVentePrixHTAutreProduit +"%";
						if(full.PrixVenteHT>0)
							html += " (min "+full.PrixVenteHT+" €)";
						html += "<br> du produit <b>" + full.ProduitReference+"</b>";
					}
					html += "</small>";
					return html;
				}
				return data;
			}),
			DTColumnBuilder.newColumn('IDCategorie').withTitle('<div class="table-header"><span class="column-title">Catégorie</div></div>').withOption('width', '200px').renderWith(function(data, type, full){
				
				return full.Categorie;
			}),
			DTColumnBuilder.newColumn('Renouvellement').withTitle('<div class="table-header"><span class="column-title">Engagement</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					if(!data)
						return "Aucun";
					else
						return data + " mois";
				}

				return data;
			}),
			DTColumnBuilder.newColumn('Reconduction').withTitle('<div class="table-header"><span class="column-title">Reconduction</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					if(full.Renouvellement!=0){
						if(data)
							return "Automatique";
						else
							return "Manuelle";
					}
					return "Aucune";
				}

				return data;
			}),
			DTColumnBuilder.newColumn('AchatSeul').withTitle('<div class="table-header"><span class="column-title">Vente</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					if(data)
						return "Seul";
					else
						return "En option";
				}

				return data;
			}),
			
			DTColumnBuilder.newColumn('IDFabricant').withTitle('<div class="table-header"><span class="column-title">Fournisseurs</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
				return full.Fabricant;
			}),
			DTColumnBuilder.newColumn('PrixAchatHT').withTitle('<div class="table-header"><span class="column-title">PA HT</div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					// if(full.ValeurAchat == "pourcent")
						if(data != null)
							return data;
						else 
							return "";
					// else
						// return '<div class="layout-align-start-start layout-row">' + '<span>' + data + ' €'+ '</span>'  + '</div>';
				}

				return data;
			}),
			DTColumnBuilder.newColumn('PrixVenteHT').withTitle('<div class="table-header"><span class="column-title">PV HT</div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					if(full.ModePrixVente == "sur-mesure")
						return "A définir";
					else
						return '<div class="layout-align-start-start layout-row">' + '<span>' + data + ' €'+ '</span>'  + '</div>';
				}

				return data;
			}),
			DTColumnBuilder.newColumn('Etat').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
					if(!data)
						html = '<span class="p-5 pr-8 pl-8 brad-16  md-red-bg white-fg" selected="true" style="text-transform:capitalize "><small>Désactivé</small></span>'; 
					else
						html = '<span class="p-5 pr-8 pl-8 brad-16  md-green-bg white-fg" selected="true" style="text-transform:capitalize "><small>Activé</small></span> '; 
								
					   return html;
				}
				return data;
			}),
			DTColumnBuilder.newColumn('DateModification').withTitle('<div class="table-header"><span class="column-title">Dernière modification</div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					return convertDate(data);
				}
				return data;
			}),
			DTColumnBuilder.newColumn('IDProduit').withTitle('<div class="table-header"><span class="column-title"></div></div>').withOption('width', '60px').renderWith(function(data, type, full){
				return '<md-menu>'+
					'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
						'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
					'</md-button>'+

					'<md-menu-content width="3">'+
						'<md-menu-item>'+
							'<md-button ng-click="vm.editProduit('+data+')">'+
								'Modifier'+
							'</md-button>'+
						'</md-menu-item>'+

						'<md-divider ></md-divider>'+

						'<md-menu-item> '+
							'<md-button ng-click="vm.supprimeProduit({\'IDProduit\':'+data+', \'Produit\':\''+full.Produit.replace(/'/g, "\\'")+'\'}, $event)"> '+
								'Supprimer '+
							'</md-button>'+
						'</md-menu-item>'+
					'</md-menu-content>'+
				'</md-menu>';
			}),						
			/* DTColumnBuilder.newColumn('IDUtilisateur').withTitle('<div class="table-header"><span class="column-title">Employé</div></div>').withOption('width', '170px').renderWith(function(data, type, full){return full.Utilisateur;}),
			DTColumnBuilder.newColumn('Titre').withTitle('<div class="table-header"><span class="column-title">Message</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
				var html = '<strong class="md-subhead font-weight-600">'+data+'</strong>';
				if(full.Message) 
					html += '<br><span >'+full.Message+'</span>';
				
				return html;
			}),
			DTColumnBuilder.newColumn('Type').withTitle('<div class="table-header"><span class="column-title">Gravité</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
						switch(data){
							case "danger": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-red-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span>'; break;
							case "success": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-green-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
							case "warning": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-orange-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
							case "info": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-blue-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
						}
				   return html;
				}
				return data;
				
			}),
			DTColumnBuilder.newColumn('Date').withTitle('<div class="table-header"><span class="column-title">Date</div></div>').withOption('width', '130px').renderWith(function(data, type, full){
				// return convertDate(data);
			}),
			 */
		];
			
			
        // Methods
        vm.ajouterProduit = ajouterProduit;
        vm.supprimeProduit = supprimeProduit;
        vm.editProduit = editProduit;

        function editProduit(IDProduit)
        {
			$location.path('/administration/produits/produit/' + IDProduit);
        }
		
        function supprimeProduit(produit, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer ce produit ?')
                .htmlContent('<b>' + produit.Produit + '</b>' + ' va être supprimé.')
                .ariaLabel('Supprimer un produit')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {
				
				// vm.produits.splice(vm.produits.indexOf(produit), 1);
				$http.post("/datas/commandes/deleteProduit.json", JSON.stringify(produit))
					.then(function (response, status, headers, config) {
						vm.produits = response.data.data;
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Le produit a été supprimé')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}, function () {});
				}, function () {});
        }
		
        vm.deleteCategorie = function (ev, categorie)
        {
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer cette catégorie ?')
                .htmlContent('<b>' + categorie.Categorie + '</b>' + ' va être supprimée.')
                .ariaLabel('Supprimer une catégorie')
                .targetEvent(ev)
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {
				$http.post("/datas/commandes/deleteCategorie.json", JSON.stringify(categorie))
				.then(function (response, status, headers, config) {
					vm.categories = response.data.data;
					$mdToast.show(
					  $mdToast.simple()
						.textContent('La categorie a été supprimée')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}, function () {});	

            }, function () {});
        }
		
        function ajouterProduit()
        {
            $state.go('app.produits.produit');
        }

		vm.editCategorie = function (ev, categorie){
			$mdDialog.show({
                controller         : 'ProduitsDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/produits/dialogs/categorie-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
				fullscreen:true,
                locals             : {
                    categorie : categorie,
                    Categories : vm.categories
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					vm.categories = response.data;
					$mdToast.show(
					  $mdToast.simple()
						.textContent("Catégorie modifiée !")
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			});
		}
  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.fournisseurs')
        .controller('fournisseursController', fournisseursController);
		 
    /** @ngInject */
    function fournisseursController($mdDialog, $http, $mdToast, $window, $rootScope, DTOptionsBuilder, DTColumnBuilder, $compile, $scope, $location  )
    {
        var vm = this;


		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		vm.recordsTotal = 0;
		vm.search = localStorage.getItem('fournisseursSearch');
		
			
		function convertDate(inputFormat, hour, day) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
	
		vm.editFournisseur = function (ev, IDFabricant){
			$http.get("/datas/commandes/getFournisseur.json?IDFabricant="+IDFabricant)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					controller         : 'fournisseursDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/fournisseurs/dialogs/fournisseurs-dialog.html',
					parent             : angular.element(document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						// Conge : "",
						Fournisseur : response.data.data
					}
				}).then(function (response)
				{
					if(typeof response != "undefined"){
						vm.dtInstance.reloadData();
						
						if(response.data.error){
						}
						else
						if(typeof IDFabricant!="undefined")
							$mdToast.show(
							  $mdToast.simple()
								.textContent("Votre fournisseur a été modifié !")
								.position('bottom right' )
								.hideDelay(3000)
							);
						else
						$mdToast.show(
						  $mdToast.simple()
							.textContent("Votre fournisseur a été créé !")
							.position('bottom right' )
							.hideDelay(3000)
						);
					} 
				});
			}, function () {});
		}
		
		
		vm.deleteFournisseur = function (ev, IDFabricant, Fournisseur)
        {
		 	var trackingObj = {IDFabricant:IDFabricant};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer ce fournisseur/fabricant ?')
                .htmlContent('<b>' + Fournisseur + '</b>' + ' va être supprimé.')
                .ariaLabel('Supprimer le fournisseur')
                .targetEvent(ev)
                .theme('md-warn')
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/commandes/deleteFournisseur.json", JSON.stringify(trackingObj)).then(function (response, status, headers, config) {  
					vm.dtInstance.reloadData();
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Le fournisseur/fabricant a été supprimé.')
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.dtInstance.reloadData();
				}, function () {});
				
            }, function () {});
        }
		
		vm.filterSave = [];
        vm.dtInstance = {};
    		
		 vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'datas',
				 url: 'datas/commandes/getFournisseurs.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'dataTableFournisseurs', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
				  $('.scrollable').animate({
					scrollTop: 0
				  }, 'slow');
			})
			.withOption('stateLoadCallback', function (oSettings) {
				var columnLoad = JSON.parse( localStorage.getItem('dataTableFournisseurs') );
				// if( columnLoad != null && columnLoad.columns[3].search.search == "")
					// columnLoad.columns[3].search.search = 1;
				return columnLoad;
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('aoSearchCols',   [
			  null,
			  null,
			  null,
			  null,
			  // { "sSearch": "0" },
			  // null,
			  null
			])
			.withOption('columnDefs',  [
				/* {
                    // Target the price column
                    targets: 4,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },
				
                {
                    targets: 0,
                    responsivePriority: 0,
                },   
                {
                    targets: 1,
                    responsivePriority: 2,
                },   
                {
                    targets: 2,
                    responsivePriority: 2,
                },   
                {
                    targets: 3,
                    responsivePriority: 1,
                },   
                {
                    targets: 4,
                    responsivePriority: 1,
                },    
				{
                    targets           : 5,
                    responsivePriority: 1,
                },     */
				{
                    targets           : 5,
                    responsivePriority: 0,
                }
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
					var api = this.api();
						vm.searchBox = angular.element('body').find('#colabconges-search');

					angular.forEach(vm.filterSave, function(value, key) {
						var cpt = key+1;
						if(typeof value.search.search == "string" && value.search.search.includes("~")){
							jQuery('.dataTableNotif tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
							jQuery('.dataTableNotif tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
							
						} else{
							jQuery('.dataTableNotif tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
							jQuery('.dataTableNotif tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
						}
					}); 
				
					if ( vm.searchBox.length > 0 )
					{
						var timeout = null;
						vm.searchBox.on('keyup', function (event)
						{
							clearTimeout(timeout);
							timeout = setTimeout(function () {
								api.search(vm.search).draw();
							}, 500);
						});
					}
					
					vm.recordsTotal = json.recordsTotal;
				}
			)
			.withLightColumnFilter({
				/*   "1": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "2": {
					"html": "select",
					"values": [{'value':"", 'label':"--"}].concat(employesSimple.data),
					// "location": $location,
					"regex":true
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '', label: '--'},  
						{value: 'Congés payés', label: 'Congés payés'}, 
						{value: 'Congés sans solde', label: 'Congés sans solde'}, 
						{value: 'Maladie ou à l’accident non professionnel', label: 'Maladie ou à l’accident non professionnel'}, 
						{value: 'Accident ou maladie professionnelle', label: 'Accident ou maladie professionnelle'}, 
						{value: 'Compte Epargne Temps', label: 'Compte Epargne Temps'}, 
						{value: "Congés d'ancienneté", label: "Congés d'ancienneté"}, 
						{value: "Congés d'adoption", label: "Congés d'adoption"}, 
						{value: "Congés de proche aidant", label: "Congés de proche aidant"}, 
						{value: "Congés de solidarité familiale", label: "Congés de solidarité familiale"}, 
						{value: "Congés liées à la maternité ou à l’adoption", label: "Congés à la maternité ou à l'adoption"}, 
						{value: "Congés maternité", label: "Congés maternité"}, 
						{value: "Congés parental d'éducation", label: "Congés parental d'éducation"}, 
						{value: "Congés paternité", label: "Congés paternité"}, 
						{value: "Congés pour enfant malade", label: "Congés pour enfant malade"}, 
						{value: "Congés pour évènements familiaux", label: "Congés pour évènements familiaux"}, 
						{value: "Congés sabbatiques", label: "Congés sabbatiques"}, 
						// {value: "Déplacement", label: "Déplacement"}, 
						// {value: "Formation", label: "Formation"}, 
						// {value: "Jours de fractionnement", label: "Jours de fractionnement"}, 
						{value: "Récupération", label: "Récupération"}, 
						{value: "Repos compensateur", label: "Repos compensateur"}, 
					],
					"location": $location,
				  "regex":true},
				
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "5": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "6": {
					"html": "range",
					"type": "number",
					"location": $location
				  },
				  "7": {
					"html": "input",
					"type": "text",
					// "location": $location
				  },
				  "8": {
					"html": "select",
					"values": [
						{value: '', label: '--'}, 
						{value: 'A valider', label: 'A renouveler'}, 
						{value: 'Validés', label: 'Renouvelée'}, 
						{value: 'Refusés', label: 'Non renouvelée'}, 
					],
					"location": $location,
				  "regex":true},
				  "9": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "10": {
					"html": "clear"
				  }
				   */
				  
			  })
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('order', [1, 'desc']);


		vm.dtColumns = [
			DTColumnBuilder.newColumn('Fabricant').withTitle('<div class="table-header"><span class="column-title">Fournisseur/fabricant</div></div>'),
			DTColumnBuilder.newColumn('Metier').withTitle('<div class="table-header"><span class="column-title">Métier / activité</div></div>'),
			DTColumnBuilder.newColumn('NbrProduits').withTitle('<div class="table-header"><span class="column-title">Nombre de produits</div></div>'),
			DTColumnBuilder.newColumn('DateModification').withTitle('<div class="table-header"><span class="column-title">Dernière modification</div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				if(data == "0000-00-00 00:00:00")
					return "--";
				else
					return convertDate(data, 1)
			}),
			DTColumnBuilder.newColumn('Actif').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '150px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
					if(!data)
						html = '<span class="p-5 pr-8 pl-8 brad-16  md-red-bg white-fg" selected="true" style="text-transform:capitalize "><small>Désactivé</small></span>'; 
					else
						html = '<span class="p-5 pr-8 pl-8 brad-16  md-green-bg white-fg" selected="true" style="text-transform:capitalize "><small>Activé</small></span> '; 
					
					   return html;
				}
				return data;
			}),
			DTColumnBuilder.newColumn(null).withTitle('').notSortable().withOption('width', '50px').renderWith(function(data, type, full){
				return '<md-menu style="float: right;">'+
				'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
						'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
					'</md-button>'+
					'<md-menu-content width="3">'+
				
						'<md-menu-item> '+
							"<md-button ng-click='vm.editFournisseur($event, \""+full.IDFabricant+"\")' > "+
								'Modifier '+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-menu-item> '+
							"<md-button ng-click='vm.deleteFournisseur($event, \""+full.IDFabricant+"\",\""+full.Fabricant+"\")' >"+
								'Supprimer '+
							'</md-button>'+
						'</md-menu-item>'+
						
					'</md-menu-content>'+
				'</md-menu>';
					
			}),
			
		];
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.commandes.produit', ['ui.tinymce', 'wipImageZoom'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.produits.produit', {
                url      : '/produit/:token',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/commandes/produit/produit.html',
                        controller : 'ProduitController as vm'
                    }
                },
                resolve  : {
                    Produit: function (msApi, $stateParams)
                    {
                        return msApi.resolve('commandes.produit@get',{'IDProduit': $stateParams.token});
                    },
                    Produits: function (msApi, $stateParams)
                    {
                        return msApi.resolve('commandes.produitsListe@get');
                    },
                    Categories: function (msApi)
                    {
                        return msApi.resolve('commandes.categories@get');
                    },
                    Fabricants: function (msApi)
                    {
                        return msApi.resolve('commandes.fabricants@get');
                    },
                    TVA: function (msApi)
                    {
                        return msApi.resolve('commandes.TVA@get');
                    }
                },
                bodyClass: 'commandes'
            });

        // Translation

        // Api
        msApiProvider.register('commandes.produit', ['datas/commandes/getProduit.json']);
        msApiProvider.register('commandes.produitsListe', ['datas/commandes/getProduits.json']);
        msApiProvider.register('commandes.categories', ['datas/commandes/getArboCagetories.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
        msApiProvider.register('commandes.TVA', ['datas/commandes/getAllTVA.json']);
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.produit')
        .controller('ProduitController', ProduitController);

    /** @ngInject */
    function ProduitController($scope, $document, $state, Produit, Produits, $mdToast, Categories, Fabricants, TVA, $http, $location, $mdDialog)
    {
        var vm = this;

        // Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
		
        vm.produit = Produit.data;
        vm.categories = Categories.data;
        vm.fabricants = Fabricants.data;
        vm.produits = Produits.data;
        vm.TVA = TVA.data;
		
		vm.getNumber = function(num) {
			return new Array(num);   
		}

		
		if(typeof vm.produit == "undefined")
			vm.produit = {};
		
		if(typeof vm.produit.PrixSpecifiques == "undefined")
			vm.produit.PrixSpecifiques = [];
		
		if(typeof vm.produit.Fournisseurs == "undefined")
			vm.produit.Fournisseurs = [];
		
		if(typeof vm.produit.ModePrixVente == "undefined")
			vm.produit.ModePrixVente = 'fixe';
		
		if(typeof vm.produit.Images == "undefined")
			vm.produit.Images = '';
		
		angular.forEach(vm.TVA, function (value, key) {
			if(value.IDTVA == vm.produit.IDTVA )
				vm.produit.PrixVenteTTC = Math.round(vm.produit.PrixVenteHT * (value.Taux / 100 + 1)*100)/100;

		});
		
		
        vm.categoriesSelectFilter = '';
      
      
        // Methods
        vm.saveProduit = saveProduit;
        vm.gotoProduits = gotoProduits;
        vm.onCategoriesSelectorOpen = onCategoriesSelectorOpen;
        vm.onCategoriesSelectorClose = onCategoriesSelectorClose;
       
        vm.isFormValid = isFormValid;

        //////////
		vm.imageZoomOptions = {};
        vm.updateImageZoomOptions = updateImageZoomOptions;
		
		init();
		
		function init(){
			if ( vm.produit.Images.length > 0 )
			{
				vm.updateImageZoomOptions(vm.produit.Images[0]);
			}
		}
		
		
		vm.options = {
			zoomEnable: true,
			style: 'box'
		};
		
		function updateImageZoomOptions(url) {
           vm.imageZoomOptions = url;
            // vm.imageZoomOptions = {
                // Images: [
                    // {
                        // thumb : url,
                        // medium: url,
                        // large : url
                    // }
                // ]
            // };
        }
		
		vm.deleteImg = function(i){
			vm.produit.Images.splice(i,1);
			init();
		}
		
		vm.selectImage = function(event){
			$mdDialog.show({
                controller         : 'ImageDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/parametres/images/dialogs/images-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : event,
                clickOutsideToClose: true,
				multiple : true,
                locals             : {
					link : "commandes/uploadImageProduit",
					Params : vm.produit,
					multipleUpload : true,
                }
            }).then(function (response)
            {
				if(typeof response != "undefined"){
					angular.forEach(response, function(value, key) {
						vm.produit.Images.push(value);
					});
				}
			});
		}
		
		$scope.tinymceOptions = {
			plugins: [
			  "advlist autolink lists link image charmap print preview hr anchor pagebreak",
			  "searchreplace wordcount visualblocks visualchars code fullscreen",
			  "insertdatetime  nonbreaking save table contextmenu directionality",
			  "emoticons template paste textcolor colorpicker textpattern"
			],
			menubar:false,
			toolbar1: "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink",
			toolbar2: "preview | hr forecolor backcolor table removeformat code",
			document_base_url : '/datas/images/courriers/',
			remove_script_host : false,
			convert_urls: false,
			paste_data_images: false,
			height : "200",
			
		};
		
        /**
         * Save produit
         */
        function saveProduit()
        {
			vm.showSpinner = 1;
			$http.post("/datas/commandes/setProduit.json",JSON.stringify(vm.produit))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
				}
				else{
					if(!vm.produit.IDProduit)
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Le produit a été ajouté !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					else
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Le produit a été modifié !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					
					vm.produit = response.data.data;
					vm.showSpinner = 0;
					// gotoProduits();
				}
			}, function () {});


        }

        /**
         * Go to produits page
         */
        function gotoProduits()
        {
            $state.go('app.produits');
        }

        /**
         * Go to produits page
         */
        vm.gotoOption = function (ev, IDProduit)
        {
			var confirm = $mdDialog.confirm()
			  .title('Souhaitez-vous continuer ?')
			  .textContent('En quittant cette page, les modifications non enregistrées seront perdues.')
			  .targetEvent(ev)
			  .ok('Continuer')
			  .cancel('Annuler');

			$mdDialog.show(confirm).then(function() {
				$location.path('/administration/produits/produit/' + IDProduit);
			});
			
          
        }

        /**
         * On categories selector open
         */
        function onCategoriesSelectorOpen()
        {
            // The md-select directive eats keydown events for some quick select
            // logic. Since we have a search input here, we don't need that logic.
            $document.find('md-select-header input[type="search"]').on('keydown', function (e)
            {
                e.stopPropagation();
            });
        }

        /**
         * On categories selector close
         */
        function onCategoriesSelectorClose()
        {
            // Clear the filter
            vm.categoriesSelectFilter = '';

            // Unbind the input event
            $document.find('md-select-header input[type="search"]').unbind('keydown');
        }

    

        /**
         * Checks if the given form valid
         *
         * @param formName
         */
        function isFormValid(formName)
        {
            if ( $scope[formName] && $scope[formName].$valid )
            {
                return $scope[formName].$valid;
            }
        }

       
		
		vm.updateTTC = function (){
			angular.forEach(vm.TVA, function (value, key) {
				if(value.IDTVA == vm.produit.IDTVA )
					vm.produit.PrixVenteTTC = Math.round(vm.produit.PrixVenteHT * (value.Taux / 100 + 1)*100)/100;

			});
		}
		
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.factures')
        .controller('FacturesController', FacturesController)	;

    /** @ngInject */


    function FacturesController($state, employesSimple, Fabricants, nbrFacturesParEtats, Factures, $scope, $rootScope, $mdSidenav, Employes, $location, $mdDialog, $http, $mdToast, $window, $filter, $document, DTOptionsBuilder, DTColumnBuilder, $compile)
    {
		
		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		// console.log(Fabricants);
		
        var vm = this;

        // Actions de transmission et d'export, sans modifier le circuit de facturation.
        vm.selectionFactures = {}; vm.documentsTransmission = []; vm.synchronisationEnCours = false;
        vm.droitFacture = function (action) {
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf('gestion.commandes.factures.' + action) !== -1;
        };
        vm.cleFacture = function (row) { return row.IDCommande + ':' + row.IDCommandes_Paiement; };
        vm.pageFacturesSelectionnee = function () {
            if (!vm.dtInstanceFactures.DataTable) return false;
            var rows = vm.dtInstanceFactures.DataTable.rows({page:'current'}).data().toArray();
            return rows.length > 0 && rows.every(function (row) { return vm.selectionFactures[vm.cleFacture(row)]; });
        };
        vm.selectionFacturesPartielle = function () {
            if (!vm.dtInstanceFactures.DataTable) return false;
            var rows = vm.dtInstanceFactures.DataTable.rows({page:'current'}).data().toArray();
            return rows.some(function (row) { return vm.selectionFactures[vm.cleFacture(row)]; }) && !vm.pageFacturesSelectionnee();
        };
        vm.nombreSelectionFactures = function () { return Object.keys(vm.selectionFactures).filter(function (key) { return vm.selectionFactures[key]; }).length; };
        vm.selectionnerPageFactures = function () {
            if (!vm.dtInstanceFactures.DataTable) return;
            var rows = vm.dtInstanceFactures.DataTable.rows({page:'current'}).data().toArray();
            var all = rows.length && rows.every(function (row) { return vm.selectionFactures[vm.cleFacture(row)]; });
            rows.forEach(function (row) { vm.selectionFactures[vm.cleFacture(row)] = !all; });
        };
        vm.exporterFactures = function (type) {
            if (!vm.droitFacture('export')) return;
            var ids = Object.keys(vm.selectionFactures).filter(function (key) { return vm.selectionFactures[key]; });
            if (type === 'select' && !ids.length) return;
            $window.open('/datas/commandes/exportFactures.json?type=' + encodeURIComponent(type) +
                '&selected=' + encodeURIComponent(ids.join(',')) + '&filtres=' +
                encodeURIComponent(angular.toJson(vm.dtInstanceFactures.DataTable ? vm.dtInstanceFactures.DataTable.ajax.params() : {})), '_blank');
        };
        vm.synchroniserFactures = function () {
            if (!vm.droitFacture('synchronisation') || vm.synchronisationEnCours) return;
            vm.synchronisationEnCours = true;
            $http.post('/datas/commandes/synchroniserFactures.json', {}).then(function (response) {
                var success = response.data && !response.data.error && response.data.data;
                var message = success ? (response.data.message || 'Synchronisation terminée.') :
                    (response.data && response.data.error && response.data.error.message || 'Synchronisation refusée.');
                $mdToast.show($mdToast.simple().textContent(message || 'Synchronisation refusée.').position('bottom right').hideDelay(5000));
                if (success) vm.dtInstanceFactures.reloadData(null, false);
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Synchronisation impossible. Vérifier le contrôleur PHP.').position('bottom right').hideDelay(5000));
            }).finally(function () { vm.synchronisationEnCours = false; });
        };

		vm.rows = [];
        // Data
        vm.factures = Factures.data;
        vm.employes = Employes.data;
		vm.nbrFacturesParEtats = nbrFacturesParEtats.data;
		vm.showMarges = 0;
		
		$http.get("datas/commandes/getNbrFacturesParEtats.json").then(function (response) {vm.nbrFacturesParEtats = response.data.data;}, function () {});
		
		
		vm.recordsTotal = 0;
		
        vm.filterChange = filterChange;
        vm.filterStatus = localStorage.getItem('facturesStatus');
		if(vm.filterStatus == null)
			vm.filterStatus = '';
		
		// vm.filterChange(vm.filterStatus);
		
		vm.search = localStorage.getItem('facturesSearch');
		vm.searchBox = "";
		
        vm.toggleSidenav = toggleSidenav;
		
		
		function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	

		function filterChange(type)
        {
// console.log(type);
            vm.filterStatus = type;
// console.log( vm.filterStatus);
			localStorage.setItem('facturesStatus', type);

           /*  if ( type === '' )
            {
               vm.dtInstanceFactures.DataTable.column(6).search('', true, false, false ).draw();
            }
			else
				vm.dtInstanceFactures.DataTable.column(6).search(vm.filterStatus, true, false, false ).draw(); */
			// console.log(vm.filterStatus);
			$('.dataTable thead tr:nth-child(2) th:nth-child(10)').find('select').val(type);
			$('.dataTable thead tr:nth-child(2) th:nth-child(10)').find('select').trigger("change");
			// vm.dtInstanceFactures._renderer.rerender(); 
        }
		
		$(document).on('change', '.dataTable thead tr:nth-child(2) th:nth-child(10)', function(){
			// filterChange($(this).find('select').val());
			// console.log($(this).find('select').val());
            vm.filterStatus = $(this).find('select').val();
			localStorage.setItem('facturesStatus', $(this).find('select').val());
		});
		
		vm.openContactDialog = function (contact)
        {
			var contactObj = {IDContact:contact};
            $mdDialog.show({
                controller         : 'profilContactController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/contacts/profil/profil-dialog.html',
                parent             : angular.element($document.find('body')),
                clickOutsideToClose: true,
				multiple:true,
				fullscreen:true,
				openFrom  : '#previewContact',
				closeTo  : '#previewContact',
                locals             : {
					Contact: contactObj,
					Fabricants: Fabricants,
					employesSimple: employesSimple,
					Structures: {},
					APE: {},
					Activites: {},
					Commandes: {},
					Alertes: {},
					Courriers: {},
					Employes: {},
					Dialog:1
                }
            });
        }


		vm.filterSave = [];
        vm.dtInstanceFactures = {};
		
		vm.dtOptionsFactures = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'data',
				 url: 'datas/commandes/getAllFactures.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'DataTablesFactures', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
			/* 	  $('.scrollable').animate({  ??? GENANT D'APRES COLLABORATEURS
					scrollTop: 0
				  }, 'slow'); */
			})
			.withOption('stateLoadCallback', function (oSettings) {
				try {
                    var saved = JSON.parse(localStorage.getItem('DataTablesFactures'));
                    if (!saved || !saved.columns) return null;
                    // Conserver les filtres et les tris des versions à 10 ou 11 colonnes.
                    if (saved.columns.length === 10) {
                        saved.columns.splice(9, 0, {visible:true, search:{search:'', smart:true, regex:false, caseInsensitive:true}});
                        (saved.order || []).forEach(function (order) { if (Number(order[0]) >= 9) order[0] = Number(order[0]) + 1; });
                    }
                    if (saved.columns.length === 11) {
                        saved.columns.unshift({visible:true, search:{search:'', smart:true, regex:false, caseInsensitive:true}});
                        (saved.order || []).forEach(function (order) { order[0] = Number(order[0]) + 1; });
                    }
                    return saved.columns.length === 12 ? saved : null;
                } catch (ignore) { return null; }
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('columnDefs',   [
                { targets:0, responsivePriority:1, orderable:false, searchable:false },
                {
                    // Target the id column
                    targets: 1,
                    responsivePriority: 1,
                },
                {
                    // Target the id column
                    targets: 2,
                    responsivePriority: 1,
                },
				{
                    // Target the id column
                    targets: 3,
					render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return convertDate(data);
                        }

                        return data;
                    }
                },
                {
                    // Target the price column
                    targets: 5,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },  
                {
                    // Target the price column
                    targets: 6,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },        {
                    // Target the actions column
                    targets           : 11,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				// Recompiling so we can bind Angular directive to the DT
				// console.log(row);
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					// Use this headerCompiled field to only compile header once
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
				var api = this.api();
                    vm.searchBox = angular.element('body').find('#factures-search');

				angular.forEach(vm.filterSave, function(value, key) {
					var cpt = key+1;
					if(value.search.search.includes("~")){
						jQuery('.dataTableFactures tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
						jQuery('.dataTableFactures tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
						
					} else{
						jQuery('.dataTableFactures tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
						jQuery('.dataTableFactures tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
					}
				}); 				
				
                if ( vm.searchBox.length > 0 )
                {
					var timeout = null;
					
                    vm.searchBox.on('keyup', function (event)
                    {
						clearTimeout(timeout);
						timeout = setTimeout(function () {
							api.search(vm.search).draw();
						}, 500);
                    });
                }
				
				vm.recordsTotal = json.recordsTotal;
				filterChange(vm.filterStatus);
			  }
			)
			.withLightColumnFilter({
				  "1": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "2": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  /* "2": {
					"html": "select",
					"values": simpleListeCommandes.data,
					"location": $location,
					"regex":true
				  }, */
				  "3": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "4": {
					"html": "select",
					"values": employesSimple.data,
					"location": $location,
					"regex":true
				  },
				  "5": {
					"html": "range",
					"type": "number",
					"location": $location
				  },
				  "6": {
					"html": "range",
					"type": "number",
					"location": $location
				  },
				  "7": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "8": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "9": {
					"html": "select",
					"values": [
						{value: '', label: '--'}, 
						{value: 'Non contrôlée', label: 'Non contrôlée'},
						{value: 'En cours', label: 'En cours'},
						{value: 'Partiellement réglée', label: 'Partiellement réglée'},
                        {value: 'Impayée', label: 'Impayée'},
                        {value: 'Soldée', label: 'Soldée'}
					],
					"location": $location,
				  "regex":true},
				  "10": {
                        "html":"select",
                        "values":[{value:'',label:'--'},{value:'À transmettre',label:'À transmettre'},{value:'Transmise',label:'Transmise'},{value:'Acceptée',label:'Acceptée'},{value:'Refusée',label:'Refusée'},{value:'Erreur',label:'Erreur'}],
                        "location":$location, "regex":true
                  },
                  "11": {
                    "html": "clear",
					"status":"facturesStatus"
				  }
				  
			  })
			  
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('fnRowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
				 // $('td', nRow).unbind('click');
					// $('td', nRow).bind('click', function() {
					// console.log(nRow);
					// openContactDialog(aData);
                      // $scope.$apply(function() {
                        // vm.expend(nRow, aData);
                    // });  
                // });
                // return nRow;
            })
			.withOption('order', [1, 'desc']);
			
			vm.dtColumnsFactures = [
                DTColumnBuilder.newColumn(null)
                    .withTitle('<div class="table-header"><span class="column-title"><md-checkbox aria-label="Tout sélectionner" ng-if="vm.droitFacture(\'export\')" ng-checked="vm.pageFacturesSelectionnee()" md-indeterminate="vm.selectionFacturesPartielle()" ng-click="vm.selectionnerPageFactures()"></md-checkbox></span></div>')
                    .withOption('width', '70px').notSortable().withOption('searchable', false)
                    .renderWith(function (data, type, full, meta) {
                        vm.documentsTransmission[meta.row] = full;
                        return type === 'display' ? '<md-checkbox aria-label="Sélectionner la facture" ng-if="vm.droitFacture(\'export\')" ng-model="vm.selectionFactures[vm.cleFacture(vm.documentsTransmission[' + meta.row + '])]"></md-checkbox>' : '';
                    }),
                DTColumnBuilder.newColumn('NumeroFacture').withTitle('<div class="table-header"><span class="column-title">N° Facture</span></div>').withOption('width', '170px').renderWith(function(data, type, full, meta){
                    if (type !== 'display') return data;
                    var html = data;

					if(full.ComConsultants == 1)
						html += '<br><span class="blue-600-fg">Com-Consultants le '+convertDate(full.DateFacturation)+'</span>';	
					
					if(full.NumeroFacture)
						html += '<br><span>Commande '+full.NumeroCommande+'</span>';	
					
					
					return html;
				}),
				/* DTColumnBuilder.newColumn('NumeroFacture').withTitle('<div class="table-header"><span class="column-title">N° Facture</div></div>').withOption('width', '80px').renderWith(function(data, type, full){
					var html = "";
					
					
					if(full.NumeroFacture)
						html += data+'<br>'+convertDate(full.DateFacturation)+'</span>';	
					
					
					return html;
				}), */
				DTColumnBuilder.newColumn('RaisonSocial').withTitle('<div class="table-header"><span class="column-title">Client</div></div>').renderWith(function(data, type, full, meta ){
					return '<a ng-click="vm.openContactDialog('+ full.IDContact +')" href="#">'+full.RaisonSocial+"</a>";
				}),
				DTColumnBuilder.newColumn('DateFacturation').withTitle('<div class="table-header"><span class="column-title">Date de facturation</div></div>').withOption('width', '120px').renderWith(function(data, type, full, meta ){
					if(data!="0000-00-00" && data != "1970-01-01")
						return convertDate(data);
					else
						return "";
				}),
				DTColumnBuilder.newColumn('Commercial').withTitle('<div class="table-header"><span class="column-title">Commercial</div></div>').withOption('width', '220px').renderWith(function(data, type, full, meta ){
				/* 	console.log(full);
					vm.rows[meta.row] = full;
					
					if ( type === 'display' ){
						var html ="";
							if(full.CommercialSupprime=="1")
								html += '<span class="grey-600-fg">'+full.Commercial+'<md-tooltip md-direction="left" >Compte supprimé</md-tooltip></span>';
							else{
								if(full.CommercialNonModifiable)
									html += '<span>'+full.Commercial+'</span>';
								else
									html += '<a href="#" editable-select="vm.rows['+meta.row+'].IDEmploye"  onaftersave="vm.saveCommercial('+meta.row+')" e-ng-options="s.IDEmploye.toString() as s.Civilite+\' \'+s.Prenom+\' \'+s.Nom for s in vm.employes"><span ng-bind-html="vm.showEmployes('+full.IDEmploye+')"></span></a>';
							}
                       return html;
					} */
					return data;
				}),
				// DTColumnBuilder.newColumn('MargeBrutHT').withTitle('<div class="table-header"><span class="column-title">Marge HT</div></div>').withOption('width', '100px'),
				DTColumnBuilder.newColumn('TotalHTRemise').withTitle('<div class="table-header"><span class="column-title">Total HT</div></div>').withOption('width', '100px'),
				DTColumnBuilder.newColumn('TotalTTC').withTitle('<div class="table-header"><span class="column-title">Total TTC</div></div>').withOption('width', '100px'),
				DTColumnBuilder.newColumn('NbrMensualites').withTitle('<div class="table-header"><span class="column-title">Nbr paiements</div></div>').withOption('width', '100px'),
				DTColumnBuilder.newColumn('EmailSend').withTitle('<div class="table-header"><span class="column-title">Facture Envoyée</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
					if ( type === 'display' ){
						var html = "";
						
						if(data != "0000-00-00 00:00:00")
							html = convertDate(data) + "<br>" + "<small><a href='mailto:"+ full.EmailSendTo +"'>"+ full.EmailSendTo +"</a></small>";
							
                       return html;
					}
					return data;
				}),
				
				DTColumnBuilder.newColumn('EtatAffiche').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
					if ( type === 'display' ){
						var html ="";
							
							switch(data){
								case "Non contrôlée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 grey-600-bg white-fg"><small>Non contrôlée</small></span>'; break;
								case "En cours": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-amber-600-bg white-fg" ><small>En cours</small></span>'; break;
								case "Partiellement réglée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-orange-bg white-fg" ><small>Partiellement réglée</small></span>'; break;
								// case "Annulée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 grey-500-bg white-fg" ><small>Annulée</small></span>'; break;
								case "Impayée": case "Impayées": html = '<span class="tag p-5 pr-8 pl-8 brad-16 red-600-bg white-fg" ><small>Impayée</small></span>'; break;
								// case "Validée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-cyan-700-bg white-fg" ><small>Validée</small></span>'; break;
								// case "Signée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-teal-600-bg white-fg" ><small>Signée</small></span>'; break;
								// case "Com-Consultants": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-blue-500-bg white-fg" ><small>Com-Consultants le '+convertDate(full.DateFacturation)+'</small></span>'; break;
								case "Soldée": case "Soldées": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-green-bg white-fg" ><small>Soldée</small></span>'; break;
								// case "Renouvelée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-green-900-bg white-fg" ><small>Renouvelée</small></span>'; break;
								// case "A renouveler": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-orange-600-bg white-fg" ><small>A renouveler</small></span>'; break;
								// case "Non renouvelée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-red-900-bg md-hue-2 white-fg" ><small>Non renouvelée</small></span>'; break;
							}
                       return html;
					}
					return data;
				}),
				DTColumnBuilder.newColumn('PlateformeStatut').withTitle('<div class="table-header"><span class="column-title">SuperPDP</span></div>').withOption('width', '150px').withOption('defaultContent', '').renderWith(function (data, type) {
                    if (type !== 'display') return data || '';
                    if (!data) return '';
					var color = ['Acceptée', 'Transmise', 'Reçue', 'Mise à disposition', 'Prise en charge', 'Traitée', 'Paiement émis', 'Payée'].indexOf(data) !== -1 ? 'md-green-bg' :
						(['Refusée', 'Rejetée', 'Irrecevable', 'Erreur', 'Contestée'].indexOf(data) !== -1 ? 'md-red-bg' :
						(data === 'Déposée' ? 'grey-600-bg' : 'md-orange-bg'));
                    var label = String(data).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
                    return '<span class="p-5 pr-16 pl-16 brad-16 font-size-12 white-fg ' + color + '" style="display:inline-block">' + label + '</span>';
                }),
                DTColumnBuilder.newColumn('IDCommande').withTitle('<div class="table-header"><span class="column-title"></div></div>').withOption('width', '60px').renderWith(function(data, type, full, meta){
					
					if(full.Prelevement == 1 && full.IDCommande_IBAN==0)
						var prelevement = 1;
					else
						var prelevement = 0;
				
					
					var html = '<md-menu style="float: right;">'+
							'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
								'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
							'</md-button>'+
							'<md-menu-content width="3">';
							
					html += '<md-menu-item>'+ 
								'<md-button ng-click="vm.DetailsCommande($event, '+full.IDCommande+')">'+ 
									'Aperçu commande'+
								'</md-button>'+
							'</md-menu-item>'+
							'<md-menu-item>'+ 
								'<md-button ng-click="vm.openContactDialog('+ full.IDContact +')">'+ 
									'Fiche client'+
								'</md-button>'+
							'</md-menu-item>'+
							'<md-divider >'+'</md-divider>';
				
				
				  
						html += '<md-menu-item >'+
									'<md-button target=" _blank" ng-click="vm.getDevisSigne($event,'+full.IDCommande+', \''+full.NumeroCommande+'\')" ';
									
									if(full.DevisSigne!=true)
										html += 'disabled';
									
									html += '>'+
										'Voir le devis signé'+
									'</md-button>'+
								'</md-menu-item>';
						
						html += '<md-menu-item >'+
								'<md-button ng-click="vm.getFacture(event, '+full.IDCommande+', \''+full.IDCommandes_Paiement+'\')">'+
									'Télécharger la facture'+
								'</md-button>'+
							'</md-menu-item>';
							
						html += '<md-divider >'+'</md-divider>';
							
						html += '<md-menu-item >'+
                                '<md-button ng-disabled="!vm.droitFacture(\'envoi\')" ng-click="vm.sendFactureEmail($event, '+full.IDCommande+', \''+full.IDCommandes_Paiement+'\', \''+full.RaisonSocial.replace(/'/g, "\\'")+'\', \''+full.NumeroFacture+'\', \''+full.IDContact+'\', \''+full.EmailSend+'\', \''+full.EmailSendTo+'\',\''+full.IDContact_Responsables+'\')">'+
									'Envoyer la facture'+
								'</md-button>'+
							'</md-menu-item>';
						
					html += '</md-menu-content>'+'</md-menu>';
					return html;
				}),
			];
			
			
		vm.showEmployes = function(commande){
			 var selected = $filter('filter')(vm.employes, {IDEmploye: commande.toString()}, true);
			return (commande && selected.length) ? selected[0].Civilite+' '+selected[0].Prenom+' '+selected[0].Nom : 'Non défini';
		}
		
	
		
       
		
        vm.sendFactureEmail = function (ev, IDCommande, IDCommandes_Paiement, RaisonSocial, NumeroFacture, IDContact, EmailSend, EmailSendTo, IDContact_Responsables)
        {
            if (!vm.droitFacture('envoi')) return;
			if(EmailSend!="0000-00-00 00:00:00"){
				var confirm = $mdDialog.confirm()
				  .title(' Cette facture a déjà été envoyée le ' + convertDate(EmailSend) + " à " + EmailSendTo)
				  .textContent("Souhaitez-vous la renvoyer à la même personne ou à quelqu'un d'autre ?")
				  .ariaLabel("Renvoyer la facture")
				  .targetEvent(ev)
					.theme('md-warn')
				  .ok("Renvoyer la facture")
				  .cancel('Annuler');
			
				$mdDialog.show(confirm).then(function () {
					vm.selectContactToSend(ev, IDCommande, IDCommandes_Paiement, RaisonSocial, NumeroFacture, IDContact, EmailSend, EmailSendTo, IDContact_Responsables);
				}, function () {
				});
			}
			else
				vm.selectContactToSend(ev, IDCommande, IDCommandes_Paiement, RaisonSocial, NumeroFacture, IDContact, EmailSend, EmailSendTo, IDContact_Responsables);
		}
		
		vm.selectContactToSend = function (ev, IDCommande, IDCommandes_Paiement, RaisonSocial, NumeroFacture, IDContact, EmailSend, EmailSendTo, IDContact_Responsables){
			$http.get("/datas/contacts/getContactInfoByID.json?IDContact="+IDContact)
            // La transmission dématérialisée ne dépend pas d'une adresse email.
            .catch(function () { return {data:{data:[]}}; })
			.then(function (response, status, headers, config) {
				var contacts = response.data.data || [];
				
				if(contacts){
					
					$mdDialog.show({
						controller: 'ContactsSendFactureController',
							templateUrl        : 'app/main/commandes/factures/dialogs/contacts-sendfactures-dialog.html',
							parent: angular.element(document.body),
							targetEvent: ev,
							controllerAs       : 'vm',
							clickOutsideToClose:true,
							locals             : {
								contacts : contacts,
								NumeroFacture : NumeroFacture,
								RaisonSocial : RaisonSocial
							}
						})
						.then(function(response) {
							
							if(typeof response != "undefined"){
								
								if(typeof response.data != "undefined" && response.data.error){
									$mdToast.show(
									  $mdToast.simple()
										.textContent(response.data.error.message)
										.position('bottom right' )
										.hideDelay(3000)
									);
									vm.showSpinner = 0;
								}
								else {
									(response.EnvoiPlateforme ?
                                        $http.post("/datas/commandes/transmettreFacture.json", {
                                            IDContact_Responsables: response.EnvoiEmail ? response.IDContact_Responsables : undefined,
                                            IDCommande: IDCommande, IDPaiement: IDCommandes_Paiement,
                                            Canal: response.EnvoiEmail ? "email_plateforme" : "plateforme"
                                        }) :
                                        $http.get("/datas/commandes/sendFacture.json?IDContact_Responsables="+response.IDContact_Responsables+"&IDCommande="+IDCommande+"&IDPaiement="+IDCommandes_Paiement))
										.then(function (response, status, headers, config) {
				
										console.log(response);
										
										if (response.config && response.config.url === "/datas/commandes/transmettreFacture.json" && !response.data.error) {
                                            var canaux = response.data.data && response.data.data.Canaux;
                                            if (!canaux || !canaux.length || canaux.some(function (canal) {
                                                return ["Envoyé", "Transmise", "Acceptée"].indexOf(canal.Statut) === -1;
                                            })) {
                                                response.data.error = {message: canaux && canaux.length ?
                                                    canaux.map(function (canal) { return canal.Canal + " : " + canal.Statut + (canal.Message ? " — " + canal.Message : ""); }).join(". ") :
                                                    "Réponse de transmission incomplète. Vérifier les statuts avant un nouvel envoi."};
                                            }
                                        }
                                        if(response.data.error){
											var canauxErreur = response.data.data && response.data.data.Canaux || [];
											var destinataireNonReference = canauxErreur.some(function (canal) {
												return canal.Canal === 'SuperPDP' && canal.Statut === 'Non référencé';
											});
											$mdDialog.show(
											  $mdDialog.alert()
												.clickOutsideToClose(false)
												.title(destinataireNonReference ? 'Destinataire non référencé' : "Une erreur s'est produite")
												.textContent(response.data.error.message)
												.ok('OK')
											);
										}
										else{
											vm.dtInstanceFactures.reloadData();
											$mdToast.show(
											  $mdToast.simple()
												.textContent("Facture envoyée avec succès !")
												.position('bottom right' )
												.hideDelay(3000)
											);
										}
										
									}, function () {
                                            $mdToast.show($mdToast.simple()
                                                .textContent("Réponse non reçue. Vérifier les statuts avant de renvoyer la facture.")
                                                .position('bottom right').hideDelay(5000));
                                        });	 
								}
			
							} 
							
							/* Etat = "Facturée";
							DateFacturation = Date.now();
							if(typeof result != "undefined"){
								var d = new Date(result),
								month = '' + (d.getMonth() + 1),
								day = '' + d.getDate(),
								year = d.getFullYear();

								if (month.length < 2) month = '0' + month;
								if (day.length < 2) day = '0' + day;
								
								DateRenouvellement = [year, month, day].join('-');
							}
							// writeCommande();
							$mdToast.show(
							  $mdToast.simple()
								.textContent('La commande a été facturée !')
								.position('bottom right' )
								.hideDelay(3000)
							);
							
							$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank'); */
							 vm.dtInstanceFactures.reloadData();
							console.log(contacts);
						
						}, function() {
						});
						
				 
				}
				else
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Aucun contact trouvé...')
						.position('bottom right' )
						.hideDelay(3000)
					);
				
			}, function () {});	 
		}
		
        vm.getFacture = function (ev, IDCommande, IDCommandes_Paiement)
        {
			console.log(IDCommandes_Paiement);
			if(IDCommandes_Paiement != 0)
				$window.open("/datas/commandes/afacture.json?IDCommande="+IDCommande+'&IDPaiement='+IDCommandes_Paiement, '_blank');
			else
				$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande, '_blank');
			/* if(Etat != "Facturée"/){
				$http.get("/datas/commandes/getCommande.json?IDCommande="+IDCommande)
				.then(function (response, status, headers, config) {
					var comde = response.data.data;
					var produit_a_renouveler = [];
					
					angular.forEach(comde.produits, function (value, key) {
						if(value.Renouvellement > 0 ){
							produit_a_renouveler.push({'Produit':value.Produit,'Renouvellement':value.Renouvellement});
						}
						
						angular.forEach(value.SousProduitsSelect, function (v, k) {
							if(v.Renouvellement > 0 ){
								produit_a_renouveler.push({'Produit':v.Produit,'Renouvellement':v.Renouvellement});
							}
						});
					});
					
					if(produit_a_renouveler.length > 0 && TotalTTC>0){
						$mdDialog.show({
						  controller: 'DialogFactureController',
							templateUrl        : 'app/main/commandes/commande/dialogs/facture-dialog.html',
						  parent: angular.element(document.body),
						  targetEvent: ev,
						  clickOutsideToClose:true,
							locals             : {
								Renouvellement : DateRenouvellement,
								produit_a_renouveler : produit_a_renouveler
							}
						})
						.then(function(result) {
							Etat = "Facturée";
							DateFacturation = Date.now();
							if(typeof result != "undefined"){
								var d = new Date(result),
								month = '' + (d.getMonth() + 1),
								day = '' + d.getDate(),
								year = d.getFullYear();

								if (month.length < 2) month = '0' + month;
								if (day.length < 2) day = '0' + day;
								
								DateRenouvellement = [year, month, day].join('-');
							}
							// writeCommande();
							$mdToast.show(
							  $mdToast.simple()
								.textContent('La commande a été facturée !')
								.position('bottom right' )
								.hideDelay(3000)
							);
							
							$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
							 vm.dtInstanceFactures.reloadData();
						
						}, function() {
						});
					}
					else{
						
						
						if(TotalTTC<0)
							var confirm = $mdDialog.confirm()
							  .title(' Souhaitez-vous faire un avoir ? ')
							  .textContent("Une fois l'avoir généré, cette commande ne pourra plus être modifiée.")
							  .ariaLabel("Générer l'avoir")
							  .targetEvent(ev)
								.theme('md-warn')
							  .ok("Générer l'avoir")
							  .cancel('Annuler');
						else
							var confirm = $mdDialog.confirm()
							  .title(' Souhaitez-vous facturer cette commande ? ')
							  .textContent('Une fois facturée, cette commande ne pourra plus être modifiée. ')
							  .ariaLabel('Facturer la commande')
							  .targetEvent(ev)
								.theme('md-warn')
							  .ok('Générer la facture')
							  .cancel('Annuler');

						$mdDialog.show(confirm).then(function () {
						  	  
								$mdToast.show(
								  $mdToast.simple()
									.textContent('La commande a été facturée !')
									.position('bottom right' )
									.hideDelay(3000)
								);
								
								$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
								 vm.dtInstanceFactures.reloadData();
						}, function () {
						});
					  
					}
				}, function () {});	 
			}
			else{
				$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
					 // vm.dtInstanceFactures.reloadData();
			}  */
		
        }
		
			  
		function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		function DialogDevisController($scope, $mdDialog) {
			$scope.hide = function() {
			  $mdDialog.hide();
			};
			
			$scope.items = ["Conditions Générales de Ventes", "Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>", "Cahier des charges fonctionnel"];
			$scope.selected = ["Conditions Générales de Ventes"];

			$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
			};

			$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
			};
		  
			$scope.cancel = function() {
			  $mdDialog.cancel();
			};

			$scope.answer = function(result) {
			  $mdDialog.hide(result);
			};
		}
	
		vm.getFactureAcompte = function (ev, commande){
			
			$http.get("/datas/commandes/getCommande.json?IDCommande="+commande)
			.then(function (response, status, headers, config) {
				// console.log(response.data.data);
				$mdDialog.show({
					 parent             : angular.element(document.body),
					targetEvent        : ev,
					controller         : 'DialogFactureAcompteController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commandes/dialogs/acompte-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande : response.data.data,
						Paiements : response.data.data.paiements,
						dtInstanceFactures : vm.dtInstanceFactures
					}
				});
				
					 // vm.dtInstanceFactures.reloadData();
			}, function () {});
		}
		
		vm.getDevisSigne = function (ev, IDCommande, NumeroCommande){
			// console.log(IDCommande);
			// console.log(NumeroCommande);
			$window.open("/datas/files/devis_signes/"+IDCommande+"-"+NumeroCommande+".pdf", '_blank');
		}
		
		vm.getDevis = function (ev, IDCommande, prelevement){
			if(prelevement ==1){
				var confirm = $mdDialog.confirm()
					  .title('Attention, IBAN du contact manquant !')
					  .textContent("L'IBAN sera obligatoire pour valider une commande par prélévement")
					  .ariaLabel('IBAN manquant')
					  .targetEvent(ev)
					  .clickOutsideToClose(true)
					  .parent(angular.element(document.body))
					  .ok('Continuer')
					  .cancel('Annuler');
					  
					$mdDialog.show(confirm).then(function() {
						 $mdDialog.show({
						  controller: DialogDevisController,
							templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
						  parent: angular.element(document.body),
						  targetEvent: ev,
						  clickOutsideToClose:true
						})
						.then(function(result) {
							var lien = "/datas/commandes/devis.json?IDCommande="+IDCommande;
							
							if(result.indexOf("Conditions Générales de Ventes")>=0)
								lien +="&cgv=1";
							else
								lien +="&cgv=0";
							if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
								lien +="&retractation=1";
							else
								lien +="&retractation=0";
							
							$window.open(lien, '_blank');
						}, function() {
					});
				}, function() {}); 
			}
			else{
			   $mdDialog.show({
					  controller: DialogDevisController,
						templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
					  parent: angular.element(document.body),
					  targetEvent: ev,
					  clickOutsideToClose:true
					})
					.then(function(result) {
						var lien = "/datas/commandes/devis.json?IDCommande="+IDCommande;
						
						if(result.indexOf("Conditions Générales de Ventes")>=0)
							lien +="&cgv=1";
						else
							lien +="&cgv=0";
						if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
							lien +="&retractation=1";
						else
							lien +="&retractation=0";
						
						$window.open(lien, '_blank');
					}, function() {
				});
			}
		}
		
		vm.deleteCommande = function (ev, commande, NumeroCommande)
        {
			var commandeObj = {IDCommande:commande};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer cette commande ?')
                .htmlContent('<b>La commande N°' + NumeroCommande + '</b>' + ' va être supprimée.')
                .ariaLabel('Supprimer une commande')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/commandes/deleteCommande.json", JSON.stringify(commandeObj)).then(function (response, status, headers, config) {  
					if(response.data.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.title("Une erreur s'est produite")
							.textContent(response.data.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.dtInstanceFactures.reloadData();
						$mdToast.show(
						  $mdToast.simple()
							.textContent('La commande a été supprimée.')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				}, function () {});
				
            });
        }
		
		

		vm.editOptions = function(ev, IDCommande){
			
		
		$http.get("/datas/commandes/getCommande.json?IDCommande="+IDCommande)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					parent             : angular.element(document.body),
					targetEvent        : ev,
					controller         : 'DialogOptionsCommandeController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commandes/dialogs/options-commande-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande :response.data.data
					}
				}).then(function(result) {
					 vm.dtInstanceFactures.reloadData();
				}, function () {});	
			}, function () {});
		}
		
		
		vm.DetailsCommande = function(ev, IDCommande){
			$mdDialog.show({
                parent             : angular.element(document.body),
                targetEvent        : ev,
                controller         : 'CommandesDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/commandes/dialogs/details-dialog.html',
                clickOutsideToClose: true,
                locals             : {
                    IDCommande : IDCommande,
					Fabricants : Fabricants,
					paramVM : vm
                },
            }).then(function(result) {
				if(result)
					vm.dtInstanceFactures.reloadData();
			}, function () {
				if(vm.reload){
					vm.dtInstanceFactures.reloadData();
					vm.reload = false;
				}
			});
		}
			
  
    }
	
	 
	  
})();

(function ()
{
    'use strict';

    angular
        .module('app.commandes.commandes')
        .controller('CommandesController', CommandesController)	;

    /** @ngInject */


    function CommandesController($state, employesSimple, simpleListeCommandes, Fabricants, nbrCommandesParEtats, Commandes, $scope, $rootScope, $mdSidenav, Employes, $location, $mdDialog, $http, $mdToast, $window, $filter, $document, DTOptionsBuilder, DTColumnBuilder, $compile)
    {
		
		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		// console.log(Fabricants);
		
        var vm = this;
		vm.rows = [];
        // Data
        vm.commandes = Commandes.data;
        vm.employes = Employes.data;
		vm.nbrCommandesParEtats = nbrCommandesParEtats.data;
		vm.showMarges = 0;
		
		$http.get("datas/commandes/getNbrCommandesParEtats.json").then(function (response, status, headers, config) {vm.nbrCommandesParEtats = response.data.data;}, function () {});
		
		
		vm.recordsTotal = 0;
		
        vm.filterChange = filterChange;
        vm.filterStatus = localStorage.getItem('commandesStatus');
		if(vm.filterStatus == null)
			vm.filterStatus = '';
		
		// vm.filterChange(vm.filterStatus);
		
		vm.search = localStorage.getItem('commandesSearch');
		vm.searchBox = "";
		
        vm.toggleSidenav = toggleSidenav;
		
		
		function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	

		function filterChange(type)
        {

            vm.filterStatus = type;
			localStorage.setItem('commandesStatus', type);
			$('.dataTable thead tr:nth-child(2) th:nth-child(8)').find('select').val(type);
			$('.dataTable thead tr:nth-child(2) th:nth-child(8)').find('select').trigger("change");
        }
		
		$(document).on('change', '.dataTable thead tr:nth-child(2) th:nth-child(8)', function(){
			// filterChange($(this).find('select').val());
			// console.log($(this).find('select').val());
            vm.filterStatus = $(this).find('select').val();
			localStorage.setItem('commandesStatus', $(this).find('select').val());
		});
		
		vm.openContactDialog = function (contact)
        {
			var contactObj = {IDContact:contact};
            $mdDialog.show({
                controller         : 'profilContactController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/contacts/profil/profil-dialog.html',
                parent             : angular.element(".commandes"),
                clickOutsideToClose: true,
				multiple:true,
				fullscreen:true,
				openFrom  : '#previewContact',
				closeTo  : '#previewContact',
                locals             : {
					Contact: contactObj,
					Fabricants: Fabricants,
					employesSimple: employesSimple,
					Structures: {},
					APE: {},
					Activites: {},
					Commandes: {},
					Alertes: {},
					Courriers: {},
					Employes: {},
					Dialog:1
                }
            });
        }


		vm.setRenouvelee = function(commande){$http.post("/datas/commandes/setRenouvelee.json",JSON.stringify({'IDCommande':commande})).then(function (response, status, headers, config) {  vm.dtInstance.reloadData();}, function () {});}
		vm.setNonRenouvelee = function(commande){$http.post("/datas/commandes/setNonRenouvelee.json",JSON.stringify({'IDCommande':commande})).then(function (response, status, headers, config) {  vm.dtInstance.reloadData();}, function () {});}
		
		vm.filterSave = [];
        vm.dtInstance = {};
		
		vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'data',
				 url: 'datas/commandes/getAllcommandes.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'DataTablesCommandes', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
			/* 	  $('.scrollable').animate({  ??? GENANT D'APRES COLLABORATEURS
					scrollTop: 0
				  }, 'slow'); */
			})
			.withOption('stateLoadCallback', function (oSettings) {
				return JSON.parse( localStorage.getItem('DataTablesCommandes') );
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('columnDefs',   [
                {
                    // Target the id column
                    targets: 0,
                    responsivePriority: 1,
                },
                {
                    // Target the id column
                    targets: 1,
                    responsivePriority: 1,
                },
				{
                    // Target the id column
                    targets: 2,
					render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return convertDate(data);
                        }

                        return data;
                    }
                },
                {
                    // Target the price column
                    targets: 4,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },  
                {
                    // Target the price column
                    targets: 5,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },        {
                    // Target the actions column
                    targets           : 8,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				// Recompiling so we can bind Angular directive to the DT
				// console.log(row);
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					// Use this headerCompiled field to only compile header once
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
				var api = this.api();
                    vm.searchBox = angular.element('body').find('#commandes-search');

				angular.forEach(vm.filterSave, function(value, key) {
					var cpt = key+1;
					if(value.search.search.includes("~")){
						jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
						jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
						
					} else{
						jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
						jQuery('.dataTableCommandes tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
					}
				}); 				
				
                if ( vm.searchBox.length > 0 )
                {
					var timeout = null;
					
                    vm.searchBox.on('keyup', function (event)
                    {
						clearTimeout(timeout);
						timeout = setTimeout(function () {
							api.search(vm.search).draw();
						}, 500);
                    });
                }
				
				vm.recordsTotal = json.recordsTotal;
				filterChange(vm.filterStatus);
			  }
			)
			.withLightColumnFilter({
				  "0": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "1": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  /* "1": {
					"html": "select",
					"values": simpleListeCommandes.data,
					"location": $location,
					"regex":true
				  }, */
				  "2": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "3": {
					"html": "select",
					"values": employesSimple.data,
					"location": $location,
					"regex":true
				  },
				  "4": {
					"html": "range",
					"type": "number",
					"location": $location
				  },
				  "5": {
					"html": "range",
					"type": "number",
					"location": $location
				  },
				  "6": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "7": {
					"html": "select",
					"values": [
						{value: '', label: '--'}, 
						{value: 'Facturée', label: 'Facturée'}, 
						{value: 'A renouveler', label: 'A renouveler'}, 
						{value: 'Renouvelée', label: 'Renouvelée'}, 
						{value: 'Non renouvelée', label: 'Non renouvelée'}, 
						{value: 'Signée', label: 'Signée'}, 
						{value: 'Validée', label: 'Validée'}, 
						{value: 'En attente', label: 'En attente'	},
						{value: 'Annulée', label: 'Annulée'	},
						{value: 'Brouillon', label: 'Brouillon'	}
					],
					"location": $location,
				  "regex":true
				 },
				  "8": {
					"html": "clear",
					"status":"commandesStatus"
				  }
				  
			  })
			  
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('fnRowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
				 // $('td', nRow).unbind('click');
					// $('td', nRow).bind('click', function() {
					// console.log(nRow);
					// openContactDialog(aData);
                      // $scope.$apply(function() {
                        // vm.expend(nRow, aData);
                    // });  
                // });
                // return nRow;
            })
			.withOption('order', [0, 'desc']);
			
			vm.dtColumns = [
				DTColumnBuilder.newColumn('NumeroCommande').withTitle('<div class="table-header"><span class="column-title">N° Commande</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
					var html = data;
					
					if(full.ComConsultants == 1)
						html += '<br><span class="blue-600-fg">Com-Consultants le '+convertDate(full.DateFacturation)+'</span>';	
					
					if(full.NumeroFacture)
						html += '<br><span> '+full.NumeroFacture+' - '+convertDate(full.DateFacturation)+'</span>';	
					
					// if(full.NomCommande && full.Etat != 'Facturée')
					if(full.NomCommande)
						html += '<em><br> '+full.NomCommande+'</em>';	
					
					return html;
				}),
				/* DTColumnBuilder.newColumn('NumeroFacture').withTitle('<div class="table-header"><span class="column-title">N° Facture</div></div>').withOption('width', '80px').renderWith(function(data, type, full){
					var html = "";
					
					
					if(full.NumeroFacture)
						html += data+'<br>'+convertDate(full.DateFacturation)+'</span>';	
					
					
					return html;
				}), */
				DTColumnBuilder.newColumn('RaisonSocial').withTitle('<div class="table-header"><span class="column-title">Client</div></div>').renderWith(function(data, type, full, meta ){
					return '<a ng-click="vm.openContactDialog('+ full.IDContact +')" href="#">'+full.RaisonSocial+"</a>";
				}),
				DTColumnBuilder.newColumn('DateCreation').withTitle('<div class="table-header"><span class="column-title">Date de création</div></div>').withOption('width', '120px').renderWith(function(data, type, full, meta ){
					if(data!="0000-00-00" && data != "1970-01-01")
						return convertDate(data);
					else
						return "";
				}),
				DTColumnBuilder.newColumn('IDEmploye').withTitle('<div class="table-header"><span class="column-title">Commercial</div></div>').withOption('width', '220px').renderWith(function(data, type, full, meta ){
				
					vm.rows[meta.row] = full;
					
					if ( type === 'display' ){
						var html ="";
							if(full.CommercialSupprime=="1")
								html += '<span class="grey-600-fg">'+full.Commercial+'<md-tooltip md-direction="left" >Compte supprimé</md-tooltip></span>';
							else{
								if(full.CommercialNonModifiable)
									html += '<span>'+full.Commercial+'</span>';
								else
									html += '<a href="#" editable-select="vm.rows['+meta.row+'].IDEmploye"  onaftersave="vm.saveCommercial('+meta.row+')" e-ng-options="s.IDEmploye.toString() as s.Civilite+\' \'+s.Prenom+\' \'+s.Nom for s in vm.employes"><span ng-bind-html="vm.showEmployes('+full.IDEmploye+')"></span></a>';
							}
                       return html;
					}
					return data;
				}),
				//DTColumnBuilder.newColumn('MargeBrutHT').withTitle('<div class="table-header"><span class="column-title">Marge HT</div></div>').withOption('width', '100px'),
				DTColumnBuilder.newColumn('TotalHTRemise').withTitle('<div class="table-header"><span class="column-title">Total HT</div></div>').withOption('width', '100px'),
				DTColumnBuilder.newColumn('ProchainPaiement').withTitle('<div class="table-header"><span class="column-title">Prochain Paiement</div></div>').withOption('width', '130px').renderWith(function(data, type, full){
					if ( type === 'display' && full.EtatAffiche == "Signée" ){
						var timestamp = new Date().getTime() + (30 * 24 * 60 * 15 * 1000);
						var date = new Date(data);
						var dateDay = new Date();
						
						if(data!="0000-00-00" && data != "1970-01-01")
								if (dateDay >= date)
									return "<span class='red-700-fg'>"+convertDate(data)+"</span>";
								else if (timestamp > date)
									return "<span class='amber-700-fg'>"+convertDate(data)+"</span>";
								else
									return "<span>"+convertDate(data)+"</span>";
						else
							return "";
					}
					return data;
				}),
				DTColumnBuilder.newColumn('DateRenouvellement').withTitle('<div class="table-header"><span class="column-title">Date Renouv.</div></div>').withOption('width', '130px').renderWith(function(data, type, full){
					if ( type === 'display' ){
						/*var html ="";
							
							switch(data){
								case "Brouillon": html = '<span class="p-5 pr-8 pl-8 brad-16 md-amber-500-bg white-fg" selected="true"><small>Brouillon</small></span>'; break;
								case "Annulée": html = '<span class="p-5 pr-8 pl-8 brad-16 grey-500-bg white-fg" selected="true"><small>Annulée</small></span>'; break;
								case "En attente": html = '<span class="p-5 pr-8 pl-8 brad-16 md-warn-bg white-fg" selected="true"><small>En attente</small></span>'; break;
								case "Validée": html = '<span class="p-5 pr-8 pl-8 brad-16 md-grey-500-bg white-fg" selected="true"><small>Validée</small></span>'; break;
								case "Signée": html = '<span class="p-5 pr-8 pl-8 brad-16 md-blue-grey-500-bg white-fg" nselected="true"><small>Signée</small></span>'; break;
								case "Com-Consultants": html = '<span class="p-5 pr-8 pl-8 brad-16 md-blue-500-bg white-fg" selected="true"><small>Com-Consultants le '+convertDate(full.DateFacturation)+'</small></span>'; break;
								case "Facturée": html = '<span class="p-5 pr-8 pl-8 brad-16 md-green-bg white-fg" selected="true"><small>Facturée le '+convertDate(full.DateFacturation)+'</small></span>'; break;
							}*/
						var timestamp = new Date().getTime() + (30 * 24 * 60 * 60 * 1000);
						var date = new Date(data);
						var dateDay = new Date();
						
						if(data!="0000-00-00" && data != "1970-01-01")
							if(full.Renouvellement != 1)
								if (dateDay >= date)
									return "<span class='red-700-fg'>"+convertDate(data)+"</span>";
								else if (timestamp > date)
									return "<span class='amber-700-fg'>"+convertDate(data)+"</span>";
								else
									return "<span>"+convertDate(data)+"</span>";
							else
								return "<span>"+convertDate(data)+"</span>";
						else
							return "";
					}
					return data;
				}),
				DTColumnBuilder.newColumn('EtatAffiche').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
					if ( type === 'display' ){
						var html ="";
							
							switch(data){
								case "Brouillon": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-amber-600-bg white-fg" ><small>Brouillon</small></span>'; break;
								case "Annulée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 grey-500-bg white-fg" ><small>Annulée</small></span>'; break;
								case "En attente": html = '<span class="tag p-5 pr-8 pl-8 brad-16 red-600-bg white-fg" ><small>En attente</small></span>'; break;
								case "Validée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-cyan-700-bg white-fg" ><small>Validée</small></span>'; break;
								case "Signée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-teal-600-bg white-fg" ><small>Signée</small></span>'; break;
								case "Com-Consultants": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-blue-500-bg white-fg" ><small>Com-Consultants le '+convertDate(full.DateFacturation)+'</small></span>'; break;
								case "Facturée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-green-bg white-fg" ><small>Facturée</small></span>'; break;
								case "Renouvelée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-green-900-bg white-fg" ><small>Renouvelée</small></span>'; break;
								case "A renouveler": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-orange-600-bg white-fg" ><small>A renouveler</small></span>'; break;
								case "Non renouvelée": html = '<span class="tag p-5 pr-8 pl-8 brad-16 md-red-900-bg md-hue-2 white-fg" ><small>Non renouvelée</small></span>'; break;
							}
                       return html;
					}
					return data;
				}),
				DTColumnBuilder.newColumn('IDCommande').withTitle('<div class="table-header"><span class="column-title"></div></div>').withOption('width', '60px').renderWith(function(data, type, full){
					
					if(full.Prelevement == 1 && full.IDCommande_IBAN==0)
						var prelevement = 1;
					else
						var prelevement = 0;
				
					
					var html = '<md-menu style="float: right;">'+
							'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
								'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
							'</md-button>'+
							'<md-menu-content width="3">';
							
					html += '<md-menu-item>'+ 
								'<md-button ng-click="vm.DetailsCommande($event, '+full.IDCommande+')">'+ 
									'Aperçu commande'+
								'</md-button>'+
							'</md-menu-item>'+
							'<md-menu-item>'+ 
								'<md-button ng-click="vm.openContactDialog('+ full.IDContact +')">'+ 
									'Fiche client'+
								'</md-button>'+
							'</md-menu-item>'+
							'<md-divider >'+'</md-divider>';
					html += '<md-menu-item>'+
								'<md-button '+ ((full.Etat=='Facturée' || (full.Etat=='Signée' /*  && full.Paiements.length <= 1 */ ) || full.Etat=='A renouveler' || full.Etat=='Renouvelée' || full.Etat=='Non renouvelée') ? "disabled":"") +' ng-click="vm.editCommande('+full.IDCommande+')">'+
									'Modifier'+
								'</md-button>'+
							'</md-menu-item>'+
							'<md-menu-item>'+
								'<md-button ng-click="vm.dupliqueCommande('+full.IDCommande+')">'+
									'Dupliquer'+
								'</md-button>'+
							'</md-menu-item>';
							
					if($rootScope.Permission=='Super Admin')
					html += '<md-menu-item >'+
								'<md-button ng-click="vm.editOptions($event, '+full.IDCommande+')">'+
									'Options'+
								'</md-button>'+
							'</md-menu-item>';
							
					 		
							
					if(full.Etat=='Brouillon')
					html += 
							'<md-divider >'+'</md-divider>'+
							'<md-menu-item  >'+
								'<md-button ng-click="vm.deleteCommande($event, '+full.IDCommande+', '+full.NumeroCommande+')">'+
									'Supprimer'+
								'</md-button>'+
							'</md-menu-item>';
							
				
					
					if(full.Etat!="Brouillon"){		
						html += '<md-divider >'+'</md-divider>';
							
				  
						if(full.DateRenouvellement!="0000-00-00" && full.DateRenouvellement != "1970-01-01")
							html += '<md-menu-item>'+
										'<md-menu>'+
											'<md-button ng-click="$mdMenu.open()">Renouvellement</md-button>'+
											'<md-menu-content>'+
												'<md-menu-item >'+
													'<md-button '+ ((full.Renouvellement == 1) ? "disabled":"") +' ng-click="vm.setRenouvelee('+full.IDCommande+')" >'+
														'Passer en renouvelée'+
													'</md-button>'+
												'</md-menu-item>'+
												'<md-menu-item >'+
													'<md-button '+ ((full.Renouvellement == 2) ? "disabled":"") +' ng-click="vm.setNonRenouvelee('+full.IDCommande+')">'+
														'Passer en non-renouvelée'+
													'</md-button>'+
												'</md-menu-item>'+
											'</md-menu-content>'+
										'</md-menu>'+
									'</md-menu-item>'+
									'<md-divider ></md-divider>';
							
						html += '<md-menu-item>'+
									'<md-menu>'+
										'<md-button ng-click="$mdMenu.open()">Documents</md-button>'+
										'<md-menu-content>';
										
											if(full.Etat!='Facturée' && full.Etat!='Signée' && full.Etat!='Brouillon' && full.TotalTTC>=0)
											html += '<md-menu-item >'+
														'<md-button ng-click="vm.getDevis($event,'+full.IDCommande+', '+prelevement+')">'+
															'Générer le devis'+
														'</md-button>'+
													'</md-menu-item>';	
													
											if((full.Etat=='Facturée' || full.Etat=='Signée')){
											html += '<md-menu-item >'+
														'<md-button target=" _blank" ng-click="vm.getDevisSigne($event,'+full.IDCommande+', \''+full.NumeroCommande+'\')" ';
														
														if(full.DevisSigne!=true)
															html += 'disabled';
														
														html += '>'+
															'Voir le devis signé'+
														'</md-button>'+
													'</md-menu-item>';						
											}
														
											if(full.Etat!='Facturée' && full.Paiements.length<= 1 && full.Etat!='Brouillon' && full.TotalTTC<0)
											html += '<md-menu-item >'+
														'<md-button '+ ((full.Etat!='Signée' && full.Etat!='Validée') ? "disabled":"") +' ng-click="vm.getFacture(event, '+full.IDCommande+', \''+full.DateRenouvellement+'\', \''+full.Etat+'\', \''+full.DateFacturation+'\', \''+full.TotalTTC+'\')">'+
															"Générer l'avoir"+
														'</md-button>'+
													'</md-menu-item>';
													
											if(full.Etat!='Facturée' && full.Paiements.length <= 1 && full.Etat!='Brouillon'  && full.TotalTTC>=0)
											html += '<md-menu-item >'+
														'<md-button '+ ((full.Etat!='Signée' && full.Etat!='Validée') ? "disabled":"") +' ng-click="vm.getFacture(event, '+full.IDCommande+', \''+full.DateRenouvellement+'\', \''+full.Etat+'\', \''+full.DateFacturation+'\', '+full.TotalTTC+')">'+
															'Générer la facture'+
														'</md-button>'+
													'</md-menu-item>'; 
													
											if(full.Paiements.length > 1 && full.Etat!='Brouillon')
											html += '<md-menu-item  >'+
														'<md-button '+ ((full.Etat!='Signée' && full.Etat!='Validée' && full.Etat!='Facturée') ? "disabled":"") +' ng-click="vm.getFactureAcompte(event, '+full.IDCommande+', '+prelevement+')">'+
															'Facturations'+
														'</md-button>'+
													'</md-menu-item>'; 
											
											if(full.Etat=='Facturée' && full.Paiements.length <= 1 && full.Etat!='Brouillon')
											html += '<md-menu-item >'+
														'<md-button ng-click="vm.getFacture(event, '+full.IDCommande+', \''+full.DateRenouvellement+'\', \''+full.Etat+'\', \''+full.DateFacturation+'\', \''+full.TotalTTC+'\')">'+
															'Télécharger la facture'+
														'</md-button>'+
													'</md-menu-item>';
						
						html +=				'</md-menu-content>'+
									'</md-menu>'+
								'</md-menu-item>';
					}
					html += '</md-menu-content>'+'</md-menu>';
					return html;
				}),
			];
			
			
		vm.showEmployes = function(commande){
			 var selected = $filter('filter')(vm.employes, {IDEmploye: commande.toString()}, true);
			return (commande && selected.length) ? selected[0].Civilite+' '+selected[0].Prenom+' '+selected[0].Nom : 'Non défini';
		}
		
		vm.saveCommercial = function(row){
			 $http.post("/datas/commandes/setCommercial.json",JSON.stringify(vm.rows[row]))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
				}
				else{
					vm.dtInstance.reloadData();
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Le commercial de la commande '+vm.rows[row].NumeroCommande+' a été modifié.')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
			}, function () {});	
		}
		
        vm.ajouterCommande = ajouterCommande;
        vm.editCommande = editCommande;

        vm.dupliqueCommande = function (IDCommande){
			$http.post("/datas/commandes/dupliquer.json",{'IDCommande':IDCommande})
			.then(function (response, status, headers, config) {
				editCommande(response.data.data.IDCommande);
			}, function () {});
		}
		
        function editCommande(IDCommande)
        {
			$location.path('/commandes/edition/' + IDCommande + '/');
        }
		
        function ajouterCommande()
        {
            $state.go('app.commandes_nouvelle');
        }
		
        vm.getFacture = function (ev, IDCommande, DateRenouvellement, Etat, DateFacturation, TotalTTC)
        {
			if(Etat != "Facturée"/*  && Etat != "Signée" */){
				$http.get("/datas/commandes/getCommande.json?IDCommande="+IDCommande)
				.then(function (response, status, headers, config) {
					var comde = response.data.data;
					var produit_a_renouveler = [];
					
					angular.forEach(comde.produits, function (value, key) {
						if(value.Renouvellement > 0 ){
							produit_a_renouveler.push({'Produit':value.Produit,'Renouvellement':value.Renouvellement});
						}
						
						angular.forEach(value.SousProduitsSelect, function (v, k) {
							if(v.Renouvellement > 0 ){
								produit_a_renouveler.push({'Produit':v.Produit,'Renouvellement':v.Renouvellement});
							}
						});
					});
					
					if(produit_a_renouveler.length > 0 && TotalTTC>0){
						$mdDialog.show({
						  controller: 'DialogFactureController',
							templateUrl        : 'app/main/commandes/commande/dialogs/facture-dialog.html',
						  parent: angular.element(document.body),
						  targetEvent: ev,
						  clickOutsideToClose:true,
							locals             : {
								Renouvellement : DateRenouvellement,
								produit_a_renouveler : produit_a_renouveler
							}
						})
						.then(function(result) {
							Etat = "Facturée";
							DateFacturation = Date.now();
							if(typeof result != "undefined"){
								var d = new Date(result),
								month = '' + (d.getMonth() + 1),
								day = '' + d.getDate(),
								year = d.getFullYear();

								if (month.length < 2) month = '0' + month;
								if (day.length < 2) day = '0' + day;
								
								DateRenouvellement = [year, month, day].join('-');
							}
							// writeCommande();
							$mdToast.show(
							  $mdToast.simple()
								.textContent('La commande a été facturée !')
								.position('bottom right' )
								.hideDelay(3000)
							);
							
							$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
							 vm.dtInstance.reloadData();
						
						}, function() {
						});
					}
					else{
						
						
						if(TotalTTC<0)
							var confirm = $mdDialog.confirm()
							  .title(' Souhaitez-vous faire un avoir ? ')
							  .textContent("Une fois l'avoir généré, cette commande ne pourra plus être modifiée.")
							  .ariaLabel("Générer l'avoir")
							  .targetEvent(ev)
								.theme('md-warn')
							  .ok("Générer l'avoir")
							  .cancel('Annuler');
						else
							var confirm = $mdDialog.confirm()
							  .title(' Souhaitez-vous facturer cette commande ? ')
							  .textContent('Une fois facturée, cette commande ne pourra plus être modifiée. ')
							  .ariaLabel('Facturer la commande')
							  .targetEvent(ev)
								.theme('md-warn')
							  .ok('Générer la facture')
							  .cancel('Annuler');

						$mdDialog.show(confirm).then(function () {
						  	  
								$mdToast.show(
								  $mdToast.simple()
									.textContent('La commande a été facturée !')
									.position('bottom right' )
									.hideDelay(3000)
								);
								
								$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
								 vm.dtInstance.reloadData();
						}, function () {
						});
					  
					} 
				}, function () {});	
			}
			else{
				/* if(Etat == "Signée"){
					Etat = "Facturée";
					DateFacturation = Date.now();
				} */
				$window.open("/datas/commandes/facture.json?IDCommande="+IDCommande+'&DateRenouvellement='+DateRenouvellement, '_blank');
					 // vm.dtInstance.reloadData();
			}
		
        }
		
			  
		function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		
		function DialogDevisController($scope, $mdDialog) {
			$scope.hide = function() {
			  $mdDialog.hide();
			};
			
			$scope.items = ["Conditions Générales de Ventes", "Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>", "Cahier des charges fonctionnel"];
			$scope.selected = ["Conditions Générales de Ventes"];

			$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
			};

			$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
			};
		  
			$scope.cancel = function() {
			  $mdDialog.cancel();
			};

			$scope.answer = function(result) {
			  $mdDialog.hide(result);
			};
		}
	
		vm.getFactureAcompte = function (ev, commande){
			
			$http.get("/datas/commandes/getCommande.json?IDCommande="+commande)
			.then(function (response, status, headers, config) {
				// console.log(response.data.data);
				$mdDialog.show({
					 parent             : angular.element(document.body),
					targetEvent        : ev,
					controller         : 'DialogFactureAcompteController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commandes/dialogs/acompte-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande : response.data.data,
						Paiements : response.data.data.paiements,
						dtInstance : vm.dtInstance
					}
				});
				
					 // vm.dtInstance.reloadData();
			}, function () {});
		}
		
		vm.getDevisSigne = function (ev, IDCommande, NumeroCommande){
			$window.open("/datas/files/devis_signes/"+IDCommande+"-"+NumeroCommande+".pdf", '_blank');
		}
		
		vm.getDevis = function (ev, IDCommande, prelevement){
			if(prelevement ==1){
				var confirm = $mdDialog.confirm()
					  .title('Attention, IBAN du contact manquant !')
					  .textContent("L'IBAN sera obligatoire pour valider une commande par prélévement")
					  .ariaLabel('IBAN manquant')
					  .targetEvent(ev)
					  .clickOutsideToClose(true)
					  .parent(angular.element(document.body))
					  .ok('Continuer')
					  .cancel('Annuler');
					  
					$mdDialog.show(confirm).then(function() {
						 $mdDialog.show({
						  controller: DialogDevisController,
							templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
						  parent: angular.element(document.body),
						  targetEvent: ev,
						  clickOutsideToClose:true
						})
						.then(function(result) {
							var lien = "/datas/commandes/devis.json?IDCommande="+IDCommande;
							
							if(result.indexOf("Conditions Générales de Ventes")>=0)
								lien +="&cgv=1";
							else
								lien +="&cgv=0";
							if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
								lien +="&retractation=1";
							else
								lien +="&retractation=0";
							
							$window.open(lien, '_blank');
						}, function() {
					});
				}, function() {}); 
			}
			else{
			   $mdDialog.show({
					  controller: DialogDevisController,
						templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
					  parent: angular.element(document.body),
					  targetEvent: ev,
					  clickOutsideToClose:true
					})
					.then(function(result) {
						var lien = "/datas/commandes/devis.json?IDCommande="+IDCommande;
						
						if(result.indexOf("Conditions Générales de Ventes")>=0)
							lien +="&cgv=1";
						else
							lien +="&cgv=0";
						if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
							lien +="&retractation=1";
						else
							lien +="&retractation=0";
						
						$window.open(lien, '_blank');
					}, function() {
				});
			}
		}
		
		vm.deleteCommande = function (ev, commande, NumeroCommande)
        {
			var commandeObj = {IDCommande:commande};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer cette commande ?')
                .htmlContent('<b>La commande N°' + NumeroCommande + '</b>' + ' va être supprimée.')
                .ariaLabel('Supprimer une commande')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/commandes/deleteCommande.json", JSON.stringify(commandeObj)).then(function (response, status, headers, config) {  
					if(response.data.data.error){
						$mdDialog.show(
						  $mdDialog.alert()
							.clickOutsideToClose(false)
							.title("Une erreur s'est produite")
							.textContent(response.data.data.error.message)
							.ok('OK')
						);
					}
					else{
						vm.dtInstance.reloadData();
						$mdToast.show(
						  $mdToast.simple()
							.textContent('La commande a été supprimée.')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}
				
				}, function () {});
				
            });
        }
		
		

		vm.editOptions = function(ev, IDCommande){
			
		
			$http.get("/datas/commandes/getCommande.json?IDCommande="+IDCommande)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					parent             : angular.element(document.body),
					targetEvent        : ev,
					controller         : 'DialogOptionsCommandeController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commandes/dialogs/options-commande-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						Commande :response.data.data
					}
				}).then(function(result) {
					 vm.dtInstance.reloadData();
				}, function () {});	
			}, function () {});
		}
		
		
		vm.DetailsCommande = function(ev, IDCommande){
			$mdDialog.show({
                parent             : angular.element(document.body),
                targetEvent        : ev,
                controller         : 'CommandesDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/commandes/dialogs/details-dialog.html',
                clickOutsideToClose: true,
                locals             : {
                    IDCommande : IDCommande,
					Fabricants : Fabricants,
					paramVM : vm
                },
            }).then(function(result) {
				if(result)
					vm.dtInstance.reloadData();
			}, function () {
				if(vm.reload){
					vm.dtInstance.reloadData();
					vm.reload = false;
				}
			});
		}
			
  
    }
	
	 
	  
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.edition')
        .controller('EditionController', EditionController)
		.filter('htmlToPlaintext', function() {
		return function(text) {
		  return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
		};
	  });
		
	angular.module('xeditable').factory('editableThemes', function() {
		  var themes = {
			'default': {
				onblur: 'ignore',
				mode: 'popover',
				formTpl:      '<form class="editable-wrap"></form>',
				noformTpl:    '<span class="editable-wrap"></span>',
				controlsTpl:  '<span class="editable-controls"></span>',
				inputTpl:     '',
				errorTpl:     '<div class="editable-error" data-ng-if="$error" data-ng-bind-html="$error"></div>',
				buttonsTpl:   '<span class="editable-buttons"></span>',
				submitTpl:    '<button type="submit"><md-icon class="green-500-fg" md-font-icon="icon icon-checkbox-marked-circle"></md-icon></button>',
				cancelTpl:    '<button type="button" ng-click="$form.$cancel()"><md-icon class="red-500-fg" md-font-icon="icon icon-close-circle"></md-icon></button>',
				resetTpl:    '<button type="reset">clear</button>'
			}};

		  return themes;
		});



    /** @ngInject */
    function EditionController($scope, $rootScope, $document, $state, Villes, Commande, Departements, Regions, IDContact, Contacts, $mdSidenav, $mdMedia, Produits, $mdToast,  $http, $element, $location, $mdDialog, $window)
    {

        var vm = this;
		
		vm.deplacer = 0;
		vm.showMarges = 0;
		vm.valeurPrecedenteSelect = null;
		
		vm.sortableOptions = {
			items: "tr:not(.not-sortable)"
		  };
		  
		vm.currentYear = new Date().getFullYear(); 
		vm.webregex = RegExp('^((https?|ftp)://)?([a-z]+[.])?[a-z0-9-]+([.][a-z]{1,6}){1,2}(/.*[?].*)?$', 'i');
		
		vm.showComplementaires = false;
		
		$scope.tinymceOptions = {
			plugins: [
			  "advlist autolink lists link image charmap print preview hr anchor pagebreak",
			  "searchreplace wordcount visualblocks visualchars code fullscreen",
			  "insertdatetime  nonbreaking save table contextmenu directionality",
			  "emoticons template paste textcolor colorpicker textpattern"
			],
			menubar:false,
			toolbar1: "insertfile undo redo | bold italic underline superscript subscript | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | hr forecolor backcolor",
		
			// toolbar2: "preview | styleselect hr forecolor backcolor table removeformat code",
			document_base_url : '/datas/images/courriers/',
			remove_script_host : false,
			convert_urls: false,
			paste_data_images: false,
			height : "300",
		};
			
			
		vm.Etat = [
			{value: "Brouillon", text: 'Brouillon'},
			{value: "Annulée", text: 'Annulée'},
			{value: "En attente", text: "En attente de validation"},
			{value: "Validée", text: 'Validée'},
			{value: "Signée", text: 'Signée'}			
		];
		
		if($rootScope.Permission=="Super Admin")
			vm.Etat.push({value: "Com-Consultants", text: 'Com-Consultants'});
		
		$scope.searchTerm;
		$scope.clearSearchTerm = function() {
			$scope.searchTerm = '';
		};
		$element.find('input').on('keydown', function(ev) {
			ev.stopPropagation();
		});
		
		if(typeof Commande != "undefined")
			vm.commande = Commande.data;
			
        vm.contacts = Contacts.data;
        vm.produits = Produits.data;
        vm.villes = Villes.data;
        vm.departements = Departements.data;
        vm.regions = Regions.data;
		
        vm.adresses = [];
        vm.sites = [];
        vm.adresse = [];
		vm.TotalPaiement = 0;
		
		
		if(typeof vm.commande == "undefined"){
			vm.commande = {'TotalTTC' :0,'TotalOriginalHT':0,'TotalHT':0, "paiements":[], "Etat":"En attente", "RemiseActive":"", "TotalHTRemise" :"", "RemiseEuroPourcent":'%', "Remise":"0", "Abonnement":"", "DateRenouvellement":"", "affichageRemiseProduits" : "Affichée", "resetContact" : 1, "produits":[]};
			if(IDContact){
				vm.commande.IDContact = IDContact;
				$http.post("/datas/contacts/getAdresses.json",JSON.stringify(vm.commande))
				.then(function (response, status, headers, config) {
					vm.adresses = response.data.data;
				}, function () {});	
			}
		}
		else
		{
			$http.post("/datas/contacts/getAdresses.json",JSON.stringify(vm.commande))
			// $http.get("/datas/contacts/getAdresses.json",JSON.stringify(vm.commande))
			.then(function (response, status, headers, config) {
				vm.adresses = response.data.data;
			}, function () {});
		}
		angular.forEach(vm.commande.paiements, function(value, key) {		
			vm.TotalPaiement =  parseFloat(vm.TotalPaiement) + (parseFloat(value.Montant));
		});
		
		
        vm.categoriesSelectFilter = '';
		vm.text_add_post = "";
        // Methods
        vm.saveCommande = saveCommande;
        vm.generateFacture = generateFacture;
        vm.generateDevis = generateDevis;
        vm.gotoCommandes = gotoCommandes;
       

        //////////
		vm.FinancementInterdit = false; 
		
		vm.FinancementBloque = function(){ 
			vm.FinancementInterdit = false; 
			if(vm.commande.paiements.length > 0 && vm.commande.paiements[0].Type == "Financement"){
				angular.forEach(vm.commande.produits, function(value, key) {
					if(value.FinancementInterdit){
					console.log(value.FinancementInterdit);
						vm.FinancementInterdit = true;
					}
				});
			}
			
			return vm.FinancementInterdit;
		};
		
		
		
		
		vm.DureeEngagementDiff = function(){
			var firstNonZeroValue = null;
			var hasDifferentValues = false; 
			
			angular.forEach(vm.commande.produits, function(value, key) {
				if(value.Renouvellement > 0){
					if (firstNonZeroValue === null)
						firstNonZeroValue = value.Renouvellement;
					else if (firstNonZeroValue != value.Renouvellement){
						
						// console.log(firstNonZeroValue);
						// console.log(value.Renouvellement);
						hasDifferentValues = true;
					}
				}
			});
			return hasDifferentValues;
		};
		
		vm.FinancementRemiseBloque = function(){
			if(vm.commande.paiements.length > 0 && vm.commande.paiements[0].Type == "Financement"){
				/* console.log(	"--" ); 
				console.log(	vm.commande.TotalHT ); 
				console.log(	vm.commande.TotalOriginalHT ); 
				console.log(	vm.commande.TotalHTRemise ); 
				console.log(	vm.commande.TotalOriginalHT <= vm.commande.TotalHTRemise ); 
				console.log(	vm.commande.TotalOriginalHT > vm.commande.TotalHTRemise );  */
				if(vm.commande.TotalOriginalHT > vm.commande.TotalHTRemise)
					return true;
				
			}
			return false;
		};
		
		vm.getDevisSigne = function (ev){
			$window.open("/datas/files/devis_signes/"+vm.commande.IDCommande+"-"+vm.commande.NumeroCommande+".pdf", '_blank');
		}
		
		vm.add_post = function(){
			if(vm.text_add_post){
				var date = new Date();
				var h=date.getHours();
				if (h<10) {h = "0" + h}
				var m=date.getMinutes();
				if (m<10) {m = "0" + m}
				
				/* vm.commande.notes.unshift({"Note":vm.text_add_post, "IDEmploye" : $rootScope.IDEmploye, "Utilisateur":$rootScope.Prenom+' '+$rootScope.Nom, "DateCreation":"Posté à "+h+':'+m});
				$http.post("/datas/commandes/setNote.json", JSON.stringify({"Note":vm.text_add_post, "IDCommande":vm.commande.IDCommande}));
				vm.text_add_post = "";
				$mdToast.show(
				  $mdToast.simple()
					.textContent('Votre commentaire a été ajouté !')
					.position('bottom right' )
					.hideDelay(3000)
				); */
				
				$http.post("/datas/commandes/setNote.json", JSON.stringify({"Note":vm.text_add_post, "IDCommande":vm.commande.IDCommande})).then(function (response, status, headers, config) {
					// vm.contact = response.data.data;
					// console.log(response);
					// vm.loader = 0;
					vm.commande.notes.unshift({"Note":vm.text_add_post, IDNote: response.data.IDNote, "IDEmploye" : $rootScope.id, "Utilisateur":$rootScope.Prenom+' '+$rootScope.Nom, "DateCreation":"Posté à "+h+':'+m});

					vm.text_add_post = "";
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Votre commentaire a été ajouté !')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}, function () {});
				
			}
			else{
				$mdToast.show(
				  $mdToast.simple()
					.textContent("Vous n'avez pas saisie de texte...")
					.position('bottom right' )
					.hideDelay(3000)
				);
			}
		};
		
		vm.edit_post = function(note){
			if(note.Note){
				var date = new Date();
				var h=date.getHours();
				if (h<10) {h = "0" + h}
				var m=date.getMinutes();
				if (m<10) {m = "0" + m}
				
				if(note.Note != note.Temp){
					note.DateModification = "Modifié à "+h+':'+m; 
					
					$http.post("/datas/commandes/setNote.json", JSON.stringify({"Note":note.Note, "IDNote":note.IDNote}));
					vm.text_add_post = "";
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Votre commentaire a été modifié !')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}
				note.Edit = 0; 
			}
			else{
				$mdToast.show(
				  $mdToast.simple()
					.textContent("Vous n'avez pas saisie de texte...")
					.position('bottom right' )
					.hideDelay(3000)
				);
			}
		};
		
		vm.isFormValid = function (formName)
        {
            if ( $scope[formName] && $scope[formName].$valid )
            {
                return $scope[formName].$valid;
            }
        }
		
		vm.changeAdresse = function (){
			$http.post("/datas/contacts/getAdresse.json",JSON.stringify(vm.commande))
			.then(function (response, status, headers, config) {
				vm.adresse = response.data.data;
			}, function () {});			
		}
		
		vm.loadAdresses = function(){
			$http.post("/datas/contacts/getAdresses.json",JSON.stringify(vm.commande))
			.then(function (response, status, headers, config) {
				vm.adresses = response.data.data;
			}, function () {});
			
			vm.loadSites();
		}
		
		vm.loadSites = function(){
			$http.post("/datas/contacts/getSitesContact.json",JSON.stringify(vm.commande))
			.then(function (response, status, headers, config) {
				vm.sites = response.data.data;
			}, function () {});					
		}
		vm.loadSites();

		vm.addwebsite = function(url) {
			$http.post("/datas/contacts/addSite.json",JSON.stringify({'url':url, "IDContact":vm.commande.IDContact}))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$scope.commandeForm.newURL.$setValidity("newURLFailed", false);
					$scope.status = response.data.error.message;
				}
				else{					
					$scope.commandeForm.newURL.$setValidity("newURLFailed", true);
					vm.addsite = 0; vm.newURL = '';
					$mdToast.show(
					  $mdToast.simple()
						.position('bottom right')
						.textContent('Site internet ajouté')
						.hideDelay(3000)
					);
					vm.loadSites();
				}
			}, function () {});
			
		};
  
		vm.changeProduit = function( produit, nouveauproduit, NbrSousProduits){
			console.log(nouveauproduit);
			if(NbrSousProduits == 0){
				if(nouveauproduit == 0){
					produit.IDProduit = 0;
					produit.Personnalise = true;
					produit.Produit = "Produit Personnalisé";
					produit.Renouvellement = 0;
					produit.PrixVenteHT = 0;
					produit.PrixVenteFinalHT = 0;
					// console.log(produit);
					vm.calcTotal();	
				}
				else{		
					produit.IDProduit = nouveauproduit.IDProduit;
					produit.PrixVenteHT = nouveauproduit.PrixVenteHT;
					produit.PrixVenteFinalHT = nouveauproduit.PrixVenteHT;
					produit.PrixVenteHTDefault = nouveauproduit.PrixVenteHT;
					produit.Produit = nouveauproduit.Produit;
					produit.Fabricants = nouveauproduit.Fabricants;
					// produit.PrixAchatHT = nouveauproduit.PrixAchatHT;
					produit.ValeurAchat = nouveauproduit.ValeurAchat;
					produit.ModePrixVente = nouveauproduit.ModePrixVente;
					produit.PourcentageVentePrixHTAutreProduit = nouveauproduit.PourcentageVentePrixHTAutreProduit;
					produit.Reconduction = nouveauproduit.Reconduction;
					produit.PrixSpecifiques = nouveauproduit.PrixSpecifiques;
					produit.Renouvellement = nouveauproduit.Renouvellement;
					produit.RenouvellementDefaut = nouveauproduit.RenouvellementDefaut;
					produit.NoteCommande = nouveauproduit.NoteCommande;
					// produit.IDCategorie = nouveauproduit.IDCategorie;
					produit.Plugin = nouveauproduit.Plugin;
					produit.PrixIncrementeParDuree = nouveauproduit.PrixIncrementeParDuree;
					produit.FinancementInterdit = nouveauproduit.FinancementInterdit;
					
					
					if(produit.Plugin ==  "plg_ref"){
						console.log(produit);
						$mdDialog.show({
							controller         : 'PluginProduitDialogController',
							controllerAs       : 'vm',
							templateUrl        : 'app/main/commandes/commande/dialogs/plugin-dialog.html',
							parent             : angular.element(document.body),
							// targetEvent        : ev,
							clickOutsideToClose: false,
							locals             : {
								Produit : produit,
								Departements : vm.departements,
								Regions : vm.regions,
								Villes : vm.villes
							}
						}).then(function (response)
						{
							if(response!= null){
								Object.assign(produit, response);
								vm.calcTotal();	
							}
						});
					}
					else
						vm.calcTotal();	
				}	
			}	
			else{
				produit.IDProduit = nouveauproduit.IDProduit;
				produit.PrixVenteHT = nouveauproduit.PrixVenteHT;
				produit.PrixVenteFinalHT = nouveauproduit.PrixVenteHT;
				produit.PrixVenteHTDefault = nouveauproduit.PrixVenteHT;
				produit.Produit = nouveauproduit.Produit;
				produit.Fabricants = nouveauproduit.Fabricants;
				// produit.PrixAchatHT = nouveauproduit.PrixAchatHT;
				produit.ValeurAchat = nouveauproduit.ValeurAchat;
				produit.Reconduction = nouveauproduit.Reconduction;
				produit.ModePrixVente = nouveauproduit.ModePrixVente;
				produit.PourcentageVentePrixHTAutreProduit = nouveauproduit.PourcentageVentePrixHTAutreProduit;
				produit.Renouvellement = nouveauproduit.Renouvellement;
				produit.RenouvellementDefaut = nouveauproduit.RenouvellementDefaut;
				produit.PrixSpecifiques = nouveauproduit.PrixSpecifiques;
				produit.NoteCommande = nouveauproduit.NoteCommande;
				// produit.IDCategorie = nouveauproduit.IDCategorie;
				produit.Plugin = nouveauproduit.Plugin;
				produit.PrixIncrementeParDuree = nouveauproduit.PrixIncrementeParDuree;
				produit.FinancementInterdit = nouveauproduit.FinancementInterdit;
				
				$mdDialog.show({
					controller         : 'OptionsCommandeDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commande/dialogs/options-dialog.html',
					parent             : angular.element(document.body),
					// targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						Produit : nouveauproduit
					}
				}).then(function (response)
				{
					if(response!= null){
						angular.forEach(response, function(value, key) {	
							value.PrixVenteFinalHT = value.PrixVenteHT;
							value.PrixAchatHT = 0;
							value.Quantite = 1;
							
							angular.forEach(value.Fabricants, function (v, k) {
								
								if(v.ValeurAchat == "pourcent") 
									if(response.PrixVenteHT)
										v.PrixAchatHTCalc = response.PrixVenteHT * v.PrixAchatHT / 100; 
									else
										v.PrixAchatHTCalc = response.PrixVenteFinalHT * v.PrixAchatHT / 100; 
								else
									v.PrixAchatHTCalc = v.PrixAchatHT;
								
								value.PrixAchatHT += v.PrixAchatHTCalc;
							});
						
						});
						
						// console.log(response);
						// produit.PrixAchatHT = 10;
						// angular.forEach(response.Fabricants, function (value, key) {
							
							// if(value.ValeurAchat == "pourcent") 
								// if(response.PrixVenteHT)
									// value.PrixAchatHTCalc = response.PrixVenteHT * value.PrixAchatHT / 100; 
								// else
									// value.PrixAchatHTCalc = response.PrixVenteFinalHT * value.PrixAchatHT / 100; 
							// else
								// value.PrixAchatHTCalc = value.PrixAchatHT;
							
							// produit.PrixAchatHT += value.PrixAchatHTCalc;
						// });
						
						produit.SousProduits = nouveauproduit.SousProduits;
						produit.SousProduitsSelect = response;
						vm.calcTotal();
					}
				});
			}
		}
		
		
		vm.editPlugin = function( ev, produit ){
			$mdDialog.show({
				controller         : 'PluginProduitDialogController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/commandes/commande/dialogs/plugin-dialog.html',
				parent             : angular.element(document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					Produit : produit,
					Villes : vm.villes,
					Regions : vm.regions,
					Departements : vm.departements
				}
			}).then(function (response)
			{
				if(response!= null){
					Object.assign(produit, response);
					vm.calcTotal();	
				}
			});
			
		}
		
		vm.editProduit = function( produit ){
			// console.log(produit);
			$mdDialog.show({
				controller         : 'OptionsCommandeDialogController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/commandes/commande/dialogs/options-dialog.html',
				parent             : angular.element(document.body),
				// targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
				Produit : produit
			}
			}).then(function (response)
			{
				if(response!= null){
					
					angular.forEach(response, function(value, key) {	
						value.PrixVenteFinalHT = value.PrixVenteHT;
						value.PrixAchatHT = 0;
						value.Quantite = 1;
						// console.log(response);
						angular.forEach(value.Fabricants, function (v, k) {
							
							if(v.ValeurAchat == "pourcent") 
								if(response.PrixVenteHT)
									v.PrixAchatHTCalc = response.PrixVenteHT * v.PrixAchatHT / 100; 
								else
									v.PrixAchatHTCalc = response.PrixVenteFinalHT * v.PrixAchatHT / 100; 
							else
								v.PrixAchatHTCalc = v.PrixAchatHT;
							
							value.PrixAchatHT += v.PrixAchatHTCalc;
						});
						
					});
					
					produit.SousProduitsSelect = response;
					vm.calcTotal();
				}
				
				
						
			});
		}
			  
		vm.toggleSidenav = function (sidenavId)
        {
			if(!$mdMedia('gt-md'))
				$mdSidenav(sidenavId)
				  .toggle()
				  .then(function () {
					
				  });
			else
				vm.sidenavOpen = !vm.sidenavOpen;
            // $mdSidenav(sidenavId).toggle();
        }
		
		
		vm.sidenavOpen = $mdMedia('gt-md');
		// $mdMedia('gt-md');
		// vm.sidenavOpen = !$mdMedia('gt-md');
		
		vm.limiteRemise = function(){
			return ((((1 - vm.commande.TotalHTRemise / vm.commande.TotalOriginalHT)*100) > 10) && !vm.commande.AutoriseRemiseSup);
		}
			
		vm.updatePrice = function(){
			angular.forEach(vm.commande.produits, function(value, key) {	
				// console.log(value);
				if(typeof value.PrixSpecifiques != "undefined" && value.PrixSpecifiques != null  && value.PrixSpecifiques.length>0){
					// value.PrixVenteHT = value.PrixVenteHTDefault;
					// value.PrixVenteFinalHT = value.PrixVenteHTDefault;
					var remiseTrouve = false;
					
					angular.forEach(value.PrixSpecifiques, function(valuePrixSpecifiques, keyPrixSpecifiques) {	
						if(value.Quantite >= valuePrixSpecifiques.Quantite){
							// value.PrixVenteHT = valuePrixSpecifiques.PrixVenteUnitaireHT;
							value.PrixVenteFinalHT = valuePrixSpecifiques.PrixVenteUnitaireHT;
							remiseTrouve = true;
						}
					});
					
					if(!remiseTrouve)
						value.PrixVenteFinalHT = value.PrixVenteHTDefault;
				}
			
				if(typeof value.SousProduitsSelect != "undefined" && value.SousProduitsSelect.length >0 )
					angular.forEach(value.SousProduitsSelect, function(valueSousProduitsSelect, keySousProduitsSelect) {	
						if(valueSousProduitsSelect.ModePrixVente == "pourcent" && valueSousProduitsSelect.PourcentageIDProduit == value.IDProduit){
							var modifManuelle = false;
							
							if(valueSousProduitsSelect.PrixVenteFinalHT != valueSousProduitsSelect.PrixVenteHT)
								modifManuelle = true;
							
							valueSousProduitsSelect.PrixVenteHT = Math.round(value.PrixVenteFinalHT * (valueSousProduitsSelect.PourcentageVentePrixHTAutreProduit / 100)*100)/100;
							if(valueSousProduitsSelect.PrixVenteHT < valueSousProduitsSelect.PrixVenteHTDefault){
								valueSousProduitsSelect.PrixVenteHT = valueSousProduitsSelect.PrixVenteHTDefault;
							}
							
							if(!modifManuelle)
								valueSousProduitsSelect.PrixVenteFinalHT = valueSousProduitsSelect.PrixVenteHT;
							
						}
					});
			});
		}
		
		vm.updateRenouvellement = function(produit, valeurPrecedenteSelect){
			if(typeof produit.PrixIncrementeParDuree != "undefined" && produit.PrixIncrementeParDuree ){
				produit.PrixVenteHTDefault = produit.PrixVenteHTDefault /valeurPrecedenteSelect * produit.Renouvellement;
				produit.PrixVenteFinalHT = produit.PrixVenteFinalHT /valeurPrecedenteSelect * produit.Renouvellement;
				produit.PrixVenteHT = produit.PrixVenteHT /valeurPrecedenteSelect * produit.Renouvellement;
				
				produit.Parametres.total.price.veryhard = produit.Parametres.total.price.veryhard /valeurPrecedenteSelect * produit.Renouvellement;
				produit.Parametres.total.price.challenging = produit.Parametres.total.price.challenging /valeurPrecedenteSelect * produit.Renouvellement;
				produit.Parametres.total.price.departements = produit.Parametres.total.price.departements /valeurPrecedenteSelect * produit.Renouvellement;
				produit.Parametres.total.price.regions = produit.Parametres.total.price.regions /valeurPrecedenteSelect * produit.Renouvellement;
				produit.Parametres.total.price.hard = produit.Parametres.total.price.hard /valeurPrecedenteSelect * produit.Renouvellement;
				produit.Parametres.total.price.medium = produit.Parametres.total.price.medium /valeurPrecedenteSelect * produit.Renouvellement;
				produit.Parametres.total.price.easy = produit.Parametres.total.price.easy /valeurPrecedenteSelect * produit.Renouvellement;
								
				produit.PrixAchatHT = 0;
			
				angular.forEach(produit.Fabricants, function (v, k) {
					if(v.Fabricant=="Google") {
						v.PrixAchatHT = v.PrixAchatHTCalc = Math.round(produit.Parametres.total.price.easy / 2 * 100) /100;	
					}
					produit.PrixAchatHT += v.PrixAchatHTCalc;
				});
				
				vm.calcTotal();
				
			}
		}
		
		
		vm.calcTotal = function(){
			vm.updatePrice();
			
			vm.commande.TotalHT =0;
			vm.commande.TotalOriginalHT =0;
			vm.commande.TotalChargesHT =0;
			// console.log(vm.commande.produits);
			angular.forEach(vm.commande.produits, function(value, key) {	
			
			// console.log(value);
				if(value.PrixVenteHT == 0)
					vm.commande.TotalOriginalHT =  parseFloat(vm.commande.TotalOriginalHT) + (parseFloat(value.PrixVenteFinalHT)*value.Quantite);
				else
					vm.commande.TotalOriginalHT =  parseFloat(vm.commande.TotalOriginalHT) + (parseFloat(value.PrixVenteHT)*value.Quantite);
				
				vm.commande.TotalHT =  parseFloat(vm.commande.TotalHT) + (parseFloat(value.PrixVenteFinalHT)*value.Quantite);	
				
			/* 	// angular.forEach(response, function(value, key) {	
					value.PrixVenteFinalHT = value.PrixVenteHT;
					value.PrixAchatHT = 0;*/
					
					angular.forEach(value.Fabricants, function (v, k) {
						
						if(v.ValeurAchat == "pourcent") 
							if(value.PrixVenteHT)
								v.PrixAchatHTCalc = value.PrixVenteHT * v.PrixAchatHT / 100 *value.Quantite; 
							else
								v.PrixAchatHTCalc = value.PrixVenteFinalHT * v.PrixAchatHT / 100 *value.Quantite; 
						else
							v.PrixAchatHTCalc = v.PrixAchatHT *value.Quantite;
						
						vm.commande.TotalChargesHT += v.PrixAchatHTCalc;
					});
				
				 // });
				
				
				if(typeof value.SousProduitsSelect != "undefined" && value.SousProduitsSelect.length >0 )
					angular.forEach(value.SousProduitsSelect, function(valueSousProduitsSelect, keySousProduitsSelect) {	
						// console.log(valueSousProduitsSelect);
						if(valueSousProduitsSelect.PrixVenteHT == 0)
							vm.commande.TotalOriginalHT =  parseFloat(vm.commande.TotalOriginalHT) + (parseFloat(valueSousProduitsSelect.PrixVenteFinalHT)*valueSousProduitsSelect.Quantite);
						else
							vm.commande.TotalOriginalHT =  parseFloat(vm.commande.TotalOriginalHT) + (parseFloat(valueSousProduitsSelect.PrixVenteHT)*valueSousProduitsSelect.Quantite);
						
						vm.commande.TotalHT =  parseFloat(vm.commande.TotalHT) + (parseFloat(valueSousProduitsSelect.PrixVenteFinalHT)*valueSousProduitsSelect.Quantite);	
						
						angular.forEach(valueSousProduitsSelect.Fabricants, function (v, k) {
							
							if(v.ValeurAchat == "pourcent") 
								if(valueSousProduitsSelect.PrixVenteHT)
									v.PrixAchatHTCalc = valueSousProduitsSelect.PrixVenteHT * v.PrixAchatHT / 100 *valueSousProduitsSelect.Quantite; 
								else
									v.PrixAchatHTCalc = valueSousProduitsSelect.PrixVenteFinalHT * v.PrixAchatHT / 100 *valueSousProduitsSelect.Quantite; 
							else
								v.PrixAchatHTCalc = v.PrixAchatHT *valueSousProduitsSelect.Quantite;
							
							vm.commande.TotalChargesHT += v.PrixAchatHTCalc;
						});
					});
			});
			
			if(vm.commande.RemiseActive)
				if(vm.commande.RemiseEuroPourcent == "€")
					vm.commande.TotalHTRemise = vm.commande.TotalHT - vm.commande.Remise;
				else
					vm.commande.TotalHTRemise = vm.commande.TotalHT - (vm.commande.TotalHT * vm.commande.Remise / 100);
			else
				vm.commande.TotalHTRemise = vm.commande.TotalHT;
			
			vm.commande.MargeBrutHT = vm.commande.TotalHTRemise - vm.commande.TotalChargesHT;
			
			vm.commande.TotalTTC = Math.round(vm.commande.TotalHTRemise *1.2*100)/100;
		}
		
		vm.calcPaiement = function(){
			vm.TotalPaiement = 0;
			
			if(vm.commande.paiements.length == 1){
				if(vm.commande.paiements[0].Type == "Solde"){
					vm.commande.paiements[0].Percent = 100;
					vm.commande.paiements[0].Montant = vm.commande.TotalTTC;
					// console.log(vm.commande.paiements[0]);
				}
			}
			
			angular.forEach(vm.commande.paiements, function(value, key) {		
				vm.TotalPaiement =  vm.TotalPaiement + (parseFloat(value.Montant));
			});
			vm.TotalPaiement = Math.round(vm.TotalPaiement*100)/100;
		}
		
		vm.go = function (url)
        {
			$location.path(url);
        }
		
		vm.editIBAN = function (ev)
        {
			$mdDialog.show({
                controller         : 'DialogIbanController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/commande/dialogs/iban-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
				clickOutsideToClose: false,
                locals             : {
                    Commande : vm.commande,					
                }
            }).then(function (response)
            {
				if(response!= null){
				
					vm.commande = response;
				} 
			});
        }
		
		jQuery(document).on('click', '.listcollapse', function(){
			jQuery(this).parent().find('.toggleshow').toggle("fast");
		});
		
		vm.addPaiement = function (ev, paiement)
        {
			$mdDialog.show({
                controller         : 'PaiementCommandeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/commande/dialogs/paiement-dialog.html',
                parent             : angular.element(document.body),
                targetEvent        : ev,
				clickOutsideToClose: false,
                locals             : {
                    Paiement : paiement,
                    Commande : vm.commande,					
                }
            }).then(function (response)
            {
				// console.log(response);
				if(response!= null){
					
					if(response.Type == "Financement")
						vm.commande.paiements = [];
					
					
					if(typeof paiement == "undefined" || vm.commande.paiements.length == 0)
						vm.commande.paiements.push(response);
					else
						vm.commande.paiements[vm.commande.paiements.indexOf(paiement)] = response;
					
					
					// console.log(paiement);
					// console.log(response);
					// console.log(vm.commande.paiements);
					vm.calcPaiement();
				}
			});
        }
		
		vm.addProduit = function (ev)
        {
			$mdDialog.show({
				controller         : 'ProduitsCommandeDialogController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/commandes/commande/dialogs/produits-dialog.html',
				parent             : angular.element(document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				fullscreen  : true,
				
				locals             : {
				Produits : vm.produits
			}
			}).then(function (response)
			{
				// console.log(response);
				if(response!= null){
					var PrixAchatHT = 0;
					angular.forEach(response.Fabricants, function (value, key) {
						
						if(value.ValeurAchat == "pourcent") 
							if(response.PrixVenteHT)
								value.PrixAchatHTCalc = response.PrixVenteHT * value.PrixAchatHT / 100; 
							else
								value.PrixAchatHTCalc = response.PrixVenteFinalHT * value.PrixAchatHT / 100; 
						else
							value.PrixAchatHTCalc = value.PrixAchatHT;
						
						PrixAchatHT += value.PrixAchatHTCalc;
					});
				
					vm.commande.produits.push({"IDProduit":'', "Quantite":1, 'PrixVenteHT':0, 'PrixVenteFinalHT' : 0, 'PrixAchatHT' : PrixAchatHT, 'Fabricants': response.Fabricants});
					
					if(typeof response.NbrSousProduits != "undefined")
						vm.changeProduit(vm.commande.produits[vm.commande.produits.length - 1], response, response.NbrSousProduits);
					else
						vm.changeProduit(vm.commande.produits[vm.commande.produits.length - 1], response, 0);
					
				}
			});
			
			// 
        }
		
		vm.removeProduit = function (produit)
        {
			vm.commande.produits.splice(vm.commande.produits.indexOf(produit), 1);
			vm.calcTotal();
        }
		
		vm.removePaiement = function (paiement)
        {
			vm.commande.paiements.splice(vm.commande.paiements.indexOf(paiement), 1);
			vm.calcPaiement();
        }
		
		vm.dupliquerPaiement = function (paiement)
        {
			/* var date = new Date(paiement.DatePaiement);
			var dateTime = date.getTime();
			// 60 secondes * 60 minutes * 24 heures
			// On multiplie par 1000 car le time est exprimé en millisecondes
			var endTime = t + (60*60*24) * 1000
			 
			var endDate = new Date(endTime);
 */
			var d = new Date(paiement.DatePaiement);
			d.setMonth(d.getMonth() + 1);

			vm.commande.paiements.push({
				"DateMode": paiement.DateMode,
				"DatePaiement": d,
				"Montant": paiement.Montant,
				"Percent": paiement.Percent,
				"Etape": paiement.Etape,
				"Mode": paiement.Mode,
				"Type": paiement.Type
			});
			vm.calcPaiement();
        }
		
		vm.changeContact = function(ev){
			var confirm = $mdDialog.confirm()
			  .title('Êtes-vous sûr de vouloir changer de client ?')
			  .textContent('Si vous continuez, vous devrez recommencer la commande.')
			  .targetEvent(ev)
			  .ok('Continuer')
			  .cancel('Annuler');

			$mdDialog.show(confirm).then(function() {
				vm.commande = {'TotalTTC' :0,'TotalOriginalHT':0,'TotalHT':0, "paiements":[], "affichageRemiseProduits" : "Affichée", "resetContact" : 1, "produits":[]};
			}, function() {
			});
		}
		
        /**
         * Save edition
         */
        function saveCommande(ev)
        {
			vm.showSpinner = 1;
			
			if( vm.commande.Etat == "Signée" || vm.commande.Etat == "Validée"){
				if(vm.commande.paiements.length>0){
					var prelevement = 0;
					angular.forEach(vm.commande.paiements, function (value, key) {
						if(value.Mode == "Prélèvement")
							prelevement = 1;
					});
					
					if(prelevement ==1 && (typeof vm.commande.IBAN == "undefined" || vm.commande.IBAN == "" )){
						$mdDialog.show(
						  $mdDialog.alert()
							.parent(angular.element(document.querySelector('body')))
							.clickOutsideToClose(true)
							.parent(angular.element(document.body))
							.title('Modification impossible')
							.textContent("L'IBAN est obligatoire pour valider une commande par prélévement")
							.ariaLabel('Modification impossible')
							.ok('OK')
							.targetEvent(ev)
						);
						
						vm.commande.Etat ="En attente";
						vm.showSpinner = 0;
						return false;
					}
				}
			}
			
			if( vm.commande.Etat == "Signée"){
			
				$mdDialog.show({
				  controller: 'DialogSignatureController',
				controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commande/dialogs/signature-dialog.html',
				  parent: angular.element(document.body),
				  targetEvent: ev,
				  clickOutsideToClose:true,
					locals             : {
						Commande : vm.commande
					}
				})
				.then(function(result) {
					/* if(typeof result != "undefined"){
						var d = new Date(result),
						month = '' + (d.getMonth() + 1),
						day = '' + d.getDate(),
						year = d.getFullYear();

						if (month.length < 2) month = '0' + month;
						if (day.length < 2) day = '0' + day;
						
						vm.commande.DateRenouvellement = [year, month, day].join('-');
					}
					 */
					writeCommande().then(function (result) {
						if(IDContact){
							$location.path('/contacts/profil/'+IDContact);
						}
						else
							$state.go ('app.commandes');
					})
					.catch(function (error) {
						// console.error("Erreur dans someOtherFunction :", error);
					})
					.finally(function () {
						vm.showSpinner = 0;
					});
				}, function() {
					vm.commande.Etat ="En attente";
					vm.showSpinner = 0;
				});
				
			
			}
			else if( vm.commande.Etat == "Validée"){
			
				$mdDialog.show({
				  controller: 'DialogValideController',
				controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commande/dialogs/valide-dialog.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose:true,
					locals             : {
						Commande : vm.commande
					}
				})
				.then(function(response) {
					if(typeof response != "undefined"){
						vm.commande = response;
						writeCommande().then(function (result) {
							vm.showSpinner = 0;
						})
						.catch(function (error) {
							// console.error("Erreur dans someOtherFunction :", error);
						})
						.finally(function () {
							vm.showSpinner = 0;
						});
					}
					
				}, function() {
					vm.commande.Etat ="En attente";
					vm.showSpinner = 0;
				});
				
			
			}else{
				writeCommande().then(function (result) {
				
					/*$mdToast.show(
					  $mdToast.simple()
						.textContent('La commande a été modifiée !')
						.position('bottom right' )
						.hideDelay(3000)
					);*/
					vm.showSpinner = 0;
				
				})
				.catch(function (error) {
					// console.error("Erreur dans someOtherFunction :", error);
				})
				.finally(function () {
					vm.showSpinner = 0;
				});
			}
        }
		
		
        function generateDevis(ev)
        {
			if(vm.commande.Etat == "Brouillon")
				vm.commande.Etat = "En attente";

			writeCommande().then(function (result) {
				if(vm.commande.paiements.length>0){
					var prelevement = 0;
					angular.forEach(vm.commande.paiements, function (value, key) {
						if(value.Mode == "Prélèvement")
							prelevement = 1;
					});
				}
					// console.log(prelevement);
				if(prelevement ==1 && (typeof vm.commande.IBAN == "undefined" || vm.commande.IBAN == "" )){
				
					var confirm = $mdDialog.confirm()
						  .title('Attention, IBAN du contact manquant !')
						  .textContent("L'IBAN sera obligatoire pour valider une commande par prélévement")
						  .ariaLabel('IBAN manquant')
						  .targetEvent(ev)
						  .clickOutsideToClose(true)
						  .parent(angular.element(document.body))
						  .ok('Continuer')
						  .cancel('Annuler');
						  
					$mdDialog.show(confirm).then(function() {
						$mdDialog.show({
							  controller: DialogDevisController,
								templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
							  parent: angular.element(document.body),
							  targetEvent: ev,
							  clickOutsideToClose:true
							})
							.then(function(result) {
								var lien = "/datas/commandes/devis.json?IDCommande="+vm.commande.IDCommande;
								
								if(result.indexOf("Conditions Générales de Ventes")>=0)
									lien +="&cgv=1";
								else
									lien +="&cgv=0";
								if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
									lien +="&retractation=1";
								else
									lien +="&retractation=0";
								
								$window.open(lien, '_blank');
							}, function() {
						});
					}, function() {}); 
				}
				
				else{
			
					$mdDialog.show({
						  controller: DialogDevisController,
							templateUrl        : 'app/main/commandes/commande/dialogs/devis-dialog.html',
						  parent: angular.element(document.body),
						  targetEvent: ev,
						  clickOutsideToClose:true
						})
						.then(function(result) {
							var lien = "/datas/commandes/devis.json?IDCommande="+vm.commande.IDCommande;
							
							if(result.indexOf("Conditions Générales de Ventes")>=0)
								lien +="&cgv=1";
							else
								lien +="&cgv=0";
							if(result.indexOf("Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>")>=0)
								lien +="&retractation=1";
							else
								lien +="&retractation=0";
							
							$window.open(lien, '_blank');
						}, function() {
					});
						
				}
			})
			.catch(function (error) {
				// console.error("Erreur dans someOtherFunction :", error);
			})
			.finally(function () {
				vm.showSpinner = 0;
			});
        }
		
        function generateFacture(ev)
        {
			// vm.showSpinner = 0;
			var acompte = 0;
			/*  $http.post("/datas/commandes/setCommande.json",JSON.stringify(vm.commande))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 1;
				}
				else{ */
					if(!vm.commande.IDCommande)
						$mdToast.show(
						  $mdToast.simple()
							.textContent('La commande a été ajoutée !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					else
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Le commande a été modifiée !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					
					// vm.commande = response.data.data;
					vm.calcPaiement();
					// vm.showSpinner = 0;

					if(vm.commande.paiements.length>1)
						angular.forEach(vm.commande.paiements, function (value, key) {
							// if(value.Mode != "Prélèvement" && value.Mode != "Virement automatique")
							if(value.Type == "Acompte")
								acompte = 1;
						});
					
					if(acompte == 1){
						$mdDialog.show({
							parent             : angular.element(document.body),
							targetEvent        : ev,
							controller         : 'DialogFactureAcompteController',
							controllerAs       : 'vm',
							templateUrl        : 'app/main/commandes/commandes/dialogs/acompte-dialog.html',
							clickOutsideToClose: true,
							locals             : {
								Paiements : vm.commande.paiements,
								Commande : vm.commande,
								dtInstance : ""
							}
						}); 
					}
					else{			
						var produit_a_renouveler = [];
						
						angular.forEach(vm.commande.produits, function (value, key) {
							if(value.Renouvellement > 0 ){
								produit_a_renouveler.push({'Produit':value.Produit,'Renouvellement':value.Renouvellement});
							}
							angular.forEach(value.SousProduitsSelect, function (v, k) {
								if(v.Renouvellement > 0 ){
									produit_a_renouveler.push({'Produit':v.Produit,'Renouvellement':v.Renouvellement});
								}
							});
						});
						
						
						// console.log(produit_a_renouveler);
						
						if(produit_a_renouveler.length > 0 && vm.commande.TotalTTC>0){
						
							$mdDialog.show({
							  controller: 'DialogFactureController',
								templateUrl        : 'app/main/commandes/commande/dialogs/facture-dialog.html',
							  parent: angular.element(document.body),
							  targetEvent: ev,
							  clickOutsideToClose:true,
								locals             : {
									Renouvellement : vm.commande.DateRenouvellement,
									produit_a_renouveler : produit_a_renouveler
								}
							})
							.then(function(result) {
								if(typeof result != "undefined"){
									var d = new Date(result),
									month = '' + (d.getMonth() + 1),
									day = '' + d.getDate(),
									year = d.getFullYear();

									if (month.length < 2) month = '0' + month;
									if (day.length < 2) day = '0' + day;
									
									vm.commande.DateRenouvellement = [year, month, day].join('-');
								}
								// writeCommande();
								$mdToast.show(
								  $mdToast.simple()
									.textContent('La commande a été facturée !')
									.position('bottom right' )
									.hideDelay(3000)
								);
								// console.log('teest');
								$window.open("/datas/commandes/facture.json?IDCommande="+vm.commande.IDCommande+'&DateRenouvellement='+vm.commande.DateRenouvellement, '_blank');
								if(IDContact){
									$location.path('/contacts/profil/'+IDContact);
								}
								else
									$state.go('app.commandes');
							}, function() {
							});
						}
						else{
							if(vm.commande.TotalTTC<0)
								var confirm = $mdDialog.confirm()
								  .title(' Souhaitez-vous faire un avoir ? ')
								  .textContent("Une fois l'avoir généré, cette commande ne pourra plus être modifiée.")
								  .ariaLabel("Générer l'avoir")
								  .targetEvent(ev)
									.theme('md-warn')
								  .ok("Générer l'avoir")
								  .cancel('Annuler');
							else
								var confirm = $mdDialog.confirm()
								  .title(' Souhaitez-vous facturer cette commande ? ')
								  .textContent('Une fois facturée, cette commande ne pourra plus être modifiée. ')
								  .ariaLabel('Facturer la commande')
								  .targetEvent(ev)
									.theme('md-warn')
								  .ok('Générer la facture')
								  .cancel('Annuler');

							$mdDialog.show(confirm).then(function () {
								  
								$mdToast.show(
								  $mdToast.simple()
									.textContent('La commande a été facturée !')
									.position('bottom right' )
									.hideDelay(3000)
								);
								$window.open("/datas/commandes/facture.json?IDCommande="+vm.commande.IDCommande+'&DateRenouvellement='+vm.commande.DateRenouvellement, '_blank');
								if(IDContact){
									$location.path('/contacts/profil/'+IDContact);
								}
								else
									$state.go('app.commandes');
							}, function () {
							});
							
						}
								
					}
					
					// vm.showSpinner = 0;
					
				// }
			// }, function () {});	
		}
		
		vm.showLogs = function(ev, Commande){
			$mdDialog.show({
                parent             : angular.element(document.body),
                targetEvent        : ev,
                controller         : 'DialogLogsCommandeController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/commande/dialogs/logs-dialog.html',
                clickOutsideToClose: true,
                locals             : {
					Commande : Commande
                }
            });
		}
		
		vm.editOptions = function(ev, IDCommande, Commande){
			$mdDialog.show({
                parent             : angular.element(document.body),
                targetEvent        : ev,
                controller         : 'DialogOptionsCommandeController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/commandes/dialogs/options-commande-dialog.html',
                clickOutsideToClose: true,
                locals             : {
                    IDCommande : IDCommande,
					Commande : Commande
                }
            }).then(function(result) {
				vm.commande = result.data;
				vm.calcPaiement();
			}, function () {});
		}
		
		function writeCommande(){
			// console.log(vm.commande);
			vm.showSpinner = 1;
			return  $http.post("/datas/commandes/setCommande.json",JSON.stringify(vm.commande))
			.then(function (response, status, headers, config) {
				if(response.data.error){
					$mdDialog.show(
					  $mdDialog.alert()
						.clickOutsideToClose(false)
						.title("Une erreur s'est produite")
						.textContent(response.data.error.message)
						.ok('OK')
					);
					vm.showSpinner = 0;
					return Promise.reject(response.data.error);
				}
				else{
					if(!vm.commande.IDCommande)
						$mdToast.show(
						  $mdToast.simple()
							.textContent('La commande a été ajoutée !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					else
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Le commande a été modifiée !')
							.position('bottom right' )
							.hideDelay(3000)
						);
					if(vm.commande.etat == "Facturée" || vm.commande.etat == "Signée")						
						if(IDContact){
							$location.path('/contacts/profil/'+IDContact);
						}
						else
							$state.go('app.commandes');
					
					vm.commande = response.data.data;
					vm.calcPaiement();
					vm.showSpinner = 0;
					return response.data.data;
				}
			}, function () {});	
		}

        /**
         * Go to editions page
         */
        function gotoCommandes()
        {
			
			if(IDContact){
				$location.path('/contacts/profil/'+IDContact);
			}
			else
				$state.go('app.commandes');
        }


       
		
		vm.updateTTC = function (){
			angular.forEach(vm.TVA, function (value, key) {
				if(value.IDTVA == vm.edition.IDTVA )
					vm.edition.PrixVenteTTC = Math.round(vm.edition.PrixVenteHT * (value.Value / 100 + 1)*100)/100;

			});
		}
		
		
    }
	
	  
	function DialogDevisController($scope, $mdDialog) {
		$scope.hide = function() {
		  $mdDialog.hide();
		};

		$scope.items = ["Conditions Générales de Ventes", "Droit de rétractation <small>(pour les particuliers ou entreprises de moins de 5 salariés)</small>", "Cahier des charges fonctionnel"];
		$scope.selected = ["Conditions Générales de Ventes"];

		$scope.toggle = function (item, list) {
		var idx = list.indexOf(item);
		if (idx > -1) {
		  list.splice(idx, 1);
		}
		else {
		  list.push(item);
		}
		};

		$scope.exists = function (item, list) {
		return list.indexOf(item) > -1;
		};
	  
		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		$scope.answer = function(result) {
		  $mdDialog.hide(result);
		};
	  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes.cdc')
        .controller('cdcController', cdcController);
		 
    /** @ngInject */
    function cdcController($mdDialog, $http, $mdToast, $window, $rootScope, DTOptionsBuilder, DTColumnBuilder, $compile, $scope, $location  )
    {
        var vm = this;


		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		vm.recordsTotal = 0;
		vm.search = localStorage.getItem('cdcSearch');
		
			
		function convertDate(inputFormat, hour, day) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
	
	/* 
		$scope.selected = [];
		
		$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
		};
		
		$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
		};
		
		$scope.isIndeterminate = function() {
			return ($scope.selected.length !== 0 &&
				$scope.selected.length !== $('.dataTable md-checkbox').length - 1);
		};
		
		$scope.isChecked = function() {
			return $scope.selected.length === $('.dataTable md-checkbox').length - 1;
		};
		
		$scope.toggleAll = function() {
			if ($scope.selected.length === $('.dataTable md-checkbox').length - 1) {
				$scope.selected = [];
			} else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
				$scope.selected = [];
				$('.dataTable md-checkbox').each(function(k, v){
					if(typeof $(v).attr('data-val') != "undefined")
						$scope.selected.push(parseInt($(v).attr('data-val')));
				});
			}
		}; */
/* 
	
		vm.exportConges = function (ev, type)
        {
			$window.open("/datas/employes/exportConges.json?type="+type+'&selected='+$scope.selected, '_blank');
        } */
		
		vm.editEmailTrack = function (ev, IDBloc){
			$http.get("/datas/commandes/getCDCBloc.json?IDBloc="+IDBloc)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					controller         : 'cdcDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/cdc/dialogs/cdc-dialog.html',
					parent             : angular.element(document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						// Conge : "",
						Bloc : response.data.data
					}
				}).then(function (response)
				{
					if(typeof response != "undefined"){
						vm.dtInstance.reloadData();
						
						if(response.data.error){
						}
						else
						if(typeof IDBloc!="undefined")
							$mdToast.show(
							  $mdToast.simple()
								.textContent("Votre bloc a été modifié !")
								.position('bottom right' )
								.hideDelay(3000)
							);
						else
						$mdToast.show(
						  $mdToast.simple()
							.textContent("Votre bloc a été créé !")
							.position('bottom right' )
							.hideDelay(3000)
						);
					} 
				});
			}, function () {});
		}
		
		
		vm.deleteTracking = function (ev, IDBloc, Bloc)
        {
		 	var trackingObj = {IDBloc:IDBloc};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer ce bloc ?')
                .htmlContent('Le bloc <b>' + Bloc + '</b>' + ' va être supprimé.')
                .ariaLabel('Supprimer le bloc')
                .targetEvent(ev)
                .theme('md-warn')
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/commandes/deleteCDCBloc.json", JSON.stringify(trackingObj)).then(function (response, status, headers, config) {  
					vm.dtInstance.reloadData();
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Le bloc a été supprimé.')
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.dtInstance.reloadData();
				}, function () {});
				
            }, function () {});
        }
		
		vm.filterSave = [];
        vm.dtInstance = {};
    		
		 vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'datas',
				 url: 'datas/commandes/getCDCBlocs.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'dataTableCdc', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
				  $('.scrollable').animate({
					scrollTop: 0
				  }, 'slow');
			})
			.withOption('stateLoadCallback', function (oSettings) {
				var columnLoad = JSON.parse( localStorage.getItem('dataTableCdc') );
				// if( columnLoad != null && columnLoad.columns[3].search.search == "")
					// columnLoad.columns[3].search.search = 1;
				return columnLoad;
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('aoSearchCols',   [
			  null,
			  null,
			  null,
			  null,
			])
			.withOption('columnDefs',  [
				   
				{
                    targets           : 4,
                    responsivePriority: 0,
                }
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
					var api = this.api();
						// vm.searchBox = angular.element('body').find('#colabconges-search');

					angular.forEach(vm.filterSave, function(value, key) {
						var cpt = key+1;
						if(typeof value.search.search == "string" && value.search.search.includes("~")){
							jQuery('.dataTableCdc tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
							jQuery('.dataTableCdc tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
							
						} else{
							jQuery('.dataTableCdc tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
							jQuery('.dataTableCdc tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
						}
					}); 
				
					if ( vm.searchBox.length > 0 )
					{
						var timeout = null;
						vm.searchBox.on('keyup', function (event)
						{
							clearTimeout(timeout);
							timeout = setTimeout(function () {
								api.search(vm.search).draw();
							}, 500);
						});
					}
					
					vm.recordsTotal = json.recordsTotal;
				}
			)
			.withLightColumnFilter({
				/*   "1": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "2": {
					"html": "select",
					"values": [{'value':"", 'label':"--"}].concat(employesSimple.data),
					// "location": $location,
					"regex":true
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '', label: '--'},  
						{value: 'Congés payés', label: 'Congés payés'}, 
						{value: 'Congés sans solde', label: 'Congés sans solde'}, 
						{value: 'Maladie ou à l’accident non professionnel', label: 'Maladie ou à l’accident non professionnel'}, 
						{value: 'Accident ou maladie professionnelle', label: 'Accident ou maladie professionnelle'}, 
						{value: 'Compte Epargne Temps', label: 'Compte Epargne Temps'}, 
						{value: "Congés d'ancienneté", label: "Congés d'ancienneté"}, 
						{value: "Congés d'adoption", label: "Congés d'adoption"}, 
						{value: "Congés de proche aidant", label: "Congés de proche aidant"}, 
						{value: "Congés de solidarité familiale", label: "Congés de solidarité familiale"}, 
						{value: "Congés liées à la maternité ou à l’adoption", label: "Congés à la maternité ou à l'adoption"}, 
						{value: "Congés maternité", label: "Congés maternité"}, 
						{value: "Congés parental d'éducation", label: "Congés parental d'éducation"}, 
						{value: "Congés paternité", label: "Congés paternité"}, 
						{value: "Congés pour enfant malade", label: "Congés pour enfant malade"}, 
						{value: "Congés pour évènements familiaux", label: "Congés pour évènements familiaux"}, 
						{value: "Congés sabbatiques", label: "Congés sabbatiques"}, 
						// {value: "Déplacement", label: "Déplacement"}, 
						// {value: "Formation", label: "Formation"}, 
						// {value: "Jours de fractionnement", label: "Jours de fractionnement"}, 
						{value: "Récupération", label: "Récupération"}, 
						{value: "Repos compensateur", label: "Repos compensateur"}, 
					],
					"location": $location,
				  "regex":true},
				
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "5": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "6": {
					"html": "range",
					"type": "number",
					"location": $location
				  },
				  "7": {
					"html": "input",
					"type": "text",
					// "location": $location
				  },
				  "8": {
					"html": "select",
					"values": [
						{value: '', label: '--'}, 
						{value: 'A valider', label: 'A renouveler'}, 
						{value: 'Validés', label: 'Renouvelée'}, 
						{value: 'Refusés', label: 'Non renouvelée'}, 
					],
					"location": $location,
				  "regex":true},
				  "9": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "10": {
					"html": "clear"
				  }
				   */
				  
			  })
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('order', [1, 'desc']);
		

		vm.dtColumns = [
		
			DTColumnBuilder.newColumn('Titre').withTitle('<div class="table-header"><span class="column-title">Titre</div></div>'),
			DTColumnBuilder.newColumn('NbrChar').withTitle('<div class="table-header"><span class="column-title">Nbr de caractère</div></div>').withOption('width', '100px'),
		
			DTColumnBuilder.newColumn('DateModification').withTitle('<div class="table-header"><span class="column-title">Dernière modification</div></div>').withOption('width', '150px').renderWith(function(data, type, full){
				return convertDate(data, 1)
			}),
			,
			DTColumnBuilder.newColumn('Actif').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '150px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
					if(!data)
						html = '<span class="p-5 pr-8 pl-8 brad-16  md-red-bg white-fg" selected="true" style="text-transform:capitalize "><small>Désactivé</small></span>'; 
					else
						html = '<span class="p-5 pr-8 pl-8 brad-16  md-green-bg white-fg" selected="true" style="text-transform:capitalize "><small>Activé</small></span> '; 
					
					   return html;
				}
				return data;
			}),
			DTColumnBuilder.newColumn(null).withTitle('').notSortable().withOption('width', '50px').renderWith(function(data, type, full){
				return '<md-menu style="float: right;">'+
				'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
						'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
					'</md-button>'+
					'<md-menu-content width="3">'+
				
						'<md-menu-item> '+
							"<md-button ng-click='vm.editEmailTrack($event, \""+full.IDBloc+"\")' > "+
								'Modifier '+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-menu-item> '+
							"<md-button ng-click='vm.deleteTracking($event, \""+full.IDBloc+"\",\""+full.Email+"\")' >"+
								'Supprimer '+
							'</md-button>'+
						'</md-menu-item>'+
						
					'</md-menu-content>'+
				'</md-menu>';
					
			}),
			
		];
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.documents')
        .controller('documentsController', documentsController);

    /** @ngInject */
    function documentsController(employesSimple, $mdDialog, $http, $mdToast, $window, $rootScope, DTOptionsBuilder, DTColumnBuilder, $compile, $scope, $location  )
    {
        var vm = this;
		

		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		vm.recordsTotal = 0;
		vm.search = localStorage.getItem('colabdocsSearch');
		
		function convertDate(inputFormat, hour) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
		
	
		$scope.selected = [];
		
		$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
		};
		
		$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
		};
		
		$scope.isIndeterminate = function() {
			return ($scope.selected.length !== 0 &&
				$scope.selected.length !== $('.dataTable md-checkbox').length - 1);
		};
		
		$scope.isChecked = function() {
			return $scope.selected.length === $('.dataTable md-checkbox').length - 1;
		};
		
		$scope.toggleAll = function() {
			if ($scope.selected.length === $('.dataTable md-checkbox').length - 1) {
				$scope.selected = [];
			} else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
				$scope.selected = [];
				$('.dataTable md-checkbox').each(function(k, v){
					if(typeof $(v).attr('data-val') != "undefined")
						$scope.selected.push(parseInt($(v).attr('data-val')));
				});
			}
		};

	
		vm.exportDocuments = function (ev, type)
        {
			$window.open("/datas/employes/exportDocuments.json?type="+type+'&selected='+$scope.selected, '_blank');
        }
		
		vm.editDocument = function (ev, IDEmployes_Document){
			
			
		$http.get("/datas/employes/getDocument.json?IDEmployes_Document="+IDEmployes_Document)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					controller         : 'DocumentDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/collaborateurs/documents/dialogs/document-dialog.html',
					parent             : angular.element(document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						Document : response.data.data,
						employesSimple : employesSimple
					}
				}).then(function (response)
				{
					if(typeof response != "undefined"){
						vm.dtInstance.reloadData();
						if(typeof IDEmployes_Document!="undefined")
							$mdToast.show(
							  $mdToast.simple()
								.textContent("Le document a été modifié !")
								.position('bottom right' )
								.hideDelay(3000)
							);
						else
						$mdToast.show(
						  $mdToast.simple()
							.textContent("Le document a été créé !")
							.position('bottom right' )
							.hideDelay(3000)
						);
					} 
				});
			}, function () {});
		
		
		}
		
		
		vm.deleteDocument = function (ev, IDEmployes_Document, label)
        {
		 	var commandeObj = {IDEmployes_Document:IDEmployes_Document};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer ce document ?')
                .htmlContent('Le document <b>"' + label + '</b>' + '" va être supprimé.')
                .ariaLabel('Supprimer un document')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/employes/deleteDocument.json", JSON.stringify(commandeObj)).then(function (response, status, headers, config) {  
					vm.dtInstance.reloadData();
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Le document a été supprimé.')
						.position('bottom right' )
						.hideDelay(3000)
					);
				vm.dtInstance.reloadData();
				}, function () {});
				
            }, function () {}); 
        }
		
	
		vm.filterSave = [];
        vm.dtInstance = {};
    		
		 vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'datas',
				 url: 'datas/employes/getDocuments.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'dataTableColabDocs', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
				  $('.scrollable').animate({
					scrollTop: 0
				  }, 'slow');
			})
			.withOption('stateLoadCallback', function (oSettings) {
				var columnLoad = JSON.parse( localStorage.getItem('dataTableColabDocs') );
				// if( columnLoad != null && columnLoad.columns[3].search.search == "")
					// columnLoad.columns[3].search.search = 1;
				return columnLoad;
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('aoSearchCols',   [
			  null,
			  null,
			  null,
			  null,
			  // { "sSearch": "0" },
			  null,
			  null
			])
			.withOption('columnDefs',  [
				{
                    // Target the price column
                    targets: 4,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },
				
               {
                    targets: 0,
                    responsivePriority: 0,
                },   
                {
                    targets: 1,
                    responsivePriority: 2,
                },   
                {
                    targets: 2,
                    responsivePriority: 2,
                },   
                {
                    targets: 3,
                    responsivePriority: 1,
                },   
                {
                    targets: 4,
                    responsivePriority: 1,
                },    
				{
                    targets           : 7,
                    responsivePriority: 0,
                } 
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
					var api = this.api();
						vm.searchBox = angular.element('body').find('#colabdocs-search');

					angular.forEach(vm.filterSave, function(value, key) {
						var cpt = key+1;
						if(typeof value.search.search == "string" && value.search.search.includes("~")){
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
							
						} else{
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
						}
					}); 
				
					if ( vm.searchBox.length > 0 )
					{
						var timeout = null;
						vm.searchBox.on('keyup', function (event)
						{
							clearTimeout(timeout);
							timeout = setTimeout(function () {
								api.search(vm.search).draw();
							}, 500);
						});
					}
					
					vm.recordsTotal = json.recordsTotal;
				}
			)
			.withLightColumnFilter({
				  "1": {
					"html": "input",
					"type": "text",
					// "location": $location
				  },
				  "2": {
					"html": "input",
					"type": "text",
					// "location": $location
				  },
				  "3": {
					"html": "input",
					"type": "text",
					// "location": $location
				  },
				  "4": {
					"html": "select",
					"values": [{'value':"", 'label':"--"}].concat(employesSimple.data),
					// "location": $location,
					"regex":true
				  },
				  "5": {
					"html": "range",
					"type": "date",
					// "location": $location
				  },
				  "6": {
					"html": "range",
					"type": "date",
					// "location": $location
				  },
				  "7": {
					"html": "clear"
				  }
			  })
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('order', [1, 'desc']);
			// .withLightColumnFilter({
			/* 	  "0": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "1": {
					"html": "select",
					"values": employesSimple.data,
					"regex":true,
					"location": $location
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '0', label: 'Non traitée'}, 
						{value: '1', label: 'Traitée'}, 
					],
					"location": $location,
					"regex":true
				  },
				  "2": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "5": {
					"html": "clear"
				  } */
			// });
			  


		vm.dtColumns = [
			DTColumnBuilder.newColumn('IDEmployes_Document').notSortable().withTitle('<div class="table-header"><span class="column-title"> <md-checkbox aria-label="Tout sélectionner" ng-checked="isChecked()" md-indeterminate="isIndeterminate()" ng-click="toggleAll()"></md-checkbox></div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				return '<md-checkbox data-val="'+data+'" aria-label="Sélectionner le '+data+'" ng-checked="exists('+data+', selected)" ng-click="toggle('+data+', selected)"></md-checkbox>';
			  
			}),
			DTColumnBuilder.newColumn('IDEmployes_Document').withTitle('<div class="table-header"><span class="column-title">N°</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('Label').withTitle('<div class="table-header"><span class="column-title">Document</div></div>').withOption('width', '120px').renderWith(function(data, type, full){
				if(full.Acces == "Fichier")
					return "<a href='"+full.Document+"' target='_blank'>"+data+"</a>";
				else
					return "<a href='"+full.Lien+"' target='_blank'>"+data+"</a>";
			}),
			DTColumnBuilder.newColumn('Type').withTitle('<div class="table-header"><span class="column-title">Type</div></div>').withOption('width', '120px'),
		
			DTColumnBuilder.newColumn('IDEmploye').withTitle('<div class="table-header"><span class="column-title">Collaborateur</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				var html = '';
				if(full.Compte== null){
					html += '<span class="" >Pour tous</span>';
				}
				else{
					if(full.CompteSupprime!=0)
						html += '<md-tooltip md-direction="left" >Compte supprimé</md-tooltip>';
					html += '<span class="" >'+ full.Compte +'</span>';
				}
				return html;
			}),
			DTColumnBuilder.newColumn('DateCreation').withTitle('<div class="table-header"><span class="column-title">Date d\'ajout</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data);
			}),
			DTColumnBuilder.newColumn('DateModification').withTitle('<div class="table-header"><span class="column-title">Dernière modification</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data, true);
			}),
			DTColumnBuilder.newColumn(null).withTitle('').notSortable().withOption('width', '50px').renderWith(function(data, type, full){
				
				var $html = '<md-menu style="float: right;">'+
				'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
						'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
					'</md-button>'+
					'<md-menu-content width="3">';
					
					if(full.Acces == "Fichier")
						$html+='<md-menu-item> '+
							"<md-button ng-href='"+full.Document+"' target='_blank'>"+
								'Télécharger '+
							'</md-button>'+
						'</md-menu-item>';
					else
						$html+='<md-menu-item> '+
							"<md-button ng-href='"+full.Lien+"' target='_blank'>"+
								'Télécharger '+
							'</md-button>'+
						'</md-menu-item>';
						
					if($rootScope.Permission=='Super Admin'){
						$html+='<md-divider ></md-divider>'+
						'<md-menu-item> '+
							'<md-button ng-click="vm.editDocument($event, '+full.IDEmployes_Document+')" > '+
							'	Modifier '+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-menu-item> '+
							'<md-button ng-click="vm.deleteDocument($event, '+full.IDEmployes_Document+', \''+full.Label+'\')" > '+
							'	Supprimer '+
							'</md-button>'+
						'</md-menu-item>';
					}
					$html+='</md-menu-content>'+
				'</md-menu>';
				
				return $html;
			}),
		];
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.conges')
        .controller('congesController', congesController);
		 
    /** @ngInject */
    function congesController(employesSimple, $mdDialog, $http, $mdToast, $window, $rootScope, DTOptionsBuilder, DTColumnBuilder, $compile, $scope, $location  )
    {
        var vm = this;


		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		vm.recordsTotal = 0;
		vm.search = localStorage.getItem('colabcongesSearch');
		
			
		function convertDate(inputFormat, hour, day) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
	
	
		$scope.selected = [];
		
		$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
		};
		
		$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
		};
		
		$scope.isIndeterminate = function() {
			return ($scope.selected.length !== 0 &&
				$scope.selected.length !== $('.dataTable md-checkbox').length - 1);
		};
		
		$scope.isChecked = function() {
			return $scope.selected.length === $('.dataTable md-checkbox').length - 1;
		};
		
		$scope.toggleAll = function() {
			if ($scope.selected.length === $('.dataTable md-checkbox').length - 1) {
				$scope.selected = [];
			} else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
				$scope.selected = [];
				$('.dataTable md-checkbox').each(function(k, v){
					if(typeof $(v).attr('data-val') != "undefined")
						$scope.selected.push(parseInt($(v).attr('data-val')));
				});
			}
		};

	
		vm.exportConges = function (ev, type)
        {
			$window.open("/datas/employes/exportConges.json?type="+type+'&selected='+$scope.selected, '_blank');
        }
		
		vm.editConge = function (ev, IDEmployes_Conge){
			$http.get("/datas/employes/getConge.json?IDEmployes_Conge="+IDEmployes_Conge)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					controller         : 'CongesCollabDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/collaborateurs/conges/dialogs/conges-dialog.html',
					parent             : angular.element(document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						// Conge : "",
						Conge : response.data.data,
						employesSimple : employesSimple
					}
				}).then(function (response)
				{
					if(typeof response != "undefined"){
						vm.dtInstance.reloadData();
						if(typeof IDEmployes_Conge!="undefined")
							$mdToast.show(
							  $mdToast.simple()
								.textContent("Votre congé a été modifié !")
								.position('bottom right' )
								.hideDelay(3000)
							);
						else
						$mdToast.show(
						  $mdToast.simple()
							.textContent("Votre congé a été demandé !")
							.position('bottom right' )
							.hideDelay(3000)
						);
					} 
				});
			}, function () {});
		}
		
		vm.apercuConge = function (ev, IDEmployes_Conge){
			alert('apercu');
		}
		
		vm.deleteConge = function (ev, IDEmployes_Conge, DateDebut, DateFin)
        {
		 	var commandeObj = {IDEmployes_Conge:IDEmployes_Conge};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer ce congé ?')
                .htmlContent('Le congé du <b>' + convertDate(DateDebut) + " au " + convertDate(DateFin) + '</b>' + ' va être supprimé.')
                .ariaLabel('Supprimer un congé')
                .targetEvent(ev)
                .theme('md-warn')
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/employes/deleteConge.json", JSON.stringify(commandeObj)).then(function (response, status, headers, config) {  
					vm.dtInstance.reloadData();
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Le congé a été supprimé.')
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.dtInstance.reloadData();
				}, function () {});
				
            }, function () {});
        }
		
		vm.filterSave = [];
        vm.dtInstance = {};
    		
		 vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'datas',
				 url: 'datas/employes/getConges.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'dataTableColabConges', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
				  $('.scrollable').animate({
					scrollTop: 0
				  }, 'slow');
			})
			.withOption('stateLoadCallback', function (oSettings) {
				var columnLoad = JSON.parse( localStorage.getItem('dataTableColabConges') );
				// if( columnLoad != null && columnLoad.columns[3].search.search == "")
					// columnLoad.columns[3].search.search = 1;
				return columnLoad;
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('aoSearchCols',   [
			  null,
			  null,
			  null,
			  null,
			  // { "sSearch": "0" },
			  null,
			  null
			])
			.withOption('columnDefs',  [
				{
                    // Target the price column
                    targets: 4,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },
				
                {
                    targets: 0,
                    responsivePriority: 0,
                },   
                {
                    targets: 1,
                    responsivePriority: 2,
                },   
                {
                    targets: 2,
                    responsivePriority: 2,
                },   
                {
                    targets: 3,
                    responsivePriority: 1,
                },   
                {
                    targets: 4,
                    responsivePriority: 1,
                },    
				{
                    targets           : 5,
                    responsivePriority: 1,
                },    
				{
                    targets           : 9,
                    responsivePriority: 0,
                }
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
					var api = this.api();
						vm.searchBox = angular.element('body').find('#colabconges-search');

					angular.forEach(vm.filterSave, function(value, key) {
						var cpt = key+1;
						if(typeof value.search.search == "string" && value.search.search.includes("~")){
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
							
						} else{
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
						}
					}); 
				
					if ( vm.searchBox.length > 0 )
					{
						var timeout = null;
						vm.searchBox.on('keyup', function (event)
						{
							clearTimeout(timeout);
							timeout = setTimeout(function () {
								api.search(vm.search).draw();
							}, 500);
						});
					}
					
					vm.recordsTotal = json.recordsTotal;
				}
			)
			.withLightColumnFilter({
				  "1": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "2": {
					"html": "select",
					"values": [{'value':"", 'label':"--"}].concat(employesSimple.data),
					// "location": $location,
					"regex":true
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '', label: '--'},  
						{value: 'Congés payés', label: 'Congés payés'}, 
						{value: 'Congés sans solde', label: 'Congés sans solde'}, 
						{value: 'Maladie ou accident non professionnel', label: 'Maladie ou accident non professionnel'}, 
						{value: 'Accident ou maladie professionnelle', label: 'Accident ou maladie professionnelle'}, 
						{value: 'Compte Epargne Temps', label: 'Compte Epargne Temps'}, 
						{value: "Congés d'ancienneté", label: "Congés d'ancienneté"}, 
						{value: "Congés d'adoption", label: "Congés d'adoption"}, 
						{value: "Congés de proche aidant", label: "Congés de proche aidant"}, 
						{value: "Congés de solidarité familiale", label: "Congés de solidarité familiale"}, 
						{value: "Congés liées à la maternité ou à l’adoption", label: "Congés à la maternité ou à l'adoption"}, 
						{value: "Congés maternité", label: "Congés maternité"}, 
						{value: "Congés parental d'éducation", label: "Congés parental d'éducation"}, 
						{value: "Congés paternité", label: "Congés paternité"}, 
						{value: "Congés pour enfant malade", label: "Congés pour enfant malade"}, 
						{value: "Congés pour évènements familiaux", label: "Congés pour évènements familiaux"}, 
						{value: "Congés sabbatiques", label: "Congés sabbatiques"}, 
						// {value: "Déplacement", label: "Déplacement"}, 
						// {value: "Formation", label: "Formation"}, 
						// {value: "Jours de fractionnement", label: "Jours de fractionnement"}, 
						{value: "Récupération", label: "Récupération"}, 
						{value: "Repos compensateur", label: "Repos compensateur"}, 
					],
					"location": $location,
				  "regex":true},
				
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "5": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "6": {
					"html": "range",
					"type": "number",
					"location": $location
				  },
				  "7": {
					"html": "input",
					"type": "text",
					// "location": $location
				  },
				  "8": {
					"html": "select",
					"values": [
						{value: '', label: '--'}, 
						{value: 'A valider', label: 'A renouveler'}, 
						{value: 'Validés', label: 'Renouvelée'}, 
						{value: 'Refusés', label: 'Non renouvelée'}, 
					],
					"location": $location,
				  "regex":true},
				  "9": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "10": {
					"html": "clear"
				  }
				  
				  
			  })
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('order', [1, 'desc']);
			// .withLightColumnFilter({
			/* 	  "0": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "1": {
					"html": "select",
					"values": employesSimple.data,
					"regex":true,
					"location": $location
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '0', label: 'Non traitée'}, 
						{value: '1', label: 'Traitée'}, 
					],
					"location": $location,
					"regex":true
				  },
				  "2": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "5": {
					"html": "clear"
				  } */
			// });
			  


		vm.dtColumns = [
			DTColumnBuilder.newColumn('IDEmployes_Conge').notSortable().withTitle('<div class="table-header"><span class="column-title"> <md-checkbox aria-label="Tout sélectionner" ng-checked="isChecked()" md-indeterminate="isIndeterminate()" ng-click="toggleAll()"></md-checkbox></div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				return '<md-checkbox data-val="'+data+'"  aria-label="Sélectionner le '+data+'" ng-checked="exists('+data+', selected)" ng-click="toggle('+data+', selected)"></md-checkbox>';
			  
			}),
			DTColumnBuilder.newColumn('IDEmployes_Conge').withTitle('<div class="table-header"><span class="column-title">N°</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('IDEmploye').withTitle('<div class="table-header"><span class="column-title">Collaborateur</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				var html = '';
				if(full.CompteSupprime!=0)
					html += '<md-tooltip md-direction="left" >Compte supprimé</md-tooltip>';
				html += '<span class="" >'+ full.Compte +'</span>';
				return html;
			}),
			DTColumnBuilder.newColumn('Type').withTitle('<div class="table-header"><span class="column-title">Type d\'absence</div></div>').withOption('width', '120px'),
			DTColumnBuilder.newColumn('DateDebut').withTitle('<div class="table-header"><span class="column-title">Début</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data)+" - "+full.HeureDebut;
			}),
			DTColumnBuilder.newColumn('DateFin').withTitle('<div class="table-header"><span class="column-title">Fin</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data)+" - "+full.HeureFin;
			}),
			DTColumnBuilder.newColumn('Duree').withTitle('<div class="table-header"><span class="column-title">Durée</div></div>').withOption('width', '120px'),
			
			DTColumnBuilder.newColumn('CommentaireSalarie').notSortable().withTitle('<div class="table-header"><span class="column-title">Note</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				
				var html = '';
				
				if(full.CommentaireSalarie!="")
					html += "<strong>Collaborateur : </strong><br>" + full.CommentaireSalarie;
				
				if(full.CommentaireSalarie!="" &&  full.CommentaireResponsable!="")
					html += "<br><br>";
				
				if(full.CommentaireResponsable!="")
					html += "<strong>Responsable : </strong><br>" + full.CommentaireResponsable;
				
				return html;
				
			}),
			DTColumnBuilder.newColumn('Statut').withTitle('<div class="table-header"><span class="column-title">Statut</div></div>').withOption('width', '150px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
						if(data == "Validés")
							 return'<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-green-bg white-fg"  style="text-transform:capitalize; display:inline-block ">Validés</span>'; 
						else if(data == "Refusés")
							return '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-red-bg white-fg"  style="text-transform:capitalize;display:inline-block ">Refusés</span> '; 
						else
							return '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-orange-bg white-fg"  style="text-transform:capitalize;display:inline-block ">À valider</span> '; 
						
					
				   return html;
				}
				return data;
				
			}),
			DTColumnBuilder.newColumn('DateCreation').withTitle('<div class="table-header"><span class="column-title">Date demande</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data);
			}),
			DTColumnBuilder.newColumn(null).withTitle('').notSortable().withOption('width', '50px').renderWith(function(data, type, full){
				return '<md-menu style="float: right;">'+
				'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
						'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
					'</md-button>'+
					'<md-menu-content width="3">'+
					/* 	
						'<md-menu-item> '+
							'<md-button ng-click="vm.apercuConge($event, '+full.IDEmployes_Conge+')" > '+
							'	Aperçu '+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-menu-item> '+
							'<md-button ng-click="vm.apercuConge($event, '+full.IDEmployes_Conge+')" > '+
							'	Justificatif '+
							'</md-button>'+
						'</md-menu-item>'+ */
						// '<md-divider ></md-divider>'+
						'<md-menu-item> '+
							"<md-button ng-click='vm.editConge($event, \""+full.IDEmployes_Conge+"\")' ng-disabled='\""+full.Statut+"\" == \"Validés\" && \""+$rootScope.Permission+"\" != \"Super Admin\"'> "+
								'Modifier '+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-menu-item> '+
							"<md-button ng-click='vm.deleteConge($event, \""+full.IDEmployes_Conge+"\",\""+full.DateDebut+"\",\""+full.DateFin+"\")'  ng-disabled='\""+full.Statut+"\" == \"Validés\"'>"+
								'Supprimer '+
							'</md-button>'+
						'</md-menu-item>'+
						
					'</md-menu-content>'+
				'</md-menu>';
					
			}),
		];
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.activites')
        .controller('ActivitesController', ActivitesController);

    /** @ngInject */
    function ActivitesController(employesSimple, $mdDialog, $http, $mdToast, $window, DTOptionsBuilder, DTColumnBuilder, $compile, $scope, $location  )
    {
       var vm = this;


		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		vm.recordsTotal = 0;
		vm.search = localStorage.getItem('colabactivitesSearch');
			
			
		
		function convertDate(inputFormat, hour , day ) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			
			var days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else if(day)
				return days[d.getDay()] + " "+[pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
	
	
		$scope.selected = [];
		
		$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
		};
		
		$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
		};
		
		$scope.isIndeterminate = function() {
			return ($scope.selected.length !== 0 &&
				$scope.selected.length !== $('.dataTable md-checkbox').length - 1);
		};
		
		$scope.isChecked = function() {
			return $scope.selected.length === $('.dataTable md-checkbox').length - 1;
		};
		
		$scope.toggleAll = function() {
			if ($scope.selected.length === $('.dataTable md-checkbox').length - 1) {
				$scope.selected = [];
			} else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
				$scope.selected = [];
				$('.dataTable md-checkbox').each(function(k, v){
					if(typeof $(v).attr('data-val') != "undefined")
						$scope.selected.push(parseInt($(v).attr('data-val')));
				});
			}
		};

	
		vm.exportActivites = function (ev, type)
        {
			$window.open("/datas/employes/exportActivite.json?type="+type+'&selected='+$scope.selected, '_blank');
        }
		
		vm.editActivite = function (ev, IDEmployes_Activite, congeApresMidi, congeMatin){
			
			$http.get("/datas/employes/getActivite.json?IDEmployes_Activite="+IDEmployes_Activite)
			.then(function (response, status, headers, config) {
				
				$mdDialog.show({
					controller         : 'ActivitesCollabDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/collaborateurs/activites/dialogs/activites-dialog.html',
					parent             : angular.element(document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						Activite : response.data.data,
						// Activite : "",
						congeApresMidi : congeApresMidi,
						congeMatin : congeMatin,
						employesSimple : employesSimple
					}
				}).then(function (response)
				{
					if(typeof response != "undefined"){
						vm.dtInstance.reloadData();
						if(typeof IDEmployes_Activite!="undefined")
							$mdToast.show(
							  $mdToast.simple()
								.textContent("Votre journée a été modifiée !")
								.position('bottom right' )
								.hideDelay(3000)
							);
						else
						$mdToast.show(
						  $mdToast.simple()
							.textContent("Votre journée a été modifiée !")
							.position('bottom right' )
							.hideDelay(3000)
						);
					} 
				});
			}, function () {});
		
		}
		
		vm.deleteActivite = function (ev, IDEmployes_Activite, label)
        {
		 	var commandeObj = {IDEmployes_Activite:IDEmployes_Activite};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer ce document ?')
                .htmlContent('Le document <b>"' + label + '</b>' + '" va être supprimé.')
                .ariaLabel('Supprimer un document')
                .targetEvent(ev)
                .ok('Supprimer')
                .theme('md-warn')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/employes/deleteDocument.json", JSON.stringify(commandeObj)).then(function (response, status, headers, config) {  
					vm.dtInstance.reloadData();
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Le document a été supprimé.')
						.position('bottom right' )
						.hideDelay(3000)
					);
				}, function () {});
				
            }); 
        }
		
		vm.filterSave = [];
        vm.dtInstance = {};
    		
		 vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'datas',
				 url: 'datas/employes/getActivites.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'dataTableColabActivites', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
				  $('.scrollable').animate({
					scrollTop: 0
				  }, 'slow');
			})
			.withOption('stateLoadCallback', function (oSettings) {
				var columnLoad = JSON.parse( localStorage.getItem('dataTableColabActivites') );
				// if( columnLoad != null && columnLoad.columns[3].search.search == "")
					// columnLoad.columns[3].search.search = 1;
				return columnLoad;
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('aoSearchCols',   [
			  null,
			  null,
			  null,
			  null,
			  // { "sSearch": "0" },
			  null,
			  null
			])
			.withOption('columnDefs',  [
				/* {
                    // Target the price column
                    targets: 4,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                }, */
				
                 {
                    targets: 0,
                    responsivePriority: 0,
                },   
                {
                    targets: 1,
                    responsivePriority: 1,
                },   
                {
                    targets: 2,
                    responsivePriority: 2,
                },   
                {
                    targets: 3,
                    responsivePriority: 1,
                },   
                {
                    targets: 4,
                    responsivePriority: 1,
                },    
                {
                    targets: 5,
                    responsivePriority: 5,
                },  
                {
                    targets: 6,
                    responsivePriority: 4,
                },    
				{
                    targets           : 7,
                    responsivePriority: 0,
                } 
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
					var api = this.api();
						vm.searchBox = angular.element('body').find('#colabactivites-search');

					angular.forEach(vm.filterSave, function(value, key) {
						var cpt = key+1;
						if(typeof value.search.search == "string" && value.search.search.includes("~")){
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
							
						} else{
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
						}
					}); 
				
					if ( vm.searchBox.length > 0 )
					{
						var timeout = null;
						vm.searchBox.on('keyup', function (event)
						{
							clearTimeout(timeout);
							timeout = setTimeout(function () {
								api.search(vm.search).draw();
							}, 500);
						});
					}
					
					vm.recordsTotal = json.recordsTotal;
				}
			).withLightColumnFilter({
				  "1": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "2": {
					"html": "select",
					"values": [{'value':"", 'label':"--"}].concat(employesSimple.data),
					// "location": $location,
					"regex":true
				  },
				  // "3": {
					// "html": "select",
					// "values": employesSimple.data,
					// "location": $location,
					// "regex":true
				  // },
				  "4": {
					"html": "range",
					"type": "number",
					"location": $location
				  },
				  "5": {
					"html": "input",
					"type": "text",
					"location": $location
				  }, 
				  "6": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "7": {
					"html": "clear"
				  }
				  
			  })
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('order', [1, 'desc']);
			// .withLightColumnFilter({
			/* 	  "0": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "1": {
					"html": "select",
					"values": employesSimple.data,
					"regex":true,
					"location": $location
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '0', label: 'Non traitée'}, 
						{value: '1', label: 'Traitée'}, 
					],
					"location": $location,
					"regex":true
				  },
				  "2": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "5": {
					"html": "clear"
				  } */
			// });
			  


		vm.dtColumns = [
			DTColumnBuilder.newColumn('IDEmployes_Activite').notSortable().withTitle('<div class="table-header"><span class="column-title"> <md-checkbox aria-label="Tout sélectionner" ng-checked="isChecked()" md-indeterminate="isIndeterminate()" ng-click="toggleAll()"></md-checkbox></div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				return '<md-checkbox data-val="'+data+'" aria-label="Sélectionner le '+convertDate(full.Date, false, true)+'"  ng-checked="exists('+data+', selected)" ng-click="toggle('+data+', selected)"></md-checkbox>';
			  
			}),
			DTColumnBuilder.newColumn('Date').withTitle('<div class="table-header"><span class="column-title">Date</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data, false, true);
			}),
			DTColumnBuilder.newColumn('IDEmploye').withTitle('<div class="table-header"><span class="column-title">Collaborateur</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
				var html = '';
				if(full.CompteSupprime!=0)
					html += '<md-tooltip md-direction="left" >Compte supprimé</md-tooltip>';
				html += '<span class="" >'+ full.Compte +'</span>';
				return html;
			}),
			DTColumnBuilder.newColumn('TranchesHeures').withTitle('<div class="table-header"><span class="column-title">Horraires</div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				var html = "";
				if(data!= "")
				angular.forEach(JSON.parse(data), function(value, key) {
				  html += value.start + " à " + value.end +"<br>";
				});
				return html;
			}),
			DTColumnBuilder.newColumn('NombreHeures').withTitle('<div class="table-header"><span class="column-title">Nombre d\'heures</div></div>').withOption('width', '120px'),
			DTColumnBuilder.newColumn('Note').withTitle('<div class="table-header"><span class="column-title">Commentaire</div></div>').withOption('width', '250px').renderWith(function(data, type, full){
				var html = "";
				if(full.Weekend)
					html += "Weekend<br>";
				if(full.Ferie)
					html += "Ferié<br>";
				if(full.Conge && !full.CongeApresmidi && !full.CongeMatin)
					html += "Absent<br>";
				if(full.CongeApresmidi)
					html += "Absent l'après-midi<br>";
				if(full.CongeMatin)
					html += "Absent le matin<br>";
				
				html += data;
				return html;
			}),
			
			DTColumnBuilder.newColumn('DateModification').withTitle('<div class="table-header"><span class="column-title">Dernière modification</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
				return convertDate(data, true);
			}),
			
			DTColumnBuilder.newColumn(null).withTitle('').notSortable().withOption('width', '50px').renderWith(function(data, type, full){
				return '<md-button style="float: right;" ng-click="vm.editActivite($event, '+full.IDEmployes_Activite+', '+full.CongeApresmidi+', '+full.CongeMatin+')" ng-disabled="\''+full.DateDiff+'\' > 5 || (\''+full.Conge+'\' == 1  && !'+full.CongeApresmidi+' && !'+full.CongeMatin+')"> '+
				'	Modifier '+
				'</md-button>';
				
				/*return '<md-menu style="float: right;">'+
				'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
						'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
					'</md-button>'+
					'<md-menu-content width="3">'+

						'<md-menu-item> '+
							'<md-button ng-click="vm.Traiternotification($event, '+full.IDAlerte+')" ng-disabled="\''+full.Traite+'\' == 1"> '+
							'	Traiter '+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-divider ></md-divider>'+
						'<md-menu-item> '+
							"<md-button ng-click='vm.Detailsnotification($event, \""+full.IDCommande+"\",\""+full.IDContact+"\")'> "+
								'Aperçu '+
							'</md-button>'+
						'</md-menu-item>'+
						
					'</md-menu-content>'+
				'</md-menu>';
					*/
			}),
		];
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.banque', [
            'wt.responsive'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider
            .state('app.banque', {
                url      : '/banque?statut',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/banque/banque.html',
                        controller : 'BanqueController as vm'
                    }
                },
                resolve  : {
                    OperationsBancaires: function (msApi)
                    {
                        return msApi.resolve('banque.operations@get');
                    },
                    nbrOperationsParEtats: function (msApi)
                    {
                        return msApi.resolve('banque.nbrOperationsParEtats@get');
                    }
                },
                bodyClass: 'banque'
            });

        msApiProvider.register('banque.operations', ['datas/banque/getOperations.json']);
        msApiProvider.register('banque.nbrOperationsParEtats', ['datas/banque/getNbrOperationsParEtats.json']);
    }

})();

(function () {
    'use strict';
    angular.module('app.banque').controller('OperationsBanqueStatutsMasseController', OperationsBanqueStatutsMasseController);

    /** @ngInject */
    function OperationsBanqueStatutsMasseController(Ids, $http, $mdDialog) {
        var vm = this;
        vm.ids = Ids || [];
        vm.statuts = ['À valider', 'En attente de pièce', 'Justifiée hors facture', 'Non justifiée', 'Ignorée'];
        vm.categories = ['Frais bancaires', 'Frais juridiques et contentieux', 'Location bâtiment', 'Assurance véhicules', 'Assurance homme clé', 'Prévoyance dirigeant', 'Mutuelle dirigeant', 'Retraite dirigeant', 'Épargne salariale', 'Protection sociale salariés', 'Mutuelle des salariés', 'Sécurité et alarme', 'Salaires', 'Cotisations sociales', 'Impôts et taxes', 'Virement interne', 'Autre'];
        vm.statut = '';
        vm.categorie = '';
        vm.busy = false;
        vm.error = '';
        vm.categorieNecessaire = function () { return ['En attente de pièce', 'Justifiée hors facture'].indexOf(vm.statut) !== -1; };
        vm.annuler = function () { if (!vm.busy) $mdDialog.cancel(); };
        vm.enregistrer = function () {
            if (vm.busy || !vm.ids.length || !vm.statut) return;
            vm.busy = true; vm.error = '';
            var data = new FormData();
            data.append('data', angular.toJson({IDs:vm.ids, Statut:vm.statut, Categorie:vm.categorie || null}));
            $http.post('/datas/banque/setStatutsOperationsMasse.json', data,
                {headers:{'Content-Type':undefined}, transformRequest:angular.identity}).then(function (response) {
                if (!response.data || response.data.error || !response.data.data) {
                    vm.error = response.data && response.data.error && response.data.error.message || 'Modification refusée.';
                    return;
                }
                $mdDialog.hide(response.data);
            }, function (response) {
                vm.error = response.data && response.data.error && response.data.error.message || 'Modification impossible.';
            }).finally(function () { vm.busy = false; });
        };
    }
})();

(function () {
    'use strict';
    angular.module('app.banque').controller('OperationsBanqueImportController', OperationsBanqueImportController);

    /** @ngInject */
    function OperationsBanqueImportController($rootScope, $http, $mdDialog) {
        var vm = this;
        vm.busy = false; vm.error = ''; vm.resultat = null; vm.comptes = [];
        vm.format = 'OFX';
        vm.autorise = function () {
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf('finance.banque.import') !== -1;
        };
        vm.fermer = function () {
            if (!vm.busy) {
                if (vm.resultat) $mdDialog.hide(vm.resultat);
                else $mdDialog.cancel();
            }
        };
        $http.get('/datas/banque/getComptes.json').then(function (response) {
            vm.comptes = response.data.data || [];
			if (vm.comptes.length === 1) vm.IDCompte = vm.comptes[0].IDCompte;
        }, function () { vm.error = 'Impossible de charger les comptes.'; });
        vm.importer = function (form) {
            if (!vm.autorise() || vm.busy || vm.resultat || form.$invalid) return;
            vm.error = '';
            if (!vm.file || Number(vm.file.size || 0) <= 0 || Number(vm.file.size || 0) > 20 * 1024 * 1024 || !/\.(cmi|ofx|csv)$/i.test(vm.file.name || '')) {
                vm.error = 'Choisir un fichier CMI, OFX ou CSV Crédit Mutuel de 20 Mo maximum.'; return;
            }
            vm.format = /\.cmi$/i.test(vm.file.name || '') ? 'CMI' : (/\.csv$/i.test(vm.file.name || '') ? 'CSV' : 'OFX');
            var data = new FormData();
            data.append('file', vm.file);
            data.append('data', angular.toJson({Format:vm.format, IDCompte:vm.IDCompte}));
            vm.busy = true;
            $http.post('/datas/banque/importerOperations.json', data, {
                headers:{'Content-Type':undefined}, transformRequest:angular.identity
            }).then(function (response) {
                if (!response.data || response.data.error || !response.data.data) {
                    vm.error = response.data && response.data.error && response.data.error.message || 'Import refusé.'; return;
                }
                vm.resultat = response.data.data;
            }, function (response) {
                vm.error = response && response.data && response.data.error && response.data.error.message || 'Import impossible. Vérifier le contrôleur PHP.';
            }).finally(function () { vm.busy = false; });
        };
    }
})();

(function () {
    'use strict';
    angular.module('app.banque').controller('OperationBanqueEditionController', OperationBanqueEditionController);
    /** @ngInject */
    function OperationBanqueEditionController(Document, StatutSeulement, LectureSeule, $rootScope, $http, $mdDialog, $window) {
        var vm = this;
        vm.document = angular.copy(Document);
        vm.document.IDPieces = angular.copy(Document.IDPieces || (Document.IDPiece ? [Document.IDPiece] : []));
        vm.documents = angular.copy(Document.Documents || []);
        vm.document.IDDocuments = vm.documents.map(function (document) { return Number(document.IDDocument); });
        vm.documentsDisponibles = [];
        vm.lectureSeule = LectureSeule === true;
        vm.dates = {};
        ["DateOperation"].forEach(function (field) {
            vm.dates[field] = Document[field] ? new Date(Document[field] + 'T00:00:00') : null;
        });
        function formatDate(date) {
            if (!date || isNaN(date.getTime())) return '';
            function pad(value) { return ('0' + value).slice(-2); }
            return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
        }
        vm.statutSeulement = StatutSeulement; vm.comptes = []; vm.pieces = []; vm.piecesUnitaires = []; vm.propositions = []; vm.prelevements = [];
        vm.contacts = []; vm.tropPercus = []; vm.error = ''; vm.busy = false;
        vm.attributionRejet = vm.statutSeulement && Document.EstRejetPrelevement && Document.Statut === 'Rejet à attribuer';
        function reconstruireStatuts(document) {
            vm.statuts = ['À rapprocher', 'À valider', 'Rapprochée', 'En attente de pièce', 'Justifiée hors facture', 'Non justifiée', 'Ignorée'];
            if (Number(document.Credit) > 0) vm.statuts.splice(3, 0, 'À rembourser');
            if (Number(document.Debit) > 0) vm.statuts.splice(3, 0, 'Remboursé');
            if (document.Statut && vm.statuts.indexOf(document.Statut) === -1) vm.statuts.push(document.Statut);
        }
        reconstruireStatuts(vm.document);
        vm.categories = ['Frais bancaires', 'Frais juridiques et contentieux', 'Location bâtiment', 'Assurance véhicules', 'Assurance homme clé', 'Prévoyance dirigeant', 'Mutuelle dirigeant', 'Retraite dirigeant', 'Épargne salariale', 'Protection sociale salariés', 'Mutuelle des salariés', 'Sécurité et alarme', 'Salaires', 'Cotisations sociales', 'Impôts et taxes', 'Virement interne', 'Autre'];
        vm.modifiable = !Document.IDOperationBancaire || (Document.Origine === 'Import manuel' && Document.Statut !== 'Rapprochée');
        vm.annuler = function () { if (!vm.busy) $mdDialog.cancel(); };
        vm.autorise = function () {
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf('finance.banque.' + (vm.statutSeulement ? 'statut' : 'edition')) !== -1;
        };
        vm.libelleDocument = function (document) {
            var complement = [];
            if (document.ContactsLibelle) complement.push(document.ContactsLibelle);
            if (document.Reference) complement.push(document.Reference);
            return document.Titre + (complement.length ? ' — ' + complement.join(' — ') : '');
        };
        vm.telechargerDocument = function (document) {
            if (document) $window.open('/datas/documents/telecharger.json?IDDocument=' + encodeURIComponent(document.IDDocument), '_blank');
        };
        function chargerSelectionDocuments() {
            if (!vm.statutSeulement || vm.attributionRejet || !Document.IDOperationBancaire) return;
            $http.get('/datas/documents/getDocumentsSelection.json', {params:{IDOperationBancaire:Document.IDOperationBancaire}}).then(function (response) {
                vm.documentsDisponibles = response.data.data || [];
            }, function () { vm.error = 'Impossible de charger les documents disponibles.'; });
        }
        function chargerDetail() {
            if (!Document.IDOperationBancaire) return;
            $http.get('/datas/banque/getOperation.json', {params:{IDOperationBancaire:Document.IDOperationBancaire}}).then(function (response) {
                var detail = response.data.data || {};
                ['Statut', 'Categorie', 'Debit', 'Credit', 'ClassificationAutomatique', 'Rapprochement',
                    'IDTropPercuClient', 'IDContactTropPercu'].forEach(function (champ) {
                    if (Object.prototype.hasOwnProperty.call(detail, champ)) vm.document[champ] = detail[champ];
                });
                vm.documents = angular.copy(detail.Documents || []);
                vm.document.IDDocuments = vm.documents.map(function (document) { return Number(document.IDDocument); });
                if (vm.document.IDContactTropPercu) vm.document.IDContactTropPercu = Number(vm.document.IDContactTropPercu);
                if (vm.document.IDTropPercuClient) vm.document.IDTropPercuClient = Number(vm.document.IDTropPercuClient);
                reconstruireStatuts(vm.document);
                chargerSelectionDocuments();
            }, function () { vm.error = 'Impossible de charger le détail de l’opération.'; });
        }
        chargerDetail();
        if (vm.statutSeulement) {
            $http.get('/datas/banque/' + (vm.attributionRejet ? 'getPrelevementsPourRejet' : 'getPiecesRapprochement') + '.json', {params:{IDOperationBancaire:Document.IDOperationBancaire}})
                .then(function (response) {
                    if (vm.attributionRejet) vm.prelevements = response.data.data || [];
                    else {
                        vm.pieces = response.data.data || [];
                        vm.piecesUnitaires = vm.pieces.filter(function (piece) { return !piece.Groupe; });
                        vm.propositions = vm.pieces.filter(function (piece) { return piece.Proposition === true; });
                    }
                }, function () { vm.error = vm.attributionRejet ? 'Impossible de charger les prélèvements possibles.' : 'Impossible de charger les pièces à rapprocher.'; });
            if (!vm.attributionRejet && Number(Document.Credit) > 0) {
                $http.get('/datas/contacts/getAllRaisonSociale.json').then(function (response) {
                    vm.contacts = response.data.data || [];
                }, function () { vm.error = 'Impossible de charger les clients.'; });
            }
            if (!vm.attributionRejet && Number(Document.Debit) > 0) {
                $http.get('/datas/banque/getTropPercusARembourser.json', {params:{IDOperationBancaire:Document.IDOperationBancaire}}).then(function (response) {
                    vm.tropPercus = response.data.data || [];
                }, function () { vm.error = 'Impossible de charger les trop-perçus à rembourser.'; });
            }
        } else if (!vm.lectureSeule) {
            $http.get('/datas/banque/getComptes.json').then(function (response) { vm.comptes = response.data.data || []; },
                function () { vm.error = 'Impossible de charger les comptes.'; });
        }
        vm.validerProposition = function (piece) {
            if (!piece) return;
            vm.document.Statut = 'Rapprochée';
            vm.document.IDPieces = angular.copy(piece.IDPieces || (piece.IDPiece ? [piece.IDPiece] : []));
            vm.document.IDPiece = vm.document.IDPieces.length === 1 ? vm.document.IDPieces[0] : null;
            vm.document.Categorie = null;
        };
        vm.changerStatut = function () {
            if (['À rembourser', 'Remboursé'].indexOf(vm.document.Statut) !== -1) {
                vm.document.Categorie = 'Trop-perçu client';
                vm.document.IDPieces = [];
            } else if (vm.document.Categorie === 'Trop-perçu client') {
                vm.document.Categorie = null;
            }
        };
        vm.enregistrer = function (form) {
            if (vm.lectureSeule || !vm.autorise() || vm.busy || form.$invalid || (!vm.statutSeulement && !vm.modifiable)) return;
            var d = vm.document;
            if (!vm.statutSeulement) ["DateOperation"].forEach(function (field) { d[field] = formatDate(vm.dates[field]); });
            vm.error = '';
            if (!vm.statutSeulement) {
                var date = new Date(d.DateOperation + 'T12:00:00Z');
                if (!/^\d{4}-\d{2}-\d{2}$/.test(d.DateOperation || '') || isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== d.DateOperation) {
                    vm.error = 'Saisir une date valide au format AAAA-MM-JJ.'; return;
                }
                if (Number(d.Debit) < 0 || Number(d.Credit) < 0 || !((Number(d.Debit) > 0) !== (Number(d.Credit) > 0))) {
                    vm.error = 'Renseigner un débit ou un crédit positif, pas les deux.'; return;
                }
            } else if (d.Statut === 'Rapprochée' && (!angular.isArray(d.IDPieces) || !d.IDPieces.length)) {
                vm.error = 'Sélectionner la ou les pièces à rapprocher.'; return;
            } else if (d.Statut === 'À rembourser' && !Number(d.IDContactTropPercu)) {
                vm.error = 'Sélectionner le client concerné par le trop-perçu.'; return;
            } else if (d.Statut === 'Remboursé' && !Number(d.IDTropPercuClient)) {
                vm.error = 'Sélectionner le trop-perçu correspondant à ce remboursement.'; return;
            } else if (['En attente de pièce', 'Justifiée hors facture'].indexOf(d.Statut) !== -1 && vm.categories.indexOf(d.Categorie) === -1) {
                vm.error = 'Sélectionner une catégorie pour cette opération.'; return;
            }
            if (vm.attributionRejet && !d.IDOperationEncaissement) {
                vm.error = 'Sélectionner le prélèvement qui a été rejeté.'; return;
            }
            var payload = vm.attributionRejet ?
                {IDOperationRejet:d.IDOperationBancaire, IDOperationEncaissement:d.IDOperationEncaissement} : vm.statutSeulement ?
                {IDOperationBancaire:d.IDOperationBancaire, Statut:d.Statut, Categorie:d.Categorie || null,
                    IDPieces:d.Statut === 'Rapprochée' ? d.IDPieces : [], IDDocuments:d.IDDocuments || [],
                    IDContactTropPercu:d.Statut === 'À rembourser' ? d.IDContactTropPercu : null,
                    IDTropPercuClient:d.Statut === 'Remboursé' ? d.IDTropPercuClient : null} :
                {IDOperationBancaire:d.IDOperationBancaire, IDCompte:d.IDCompte, DateOperation:d.DateOperation,
                    Libelle:d.Libelle, Reference:d.Reference, Debit:d.Debit, Credit:d.Credit};
            var data = new FormData(); data.append('data', angular.toJson(payload));
            vm.busy = true;
            $http.post('/datas/banque/' + (vm.attributionRejet ? 'attribuerRejet' : (vm.statutSeulement ? 'setStatutOperation' : 'editOperation')) + '.json', data,
                {headers:{'Content-Type':undefined}, transformRequest:angular.identity}).then(function (response) {
                    if (!response.data || response.data.error || !response.data.data) { vm.error = (response.data && response.data.error && response.data.error.message) || 'Enregistrement refusé.'; return; }
                    $mdDialog.hide(response.data);
                }, function () { vm.error = 'Enregistrement impossible. Vérifier le contrôleur PHP.'; })
                .finally(function () { vm.busy = false; });
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_login', {
            url      : '/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });


        // Navigation
     /*    msNavigationServiceProvider.saveItem('auth', {
            title : 'Authentication',
            icon  : 'icon-lock',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('auth.login', {
            title : 'Login',
            state : 'app.auth_login',
            weight: 1
        }); */
    }

})();
(function ()
{
    'use strict';
	var NavigationService = null;
    angular
        .module('app.auth.login')
        .controller('LoginController', LoginController)
		.config(["msNavigationServiceProvider", function (msNavigationServiceProvider) {
			NavigationService = msNavigationServiceProvider;
		}]);

    /** @ngInject */
    function LoginController($scope, $http, $location, $rootScope, fuseTheming, $mdDialog, $state)
    {
		var vm = this;
		clearTimeout($rootScope.timeout);
		$http.get('/datas/auth/logout.json');
		$rootScope.logIn = false;
		$scope.showSpinner = 0;
		$rootScope.StatutConnexion = "";
		
		if(typeof $rootScope.onglets != "undefined")
			angular.forEach($rootScope.onglets, function(value, key) {
				NavigationService.deleteItem(value.Path);
			});
			
		$scope.submit = function(){
			$rootScope.StatutConnexion = "Vérification du compte...";
			$scope.showSpinner = 1;
			$http({
			  method: 'GET',
			  url: '/datas/auth/login.json',
			  params : vm.form
			}).then(function successCallback(response) {
				if(response.data.error){
					$scope.loginForm.email.$setValidity("loginFailed", false);
					$scope.loginForm.password.$setValidity("loginFailed", false);
					$scope.status = response.data.error.message;
					$rootScope.StatutConnexion = "";
					$scope.showSpinner = 0;
				}
				else{
					$scope.loginForm.email.$setValidity("loginFailed", true);
					$scope.loginForm.password.$setValidity("loginFailed", true);
					$rootScope.logIn = true; 
					$rootScope.id = response.data.success.id;
					$rootScope.Nom = response.data.success.nom;
					$rootScope.Telephone = response.data.success.telephone;
					$rootScope.Prenom = response.data.success.prenom;
					$rootScope.Avatar = response.data.success.Avatar;
					$rootScope.Email = response.data.success.email;
					$rootScope.Permission = response.data.success.permission;
					$rootScope.droits = response.data.success.droits;
					$rootScope.onglets = response.data.success.onglets;
					$rootScope.pageDefault = response.data.success.PageDefault;
					$rootScope.DerniereConnexion = response.data.success.DerniereConnexion;
					
					
					var date1 = new Date(response.data.success.DerniereConnexion);
					var date2 = new Date();
					var diffEnMilliseconde = date2-date1;
					if(((date2-date1)/1000/3600) >=4 )
						localStorage.clear();
						
					document.title = "Exodream - Progiciel de gestion intégré";
					
					angular.forEach($rootScope.onglets, function(value, key) {
						value.groupe = (value.groupe === 1) ? true : false;
						NavigationService.saveItem(value.Path, {
							title : value.title,
							group : value.groupe,
							weight: parseInt(value.weight, 10),
							state: value.state,
							icon: value.icon
						});
					});
					
					$rootScope.StatutConnexion = "Mise à jour du système...";
					$http({
						method: 'GET',
						url: '/datas/alertes/getChangeLogs.json',
					}).then(function successCallback(response) {
						$rootScope.changelogs = response.data;
						// console.log($rootScope);
						if($rootScope.pageDefault!="")
							$state.go ($rootScope.pageDefault);
						else
							$state.go ('app.analyse_resume');
						
						// console.log($rootScope.changelogs);
						if($rootScope.changelogs.data.length>0 && typeof $rootScope.alertChageLogs =="undefined"){
							var html = "";
							angular.forEach($rootScope.changelogs.data, function(value,key){
								html += "<strong>"+value.date+"</strong>" + " : " +value.log + "<br>";
							});
							$mdDialog.show(
								$mdDialog.alert()
									.parent(angular.element(document.body))
									.clickOutsideToClose(true)
									.title('Nouvelles mises à jour')
									.htmlContent(html)
									.ariaLabel('Nouvelles mises à jour')
									.ok('Fermer')
							).finally(function() {
								 getLastAlertes();
							 });
							$rootScope.alertChageLogs = true;
						} 
						else getLastAlertes();
						
					});
					
				}
			}, function errorCallback(response) {
				console.log('error');
			});
		}
		
		function getLastAlertes(){
			// console.log("test");
			$http({
				method: 'GET',
				url: '/datas/alertes/getLastAlertes.json?date='+$rootScope.DerniereConnexion,
			}).then(function successCallback(response) {
				var lastAlertes = response.data.data;
				if(lastAlertes.length>0 && typeof lastAlertes !="undefined"){
					
					
					var html = '<md-dialog aria-label="Dernières alertes" style="max-width: 500px;">';
						html += '  <md-toolbar>';
						  html += '  <div class="md-toolbar-tools">';
							html += '  <h2>Depuis votre dernière connexion :</h2>';
						 html += '   </div>';
						html += '  </md-toolbar>';


						html += '  <md-dialog-content class="p-0">';
						html += '    <md-list class="p-0">';
						
						angular.forEach(lastAlertes, function(value,key){
							html += ' <md-list-item class="md-long-text height-120 border-bottom" ng-click="closeDialog('+value.IDAlerte+')">';
								// if(value.CommercialSupprime!=0)
									html += ' <div layout="column" flex>';
										html += ' <div layout="row" flex  layout-align="space-between center">';
											
											html += '<h4 class="font-weight-500 m-0 line-height-24">'+ value.Commercial ;
												if(value.CommercialSupprime!=0)
													html += '<md-tooltip md-direction="left" >Commercial supprimé</md-tooltip>';
											
												switch(value.Type){
													case "Danger": html += '<md-icon class="md-warn mr-16 material-icons-outlined ml-8 s18" >report_problem</md-icon>'; break;
													case "Warning": html += '<md-icon class="amber-500-fg mr-16 material-icons-outlined ml-8 s18" >report_problem</md-icon>'; break;
													case "Info": html += '<md-icon class="md-accent mr-16 material-icons-outlined ml-8 s18" >info</md-icon>'; break;
													case "Success": html += '<md-icon class="green-800-fg mr-16 material-icons-outlined ml-8 s18" >info</md-icon>'; break;
												}
											
												
											html += ' </h4>'; 
											html += '<p class="m-0 line-height-24 blue-grey-300-fg font-size-12" >'+convertDate(value.Date)+'</p>';
									
										html += ' </div>';
								// html += '<div class="md-list-item-text" layout="column">';
								
										html += '  <p class="m-0 line-height-24 blue-grey-700-fg">'+ value.Alerte +'</p>';
									html += ' </div>';
							// html += ' </div>';
									// html += '<md-tooltip md-direction="left" >Commercial supprimé</md-tooltip>';
							// html += ' <md-list-item class="md-2-line md-long-text secondary-button-padding" >';
							/* 
							switch(value.Type){
								case "Danger": html += '<md-icon class="md-warn mr-16 material-icons-outlined" >report_problem</md-icon>'; break;
								case "Warning": html += '<md-icon class="amber-500-fg mr-16 material-icons-outlined" >report_problem</md-icon>'; break;
								case "Info": html += '<md-icon class="md-accent mr-16 material-icons-outlined" >info</md-icon>'; break;
								case "Success": html += '<md-icon class="green-800-fg mr-16 material-icons-outlined" >info</md-icon>'; break;
							}
							
							html += '<div class="md-list-item-text" layout="column">';
							
								html += '  <h4>'+ value.Alerte +'</h4>';
								
								if(value.CommercialSupprime!=0)
									html += '<md-tooltip md-direction="left" >Commercial supprimé</md-tooltip>';
									html += '<p class="" >Pour '+ value.Commercial +' - '+convertDate(value.Date)+'</p>';
								
								
							html += ' </div>';
								html += ' <md-button class="md-secondary" ng-click="closeDialog('+value.IDAlerte+')">Détails</md-button>'; */
							html += ' </md-list-item>';
						});
						
						html += '	</md-list>';						
						html += '  </md-dialog-content>';
						html += '  <md-dialog-actions>';
						html += '    <md-button ng-click="closeDialog(\'\')" class="md-primary">';
						html += '      Fermer';
						html += '    </md-button>';
						html += '  </md-dialog-actions>';
						html += '</md-dialog>';
						   
			
					$mdDialog.show({
						parent: angular.element(document.body),
						clickOutsideToClose:true,
						template: html,
						fullscreen: true,
						controller: DialogController
					  });
						
					  function DialogController($scope, $mdDialog) {
						$scope.closeDialog = function(id) {
						  $mdDialog.hide();
						  if(id!="")
							$state.go ('app.analyse_notifications', {'IDAlerte':id});
						};
					};
					
					function convertDate(inputFormat) {
						function pad(s) { return (s < 10) ? '0' + s : s; }
						var d = new Date(inputFormat);
						return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
					}
				}
			});
		}
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_lock', {
            url      : '/auth/lock/:lien',
			// params: {
				// Lien: "test"
			// },
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_lock': {
                    templateUrl: 'app/main/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });


        // Navigation
       /*  msNavigationServiceProvider.saveItem('auth.lock', {
            title : 'Lock Screen',
            state : 'app.auth_lock',
            weight: 7
        }); */
    }

})();
(function ()
{
    'use strict';
	var NavigationService = null;
    angular
        .module('app.auth.lock')
        .controller('LockController', LockController)
		.config(["msNavigationServiceProvider", function (msNavigationServiceProvider) {
			NavigationService = msNavigationServiceProvider;
		}]);

    /** @ngInject */
    function LockController($rootScope,$location, $scope, $http, fuseTheming, $mdDialog, $stateParams,  $state)
    {
        var vm = this;
		clearTimeout($rootScope.timeout);
		$mdDialog.cancel();
		$mdDialog.cancel();
		$mdDialog.cancel();
		$mdDialog.cancel();
		
		$http.get('/datas/auth/logout.json');
		$rootScope.logIn = false;
		$scope.showSpinner = 0;
		
		$rootScope.StatutConnexion = "";
		
		// $http({
		  // method: 'GET',
		  // url: '/datas/configuration/get.json',
		// }).then(function successCallback(response) {
			// $rootScope.config = response.data.data;
			// fuseTheming.setActiveTheme($rootScope.config.bgcolor);
		// });
		
		if(typeof $rootScope.Email == "undefined" || typeof $rootScope.Nom == "undefined" || typeof $rootScope.Prenom == "undefined")
			$location.path('/auth/login');
		       
        vm.form = {
            username: $rootScope.Prenom + ' ' + $rootScope.Nom,
            email: $rootScope.Email
        };
		
        $scope.submit = function(){
			$rootScope.StatutConnexion = "Vérification du compte...";
			$scope.showSpinner = 1;
			$http({
			  method: 'GET',
			  url: '/datas/auth/login.json',
			  params : vm.form
			}).then(function successCallback(response) {
				if(response.data.error){
					$scope.lockForm.password.$setValidity("loginFailed", false);
					$scope.status = response.data.error.message;
					$rootScope.StatutConnexion = "";
					$scope.showSpinner = 0;
				}
				else{
					$scope.lockForm.password.$setValidity("loginFailed", true);
					$rootScope.logIn = true;
					$rootScope.id = response.data.success.id;
					$rootScope.Nom = response.data.success.nom;
					$rootScope.Telephone = response.data.success.telephone;
					$rootScope.Prenom = response.data.success.prenom;
					$rootScope.Email = response.data.success.email;
					$rootScope.Avatar = response.data.success.Avatar;
					$rootScope.droits = response.data.success.droits;
					$rootScope.Permission = response.data.success.permission;
					$rootScope.onglets = response.data.success.onglets;
					// $rootScope.reseaux = response.data.success.reseaux; // ???????
					$rootScope.pageDefault = response.data.success.PageDefault;
					$rootScope.DerniereConnexion = response.data.success.DerniereConnexion;
					
					
					var date1 = new Date(response.data.success.DerniereConnexion);
					var date2 = new Date();
					var diffEnMilliseconde = date2-date1;
					if(((date2-date1)/1000/3600) >=4 )
						localStorage.clear();
						
					document.title = "Exodream - Progiciel de gestion intégré";
					
					angular.forEach($rootScope.onglets, function(value, key) {
						value.groupe = (value.groupe === 1) ? true : false;
						NavigationService.saveItem(value.Path, {
							title : value.title,
							group : value.groupe,
							weight: parseInt(value.weight, 10),
							state: value.state,
							icon: value.icon
						});
					});
					
					$rootScope.StatutConnexion = "Mise à jour du système...";
					$http({
						method: 'GET',
						url: '/datas/alertes/getChangeLogs.json',
					}).then(function successCallback(response) {
						$rootScope.changelogs = response.data;
						// console.log($rootScope);
						$location.path($stateParams.lien.split('_').join('/'));
						// console.log($rootScope.changelogs);
						if($rootScope.changelogs.data.length>0 && typeof $rootScope.alertChageLogs =="undefined"){
							var html = "";
							angular.forEach($rootScope.changelogs.data, function(value,key){
								html += "<strong>"+value.date+"</strong>" + " : " +value.log + "<br>";
							});
							$mdDialog.show(
								$mdDialog.alert()
									.parent(angular.element(document.querySelector('#popupContainer')))
									.clickOutsideToClose(true)
									.title('Nouvelles mises à jour')
									.htmlContent(html)
									.ariaLabel('Nouvelles mises à jour')
									.ok('Fermer')
								).finally(function() {
									 getLastAlertes();
								});
								$rootScope.alertChageLogs = true;
						} 
							else getLastAlertes();
						
						
					});
					
					
				}
			}, function errorCallback(response) {
				console.log('error');
			});
		}

        function getLastAlertes(){
			$http({
				method: 'GET',
				url: '/datas/alertes/getLastAlertes.json?date='+$rootScope.DerniereConnexion,
			}).then(function successCallback(response) {
				var lastAlertes = response.data.data;
				if(lastAlertes.length>0 && typeof lastAlertes !="undefined"){
					console.log(lastAlertes);
					
					
					var html = '<md-dialog aria-label="Dernières alertes" style="max-width: 500px;">';
						html += '  <md-toolbar>';
						  html += '  <div class="md-toolbar-tools">';
							html += '  <h2>Depuis votre dernière connexion :</h2>';
						 html += '   </div>';
						html += '  </md-toolbar>';


						html += '  <md-dialog-content class="p-0">';
						html += '    <md-list class="p-0">';
						
						angular.forEach(lastAlertes, function(value,key){
							html += ' <md-list-item class="md-long-text height-120 border-bottom" ng-click="closeDialog('+value.IDAlerte+')">';
								// if(value.CommercialSupprime!=0)
									html += ' <div layout="column" flex>';
										html += ' <div layout="row" flex  layout-align="space-between center">';
											
											html += '<h4 class="font-weight-500 m-0 line-height-24">'+ value.Commercial ;
												if(value.CommercialSupprime!=0)
													html += '<md-tooltip md-direction="left" >Commercial supprimé</md-tooltip>';
											
												switch(value.Type){
													case "Danger": html += '<md-icon class="md-warn mr-16 material-icons-outlined ml-8 s18" >report_problem</md-icon>'; break;
													case "Warning": html += '<md-icon class="amber-500-fg mr-16 material-icons-outlined ml-8 s18" >report_problem</md-icon>'; break;
													case "Info": html += '<md-icon class="md-accent mr-16 material-icons-outlined ml-8 s18" >info</md-icon>'; break;
													case "Success": html += '<md-icon class="green-800-fg mr-16 material-icons-outlined ml-8 s18" >info</md-icon>'; break;
												}
											
												
											html += ' </h4>'; 
											html += '<p class="m-0 line-height-24 blue-grey-300-fg font-size-12" >'+convertDate(value.Date)+'</p>';
									
										html += ' </div>';
								// html += '<div class="md-list-item-text" layout="column">';
								
										html += '  <p class="m-0 line-height-24 blue-grey-700-fg">'+ value.Alerte +'</p>';
									html += ' </div>';
							// html += ' </div>';
									// html += '<md-tooltip md-direction="left" >Commercial supprimé</md-tooltip>';
							// html += ' <md-list-item class="md-2-line md-long-text secondary-button-padding" >';
							/* 
							switch(value.Type){
								case "Danger": html += '<md-icon class="md-warn mr-16 material-icons-outlined" >report_problem</md-icon>'; break;
								case "Warning": html += '<md-icon class="amber-500-fg mr-16 material-icons-outlined" >report_problem</md-icon>'; break;
								case "Info": html += '<md-icon class="md-accent mr-16 material-icons-outlined" >info</md-icon>'; break;
								case "Success": html += '<md-icon class="green-800-fg mr-16 material-icons-outlined" >info</md-icon>'; break;
							}
							
							html += '<div class="md-list-item-text" layout="column">';
							
								html += '  <h4>'+ value.Alerte +'</h4>';
								
								if(value.CommercialSupprime!=0)
									html += '<md-tooltip md-direction="left" >Commercial supprimé</md-tooltip>';
									html += '<p class="" >Pour '+ value.Commercial +' - '+convertDate(value.Date)+'</p>';
								
								
							html += ' </div>';
								html += ' <md-button class="md-secondary" ng-click="closeDialog('+value.IDAlerte+')">Détails</md-button>'; */
							html += ' </md-list-item>';
							' </md-list-item>';
						});
						
						html += '	</md-list>';						
						html += '  </md-dialog-content>';
						html += '  <md-dialog-actions>';
						html += '    <md-button ng-click="closeDialog(\'\')" class="md-primary">';
						html += '      Fermer';
						html += '    </md-button>';
						html += '  </md-dialog-actions>';
						html += '</md-dialog>';
						   
			
					$mdDialog.show({
						parent: angular.element(document.body),
						clickOutsideToClose:true,
						template: html,
						fullscreen: true,
						controller: DialogController
					  });
						
					  function DialogController($scope, $mdDialog) {
						$scope.closeDialog = function(id) {
						  $mdDialog.hide();
						  if(id!="")
							$state.go ('app.analyse_notifications', {'IDAlerte':id});
						};
					};
					
					function convertDate(inputFormat) {
						function pad(s) { return (s < 10) ? '0' + s : s; }
						var d = new Date(inputFormat);
						return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
					}
				}
			});
		}
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_forgot-password', {
            url      : '/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_forgot-password': {
                    templateUrl: 'app/main/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($scope, $http, $location, $rootScope, $mdDialog)
    {
		var vm = this;
		$http.get('/datas/auth/logout.json');
		$rootScope.logIn = false;
		$scope.showSpinner = 0;
		
		$scope.submit = function(){
			$scope.showSpinner = 1;
			$http({
			  method: 'GET',
			  url: '/datas/auth/forgot_password.json',
			  params : vm.form
			}).then(function successCallback(response) {
				if(response.data.error){
					$scope.forgotPasswordForm.email.$setValidity("loginFailed", false);
					$scope.status = response.data.error.message;
					$scope.showSpinner = 0;
				}
				else{
					$scope.showSpinner = 0;
					$scope.forgotPasswordForm.email.$setValidity("loginFailed", true);
					$mdDialog
					  .show($mdDialog
						.alert()
						.title('Nous vous avons envoyé un e-mail !')
						.textContent('Il contient votre nouveau mot de passe temporaire.')
						.ok('Me connecter maintenant')
					  )
					  .then(function() {
						$location.path('/auth/login');
					  });
				}
			}, function errorCallback(response) {
				console.log('error');
			});
		}
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.analyse.resume',
            [
              'nvd3','ngMap'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.analyse_resume', {
                url      : '/accueil',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/analyse/resume/resume.html',
                        controller : 'ResumeController as vm',
						 requiresAuthentication: true,
                    }
                },
                resolve  : {
                
					Contacts: function (msApi)
					{
						return msApi.resolve('contacts.contacts@get');
					},
                    Resume: function (msApi)
                    {
                        return msApi.resolve('analyse.resume@get');
                    },
					employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.simpleListe@get');
                    },
                    Statistiques: function (msApi)
                    {
                        return msApi.resolve('commandes.statistiques@get');
                    },
					Fabricants: function (msApi)
					{
						return msApi.resolve('commandes.fabricants@get');
					},
                    Employes: function (msApi)
                    {
                        return msApi.resolve('analyse.Employes@get', {'date':'A' + new Date().getFullYear()});
                    }/*,
                    Ventes: function (msApi)
                    {
                        return msApi.resolve('employes.ventes@get');
                    }*/
                },
                bodyClass: 'resume'
            });

	
				
        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
        msApiProvider.register('commandes.statistiques', ['datas/analyse/getStatistiques.json']);
        msApiProvider.register('analyse.Employes', ['datas/analyse/getEmployesDates.json']);
        msApiProvider.register('analyse.resume', ['datas/analyse/getResumeStatistiques.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
        msApiProvider.register('contacts.contacts', ['datas/contacts/getAll.json']);
        // msApiProvider.register('employes.ventes', ['datas/analyse/getVentes.json']);
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.analyse.resume')
		.directive('compile', ['$compile', function ($compile) {
		  return function(scope, element, attrs) {
			  scope.$watch(
				function(scope) {
				  return scope.$eval(attrs.compile);
				},
				function(value) {
				  element.html(value);
				  $compile(element.contents())(scope);
				}
			  )};
		}])
        .controller('ResumeController', ResumeController);

    /** @ngInject */
    function ResumeController($scope, $document, employesSimple, Fabricants, $state, $mdToast, $http, $location, $mdDialog, Statistiques, Contacts, Resume, Employes, NgMap, $rootScope,$timeout)
    {
		var vm = this;
		
		vm.dynMarkers = [];
		var infowindow;
		const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
		  "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"
		];


		vm.statistiques = Statistiques.data;
		vm.contacts = Contacts.data;
		vm.resume = Resume.data;
		vm.employes = Employes.data;
		vm.currentRange = 'A' + new Date().getFullYear();
		vm.year = new Date().getFullYear();
		vm.contact = "";
		vm.currentEmployesDatas = {"IDEmploye":""}; 
		vm.currentEmployes = "Tout le monde";
		vm.showDetailVisible = false;
		vm.monthDetail = "";
		vm.monthNumber = "";
		
		
		vm.closeDetails = function(month){
			vm.showDetailVisible = false;
			renderColor();
		}
		

		vm.changeMonth = function(month){
			$http.get("datas/analyse/getDetailMonth.json?IDEmploye=" + vm.currentEmployesDatas.IDEmploye + "&date="+ vm.statistiques.config.currentRange.replace('A','') +"&month="+month)
			.then(function (response, status, headers, config) {
				renderColor();
				// for(var i=0; i<12; i++)
					// d3.select('.nv-series-0 .nv-bar:nth-child('+ (i + 1) +')').style('fill','#90caf9');
				if( month !=""){
					d3.select('.nv-series-0 .nv-bar:nth-child('+ (month) +')').style('fill','#ef5350');
					
					vm.showDetailVisible = true;
						vm.showDetail = response.data.data;	; 
						vm.monthNumber = month;
						vm.monthDetail = monthNames[month-1];	; 	
				}
			}, function () {});	
		}
		
		vm.openContactDialog = function (contact)
		{
			var contactObj = {IDContact:contact};
			$mdDialog.show({
				controller         : 'profilContactController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/contacts/profil/profil-dialog.html',
				parent             : angular.element(".commandes"),
				clickOutsideToClose: true,
				multiple:true,
				fullscreen:true,
				openFrom  : '#previewContact',
				closeTo  : '#previewContact',
				locals             : {
					Contact: contactObj,
					Fabricants: Fabricants,
					employesSimple: employesSimple,
					Structures: {},
					APE: {},
					Activites: {},
					Commandes: {},
					Alertes: {},
					Courriers: {},
					Employes: {},
					Dialog:1
				}
			});
		}
		
		vm.changeEmploye = function(employe){			
			if(employe=="all"){
				$http.get("datas/analyse/getStatistiques.json")
				.then(function (response, status, headers, config) {
					var config = vm.statistiques.config;
					vm.statistiques = response.data.data;
					vm.statistiques.config = config;			
					vm.statistiques.config.changeRange(vm.statistiques.config.currentRange)					
				}, function () {});	
				$http.get("datas/analyse/getResumeStatistiques.json")
				.then(function (response, status, headers, config) {
					vm.resume = response.data.data;				
				}, function () {});					
				vm.currentEmployes = "Tout le monde";
				vm.currentEmployesDatas = {"IDEmploye":""};
			}
			else{
				$http.get("datas/analyse/getStatistiques.json?IDEmploye=" + employe.IDEmploye)
				.then(function (response, status, headers, config) {
					var config = vm.statistiques.config;
					vm.statistiques = response.data.data;
					vm.statistiques.config = config;		
					vm.statistiques.config.changeRange(vm.statistiques.config.currentRange)
				}, function () {});	
				$http.get("datas/analyse/getResumeStatistiques.json?IDEmploye=" + employe.IDEmploye + "&date="+ vm.statistiques.config.currentRange)
				.then(function (response, status, headers, config) {
					vm.resume = response.data.data;				
				}, function () {});			
				vm.currentEmployes = employe.Prenom +' '+ employe.Nom+ ' <small>(' +employe.Permission+')</small>';
				vm.currentEmployesDatas = employe;
			}
			
			if(vm.showDetail!=false)
				vm.changeMonth(vm.monthNumber);
			
		};
		
		function renderColor(){
			 var month = new Date().getMonth();
			var year = new Date().getFullYear();
			for(var i=0; i<12; i++){
				if(vm.statistiques.config.currentCourbe == 'chartFactures'){
					d3.select('.nv-series-0 .nv-bar:nth-child('+ (i + 1) +')') .append('defs')
					  .append('pattern')
						.attr('id', 'pattern'+i)
						.attr('patternUnits', 'userSpaceOnUse')
						.attr('width', 4)
						.attr('height', 4)
					  .append('path')
						.attr('d', 'M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2')
						.attr('stroke', '#000000')
						.attr('stroke-width', 1);
					
					if((i>month && year == vm.statistiques.config.currentRange.replace('A','')) || year < vm.statistiques.config.currentRange.replace('A',''))
						d3.select('.nv-series-0 .nv-bar:nth-child('+ (i+1) +')').style('fill', "url(#pattern"+(i)+")");
					else
						 d3.select('.nv-series-0 .nv-bar:nth-child('+ (i + 1) +')').style('fill','#90caf9');
				}
				else d3.select('.nv-series-0 .nv-bar:nth-child('+ (i + 1) +')').style('fill','#90caf9');
			}	
		}
		
		vm.DetailsCommande = function(ev, IDCommande, Commande){
			$mdDialog.show({
                parent             : angular.element(document.body),
                targetEvent        : ev,
				multiple:true,
                controller         : 'CommandesDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/commandes/commandes/dialogs/details-dialog.html',
                clickOutsideToClose: true,
                locals             : {
                    IDCommande : IDCommande,
					Fabricants : Fabricants,
					paramVM : {}
                },
            }).then(function(result) {
				if(result)
					vm.dtInstance.reloadData();
			}, function () {
				if(vm.reload){
					vm.dtInstance.reloadData();
					vm.reload = false;
				}
			});
		}
		
		
		vm.statistiques.config = {
			chart  : {
				config : {
					refreshDataOnly: true,
					deepWatchData  : true
				},
				options: {
					chart: {
						type: 'discreteBarChart',
						height: 250,
						margin : {
							top: 40,
							right: 6,
							bottom: 20,
							left: 6
						},
						// yDomain: [0, 50000],
						stacked: true,
						showValues: true,
						isArea                 : true,
						interpolate            : 'cardinal',
						clipEdge               : false,
						duration               : 800,
						showXAxis              : true,
						showYAxis              : false,
						showLegend             : false,
						color                  : ['#90caf9'],
						// color                  : ['#90caf9', "#80cbc4"],
						tooltip: {
							enabled: false
						},
						x: function(d){return d.label;},
						y: function(d){return d.value + (1e-10);},
						valueFormat: function(d){
							return d.toLocaleString()+ ' €';
						},
						xAxis                  : {
							tickFormat: function (d)
							{
								return vm.statistiques.config.month[d-1];
							}
						},
						discretebar: {
						// multibar: {
						  dispatch: {
							elementClick: function(e) {
								// for(var i=0; i<12; i++)
									// d3.select('.nv-series-0 .nv-bar:nth-child('+ (i + 1) +')').style('fill','#90caf9');
								renderColor();
								d3.select('.nv-series-0 .nv-bar:nth-child('+ (e.index + 1) +')').style('fill','#ef5350');
								
								$scope.$apply(function(){
									vm.changeMonth(e.data.label);
								});				
							},
							renderEnd : function(e){
								renderColor();
							}
						  }
						}
						
						
					}
				},
				data   : []
            },
            month        : ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sept', 'Oct', 'Nov', 'Déc'],
            currentRange: '',
            currentCourbe: 'chartFactures',
			
			changeRange : function (range)
            {
				vm.statistiques.config.currentRange = range;
				
				$http.get("datas/analyse/getEmployesDates.json?date="+ range)
				.then(function (response, status, headers, config) {
					vm.employes = response.data.data;				
				}, function () {});		
				
				
				$http.get("datas/analyse/getResumeStatistiques.json?IDEmploye=" + vm.currentEmployesDatas.IDEmploye + "&date="+ range)
				.then(function (response, status, headers, config) {
					vm.resume = response.data.data;				
				}, function () {});
				
				if(vm.showDetail!=false)
					vm.changeMonth(vm.monthNumber);
				
				if(vm.statistiques.resume){
					// console.log(vm.statistiques.config.chart.options.chart.type);
					if( typeof vm.statistiques.config.chart.data[0].values == "undefined"){
						vm.statistiques.config.chart.data[0] = {
							key   : vm.statistiques.resume[vm.statistiques.config.currentCourbe].key,
							values: vm.statistiques.resume[vm.statistiques.config.currentCourbe].values[range]
						};
						if(vm.statistiques.config.currentCourbe == "chartFactures"){
							/* vm.statistiques.config.chart.data[1] = {
								key   : vm.statistiques.resume["chartMarges"].key,
								values: vm.statistiques.resume["chartMarges"].values[range]
							}; */
							// vm.statistiques.config.chart.options.chart.type = "multiBarChart";
						}
						else{
							// vm.statistiques.config.chart.options.chart.type = "discreteBarChart";
							// delete vm.statistiques.config.chart.data[1];
						}
					}else{
						for(var i=0; i<12; i++){
							vm.statistiques.config.chart.data[0].values =  vm.statistiques.resume[vm.statistiques.config.currentCourbe].values[range];
						
						}
					}
					// console.log(vm.statistiques.config.currentCourbe);
					
				}
            },
            changeCourbe : function (range)
            {
				vm.statistiques.config.currentCourbe = range;
				
				// console.log(vm.statistiques.resume[range]);
				if(vm.showDetail!=false)
					vm.changeMonth(vm.monthNumber);
				
				if(vm.statistiques.resume){
					if( typeof vm.statistiques.config.chart.data[0] == "undefined"){
						vm.statistiques.config.chart.data[0] = {
							key   : vm.statistiques.resume[range].key,
							values: vm.statistiques.resume[range].values[vm.statistiques.config.currentRange]
						};
						
						if(vm.statistiques.config.currentCourbe == "chartFactures"){
							/* vm.statistiques.config.chart.data[1] = {
								key   : vm.statistiques.resume["chartMarges"].key,
								values: vm.statistiques.resume["chartMarges"].values[range]
							}; */
							// vm.statistiques.config.chart.options.chart.type = "multiBarChart";
						}
						else{
							// vm.statistiques.config.chart.options.chart.type = "discreteBarChart";
							// delete vm.statistiques.config.chart.data[1];
						}
					}
					else{
						vm.statistiques.config.chart.data[0].key = vm.statistiques.resume[range].key;
						for(var i=0; i<12; i++){
							vm.statistiques.config.chart.data[0].values = vm.statistiques.resume[range].values[vm.statistiques.config.currentRange];
							// console.log(typeof vm.statistiques.resume[range].values[vm.statistiques.config.currentRange][i].value);
							if( typeof vm.statistiques.resume[range].values[vm.statistiques.config.currentRange][i].value != "undefined")
								vm.statistiques.config.chart.data[0].values[i].value = vm.statistiques.resume[range].values[vm.statistiques.config.currentRange][i].value;
							else
								vm.statistiques.config.chart.data[0].values[i].value = 0;
						}
					}
					
					
		/* 			$timeout(function() {
								var valueLine = 15000; // Définissez la valeur de votre ligne
            var chart = nv.models.discreteBarChart(); // Créez une instance de votre graphique si nécessaire
						chart.yDomain([0, Math.max(800000, valueLine)]);
           var svg = d3.select('#chart svg');
			var yPos = chart.xAxis.scale()(valueLine); // Utilisez l'échelle Y ajustée pour calculer yPos
console.log(chart.yAxis.scale());
console.log(chart.yAxis.scale().domain()); // Devrait montrer le domaine des données, par exemple [0, 30000]
console.log(chart.yAxis.scale().range());
console.log(yPos);
			svg.append('line')
				.attr('x1', 0)
				.attr('x2', parseInt(svg.style('width')))
				.attr('y1', yPos)
				.attr('y2', yPos)
				.attr('stroke', 'red')
				.attr('stroke-width', 2);
				
							}, 1000);	 */	
					renderColor();
				}
				/* 
				console.log(range);
				console.log(vm.statistiques.config.currentRange);
				console.log(vm.statistiques.resume[range].values);
				console.log(vm.statistiques.config.chart.data[0]); */
            }
			
        };
		vm.statistiques.config.changeCourbe('chartFactures');
		vm.statistiques.config.changeRange('A' + new Date().getFullYear());
		
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.analyse.notifications',[]
        )
        .config(config);

	
    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.analyse_notifications', {
                url      : '/notifications',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/analyse/notifications/notifications.html',
                        controller : 'NotificationsController as vm'
                    }
                },
                resolve  : {
                   employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.simpleListe@get');
                    },
                    Fabricants: function (msApi)
                    {
                        return msApi.resolve('commandes.fabricants@get');
                    },
                },
                bodyClass: 'notifications'
            });

        // Api
        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.analyse.notifications')
        .controller('NotificationsController', NotificationsController)	;

    /** @ngInject */


    function NotificationsController(employesSimple, $mdDialog, Fabricants, $http, $mdToast, $window, DTOptionsBuilder, DTColumnBuilder, $compile, $scope, $location, $document )
    {
		
		/* const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		}); */

        var vm = this;
		vm.recordsTotal = 0;
		vm.search = localStorage.getItem('notificationsSearch');
		
		function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
		}
	
	
		vm.filterSave = [];
        vm.dtInstance = {};
    		
		 vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'datas',
				 url: 'datas/alertes/getAlertes.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				// console.log("load");
				// console.log('DataTablesLogs');
				// console.log(JSON.parse( localStorage.getItem('DataTablesLogs') ));
				localStorage.setItem( 'DataTablesNotif', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
				 /*  $('.scrollable').animate({ ??? GENANT D'APRES COLLABORATEURS
					scrollTop: 0
				  }, 'slow'); */
			})
			.withOption('stateLoadCallback', function (oSettings) {
				var columnLoad = JSON.parse( localStorage.getItem('DataTablesNotif') );
				// console.log(columnLoad.columns);
				// console.log(typeof columnLoad);
				// console.log(columnLoad);
				if( columnLoad != null && columnLoad.columns[3].search.search == "")
					columnLoad.columns[3].search.search = 1;
				return columnLoad;
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('aoSearchCols',   [
			  null,
			  null,
			  null,
			  { "sSearch": "0" },
			  null,
			  null
			])
			.withOption('columnDefs',  [
                /*{
                    // Target the id column
                    targets: 0,
                    responsivePriority: 1,
                },
                {
                    // Target the id column
                    targets: 1,
                    responsivePriority: 2,
                },*/    
                {
                    targets: 0,
                    responsivePriority: 1,
                },   
                {
                    targets: 1,
                    responsivePriority: 2,
                },   
                {
                    targets: 2,
                    responsivePriority: 2,
                },   
                {
                    targets: 3,
                    responsivePriority: 1,
                },   
                {
                    targets: 4,
                    responsivePriority: 1,
                },    
				{
                    targets           : 5,
                    responsivePriority: 0,
                }
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					// Use this headerCompiled field to only compile header once
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
					var api = this.api();
						vm.searchBox = angular.element('body').find('#notifications-search');

					angular.forEach(vm.filterSave, function(value, key) {
						var cpt = key+1;
						if(typeof value.search.search == "string" && value.search.search.includes("~")){
							jQuery('.dataTableNotif tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
							jQuery('.dataTableNotif tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
							
						} else{
							jQuery('.dataTableNotif tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
							jQuery('.dataTableNotif tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
						}
					}); 
				
					if ( vm.searchBox.length > 0 )
					{
						var timeout = null;
						vm.searchBox.on('keyup', function (event)
						{
							clearTimeout(timeout);
							timeout = setTimeout(function () {
								// localStorage.setItem('notificationsSearch', vm.search);
								api.search(vm.search).draw();
							}, 500);
						});
						// if(vm.search != null)
							// vm.searchBox.trigger('keyup');
					}
					
					/* if(vm.filterStatus == null || vm.filterStatus == "all"){
						api.column(4).search('', true, false, false ).draw();
					}
					else
						api.column(4).search(vm.filterStatus, true, false, false ).draw();
					 */
					vm.recordsTotal = json.recordsTotal;
				}
			)
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('order', [4, 'desc'])
			.withLightColumnFilter({
				  "0": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "1": {
					"html": "select",
					"values": employesSimple.data,
					"regex":true,
					"location": $location
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '0', label: 'Non traitée'}, 
						{value: '1', label: 'Traitée'}, 
					],
					"location": $location,
					"regex":true
				  },
				  "2": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "5": {
					"html": "clear"
				  }
			  });
			  
				
			vm.dtColumns = [
				DTColumnBuilder.newColumn('IDAlerte').withTitle('<div class="table-header"><span class="column-title">N°</div></div>').withOption('width', '70px'),
				DTColumnBuilder.newColumn('IDEmploye').withTitle('<div class="table-header"><span class="column-title">Employé</div></div>').withOption('width', '170px').renderWith(function(data, type, full){
					var html = '';
					if(full.CommercialSupprime!=0)
						html += '<md-tooltip md-direction="left" >Commercial supprimé</md-tooltip>';
					html += '<span class="" >'+ full.Commercial +'</span>';
					return html;
				}),
				DTColumnBuilder.newColumn('Alerte').withTitle('<div class="table-header"><span class="column-title">Alerte</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
					if ( type === 'display' ){
						var html ='<div class="flexbox-parent"><div layout="row"  layout-align="start center" >';
							switch(full.Type){
								case "Danger": html += '<md-icon flex="2" class="red-900-fg mr-16 hide-xs material-icons-outlined" >report_problem</md-icon>'; break;
								case "Warning": html += '<md-icon flex="2" class="orange-500-fg mr-16 hide-xs material-icons-outlined" >report_problem</md-icon>'; break;
								case "Info": html += '<md-icon flex="2" class="md-accent mr-16 hide-xs material-icons-outlined" >info</md-icon>'; break;
								case "Success": html += '<md-icon flex="2" class="green-800-fg mr-16 hide-xs material-icons-outlined" >info</md-icon>'; break;
							}
                       return html + '<p flex>'+data+'</p>' + '</div></div>';
					}
					return data;
					
				}),
				DTColumnBuilder.newColumn('Traite').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '150px').renderWith(function(data, type, full){
					if ( type === 'display' ){
						var html ="";
						console.log(full.DateTraitement);
							if(data)
								 return'<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-green-bg white-fg"  style="text-transform:capitalize; display:inline-block ">Traitée <br><small>'+ convertDate(full.DateTraitement) +'</small></span>'; 
							else
								return '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-orange-bg white-fg"  style="text-transform:capitalize;display:inline-block ">Non traitée</span> '; 
							
						
                       return html;
					}
					return data;
					
				}),
				DTColumnBuilder.newColumn('Date').withTitle('<div class="table-header"><span class="column-title">Date</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
					return convertDate(data);
				}),
				DTColumnBuilder.newColumn(null).withTitle('').notSortable().withOption('width', '50px').renderWith(function(data, type, full){
					// console.log(JSON.stringify(full).replace("'","\'"));
					return '<md-menu style="float: right;">'+
					'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
							'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
						'</md-button>'+
						'<md-menu-content width="3">'+

							'<md-menu-item> '+
								'<md-button ng-click="vm.Traiternotification($event, '+full.IDAlerte+')" ng-disabled="\''+full.Traite+'\' == 1"> '+
								'	Traiter '+
								'</md-button>'+
							'</md-menu-item>'+
							'<md-divider ></md-divider>'+
							'<md-menu-item> '+
								"<md-button ng-click='vm.Detailsnotification($event, \""+full.IDCommande+"\",\""+full.IDContact+"\")' ng-disabled='!"+full.IDCommande+"'> "+
									'Commande associée'+
								'</md-button>'+
							'</md-menu-item>'+
							'<md-menu-item> '+
								"<md-button ng-click='vm.openContactDialog(\""+full.IDContact+"\")'> "+
									'Fiche contact '+
								'</md-button>'+
							'</md-menu-item>'+
							
						'</md-menu-content>'+
					'</md-menu>';
						
				}),
			];
		
		vm.Detailsnotification = function(ev, IDCommande, IDContact){
			if(IDCommande != 0){
				$mdDialog.show({
					parent             : angular.element(document.body),
					targetEvent        : ev,
					controller         : 'CommandesDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/commandes/commandes/dialogs/details-dialog.html',
					clickOutsideToClose: true,
					locals             : {
						IDCommande : IDCommande,
						Fabricants : Fabricants,
						paramVM : vm
					},
				}).then(function(result) {
					if(result)
						vm.dtInstance.reloadData();
				}, function () {
					if(vm.reload){
						vm.dtInstance.reloadData();
						vm.reload = false;
					}
				});
			}
			else{
				// $window.open("/contacts/profil/"+IDContact, '_blank');
				// vm.openContactDialog(IDContact);
			}
		};
		
		vm.openContactDialog = function (contact)
        {
			var contactObj = {IDContact:contact};
            $mdDialog.show({
                controller         : 'profilContactController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/contacts/profil/profil-dialog.html',
                parent             : angular.element($document.find('body')),
                clickOutsideToClose: true,
				multiple:true,
				fullscreen:true,
				openFrom  : '#previewContact',
				closeTo  : '#previewContact',
                locals             : {
					Contact: contactObj,
					Fabricants: Fabricants,
					employesSimple: employesSimple,
					Structures: {},
					APE: {},
					Activites: {},
					Commandes: {},
					Alertes: {},
					Courriers: {},
					Employes: {},
					Dialog:1
                }
            });
        }
		
		vm.Traiternotification = function(ev, IDAlerte){ 
			$http.post("/datas/alertes/getNotification.json",JSON.stringify({'IDAlerte' : IDAlerte}))
				.then(function (response, status, headers, config) {
					var notification = response.data.data;		
					if(notification.TypeAlerte == "Renouvellement"){
						$mdDialog.show({
							controller: DialogNotificationController,
							templateUrl: 'app/main/analyse/notifications/dialogs/dialog-renouvellement.html',
							parent: angular.element(document.body),
							targetEvent: ev,
							clickOutsideToClose:true,
							locals             : {
								notification : notification
							}
						})
						.then(function(answer) {
							notification = answer;
							$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
							.then(function (response, status, headers, config) {
								notification.Traite = 1; vm.dtInstance.reloadData();
								$mdToast.show(
								  $mdToast.simple()
									.textContent('Notification traitée')
									.position('bottom right' )
									.hideDelay(3000)
								);
							}, function () {});	
						}, function() {
						});
					}
					else if(notification.TypeAlerte == "Bilan"){
						$mdDialog.show({
							controller: DialogNotificationController,
							templateUrl: 'app/main/analyse/notifications/dialogs/dialog-bilan.html',
							parent: angular.element(document.body),
							targetEvent: ev,
							clickOutsideToClose:true,
							locals             : {
								notification : notification
							}
						})
						.then(function(answer) {
							// console.log(notification);
							notification = answer;
							$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
							.then(function (response, status, headers, config) {
								notification.Traite = 1; vm.dtInstance.reloadData();
								$mdToast.show(
								  $mdToast.simple()
									.textContent('Notification traitée')
									.position('bottom right' )
									.hideDelay(3000)
								);
							}, function () {});	
						}, function() {
						});
					}
					else if(notification.TypeAlerte == "Devis"){
						$mdDialog.show({
							controller: DialogNotificationController,
							templateUrl: 'app/main/analyse/notifications/dialogs/dialog-devis.html',
							parent: angular.element(document.body),
							targetEvent: ev,
							clickOutsideToClose:true,
							locals             : {
								notification : notification
							}
						})
						.then(function(answer) {
							// console.log(notification);
							notification = answer;
							$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
							.then(function (response, status, headers, config) {
								notification.Traite = 1; vm.dtInstance.reloadData();
								$mdToast.show(
								  $mdToast.simple()
									.textContent('Notification traitée')
									.position('bottom right' )
									.hideDelay(3000)
								);
							}, function () {});	
						}, function() {
						});
					}
					else{
						$mdDialog.show({
							controller: DialogNotificationController,
							templateUrl: 'app/main/analyse/notifications/dialogs/dialog-default.html',
							parent: angular.element(document.body),
							targetEvent: ev,
							clickOutsideToClose:true,
							locals             : {
								notification : notification
							}
						})
						.then(function(answer) {
							// notification.satus = answer;
							notification = answer;
							$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
							.then(function (response, status, headers, config) {
								notification.Traite = 1; vm.dtInstance.reloadData();
								$mdToast.show(
								  $mdToast.simple()
									.textContent('Notification traitée')
									.position('bottom right' )
									.hideDelay(3000)
								);
							}, function () {});	
						}, function() {
						});
						
					}
				}, function () {});
		};
  
    }
	
	function DialogNotificationController($scope, $mdDialog, notification) {
		$scope.notification = notification;

		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		// $scope.renouvele = function(answer) {
		  // $mdDialog.hide(answer);
		// };
		
		$scope.reponse = function(answer) {
		  $mdDialog.hide(answer);
		};
	  }
	  
})();
(function ()
{
    'use strict';

    angular
        .module('app.analyse.logs',[]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.analyse_logs', {
                url      : '/analyse/logs',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/analyse/logs/logs.html',
                        controller : 'LogsController as vm'
                    }
                },
                resolve  : {
					employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.simpleListe@get');
                    }
                },
                bodyClass: 'logs'
            });
			
        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.analyse.logs')
        .controller('LogsController', LogsController)	;

    /** @ngInject */


    function LogsController(employesSimple, DTColumnBuilder, DTOptionsBuilder, $compile, $scope, $location )
    {
		
	/* 	const formatter = new Intl.NumberFormat('fr-FR', {
			style: 'currency',
			currency: 'EUR',
			minimumFractionDigits:0
		});
 */
        var vm = this;
		
		vm.search = localStorage.getItem('logsSearch');
		// vm.date = new Date();
		vm.recordsTotal = 0;
	
		function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
		}
		
		vm.filterSave = [];
        vm.dtInstance = {};
    		
		
		
		vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'datas',
				 url: 'datas/analyse/getLogs.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('StateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'DataTablesLogs', JSON.stringify(oData) );
			})
			.withOption('stateLoadCallback', function (oSettings) {
				return JSON.parse( localStorage.getItem('DataTablesLogs') );
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('drawCallback', function (o) {
				  $('.scrollable').animate({
					scrollTop: 0
				  }, 'slow');
			})
			
			.withLightColumnFilter({
				  "0": {
					"html": "input",
					"type": "text",
					// "location": $location
				  },
				  "1": {
					"html": "select",
					"values": employesSimple.data,
					// "location": $location,
					"regex":true
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '', label: '--'}, 
						{value: 'danger', label: 'Danger'}, 
						{value: 'warning', label: 'Warning'}, 
						{value: 'info', label: 'Info'}, 
						{value: 'success', label: 'Success'	}
					],
					// "location": $location,
					"regex":true
				  },
				  "2": {
					"html": "input",
					"type": "tel",
					// "location": $location
				  },
				  "4": {
					"html": "range",
					"type": "date",
					// "location": $location
				  }
			  })
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
				var api = this.api();
                vm.searchBox = angular.element('body').find('#logs-search');
				
				angular.forEach(vm.filterSave, function(value, key) {
					var cpt = key+1;
					if(value.search.search.includes("~")){
						jQuery('.dataTableLogs tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
						jQuery('.dataTableLogs tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
						
					} else{
						jQuery('.dataTableLogs tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
						jQuery('.dataTableLogs tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
					}
				}); 
				
				
                if ( vm.searchBox.length > 0 )
                {
					var timeout = null;
                    vm.searchBox.on('keyup', function (event)
                    {
						clearTimeout(timeout);
						timeout = setTimeout(function () {
							api.search(vm.search).draw();
						}, 500);
                    });
                }
				
				vm.recordsTotal = json.recordsTotal;
			  }
			)
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('order', [0, 'desc']);
	
			
			// vm.dtColumns = $scope.test(DTColumnBuilder, Config.data.Column);
		
			

			// vm.dtColumns = Config.data.Column;
			
			vm.dtColumns = [
				DTColumnBuilder.newColumn('IDLog').withTitle('<div class="table-header"><span class="column-title">N°</div></div>').withOption('width', '70px'),
				DTColumnBuilder.newColumn('IDUtilisateur').withTitle('<div class="table-header"><span class="column-title">Employé</div></div>').withOption('width', '170px').renderWith(function(data, type, full){return full.Utilisateur;}),
				DTColumnBuilder.newColumn('Titre').withTitle('<div class="table-header"><span class="column-title">Message</div></div>').withOption('width', 'auto').renderWith(function(data, type, full){
					var html = '<strong class="md-subhead font-weight-600">'+data+'</strong>';
					if(full.Message) 
						html += '<br><span >'+full.Message+'</span>';
					
					return html;
				}),
				DTColumnBuilder.newColumn('Type').withTitle('<div class="table-header"><span class="column-title">Gravité</div></div>').withOption('width', '100px').renderWith(function(data, type, full){
					if ( type === 'display' ){
						var html ="";
							console.log(data);
							switch(data){
								case "danger": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-red-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span>'; break;
								case "success": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-green-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
								case "warning": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-orange-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
								case "info": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-blue-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
								case "Danger": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-red-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span>'; break;
								case "Success": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-green-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
								case "Warning": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-orange-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
								case "Info": html = '<span class="p-5 pr-16 pl-16 brad-16 font-size-12  md-blue-bg white-fg" selected="true" style="text-transform:capitalize "><span>'+data+'</span></span> '; break;
							}
                       return html;
					}
					return data;
					
				}),
				DTColumnBuilder.newColumn('Date').withTitle('<div class="table-header"><span class="column-title">Date</div></div>').withOption('width', '130px').renderWith(function(data, type, full){
					return convertDate(data);
				}),
				
			];
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.analyse.map',['ngMap']
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.analyse_map', {
                url      : '/analyse/map',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/analyse/map/map.html',
                        controller : 'MapController as vm',
						 requiresAuthentication: true,
                    }
                },
                resolve  : {
                
					Structures    : function (msApi)
					{
						return msApi.resolve('profilContact.structures@get');
					},
					employesSimple: function (msApi)
                    {
                        return msApi.resolve('employes.simpleListe@get');
                    },
					APE    : function (msApi)
					{
						return msApi.resolve('profilContact.APE@get');
					},
					Activites    : function (msApi)
					{
						return msApi.resolve('profilContact.Activites@get');
					},
					Employes: function (msApi)
					{
						return msApi.resolve('commandes.Employes@get');
					},
					Fabricants: function (msApi)
					{
						return msApi.resolve('commandes.fabricants@get');
					},
					Contacts: function (msApi)
					{
						return msApi.resolve('contacts.contacts@get', {'map': true});
					}
                },
                bodyClass: 'map'
            });


        msApiProvider.register('employes.simpleListe', ['datas/employes/simpleListe.json']);
        msApiProvider.register('profilContact.structures', ['/datas/contacts/getStructures.json']);
        msApiProvider.register('contacts.contacts', ['datas/contacts/getAll.json']);
        msApiProvider.register('profilContact.APE', ['/datas/contacts/getAPE.json']);
        msApiProvider.register('commandes.fabricants', ['datas/commandes/getAllFabricants.json']);
        msApiProvider.register('profilContact.Activites', ['/datas/contacts/getActivites.json']);
        msApiProvider.register('commandes.Employes', ['datas/employes/getEmployes.json']);
       
    }
})();
(function () {
    'use strict';

    angular
        .module('app.analyse.map')
        .controller('MapController', MapController);

    /** @ngInject */
    function MapController($scope, Structures, employesSimple , APE, Fabricants, Activites, Employes, $document, $state, $mdToast, $http, $location, $mdDialog, Contacts, NgMap){
        var vm = this;

        vm.dynMarkers = [];
        vm.contacts = Contacts.data; // Tous les contacts
        vm.filter = ["Client", "Prospect", "Suspect"];
        vm.search = '';
        vm.map = null;
        vm.defaultPosition = { lat: 48.0812766, lng: 7.3898303 }; // Position par défaut
		
        // Chargement initial des marqueurs
        NgMap.getMap().then(function (map) {
            vm.map = map;
			vm.map.setCenter(vm.defaultPosition);
			vm.initializeMap();
            vm.updateMarkers(); // Charge les marqueurs initiaux
        }).catch(function (error) {
            console.error('Erreur lors de la récupération de la carte :', error);
        });

        // Filtre si un status est actif ou non
        vm.is = function (status) {
            return vm.filter.indexOf(status) !== -1;
        };

		vm.initializeMap = function() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                    var userPosition = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    vm.map.setCenter(userPosition); // Centrer la carte sur la position de l'utilisateur

                    // Ajouter un marqueur à la position de l'utilisateur
                    new google.maps.Marker({
                        position: userPosition,
                        map: vm.map,
                        title: 'Vous êtes ici'
                    });
                }, function() {
                    // En cas d'échec ou si l'utilisateur refuse la géolocalisation
                    vm.map.setCenter(vm.defaultPosition); // Centrer sur la position par défaut
					 new google.maps.Marker({
                        position: vm.defaultPosition,
                        map: vm.map,
                        title: 'Vous êtes ici'
                    });
                });
            } else {
                // Si la géolocalisation n'est pas supportée
                vm.map.setCenter(vm.defaultPosition); // Centrer sur la position par défaut
				new google.maps.Marker({
                        position: vm.defaultPosition,
                        map: vm.map,
                        title: 'Vous êtes ici'
                    });
            }
        };
		
        // Fonction pour ajouter/enlever les filtres
        vm.checkfilter = function (status) {
            if (vm.is(status)) {
                vm.filter.splice(vm.filter.indexOf(status), 1);
            } else {
                vm.filter.push(status);
            }
            vm.updateMarkers(); // Recharge les marqueurs après modification des filtres
        };

        // Met à jour les marqueurs selon les filtres
        vm.updateMarkers = function () {
            // Supprimer tous les anciens marqueurs
            vm.clearMarkers();
            var matchingContacts = [];
            // Filtrer les contacts selon les filtres appliqués
            for (var i = 0; i < vm.contacts.length; i++) {
                var contact = vm.contacts[i];

                // Vérification des conditions : filtre actif + recherche textuelle
                if (vm.is(contact.Status) && (vm.search === '' || contact.RaisonSocial.toLowerCase().includes(vm.search.toLowerCase()))) {
                    var latitude = parseFloat(contact.Latitude);
                    var longitude = parseFloat(contact.Longitude);

                    // Vérifier si les coordonnées sont valides
                    if (!isNaN(latitude) && !isNaN(longitude)) {
						matchingContacts.push(contact); // Ajouter le contact correspondant à la recherche
                        console.log([latitude, longitude]);

                        // Vérifier si la carte est bien initialisée
                        if (vm.map) {
                            var marker = new google.maps.Marker({
                                position: new google.maps.LatLng(latitude, longitude),
                                map: vm.map,
                                title: contact.RaisonSocial
                            });

                            // Ajouter l'événement de clic sur le marqueur pour afficher l'infowindow
                            google.maps.event.addListener(marker, 'click', (function(marker, contact) {
                                return function() {
                                    vm.showInfoWindow(marker, contact);
                                };
                            })(marker, contact));

                            vm.dynMarkers.push(marker);
                        } else {
                            console.warn('La carte n\'est pas encore prête.');
                        }
                    } else {
                        console.warn('Coordonnées invalides pour le contact :', contact.RaisonSocial);
                    }
                }
            }
			  vm.centerMapOnResults(matchingContacts);
			  
        };

        // Fonction pour supprimer tous les anciens marqueurs
        vm.clearMarkers = function () {
            for (var i = 0; i < vm.dynMarkers.length; i++) {
                vm.dynMarkers[i].setMap(null); // Retirer chaque marqueur de la carte
            }
            vm.dynMarkers = []; // Réinitialiser la liste des marqueurs
        };

		vm.centerMapOnResults = function(contacts) {
            if (contacts.length === 1) {
                // S'il y a un seul contact, centrer directement sur ses coordonnées
                var latitude = parseFloat(contacts[0].Latitude);
                var longitude = parseFloat(contacts[0].Longitude);
                if (!isNaN(latitude) && !isNaN(longitude)) {
                    vm.map.setCenter(new google.maps.LatLng(latitude, longitude));
                    vm.map.setZoom(12); // Zoomer sur le résultat unique
                }
            } else if (contacts.length > 1) {
                // S'il y a plusieurs contacts, ajuster les limites pour tous les inclure
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < contacts.length; i++) {
                    var latLng = new google.maps.LatLng(parseFloat(contacts[i].Latitude), parseFloat(contacts[i].Longitude));
                    bounds.extend(latLng);
                }
                vm.map.fitBounds(bounds); // Ajuster la carte pour inclure tous les résultats
            }
        };
		
        // Affiche la fenêtre d'information pour un marqueur
      // Affiche la fenêtre d'information pour un marqueur
		vm.showInfoWindow = function (marker, contact) {
			var htmlContent = '<div id="siteNotice"></div>' +
				'<h3 id="firstHeading" class="firstHeading">' +
				'<a class="btn-info" style="cursor:pointer" data-id="' + contact.IDContact + '">' +
				contact.RaisonSocial + '</a></h3>' +
				'<div id="bodyContent">' +
				'<p>' + contact.AdresseComplete.replace(/,/g, '<br>') + '</p>' +
				'<p>Tél. : <a href="tel:' + contact.Telephone + '">' + contact.Telephone + '</a></p>' +
				'<p><a href="https://www.google.com/maps/search/' + encodeURIComponent(contact.RaisonSocial) + '+' + encodeURIComponent(contact.AdresseComplete) + '/@' + contact.Latitude + ',' + contact.Longitude + ',z=13" target="_blank">Voir sur Google Maps</a></p>' +
				'</div>';

			var infowindow = new google.maps.InfoWindow({
				content: htmlContent
			});

			infowindow.open(vm.map, marker);
		};


        // Ouvre la fenêtre de dialogue personnalisé au clic sur le nom du client
        jQuery(document).on('click','.btn-info',function(){
			var IDContact = $(this).data('id');
			var contact = null;
			
			angular.forEach(vm.contacts,function(v){
				if(v.IDContact == IDContact) 
					contact = v;
			});
			
			$mdDialog.show({
                controller         : 'profilContactController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/contacts/profil/profil-dialog.html',
                parent             : angular.element($document.find('body')),
                clickOutsideToClose: true,
				multiple:true,
				fullscreen:true,
				openFrom  : '#previewContact',
				closeTo  : '#previewContact',
                locals             : {
					Contact: contact,
					Structures: Structures,
					employesSimple : employesSimple,
					APE: APE,
					Activites: Activites,
					Fabricants: Fabricants,
					Commandes: {},
					Courriers: {},
					Alertes: {},
					Employes: Employes,
					Dialog:1
                }
            });
		});
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.analyse.emailstracking')
        .controller('emailsTrackingController', emailsTrackingController);
		 
    /** @ngInject */
    function emailsTrackingController(employesSimple, $mdDialog, $http, $mdToast, $window, $rootScope, DTOptionsBuilder, DTColumnBuilder, $compile, $scope, $location  )
    {
        var vm = this;


		const formatter = new Intl.NumberFormat('fr-FR', {
		  style: 'currency',
		  currency: 'EUR',
		  minimumFractionDigits:0
		});
		
		vm.recordsTotal = 0;
		vm.search = localStorage.getItem('emailstrackingSearch');
		
			
		function convertDate(inputFormat, hour, day) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			if(hour)
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
			else
				return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/');
		}
	
	
	/* 
		$scope.selected = [];
		
		$scope.toggle = function (item, list) {
			var idx = list.indexOf(item);
			if (idx > -1) {
			  list.splice(idx, 1);
			}
			else {
			  list.push(item);
			}
		};
		
		$scope.exists = function (item, list) {
			return list.indexOf(item) > -1;
		};
		
		$scope.isIndeterminate = function() {
			return ($scope.selected.length !== 0 &&
				$scope.selected.length !== $('.dataTable md-checkbox').length - 1);
		};
		
		$scope.isChecked = function() {
			return $scope.selected.length === $('.dataTable md-checkbox').length - 1;
		};
		
		$scope.toggleAll = function() {
			if ($scope.selected.length === $('.dataTable md-checkbox').length - 1) {
				$scope.selected = [];
			} else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
				$scope.selected = [];
				$('.dataTable md-checkbox').each(function(k, v){
					if(typeof $(v).attr('data-val') != "undefined")
						$scope.selected.push(parseInt($(v).attr('data-val')));
				});
			}
		}; */
/* 
	
		vm.exportConges = function (ev, type)
        {
			$window.open("/datas/employes/exportConges.json?type="+type+'&selected='+$scope.selected, '_blank');
        } */
		
		vm.editEmailTrack = function (ev, IDEmploye_Emails_Tracking){
			$http.get("/datas/analyse/getEmailTrack.json?IDEmploye_Emails_Tracking="+IDEmploye_Emails_Tracking)
			.then(function (response, status, headers, config) {
				$mdDialog.show({
					controller         : 'emailsTrackingDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/analyse/emails_tracking/dialogs/emails_tracking-dialog.html',
					parent             : angular.element(document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						// Conge : "",
						Tracking : response.data.data
					}
				}).then(function (response)
				{
					if(typeof response != "undefined"){
						vm.dtInstance.reloadData();
						
						if(response.data.error){
						}
						else
						if(typeof IDEmploye_Emails_Tracking!="undefined")
							$mdToast.show(
							  $mdToast.simple()
								.textContent("Votre tracking a été modifié !")
								.position('bottom right' )
								.hideDelay(3000)
							);
						else
						$mdToast.show(
						  $mdToast.simple()
							.textContent("Votre tracking a été créé !")
							.position('bottom right' )
							.hideDelay(3000)
						);
					} 
				});
			}, function () {});
		}
		
		
		vm.deleteTracking = function (ev, IDEmploye_Emails_Tracking, Email)
        {
		 	var trackingObj = {IDEmploye_Emails_Tracking:IDEmploye_Emails_Tracking};
			
            var confirm = $mdDialog.confirm()
                .title('Voulez-vous vraiment supprimer ce tracking ?')
                .htmlContent('Le tracking de l\'email <b>' + Email + '</b>' + ' va être supprimé.')
                .ariaLabel('Supprimer le tracking')
                .targetEvent(ev)
                .theme('md-warn')
                .ok('Supprimer')
                .cancel('Annuler');

            $mdDialog.show(confirm).then(function ()
            {

				$http.post("/datas/analyse/deleteEmailsTrack.json", JSON.stringify(trackingObj)).then(function (response, status, headers, config) {  
					vm.dtInstance.reloadData();
					$mdToast.show(
					  $mdToast.simple()
						.textContent('Le tracking a été supprimé.')
						.position('bottom right' )
						.hideDelay(3000)
					);
					vm.dtInstance.reloadData();
				}, function () {});
				
            }, function () {});
        }
		
		vm.filterSave = [];
        vm.dtInstance = {};
    		
		 vm.dtOptions = DTOptionsBuilder.newOptions()
			.withOption('ajax', {
				 dataSrc: 'datas',
				 url: 'datas/analyse/getEmailsTrack.json',
				 type: 'GET'
			})
			.withDataProp('data')
			.withOption('processing', true)
			.withOption('serverSide', true)
			.withOption('bStateSave', true)
			.withOption('iCookieDuration', 60*60*12)
			.withOption('stateSaveCallback', function (oSettings, oData) {
				localStorage.setItem( 'dataTableEmailsTracking', JSON.stringify(oData) );
			})
			.withOption('drawCallback', function (o) {
				  $('.scrollable').animate({
					scrollTop: 0
				  }, 'slow');
			})
			.withOption('stateLoadCallback', function (oSettings) {
				var columnLoad = JSON.parse( localStorage.getItem('dataTableEmailsTracking') );
				// if( columnLoad != null && columnLoad.columns[3].search.search == "")
					// columnLoad.columns[3].search.search = 1;
				return columnLoad;
			})
			.withOption('stateLoadParams', function( settings, data ) {
				vm.search= data.search.search;
				vm.filterSave = data.columns;
			})
			.withOption('aoSearchCols',   [
			  null,
			  null,
			  null,
			  null,
			  // { "sSearch": "0" },
			  null,
			  null
			])
			.withOption('columnDefs',  [
				{
                    // Target the price column
                    targets: 4,
					"type": "num-fmt",
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return formatter.format(data);
                        }

                        return data;
                    }
                },
				
                {
                    targets: 0,
                    responsivePriority: 0,
                },   
                {
                    targets: 1,
                    responsivePriority: 2,
                },   
                {
                    targets: 2,
                    responsivePriority: 2,
                },   
                {
                    targets: 3,
                    responsivePriority: 1,
                },   
                {
                    targets: 4,
                    responsivePriority: 1,
                },    
				{
                    targets           : 5,
                    responsivePriority: 1,
                },    
				{
                    targets           : 7,
                    responsivePriority: 0,
                }
            ])
			.withOption('responsive', {
				details: {
					display: $.fn.dataTable.Responsive.display.childRowImmediate,
					type: 'none',
					target: ''
				}
			})
			.withOption('pagingType', 'simple')
			.withOption('lengthMenu', [50, 100, 250])
			.withPaginationType('simple')
			.withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
			.withOption('createdRow', function(row, data, dataIndex) {
				$compile(angular.element(row).contents())($scope);
			})
			.withOption('headerCallback', function(header) {
				if (!vm.headerCompiled) {
					vm.headerCompiled = true;
					$compile(angular.element(header).contents())($scope);
				}
			})
			.withOption('initComplete', function(settings, json) {
					var api = this.api();
						vm.searchBox = angular.element('body').find('#colabconges-search');

					angular.forEach(vm.filterSave, function(value, key) {
						var cpt = key+1;
						if(typeof value.search.search == "string" && value.search.search.includes("~")){
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(1)').val(value.search.search.split("~")[0]);
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input:nth-child(2)').val(value.search.search.split("~")[1]);
							
						} else{
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') input').val(value.search.search);
							jQuery('.dataTable tr:nth-child(2) th:nth-child('+cpt+') select').val(value.search.search);
						}
					}); 
				
					if ( vm.searchBox.length > 0 )
					{
						var timeout = null;
						vm.searchBox.on('keyup', function (event)
						{
							clearTimeout(timeout);
							timeout = setTimeout(function () {
								api.search(vm.search).draw();
							}, 500);
						});
					}
					
					vm.recordsTotal = json.recordsTotal;
				}
			)
			.withLightColumnFilter({
				/*   "1": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "2": {
					"html": "select",
					"values": [{'value':"", 'label':"--"}].concat(employesSimple.data),
					// "location": $location,
					"regex":true
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '', label: '--'},  
						{value: 'Congés payés', label: 'Congés payés'}, 
						{value: 'Congés sans solde', label: 'Congés sans solde'}, 
						{value: 'Maladie ou à l’accident non professionnel', label: 'Maladie ou à l’accident non professionnel'}, 
						{value: 'Accident ou maladie professionnelle', label: 'Accident ou maladie professionnelle'}, 
						{value: 'Compte Epargne Temps', label: 'Compte Epargne Temps'}, 
						{value: "Congés d'ancienneté", label: "Congés d'ancienneté"}, 
						{value: "Congés d'adoption", label: "Congés d'adoption"}, 
						{value: "Congés de proche aidant", label: "Congés de proche aidant"}, 
						{value: "Congés de solidarité familiale", label: "Congés de solidarité familiale"}, 
						{value: "Congés liées à la maternité ou à l’adoption", label: "Congés à la maternité ou à l'adoption"}, 
						{value: "Congés maternité", label: "Congés maternité"}, 
						{value: "Congés parental d'éducation", label: "Congés parental d'éducation"}, 
						{value: "Congés paternité", label: "Congés paternité"}, 
						{value: "Congés pour enfant malade", label: "Congés pour enfant malade"}, 
						{value: "Congés pour évènements familiaux", label: "Congés pour évènements familiaux"}, 
						{value: "Congés sabbatiques", label: "Congés sabbatiques"}, 
						// {value: "Déplacement", label: "Déplacement"}, 
						// {value: "Formation", label: "Formation"}, 
						// {value: "Jours de fractionnement", label: "Jours de fractionnement"}, 
						{value: "Récupération", label: "Récupération"}, 
						{value: "Repos compensateur", label: "Repos compensateur"}, 
					],
					"location": $location,
				  "regex":true},
				
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "5": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "6": {
					"html": "range",
					"type": "number",
					"location": $location
				  },
				  "7": {
					"html": "input",
					"type": "text",
					// "location": $location
				  },
				  "8": {
					"html": "select",
					"values": [
						{value: '', label: '--'}, 
						{value: 'A valider', label: 'A renouveler'}, 
						{value: 'Validés', label: 'Renouvelée'}, 
						{value: 'Refusés', label: 'Non renouvelée'}, 
					],
					"location": $location,
				  "regex":true},
				  "9": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "10": {
					"html": "clear"
				  }
				   */
				  
			  })
			.withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
			  'processing':'test',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
			.withOption('order', [1, 'desc']);
			// .withLightColumnFilter({
			/* 	  "0": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "1": {
					"html": "select",
					"values": employesSimple.data,
					"regex":true,
					"location": $location
				  },
				  "3": {
					"html": "select",
					"values": [
						{value: '0', label: 'Non traitée'}, 
						{value: '1', label: 'Traitée'}, 
					],
					"location": $location,
					"regex":true
				  },
				  "2": {
					"html": "input",
					"type": "text",
					"location": $location
				  },
				  "4": {
					"html": "range",
					"type": "date",
					"location": $location
				  },
				  "5": {
					"html": "clear"
				  } */
			// });
			  


		vm.dtColumns = [
		
		
		// IDEmploye_Emails_Tracking	Imap	User	Email	Pass	Port	DateCreation	DateModification	DernierTracking	Actif	Erreur
			DTColumnBuilder.newColumn('Email').withTitle('<div class="table-header"><span class="column-title">E-mail</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('User').withTitle('<div class="table-header"><span class="column-title">Identifiant</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('Imap').withTitle('<div class="table-header"><span class="column-title">Serveur Imap</div></div>').withOption('width', '70px'),
			// DTColumnBuilder.newColumn('Pass').withTitle('<div class="table-header"><span class="column-title">Pass</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('Port').withTitle('<div class="table-header"><span class="column-title">Port</div></div>').withOption('width', '70px'),
			// DTColumnBuilder.newColumn('DateCreation').withTitle('<div class="table-header"><span class="column-title">DateCreation</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('DateModification').withTitle('<div class="table-header"><span class="column-title">Dernière modification</div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				return convertDate(data, 1)
			}),
			DTColumnBuilder.newColumn('stock').withTitle('<div class="table-header"><span class="column-title">E-mails stockés</div></div>').withOption('width', '70px'),
			DTColumnBuilder.newColumn('DernierTracking').withTitle('<div class="table-header"><span class="column-title">Dernier tracking</div></div>').withOption('width', '70px').renderWith(function(data, type, full){
				if(data == "0000-00-00 00:00:00")
					return "--";
				else
					return convertDate(data, 1)
			}),
			DTColumnBuilder.newColumn('Actif').withTitle('<div class="table-header"><span class="column-title">Etat</div></div>').withOption('width', '150px').renderWith(function(data, type, full){
				if ( type === 'display' ){
					var html ="";
					if(!data)
						html = '<span class="p-5 pr-8 pl-8 brad-16  md-red-bg white-fg" selected="true" style="text-transform:capitalize "><small>Désactivé</small></span>'; 
					else
						html = '<span class="p-5 pr-8 pl-8 brad-16  md-green-bg white-fg" selected="true" style="text-transform:capitalize "><small>Activé</small></span> '; 
					
					if(full.Erreur)
						html += '<span class="p-5 pr-8 pl-8 brad-16  md-red-bg white-fg" selected="true" style="text-transform:capitalize "><small>Erreur connexion</small></span>'; 
					
					   return html;
				}
				return data;
			}),
			DTColumnBuilder.newColumn(null).withTitle('').notSortable().withOption('width', '50px').renderWith(function(data, type, full){
				return '<md-menu style="float: right;">'+
				'<md-button class="md-icon-button"  ng-click="$mdMenu.open($event)">'+
						'<md-icon md-font-icon="icon-dots-vertical"></md-icon>'+
					'</md-button>'+
					'<md-menu-content width="3">'+
				
						'<md-menu-item> '+
							"<md-button ng-click='vm.editEmailTrack($event, \""+full.IDEmploye_Emails_Tracking+"\")' > "+
								'Modifier '+
							'</md-button>'+
						'</md-menu-item>'+
						'<md-menu-item> '+
							"<md-button ng-click='vm.deleteTracking($event, \""+full.IDEmploye_Emails_Tracking+"\",\""+full.Email+"\")' >"+
								'Supprimer '+
							'</md-button>'+
						'</md-menu-item>'+
						
					'</md-menu-content>'+
				'</md-menu>';
					
			}),
			
		];
    }
})();

(function ()
{
    'use strict';
    angular.module('app.achats.factures').controller('FacturesAchatsController', FacturesAchatsController);

    /** @ngInject */
    function FacturesAchatsController(FacturesAchats, nbrFacturesAchatsParEtats, $scope, $rootScope, $http, $q, $mdDialog, $mdToast, $mdSidenav, $window, $location, $compile, $timeout, DTOptionsBuilder, DTColumnBuilder)
    {
        var vm = this, restoreTimer;
        vm.dtInstance = {}; vm.rows = [];
        vm.search = ''; vm.filterSave = [];
        vm.filterStatus = localStorage.getItem('factures-achatsStatus') || '';
        vm.compteurs = nbrFacturesAchatsParEtats.data || {}; vm.recordsTotal = 0; vm.busy = false;
        vm.droits = function (action) {
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf('finance.achats.factures.' + action) !== -1;
        };
        vm.peutValiderFournisseurs = function () {
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf('finance.achats.fournisseurs.validation') !== -1;
        };
        vm.propositionsFournisseurs = [];
        vm.propositionsTotal = 0;
        vm.modifiable = function (row) { return row.Origine === 'Import manuel' && ['Brouillon', 'À valider'].indexOf(row.EtatValidation) !== -1 && !Number(row.MontantRegle); };
        vm.supprimable = vm.modifiable;
        vm.toggleSidenav = function (id) { $mdSidenav(id).toggle(); };
        // Même sélection que dans les congés / notes de frais.
        $scope.selected = [];
        $scope.toggle = function (item, list) {
            var index = list.indexOf(item);
            if (index > -1) list.splice(index, 1);
            else list.push(item);
        };
        $scope.exists = function (item, list) { return list.indexOf(item) > -1; };
        function lignesPage() {
            return vm.dtInstance.DataTable ? vm.dtInstance.DataTable.rows({page:'current'}).data().toArray() : [];
        }
        $scope.isChecked = function () {
            var rows = lignesPage();
            return rows.length > 0 && rows.every(function (row) { return $scope.exists(Number(row.IDFactureAchat), $scope.selected); });
        };
        $scope.isIndeterminate = function () {
            return !$scope.isChecked() && lignesPage().some(function (row) { return $scope.exists(Number(row.IDFactureAchat), $scope.selected); });
        };
        $scope.toggleAll = function () {
            $scope.selected = $scope.isChecked() ? [] : lignesPage().map(function (row) { return Number(row.IDFactureAchat); });
        };
        vm.nombreSelection = function () { return $scope.selected.length; };
        vm.peutSelectionner = function () { return vm.droits('export') || vm.droits('statut'); };
        vm.searchChange = function () { if (vm.dtInstance.DataTable) vm.dtInstance.DataTable.search(vm.search || '').draw(); };
        vm.filterChange = function (value) {
            vm.filterStatus = value || '';
            localStorage.setItem('factures-achatsStatus', vm.filterStatus);
            if (!vm.dtInstance.DataTable) return;
            var table = vm.dtInstance.DataTable;
            angular.element(table.table().header()).find('tr:eq(1) th').eq(11).find('select').val(vm.filterStatus);
            table.column(11).search(vm.filterStatus, false, false).draw();
        };
        vm.consulter = function (event, row) {
            if (vm.busy) return;
            // Le détail affiche la ligne reçue du GET de la liste, sans la modifier.
            ouvrirEdition(event, row, false, true);
        };
        vm.editer = function (event, row) {
            if (!vm.droits('edition') || vm.busy || (row && !vm.modifiable(row))) return;
            if (!row) return ouvrirEdition(event, {TypeDocument:'Facture', Origine:'Import manuel', EtatValidation:'Brouillon', MontantRegle:0, TotalHT:0, TotalTVA:0, Devise:'EUR', TauxConversion:1, SourceTaux:'EUR'}, false);
            ouvrirEdition(event, row, false);
        };
        vm.changerStatut = function (event, row) {
            if (!vm.droits('statut') || vm.busy) return;
            ouvrirEdition(event, row, true);
        };
        vm.modifierSelection = function (event) {
            if (!vm.droits('statut') || vm.busy || !$scope.selected.length) return;
            $mdDialog.show({
                controller:'FacturesAchatsStatutsMasseController', controllerAs:'vm',
                templateUrl:'app/main/achats/factures/dialogs/statuts-masse.html', targetEvent:event,
                clickOutsideToClose:false, locals:{Ids:angular.copy($scope.selected)}
            }).then(function (response) {
                $scope.selected = [];
                recharger();
                toast(response.message || 'Les statuts ont été modifiés.');
            }, angular.noop);
        };
        // Le GET de liste contient tous les champs de ces formulaires.
        // Utiliser la ligne sélectionnée évite de présenter le détail d'un autre document
        // avec les réponses JSON statiques. L'enregistrement reste un POST au contrôleur.
        function ouvrirEdition(event, document, statutSeulement, lectureSeule) {
            return $mdDialog.show({
                controller:'FactureAchatEditionController', controllerAs:'vm',
                templateUrl:'app/main/achats/factures/dialogs/edition.html', targetEvent:event,
                clickOutsideToClose:false, locals:{Document:document, StatutSeulement:statutSeulement, LectureSeule:!!lectureSeule}
            }).then(function () { recharger(); }, angular.noop);
        }
        vm.telecharger = function (row) {
            if (!row || !row.IDFactureAchat) return;
            $window.open('/datas/achats/facture.json?IDFactureAchat=' + encodeURIComponent(row.IDFactureAchat), '_blank');
        };
        vm.supprimer = function (event, row) {
            if (!vm.droits('suppression') || !vm.supprimable(row) || vm.busy) return;
            $mdDialog.show($mdDialog.confirm().title('Supprimer cet élément ?')
                .textContent('Seuls les éléments manuels non validés ou non rapprochés peuvent être supprimés.')
                .targetEvent(event).theme('md-warn').ok('Supprimer').cancel('Annuler')).then(function () {
                    if (!vm.droits('suppression') || !vm.supprimable(row)) return;
                    vm.busy = true;
                    $http.post('/datas/achats/deleteFacture.json', {IDFactureAchat:row.IDFactureAchat}).then(function (response) {
                        if (response.data.error) { messageErreur(response); return; }
                        var index = $scope.selected.indexOf(Number(row.IDFactureAchat)); if (index !== -1) $scope.selected.splice(index, 1); recharger(); toast('Suppression enregistrée.');
                    }, messageErreur).finally(function () { vm.busy = false; });
                }, angular.noop);
        };
        vm.importer = function (event) {
            if (!vm.droits('import') || vm.busy) return;
            $mdDialog.show({controller:'FacturesAchatsImportController', controllerAs:'vm',
                templateUrl:'app/main/achats/factures/dialogs/import.html', targetEvent:event, clickOutsideToClose:false
            }).then(function () { recharger(); }, angular.noop);
        };
        vm.exporter = function (type) {
            if (!vm.droits('export')) return;
            var ids = $scope.selected;
            if (type === 'select' && !ids.length) { toast('Sélectionner au moins un élément.'); return; }
            var params = 'type=' + encodeURIComponent(type) + '&selected=' + encodeURIComponent(ids.join(',')) +
                '&filtres=' + encodeURIComponent(angular.toJson(vm.dtInstance.DataTable ? vm.dtInstance.DataTable.ajax.params() : {}));
            $window.open('/datas/achats/exportFactures.json?' + params, '_blank');
        };
        vm.synchroniser = function () {
            if (!vm.droits('synchronisation') || vm.busy) return;
            vm.busy = true;
            $http.post('/datas/achats/synchroniser.json', {}).then(function (response) {
                if (response.data.error) { messageErreur(response); return; }
                recharger(); toast(response.data.message || 'Synchronisation terminée.');
                chargerPropositions().then(function () {
                    if (vm.propositionsTotal) vm.validerFournisseurs();
                });
            }, messageErreur).finally(function () { vm.busy = false; });
        };
        vm.validerFournisseurs = function (event) {
            if (!vm.peutValiderFournisseurs() || !vm.propositionsTotal || vm.busy) return;
            $mdDialog.show({
                controller:'FournisseursSuperPDPValidationController', controllerAs:'vm',
                templateUrl:'app/main/achats/factures/dialogs/fournisseur-validation.html',
                targetEvent:event, clickOutsideToClose:false,
                locals:{Propositions:angular.copy(vm.propositionsFournisseurs)}
            }).then(function () {
                recharger(); chargerPropositions();
            }, function () { chargerPropositions(); });
        };
        function chargerPropositions() {
            if (!vm.peutValiderFournisseurs()) return $q.when();
            return $http.get('/datas/achats/getFournisseursSuperPDPAValider.json').then(function (response) {
                var data = response.data && response.data.data || {};
                vm.propositionsFournisseurs = data.Propositions || [];
                vm.propositionsTotal = Number(data.Total || vm.propositionsFournisseurs.length || 0);
            }, function () {
                vm.propositionsFournisseurs = []; vm.propositionsTotal = 0;
            });
        }
        function recharger() {
            if (vm.dtInstance.reloadData) vm.dtInstance.reloadData(null, false);
            $http.get('/datas/achats/getNbrFacturesParEtats.json').then(function (response) { vm.compteurs = response.data.data || {}; }, messageErreur);
        }
        function toast(message) { $mdToast.show($mdToast.simple().textContent(message).position('bottom right').hideDelay(5000)); }
        function messageErreur(response) {
            var error = response && response.data && (response.data.error || (response.data.data && response.data.data.error));
            toast(error && error.message || 'Action impossible. Vérifier la réponse du contrôleur.');
        }
        function renderTexte(data, type) {
            var value = data === null || data === undefined ? '' : String(data);
            return type === 'display' ? value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') : value;
        }
        function renderDate(data, type) {
            if (type === 'display' && /^\d{4}-\d{2}-\d{2}$/.test(data || '')) return data.split('-').reverse().join('/');
            return renderTexte(data, type);
        }
        function renderStatut(data, type) {
            if (type !== 'display' || !data) return data || '';
            var colors = {'Brouillon':'grey-600-bg', 'À valider':'md-orange-bg', 'À payer':'blue-600-bg',
				'Partiellement réglée':'amber-700-bg', 'Partiellement remboursé':'amber-700-bg', 'Échue':'md-red-bg', 'Refusée':'md-red-bg', 'Rejetée':'md-red-bg',
                'Invalide':'md-red-bg', 'Non recevable':'md-red-bg', 'En litige':'md-red-bg', 'Erreur':'md-red-bg',
				'Réglée':'md-green-bg', 'Imputé':'md-green-bg', 'Remboursé':'md-green-bg', 'Validée':'md-green-bg', 'Acceptée':'md-green-bg', 'Rapprochée':'md-green-bg',
                'Envoyée':'md-green-bg', 'Reçue':'md-green-bg', 'Mise à disposition':'md-green-bg',
                'Prise en charge':'md-green-bg', 'Traitée':'md-green-bg', 'Paiement transmis':'md-green-bg', 'Paiement reçu':'md-green-bg',
                'Déposée':'grey-600-bg', 'Partiellement acceptée':'md-orange-bg', 'Suspendue':'md-orange-bg',
                'Non référencé':'md-orange-bg', 'À rapprocher':'md-orange-bg', 'Ignorée':'grey-600-bg'};
            return '<span class="p-5 pr-16 pl-16 brad-16 font-size-12 white-fg ' + (colors[data] || 'blue-grey-600-bg') + '" style="display:inline-block">' + renderTexte(data, type) + '</span>';
        }
        function renderMontant(data, type) {
            return type === 'display' ? new Intl.NumberFormat('fr-FR', {style:'currency', currency:'EUR'}).format(Number(data || 0)) : Number(data || 0);
        }
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle("<div class=\"table-header\"><span class=\"column-title\"><md-checkbox aria-label=\"Tout sélectionner\" ng-if=\"vm.peutSelectionner()\" ng-checked=\"isChecked()\" md-indeterminate=\"isIndeterminate()\" ng-click=\"toggleAll()\"></md-checkbox></span></div>").withOption('width', '70px').notSortable().withOption('searchable', false)
                .renderWith(function (data, type, row, meta) {
                    vm.rows[meta.row] = row;
                    return type === 'display' ? '<md-checkbox data-val="' + Number(row.IDFactureAchat) + '" aria-label="Sélectionner" ng-if="vm.peutSelectionner()" ng-checked="exists(' + Number(row.IDFactureAchat) + ', selected)" ng-click="toggle(' + Number(row.IDFactureAchat) + ', selected)"></md-checkbox>' : '';
                }),
            DTColumnBuilder.newColumn('NumeroFacture').withTitle("<div class=\"table-header\"><span class=\"column-title\">N° facture</span></div>").withOption('width', '170px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('Fournisseur').withTitle("<div class=\"table-header\"><span class=\"column-title\">Fournisseur</span></div>").withOption('width', '170px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('TypeDocument').withTitle("<div class=\"table-header\"><span class=\"column-title\">Document</span></div>").withOption('width', '100px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('DateFacture').withTitle("<div class=\"table-header\"><span class=\"column-title\">Date</span></div>").withOption('width', '100px').renderWith(renderDate),
            DTColumnBuilder.newColumn('DateEcheance').withTitle("<div class=\"table-header\"><span class=\"column-title\">Échéance</span></div>").withOption('width', '100px').renderWith(renderDate),
            DTColumnBuilder.newColumn('TotalHT').withTitle("<div class=\"table-header\"><span class=\"column-title\">HT</span></div>").withOption('width', '100px').renderWith(renderMontant),
            DTColumnBuilder.newColumn('TotalTVA').withTitle("<div class=\"table-header\"><span class=\"column-title\">TVA</span></div>").withOption('width', '100px').renderWith(renderMontant),
            DTColumnBuilder.newColumn('TotalTTC').withTitle("<div class=\"table-header\"><span class=\"column-title\">TTC</span></div>").withOption('width', '100px').renderWith(renderMontant),
            DTColumnBuilder.newColumn('Solde').withTitle("<div class=\"table-header\"><span class=\"column-title\">Solde</span></div>").withOption('width', '100px').renderWith(renderMontant),
            DTColumnBuilder.newColumn('EtatValidation').withTitle("<div class=\"table-header\"><span class=\"column-title\">Validation</span></div>").withOption('width', '150px').renderWith(renderStatut),
            DTColumnBuilder.newColumn('Statut').withTitle("<div class=\"table-header\"><span class=\"column-title\">Règlement</span></div>").withOption('width', '150px').renderWith(renderStatut),
            DTColumnBuilder.newColumn('Origine').withTitle("<div class=\"table-header\"><span class=\"column-title\">Origine</span></div>").withOption('width', '100px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('StatutPDP').withTitle("<div class=\"table-header\"><span class=\"column-title\">SuperPDP</span></div>").withOption('width', '150px').renderWith(renderStatut),
            DTColumnBuilder.newColumn(null).withTitle("<div class=\"table-header\"><span class=\"column-title\"></span></div>").withOption('width', '50px').notSortable().withOption('searchable', false)
                .renderWith(function (data, type, row, meta) {
                    vm.rows[meta.row] = row;
                    if (type !== 'display') return '';
                    var ref = 'vm.rows[' + meta.row + ']';
                    return '<md-menu style="float: right;"><md-button class="md-icon-button" aria-label="Actions" ng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3">' +
                        '<md-menu-item><md-button ng-click="vm.consulter($event, ' + ref + ')">Détail</md-button></md-menu-item>' +
                        '<md-menu-item><md-button ng-click="vm.telecharger(' + ref + ')">Télécharger la facture / l\'avoir</md-button></md-menu-item>' +
                        '<md-divider></md-divider>' +
                        '<md-menu-item><md-button ng-click="vm.editer($event, ' + ref + ')" ng-disabled="!vm.droits(\'edition\') || !vm.modifiable(' + ref + ')">Modifier</md-button></md-menu-item>' +
                        '<md-menu-item><md-button ng-click="vm.changerStatut($event, ' + ref + ')" ng-disabled="!vm.droits(\'statut\')">Changer le statut</md-button></md-menu-item>' +
                        '<md-menu-item><md-button ng-click="vm.supprimer($event, ' + ref + ')" ng-disabled="!vm.droits(\'suppression\') || !vm.supprimable(' + ref + ')">Supprimer</md-button></md-menu-item></md-menu-content></md-menu>';
                })
        ];
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {dataSrc:'data', url:'datas/achats/getFactures.json', type:'GET'})
            .withDataProp('data').withOption('processing', true).withOption('serverSide', true)
            .withOption('bStateSave', true).withOption('iCookieDuration', 60 * 60 * 12)
            .withOption('stateSaveCallback', function (settings, data) { localStorage.setItem('factures-achatsTable', JSON.stringify(data)); })
            .withOption('stateLoadCallback', function () {
                try { var saved = JSON.parse(localStorage.getItem('factures-achatsTable')); return saved && saved.columns.length === vm.dtColumns.length ? saved : null; }
                catch (ignore) { return null; }
            })
            .withOption('stateLoadParams', function (settings, data) { vm.search = data.search.search; vm.filterSave = data.columns; })
            .withOption('columnDefs', [{targets:[0, 14], responsivePriority:1}])
            .withOption('responsive', {details:{display:$.fn.dataTable.Responsive.display.childRowImmediate, type:'none', target:''}})
            .withOption('pagingType','simple').withOption('lengthMenu',[50,100,250]).withPaginationType('simple')
            .withOption('dom','rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('createdRow', function (row) {
                // Comme les modules RH : compiler les lignes avec le scope du contrôleur.
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('drawCallback', function () {
                var api = this.api();
                vm.recordsTotal = api.page.info().recordsTotal;
                vm.filterStatus = api.column(11).search();
                $scope.$evalAsync();
            })
            .withOption('initComplete', function () {
                var api = this.api();
                restoreTimer = $timeout(function () {
                    angular.forEach(vm.filterSave, function (value, key) {
                        var parts = value.search.search.split('~');
                        angular.element(api.table().header()).find('tr:eq(1) th').eq(key).find('input,select')
                            .each(function (index) { angular.element(this).val(parts[index] || ''); });
                    });
                });
            })
            .withLightColumnFilter({
                "1": {html:"input", type:"text", location:$location},
                "2": {html:"input", type:"text", location:$location},
                "3": {html:"select", values:[{"value":"","label":"--"},{"value":"Facture","label":"Facture"},{"value":"Avoir","label":"Avoir"}], regex:true, location:$location},
                "4": {html:"range", type:"date", location:$location},
                "5": {html:"range", type:"date", location:$location},
                "6": {html:"range", type:"number", location:$location},
                "7": {html:"range", type:"number", location:$location},
                "8": {html:"range", type:"number", location:$location},
                "9": {html:"range", type:"number", location:$location},
                "10": {html:"select", values:[{"value":"","label":"--"},{"value":"Brouillon","label":"Brouillon"},{"value":"À valider","label":"À valider"},{"value":"Validée","label":"Validée"},{"value":"Refusée","label":"Refusée"}], regex:true, location:$location},
				"11": {html:"select", values:[{"value":"","label":"--"},{"value":"À payer","label":"À payer"},{"value":"Partiellement réglée","label":"Partiellement réglée"},{"value":"Échue","label":"Échue"},{"value":"Réglée","label":"Réglée"},{"value":"À imputer","label":"À imputer"},{"value":"Imputé","label":"Imputé"},{"value":"Partiellement remboursé","label":"Partiellement remboursé"},{"value":"Remboursé","label":"Remboursé"}], regex:true, location:$location},
                "12": {html:"select", values:[{"value":"","label":"--"},{"value":"SuperPDP","label":"SuperPDP"},{"value":"Import manuel","label":"Import manuel"}], regex:true, location:$location},
                "13": {html:"select", values:[{"value":"","label":"--"},{"value":"Reçue","label":"Reçue"},{"value":"À contrôler","label":"À contrôler"},{"value":"Acceptée","label":"Acceptée"},{"value":"Refusée","label":"Refusée"}], regex:true, location:$location},
                "14": {html:"clear", status:"factures-achatsStatus"}
            })
            .withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
            .withOption('order', [4, 'desc']);
        $scope.$on('$destroy', function () {
            $timeout.cancel(restoreTimer);
        });
        chargerPropositions().then(function () {
            // Le lien placé dans l'alerte créée par la cron ouvre directement
            // la validation, une fois les propositions réellement chargées.
            var ouvrirValidation = String($location.search().validationSuperPDP || '') === '1';
            if (ouvrirValidation) {
                $location.search('validationSuperPDP', null).replace();
            }
            if (vm.propositionsTotal && ouvrirValidation) {
                $timeout(function () { vm.validerFournisseurs(); });
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
			console.log(item);
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout, $location, $http)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.gopagesearch = gopagesearch;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();


				/* 	$(document).keydown(function(e) { CTRL + F
						if (e.keyCode == 70 && e.ctrlKey) {
							e.preventDefault();
							expand();
						}
					}); */
		

		var typingTimer;                //timer identifier
		var doneTypingInterval = 300;  //time in ms, 5 seconds for example
		var $input = $('#ms-search-bar-input');
		var scurrent,sold;
		//on keyup, start the countdown
		// $input.on('keyup', function () {

		// });

		//on keydown, clear the countdown 
		/* $input.on('keydown', function () {
		  clearTimeout(typingTimer);
		}); */

		//user is "finished typing," do something
		function doneTyping () {
			// console.log('"tye');
				if ( angular.isUndefined(scurrent) )
                {
                    vm.resultsLoading = false;
                    return;
                }

                if ( angular.equals(scurrent, sold) )
                {
                    vm.resultsLoading = false;
                    return;
                }

                if ( vm.collapsed )
                {
                    vm.resultsLoading = false;
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: scurrent}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

					// console.log(onSearchEvaluated.then);
                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated, scurrent);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response, scurrent);
				// console.log(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([], scurrent);
				// console.log(vm.results);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
		}
		
        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
				vm.resultsLoading = true;
				clearTimeout(typingTimer);
				scurrent = current;
				sold = old;
				typingTimer = setTimeout(doneTyping, doneTypingInterval);
                
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results, search)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
			// console.log(search);
			if(!isNull && typeof search != "undefined")
				$http.post("/datas/recherches/getResultats.json",JSON.stringify({query: search})).then(function (response, status, headers, config) {
				
				results = results.concat(response.data.data);
				vm.results = results;
				
			}, function () {});
			else vm.results = results;
			
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;
		
            // Call collapse on scope
            $scope.collapse();
	
            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }
			
            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default: 
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function gopagesearch(item){
			$location.path(item.url);
            vm.collapse();
		}
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
		
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);
						bodyEl.find('.logo-image-mini').css('display','block');
						bodyEl.find('.logo-image').css('display','none');

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

								bodyEl.find('.logo-image-mini').css('display','none');
								bodyEl.find('.logo-image').css('display','block');
                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sample', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.sample', {
                url    : '/sample',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sample/sample.html',
                        controller : 'SampleController as vm'
                    }
                },
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sample');

        // Api
        msApiProvider.register('sample', ['app/data/sample/sample.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('fuse', {
            title : 'SAMPLE',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('fuse.sample', {
            title    : 'Sample',
            icon     : 'icon-tile-four',
            state    : 'app.sample',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'SAMPLE.SAMPLE_NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController(SampleData)
    {
        var vm = this;

        // Data
        vm.helloText = SampleData.data.helloText;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.e404', {
            url      : '/e404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.e404': {
                    templateUrl: 'app/main/e404/e404.html',
                    controller : 'e404Controller as vm'
                }
            },
            bodyClass: 'error-e404'
        });


        /* msNavigationServiceProvider.saveItem('e404', {
            title : 'e404',
            state : 'app.e404',
            weight: 1,
			hidden: function (){
				return true;
			}
        }); */
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.e404')
        .controller('e404Controller', e404Controller);

    /** @ngInject */
    function e404Controller($rootScope, $state)
    {
        // Data

		var vm = this;
		
        // Methods
		vm.goIndex = function(){
			if($rootScope.pageDefault!="")
				$state.go ($rootScope.pageDefault);
			else
				$state.go ('app.analyse_resume');
		}
        //////////
    }
})();
(function ()
{
    'use strict';
    angular.module('app.banque').controller('BanqueController', BanqueController);

    /** @ngInject */
    function BanqueController(OperationsBancaires, nbrOperationsParEtats, $scope, $rootScope, $http, $mdDialog, $mdToast, $mdSidenav, $window, $location, $compile, $timeout, DTOptionsBuilder, DTColumnBuilder)
    {
        var vm = this, restoreTimer;
        var statuts = ['À rapprocher', 'À valider', 'Rapprochée', 'À rembourser', 'Remboursé', 'Rejet à attribuer', 'Rejetée', 'En attente de pièce', 'Justifiée hors facture', 'Non justifiée', 'Ignorée'];
        var statutUrl = statuts.indexOf($location.search().statut) !== -1 ? $location.search().statut : '';
        vm.dtInstance = {}; vm.rows = [];
        vm.search = ''; vm.filterSave = [];
        vm.filterStatus = statutUrl || localStorage.getItem('banqueStatus') || '';
        vm.compteurs = nbrOperationsParEtats.data || {}; vm.recordsTotal = 0; vm.busy = false;
        vm.droits = function (action) {
            return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf('finance.banque.' + action) !== -1;
        };
		vm.peutSelectionner = function () { return vm.droits('statut') || vm.droits('export'); };
        vm.modifiable = function (row) { return row.Origine === 'Import manuel' && ['Rapprochée', 'Rejet à attribuer', 'Rejetée'].indexOf(row.Statut) === -1; };
        vm.supprimable = vm.modifiable;
        vm.statutModifiable = function (row) { return !row.IDOperationRejet && !row.IDOperationEncaissementRejete && !(row.IDTropPercuClient && row.Statut === 'Remboursé'); };
        vm.toggleSidenav = function (id) { $mdSidenav(id).toggle(); };
        // Même sélection que dans les congés / notes de frais.
        $scope.selected = [];
        $scope.toggle = function (item, list) {
            var index = list.indexOf(item);
            if (index > -1) list.splice(index, 1);
            else list.push(item);
        };
        $scope.exists = function (item, list) { return list.indexOf(item) > -1; };
        function lignesPage() {
            return vm.dtInstance.DataTable ? vm.dtInstance.DataTable.rows({page:'current'}).data().toArray() : [];
        }
        $scope.isChecked = function () {
            var rows = lignesPage();
            return rows.length > 0 && rows.every(function (row) { return $scope.exists(Number(row.IDOperationBancaire), $scope.selected); });
        };
        $scope.isIndeterminate = function () {
            return !$scope.isChecked() && lignesPage().some(function (row) { return $scope.exists(Number(row.IDOperationBancaire), $scope.selected); });
        };
        $scope.toggleAll = function () {
            $scope.selected = $scope.isChecked() ? [] : lignesPage().map(function (row) { return Number(row.IDOperationBancaire); });
        };
        vm.nombreSelection = function () { return $scope.selected.length; };
        vm.searchChange = function () { if (vm.dtInstance.DataTable) vm.dtInstance.DataTable.search(vm.search || '').draw(); };
        vm.filterChange = function (value) {
            vm.filterStatus = value || '';
            localStorage.setItem('banqueStatus', vm.filterStatus);
            if (!vm.dtInstance.DataTable) return;
            var table = vm.dtInstance.DataTable;
            angular.element(table.table().header()).find('tr:eq(1) th').eq(7).find('select').val(vm.filterStatus);
            table.column(7).search(vm.filterStatus, false, false).draw();
        };
        vm.consulter = function (event, row) {
            if (vm.busy) return;
            // Le détail affiche la ligne reçue du GET de la liste, sans la modifier.
            ouvrirEdition(event, row, false, true);
        };
        vm.editer = function (event, row) {
            if (!vm.droits('edition') || vm.busy || (row && !vm.modifiable(row))) return;
            if (!row) return ouvrirEdition(event, {Origine:'Import manuel', Statut:'À rapprocher', Debit:0, Credit:0, Rapprochement:''}, false);
            ouvrirEdition(event, row, false);
        };
        vm.changerStatut = function (event, row) {
            if (!vm.droits('statut') || vm.busy || !vm.statutModifiable(row)) return;
            ouvrirEdition(event, row, true);
        };
		vm.modifierSelection = function (event) {
			if (!vm.droits('statut') || vm.busy || !$scope.selected.length) return;
			$mdDialog.show({
				controller:'OperationsBanqueStatutsMasseController', controllerAs:'vm',
				templateUrl:'app/main/banque/dialogs/statuts-masse.html', targetEvent:event,
				clickOutsideToClose:false, locals:{Ids:angular.copy($scope.selected)}
			}).then(function (response) {
				$scope.selected = [];
				recharger();
				toast(response.message || 'Les opérations ont été modifiées.');
			}, angular.noop);
		};
        // Le GET de liste contient tous les champs de ces formulaires.
        // Utiliser la ligne sélectionnée évite de présenter le détail d'un autre document
        // avec les réponses JSON statiques. L'enregistrement reste un POST au contrôleur.
        function ouvrirEdition(event, document, statutSeulement, lectureSeule) {
            return $mdDialog.show({
                controller:'OperationBanqueEditionController', controllerAs:'vm',
                templateUrl:'app/main/banque/dialogs/edition.html', targetEvent:event,
                clickOutsideToClose:false, locals:{Document:document, StatutSeulement:statutSeulement, LectureSeule:!!lectureSeule}
            }).then(function () { recharger(); }, angular.noop);
        }
        vm.supprimer = function (event, row) {
            if (!vm.droits('suppression') || !vm.supprimable(row) || vm.busy) return;
            $mdDialog.show($mdDialog.confirm().title('Supprimer cet élément ?')
                .textContent('Seuls les éléments manuels non validés ou non rapprochés peuvent être supprimés.')
                .targetEvent(event).theme('md-warn').ok('Supprimer').cancel('Annuler')).then(function () {
                    if (!vm.droits('suppression') || !vm.supprimable(row)) return;
                    vm.busy = true;
                    $http.post('/datas/banque/deleteOperation.json', {IDOperationBancaire:row.IDOperationBancaire}).then(function (response) {
                        if (response.data.error) { messageErreur(response); return; }
                        var index = $scope.selected.indexOf(Number(row.IDOperationBancaire)); if (index !== -1) $scope.selected.splice(index, 1); recharger(); toast('Suppression enregistrée.');
                    }, messageErreur).finally(function () { vm.busy = false; });
                }, angular.noop);
        };
        vm.importer = function (event) {
            if (!vm.droits('import') || vm.busy) return;
            $mdDialog.show({controller:'OperationsBanqueImportController', controllerAs:'vm',
                templateUrl:'app/main/banque/dialogs/import.html', targetEvent:event, clickOutsideToClose:false
            }).then(function () { recharger(); }, angular.noop);
        };
        vm.exporter = function (type) {
            if (!vm.droits('export')) return;
            var ids = $scope.selected;
            if (type === 'select' && !ids.length) { toast('Sélectionner au moins un élément.'); return; }
            var params = 'type=' + encodeURIComponent(type) + '&selected=' + encodeURIComponent(ids.join(',')) +
                '&filtres=' + encodeURIComponent(angular.toJson(vm.dtInstance.DataTable ? vm.dtInstance.DataTable.ajax.params() : {}));
            $window.open('/datas/banque/exportOperations.json?' + params, '_blank');
        };
        vm.synchroniser = function () {
            if (!vm.droits('synchronisation') || vm.busy) return;
            vm.busy = true;
            $http.post('/datas/banque/synchroniser.json', {}).then(function (response) {
                if (response.data.error) { messageErreur(response); return; }
                recharger(); toast(response.data.message || 'Synchronisation terminée.');
            }, messageErreur).finally(function () { vm.busy = false; });
        };
        function recharger() {
            if (vm.dtInstance.reloadData) vm.dtInstance.reloadData(null, false);
            $http.get('/datas/banque/getNbrOperationsParEtats.json').then(function (response) { vm.compteurs = response.data.data || {}; }, messageErreur);
        }
        function toast(message) { $mdToast.show($mdToast.simple().textContent(message).position('bottom right').hideDelay(5000)); }
        function messageErreur(response) {
            var error = response && response.data && (response.data.error || (response.data.data && response.data.data.error));
            toast(error && error.message || 'Action impossible. Vérifier la réponse du contrôleur.');
        }
        function renderTexte(data, type) {
            var value = data === null || data === undefined ? '' : String(data);
            return type === 'display' ? value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') : value;
        }
        function renderDate(data, type) {
            if (type === 'display' && /^\d{4}-\d{2}-\d{2}$/.test(data || '')) return data.split('-').reverse().join('/');
            return renderTexte(data, type);
        }
        function renderStatut(data, type) {
            if (type !== 'display' || !data) return data || '';
            var colors = {'Brouillon':'grey-600-bg', 'À payer':'blue-600-bg',
                'Partiellement réglée':'amber-700-bg', 'Échue':'md-red-bg', 'Refusée':'md-red-bg',
                'Réglée':'md-green-bg', 'Validée':'md-green-bg', 'Acceptée':'md-green-bg', 'Rapprochée':'md-green-bg',
                'Justifiée hors facture':'md-green-bg', 'Remboursé':'md-green-bg', 'À rembourser':'amber-700-bg', 'En attente de pièce':'amber-700-bg',
                'Rejet à attribuer':'md-orange-bg', 'Rejetée':'md-red-bg',
                'À rapprocher':'blue-600-bg', 'À valider':'md-orange-bg', 'Non justifiée':'md-red-bg', 'Ignorée':'grey-600-bg'};
            return '<span class="p-5 pr-16 pl-16 brad-16 font-size-12 white-fg ' + (colors[data] || 'blue-grey-600-bg') + '" style="display:inline-block">' + renderTexte(data, type) + '</span>';
        }
        function renderMontant(data, type) {
            var montant = Number(data || 0);
            return type === 'display' ? (Math.abs(montant) < 0.005 ? '' : new Intl.NumberFormat('fr-FR', {style:'currency', currency:'EUR'}).format(montant)) : montant;
        }
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle("<div class=\"table-header\"><span class=\"column-title\"><md-checkbox aria-label=\"Tout sélectionner\" ng-if=\"vm.peutSelectionner()\" ng-checked=\"isChecked()\" md-indeterminate=\"isIndeterminate()\" ng-click=\"toggleAll()\"></md-checkbox></span></div>").withOption('width', '70px').notSortable().withOption('searchable', false)
                .renderWith(function (data, type, row, meta) {
                    vm.rows[meta.row] = row;
                    return type === 'display' ? '<md-checkbox data-val="' + Number(row.IDOperationBancaire) + '" aria-label="Sélectionner" ng-if="vm.peutSelectionner()" ng-checked="exists(' + Number(row.IDOperationBancaire) + ', selected)" ng-click="toggle(' + Number(row.IDOperationBancaire) + ', selected)"></md-checkbox>' : '';
                }),
            DTColumnBuilder.newColumn('DateOperation').withTitle("<div class=\"table-header\"><span class=\"column-title\">Date</span></div>").withOption('width', '100px').renderWith(renderDate),
            DTColumnBuilder.newColumn('Compte').withTitle("<div class=\"table-header\"><span class=\"column-title\">Compte</span></div>").withOption('width', '100px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('Libelle').withTitle("<div class=\"table-header\"><span class=\"column-title\">Libellé</span></div>").withOption('width', '170px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('Reference').withTitle("<div class=\"table-header\"><span class=\"column-title\">Référence</span></div>").withOption('width', '100px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('Debit').withTitle("<div class=\"table-header\"><span class=\"column-title\">Débit</span></div>").withOption('width', '100px').renderWith(renderMontant),
            DTColumnBuilder.newColumn('Credit').withTitle("<div class=\"table-header\"><span class=\"column-title\">Crédit</span></div>").withOption('width', '100px').renderWith(renderMontant),
            DTColumnBuilder.newColumn('Statut').withTitle("<div class=\"table-header\"><span class=\"column-title\">État</span></div>").withOption('width', '100px').renderWith(renderStatut),
            DTColumnBuilder.newColumn('Categorie').withTitle("<div class=\"table-header\"><span class=\"column-title\">Catégorie</span></div>").withOption('width', '120px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('Rapprochement').withTitle("<div class=\"table-header\"><span class=\"column-title\">Rapprochement</span></div>").withOption('width', '170px').renderWith(renderTexte),
            DTColumnBuilder.newColumn('Origine').withTitle("<div class=\"table-header\"><span class=\"column-title\">Origine</span></div>").withOption('width', '100px').renderWith(renderTexte),
            DTColumnBuilder.newColumn(null).withTitle("<div class=\"table-header\"><span class=\"column-title\"></span></div>").withOption('width', '50px').notSortable().withOption('searchable', false)
                .renderWith(function (data, type, row, meta) {
                    vm.rows[meta.row] = row;
                    if (type !== 'display') return '';
                    var ref = 'vm.rows[' + meta.row + ']';
                    return '<md-menu style="float: right;"><md-button class="md-icon-button" aria-label="Actions" ng-click="$mdMenu.open($event)"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3">' +
                        '<md-menu-item><md-button ng-click="vm.consulter($event, ' + ref + ')">Détail</md-button></md-menu-item>' +
                        '<md-menu-item><md-button ng-click="vm.editer($event, ' + ref + ')" ng-disabled="!vm.droits(\'edition\') || !vm.modifiable(' + ref + ')">Modifier</md-button></md-menu-item>' +
                        '<md-menu-item><md-button ng-click="vm.changerStatut($event, ' + ref + ')" ng-disabled="!vm.droits(\'statut\') || !vm.statutModifiable(' + ref + ')">Changer le statut</md-button></md-menu-item>' +
                        '<md-menu-item><md-button ng-click="vm.supprimer($event, ' + ref + ')" ng-disabled="!vm.droits(\'suppression\') || !vm.supprimable(' + ref + ')">Supprimer</md-button></md-menu-item></md-menu-content></md-menu>';
                })
        ];
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {dataSrc:'data', url:'datas/banque/getOperations.json', type:'GET'})
            .withDataProp('data').withOption('processing', true).withOption('serverSide', true)
            .withOption('bStateSave', true).withOption('iCookieDuration', 60 * 60 * 12)
            .withOption('stateSaveCallback', function (settings, data) { localStorage.setItem('banqueTable', JSON.stringify(data)); })
            .withOption('stateLoadCallback', function () {
                try { var saved = JSON.parse(localStorage.getItem('banqueTable')); return saved && saved.columns.length === vm.dtColumns.length ? saved : null; }
                catch (ignore) { return null; }
            })
            .withOption('stateLoadParams', function (settings, data) {
                if (statutUrl && data.columns[7]) data.columns[7].search.search = statutUrl;
                vm.search = data.search.search; vm.filterSave = data.columns;
            })
            .withOption('columnDefs', [{targets:[0, 11], responsivePriority:1}])
            .withOption('responsive', {details:{display:$.fn.dataTable.Responsive.display.childRowImmediate, type:'none', target:''}})
            .withOption('pagingType','simple').withOption('lengthMenu',[50,100,250]).withPaginationType('simple')
            .withOption('dom','rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('createdRow', function (row) {
                // Comme les modules RH : compiler les lignes avec le scope du contrôleur.
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('drawCallback', function () {
                var api = this.api();
                vm.recordsTotal = api.page.info().recordsTotal;
                vm.filterStatus = api.column(7).search();
                $scope.$evalAsync();
            })
            .withOption('initComplete', function () {
                var api = this.api();
                restoreTimer = $timeout(function () {
                    angular.forEach(vm.filterSave, function (value, key) {
                        var parts = value.search.search.split('~');
                        angular.element(api.table().header()).find('tr:eq(1) th').eq(key).find('input,select')
                            .each(function (index) { angular.element(this).val(parts[index] || ''); });
                    });
                    if (statutUrl && api.column(7).search() !== statutUrl) api.column(7).search(statutUrl, false, false).draw();
                });
            })
            .withLightColumnFilter({
                "1": {html:"range", type:"date", location:$location},
                "2": {html:"input", type:"text", location:$location},
                "3": {html:"input", type:"text", location:$location},
                "4": {html:"input", type:"text", location:$location},
                "5": {html:"range", type:"number", location:$location},
                "6": {html:"range", type:"number", location:$location},
                "7": {html:"select", values:[{"value":"","label":"--"},{"value":"À rapprocher","label":"À rapprocher"},{"value":"À valider","label":"À valider"},{"value":"Rapprochée","label":"Rapprochée"},{"value":"À rembourser","label":"À rembourser"},{"value":"Remboursé","label":"Remboursé"},{"value":"Rejet à attribuer","label":"Rejet à attribuer"},{"value":"Rejetée","label":"Rejetée"},{"value":"En attente de pièce","label":"En attente de pièce"},{"value":"Justifiée hors facture","label":"Justifiée hors facture"},{"value":"Non justifiée","label":"Non justifiée"},{"value":"Ignorée","label":"Ignorée"}], regex:true, location:$location},
                "8": {html:"select", values:[{"value":"","label":"--"},{"value":"Trop-perçu client","label":"Trop-perçu client"},{"value":"Frais bancaires","label":"Frais bancaires"},{"value":"Frais juridiques et contentieux","label":"Frais juridiques et contentieux"},{"value":"Location bâtiment","label":"Location bâtiment"},{"value":"Assurance véhicules","label":"Assurance véhicules"},{"value":"Assurance homme clé","label":"Assurance homme clé"},{"value":"Prévoyance dirigeant","label":"Prévoyance dirigeant"},{"value":"Mutuelle dirigeant","label":"Mutuelle dirigeant"},{"value":"Retraite dirigeant","label":"Retraite dirigeant"},{"value":"Épargne salariale","label":"Épargne salariale"},{"value":"Protection sociale salariés","label":"Protection sociale salariés"},{"value":"Mutuelle des salariés","label":"Mutuelle des salariés"},{"value":"Sécurité et alarme","label":"Sécurité et alarme"},{"value":"Salaires","label":"Salaires"},{"value":"Cotisations sociales","label":"Cotisations sociales"},{"value":"Impôts et taxes","label":"Impôts et taxes"},{"value":"Virement interne","label":"Virement interne"},{"value":"Autre","label":"Autre"}], regex:true, location:$location},
                "9": {html:"input", type:"text", location:$location},
                "10": {html:"select", values:[{"value":"","label":"--"},{"value":"API","label":"API"},{"value":"Import manuel","label":"Import manuel"}], regex:true, location:$location},
                "11": {html:"clear", status:"banqueStatus"}
            })
            .withLanguage({
			  "sProcessing": '<md-progress-linear md-mode="indeterminate" aria-valuemin="0" aria-valuemax="100" role="progressbar" class="md-default-theme "><div class="md-container md-mode-indeterminate"><div class="md-dashed"></div><div class="md-bar md-bar1"></div><div class="md-bar md-bar2"></div></div></md-progress-linear>',
				"sSearch":         "Rechercher&nbsp;:",
				"sLengthMenu":     "Afficher _MENU_ &eacute;l&eacute;ments",
				"sInfo":           "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_",
				"sInfoEmpty":      "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0",
				"sInfoFiltered":   "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
				"sInfoPostFix":    "",
				"sLoadingRecords": "Chargement en cours...",
				"sZeroRecords":    "Aucun &eacute;l&eacute;ment &agrave; afficher",
				"sEmptyTable":     "Aucune donn&eacute;e disponible dans le tableau",
				"oPaginate": {
					"sFirst":      "Premier",
					"sPrevious":   "Pr&eacute;c&eacute;dent",
					"sNext":       "Suivant",
					"sLast":       "Dernier"
				},
				"oAria": {
					"sSortAscending":  ": activer pour trier la colonne par ordre croissant",
					"sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
				}
			})
            .withOption('order', [1, 'desc']);
        $scope.$on('$destroy', function () {
            $timeout.cancel(restoreTimer);
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-palegrey',
            options: {
                '50': '#eceff1',
                '100': '#cfd8dc',
                '200': '#b0bec5',
                '300': '#90a4ae',
                '400': '#78909c',
                '500': '#607d8b',
                '600': '#546e7a',
                '700': '#455a64',
                '800': '#37474f',
                '900': '#263238',
                'A100': '#ffffff',
                'A200': '#b0bec5',
                'A400': '#78909c',
                'A700': '#455a64',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
				
				// console.log(colorType.hues['hue-2']);
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: #1e293b;\n    background-color: #f1f5f9;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: #f1f5f9;\n    color: #1e293b;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: #f1f5f9 !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags)
        .filter('filterStatus', filterStatus);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
               tags.forEach(function (tag)
                {
                    var tagExists = false;
                    angular.forEach(item, function (itemTag)
                    {
                        if ( typeof itemTag == "string" && itemTag.toUpperCase().indexOf(tag.toUpperCase())>=0 )
                        {
							if(filtered.indexOf(item)<0)
								filtered.push(item);
                            return;
                        }
                    });

                });

            });
            return filtered;
        };
    }


    /** @ngInject */
    function filterStatus()
    {
		
        return function (items, tag)
        {
            if ( items.length === 0 || tag.length === 0 )
            {
                return items;
            }

            var filtered = [];
            items.forEach(function (item)
            {
				if ( item.Status == tag )
				{
					filtered.push(item);
					return;
				}

            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';
    angular.module('app.core').controller('DocumentsImportController', DocumentsImportController);
    /** @ngInject */
    function DocumentsImportController(Categorie, Droit, Url, $rootScope, $http, $mdDialog) {
        var vm = this;
        vm.categorie = Categorie; vm.busy = false; vm.error = ''; vm.resultat = null; vm.comptes = [];
        vm.formats = Categorie === 'achats' ? ['PDF / Factur-X', 'CSV'] : ['CSV', 'OFX'];
        vm.format = vm.formats[0];
        vm.autorise = function () { return $rootScope.Permission === 'Super Admin' || ($rootScope.droits || []).indexOf(Droit) !== -1; };
        vm.fermer = function () { if (!vm.busy) { if (vm.resultat) $mdDialog.hide(vm.resultat); else $mdDialog.cancel(); } };
        if (Categorie === 'banque') $http.get('/datas/banque/getComptes.json').then(function (response) { vm.comptes = response.data.data || []; },
            function () { vm.error = 'Impossible de charger les comptes.'; });
        vm.importer = function (form) {
            if (!vm.autorise() || vm.busy || vm.resultat || form.$invalid) return;
            vm.error = '';
            var extension = vm.format === 'CSV' ? /\.csv$/i : (vm.format === 'OFX' ? /\.ofx$/i : /\.pdf$/i);
            if (!vm.file || vm.file.size > 20 * 1024 * 1024 || !extension.test(vm.file.name)) {
                vm.error = 'Choisir un fichier du format indiqué, de 20 Mo maximum.'; return;
            }
            var data = new FormData();
            data.append('file', vm.file);
            data.append('data', angular.toJson({Format:vm.format, IDCompte:vm.IDCompte}));
            vm.busy = true;
            $http.post(Url, data, {headers:{'Content-Type':undefined}, transformRequest:angular.identity}).then(function (response) {
                if (!response.data || response.data.error || !response.data.data) { vm.error = (response.data && response.data.error && response.data.error.message) || 'Import refusé.'; return; }
                vm.resultat = response.data.data;
                if (!vm.resultat) vm.error = 'Réponse du contrôleur incomplète.';
            }, function () { vm.error = 'Import impossible. Vérifier le contrôleur PHP.'; }).finally(function () { vm.busy = false; });
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : true,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        // $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

	var NavigationService = null;
	
    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController)
		.config(["msNavigationServiceProvider", function (msNavigationServiceProvider) {
			NavigationService = msNavigationServiceProvider;
		}]);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state,$mdMedia, $timeout, $mdSidenav, $translate, $mdToast, $mdDialog , msNavigationService, $location, $http)
    {
		 $rootScope.$mdMedia = $mdMedia;
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

		vm.nbrNotifications = 0;
        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.profile = profile;
        vm.notifications = "";
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function profile()
        {
			$location.path("/administration/employes/profil/"+$rootScope.id);
        }
		
        function logout()
        {
			$location.path("/auth/login");
        }


		function getNotifications(){
			$http.get("/datas/alertes/getNbrLastAlertes.json").then(function (response, status, headers, config) {
				vm.nbrNotifications = response.data.data;
				var color, content = "";
				content = vm.nbrNotifications.total;
				color = "red";
				
				if(vm.nbrNotifications.total>0) color = ' #1ca9e7';						
				if(vm.nbrNotifications.warnings>0) color = '#EF6C00 ';
				if(vm.nbrNotifications.errors>0) color = ' #f44336';


				var badge = (typeof color != "undefined" && color != "" && typeof content != "undefined" && content != "" && content > 0) ? {content: content, color  : color} : "";
				
				NavigationService.saveItem("analyse.notifications", {
					badge :badge,
				});
				
			}, function () {});
			setTimeout(getNotifications,5000); /* rappel après 2 secondes = 2000 millisecondes */
			
			
		}
 
		getNotifications();
		
        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }
	/* function DialogNotificationController($scope, $mdDialog, notification) {
		$scope.notification = notification;

		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		$scope.renouvele = function(answer) {
		  $mdDialog.hide(answer);
		};
	  } */
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController)
		.filter('DateFormat', function myDateFormat($filter){
		  return function(text){
			var  tempdate= new Date(text);
			return $filter('date')(tempdate, "dd/MM/yyyy");
		  }
		});

    /** @ngInject */
    function QuickPanelController(msApi, $http, $location, $mdDialog, $mdToast, $rootScope)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };
        vm.notifications = "";


		vm.gonotifications = function ()
        {
			$location.path("/notifications");
        }
		
        vm.TraiternotificationToolbar = function(ev, notification){
			clearTimeout($rootScope.timeout);
			if(notification.TypeAlerte == "Renouvellement"){
				$mdDialog.show({
				  controller: DialogNotificationController,
				  templateUrl: 'app/main/analyse/notifications/dialogs/dialog-renouvellement.html',
				  parent: angular.element(document.body),
				  targetEvent: ev,
				  clickOutsideToClose:true,
					locals             : {
						notification : notification
					}
				})
				.then(function(answer) {
					notification = answer;
					
					$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
					.then(function (response, status, headers, config) {
						notification.Traite = 1;
						$(ev.target).parents('md-list-item').animate(
							{'left':'100%'}, 500, 
							function() {
								$(ev.target).parents('md-list-item').animate({'height':'0','min-height':'0'},500, function(){									
									vm.notifications.splice(vm.notifications.indexOf(notification), 1);
								});
						});
			
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Notification traitée')
							.position('bottom right' )
							.hideDelay(3000)
						);
						$rootScope.timeout = setInterval(getNotifications,3000);
					});		
				}, function () {});
			}
			else if(notification.TypeAlerte == "Devis"){
				$mdDialog.show({
					controller: DialogNotificationController,
					templateUrl: 'app/main/analyse/notifications/dialogs/dialog-devis.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose:true,
					locals             : {
						notification : notification
					}
				})
				.then(function(answer) {
					notification = answer;
					// notification.satus = answer;
					$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
					.then(function (response, status, headers, config) {
						notification.Traite = 1;
						$(ev.target).parents('md-list-item').animate(
							{'left':'100%'}, 500, 
							function() {
								$(ev.target).parents('md-list-item').animate({'height':'0','min-height':'0'},500, function(){									
									vm.notifications.splice(vm.notifications.indexOf(notification), 1);
								});
						});
			
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Notification traitée')
							.position('bottom right' )
							.hideDelay(3000)
						);
						$rootScope.timeout = setInterval(getNotifications,3000);
					});		
				}, function () {});
			}
			else if(notification.TypeAlerte == "Bilan"){
				$mdDialog.show({
					controller: DialogNotificationController,
					templateUrl: 'app/main/analyse/notifications/dialogs/dialog-bilan.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose:true,
					locals             : {
						notification : notification
					}
				})
				.then(function(answer) {
					// console.log(notification);
					notification = answer;
					$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
					.then(function (response, status, headers, config) {
						notification.Traite = 1; 
						$(ev.target).parents('md-list-item').animate(
							{'left':'100%'}, 500, 
							function() {
								$(ev.target).parents('md-list-item').animate({'height':'0','min-height':'0'},500, function(){									
									vm.notifications.splice(vm.notifications.indexOf(notification), 1);
								});
						});
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Notification traitée')
							.position('bottom right' )
							.hideDelay(3000)
						);
					}, function () {});	
				}, function() {
				});
			}
			else{
			
				$mdDialog.show({
					controller: DialogNotificationController,
					templateUrl: 'app/main/analyse/notifications/dialogs/dialog-default.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose:true,
					locals             : {
						notification : notification
					}
				})
				.then(function(answer) {
					notification = answer;
					$http.post("/datas/alertes/traiterNotification.json",JSON.stringify(notification))
					.then(function (response, status, headers, config) {
						notification.Traite = 1;
						$(ev.target).parents('md-list-item').animate(
							{'left':'100%'}, 500, 
							function() {
								$(ev.target).parents('md-list-item').animate({'height':'0','min-height':'0'},500, function(){									
									vm.notifications.splice(vm.notifications.indexOf(notification), 1);
								});
						});
						$mdToast.show(
						  $mdToast.simple()
							.textContent('Notification traitée')
							.position('bottom right' )
							.hideDelay(3000)
						);
						$rootScope.timeout = setInterval(getNotifications,3000);
					});			
					
				}, function() {
				  
				});
			}
		};
		
		function getNotifications(){
			$http.get("/datas/alertes/getLastAlertes.json").then(function (response, status, headers, config) {
				if(response.data.error){
					$location.path("/auth/lock/"+$location.url().split('/').join('_'));
					clearTimeout($rootScope.timeout);
				}
				else
					vm.notifications = response.data.data;
			}, function () {});
			 /* rappel après 2 secondes = 2000 millisecondes */
		}
 
		$rootScope.timeout = setInterval(getNotifications,3000);
		
		vm.gonotifications = function ()
        {
			$location.path("/notifications");
        }
		
      /*  msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );*/

        // Methods

        //////////
    }
	
	function DialogNotificationController($scope, $mdDialog, notification) {
		$scope.notification = notification;

		$scope.cancel = function() {
		  $mdDialog.cancel();
		};

		$scope.reponse = function(answer) {
		  $mdDialog.hide(answer);
		};
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
	 
    angular
        .module('fuse', [
            'google.places',
			 'datatables',
			 'datatables.fixedheader',
			 'datatables.light-columnfilter',
			 // 'yadcf',
			 
            // Core
            'app.core',
			'ngIdle',
            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            // Sample
            // 'app.sample',
            'app.contacts',
            'app.collaborateurs',
            'app.sites',
            'app.commandes',
            'app.achats',
            'app.banque',
            'app.analyse',
            'app.parametres',
            'app.courriers',
            'app.auth',
            'app.e404'
        ])
      .directive('mdOpenOnFocus', function($timeout) {
            return {
                restrict: 'A',
                link: function(scope, element) {

                    var openDatePicker = function(event) {
                        $timeout(function() {
                            var datePickerElement = element[0];
                            if (datePickerElement) {
                                var button = datePickerElement.querySelector('.md-datepicker-triangle-button');
                                if (button) {
                                    button.click();
                                } else {
                                }
                            } else {
                            }
                        }, 100); // délai de 100 ms
                    };

                    var inputElement = element[0].querySelector('input');
                    if (inputElement) {
                        angular.element(inputElement).on('focus', openDatePicker);
                        angular.element(inputElement).on('click', openDatePicker);
                    } else {
                    }
                }
            };
        }).run(initDT)/* .
		value('froalaConfig', {
			inlineMode: true,
			// useClasses: false,
			dragInline: false,
			placeholderText: 'Entrez votre texte',
			toolbarButtons : ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript','fontSize', 'color', 'paragraphFormat', 'align', 'formatOL', 'formatUL', '-', 'outdent', 'indent', 'quote', 'insertLink', 'insertImage', 'insertTable', '|', 'fontAwesome', 'specialCharacters', 'insertHR', 'clearFormatting', '|', 'html'],
			imageEditButtons: ['imageAlign', 'imageRemove'],
			quickInsertTags  : [],
			heightMin: 200,
			language: 'fr'
		}) */
		
})();

function initDT(DTDefaultOptions) {
    DTDefaultOptions.setLoadingTemplate('<md-progress-linear md-mode="indeterminate" ></md-progress-linear>');
}

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController)		
		.config(function(IdleProvider, KeepaliveProvider) {
			IdleProvider.idle(900); // in seconds
			IdleProvider.timeout(15); // in seconds
		})
		.run(function(Idle){
			Idle.watch();
		});

    /** @ngInject */
    function MainController($scope, $timeout, $rootScope, $location, Idle,$http)
    {
        // Data

        //////////
		
		// Account timeout
		$scope.$on('IdleTimeout', function() {
			if($rootScope.logIn)
				$rootScope.$apply(function() {
					$location.path("/auth/lock/"+$location.url().split('/').join('_'));
					clearTimeout($rootScope.timeout);
				});
			Idle.unwatch();
			Idle.watch();
		});


		$scope.openSelectSearch = function(id, time){
			if(typeof time == "undefined")
				time = 50;
			
			return $timeout(function() {$(id).focus();},time);
		}

        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
		
		/*function convertDate(inputFormat) {
			function pad(s) { return (s < 10) ? '0' + s : s; }
			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/') + ' '+[pad(d.getHours()), pad(d.getMinutes())].join(':');
		}
		
		$scope.test = function(DTColumnBuilder, datas){
			var dtColumns = [];
			angular.forEach(datas, function(column, key) {
				var Column = DTColumnBuilder;
				Column = Column.newColumn(column.name);
				Column = Column.withTitle(column.title);
				
				if(typeof column.options != "undefined")
					angular.forEach(column.options, function(options, name) {
						Column = Column.withOption(name, options); 
					});
				
				if(typeof column.render != "undefined")
					Column = Column.renderWith(
						function(data, type, full){
							if ( type === 'display' ){
								return console.log(eval(column.render));
							}
							else
								return data;
						}
					);
				
				dtColumns.push(Column);
			});
			return dtColumns;
		};*/
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : true,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

		
    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        
        $urlRouterProvider
		.when('/', '/auth/login')
		.when('/parametres/fournisseurs', '/achats/fournisseurs')
		.otherwise('e404');


        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

	var NavigationService = null;
	 
    angular
        .module('fuse')
        .controller('IndexController', IndexController)
		.config(["msNavigationServiceProvider", function (msNavigationServiceProvider) {
			NavigationService = msNavigationServiceProvider;
		}]);
	
	
    /** @ngInject */
    function IndexController(fuseTheming, $rootScope, $location, $http)
    {
        var vm = this;


        // Data
        vm.themes = fuseTheming.themes;

		if((!$rootScope || !$rootScope.logIn) && $location.path()!="/auth/login" && $location.path()!="/auth/forgot-password" && $location.path()!="/auth/lock"){
			
			if(typeof $rootScope.onglets != "undefined")
			angular.forEach($rootScope.onglets, function(value, key) {
				NavigationService.deleteItem(value.Path);
			});
			
			$http({
			  method: 'GET',
			  url: '/datas/auth/login.json'
			}).then(function successCallback(response) {
				if(response.data.error){
					$location.path("/auth/login");
				}
				else{
					$rootScope.logIn = true;
					$rootScope.id = response.data.success.id;
					$rootScope.Nom = response.data.success.nom;
					$rootScope.Telephone = response.data.success.telephone;
					$rootScope.Prenom = response.data.success.prenom;
					$rootScope.Avatar = response.data.success.Avatar;
					$rootScope.Email = response.data.success.email;
					$rootScope.Permission = response.data.success.permission;
					$rootScope.droits = response.data.success.droits;
					$rootScope.onglets = response.data.success.onglets;
					$rootScope.pageDefault = response.data.success.PageDefault;
					
					var date1 = new Date(response.data.success.DerniereConnexion);
					var date2 = new Date();
					var diffEnMilliseconde = date2-date1;
					if(((date2-date1)/1000/3600) >=4 )
						localStorage.clear();

					angular.forEach($rootScope.onglets, function(value, key) {
						value.groupe = (value.groupe === 1) ? true : false;
						
						var badge = (typeof value.color != "undefined" && value.color != "" && typeof value.content != "undefined" && value.content != "") ? {content: value.content, color  : value.color} : "";
						
						NavigationService.saveItem(value.Path, {
							title : value.title,
							group : value.groupe,
							weight: parseInt(value.weight, 10),
							state: value.state,
							icon: value.icon,
							badge      : badge,
						});
					});
					
			
				}
		});
		}
		
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config( $translateProvider, $provide)
    {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('fr');
        $translateProvider.useSanitizeValueStrategy('sanitize');
		
		// $provide.decorator('taOptions', [
            // '$delegate', function (taOptions)
            // {
                // taOptions.toolbar = [
                    // ['bold', 'italics', 'underline', 'ul', 'ol', 'redo', 'undo','justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent','insertImage','wordcount', 'charcount']
                // ];

                // taOptions.classes = {
                    // focussed           : 'focussed',
                    // toolbar            : 'ta-toolbar',
                    // toolbarGroup       : 'ta-group',
                    // toolbarButton      : 'md-button',
                    // toolbarButtonActive: 'active',
                    // disabled           : '',
                    // textEditor         : 'form-control',
                    // htmlEditor         : 'form-control'
                // };

                // return taOptions;
            // }
        // ]);

        // Text Angular tools
        /* $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]); */
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.parametres.employes', ["app.parametres.employes.employes", "app.parametres.employes.profil"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.parametres.droits', ["app.parametres.droits.droits"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs.frais',
            [
                'app.collaborateurs.frais.frais',
                'app.collaborateurs.frais.edition',
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
      
		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sites',
            [
                'app.sites.liste',
                'app.sites.details',
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
      

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.courriers', ["app.courriers.courriers", "app.courriers.edition"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts',
            [
                'app.contacts.liste',
                'app.contacts.nouveau',
                'app.contacts.liste_produits',
                'app.contacts.profil',
                'app.contacts.corbeille',
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
      

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.commandes',
            [
                'app.commandes.produits',
                'app.commandes.produit',
                'app.commandes.commandes',
                'app.commandes.factures',
                'app.commandes.cdc',
                // 'app.commandes.renouvellements',
                // 'app.commandes.archives',
                'app.commandes.edition',
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
      
		
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.collaborateurs',
            [
                'app.collaborateurs.activites',
                'app.collaborateurs.documents',
                'app.collaborateurs.frais',
                'app.collaborateurs.conges',
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
      

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth', [
            'app.auth.login',
            'app.auth.forgot-password',
            'app.auth.lock'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.analyse',
            [
                'app.analyse.map',
                'app.analyse.resume',
                'app.analyse.notifications',
                'app.analyse.logs',
                'app.analyse.emailstracking',
                
            ]
        )
        .config(config);

    /** @ngInject */
    function config()
    {
      
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.achats', [
            'app.achats.factures',
            'app.commandes.fournisseurs'
        ]);

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><div ng-include=\"\'app/quick-panel/tabs/notifications/notifications.html\'\"></div></md-content>");
$templateCache.put("app/core/dialogs/documents-import.html","<md-dialog class=\"finance-dialog\" aria-label=\"Importer\" flex=\"80\"><form class=\"md-inline-form\" \nenctype=\"multipart/form-data\" name=\"importForm\" ng-submit=\"vm.importer(importForm)\" novalidate><md-dialog-content \nms-scroll><span class=\"md-title\">\n{{vm.categorie === \'achats\' ? \'Importer des factures fournisseurs\' : \'Importer un extrait de compte\'}}</span><p></p>\n<div ng-if=\"!vm.resultat\"><md-input-container md-no-float class=\"md-block\"><label>Format</label><md-select \nng-model=\"vm.format\" required><md-option ng-repeat=\"format in vm.formats\" ng-value=\"format\">{{format}}</md-option>\n</md-select></md-input-container><md-input-container md-no-float class=\"md-block\" ng-if=\"vm.categorie === \'banque\'\">\n<label>Compte bancaire</label><md-select ng-model=\"vm.IDCompte\" required><md-option ng-repeat=\"compte in vm.comptes\" \nng-value=\"compte.IDCompte\">{{compte.Libelle}}</md-option></md-select></md-input-container><p \nng-if=\"vm.format === \'CSV\' && vm.categorie === \'achats\'\">\nColonnes CSV (séparateur ;) : IDFabricant;TypeDocument;NumeroFacture;DateFacture;DateEcheance;TotalHT;TotalTVA. Dates AAAA-MM-JJ, montants décimaux avec un point.\n</p><p ng-if=\"vm.format === \'CSV\' && vm.categorie === \'banque\'\">\nColonnes CSV (séparateur ;) : DateOperation;Libelle;Reference;Debit;Credit. Dates AAAA-MM-JJ, montants décimaux avec un point.\n</p><md-input-container md-no-float class=\"md-block\"><label>Fichier</label><input type=\"file\" name=\"file\" ngf-select \nng-model=\"vm.file\" aria-label=\"Fichier à importer\" \nng-attr-accept=\"{{vm.format === \'CSV\' ? \'.csv\' : (vm.format === \'OFX\' ? \'.ofx\' : \'.pdf\')}}\" required><div \nclass=\"hint font-size-14\">20 Mo maximum</div></md-input-container></div><div ng-if=\"vm.resultat\"><p>\n{{vm.resultat.Importes}} élément(s) importé(s), {{vm.resultat.Doublons}} doublon(s), {{vm.resultat.Rejetes.length}} rejet(s).\n</p><p ng-repeat=\"rejet in vm.resultat.Rejetes\">Ligne {{rejet.Ligne}} : {{rejet.Message}}</p></div><p \nclass=\"md-warn-fg\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.fermer()\" ng-disabled=\"vm.busy\">{{vm.resultat ? \'Fermer\' : \'Annuler\'}}</md-button><md-button \nng-if=\"!vm.resultat\" type=\"submit\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.busy || importForm.$invalid || !vm.autorise()\" aria-label=\"Importer\"><span ng-show=\"!vm.busy\">Importer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.busy\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'min-width: 1400px\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/banque/banque.html","<div id=\"banque\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"banque-sidenav\" \nng-include=\"\'app/main/banque/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"center\" layout=\"column\" flex>\n<div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-wrap layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"search-wrapper\" flex layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'banque-sidenav\')\" hide-gt-md><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search md-whiteframe-2dp\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"banque-search\" \ntype=\"text\" ng-model=\"vm.search\" ng-change=\"vm.searchChange()\" ng-model-options=\"{debounce: 300}\" \nplaceholder=\"Rechercher une opération bancaire\" flex> <button ng-if=\"vm.search\" \nng-click=\"vm.search=\'\';vm.searchChange()\"><md-icon class=\"material-icons-outlined\">cancel</md-icon></button></div>\n</div><div class=\"module-actions\" layout=\"row\" layout-wrap layout-align=\"end center\"><md-button class=\"md-raised\" \nng-if=\"vm.droits(\'statut\') && vm.nombreSelection()\" ng-disabled=\"vm.busy\" ng-click=\"vm.modifierSelection($event)\">\n<md-icon class=\"material-icons-outlined\">published_with_changes</md-icon><span>\nModifier la sélection ({{vm.nombreSelection()}})</span></md-button><md-button class=\"md-raised\" \nng-if=\"vm.droits(\'import\')\" ng-disabled=\"vm.busy\" ng-click=\"vm.importer($event)\"><md-icon \nclass=\"material-icons-outlined\">file_upload</md-icon><span>Importer</span></md-button><md-button class=\"md-raised\" \nng-if=\"vm.droits(\'synchronisation\')\" ng-disabled=\"vm.busy\" ng-click=\"vm.synchroniser()\"><md-icon \nclass=\"material-icons-outlined\">sync</md-icon><span>Synchroniser</span></md-button><md-menu \nng-if=\"vm.droits(\'export\')\"><md-button class=\"md-raised\" ng-click=\"$mdMenu.open($event)\"><md-icon \nclass=\"material-icons-outlined\">file_download</md-icon><span>Exporter</span></md-button><md-menu-content><md-menu-item>\n<md-button ng-click=\"vm.exporter(\'select\')\" ng-disabled=\"!vm.nombreSelection()\"><md-icon \nclass=\"material-icons-outlined\">fact_check</md-icon>La sélection ({{vm.nombreSelection()}})</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.exporter(\'filter\')\"><md-icon class=\"material-icons-outlined\">filter_list\n</md-icon>Les résultats filtrés</md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nclass=\"content-card main scrollable\" flex=\"100\" layout=\"column\"><table \nclass=\"dataTable dataTableBanque row-border hover\" datatable dt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"></table></div></div></div>");
$templateCache.put("app/main/e404/e404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><svg width=\"100%\" height=\"100%\" viewBox=\"0 0 1120 699\" fill=\"none\" \npreserveAspectRatio=\"xMidYMax slice\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0)\"><path \nd=\"M0 51.1424C0 128.64 48.6181 191.351 108.701 191.351L0 51.1424Z\" class=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M108.701 191.351C108.701 112.982 162.956 49.567 230.004 49.567L108.701 191.351Z\" class=\"md-accent-fg\" \nfill=\"currentColor\"/><path d=\"M39.3843 58.1677C39.3843 131.782 70.3872 191.351 108.701 191.351L39.3843 58.1677Z\" \nclass=\"md-accent-fg\" fill=\"currentColor\"/><path \nd=\"M108.701 191.351C108.701 91.2128 171.411 10.1827 248.909 10.1827L108.701 191.351Z\" class=\"blue-grey-800-fg\" \nfill=\"currentColor\"/><path \nd=\"M85.8329 192.339C85.8329 192.339 101.248 191.864 105.894 188.556C110.54 185.248 129.607 181.298 130.76 186.603C131.912 191.909 153.927 212.991 136.522 213.132C119.118 213.272 96.0831 210.421 91.4462 207.596C86.8093 204.772 85.8329 192.339 85.8329 192.339Z\" \nfill=\"#A8A8A8\"/><path opacity=\"0.2\" \nd=\"M136.833 211.285C119.429 211.425 96.3938 208.574 91.7568 205.749C88.2256 203.598 86.8184 195.88 86.3476 192.319C86.0215 192.333 85.8329 192.339 85.8329 192.339C85.8329 192.339 86.8093 204.772 91.4463 207.596C96.0832 210.421 119.118 213.272 136.523 213.132C141.546 213.091 143.282 211.304 143.186 208.656C142.488 210.256 140.572 211.255 136.833 211.285Z\" \nfill=\"black\"/><path opacity=\"0.3\" \nd=\"M198.609 449.94C301.886 449.94 385.609 438.55 385.609 424.5C385.609 410.45 301.886 399.06 198.609 399.06C95.3319 399.06 11.6091 410.45 11.6091 424.5C11.6091 438.55 95.3319 449.94 198.609 449.94Z\" \nclass=\"blue-grey-900-fg dark:text-gray-400\" fill=\"currentColor\"/><path opacity=\"0.3\" \nd=\"M836.609 699C992.906 699 1119.61 681.763 1119.61 660.5C1119.61 639.237 992.906 622 836.609 622C680.313 622 553.609 639.237 553.609 660.5C553.609 681.763 680.313 699 836.609 699Z\" \nclass=\"blue-grey-900-fg dark:text-gray-400\" fill=\"currentColor\"/><path opacity=\"0.3\" \nd=\"M310.609 668.627C404.498 668.627 480.609 658.273 480.609 645.5C480.609 632.727 404.498 622.373 310.609 622.373C216.721 622.373 140.609 632.727 140.609 645.5C140.609 658.273 216.721 668.627 310.609 668.627Z\" \nclass=\"blue-grey-900-fg dark:text-gray-400\" fill=\"currentColor\"/><path \nd=\"M462.609 626C552.609 649 725.609 596 744.609 536\" class=\"blue-grey-800-fg dark:text-gray-600\" stroke=\"currentColor\" \nstroke-width=\"3\" stroke-miterlimit=\"10\"/><path \nd=\"M309.609 259C309.609 259 439.609 223 447.609 339C455.609 455 340.609 488 430.609 511\" \nclass=\"blue-grey-800-fg dark:text-gray-600\" stroke=\"currentColor\" stroke-width=\"3\" stroke-miterlimit=\"10\"/><path \nd=\"M184.011 537.283C184.011 537.283 223.084 526.463 225.488 561.328C227.893 596.192 193.329 606.111 220.379 613.024\" \nclass=\"blue-grey-800-fg dark:text-gray-600\" stroke=\"currentColor\" stroke-width=\"3\" stroke-miterlimit=\"10\"/><path \nd=\"M778.705 563.24L770.827 613.535C770.827 613.535 732.045 634.138 759.314 634.744C786.582 635.35 915.047 634.744 915.047 634.744C915.047 634.744 939.892 634.744 900.504 612.929L892.626 560.21L778.705 563.24Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path opacity=\"0.1\" \nd=\"M753.828 634.198C760.021 628.688 770.827 622.946 770.827 622.946L778.705 572.651L892.626 572.758L900.504 622.34C909.689 627.427 915.379 631.327 918.707 634.318C923.766 633.164 929.295 628.875 900.504 612.929L892.626 560.21L778.705 563.24L770.827 613.535C770.827 613.535 738.239 630.85 753.828 634.198Z\" \nfill=\"black\"/><path \nd=\"M1073.64 212.689H596.479C586.512 212.689 578.433 220.768 578.433 230.734V552.163C578.433 562.129 586.512 570.208 596.479 570.208H1073.64C1083.61 570.208 1091.69 562.129 1091.69 552.163V230.734C1091.69 220.768 1083.61 212.689 1073.64 212.689Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path d=\"M1074.42 231.777H595.703V499.613H1074.42V231.777Z\" \nclass=\"blue-grey-700-fg\" fill=\"currentColor\"/><path \nd=\"M835.06 226.323C836.733 226.323 838.089 224.966 838.089 223.293C838.089 221.62 836.733 220.263 835.06 220.263C833.386 220.263 832.03 221.62 832.03 223.293C832.03 224.966 833.386 226.323 835.06 226.323Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M1091.69 520.822V552.163C1091.69 554.533 1091.22 556.879 1090.31 559.069C1089.41 561.258 1088.08 563.248 1086.4 564.924C1084.73 566.599 1082.74 567.929 1080.55 568.835C1078.36 569.742 1076.01 570.209 1073.64 570.208H596.479C594.109 570.209 591.762 569.742 589.573 568.835C587.383 567.929 585.393 566.599 583.718 564.924C582.042 563.248 580.713 561.258 579.806 559.069C578.899 556.879 578.433 554.533 578.433 552.163V520.822H1091.69Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M968.978 667.466V673.526H642.968V668.678L643.417 667.466L651.452 645.651H962.312L968.978 667.466Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M1094.44 661.534C1093.84 664.073 1091.6 666.751 1086.54 669.284C1068.36 678.373 1031.39 666.86 1031.39 666.86C1031.39 666.86 1002.91 662.012 1002.91 649.287C1003.71 648.739 1004.55 648.244 1005.41 647.803C1013.05 643.759 1038.39 633.781 1083.33 648.225C1086.64 649.264 1089.59 651.202 1091.87 653.822C1093.69 655.954 1095.12 658.657 1094.44 661.534Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path opacity=\"0.1\" \nd=\"M1094.44 661.534C1072.19 670.06 1052.35 670.696 1032 656.559C1021.73 649.432 1012.41 647.669 1005.41 647.802C1013.05 643.759 1038.39 633.781 1083.33 648.225C1086.64 649.264 1089.59 651.202 1091.87 653.822C1093.69 655.953 1095.12 658.657 1094.44 661.534Z\" \nfill=\"black\"/><path \nd=\"M1066.54 656.559C1070.89 656.559 1074.42 655.473 1074.42 654.135C1074.42 652.796 1070.89 651.711 1066.54 651.711C1062.19 651.711 1058.66 652.796 1058.66 654.135C1058.66 655.473 1062.19 656.559 1066.54 656.559Z\" \nclass=\"text-gray-100\" fill=\"currentColor\"/><path \nd=\"M835.06 557.18C841.418 557.18 846.573 552.026 846.573 545.667C846.573 539.308 841.418 534.154 835.06 534.154C828.701 534.154 823.546 539.308 823.546 545.667C823.546 552.026 828.701 557.18 835.06 557.18Z\" \nclass=\"text-gray-100\" fill=\"currentColor\"/><path opacity=\"0.1\" \nd=\"M968.978 667.466V673.526H642.968V668.678L643.417 667.466H968.978Z\" fill=\"black\"/><path \nd=\"M316.609 159H108.609V401H316.609V159Z\" class=\"blue-grey-700-fg\" fill=\"currentColor\"/><path \nd=\"M337.609 135H87.6091V221H337.609V135Z\" class=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M337.609 237H87.6091V323H337.609V237Z\" class=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M337.609 339H87.6091V425H337.609V339Z\" class=\"blue-grey-800-fg\" fill=\"currentColor\"/><path opacity=\"0.4\" \nd=\"M277.609 150H261.609V166H277.609V150Z\" class=\"md-accent-fg\" fill=\"currentColor\"/><path opacity=\"0.8\" \nd=\"M300.609 150H284.609V166H300.609V150Z\" class=\"md-accent-fg\" fill=\"currentColor\"/><path \nd=\"M323.609 150H307.609V166H323.609V150Z\" class=\"md-accent-fg\" fill=\"currentColor\"/><path opacity=\"0.4\" \nd=\"M277.609 251H261.609V267H277.609V251Z\" class=\"md-accent-fg\" fill=\"currentColor\"/><path opacity=\"0.8\" \nd=\"M300.609 251H284.609V267H300.609V251Z\" class=\"md-accent-fg\" fill=\"currentColor\"/><path \nd=\"M323.609 251H307.609V267H323.609V251Z\" class=\"md-accent-fg\" fill=\"currentColor\"/><path opacity=\"0.4\" \nd=\"M277.609 352H261.609V368H277.609V352Z\" class=\"md-accent-fg\" fill=\"currentColor\"/><path opacity=\"0.8\" \nd=\"M300.609 352H284.609V368H300.609V352Z\" class=\"md-accent-fg\" fill=\"currentColor\"/><path \nd=\"M323.609 352H307.609V368H323.609V352Z\" class=\"md-accent-fg\" fill=\"currentColor\"/><path \nd=\"M316.609 617C360.24 617 395.609 581.63 395.609 538C395.609 494.37 360.24 459 316.609 459C272.979 459 237.609 494.37 237.609 538C237.609 581.63 272.979 617 316.609 617Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path d=\"M304.609 600H280.609V643H304.609V600Z\" class=\"blue-grey-800-fg\" \nfill=\"currentColor\"/><path d=\"M352.609 600H328.609V643H352.609V600Z\" class=\"blue-grey-800-fg\" fill=\"currentColor\"/>\n<path \nd=\"M300.609 651C311.655 651 320.609 647.642 320.609 643.5C320.609 639.358 311.655 636 300.609 636C289.563 636 280.609 639.358 280.609 643.5C280.609 647.642 289.563 651 300.609 651Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M348.609 650C359.655 650 368.609 646.642 368.609 642.5C368.609 638.358 359.655 635 348.609 635C337.563 635 328.609 638.358 328.609 642.5C328.609 646.642 337.563 650 348.609 650Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M318.609 545C333.521 545 345.609 532.912 345.609 518C345.609 503.088 333.521 491 318.609 491C303.697 491 291.609 503.088 291.609 518C291.609 532.912 303.697 545 318.609 545Z\" \nclass=\"blue-grey-50-fg\" fill=\"currentColor\"/><path \nd=\"M318.609 527C323.58 527 327.609 522.971 327.609 518C327.609 513.029 323.58 509 318.609 509C313.639 509 309.609 513.029 309.609 518C309.609 522.971 313.639 527 318.609 527Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M239.976 464.532C233.598 435.965 253.988 407.098 285.52 400.057C317.053 393.017 347.786 410.467 354.164 439.035C360.543 467.603 339.646 478.139 308.114 485.18C276.582 492.221 246.355 493.1 239.976 464.532Z\" \nclass=\"md-accent-fg\" fill=\"currentColor\"/><path \nd=\"M390.703 522.244C410.759 513.66 424.833 501.597 422.138 495.301C419.443 489.005 401 490.86 380.945 499.444C360.889 508.028 346.816 520.09 349.511 526.386C352.205 532.682 370.648 530.827 390.703 522.244Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M242.703 575.244C262.759 566.66 276.833 554.597 274.138 548.301C271.443 542.005 253 543.86 232.945 552.444C212.889 561.027 198.816 573.09 201.511 579.386C204.205 585.682 222.648 583.827 242.703 575.244Z\" \nclass=\"blue-grey-800-fg\" fill=\"currentColor\"/><path \nd=\"M362.609 561C362.609 568.732 342.7 584 320.609 584C298.518 584 277.609 569.732 277.609 562C277.609 554.268 298.518 556 320.609 556C342.7 556 362.609 553.268 362.609 561Z\" \nclass=\"blue-grey-50-fg\" fill=\"currentColor\"/></g><defs><clipPath id=\"clip0\"><rect width=\"1119.61\" height=\"699\" \nfill=\"white\"/></clipPath></defs></svg><div class=\"error-code mt-50\">Ooops... 404</div><div \nclass=\"message blue-grey-600-fg\">La page que vous cherchez n\'existe pas.</div><br><br><md-button \nclass=\"md-raised md-accent mt-32\" ng-click=\"vm.goIndex()\">Retourner à l\'accueil</md-button></div></div>");
$templateCache.put("app/main/sample/sample.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s26\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Nom, téléphone, adresse ...\" flex ng-model=\"MsSearchBar.query\" \nng-model-options=\"MsSearchBar.queryOptions\" ng-blur=\"MsSearchBar.collapse()\" \nng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button class=\"ms-search-bar-collapser md-icon-button\" \nng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\"><md-icon class=\"material-icons-outlined icon s26\">\ncancel</md-icon></md-button><div class=\"ms-search-bar-results\" ng-if=\"MsSearchBar.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">Aucun résultat!</div><div class=\"result\" \nng-repeat=\"result in MsSearchBar.results\" \nng-click=\"(!result.url)?MsSearchBar.handleResultClick(result):MsSearchBar.gopagesearch(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"material-icons-outlined icon\">{{result.icon}}</i><div ng-if=\"!result.icon\" \nclass=\"square md-accent-bg\"></div></div><div><div class=\"title\" ng-bind-html=\"result.title\"></div><div \nclass=\"description\" ng-if=\"result.description\" ng-bind-html=\"result.description\"></div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo pb-16\" \nlayout=\"row\" layout-align=\"start center\"><img class=\"logo-image\" src=\"/assets/images/logos/logo-ExodreamNB2021.svg\"> \n<img class=\"logo-image-mini\" src=\"/assets/images/logos/exo2021.png\" \nstyle=\"display:none; width: 30px;max-width: 30px;min-width: 0px;max-height: 30px;min-height: 0px\"></div></md-toolbar>\n<div class=\"scrollable\"><div class=\"navigation-user\" layout=\"column\" layout-align=\"space-between center\"><div \nclass=\"h3 username\">{{Prenom}} {{Nom}}</div><div class=\"h5 email hint-text mt-8\">{{Email}}</div><div \nclass=\"avatar-container fuse-navy-700\"><img class=\"avatar\" \nsrc=\"{{Avatar ? Avatar : \'assets/images/avatars/profile.jpg\'}}\"></div></div><ms-navigation folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/notifications/notifications.html","<md-toolbar class=\"md-light-blue-600-bg\"><div class=\"md-toolbar-tools\"><h3 class=\"ng-binding\">Notifications</h3><span \nflex=\"\" class=\"flex\"></span><md-icon ng-show=\"vm.notifications.length\" md-font-icon=\"material-icons-outlined\" \nclass=\"icon s26 material-icons-outlined\">notifications_active</md-icon><md-icon ng-hide=\"vm.notifications.length\" \nmd-font-icon=\"material-icons-outlined\" class=\"icon s26 material-icons-outlined\">notifications</md-icon></div>\n</md-toolbar><md-list class=\"p-0\"><md-list-item class=\"md-1-line\" ng-hide=\"vm.notifications.length\"><div \nclass=\"md-list-item-text\" layout=\"column\">Aucune notification pour le moment</div></md-list-item><md-list-item \nclass=\"md-long-text height-120 border-bottom\" class=\"server md-2-line md-long-text\" \nng-repeat=\"notification in vm.notifications\" ng-click=\"vm.TraiternotificationToolbar($event, notification)\"><div \nlayout=\"column\" flex><div layout=\"row\" flex layout-align=\"space-between center\"><h4 \nclass=\"font-weight-500 m-0 line-height-24\"><md-icon class=\"md-warn material-icons-outlined mr-6 s18\" \nng-if=\"notification.Type == \'Danger\' || notification.Type == \'danger\'\">report_problem</md-icon><md-icon \nclass=\"amber-500-fg material-icons-outlined mr-6 s18\" \nng-if=\"notification.Type == \'Warning\' || notification.Type == \'warning\'\">report_problem</md-icon><md-icon \nclass=\"md-accent material-icons-outlined mr-6 s18\" ng-if=\"notification.Type == \'Info\' || notification.Type == \'info\'\">\ninfo</md-icon><md-icon class=\"green-800-fg material-icons-outlined mr-6 s18\" \nng-if=\"notification.Type == \'Success\' || notification.Type == \'success\'\">info</md-icon>{{notification.Commercial}}\n<md-tooltip md-direction=\"left\" ng-if=\"notification.CommercialSupprime!=0\">Commercial supprimé</md-tooltip></h4><p \nclass=\"m-0 line-height-24 blue-grey-300-fg font-size-12\">{{notification.Date.replace(\" \",\"T\") | date:\'dd/MM/yyyy\'}}</p>\n</div><div class=\"md-list-item-text\" layout=\"column\"><p class=\"m-0 line-height-20 blue-grey-700-fg\" \nng-bind-html=\"notification.Alerte\">{{notification.Alerte}}</p></div></div></md-list-item></md-list><md-menu-divider>\n</md-menu-divider>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/main/achats/factures/factures-achats.html","<div id=\"factures-achats\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"factures-achats-sidenav\" \nng-include=\"\'app/main/achats/factures/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-wrap layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"search-wrapper\" flex layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'factures-achats-sidenav\')\" hide-gt-md>\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search md-whiteframe-2dp\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nid=\"factures-achats-search\" type=\"text\" ng-model=\"vm.search\" ng-change=\"vm.searchChange()\" \nng-model-options=\"{debounce: 300}\" placeholder=\"Rechercher une facture fournisseur\" flex> <button ng-if=\"vm.search\" \nng-click=\"vm.search=\'\';vm.searchChange()\"><md-icon class=\"material-icons-outlined\">cancel</md-icon></button></div>\n</div><div class=\"module-actions\" layout=\"row\" layout-wrap layout-align=\"end center\"><md-button class=\"md-raised\" \nng-if=\"vm.droits(\'statut\') && vm.nombreSelection()\" ng-disabled=\"vm.busy\" ng-click=\"vm.modifierSelection($event)\">\n<md-icon class=\"material-icons-outlined\">published_with_changes</md-icon><span>\nModifier la sélection ({{vm.nombreSelection()}})</span></md-button><md-button class=\"md-raised\" \nng-if=\"vm.droits(\'import\')\" ng-disabled=\"vm.busy\" ng-click=\"vm.importer($event)\"><md-icon \nclass=\"material-icons-outlined\">file_upload</md-icon><span>Importer</span></md-button><md-button class=\"md-raised\" \nng-if=\"vm.droits(\'synchronisation\')\" ng-disabled=\"vm.busy\" ng-click=\"vm.synchroniser()\"><md-icon \nclass=\"material-icons-outlined\">sync</md-icon><span>Synchroniser</span></md-button><md-button class=\"md-raised\" \nng-if=\"vm.peutValiderFournisseurs() && vm.propositionsTotal\" ng-disabled=\"vm.busy\" \nng-click=\"vm.validerFournisseurs($event)\"><md-icon class=\"material-icons-outlined\">person_add</md-icon><span>\nFournisseurs à valider ({{vm.propositionsTotal}})</span></md-button><md-menu ng-if=\"vm.droits(\'export\')\"><md-button \nclass=\"md-raised\" ng-click=\"$mdMenu.open($event)\"><md-icon class=\"material-icons-outlined\">file_download</md-icon>\n<span>Exporter</span></md-button><md-menu-content><md-menu-item><md-button ng-click=\"vm.exporter(\'select\')\" \nng-disabled=\"!vm.nombreSelection()\"><md-icon class=\"material-icons-outlined\">fact_check</md-icon>\nLa sélection ({{vm.nombreSelection()}})</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.exporter(\'filter\')\"><md-icon class=\"material-icons-outlined\">filter_list</md-icon>Les résultats filtrés\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-card main scrollable\" \nflex=\"100\" layout=\"column\"><table class=\"dataTable dataTableFacturesAchats row-border hover\" datatable \ndt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"></table></div></div></div>");
$templateCache.put("app/main/analyse/emails_tracking/emails_tracking.html","<div id=\"emails_tracking\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"white-fg pr-32\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"material-icons-outlined s28\">all_inbox\n</md-icon><span class=\"ml-10\">Emails tracking</span></div><div class=\"emails_tracking-count secondary-text\"><span>\n{{vm.recordsTotal}} emails suivis</span></div></div><div><md-button class=\"md-raised\" \nng-click=\"vm.editEmailTrack($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span>Ajouter</span></md-button></div>\n</div><div layout=\"row\" flex layout-align=\"space-between \"><div class=\"content-card\" flex=\"100\" layout=\"column\" flex>\n<div class=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table \nclass=\"dataTable dataTableEmailsTracking row-border hover\" datatable dt-instance=\"vm.dtInstance\" \ndt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"></table></div></div></div></div></div>");
$templateCache.put("app/main/analyse/logs/logs.html","<div id=\"logs\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"white-fg pr-32\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"material-icons-outlined s28\">info</md-icon><span \nclass=\"ml-8\">Logs</span></div><div class=\"log-count secondary-text\"><span>{{vm.recordsTotal}} logs</span></div></div>\n<div class=\"search md-whiteframe-2dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"logs-search\" class=\"search\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"Rechercher\" flex> <button ng-if=\"vm.search\" \nng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');\"><md-icon class=\"material-icons-outlined\">cancel</md-icon>\n</button></div></div><div layout=\"row\" flex layout-align=\"space-between \"><div class=\"content-card\" flex=\"100\" \nlayout=\"column\" flex><div class=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table \nclass=\"dataTable dataTableLogs row-border hover\" datatable dt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"></table></div></div></div></div></div>");
$templateCache.put("app/main/analyse/map/map.html","<div id=\"dashboard-map\"><ng-map zoom=\"8\" id=\"map\" dorebuildall=\"true\" scrollwheel=\"true\" maximum-zoom=\"12\" \ncenter=\"[{{vm.lat}}, {{vm.lng}}]\"></ng-map><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-1dp brad-16\" flex layout=\"row\" layout-align=\"start center\"><div class=\"search\" \nflex layout=\"row\" layout-align=\"start center\"><md-icon class=\"material-icons-outlined icon s24\">search</md-icon><input \nid=\"map-search\" class=\"search-input\" flex ng-model=\"vm.search\" ng-change=\"vm.updateMarkers()\" type=\"text\" \nplaceholder=\"Rechercher\"> <button ng-if=\"vm.search\" \nng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');vm.updateMarkers()\"><md-icon class=\"material-icons-outlined\">\ncancel</md-icon></button></div></div></div><md-menu><md-button class=\"ph-16 md-raised\" ng-click=\"$mdMenu.open()\" \nmd-menu-origin md-menu-align-target><md-icon class=\"material-icons-outlined\">filter_alt</md-icon>\n{{vm.filter.length}}/6 filtres</md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.checkfilter(\'Client\')\" class=\"green-bg white-fg\"><md-icon md-menu-align-target class=\"green-bg white-fg\" \nmd-font-icon=\"{{vm.is(\'Client\') ? \'icon-checkbox-marked-outline\' : \'icon-checkbox-blank-outline\'}}\"></md-icon>Client\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.checkfilter(\'Prospect\')\" \nclass=\"md-cyan-700-bg white-fg\"><md-icon md-menu-align-target class=\"md-cyan-700-bg white-fg\" \nmd-font-icon=\"{{vm.is(\'Prospect\') ? \'icon-checkbox-marked-outline\' : \'icon-checkbox-blank-outline\'}}\"></md-icon>\nProspect</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.checkfilter(\'Suspect\')\" \nclass=\"md-blue-grey-500-bg white-fg\"><md-icon md-menu-align-target class=\"md-blue-grey-500-bg white-fg\" \nmd-font-icon=\"{{vm.is(\'Suspect\') ? \'icon-checkbox-marked-outline\' : \'icon-checkbox-blank-outline\'}}\"></md-icon>Suspect\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.checkfilter(\'Annulé\')\" \nclass=\"md-grey-500-bg white-fg\"><md-icon md-menu-align-target class=\"md-grey-500-bg white-fg\" \nmd-font-icon=\"{{vm.is(\'Annulé\') ? \'icon-checkbox-marked-outline\' : \'icon-checkbox-blank-outline\'}}\"></md-icon>Annulé\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.checkfilter(\'Ancien client\')\" \nclass=\"md-red-500-bg white-fg\"><md-icon md-menu-align-target class=\"md-red-500-bg white-fg\" \nmd-font-icon=\"{{vm.is(\'Ancien client\') ? \'icon-checkbox-marked-outline\' : \'icon-checkbox-blank-outline\'}}\"></md-icon>\nAncien client</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.checkfilter(\'Fin d\\\'activité\')\" \nclass=\"md-grey-500-bg white-fg\"><md-icon md-menu-align-target class=\"md-grey-500-bg white-fg\" \nmd-font-icon=\"{{vm.is(\'Fin d\\\'activité\') ? \'icon-checkbox-marked-outline\' : \'icon-checkbox-blank-outline\'}}\"></md-icon>\nFin d\'activité</md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/main/analyse/notifications/notifications.html","<div id=\"notifications\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"white-fg pr-32\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"material-icons-outlined s28\">\nnotifications_active</md-icon><span class=\"ml-10\">Notifications</span></div><div \nclass=\"notification-count secondary-text\"><span>{{vm.recordsTotal}} notifications</span></div></div><div \nclass=\"search md-whiteframe-2dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input id=\"notifications-search\" class=\"search\" type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"Rechercher\" flex> <button ng-if=\"vm.search\" ng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');\">\n<md-icon class=\"material-icons-outlined\">cancel</md-icon></button></div></div><div layout=\"row\" flex \nlayout-align=\"space-between \"><div class=\"content-card\" flex=\"100\" layout=\"column\" flex><div \nclass=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table \nclass=\"dataTable dataTableNotif row-border hover\" datatable dt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"></table></div></div></div></div></div>");
$templateCache.put("app/main/analyse/resume/resume.html","<div id=\"dashboard-analytics\"><div class=\"widget-group data-chart md-blue-900-bg white-fg\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"row\" class=\"\" flex=\"100\" id=\"ca\"><ms-widget-front class=\"b-0\"><div class=\"ph-16 pv-8\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div layout=\"column\" layout-align=\"start start\" flex=\"33\">\n<div class=\"h2 weight-500\">{{vm.statistiques.config.chart.data[0].key}}</div><div class=\"h4 secondary-text\">\nCourbes mensuelles Hors-Taxes</div></div><div class=\"pv-8\" layout=\"row\" layout-align=\"center center\" \nlayout-align-sm=\"end\" flex=\"33\" flex-sm=\"100\" id=\"chartType\"><md-button class=\"ph-16 md-raised\" \nng-click=\"vm.statistiques.config.changeCourbe(\'chartFactures\')\" \nng-disabled=\"vm.statistiques.config.currentCourbe == \'chartFactures\'\">Facturé</md-button><md-button \nclass=\"ph-16 md-raised\" ng-if=\"Permission == \'Super Admin\'\" ng-click=\"vm.statistiques.config.changeCourbe(\'chartTVA\')\" \nng-disabled=\"vm.statistiques.config.currentCourbe == \'chartTVA\'\">TVA</md-button><md-button class=\"ph-16 md-raised\" \nng-click=\"vm.statistiques.config.changeCourbe(\'chartMarges\')\" \nng-disabled=\"vm.statistiques.config.currentCourbe == \'chartMarges\'\">Marge brute</md-button><md-button \nclass=\"ph-16 md-raised\" ng-click=\"vm.statistiques.config.changeCourbe(\'chartPotentiel\')\" \nng-disabled=\"vm.statistiques.config.currentCourbe == \'chartPotentiel\'\">Potentiel</md-button><md-button \nclass=\"ph-16 md-raised\" ng-click=\"vm.statistiques.config.changeCourbe(\'chartCA\')\" \nng-disabled=\"vm.statistiques.config.currentCourbe == \'chartCA\'\">Payé</md-button></div><div class=\"pv-8\" layout=\"row\" \nlayout-align=\"end center\" layout-align-sm=\"end\" flex-sm=\"100\" flex=\"33\"><md-menu md-offset=\"0 48\" class=\"mr-8\" \nng-if=\"Permission == \'Super Admin\'\"><md-button class=\"ph-16 md-raised\" ng-click=\"$mdMenu.open()\" md-menu-origin \nmd-menu-align-target><span ng-bind-html=\"vm.currentEmployes\"></span><md-icon md-font-icon=\"icon-chevron-down\" \nstyle=\"margin-top: -5px\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item>\n<md-button ng-click=\"vm.changeEmploye(\'all\')\" aria-label=\"{{employe}}\"><span \nng-class=\"{\'secondary-text\': vm.currentEmployes == \'Tout le monde\'}\">Tout le monde</span></md-button></md-menu-item>\n<md-menu-item ng-repeat=\"(key, employe) in vm.employes\"><md-button ng-click=\"vm.changeEmploye(employe)\" \naria-label=\"{{employe}}\"><span \nng-class=\"{\'secondary-text\': vm.currentEmployes == (employe.Prenom +\' \'+ employe.Nom+ \' \' +employe.Permission)}\">\n{{employe.Prenom}} {{employe.Nom}} <small>({{employe.Permission}})</small></span></md-button></md-menu-item>\n</md-menu-content></md-menu><md-menu md-offset=\"0 48\"><md-button class=\"ph-16 md-raised\" ng-click=\"$mdMenu.open()\" \nmd-menu-origin md-menu-align-target>{{vm.statistiques.config.currentRange.replace(\"A\",\"\")}}<md-icon \nmd-font-icon=\"icon-chevron-down\" style=\"margin-top: -5px\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"(key, range) in vm.statistiques.resume.ranges\"><md-button \nng-click=\"vm.statistiques.config.changeRange(key)\" aria-label=\"{{range}}\"><span \nng-class=\"{\'secondary-text\': vm.statistiques.config.currentRange == key}\">{{range}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"\" layout=\"column\" flex=\"100\" layout-align=\"center\"><div layout=\"row\">\n<div><div class=\"h4 secondary-text\">ANNUEL RÉEL</div><div layout=\"row\" layout-align=\"start end\"><div \nclass=\"md-headline\">\n{{vm.statistiques.resume.values[vm.statistiques.config.currentCourbe].count[vm.statistiques.config.currentRange] | currency:\'€\'}}\n</div></div></div><div class=\"ml-32\" \nng-if=\"vm.statistiques.config.currentRange == (\'A\'+vm.year) && vm.statistiques.resume.values[vm.statistiques.config.currentCourbe].prevision[vm.statistiques.config.currentRange]\">\n<div class=\"h4 secondary-text\">PRÉVISION TEMPS RÉEL</div><div layout=\"row\" layout-align=\"start end\"><div \nclass=\"md-headline\">\n{{vm.statistiques.resume.values[vm.statistiques.config.currentCourbe].prevision[vm.statistiques.config.currentRange] | currency:\'€\'}}\n</div></div></div><div class=\"ml-32\" \nng-if=\"vm.statistiques.resume.values[vm.statistiques.config.currentCourbe].prevision[vm.statistiques.config.currentRange]\">\n<div class=\"h4 secondary-text\">\n{{vm.statistiques.config.currentRange == (\"A\"+vm.year) ? \"RENOUVELLEMENTS RESTANTS\" : \"PRÉVISION INITIALE\"}}</div><div \nlayout=\"row\" layout-align=\"start end\"><div class=\"md-headline\">\n{{vm.statistiques.resume.values[vm.statistiques.config.currentCourbe].renouvellements[vm.statistiques.config.currentRange] | currency:\'€\'}}\n</div></div></div><div class=\"ml-32\" \nng-if=\"vm.statistiques.config.currentRange == (\'A\'+vm.year) && vm.statistiques.resume.values[vm.statistiques.config.currentCourbe].prevision[vm.statistiques.config.currentRange]\">\n<div class=\"h4 secondary-text\">POTENTIEL</div><div layout=\"row\" layout-align=\"start end\"><div class=\"md-headline\">\n{{vm.statistiques.resume.values[vm.statistiques.config.currentCourbe].potentiel[vm.statistiques.config.currentRange] | currency:\'€\'}}\n</div></div></div></div><nvd3 id=\"chart\" class=\"h-250\" hide show-gt-md config=\"vm.statistiques.config.chart.config\" \noptions=\"vm.statistiques.config.chart.options\" data=\"vm.statistiques.config.chart.data\"></nvd3></div></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group animate-slide-down\" layout=\"row\" flex=\"100\" layout-wrap \nng-show=\"vm.showDetailVisible\"><ms-widget layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 red-400-bg white-fg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><button \nclass=\"md-icon-button\" ng-click=\"vm.changeMonth(vm.monthNumber-1)\" ng-hide=\"vm.monthNumber<=1\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></button><div class=\"h3 pl-8 pr-8 pt-16 pb-16\">\nDétail {{vm.monthDetail}} {{vm.statistiques.config.currentRange.replace(\"A\",\"\")}}</div><button class=\"md-icon-button\" \nng-click=\"vm.changeMonth(vm.monthNumber+1)\" ng-hide=\"vm.monthNumber>=12\"><md-icon md-font-icon=\"icon-arrow-right\">\n</md-icon></button></div><button ng-click=\"vm.closeDetails()\"><md-icon md-font-icon=\"icon-close\"></md-icon></button>\n</div><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"{{table.titre}}\" \nng-repeat=\"table in vm.showDetail.tables\"><md-content class=\"md-padding\"><div class=\"simple-table-container\" \nms-responsive-table><table class=\"simple\"><thead ng-if=\"table.th\"><tr><th class=\"black-fg\" ng-repeat=\"th in table.th\">\n<strong>{{th}}</strong></th></tr></thead><tbody ng-if=\"table.tr \"><tr ng-repeat=\"tr in table.tr track by $index\"><td \nng-repeat=\"td in tr track by $index\" compile=\"td\">sdf</td></tr><tr></tr></tbody></table></div></md-content></md-tab>\n</md-tabs></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.resume.widgets\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"{{widget.flex[\'gt-xs\']}}\" \nflex-gt-md=\"{{widget.flex[\'gt-md\']}}\" ng-repeat=\"(key,widget) in vm.resume.widgets\"><ms-widget-front \nclass=\"h-170 p-16\" ng-class=\"widget.background\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"h4 font-weight-500 secondary-text text-uppercase\">{{widget.titre}}</div><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\" ng-if=\"widget.infos\">Infos</md-button></div><div class=\"\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"md-display-1\" layout=\"row\" layout-align=\"start center\"><span>\n{{widget.valeur}}</span><md-icon md-font-icon=\"icon-trending-up\" ng-if=\"widget.evolution==\'up\'\" class=\"s36 ml-16\">\n</md-icon><md-icon md-font-icon=\"icon-trending-down\" ng-if=\"widget.evolution==\'down\'\" class=\"s36 ml-16\"></md-icon>\n</div><div class=\"pb-16\" ng-if=\"widget.progression\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{widget.progression}}\"></md-progress-linear></div><div layout=\"row\" layout-align=\"start center\"><span>\n{{widget.datePrecedente}} : {{widget.valeurPrecedente}}</span> <span class=\"text-boxed-light\" ng-class=\"widget.boxed\" \nng-show=\"widget.differencePrecedente\">{{widget.differencePrecedente}}</span></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16\" ng-class=\"widget.background\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div ng-bind-html=\"widget.infos\"></div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap ng-if=\"vm.resume.tables\"><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-xs=\"{{table.flex[\'gt-xs\']}}\" flex-gt-md=\"{{table.flex[\'gt-md\']}}\" ng-repeat=\"(key2,table) in vm.resume.tables\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h3 pl-8 pt-16 pb-16 text-uppercase\">{{table.titre}}</div><md-button ng-if=\"table.lien\" \nng-href=\"{{table.lien}}\">Voir plus</md-button></div><div class=\"simple-table-container\" ms-responsive-table><table \nclass=\"simple\"><thead ng-if=\"table.th\"><tr><th class=\"black-fg\" ng-repeat=\"th in table.th\"><strong>{{th}}</strong></th>\n</tr></thead><tbody ng-if=\"table.tr\"><tr ng-repeat=\"tr in table.tr\"><td ng-repeat=\"td in tr\" ng-bind-html=\"td\"></td>\n</tr><tr></tr></tbody></table></div></ms-widget-front></ms-widget></div></div>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><svg class=\"absolute inset-0 pointer-events-none\" viewBox=\"0 0 960 540\" \nwidth=\"100%\" height=\"100%\" preserveAspectRatio=\"xMidYMax slice\" xmlns=\"http://www.w3.org/2000/svg\"><g \nclass=\"opacity-25\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"100\"><circle r=\"234\" cx=\"196\" cy=\"23\"></circle>\n<circle r=\"234\" cx=\"790\" cy=\"491\"></circle></g></svg> <svg class=\"absolute right\" viewBox=\"0 0 220 192\" width=\"220\" \nheight=\"192\" fill=\"none\"><defs><pattern id=\"837c3e70-6c3a-44e6-8854-cc48c737b659\" x=\"0\" y=\"0\" width=\"20\" height=\"20\" \npatternUnits=\"userSpaceOnUse\"><rect x=\"0\" y=\"0\" width=\"4\" height=\"4\" fill=\"currentColor\"></rect></pattern></defs><rect \nwidth=\"220\" height=\"192\" fill=\"url(#837c3e70-6c3a-44e6-8854-cc48c737b659)\"></rect></svg><div id=\"forgot-password-form\" \nclass=\"relative md-whiteframe-8dp brad-16\"><span><img src=\"/assets/images/logos/exo2021.svg\" width=\"130px\"></span><div \nclass=\"title\">Récupérer mon mot de passe</div><form name=\"forgotPasswordForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Saisissez votre adresse email\" ng-pattern=\"/^.+@.+\\..+$/\" required \nng-change=\"forgotPasswordForm.email.$setValidity(\'loginFailed\', true)\"><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ce champ est obligatoire\n</span></div><div ng-message=\"pattern\"><span>Vous devez entrer une adresse e-mail valide</span></div><div \nng-message=\"loginFailed\"><span>{{status}}</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button circular-progress-button\" aria-label=\"Récupérer\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" ng-click=\"submit()\" \nlayout-align=\"center center\"><span ng-show=\"!showSpinner\">Récupérer</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"showSpinner\"></md-progress-circular></md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.auth_login\">Retour à la connexion\n</a></div></div></div></div>");
$templateCache.put("app/main/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><svg class=\"absolute inset-0 pointer-events-none\" viewBox=\"0 0 960 540\" width=\"100%\" \nheight=\"100%\" preserveAspectRatio=\"xMidYMax slice\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"opacity-25\" \nfill=\"none\" stroke=\"currentColor\" stroke-width=\"100\"><circle r=\"234\" cx=\"196\" cy=\"23\"></circle><circle r=\"234\" \ncx=\"790\" cy=\"491\"></circle></g></svg> <svg class=\"absolute right\" viewBox=\"0 0 220 192\" width=\"220\" height=\"192\" \nfill=\"none\"><defs><pattern id=\"837c3e70-6c3a-44e6-8854-cc48c737b659\" x=\"0\" y=\"0\" width=\"20\" height=\"20\" \npatternUnits=\"userSpaceOnUse\"><rect x=\"0\" y=\"0\" width=\"4\" height=\"4\" fill=\"currentColor\"></rect></pattern></defs><rect \nwidth=\"220\" height=\"192\" fill=\"url(#837c3e70-6c3a-44e6-8854-cc48c737b659)\"></rect></svg><div id=\"lock-form\" \nclass=\"md-whiteframe-8dp relative brad-16\"><div layout=\"row\" layout-align=\"start center\" layout-sm=\"column\" \nlayout-align-sm=\"center center\"><div class=\"avatar-container\"><span><img src=\"/assets/images/logos/exo2021.svg\" \nwidth=\"90px\"></span><md-icon md-font-icon=\"icon-lock\" class=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex \nlayout=\"column\" layout-align=\"start\" layout-align-sm=\"center center\"><div class=\"h3 mb-8\">Votre session est verrouillée\n</div><div class=\"subtitle\">\nEn raison de votre inactivité, nous avons verrouillé votre session. Saisissez votre mot de passe pour continuer.</div>\n</div></div><form name=\"lockForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \nng-model=\"vm.form.email\" name=\"email\" type=\"hidden\"></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input ng-model=\"vm.form.username\" placeholder=\"E-mail\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Mot de passe\" required ng-change=\"lockForm.password.$setValidity(\'loginFailed\', true)\"><div \nng-messages=\"lockForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ce champ est obligatoire</span>\n</div><div ng-message=\"loginFailed\"><span>{{status}}</span></div></div></md-input-container><center><small>\n{{StatutConnexion}}</small></center><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button circular-progress-button\" aria-label=\"Déverrouiller\" \nng-disabled=\"lockForm.$invalid || lockForm.$pristine\" ng-click=\"submit()\" layout-align=\"center center\"><span \nng-show=\"!showSpinner\">Déverrouiller</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"showSpinner\"></md-progress-circular></md-button></form><div class=\"message\"><a ui-sref=\"app.auth_login\" \nclass=\"md-accent-color\"><span>Vous n\'êtes pas</span><span> {{Prenom}} {{Nom}} ?</span></a></div></div></div></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"center\"><div id=\"login-v2-intro\" flex hide show-gt-sm layout=\"row\" \nlayout-align=\"start   \"><svg class=\"absolute inset-0 pointer-events-none\" viewBox=\"0 0 960 540\" width=\"100%\" \nheight=\"100%\" preserveAspectRatio=\"xMidYMax slice\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"opacity-25\" \nfill=\"none\" stroke=\"currentColor\" stroke-width=\"100\"><circle r=\"234\" cx=\"196\" cy=\"23\"></circle><circle r=\"234\" \ncx=\"790\" cy=\"491\"></circle></g></svg> <svg class=\"absolute right\" viewBox=\"0 0 220 192\" width=\"220\" height=\"192\" \nfill=\"none\"><defs><pattern id=\"837c3e70-6c3a-44e6-8854-cc48c737b659\" x=\"0\" y=\"0\" width=\"20\" height=\"20\" \npatternUnits=\"userSpaceOnUse\"><rect x=\"0\" y=\"0\" width=\"4\" height=\"4\" fill=\"currentColor\"></rect></pattern></defs><rect \nwidth=\"220\" height=\"192\" fill=\"url(#837c3e70-6c3a-44e6-8854-cc48c737b659)\"></rect></svg><div class=\"relative\"><div \nclass=\"logo\"><span><img src=\"/assets/images/logos/logo-ExodreamNB2021.svg\"></span></div><div class=\"title\">\nProgiciel de gestion intégré</div><div class=\"description mt-16 blue-grey-A200-fg\"></div></div></div><div \nid=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div \nclass=\"logo pt-16\" hide-gt-sm><span><img src=\"/assets/images/logos/logo-ExodreamN2021.svg\"></span></div><img \nsrc=\"/assets/images/logos/exo2021.svg\" class=\"width-60 mb-30 hide-sm hide-xs\"><div class=\"title\">CONNECTEZ-VOUS !</div>\n<div class=\"description\">Saisissez votre identifiant et mot de passe.</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><label>Email</label><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required \nng-click=\"loginForm.email.$setValidity(\'loginFailed\', true);loginForm.password.$setValidity(\'loginFailed\', true)\" \nng-change=\"loginForm.email.$setValidity(\'loginFailed\', true);loginForm.password.$setValidity(\'loginFailed\', true)\"><div\n ng-messages=\"loginForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ce champ est obligatoire</span>\n</div><div ng-message=\"pattern\"><span>Vous devez saisir une adresse e-mail valide</span></div><div \nng-message=\"loginFailed\"><span>{{status}}</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><label>Mot de passe</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" required \nng-click=\"loginForm.email.$setValidity(\'loginFailed\', true);loginForm.password.$setValidity(\'loginFailed\', true)\" \nng-change=\"loginForm.email.$setValidity(\'loginFailed\', true);loginForm.password.$setValidity(\'loginFailed\', true)\"><div\n ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ce champ est obligatoire</span>\n</div><div ng-message=\"loginFailed\"><span>{{status}}</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><a \nui-sref=\"app.auth_forgot-password\" class=\"forgot-password md-accent-color\">Mot de passe oublié ?</a></div><center>\n<small>{{StatutConnexion}}</small></center><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button circular-progress-button\" aria-label=\"Connexion\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-click=\"submit()\" layout-align=\"center center\"><span \nng-show=\"!showSpinner\">Connexion</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"showSpinner\"></md-progress-circular></md-button></form></div></div></div>");
$templateCache.put("app/main/banque/dialogs/edition.html","<md-dialog class=\"banque-dialog\" flex=\"80\" aria-label=\"Opération bancaire\"><form name=\"editionForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.enregistrer(editionForm)\" novalidate><md-dialog-content ms-scroll><span \nclass=\"md-title\">\n{{vm.lectureSeule ? \'Détail\' : vm.statutSeulement ? \'Statut et rapprochement\' : (vm.document.IDOperationBancaire ? \'Modifier une opération\' : \'Votre opération bancaire\')}}\n</span><p></p><div ng-if=\"vm.lectureSeule\"><table class=\"full-width\"><tr><td class=\"secondary-text pr-16 pb-8\">Date\n</td><td class=\"pb-8\">{{vm.document.DateOperation | date:\'dd/MM/yyyy\'}}</td></tr><tr><td \nclass=\"secondary-text pr-16 pb-8\">Compte</td><td class=\"pb-8\">{{vm.document.Compte || \'—\'}}</td></tr><tr><td \nclass=\"secondary-text pr-16 pb-8\">Libellé</td><td class=\"pb-8\">{{vm.document.Libelle || \'—\'}}</td></tr><tr><td \nclass=\"secondary-text pr-16 pb-8\">Référence</td><td class=\"pb-8\">{{vm.document.Reference || \'—\'}}</td></tr><tr><td \nclass=\"secondary-text pr-16 pb-8\">Débit</td><td class=\"pb-8\"><span ng-if=\"vm.document.Debit > 0\">\n{{vm.document.Debit | number:2}} €</span><span ng-if=\"!(vm.document.Debit > 0)\">—</span></td></tr><tr><td \nclass=\"secondary-text pr-16 pb-8\">Crédit</td><td class=\"pb-8\"><span ng-if=\"vm.document.Credit > 0\">\n{{vm.document.Credit | number:2}} €</span><span ng-if=\"!(vm.document.Credit > 0)\">—</span></td></tr><tr><td \nclass=\"secondary-text pr-16 pb-8\">Statut</td><td class=\"pb-8\">{{vm.document.Statut || \'—\'}}</td></tr><tr><td \nclass=\"secondary-text pr-16 pb-8\">Catégorie</td><td class=\"pb-8\">{{vm.document.Categorie || \'—\'}}<span \nng-if=\"vm.document.ClassificationAutomatique\"> (détectée automatiquement)</span></td></tr><tr><td \nclass=\"secondary-text pr-16 pb-8\">Rapprochement</td><td class=\"pb-8\">{{vm.document.Rapprochement || \'—\'}}</td></tr><tr \nng-if=\"vm.document.EcartChange\"><td class=\"secondary-text pr-16 pb-8\">Écart de change</td><td class=\"pb-8\">\n{{vm.document.EcartChange | number:2}} €</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">Origine</td><td \nclass=\"pb-8\">{{vm.document.Origine || \'—\'}}</td></tr></table><div class=\"documents-bancaires\" \nng-if=\"vm.documents.length\"><p class=\"md-subhead\">Documents rattachés</p><div class=\"document-bancaire\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"document in vm.documents\"><md-icon md-font-icon=\"icon-file-document\" \nclass=\"mr-8\"></md-icon><span flex>{{vm.libelleDocument(document)}}</span><md-button type=\"button\" \nclass=\"md-icon-button\" aria-label=\"Télécharger\" ng-click=\"vm.telechargerDocument(document)\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon></md-button></div></div></div><div \nng-if=\"!vm.lectureSeule && !vm.statutSeulement\"><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nflex><label>Compte bancaire</label><md-select ng-model=\"vm.document.IDCompte\" name=\"IDCompte\" required><md-option \nng-repeat=\"compte in vm.comptes\" ng-value=\"compte.IDCompte\">{{compte.Libelle}}</md-option></md-select><div \nng-messages=\"editionForm[\'IDCompte\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"valid\">Date invalide</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Date</label><md-datepicker ng-model=\"vm.dates.DateOperation\" \nname=\"DateOperation\" md-open-on-focus required></md-datepicker><div ng-messages=\"editionForm[\'DateOperation\'].$error\">\n<div ng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"valid\">Date invalide</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Libellé\n</label><input ng-model=\"vm.document.Libelle\" name=\"Libelle\" required maxlength=\"255\"><div \nng-messages=\"editionForm[\'Libelle\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"valid\">Date invalide</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Référence</label><input ng-model=\"vm.document.Reference\" name=\"Reference\" \nmaxlength=\"100\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nmd-no-float flex><label>Débit (€)</label><input type=\"number\" min=\"0\" step=\"0.01\" ng-model=\"vm.document.Debit\" \nname=\"Debit\" required><div ng-messages=\"editionForm[\'Debit\'].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div><div ng-message=\"valid\">Date invalide</div></div></md-input-container><md-input-container\n class=\"md-block\" md-no-float flex><label>Crédit (€)</label><input type=\"number\" min=\"0\" step=\"0.01\" \nng-model=\"vm.document.Credit\" name=\"Credit\" required><div ng-messages=\"editionForm[\'Credit\'].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"valid\">Date invalide</div></div>\n</md-input-container></div></div><div ng-if=\"!vm.lectureSeule && vm.statutSeulement\"><p>\n{{vm.document.Libelle}} — {{vm.document.DateOperation | date:\'dd/MM/yyyy\'}}</p><p><span ng-if=\"vm.document.Debit > 0\">\nDébit : {{vm.document.Debit | currency:\'€\'}}</span><span ng-if=\"vm.document.Credit > 0\">\nCrédit : {{vm.document.Credit | currency:\'€\'}}</span></p><div ng-if=\"vm.attributionRejet\" class=\"mb-16\"><p \nclass=\"md-subhead\">Quel prélèvement a été rejeté ?</p><p class=\"secondary-text\">\nLe rapprochement d’origine sera annulé et la facture éventuellement concernée sera rouverte. Aucun choix n’est effectué automatiquement.\n</p><md-radio-group class=\"rejet-prelevements\" layout=\"column\" ng-model=\"vm.document.IDOperationEncaissement\" \nname=\"IDOperationEncaissement\" required><md-radio-button class=\"rejet-prelevement md-align-top-left\" \nng-repeat=\"prelevement in vm.prelevements\" ng-value=\"prelevement.IDOperationBancaire\"><strong \nclass=\"rejet-prelevement-entete\">\n{{prelevement.DateOperation | date:\'dd/MM/yyyy\'}} — {{prelevement.Montant | currency:\'€\'}}</strong> <span \nclass=\"rejet-prelevement-libelle\">{{prelevement.Libelle}}</span> <span class=\"rejet-prelevement-lien secondary-text\" \nng-if=\"prelevement.Rapprochement\">Actuellement rapproché avec : {{prelevement.Rapprochement}}</span> <span \nclass=\"rejet-prelevement-lien secondary-text\" ng-if=\"!prelevement.Rapprochement\">Aucune facture actuellement liée\n</span></md-radio-button></md-radio-group><p class=\"secondary-text\" ng-if=\"!vm.busy && !vm.prelevements.length\">\nAucun prélèvement de même montant n’a été trouvé dans les 15 jours précédents.</p></div><div layout=\"row\" \nng-if=\"!vm.attributionRejet\"><md-input-container class=\"md-block\" md-no-float flex><label>Statut</label><md-select \nng-model=\"vm.document.Statut\" name=\"Statut\" ng-change=\"vm.changerStatut()\" required><md-option \nng-repeat=\"statut in vm.statuts\" ng-value=\"statut\">{{statut}}</md-option></md-select><div \nng-messages=\"editionForm[\'Statut\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"valid\">Date invalide</div></div></md-input-container></div><div layout=\"row\" \nng-if=\"!vm.attributionRejet && [\'À valider\', \'En attente de pièce\', \'Justifiée hors facture\'].indexOf(vm.document.Statut) !== -1\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Catégorie</label><md-select \nng-model=\"vm.document.Categorie\" name=\"Categorie\" \nng-required=\"vm.document.Statut === \'En attente de pièce\' || vm.document.Statut === \'Justifiée hors facture\'\">\n<md-option ng-repeat=\"categorie in vm.categories\" ng-value=\"categorie\">{{categorie}}</md-option></md-select><div \nclass=\"hint\" ng-if=\"vm.document.ClassificationAutomatique\">Catégorie détectée automatiquement, à confirmer.</div><div \nng-messages=\"editionForm[\'Categorie\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" \nng-if=\"!vm.attributionRejet && [\'À rembourser\', \'Remboursé\'].indexOf(vm.document.Statut) !== -1\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Catégorie</label><input ng-model=\"vm.document.Categorie\" \nname=\"CategorieTropPercu\" readonly=\"readonly\"><div class=\"hint\">\nCette catégorie est imposée pour conserver le suivi entre l’encaissement et son remboursement.</div>\n</md-input-container></div><div layout=\"row\" ng-if=\"!vm.attributionRejet && vm.document.Statut === \'À rembourser\'\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Client à rembourser</label><md-select \nng-model=\"vm.document.IDContactTropPercu\" name=\"IDContactTropPercu\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.rechercheContact\" type=\"search\" placeholder=\"Rechercher un client\" \nclass=\"header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"contact in vm.contacts | filter:vm.rechercheContact\" ng-value=\"contact.IDContact * 1\">\n{{contact.RaisonSocial}}</md-option></md-select><div class=\"hint\">\nLe trop-perçu restera ouvert jusqu’au rapprochement du débit de remboursement.</div><div \nng-messages=\"editionForm[\'IDContactTropPercu\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" ng-if=\"!vm.attributionRejet && vm.document.Statut === \'Remboursé\'\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Trop-perçu remboursé</label><md-select \nng-model=\"vm.document.IDTropPercuClient\" name=\"IDTropPercuClient\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.rechercheTropPercu\" type=\"search\" \nplaceholder=\"Client, montant ou libellé\" class=\"header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"tropPercu in vm.tropPercus | filter:vm.rechercheTropPercu\" \nng-value=\"tropPercu.IDTropPercuClient * 1\">\n{{tropPercu.Client}} — {{tropPercu.Montant | currency:\'€\'}} — {{tropPercu.DateEncaissement | date:\'dd/MM/yyyy\'}}\n</md-option></md-select><div class=\"hint\">Seuls les trop-perçus du même montant encore à rembourser sont acceptés.\n</div><div ng-messages=\"editionForm[\'IDTropPercuClient\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div></div></md-input-container></div><div class=\"justification-bancaire\" \nng-if=\"!vm.attributionRejet && [\'À valider\', \'En attente de pièce\', \'Justifiée hors facture\'].indexOf(vm.document.Statut) !== -1\">\n<div layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Documents rattachés</label><md-select \nng-model=\"vm.document.IDDocuments\" name=\"IDDocuments\" multiple=\"multiple\"><md-option \nng-repeat=\"document in vm.documentsDisponibles\" ng-value=\"document.IDDocument * 1\">{{vm.libelleDocument(document)}}\n</md-option></md-select><div class=\"hint font-size-14\">Les documents sont ajoutés et gérés depuis la fiche du contact.\n</div></md-input-container></div></div><div \nng-if=\"!vm.attributionRejet && vm.document.Statut === \'À valider\' && vm.propositions.length\" class=\"mb-16\"><p \nclass=\"md-subhead\">Propositions de rapprochement</p><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"piece in vm.propositions | limitTo:3\"><span flex>{{piece.Libelle}} — {{piece.Solde | currency:\'€\'}}<span \nng-if=\"piece.Devise !== \'EUR\'\">\n ({{piece.MontantOrigine | number:2}} {{piece.Devise}} ; écart de change {{piece.EcartChange | number:2}} €)</span>\n — score {{piece.Score}} %</span><md-button type=\"button\" class=\"md-accent\" ng-click=\"vm.validerProposition(piece)\">\nValider</md-button></div></div><div layout=\"row\" ng-if=\"!vm.attributionRejet && vm.document.Statut === \'Rapprochée\'\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Facture(s) d\'achat ou de vente à rapprocher</label>\n<md-select ng-model=\"vm.document.IDPieces\" name=\"IDPieces\" multiple=\"multiple\" required><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.recherchePiece\" type=\"search\" \nplaceholder=\"Numéro, fournisseur ou client\" class=\"header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"piece in vm.piecesUnitaires | filter:vm.recherchePiece\" \nng-value=\"piece.IDPiece\">{{piece.Libelle}}<span ng-if=\"piece.DatePiece\"> — {{piece.DatePiece | date:\'dd/MM/yyyy\'}}\n</span> — {{piece.Solde | currency:\'€\'}}<span ng-if=\"piece.Devise !== \'EUR\'\">\n — écart {{piece.EcartChange | number:2}} €</span></md-option></md-select><div class=\"hint font-size-14\">\nLa sélection remplace le rapprochement actuel et recalcule le statut des anciennes et nouvelles factures.</div><div \nng-messages=\"editionForm[\'IDPieces\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div></div><p class=\"md-warn-fg\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.annuler()\" ng-disabled=\"vm.busy\">\n{{vm.lectureSeule ? \'Fermer\' : \'Annuler\'}}</md-button><md-button ng-if=\"!vm.lectureSeule\" type=\"submit\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"vm.busy || editionForm.$invalid || !vm.autorise() || (!vm.statutSeulement && !vm.modifiable)\" \naria-label=\"Appliquer\"><span ng-show=\"!vm.busy\">{{vm.attributionRejet ? \'Attribuer le rejet\' : \'Appliquer\'}}</span>\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.busy\"></md-progress-circular></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/banque/dialogs/import.html","<md-dialog class=\"banque-dialog\" aria-label=\"Importer un extrait de compte\" flex=\"80\"><form class=\"md-inline-form\" \nenctype=\"multipart/form-data\" name=\"importForm\" ng-submit=\"vm.importer(importForm)\" novalidate><md-dialog-content \nms-scroll><span class=\"md-title\">Importer un extrait de compte</span><p></p><div ng-if=\"!vm.resultat\">\n<md-input-container md-no-float class=\"md-block\"><label>Compte bancaire</label><md-select ng-model=\"vm.IDCompte\" \nrequired><md-option ng-repeat=\"compte in vm.comptes\" ng-value=\"compte.IDCompte\">{{compte.Libelle}}</md-option>\n</md-select></md-input-container><p>\nLe format CMI (CyberGestion) est recommandé : il contient à la fois l’identifiant bancaire, le libellé complet, le client et la référence de commande. OFX et CSV restent acceptés pour compatibilité.\n</p><md-input-container md-no-float class=\"md-block\"><label>Fichier</label><input type=\"file\" name=\"file\" ngf-select \nng-model=\"vm.file\" aria-label=\"Fichier bancaire à importer\" accept=\".cmi,.ofx,.csv\" required><div \nclass=\"hint font-size-14\">CMI recommandé, OFX ou CSV acceptés, 20 Mo maximum</div></md-input-container></div><div \nng-if=\"vm.resultat\"><p>\n{{vm.resultat.Importes}} élément(s) importé(s), {{vm.resultat.Enrichis || 0}} opération(s) enrichie(s), {{vm.resultat.Doublons}} doublon(s), {{vm.resultat.Rejetes.length}} rejet(s).\n</p><p ng-if=\"vm.resultat.Rapprochement\">\n{{vm.resultat.Rapprochement.Rapprochees}} rapprochement(s) automatique(s), {{vm.resultat.Rapprochement.AValider}} opération(s) à valider et {{vm.resultat.Rapprochement.NonJustifiees}} opération(s) non justifiée(s).\n</p><p ng-repeat=\"rejet in vm.resultat.Rejetes\">Ligne {{rejet.Ligne}} : {{rejet.Message}}</p></div><p \nclass=\"md-warn-fg\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.fermer()\" ng-disabled=\"vm.busy\">{{vm.resultat ? \'Fermer\' : \'Annuler\'}}</md-button><md-button \nng-if=\"!vm.resultat\" type=\"submit\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.busy || importForm.$invalid || !vm.autorise()\" aria-label=\"Importer\"><span ng-show=\"!vm.busy\">Importer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.busy\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/banque/dialogs/statuts-masse.html","<md-dialog class=\"banque-dialog\" flex=\"80\" aria-label=\"Modifier le statut des opérations\"><form \nname=\"statutsMasseForm\" class=\"md-inline-form\" ng-submit=\"vm.enregistrer()\" novalidate><md-dialog-content ms-scroll>\n<span class=\"md-title\">Modifier {{vm.ids.length}} opération(s)</span><p class=\"secondary-text\">\nLes rapprochements, rejets de prélèvement, trop-perçus et remboursements doivent être traités individuellement.</p><div\n layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Statut</label><md-select \nng-model=\"vm.statut\" required><md-option ng-repeat=\"statut in vm.statuts\" ng-value=\"statut\">{{statut}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" ng-if=\"vm.categorieNecessaire()\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Catégorie</label><md-select ng-model=\"vm.categorie\"><md-option value=\"\">\nConserver la catégorie actuelle</md-option><md-option ng-repeat=\"categorie in vm.categories\" ng-value=\"categorie\">\n{{categorie}}</md-option></md-select><div class=\"hint\">\nSans sélection, chaque opération conserve sa catégorie. Une catégorie existante reste obligatoire pour justifier l’opération.\n</div></md-input-container></div><p class=\"md-warn-fg\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"button\" ng-click=\"vm.annuler()\" \nng-disabled=\"vm.busy\">Annuler</md-button><md-button type=\"submit\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.busy || !vm.statut\"><span ng-show=\"!vm.busy\">Appliquer</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.busy\"></md-progress-circular></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/collaborateurs/activites/activites.html","<div id=\"colabactivites\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"white-fg pr-32\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"material-icons-outlined s28\">date_range\n</md-icon><span class=\"ml-10\">Présences et activités</span></div><div class=\"notification-count secondary-text\"><span>\n{{vm.recordsTotal}} jours</span></div></div><div><md-button class=\"md-raised\" \nng-click=\"vm.exportActivites($event, \'select\')\"><md-icon class=\"material-icons-outlined\">file_download</md-icon>\nExporter la sélection</md-button></div></div><div layout=\"row\" flex layout-align=\"space-between \"><div \nclass=\"content-card\" flex=\"100\" layout=\"column\" flex><div class=\"content-card main scrollable\" flex=\"100\" \nlayout=\"column\" flex><table class=\"dataTable dataTableColabActivites row-border hover\" datatable \ndt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"></table></div></div></div></div></div>");
$templateCache.put("app/main/collaborateurs/conges/conges.html","<div id=\"colabconges\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"white-fg pr-32\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"material-icons-outlined s28\">event_busy\n</md-icon><span class=\"ml-10\">Congés et absences</span></div><div class=\"colabconges-count secondary-text\"><span>\n{{vm.recordsTotal}} absences</span></div></div><div><md-button class=\"md-raised\" ng-click=\"vm.editConge($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><span>Ajouter</span></md-button><md-button class=\"md-raised\" \nng-click=\"vm.exportConges($event, \'select\')\"><md-icon class=\"material-icons-outlined\">file_download</md-icon>\nExporter la sélection</md-button></div></div><div layout=\"row\" flex layout-align=\"space-between \"><div \nclass=\"content-card\" flex=\"100\" layout=\"column\" flex><div class=\"content-card main scrollable\" flex=\"100\" \nlayout=\"column\" flex><table class=\"dataTable dataTableColabConges row-border hover\" datatable \ndt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"></table></div></div></div></div></div>");
$templateCache.put("app/main/collaborateurs/documents/documents.html","<div id=\"colabdocs\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"white-fg pr-32\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"material-icons-outlined s28\">description\n</md-icon><span class=\"ml-10\">Documents</span></div><div class=\"colabdocs-count secondary-text\"><span>\n{{vm.recordsTotal}} documents</span></div></div><div><md-button class=\"md-raised\" ng-click=\"vm.editDocument($event)\" \nng-if=\"Permission==\'Super Admin\'\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span>Ajouter</span></md-button>\n<md-button class=\"md-raised\" ng-click=\"vm.exportDocuments($event, \'select\')\"><md-icon class=\"material-icons-outlined\">\nfile_download</md-icon>Exporter la sélection</md-button></div></div><div layout=\"row\" flex \nlayout-align=\"space-between \"><div class=\"content-card\" flex=\"100\" layout=\"column\" flex><div \nclass=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table \nclass=\"dataTable dataTableColabDocs row-border hover\" datatable dt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"></table></div></div></div></div></div>");
$templateCache.put("app/main/commandes/cdc/cdc.html","<div id=\"cdc\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"white-fg pr-32\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"material-icons-outlined s28\">\ndocument_scanner</md-icon><span class=\"ml-10\">Cahier des charges</span></div><div class=\"cdc-count secondary-text\">\n<span>{{vm.recordsTotal}} Blocs</span></div></div><div><md-button class=\"md-raised\" \nng-click=\"vm.editEmailTrack($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span>Ajouter</span></md-button></div>\n</div><div layout=\"row\" flex layout-align=\"space-between \"><div class=\"content-card\" flex=\"100\" layout=\"column\" flex>\n<div class=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table \nclass=\"dataTable dataTableCdc row-border hover\" datatable dt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"></table></div></div></div></div></div>");
$templateCache.put("app/main/commandes/commande/edition.html","<div id=\"invoice\" class=\"compact page-layout blank simple\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align=\"start center\"><div class=\"white-fg mb-16 mt-16\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-produits-button md-icon-button\" \naria-label=\"Retour aux commandes\" flex-xs=\"15\" ng-click=\"vm.gotoCommandes()\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\">\n<div class=\"h2\" ng-hide=\"!vm.commande.NumeroCommande\">Commande : {{vm.commande.NumeroCommande}}</div><div class=\"h2\" \nng-hide=\"vm.commande.NumeroCommande\"><span>Nouvelle commande</span></div><div class=\"subtitle secondary-text\" \nng-show=\"vm.commande.NumeroCommande\"><span>Modification</span></div></div><div class=\"ml-24\" \nng-hide=\"!vm.commande.IDContact\" style=\"max-width:200px\"><md-button editable-select=\"vm.commande.Etat\" \nonaftersave=\"vm.saveCommande($event)\" \nng-disabled=\"!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer  || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\" \ne-ng-options=\"s.value as s.text for s in vm.Etat\" class=\"md-amber-600-bg white-fg\" \nng-show=\"vm.commande.Etat == \'Brouillon\' && !vm.deplacer\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.commande.Etat}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le statut de la commande</md-tooltip></md-button><md-button editable-select=\"vm.commande.Etat\" \nonaftersave=\"vm.saveCommande($event)\" \nng-disabled=\"!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer  || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\" \ne-ng-options=\"s.value as s.text for s in vm.Etat\" class=\"md-grey-500-bg white-fg\" \nng-show=\"vm.commande.Etat == \'Annulée\' && !vm.deplacer\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.commande.Etat}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le statut de la commande</md-tooltip></md-button><md-button editable-select=\"vm.commande.Etat\" \nonaftersave=\"vm.saveCommande($event)\" \nng-disabled=\"!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer  || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\" \ne-ng-options=\"s.value as s.text for s in vm.Etat\" class=\"red-600-bg white-fg\" \nng-show=\"vm.commande.Etat == \'En attente\' && !vm.deplacer\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.commande.Etat}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le statut de la commande</md-tooltip></md-button><md-button editable-select=\"vm.commande.Etat\" \nonaftersave=\"vm.saveCommande($event)\" \nng-disabled=\"!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer  || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\" \ne-ng-options=\"s.value as s.text for s in vm.Etat\" class=\"md-cyan-700-bg white-fg\" \nng-show=\"vm.commande.Etat == \'Validée\' && !vm.deplacer\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.commande.Etat}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le statut de la commande</md-tooltip></md-button><md-button editable-select=\"vm.commande.Etat\" \nonaftersave=\"vm.saveCommande($event)\" \nng-disabled=\"!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer  || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\" \ne-ng-options=\"s.value as s.text for s in vm.Etat\" class=\"md-teal-600-bg\" \nng-show=\"vm.commande.Etat == \'Signée\' && !vm.deplacer\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.commande.Etat}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le statut de la commande</md-tooltip></md-button><md-button editable-select=\"vm.commande.Etat\" \nonaftersave=\"vm.saveCommande($event)\" \nng-disabled=\"!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer  || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\" \ne-ng-options=\"s.value as s.text for s in vm.Etat\" class=\"md-green-600-bg white-fg\" \nng-show=\"vm.commande.Etat == \'Facturée\' && !vm.deplacer\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.commande.Etat}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le statut de la commande</md-tooltip></md-button><md-button editable-select=\"vm.commande.Etat\" \nonaftersave=\"vm.saveCommande($event)\" \nng-disabled=\"!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer  || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\" \ne-ng-options=\"s.value as s.text for s in vm.Etat\" class=\"md-blue-500-bg white-fg\" \nng-show=\"vm.commande.Etat == \'Com-Consultants\' && !vm.deplacer\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.commande.Etat}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le statut de la commande</md-tooltip></md-button></div><a href=\"#\" class=\"white-fg\" \nonaftersave=\"vm.saveCommande($event)\" \nng-if=\"!(!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer  || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0))\" \neditable-combodate=\"vm.commande.DatePrevisionSignature\" e-template=\"DD / MM / YYYY\" e-min-year=\"{{vm.currentYear}}\" \ne-max-year=\"{{vm.currentYear +2}}\" e-year-descending=\"false\">\nSignature prévisionnelle : {{ (vm.commande.DatePrevisionSignature | date:\"dd/MM/yyyy\") || \'empty\' }}</a></div></div>\n<div layout=\"row\" layout-align=\"start center\" layout-align-xs=\"center center\" layout-align-sm=\"center center\" \nlayout-wrap><md-menu hide-xl><md-button aria-label=\"Open phone interactions menu\" class=\"md-raised\" \nng-click=\"$mdMenu.open()\" \nng-disabled=\"!vm.commande.NumeroCommande || !vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer \">\n<md-icon class=\"material-icons-outlined\">menu</md-icon>Actions</md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button ng-click=\"vm.showMarges = !vm.showMarges\" ng-disabled=\"!vm.commande.IDContact || vm.deplacer \"><md-icon \nng-show=\"!vm.showMarges\" class=\"material-icons-outlined\">visibility_off</md-icon><md-icon ng-show=\"vm.showMarges\" \nclass=\"material-icons-outlined\">visibility</md-icon>Charges externes</md-button></md-menu-item><md-menu-item \nng-show=\"vm.commande.logs.length>0\"><md-button ng-click=\"vm.showLogs($event, vm.commande)\" \nng-disabled=\"!vm.commande.IDContact || vm.deplacer \" ng-show=\"vm.commande.logs.length>0\"><md-icon \nng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">timeline</md-icon>Historique</md-button></md-menu-item>\n<md-menu-item ng-show=\"Permission==\'Super Admin\'\"><md-button \nng-click=\"vm.editOptions($event, vm.commande.IDCommande, vm.commande)\" ng-show=\"vm.commande.NumeroCommande\" \nng-disabled=\"!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer \" \nng-show=\"Permission==\'Super Admin\'\"><md-icon ng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">settings\n</md-icon>Paramètres</md-button></md-menu-item><md-menu-divider ng-show=\"vm.commande.NumeroCommande\"></md-menu-divider>\n<md-menu-item ng-show=\"vm.commande.NumeroCommande\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" \nng-show=\"vm.commande.NumeroCommande\"><md-icon ng-show=\"!vm.showSpinner\" class=\"material-icons-outlined mr-16\">\ndescription</md-icon>Documents</md-button><md-menu-content width=\"4\"><md-menu-item \nng-show=\" vm.commande.produits.length>0 && vm.commande.IDCommande && vm.commande.Etat != \'Signée\'\"><md-button \nclass=\"send-button\" ng-click=\"vm.generateDevis($event)\" \nng-disabled=\"!vm.isFormValid(\'commandeForm\') || vm.commande.TotalTTC<vm.TotalPaiement || vm.deplacer || vm.limiteRemise() || vm.DureeEngagementDiff() || vm.FinancementBloque() || vm.FinancementRemiseBloque() || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\">\n<md-icon ng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">description</md-icon><span \nng-show=\"!vm.showSpinner\">Générer le devis</span></md-button></md-menu-item><md-menu-item \nng-show=\"vm.commande.DevisSigne == true\"><md-button class=\"send-button\" ng-click=\"vm.getDevisSigne($event)\"><md-icon \nng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">description</md-icon><span ng-show=\"!vm.showSpinner\">\nVoir le devis signé</span></md-button></md-menu-item><md-menu-item \nng-show=\" vm.commande.produits.length>0 && (vm.commande.Etat != \'En attente\' && vm.commande.Etat != \'Annulée\' && vm.commande.Etat != \'Com-Consultants\' && vm.commande.Etat != \'Brouillon\') && vm.commande.TotalTTC>=0\">\n<md-button class=\"send-button\" ng-click=\"vm.generateFacture($event)\" \nng-disabled=\"!vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.limiteRemise() || vm.DureeEngagementDiff() || vm.FinancementBloque() || vm.FinancementRemiseBloque() || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\">\n<md-icon ng-show=\"!vm.showSpinner\" md-font-icon=\"icon icon-file-pdf\"></md-icon><span ng-show=\"!vm.showSpinner\">\nGénérer une facture</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\">\n</md-progress-circular></md-button></md-menu-item><md-menu-item \nng-show=\" vm.commande.produits.length>0 && (vm.commande.Etat != \'En attente\' && vm.commande.Etat != \'Annulée\' && vm.commande.Etat != \'Com-Consultants\' && vm.commande.Etat != \'Brouillon\') && vm.commande.TotalTTC<0\">\n<md-button class=\"send-button\" ng-click=\"vm.generateFacture($event)\" \nng-disabled=\"!vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.limiteRemise() || vm.DureeEngagementDiff() || vm.FinancementBloque() || vm.FinancementRemiseBloque() || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\">\n<md-icon ng-show=\"!vm.showSpinner\" md-font-icon=\"icon icon-file-pdf\"></md-icon><span ng-show=\"!vm.showSpinner\">\nGénérer un avoir</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\">\n</md-progress-circular></md-button></md-menu-item></md-menu-content></md-menu></md-menu-item></md-menu-content>\n</md-menu><div hide show-xl><md-button class=\"md-raised\" ng-click=\"vm.showMarges = !vm.showMarges\" \nng-disabled=\"!vm.commande.IDContact || vm.deplacer \"><md-icon ng-show=\"!vm.showMarges\" class=\"material-icons-outlined\">\nvisibility_off</md-icon><md-icon ng-show=\"vm.showMarges\" class=\"material-icons-outlined\">visibility</md-icon>\nCharges externes</md-button><md-button class=\"md-raised\" ng-click=\"vm.showLogs($event, vm.commande)\" \nng-disabled=\"!vm.commande.IDContact || vm.deplacer \" ng-show=\"vm.commande.logs.length>0\"><md-icon \nng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">timeline</md-icon>Historique</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.editOptions($event, vm.commande.IDCommande, vm.commande)\" \nng-show=\"vm.commande.NumeroCommande\" \nng-disabled=\"!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer \" \nng-show=\"Permission==\'Super Admin\'\"><md-icon ng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">settings\n</md-icon>Paramètres</md-button><md-menu><md-button class=\"md-raised\" ng-click=\"$mdMenu.open($event)\" \nng-show=\"vm.commande.NumeroCommande\" \nng-disabled=\"!vm.commande.IDContact || !vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.deplacer \">\n<md-icon ng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">description</md-icon>Documents</md-button>\n<md-menu-content width=\"4\"><md-menu-item \nng-show=\" vm.commande.produits.length>0 && vm.commande.IDCommande && vm.commande.Etat != \'Signée\'\"><md-button \nclass=\"send-button\" ng-click=\"vm.generateDevis($event)\" \nng-disabled=\"!vm.isFormValid(\'commandeForm\') || vm.commande.TotalTTC<vm.TotalPaiement || vm.deplacer || vm.limiteRemise() || vm.DureeEngagementDiff() || vm.FinancementBloque() || vm.FinancementRemiseBloque() || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\">\n<md-icon ng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">description</md-icon><span \nng-show=\"!vm.showSpinner\">Générer le devis</span></md-button></md-menu-item><md-menu-item \nng-show=\"vm.commande.DevisSigne == true\"><md-button class=\"send-button\" ng-click=\"vm.getDevisSigne($event)\"><md-icon \nng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">description</md-icon><span ng-show=\"!vm.showSpinner\">\nVoir le devis signé</span></md-button></md-menu-item><md-menu-item \nng-show=\" vm.commande.produits.length>0 && (vm.commande.Etat != \'En attente\' && vm.commande.Etat != \'Annulée\' && vm.commande.Etat != \'Com-Consultants\' && vm.commande.Etat != \'Brouillon\') && vm.commande.TotalTTC>=0\">\n<md-button class=\"send-button\" ng-click=\"vm.generateFacture($event)\" \nng-disabled=\"!vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.limiteRemise() || vm.DureeEngagementDiff() || vm.FinancementBloque() || vm.FinancementRemiseBloque() || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\">\n<md-icon ng-show=\"!vm.showSpinner\" md-font-icon=\"icon icon-file-pdf\"></md-icon><span ng-show=\"!vm.showSpinner\">\nGénérer une facture</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\">\n</md-progress-circular></md-button></md-menu-item><md-menu-item \nng-show=\" vm.commande.produits.length>0 && (vm.commande.Etat != \'En attente\' && vm.commande.Etat != \'Annulée\' && vm.commande.Etat != \'Com-Consultants\' && vm.commande.Etat != \'Brouillon\') && vm.commande.TotalTTC<0\">\n<md-button class=\"send-button\" ng-click=\"vm.generateFacture($event)\" \nng-disabled=\"!vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || vm.limiteRemise() || vm.DureeEngagementDiff() || vm.FinancementBloque() || vm.FinancementRemiseBloque() || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\">\n<md-icon ng-show=\"!vm.showSpinner\" md-font-icon=\"icon icon-file-pdf\"></md-icon><span ng-show=\"!vm.showSpinner\">\nGénérer un avoir</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\">\n</md-progress-circular></md-button></md-menu-item></md-menu-content></md-menu></div><md-button \nclass=\"send-button md-raised\" ng-click=\"vm.saveCommande($event)\" \nng-disabled=\"!vm.isFormValid(\'commandeForm\') || (vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>0) || (vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0) || vm.deplacer || vm.limiteRemise() || vm.DureeEngagementDiff() || vm.FinancementBloque() || vm.FinancementRemiseBloque()\">\n<md-icon ng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">save</md-icon><span ng-show=\"!vm.showSpinner\">\nEnregistrer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\">\n</md-progress-circular></md-button></div></div><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" \nlayout-align=\"space-between stretch\"><div class=\"invoice-container\" ms-scroll flex-gt-md=\"70\" flex-sm=\"100\" \nflex-md=\"95\" flex=\"100\"><form editable-form id=\"commandeForm\" name=\"commandeForm\"><div class=\"card border brad-16\"><div\n class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div class=\"client\" flex=\"50\" flex-gt-md=\"65\" \nflex-xs=\"100\"><md-input-container class=\"md-block mb-0\" md-no-float flex ng-hide=\"vm.commande.NumeroCommande\"><label>\nNom de la commande</label><input ng-model=\"vm.commande.NomCommande\" ng-disabled=\"vm.commande.Etat == \'Facturée\'\" \ntype=\"text\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" flex-direction=\"reverse\" \nlayout-align=\"space-between center\"><div class=\"client\" flex=\"50\" flex-gt-md=\"65\" flex-xs=\"100\"><md-input-container \nclass=\"md-block mb-0\" md-no-float flex ng-show=\"vm.commande.NumeroCommande\"><label>Nom de la commande</label><input \nng-model=\"vm.commande.NomCommande\" ng-disabled=\"vm.commande.Etat == \'Facturée\'\" type=\"text\"></md-input-container>\n<md-input-container md-no-float flex class=\"mt-8 mb-5 md-block\"><label>Client</label><md-select \nng-model=\"vm.commande.IDContact\" name=\"IDContact\" md-on-open=\"openSelectSearch(\'#header-searchbox\', 1000)\" \nplaceholder=\"Choisir un client\" md-on-close=\"clearSearchTerm()\" required \nng-change=\"vm.commande.sites = vm.commande.Projet = \'\'; vm.commande.IDAdresseFacturation = \'\'; vm.commande.IDCommande_IBAN = vm.commande.IDIBAN = vm.commande.IBAN = vm.commande.BIC = vm.commande.Domiciliation = vm.commande.Titulaire = \'\'; \" \nng-disabled=\"vm.commande.IDContact && (vm.commande.Etat == \'Signée\' || vm.commande.Etat == \'Facturée\')\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" force-select-focus type=\"search\" \nplaceholder=\"Chercher un client\" class=\"header-searchbox md-text\" id=\"header-searchbox\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"contact in vm.contacts | filter:searchTerm\" ng-value=\"{{contact.IDContact}}\">{{contact.RaisonSocial}}\n</md-option></md-select><div ng-messages=\"commandeForm.IDContact.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block mt-8\" md-no-float flex \nng-show=\"vm.commande.IDContact\"><label>Adresse de Facturation</label><md-select \nng-model=\"vm.commande.IDAdresseFacturation\" name=\"IDAdresseFacturation\" ng-disabled=\"vm.commande.Etat == \'Facturée\'\" \nplaceholder=\"Adresse de Facturation\" md-on-open=\"vm.loadAdresses()\" required ng-change=\"vm.changeAdresse()\"><md-option \nng-repeat=\"adresse in vm.adresses\" ng-value=\"{{adresse.IDAdresse}}\">\n{{adresse.NomAdresse}} ({{adresse.Adresse}} - {{adresse.Ville.CodePostal}} {{adresse.Ville.NomVille}})</md-option>\n</md-select><div ng-messages=\"commandeForm.IDAdresseFacturation.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><span ng-hide=\"vm.commande.IDContact\" \nclass=\"ml-8 font-size-20 text-center\">ou</span><md-button class=\"md-primary\" ng-click=\"vm.go(\'/contacts/nouveau\')\" \nng-hide=\"vm.commande.IDContact\"><md-icon class=\"material-icons-outlined\">add_box</md-icon><span>\nAjouter un nouveau client</span></md-button><div class=\"issuer white-fg\" layout=\"row\" flex=\"40\" flex-xs=\"100\" \nflex-gt-md=\"30\" layout-align=\"start center\" ng-show=\"vm.commande.NumeroCommande\"><div class=\"info\"><div \nclass=\"md-title\" ng-show=\"vm.commande.NumeroCommande\">Commande N° {{vm.commande.NumeroCommande}}</div><div \nclass=\"address\" ng-show=\"vm.commande.adresse.NomAdresse\">{{vm.commande.adresse.NomAdresse}}</div><div class=\"address\" \nng-show=\"vm.commande.adresse.Adresse\">{{vm.commande.adresse.Adresse}}</div><div class=\"address\" \nng-show=\"vm.commande.adresse.Adresse2\">{{vm.commande.adresse.Adresse2}}</div><div class=\"address\" \nng-show=\"vm.commande.adresse.Ville\">\n{{vm.commande.adresse.Ville.CodePostal}} {{vm.commande.adresse.Ville.NomVille}} - {{vm.commande.adresse.Pays.NomPays}}\n</div><div class=\"siret\" ng-show=\"vm.commande.adresse.Siret\">SIRET : {{vm.commande.adresse.Siret}}</div></div></div>\n</div><div layout=\"column\" class=\"mt-16\" flex=\"50\" flex-gt-md=\"65\" flex-xs=\"100\"><div layout=\"row\" \nng-if=\"vm.commande.IDContact\"><md-input-container flex><label>Projet</label><md-select ng-model=\"vm.commande.Projet\" \nname=\"Projet\" required ng-disabled=\"vm.commande.Etat == \'Facturée\'\"><md-option value=\"avec\">Concerne un site internet\n</md-option><md-option value=\"inconnu\">Concerne un site internet inconnu / indéfini</md-option><md-option value=\"sans\">\nSans rapport avec un site internet</md-option></md-select><div ng-messages=\"commandeForm.Projet.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container><div \nng-if=\"vm.commande.Projet == \'avec\'\" flex layout=\"row\" layout-align=\"start center\"><md-input-container flex \nclass=\"pt-5\"><label>Site(s)</label><md-select ng-model=\"vm.commande.sites\" multiple=\"multiple\" name=\"sites\" \nng-required=\"vm.commande.Projet == \'avec\'\" ng-disabled=\"vm.commande.Etat == \'Facturée\'\"><md-option \nng-value=\"site.IDSiteWeb\" ng-repeat=\"site in vm.sites\">\n{{site.URL.replace(\"http://\",\"\").replace(\"https://\",\"\").replace(\"www.\",\"\")}}</md-option></md-select><div \nng-messages=\"commandeForm.sites.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Ajouter\" ng-if=\"!vm.addsite\" \nng-click=\"vm.addsite = 1\"><md-tooltip md-direction=\"right\">Ajouter un site</md-tooltip><md-icon \nmd-font-icon=\"icon icon-plus\"></md-icon></md-button></div></div><div layout=\"row\" layout-align=\"space-between start\" \nng-if=\"vm.addsite\"><md-input-container class=\"md-block\" md-no-float flex><label>URL du site internet à ajouter</label>\n<input ng-model=\"vm.newURL\" name=\"newURL\" type=\"url\" ng-required=\"vm.addsite\" ng-pattern=\"vm.webregex\"><div \nng-messages=\"commandeForm.newURL.$error\" role=\"alert\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"pattern\">Le format votre l\'URL est incorrecte</div><div ng-message=\"newURLFailed\"><span>{{status}}</span>\n</div></div></md-input-container><md-button class=\"mt-16 md-raised\" ng-click=\"vm.addwebsite(vm.newURL); \" \nng-disabled=\"!vm.newURL\">Ajouter</md-button><md-button class=\"mt-16\" ng-click=\"vm.addsite = 0; vm.newURL = \'\'\">Annuler\n</md-button></div></div></div><div class=\"content\" \nng-show=\"vm.commande.IDContact && vm.commande.Projet != \'\' && (vm.commande.Projet != \'avec\' || (vm.commande.Projet == \'avec\' && vm.commande.sites))\">\n<table class=\"simple invoice-table\" wt-responsive-table><thead><th class=\"text-center\" \nng-hide=\"vm.commande.Etat == \'Facturée\'\">#</th><th style=\"width:60%\">PRODUIT</th><th class=\"text-right\">QUANTITÉ</th>\n<th class=\"text-right\">PU HT</th><th class=\"text-center md-red-50-bg\" ng-if=\"vm.showMarges\">PA HT</th><th \nclass=\"text-right\">TOTAL</th></thead><tbody ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.commande.produits\" \nng-show=\"vm.deplacer\"><tr ng-repeat=\"produit in vm.commande.produits track by $index\"><td class=\"text-center\"><md-icon \nmd-font-icon=\"icon icon-cursor-move\"></md-icon></td><td colspan=\"4\"><div class=\"title\">{{produit.Produit}}</div></td>\n</tr><tr class=\"not-sortable\" ng-hide=\"vm.commande.Etat == \'Facturée\'\"><td colspan=\"2\" class=\"pb-0\"><md-button \nclass=\"md-raised\" ng-disabled=\"true\" ng-click=\"vm.addProduit($event)\" ng-show=\"vm.commande.IDContact\"><md-icon \nclass=\"material-icons-outlined\">add_box</md-icon><span>Ajouter un produit</span></md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.deplacer = !vm.deplacer\"><md-icon class=\"material-icons-outlined\">task_alt\n</md-icon><span>Valider l\'ordre</span></md-button></td><td colspan=\"3\" class=\"text-right\"></td></tr></tbody><tbody \nng-hide=\"vm.deplacer\"><tr ng-repeat-start=\"produit in vm.commande.produits track by $index\" \nng-class=\"produit.SousProduitsSelect.length > 0 ? \'bb-0\' : \'\'\"><td class=\"text-center\" \nng-hide=\"vm.commande.Etat == \'Facturée\'\"><md-button class=\"md-primary md-icon-button\" \nng-click=\"vm.removeProduit(produit)\" ng-hide=\"produit.SousProduits.length > 0\"><md-icon \nclass=\"material-icons-outlined red-900-fg\">delete</md-icon><md-tooltip md-direction=\"left\">Supprimer le produit\n</md-tooltip></md-button><md-menu md-position-mode=\"target-right target\" ng-show=\"produit.SousProduits.length > 0\">\n<md-button aria-label=\"Open demo menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon icon-dots-vertical\"></md-icon></md-button><md-menu-content><md-menu-item \nng-show=\"produit.SousProduits.length > 0\"><md-button class=\"md-primary\" ng-click=\"vm.editProduit(produit)\"><md-icon \nclass=\"material-icons-outlined\">edit</md-icon>Modifier les sous-produits</md-button></md-menu-item><md-menu-item>\n<md-button class=\"md-primary\" ng-click=\"vm.removeProduit(produit)\"><md-icon class=\"material-icons-outlined red-900-fg\">\ndelete</md-icon>Supprimer</md-button></md-menu-item></md-menu-content></md-menu></td><td><div class=\"title\"><div \nclass=\"mt-24\" ng-show=\"produit.Personnalise && vm.commande.IDContact\"><md-input-container class=\"md-block\" \nng-disabled=\"vm.commande.Etat == \'Facturée\'\" ng-show=\"produit.Personnalise && vm.commande.IDContact\"><label>Produit\n</label><input ng-model=\"produit.Produit\" ng-disabled=\"vm.commande.Etat == \'Facturée\'\" type=\"text\" \nplaceholder=\"Produit personnalisé\" ng-required=\"produit.Personnalise\"></md-input-container><md-input-container \nclass=\"md-block mb-16\"><label>Engagement</label><md-select ng-model=\"produit.Renouvellement\" name=\"Renouvellement\" \nrequired ng-disabled=\"vm.commande.Etat == \'Facturée\' || vm.commande.Etat == \'Signée\'\"><md-option ng-value=\"24\">24 mois\n</md-option><md-option ng-value=\"18\">18 mois</md-option><md-option ng-value=\"12\">12 mois</md-option><md-option \nng-value=\"11\">11 mois</md-option><md-option ng-value=\"10\">10 mois</md-option><md-option ng-value=\"9\">9 mois</md-option>\n<md-option ng-value=\"8\">8 mois</md-option><md-option ng-value=\"7\">7 mois</md-option><md-option ng-value=\"6\">6 mois\n</md-option><md-option ng-value=\"5\">5 mois</md-option><md-option ng-value=\"4\">4 mois</md-option><md-option \nng-value=\"3\">3 mois</md-option><md-option ng-value=\"2\">2 mois</md-option><md-option ng-value=\"1\">1 mois</md-option>\n<md-option ng-value=\"0\">Aucun</md-option></md-select><div ng-messages=\"commandeForm.Renouvellement.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block\" \nng-disabled=\"vm.commande.Etat == \'Facturée\'\" md-no-float flex ng-show=\"produit.Personnalise && vm.commande.IDContact\">\n<label>Description</label><textarea ng-model=\"produit.NoteCommande\" ng-disabled=\"vm.commande.Etat == \'Facturée\'\" \ntype=\"text\" md-detect-hidden=\"true\" placeholder=\"Description qui apparaitra sur le devis\"></textarea>\n</md-input-container></div><div ng-hide=\"produit.Personnalise\"><h3 class=\"mb-5 mt-0\"><strong>{{produit.Produit}}\n</strong><h6 layout=\"row\" layout-wrap=\"\" layout-align=\"start center\" \nng-show=\"vm.FinancementInterdit &amp;&amp; produit.FinancementInterdit\" aria-hidden=\"false\" style=\"\" \nclass=\"red-500-fg m-0 layout-wrap layout-align-start-center layout-row\"><p flex=\"\" class=\"flex mt-0 mb-0\">\nCe produit ne peut pas être financé.</p></h6></h3><small hide-xs ng-bind-html=\"produit.NoteCommande\">\n{{produit.NoteCommande}}</small> <small ng-if=\"produit.Plugin==\'plg_ref\' && !produit.Parametres.ComplementDeCommande\">\n<ul><li>Mise à jour du contenu statique et informations importantes (congés, déménagement...)</li><li>\nMaintenance corrective du site internet</li></ul></small><small ng-if=\"produit.Plugin==\'plg_ref\'\" class=\"mb-16\">\n<strong>Paramètres de la campagne :</strong><ul class=\"mb-24\"><li><strong>Combinaisons :</strong>\n {{produit.Parametres.total.nbrRequetes}} mots-clés pertinents</li><li><strong>Localités :</strong>\n {{produit.Parametres.total.nbrLocalites.regions.length + produit.Parametres.total.nbrLocalites.departements.length + produit.Parametres.total.nbrLocalites.veryhard.length + produit.Parametres.total.nbrLocalites.challenging.length + produit.Parametres.total.nbrLocalites.hard.length + produit.Parametres.total.nbrLocalites.medium.length + produit.Parametres.total.nbrLocalites.easy.length}} zones géographiques stratégiques\n</li><li><strong>Population ciblées :</strong>\n {{produit.Parametres.total.nbrPopulation | number}} habitants (hors noms départements)</li></ul></small>\n<md-input-container class=\"md-block mb-16 mt-16\" \nng-if=\"produit.Renouvellement<0 || produit.RenouvellementDefaut<0 || produit.Plugin==\'plg_ref\'\"><label>Engagement\n</label><md-select ng-model=\"produit.Renouvellement\" name=\"Renouvellement\" \nng-focus=\"vm.valeurPrecedenteSelect = produit.Renouvellement;\" \nng-change=\"vm.updateRenouvellement(produit, vm.valeurPrecedenteSelect);\" required \nng-disabled=\"vm.commande.Etat == \'Facturée\' || vm.commande.Etat == \'Signée\'\"><md-option ng-value=\"24\">24 mois\n</md-option><md-option ng-value=\"18\" ng-if=\"produit.Plugin!=\'plg_ref\'\">18 mois</md-option><md-option ng-value=\"12\">\n12 mois</md-option><md-option ng-value=\"11\" ng-if=\"produit.Plugin!=\'plg_ref\'\">11 mois</md-option><md-option \nng-value=\"10\" ng-if=\"produit.Plugin!=\'plg_ref\'\">10 mois</md-option><md-option ng-value=\"9\" \nng-if=\"produit.Plugin!=\'plg_ref\'\">9 mois</md-option><md-option ng-value=\"8\" ng-if=\"produit.Plugin!=\'plg_ref\'\">8 mois\n</md-option><md-option ng-value=\"7\" ng-if=\"produit.Plugin!=\'plg_ref\'\">7 mois</md-option><md-option ng-value=\"6\" \nng-if=\"produit.Plugin!=\'plg_ref\'\">6 mois</md-option><md-option ng-value=\"5\" ng-if=\"produit.Plugin!=\'plg_ref\'\">5 mois\n</md-option><md-option ng-value=\"4\" ng-if=\"produit.Plugin!=\'plg_ref\'\">4 mois</md-option><md-option ng-value=\"3\" \nng-if=\"produit.Plugin!=\'plg_ref\'\">3 mois</md-option><md-option ng-value=\"2\" ng-if=\"produit.Plugin!=\'plg_ref\'\">2 mois\n</md-option><md-option ng-value=\"1\" ng-if=\"produit.Plugin!=\'plg_ref\'\">1 mois</md-option><md-option ng-value=\"0\" \nng-if=\"produit.Plugin!=\'plg_ref\'\">Aucun</md-option></md-select><div ng-messages=\"commandeForm.Renouvellement.$error\">\n<div ng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container><p class=\"mb-24 mt-5\" \nng-if=\"(produit.Renouvellement>0 || produit.PrixSpecifiques.length>0 || produit.Reconduction) &&  produit.Plugin!=\'plg_ref\'\">\n<span ng-if=\"produit.Renouvellement>0 && produit.RenouvellementDefaut>0\" \nclass=\"orange-100-bg font-size-10 grey-900-fg p-5 ng-bindin brad-16\">Engagement sur {{produit.Renouvellement}} mois\n</span><span ng-if=\"produit.Reconduction\" class=\"red-100-bg font-size-10 grey-900-fg p-5 ng-bindin brad-16 ml-5\">\nReconduction automatique</span></p><md-content class=\"md-dense\" ng-if=\"produit.Plugin==\'plg_ref\'\"><md-button \nclass=\"md-raised\" ng-click=\"vm.editPlugin($event, produit)\" \nng-disabled=\"vm.commande.Etat == \'Facturée\' || vm.commande.Etat == \'Signée\'\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon><span>Requêtes & localités</span></md-button></md-content></div></div></td><td \nclass=\"text-right\"><md-input-container class=\"pt-24\"><input class=\"text-right\" \nng-disabled=\"produit.IDProduit===\'\' || vm.commande.Etat == \'Facturée\'\" type=\"number\" aria-label=\"Quantité\" \nng-model=\"produit.Quantite\" step=\"1\" min=\"1\" required ng-change=\"vm.calcTotal()\"></md-input-container></td><td \nclass=\"text-right\"><a href=\"#\" e-single editable-number=\"produit.PrixVenteFinalHT\" \nedit-disabled=\"produit.IDProduit===\'\' || vm.commande.Etat == \'Facturée\' || produit.PrixSpecifiques.length\" \ne-step=\"any\" e-max=\"produit.PrixVenteHT\" e-required onaftersave=\"vm.calcTotal()\"><md-tooltip md-direction=\"top\" \nng-if=\"produit.IDProduit!==\'\' && vm.commande.Etat != \'Facturée\'\">\n{{produit.PrixSpecifiques.length ? \"Prix dégressifs selon quantité\" : \"Modifier\"}}</md-tooltip>\n{{produit.PrixVenteFinalHT}}</a> € <small \nng-show=\"produit.PrixVenteHT!=0 && produit.PrixVenteHT != produit.PrixVenteFinalHT && vm.commande.affichageRemiseProduits == \'Affichée\'\" \nclass=\"red-600-fg\"><br><del>{{produit.PrixVenteHT | currency:\'\'}} €</del></small></td><td ng-if=\"vm.showMarges\" \nng-class=\"produit.SousProduitsSelect.length > 0 ? \'noborder\' : \'\'\" class=\"text-center md-red-50-bg\"><span \nng-if=\"produit.PrixAchatHT>0\">{{produit.PrixAchatHT | currency:\'\'}} €	<span></span></span></td><td class=\"text-right\">\n{{produit.PrixVenteFinalHT * produit.Quantite | currency:\'\'}} € <small \nng-show=\"produit.PrixVenteHT != 0 && produit.PrixVenteHT != produit.PrixVenteFinalHT && vm.commande.affichageRemiseProduits == \'Affichée\'\" \nclass=\"red-600-fg\"><br><del>{{produit.PrixVenteHT * produit.Quantite | currency:\'\'}} €</del></small></td></tr><tr \nng-repeat-end ng-repeat=\"SousProduits in produit.SousProduitsSelect\" class=\"SousProduits not-sortable\"><td \nclass=\"text-center\" style=\"vertical-align:top\" ng-hide=\"vm.commande.Etat == \'Facturée\'\" \nrowspan=\"{{produit.SousProduitsSelect.length}}\" ng-if=\"$first\"></td><td ng-class=\"!$last ? \'smborder\' : \'\'\"><div \nlayout=\"row\" layout-align=\"start start\"><md-icon class=\"material-icons-outlined blue-grey-900-fg mt-0\" flex=\"10\">\ncheck_box</md-icon><div flex=\"90\"><span class=\"\" flex>{{SousProduits.Produit}}</span> <small hide-xs \nng-bind-html=\"SousProduits.NoteCommande\">{{SousProduits.NoteCommande}}</small></div></div></td><td \nng-class=\"!$last ? \'smborder\' : \'\'\" class=\"text-right\"><md-input-container class=\"pt-24\"><input class=\"text-right\" \nng-disabled=\"produit.IDProduit===\'\' || vm.commande.Etat == \'Facturée\'\" type=\"number\" aria-label=\"Quantité\" \nng-model=\"SousProduits.Quantite\" step=\"1\" min=\"1\" required ng-change=\"vm.calcTotal()\"></md-input-container></td><td \nng-class=\"!$last ? \'smborder\' : \'\'\" class=\"text-right\"><a href=\"#\" e-single \neditable-number=\"SousProduits.PrixVenteFinalHT\" \nedit-disabled=\"SousProduits.IDProduit===\'\' || vm.commande.Etat == \'Facturée\'\" e-step=\"any\" \ne-max=\"SousProduits.PrixVenteHT\" e-required onaftersave=\"vm.calcTotal()\">{{SousProduits.PrixVenteFinalHT}}</a> €\n<md-tooltip md-direction=\"top\" ng-if=\"SousProduits.IDProduit!==\'\' && vm.commande.Etat != \'Facturée\'\">\n{{SousProduits.PrixSpecifiques.length ? \"Prix dégressifs selon quantité\" : \"Modifier\"}}</md-tooltip><small \nng-show=\"SousProduits.PrixVenteHT!=0 && SousProduits.PrixVenteHT != SousProduits.PrixVenteFinalHT && vm.commande.affichageRemiseProduits == \'Affichée\'\" \nclass=\"red-600-fg\"><br><del>{{SousProduits.PrixVenteHT | currency:\'\'}} €</del></small></td><td ng-if=\"vm.showMarges\" \nng-class=\"!$last ? \'noborder\' : \'\'\" class=\"text-center md-red-50-bg\"><span ng-if=\"SousProduits.PrixAchatHT>0\">\n{{SousProduits.PrixAchatHT | currency:\'\'}} €	<span></span></span></td><td ng-class=\"!$last ? \'smborder\' : \'\'\" \nclass=\"text-right\">{{SousProduits.PrixVenteFinalHT * SousProduits.Quantite | currency:\'\'}} € <small \nng-show=\"SousProduits.PrixVenteHT != 0 && SousProduits.PrixVenteHT != SousProduits.PrixVenteFinalHT && vm.commande.affichageRemiseProduits == \'Affichée\'\" \nclass=\"red-600-fg\"><br><del>{{SousProduits.PrixVenteHT * SousProduits.Quantite | currency:\'\'}} €</del></small></td>\n</tr><tr class=\"not-sortable row-com\"><td colspan=\"6\"><md-input-container class=\"md-block\" \nng-if=\"vm.showComplementaires || vm.commande.Complementaires\"><textarea aria-label=\"Description du produit\" \nui-tinymce=\"tinymceOptions\" ng-model=\"vm.commande.Complementaires\" rows=\"5\" \nng-disabled=\"vm.commande.Etat == \'Facturée\' || !vm.commande.IDContact\"></textarea></md-input-container>\n<md-input-container class=\"md-block info-complementaires\" \nng-if=\"!vm.showComplementaires && !vm.commande.Complementaires\"><a href=\"#\" ng-click=\"vm.showComplementaires=true\" \nng-hide=\"vm.commande.Etat == \'Facturée\' || !vm.commande.IDContact\"><p \nng-class=\"(vm.commande.Complementaires)? \'md-grey-100-bg p-16\': \'\'\">\n{{vm.commande.Complementaires || \'Ajouter des informations complémentaires\' }}</p><md-tooltip md-direction=\"top\" \nng-show=\"vm.commande.Complementaires && vm.commande.Etat != \'Facturée\'\">\nCliquer pour modifier les informations complémentaires</md-tooltip></a></md-input-container></td></tr><tr \nclass=\"not-sortable row-sort\" ng-hide=\"vm.commande.Etat == \'Facturée\'\"><td colspan=\"3\" class=\"pb-0\"><md-button \nclass=\"md-raised ml-0\" ng-click=\"vm.addProduit($event)\" ng-show=\"vm.commande.IDContact\"><md-icon \nclass=\"material-icons-outlined\">add_box</md-icon><span>Ajouter un produit</span></md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.deplacer = !vm.deplacer; vm.showMarges = 0\" \nng-disabled=\"vm.commande.produits.length <= 1\"><md-icon md-font-icon=\"icon icon-cursor-move\"></md-icon><span>\nModifier l\'ordre</span></md-button></td><td colspan=\"3\" class=\"text-right pb-0\"><md-switch md-invert \nstyle=\"float:right\" class=\"md-warn m-0\" ng-model=\"vm.commande.affichageRemiseProduits\" ng-true-value=\"\'Affichée\'\" \nng-false-value=\"\'Masquée\'\">Remises produits ({{vm.commande.affichageRemiseProduits}}s au client)<md-tooltip \nmd-direction=\"bottom\">Afficher les remises sur la commande</md-tooltip></md-switch></td></tr></tbody></table><table \nclass=\"simple invoice-table-footer mt-16\" ng-hide=\"vm.deplacer\"><tbody><tr class=\"subtotal md-red-50-bg\" \nng-if=\"vm.showMarges\"><td class=\"pl-8\">TOTAL Charges</td><td class=\"pr-8\"><span>\n{{vm.commande.TotalChargesHT | currency:\'\'}} €</span></td></tr><tr class=\"subtotal\"><td>TOTAL HT <span \nng-show=\"vm.commande.affichageRemiseProduits == \'Affichée\' && vm.commande.TotalHT < vm.commande.TotalOriginalHT\">\nAVANT REMISES PRODUITS</span></td><td><span ng-show=\"vm.commande.affichageRemiseProduits == \'Affichée\'\">\n{{vm.commande.TotalOriginalHT | currency:\'\'}} €</span> <span \nng-hide=\"vm.commande.affichageRemiseProduits == \'Affichée\'\">{{vm.commande.TotalHT | currency:\'\'}} €</span></td></tr><tr\n class=\"subtotal\" \nng-show=\"vm.commande.TotalHT != vm.commande.TotalOriginalHT && vm.commande.affichageRemiseProduits == \'Affichée\'\"><td>\n<span ng-hide=\"vm.commande.TotalHT > vm.commande.TotalOriginalHT\">REMISE SUR PRODUITS HT</span><span \nng-hide=\"vm.commande.TotalHT < vm.commande.TotalOriginalHT\">PLUSVALUE HT</span></td><td class=\"red-600-fg\">\n{{vm.commande.TotalHT - vm.commande.TotalOriginalHT | currency:\'\'}} €</td></tr><tr class=\"subtotal\" \nng-show=\"vm.commande.TotalHT != vm.commande.TotalOriginalHT  && vm.commande.affichageRemiseProduits == \'Affichée\'\"><td>\nTOTAL HT</td><td>{{vm.commande.TotalHT | currency:\'\'}} €</td></tr><tr class=\"subtotal\"><td><span>REMISE</span></td><td>\n<md-button aria-label=\"Ajouter une remise\" ng-click=\"vm.commande.RemiseActive=1;vm.calcTotal();vm.calcPaiement()\" \nng-hide=\"vm.commande.RemiseActive || vm.commande.Etat == \'Facturée\'\" class=\"md-raised mr-0\">Ajouter une remise\n</md-button><md-input-container md-no-float flex ng-show=\"vm.commande.RemiseActive\"><input style=\"width:70px\" \ntype=\"number\" ng-model=\"vm.commande.Remise\" ng-value=\"0\" aria-label=\"Remise\" \nng-disabled=\"vm.commande.Etat == \'Facturée\'\" aria-label=\"Montant remise\" ng-change=\"vm.calcTotal();vm.calcPaiement()\" \nng-required=\"vm.commande.RemiseActive\"></md-input-container><md-input-container md-no-float flex \nng-show=\"vm.commande.RemiseActive\"><md-select ng-model=\"vm.commande.RemiseEuroPourcent\" \nng-required=\"vm.commande.RemiseActive\" aria-label=\"Type de remise\" ng-disabled=\"vm.commande.Etat == \'Facturée\'\" \nng-change=\"vm.calcTotal();vm.calcPaiement()\"><md-option value=\"€\">€</md-option><md-option value=\"%\">%</md-option>\n</md-select></md-input-container><md-button class=\"md-primary md-icon-button\" \nng-show=\"vm.commande.RemiseActive && vm.commande.Etat != \'Facturée\'\" \nng-click=\"vm.commande.RemiseActive=0;vm.calcTotal();vm.calcPaiement()\"><md-icon \nclass=\"material-icons-outlined red-900-fg\">delete</md-icon><md-tooltip md-direction=\"left\">Supprimer la remise\n</md-tooltip></md-button></td></tr><tr class=\"subtotal\" ng-show=\"vm.commande.RemiseActive\"><td>NOUVEAU TOTAL HT</td>\n<td>{{vm.commande.TotalHTRemise | currency:\'\'}} €</td></tr><tr \nclass=\"subtotal {{(vm.commande.MargeBrutHT < 0 && vm.commande.TotalTTC >= 0) ? \'md-red-500-bg\' : \'md-green-50-bg\';}}\" \nng-if=\"vm.showMarges\"><td class=\"pl-8\">TOTAL Marges brutes</td><td class=\"pr-8\"><span>\n{{vm.commande.MargeBrutHT | currency:\'\'}} €</span></td></tr><tr class=\"tax\"><td>TVA 20%</td><td>\n{{vm.commande.TotalTTC - vm.commande.TotalHTRemise | currency:\'\'}} €</td></tr><tr class=\"total\"><td><strong>TOTAL TTC\n</strong></td><td><strong>{{vm.commande.TotalTTC | currency:\'\'}} €</strong></td></tr><tr \nng-show=\"((1 - vm.commande.TotalHTRemise / vm.commande.TotalOriginalHT)*100) > 10 && !vm.commande.AutoriseRemiseSup\">\n<td colspan=\"2\"><h3 class=\"red-500-fg mb-0\" layout=\"row\" layout-wrap layout-align=\"start center\"><md-icon \nclass=\"material-icons-outlined mr-16 red-500-fg\">error_outline</md-icon><p flex>Le total des remises équivaut à \n<strong>{{(1 - vm.commande.TotalHTRemise / vm.commande.TotalOriginalHT)*100 | currency:\'\'}} %</strong> de la commande !\n<br>Ne dépassez pas 10% ou contacter un administrateur en cas exceptionnel.</p></h3></td></tr><tr \nng-show=\"vm.DureeEngagementDiff()\"><td colspan=\"2\"><h3 class=\"red-500-fg mb-0\" layout=\"row\" layout-wrap \nlayout-align=\"start center\"><md-icon class=\"material-icons-outlined mr-16 red-500-fg\">error_outline</md-icon><p flex>\nPour des raisons de suivi, l\'ensemble des produits doit avoir la même durée d\'engagement sur une même commande.</p>\n</h3></td></tr><tr ng-show=\"vm.FinancementBloque()\"><td colspan=\"2\"><h3 class=\"red-500-fg mb-0\" layout=\"row\" \nlayout-wrap layout-align=\"start center\"><md-icon class=\"material-icons-outlined mr-16 red-500-fg\">error_outline\n</md-icon><p flex>Les financements ne sont pas autorisés sur certains produits de cette commande.</p></h3></td></tr><tr\n ng-show=\"vm.FinancementRemiseBloque()\"><td colspan=\"2\"><h3 class=\"red-500-fg mb-0\" layout=\"row\" layout-wrap \nlayout-align=\"start center\"><md-icon class=\"material-icons-outlined mr-16 red-500-fg\">error_outline</md-icon><p flex>\nLes remises ne sont pas autorisées sur les financements, les intérêts (de ~11%) étant déjà offerts.</p></h3></td></tr>\n<tr ng-show=\"(vm.commande.MargeBrutHT < 0  && vm.commande.TotalTTC >= 0)\"><td colspan=\"2\"><h3 class=\"red-500-fg mb-0\" \nlayout=\"row\" layout-wrap layout-align=\"start center\"><md-icon class=\"material-icons-outlined mr-16 red-500-fg\">\nerror_outline</md-icon><p flex>\nLe prix de vente de cette commande ne suffit pas à couvrir les charges externes. Cette commande est à perte.</p></h3>\n</td></tr></tbody></table></div><div class=\"footer\" ng-hide=\"vm.commande.TotalTTC<=0 || vm.deplacer \"><md-divider \nclass=\"\"></md-divider><md-list flex=\"100\" class=\"pl-8 pr-8\"><md-list-item \nclass=\"secondary-button-padding md-3-line md-long-text\"><div class=\"md-list-item-text\"><p ng-hide=\"vm.commande.IBAN\">\nAucun IBAN sélectionné.</p><p ng-show=\"vm.commande.IBAN\"><strong>IBAN client : </strong>{{vm.commande.IBAN}}</p><p \nng-show=\"vm.commande.IBAN\"><strong>BIC : </strong>{{vm.commande.BIC}}</p><p ng-show=\"vm.commande.IBAN\"><strong>\nDomiciliation : </strong>{{vm.commande.Domiciliation}}</p><p ng-show=\"vm.commande.IBAN\"><strong>Titulaire : </strong>\n{{vm.commande.Titulaire}}</p></div><md-button ng-hide=\"vm.commande.IBAN || vm.commande.Etat == \'Facturée\'\" \nclass=\"md-secondary\" ng-click=\"vm.editIBAN($event)\"><md-icon class=\"material-icons-outlined\">drive_file_rename_outline\n</md-icon>Sélectionner</md-button><md-button ng-show=\"vm.commande.IBAN && vm.commande.Etat != \'Facturée\'\" \nclass=\"md-secondary\" \nng-click=\"vm.commande.IDCommande_IBAN = vm.commande.IDIBAN = vm.commande.IBAN = vm.commande.BIC = vm.commande.Domiciliation = vm.commande.Titulaire = \'\'\">\n<md-icon class=\"material-icons-outlined\">drive_file_rename_outline</md-icon>Retirer ou modifier</md-button>\n</md-list-item></md-list><md-divider class=\"mb-24\"></md-divider><div class=\"note pl-24 pr-24\">\nEchéanciers de paiements :</div><div layout=\"column\" layout-align=\"start none\" flex=\"100\" class=\"pl-8 pr-8\"><md-list \nflex=\"100\"><md-list-item class=\"secondary-button-padding\" ng-hide=\"vm.commande.Etat == \'Facturée\'\" \nng-repeat=\"paiement in vm.commande.paiements\"><h3 ng-if=\"paiement.Type!=\'Mensualité\' && paiement.Type!=\'Financement\'\">\n{{paiement.Type}} de <strong>{{paiement.Montant | currency:\'\'}} €</strong> par <strong>{{paiement.Mode}}</strong> \n<strong ng-show=\"paiement.DateMode == \'signature\'\">à la signature du devis</strong> <strong \nng-show=\"paiement.DateMode == \'facturation\'\">à la facturation</strong> <span \nng-show=\"paiement.DateMode == \'spécifique\'\">le <strong>{{paiement.DatePaiement | date : format : shortDate}}</strong>\n</span> <span ng-show=\"paiement.DateMode == \'étape\'\">- <strong>{{paiement.Etape}}</strong></span></h3><h3 \nng-if=\"paiement.Type==\'Mensualité\'\">{{paiement.NbrMensualites}} {{paiement.Type}}s de <strong>\n{{paiement.Montant/paiement.NbrMensualites | currency:\'\'}} €</strong> par <strong>{{paiement.Mode}}</strong> <strong \nng-show=\"paiement.DateMode == \'signature\'\">à partir de la signature du devis</strong> <strong \nng-show=\"paiement.DateMode == \'facturation\'\">à partir de la facturation</strong> <span \nng-show=\"paiement.DateMode == \'spécifique\'\">à partir du <strong>{{paiement.DatePaiement | date : format : shortDate}}\n</strong></span> <span ng-show=\"paiement.DateMode == \'étape\'\">à partir de <strong>{{paiement.Etape}}</strong></span>\n</h3><h3 ng-if=\"paiement.Type==\'Financement\'\">{{paiement.NbrMensualites}} mensualités de <strong>\n{{paiement.Montant/paiement.NbrMensualites | currency:\'\'}} €</strong> par <strong>{{paiement.Mode}}</strong> <strong \nng-show=\"paiement.DateMode == \'signature\'\">à partir de la signature du devis</strong> <strong \nng-show=\"paiement.DateMode == \'facturation\'\">à partir de la facturation</strong> <span \nng-show=\"paiement.DateMode == \'spécifique\'\">à partir du <strong>{{paiement.DatePaiement | date : format : shortDate}}\n</strong></span> <span ng-show=\"paiement.DateMode == \'étape\'\">à partir de <strong>{{paiement.Etape}}</strong></span>\n</h3><md-menu class=\"md-secondary\" ng-hide=\"vm.commande.Etat == \'Facturée\'\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.addPaiement($event , paiement)\" ng-disabled=\"paiement.FactureAc == 1\">\nModifier <span ng-show=\"paiement.FactureAc == 1\">(déjà facturé)</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.dupliquerPaiement(paiement)\" ng-disabled=\"vm.commande.TotalTTC<=vm.TotalPaiement\">Dupliquer\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.removePaiement(paiement)\" \nng-disabled=\"paiement.FactureAc == 1\">Supprimer <span ng-show=\"paiement.FactureAc == 1\">(déjà facturé)</span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-list-item><md-list-item class=\"secondary-button-padding\" \nng-show=\"vm.commande.Etat == \'Facturée\'\" ng-repeat=\"paiement in vm.commande.paiements\"><h3>{{paiement.Type}} de \n<strong>{{paiement.Montant | currency:\'\'}} €</strong> par <strong>{{paiement.Mode}}</strong> <strong \nng-show=\"paiement.DateMode == \'signature\'\">à la signature du devis</strong> <strong \nng-show=\"paiement.DateMode == \'facturation\'\">à la facturation</strong> <span \nng-show=\"paiement.DateMode == \'spécifique\'\">le <strong>{{paiement.DatePaiement | date : format : shortDate}}</strong>\n</span> <span ng-show=\"paiement.DateMode == \'étape\'\">- <strong>{{paiement.Etape}}</strong></span></h3></md-list-item>\n<md-list-item class=\"secondary-button-padding\" \nng-hide=\"vm.commande.TotalTTC<=vm.TotalPaiement || vm.commande.Etat == \'Facturée\'\"><h3 flex=\"100\">Solde de <strong>\n{{vm.commande.TotalTTC-vm.TotalPaiement | currency:\'\'}} €</strong> à régler à la facturation</h3><md-menu \nclass=\"md-secondary\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.addPaiement($event)\">Ajouter une échéance</md-button></md-menu-item></md-menu-content></md-menu>\n</md-list-item></md-list><div flex=\"100\"><h3 class=\"red-500-fg\" \nng-show=\"vm.commande.TotalTTC<vm.TotalPaiement && vm.commande.TotalTTC>=0\"><md-icon \nclass=\"material-icons-outlined ml-16 mr-8 red-500-fg\">error_outline</md-icon>\nLe total des paiements est supérieur au montant de la commande de <strong>\n{{vm.TotalPaiement - vm.commande.TotalTTC | currency:\'\'}} €</strong> !</h3></div></div></div></div></form><div \nclass=\"page-break\"></div></div><div layout=\"row\" class=\"comment-container\" layout-align=\"end stretch\" \nlayout-align-sm=\"end end\" layout-align-xs=\"end end\" flex flex-sm=\"100\" flex-xs=\"100\" flex-order-sm=\"-1\" \nflex-order-xs=\"-1\"><md-sidenav class=\"md-sidenav-right bl {{$mdMedia(\'gt-md\') ? \'mt-5\' : \'\'}} sidenav\" \nmd-component-id=\"comment-sidenav\" md-is-locked-open=\"vm.sidenavOpen && $mdMedia(\'gt-md\')\" \nng-show=\"vm.commande.IDContact\"><div class=\"add-post bb p-8 pl-16 pr-16\" ng-show=\"vm.commande.IDContact\">\n<md-input-container class=\"md-block\"><label>Ajouter une note</label><textarea ng-model=\"vm.text_add_post\"></textarea>\n</md-input-container><footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.add_post()\" \nclass=\"post-button md-raised\" aria-label=\"Ajouter\">Ajouter</md-button></footer></div><div \nclass=\"invoice-notes scrollable p-16 md-background-bg mt-5\" ms-scroll><h3 ng-hide=\"vm.commande.notes.length>0\"><strong>\nAucun commentaire pour cette commande.</strong></h3><h3 ng-show=\"vm.commande.notes.length>0\"><strong>\n{{vm.commande.notes.length}} commentaire(s) pour cette commande :</strong></h3><div \nng-repeat=\"note in vm.commande.notes\"><div ng-show=\"note.Edit == 1\" ng-if=\"!note.Commandes && note.IDEmploye == id\" \nclass=\"pt-8 pb-8 mb-16 add-post\" style=\"border-top:2px solid #f44336; border-bottom:2px solid #f44336\">\n<md-input-container class=\"md-block\"><label>Modifier votre commentaire</label><textarea ng-model=\"note.Note\" \nmd-detect-hidden=\"true\"></textarea></md-input-container><footer layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"note.Edit = 0; note.Note = note.Temp\" class=\"post-button\" aria-label=\"Annuler\">Annuler</md-button><md-button \nng-click=\"vm.edit_post(note)\" class=\"post-button md-raised md-accent\" aria-label=\"Modifier\">Modifier</md-button>\n</footer></div><div class=\"p-8 pl-16 pr-16 mb-16 brad-16\" ng-hide=\"note.Edit == 1\" \nng-class=\"(note.IDListe == vm.commande.IDListe_NotesContact) ? \'blue-grey-50-bg\' : \'blue-50-bg\'\"><blockquote><p \nclass=\"mt-0\" style=\"white-space: pre-line;word-wrap: break-word\"><strong \nng-if=\"note.IDListe == vm.commande.IDListe_NotesContact\">Note générale du contact<br><br></strong>{{note.Note}}</p>\n<footer layout=\"row\" layout-align=\"start start\"><md-truncate flex>{{note.Utilisateur}}<br><small>{{note.DateCreation}}\n</small><br ng-if=\"note.DateModification\"><small ng-if=\"note.DateModification\">{{note.DateModification}}</small>\n</md-truncate><md-button class=\"edit-post p-0 m-0 md-primary font-size-12\" aria-label=\"Modifier\" \nng-if=\"note.IDListe != vm.commande.IDListe_NotesContact  && note.IDEmploye == id\" \nng-click=\"note.Edit = 1; note.Temp = note.Note\"><md-icon class=\"material-icons-outlined font-size-12\">edit</md-icon>\nModifier</md-button></footer></blockquote></div></div></div></md-sidenav><div \nclass=\"white-bg bl bb {{$mdMedia(\'sm\') || $mdMedia(\'xs\') ? \'p-8\' : \' pt-24\'}} mt-5\" flex=\"100\"><md-button \nclass=\"md-icon-button sidenav-toggle\" aria-label=\"Commentaires\" ng-click=\"vm.toggleSidenav(\'comment-sidenav\')\"><md-icon\n class=\"material-icons-outlined\" ng-if=\"vm.sidenavOpen\"><md-tooltip md-direction=\"left\">Masquer les commentaires\n</md-tooltip>speaker_notes</md-icon><md-icon class=\"material-icons-outlined\" ng-if=\"!vm.sidenavOpen\"><md-tooltip \nmd-direction=\"left\">Afficher les commentaires</md-tooltip>speaker_notes_off</md-icon></md-button></div></div></div>\n</div>");
$templateCache.put("app/main/commandes/commandes/commandes.html","<div id=\"commandes\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/commandes/commandes/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"center scrollable\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper\" flex layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"search md-whiteframe-2dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"commandes-search\" class=\"search\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"Rechercher\" flex> <button ng-if=\"vm.search\" \nng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');\"><md-icon class=\"material-icons-outlined\">cancel</md-icon>\n</button></div></div></div><div layout=\"row\" flex layout-align=\"space-between \"><div class=\"content-card main\" \nflex=\"100\" layout=\"column\" flex><table class=\"dataTable dataTableCommandes row-border hover\" datatable \ndt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"></table></div></div></div></div>");
$templateCache.put("app/main/commandes/factures/factures.html","<div id=\"factures\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/commandes/factures/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-wrap layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"search-wrapper\" flex layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search md-whiteframe-2dp\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input \nid=\"factures-search\" class=\"search\" type=\"text\" ng-model=\"vm.search\" placeholder=\"Rechercher\" flex> <button \nng-if=\"vm.search\" ng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');\"><md-icon class=\"material-icons-outlined\">\ncancel</md-icon></button></div></div><div class=\"module-actions\" layout=\"row\" layout-wrap layout-align=\"end center\">\n<md-button class=\"md-raised\" ng-if=\"vm.droitFacture(\'synchronisation\')\" ng-disabled=\"vm.synchronisationEnCours\" \nng-click=\"vm.synchroniserFactures()\"><md-icon class=\"material-icons-outlined\">sync</md-icon><span>Synchroniser</span>\n</md-button><md-menu ng-if=\"vm.droitFacture(\'export\')\"><md-button class=\"md-raised\" ng-click=\"$mdMenu.open($event)\">\n<md-icon class=\"material-icons-outlined\">file_download</md-icon><span>Exporter</span></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"vm.exporterFactures(\'select\')\" ng-disabled=\"!vm.nombreSelectionFactures()\"><md-icon \nclass=\"material-icons-outlined\">fact_check</md-icon>La sélection ({{vm.nombreSelectionFactures()}})</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.exporterFactures(\'filter\')\"><md-icon \nclass=\"material-icons-outlined\">filter_list</md-icon>Les résultats filtrés</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div class=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table \nclass=\"dataTable dataTableFactures row-border hover\" datatable dt-instance=\"vm.dtInstanceFactures\" \ndt-columns=\"vm.dtColumnsFactures\" dt-options=\"vm.dtOptionsFactures\"></table></div></div></div>");
$templateCache.put("app/main/commandes/fournisseurs/fournisseurs.html","<div id=\"fournisseurs\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"white-fg pr-32\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"material-icons-outlined s28\">recent_actors\n</md-icon><span class=\"ml-10\">Fournisseurs</span></div><div class=\"fournisseurs-count secondary-text\"><span>\n{{vm.recordsTotal}} fournisseurs</span></div></div><div><md-button class=\"md-raised\" \nng-click=\"vm.editFournisseur($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span>Ajouter</span></md-button>\n</div></div><div layout=\"row\" flex layout-align=\"space-between \"><div class=\"content-card\" flex=\"100\" layout=\"column\" \nflex><div class=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table \nclass=\"dataTable dataTableFournisseurs row-border hover\" datatable dt-instance=\"vm.dtInstance\" \ndt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"></table></div></div></div></div></div>");
$templateCache.put("app/main/commandes/produit/produit.html","<div id=\"commandes-produit\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-produits-button md-icon-button\" aria-label=\"Go to produits\" ng-click=\"vm.gotoProduits()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"produit-image\" hide-xs><img \nng-src=\"{{vm.produit.Images.length>0 ? vm.produit.Images[0] : \'/assets/images/ecommerce/product-image-placeholder.png\'}}\">\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.produit.Produit}}</div><div \nclass=\"subtitle secondary-text\"><span>Modification du produit</span></div></div></div></div><div layout=\"row\">\n<md-button class=\"send-button md-raised\" ng-click=\"vm.saveProduit()\" \nng-disabled=\"!vm.isFormValid(\'produitForm\') || !vm.isFormValid(\'produitForm2\') || !vm.isFormValid(\'produitForm3\') || !vm.isFormValid(\'produitForm5\')\">\n<md-icon ng-show=\"!vm.showSpinner\" md-font-icon=\"icon icon-content-save\"></md-icon><span ng-show=\"!vm.showSpinner\">\nEnregistrer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\">\n</md-progress-circular></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label>\n<span>Informations générales</span></md-tab-label><md-tab-body><div \nclass=\"produit-detail-form-container md-background-bg brad-16 border\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"><form \nid=\"produitForm\" name=\"produitForm\" layout=\"column\"><h2>Informations générales</h2><md-input-container \nclass=\"md-block\"><label>Publication</label><md-select ng-model=\"vm.produit.Etat\" name=\"Etat\" required><md-option \nng-value=\"1\">Activé</md-option><md-option ng-value=\"0\">Désactivé</md-option></md-select><div \nng-messages=\"produitForm.Etat.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Nom du produit</label><input type=\"text\" \nng-model=\"vm.produit.Produit\" name=\"Produit\" required><div ng-messages=\"produitForm.Produit.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block\">\n<label>Référence</label><input type=\"text\" ng-model=\"vm.produit.Reference\" name=\"Reference\" required><div \nng-messages=\"produitForm.Reference.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Catégories</label><md-select \nng-model=\"vm.produit.IDCategorie\" md-on-open=\"openSelectSearch(\'#header-searchbox\')\" \nmd-on-open=\"vm.onCategoriesSelectorOpen()\" md-on-close=\"vm.onCategoriesSelectorClose()\" name=\"IDCategorie\" required>\n<div ng-repeat=\"categorie in vm.categories\" ng-include=\"\'app/main/commandes/produits/dialogs/tree-renderer.html\'\" \nonload=\"value=categorie; indent=0\"></div></md-select><div ng-messages=\"produitForm.IDCategorie.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></form></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>Présentation</span></md-tab-label><md-tab-body><div \nclass=\"produit-detail-form-container md-background-bg brad-16 border\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"><form \nid=\"produitForm\" name=\"produitForm3\" layout=\"column\"><h2 class=\"mb-0\">Résumé du produit</h2><p>\nCes informations seront affichées sur les bons de commandes, les devis et les factures, accompagnant le nom du produit.\n</p><md-input-container class=\"md-block\"><textarea aria-label=\"Résumé du produit\" ui-tinymce=\"tinymceOptions\" \nng-model=\"vm.produit.NoteCommande\" rows=\"5\"></textarea></md-input-container><md-divider class=\"md-default-theme\">\n</md-divider><h2 class=\"mb-0\">Description du produit</h2><p>\nCette description complête du produit sera communiquée au prospect ou client via un cahier des charges.</p>\n<md-input-container class=\"md-block\"><textarea aria-label=\"Description du produit\" ui-tinymce=\"tinymceOptions\" \nng-model=\"vm.produit.Description\" rows=\"5\"></textarea></md-input-container><md-divider class=\"md-default-theme\">\n</md-divider><h2 class=\"mb-0\">Note Interne</h2><p>\nCette note accompagnera le produit mais ne sera visible que pour les utilisateurs de cet ERP.</p><md-input-container \nclass=\"md-block\"><textarea aria-label=\"Note Interne\" ui-tinymce=\"tinymceOptions\" ng-model=\"vm.produit.NoteInterne\" \nrows=\"5\"></textarea></md-input-container></form></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Images</span>\n</md-tab-label><md-tab-body><div class=\"produit-detail-form-container md-background-bg brad-16 border\" flex=\"100\" \nflex-gt-sm=\"80\" flex-gt-md=\"60\"><div ng-if=\"!vm.produit.IDProduit\">\nVeuillez enregistrer le produit pour pouvoir ajouter des images.</div><form id=\"produitForm\" name=\"produitForm4\" \nlayout=\"column\" ng-if=\"vm.produit.IDProduit\"><div class=\"mv-32\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.produit.Images.length > 0\"><div class=\"image-zoom-area\"><img ng-src=\"{{vm.imageZoomOptions}}\"></div></div>\n<div layout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"product-image\" layout=\"row\" \nlayout-align=\"center center\" style=\"width: 100%\"><div ng-repeat=\"image in vm.produit.Images track by $index\" \nclass=\"media m-8 md-whiteframe-2dp\" style=\"height: 175px; position:relative\"><img class=\"md-raised\" \nstyle=\"height:100%; width: auto\" ng-src=\"{{image}}\" ng-click=\"vm.updateImageZoomOptions(image)\"><md-button \nclass=\"md-fab md-mini md-warn\" ng-click=\"vm.deleteImg($index)\" style=\"position: absolute;right: 0;top: 0\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-button ng-click=\"vm.selectImage($event)\" \nclass=\"border md-accent m-8 pt-24\" layout=\"column\" layout-align=\"center center\" style=\"height:180px;  width:100%\">\n<md-icon style=\"margin:0\" class=\"s50\" md-font-icon=\"icon-camera\"></md-icon><p>Mettez votre produit en<br>\nvaleur avec une photo</p></md-button></div></div><div class=\"p-8 font-size-12\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.produit.Images.length > 0\">Cliquer sur une image pour zoomer !</div></form>\n</div></md-tab-body></md-tab><md-tab><md-tab-label><span>Réglages</span></md-tab-label><md-tab-body><div \nclass=\"produit-detail-form-container md-background-bg brad-16 border\" flex=\"100\" flex-gt-sm=\"80\" flex-gt-md=\"60\"><form \nid=\"produitForm2\" name=\"produitForm2\" layout=\"column\"><h2>Options et réglages</h2><md-input-container class=\"md-block\">\n<label>Durée d\'engagement</label><md-select ng-model=\"vm.produit.Renouvellement\" name=\"Renouvellement\" required>\n<md-option ng-value=\"12\">12 mois</md-option><md-option ng-value=\"11\">11 mois</md-option><md-option ng-value=\"10\">\n10 mois</md-option><md-option ng-value=\"9\">9 mois</md-option><md-option ng-value=\"8\">8 mois</md-option><md-option \nng-value=\"7\">7 mois</md-option><md-option ng-value=\"6\">6 mois</md-option><md-option ng-value=\"5\">5 mois</md-option>\n<md-option ng-value=\"4\">4 mois</md-option><md-option ng-value=\"3\">3 mois</md-option><md-option ng-value=\"2\">2 mois\n</md-option><md-option ng-value=\"1\">1 mois</md-option><md-option ng-value=\"-1\">Variable</md-option><md-option \nng-value=\"0\">Sans abonnement</md-option></md-select><div ng-messages=\"produitForm2.Renouvellement.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block\">\n<label>Financement</label><md-select ng-model=\"vm.produit.FinancementInterdit\" name=\"FinancementInterdit\" required>\n<md-option ng-value=\"0\">Autorisé</md-option><md-option ng-value=\"1\">Interdit</md-option></md-select><div \nng-messages=\"produitForm2.FinancementInterdit.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><md-input-container class=\"md-block\" ng-show=\"vm.produit.Renouvellement\"><label>Reconduction\n</label><md-select ng-model=\"vm.produit.Reconduction\" name=\"Reconduction\" ng-required=\"vm.produit.Renouvellement\">\n<md-option ng-value=\"1\">Automatique (tacite)</md-option><md-option ng-value=\"0\">\nManuelle (nécessite une nouvelle validation du client)</md-option></md-select><div \nng-messages=\"produitForm2.Reconduction.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Plugin</label><md-select ng-model=\"vm.produit.Plugin\" \nname=\"Plugin\" required><md-option value=\"Aucun\">Aucun</md-option><md-option value=\"plg_ref\">Mot clés et Localités\n</md-option></md-select><div ng-messages=\"produitForm2.Plugin.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block\"><label>Vente</label>\n<md-select ng-model=\"vm.produit.AchatSeul\" name=\"AchatSeul\" required><md-option ng-value=\"1\">Disponible à l\'achat seul\n</md-option><md-option ng-value=\"0\">Uniquement vendu en option d\'un autre produit</md-option></md-select><div \nng-messages=\"produitForm2.AchatSeul.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.produit.options.length>0\"><label>\nCe produit peut être une option d\'autres produits</label><md-select ng-model=\"vm.produit.IDProduits\" \nmd-on-open=\"vm.onCategoriesSelectorOpen()\" md-on-close=\"vm.onCategoriesSelectorClose()\" multiple=\"multiple\">\n<md-select-header><input type=\"search\" class=\"md-text\" ng-model=\"vm.categoriesSelectFilter\" \nplaceholder=\"Chercher un produit\"></md-select-header><md-option ng-value=\"produit.IDProduit\" \nng-repeat=\"produit in vm.produits | filter:vm.categoriesSelectFilter\">{{produit.Produit}}</md-option></md-select>\n</md-input-container><h3 class=\"mb-0\" ng-show=\"vm.produit.options.length>0\">\nCe produit à {{vm.produit.options.length}} option(s) :</h3><ul class=\"mb-0\" ng-show=\"vm.produit.options.length>0\"><div \nng-repeat=\"option in vm.produit.options\"><li><a href=\"#\" ng-click=\"vm.gotoOption($event, option.IDProduit);\">\n{{option.Produit}}</a></li></div></ul></form></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Tarifs</span>\n</md-tab-label><md-tab-body><div class=\"produit-detail-form-container md-background-bg brad-16 border\" flex=\"100\" \nflex-gt-sm=\"80\" flex-gt-md=\"60\"><form id=\"produitForm\" name=\"produitForm5\" layout=\"column\"><h2>Valeurs d\'achat</h2><div\n layout=\"row\" ng-repeat=\"Fournisseur in vm.produit.Fournisseurs track by $index\"><md-input-container class=\"md-block\" \nflex><label>Fabricant / Fournisseur</label><md-select ng-model=\"vm.produit.Fournisseurs[$index].IDFabricant\" required \nname=\"IDFabricant{{$index}}\" md-on-open=\"vm.onCategoriesSelectorOpen()\" md-on-close=\"vm.onCategoriesSelectorClose()\">\n<md-select-header><input type=\"search\" class=\"md-text\" ng-model=\"vm.categoriesSelectFilter\" \nplaceholder=\"Chercher un fabricant / fournisseur\"></md-select-header><md-optgroup><md-option \nng-value=\"fabricant.IDFabricant\" ng-repeat=\"fabricant in vm.fabricants | filter:vm.categoriesSelectFilter\">\n{{fabricant.Fabricant}}<small ng-if=\"fabricant.Metier\"> ({{fabricant.Metier}})</small></md-option></md-optgroup>\n</md-select><div ng-messages=\"produitForm5[\'IDFabricant\'+$index].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block mr-8\" flex><label>\nValeur d\'achat</label><md-select ng-model=\"vm.produit.Fournisseurs[$index].ValeurAchat\" name=\"ValeurAchat{{$index}}\" \nrequired ng-change=\"vm.updateTTC()\"><md-option value=\"fixe\">Fixe</md-option><md-option value=\"pourcent\">Pourcentage\n</md-option></md-select><div ng-messages=\"produitForm5[\'ValeurAchat\'+$index].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block ml-8\" flex><label>\n{{vm.produit.Fournisseurs[$index].ValeurAchat == \'fixe\' ? \"Prix d\'achat HT\" : \"Pourcentage\" }}</label><input \ntype=\"number\" name=\"PrixAchatHT{{$index}}\" ng-model=\"vm.produit.Fournisseurs[$index].PrixAchatHT\" min=\"0\" \nmax=\"{{ (vm.produit.Fournisseurs[$index].ValeurAchat != \'fixe\' ? \'100\' :\'\') }}\" required><md-icon \nmd-font-icon=\"icon {{vm.produit.Fournisseurs[$index].ValeurAchat == \'fixe\' ? \'icon-currency-eur\' : \'icon-percent\'}}\">\n</md-icon><div ng-messages=\"produitForm5[\'PrixAchatHT\'+$index].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div><div ng-message=\"min\">Le montant doit être supérieur à 0</div><div ng-message=\"max\">\nLe montant doit être inférieur à 100</div></div></md-input-container><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.produit.Fournisseurs.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div layout=\"row\"><md-button \nng-click=\"vm.produit.Fournisseurs.push({\'IDFabricant\':\'\',\'ValeurAchat\':\'\',\'PrixAchatHT\':\'\'})\">+ Ajouter un fournisseur\n</md-button></div><h2>Règles de prix</h2><md-input-container class=\"md-block\"><label>Calcul du prix de vente HT</label>\n<md-select ng-model=\"vm.produit.ModePrixVente\" name=\"ModePrixVente\" required ng-change=\"vm.updateTTC()\"><md-option \nvalue=\"fixe\">Fixe</md-option><md-option value=\"pourcent\">Pourcentage d\'un autre produit</md-option><md-option \nvalue=\"sur-mesure\">Sur mesure (à définir lors à la commande)</md-option></md-select><md-icon \nmd-font-icon=\"icon icon-currency-eur\"></md-icon><div ng-messages=\"produitForm5.ModePrixVente.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block\">\n<label>Variation du prix de vente</label><md-select ng-model=\"vm.produit.PrixIncrementeParDuree\" \nname=\"PrixIncrementeParDuree\" ng-required=\"vm.produit.ModePrixVente!=\'pourcent\' && vm.produit.Renouvellement==\'-1\'\" \nng-show=\"vm.produit.ModePrixVente!=\'pourcent\' && vm.produit.Renouvellement==\'-1\'\"><md-option value=\"0\">Aucune\n</md-option><md-option value=\"1\">Indexée sur la durée mensuelle</md-option></md-select><div \nng-messages=\"produitForm5.PrixIncrementeParDuree.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n</div></md-input-container><div layout=\"row\"><md-input-container flex class=\"md-block mr-16\" \nng-show=\"vm.produit.ModePrixVente==\'fixe\'\"><label>Prix de vente HT</label><input type=\"number\" \nng-model=\"vm.produit.PrixVenteHT\" name=\"PrixVenteHT\" ng-required=\"vm.produit.ModePrixVente==\'fixe\'\" ng-min=\"0\" \nng-change=\"vm.updateTTC()\"><md-icon md-font-icon=\"icon icon-currency-eur\"></md-icon><div \nng-messages=\"produitForm5.PrixVenteHT.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"number\">You did not enter a valid number</div><div ng-message=\"min\">\nYour field value is lesser minimum value</div></div></md-input-container><md-input-container flex class=\"md-block\">\n<label>Taux de TVA</label><md-select ng-model=\"vm.produit.IDTVA\" required name=\"TVA\" ng-change=\"vm.updateTTC()\">\n<md-option ng-value=\"TVA.IDTVA\" ng-repeat=\"TVA in vm.TVA\">{{TVA.LabelTVA}}</md-option></md-select><md-icon \nmd-font-icon=\"icon icon-percent\"></md-icon><div ng-messages=\"produitForm5.TVA.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-input-container flex class=\"md-block ml-16\" \nng-show=\"vm.produit.ModePrixVente==\'fixe\'\"><label>Prix de vente TTC</label><input type=\"number\" step=\"0.01\" \nng-model=\"vm.produit.PrixVenteTTC\" disabled=\"disabled\"><md-icon md-font-icon=\"icon icon-currency-eur\"></md-icon>\n</md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block mr-16\" \nng-show=\"vm.produit.ModePrixVente==\'pourcent\'\"><label>Pourcentage prix</label><input type=\"number\" \nng-model=\"vm.produit.PourcentageVentePrixHTAutreProduit\" name=\"PourcentageVentePrixHTAutreProduit\" \nng-required=\"vm.produit.ModePrixVente==\'pourcent\'\" min=\"0\"><md-icon md-font-icon=\"icon icon-percent\"></md-icon><div \nng-messages=\"produitForm5.PourcentageVentePrixHTAutreProduit.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div><div ng-message=\"min\">Le montant doit être supérieur à 0</div></div></md-input-container>\n<md-input-container flex class=\"md-block mr-16\" ng-show=\"vm.produit.ModePrixVente==\'pourcent\'\"><label>Montant minimum\n</label><input type=\"number\" ng-model=\"vm.produit.PrixVenteHT\" name=\"PrixVenteHT\" \nng-required=\"vm.produit.ModePrixVente==\'pourcent\'\" min=\"0\" ng-change=\"vm.updateTTC()\"><md-icon \nmd-font-icon=\"icon icon-currency-eur\"></md-icon><div ng-messages=\"produitForm5.PrixVenteHT.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"min\">Le montant doit être supérieur à 0 €</div>\n</div></md-input-container><md-input-container flex class=\"md-block\" ng-show=\"vm.produit.ModePrixVente==\'pourcent\'\">\n<label>du produit</label><md-select ng-model=\"vm.produit.PourcentageIDProduit\" \nng-required=\"vm.produit.ModePrixVente==\'pourcent\'\" name=\"PourcentageIDProduit\" \nmd-on-open=\"vm.onCategoriesSelectorOpen()\" md-on-close=\"vm.onCategoriesSelectorClose()\"><md-select-header><input \ntype=\"search\" class=\"md-text\" ng-model=\"vm.produitsSelectFilter\" placeholder=\"Chercher un produit\"></md-select-header>\n<md-option ng-value=\"produit.IDProduit\" ng-repeat=\"produit in vm.produits | filter:vm.produitsSelectFilter\">\n{{produit.Produit}}</md-option></md-select><md-icon md-font-icon=\"icon-file-document\"></md-icon><div \nng-messages=\"produitForm5.PourcentageIDProduit.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div ng-show=\"vm.produit.ModePrixVente==\'fixe\'\"><h2>Prix spécifiques</h2><div layout=\"row\" \nng-repeat=\"PrixSpecifiques in vm.produit.PrixSpecifiques track by $index\"><md-input-container md-no-float flex><label>\nA partir de la quantité</label><input ng-model=\"vm.produit.PrixSpecifiques[$index].Quantite\" type=\"number\" \nname=\"Quantite{{$index}}\" required ng-min=\"vm.produit.PrixSpecifiques[$index-1].Quantite+1 || 2\"><div \nng-messages=\"produitForm5[\'Quantite\'+$index].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"min\">La quantité doit être supérieure ou égale à {{vm.produit.PrixSpecifiques[$index-1].Quantite+1 || 2}}\n</div></div></md-input-container><md-input-container md-no-float flex><label>Prix de vente unitaire HT</label><input \nng-model=\"vm.produit.PrixSpecifiques[$index].PrixVenteUnitaireHT\" type=\"number\" name=\"PrixVenteUnitaireHT{{$index}}\" \nrequired ng-max=\"vm.produit.PrixSpecifiques[$index-1].PrixVenteUnitaireHT || vm.produit.PrixVenteHT\"><div \nng-messages=\"produitForm5[\'PrixVenteUnitaireHT\'+$index].$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div><div ng-message=\"max\">\nLe montant doit être inférieur à {{vm.produit.PrixSpecifiques[$index-1].PrixVenteUnitaireHT || vm.produit.PrixVenteHT}} €\n</div></div></md-input-container><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.produit.PrixSpecifiques.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div layout=\"row\"><md-button ng-click=\"vm.produit.PrixSpecifiques.push({\'Quantite\':\'\',\'PrixVenteUnitaireHT\':\'\'})\">\n+ Ajouter un prix spécifique</md-button></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/commandes/produits/produits.html","<div id=\"produits\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/commandes/produits/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"search-wrapper\" flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"search md-whiteframe-2dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"produits-search\" class=\"search\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"Rechercher\" flex> <button ng-if=\"vm.search\" \nng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');\"><md-icon class=\"material-icons-outlined\">cancel</md-icon>\n</button></div></div></div><div class=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table \nclass=\"dataTable dataTableProduits row-border hover\" datatable dt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" \ndt-options=\"vm.dtOptions\"></table></div></div></div>");
$templateCache.put("app/main/contacts/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/contacts/contacts/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"center scrollable\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"search-wrapper\" flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"search md-whiteframe-2dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"material-icons-outlined icon s24\">person_search</md-icon><input id=\"contacts-search\" class=\"search-input\" flex \nng-model=\"vm.search\" type=\"text\" placeholder=\"Rechercher\"> <button ng-if=\"vm.search\" \nng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');\"><md-icon class=\"material-icons-outlined\">cancel</md-icon>\n</button></div></div></div><div layout=\"row\" flex layout-align=\"space-between \"><div class=\"content-card main\" \nflex=\"100\" layout=\"column\" flex><table class=\"dataTable dataTableContacts row-border hover\" datatable \ndt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"></table></div></div></div></div>");
$templateCache.put("app/main/contacts/corbeille/corbeille.html","<div id=\"corbeille\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"column\" layout-align=\"start start\"><span class=\"logo-icon\"><md-icon \nclass=\"material-icons-outlined s28 white-fg\">delete</md-icon><span \nclass=\"logo-text ml-10 font-size-24 font-weight-700 mr-64 pr-16 white-fg\">Corbeille</span> </span><span \nclass=\"secondary-text white-fg\">{{vm.recordsTotal}} contacts</span></div><div class=\"search-wrapper\" flex layout=\"row\" \nlayout-align=\"start center\"><div class=\"search md-whiteframe-2dp\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"material-icons-outlined icon s24\">person_search</md-icon><input id=\"contacts-search\" \nclass=\"search-input\" flex ng-model=\"vm.search\" type=\"text\" placeholder=\"Rechercher\"> <button ng-if=\"vm.search\" \nng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');\"><md-icon class=\"material-icons-outlined\">cancel</md-icon>\n</button></div></div></div><div layout=\"row\" flex layout-align=\"space-between \"><div \nclass=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><div \nng-repeat=\"contact in vm.contacts | filter: vm.search as filteredContacts track by contact.IDContact | filterStatus:vm.filterStatus | filterByTags:vm.tags | orderBy: vm.listOrder :vm.listOrderAsc\" \nclass=\"md-white-bg border-bottom contact-list\"><div layout=\"column\" layout-fill><div layout=\"row\" class=\"pl-16 pr-16\" \nlayout-align=\"start center\"><p class=\"text-truncate font-weight-600\" flex>{{contact.RaisonSocial | uppercase}}</p><p \nclass=\"phone text-truncate hide-xs\" flex>{{contact.Telephone|phoneNumber}}</p><p \nclass=\"job-title text-truncate hide-xs\" flex-gt-sm=\"25\"><span ng-bind-html=\"contact.Activites\"></span></p><p \nclass=\"company text-truncate\" flex-gt-sm=\"10\"><md-chips><md-chip class=\"md-blue-grey-500-bg white-fg\" \nng-show=\"contact.Status == \'Suspect\'\" selected=\"true\"><small>{{contact.Status}}</small></md-chip><md-chip \nclass=\"md-grey-500-bg white-fg\" ng-show=\"contact.Status == \'Fin d\\\'activité\'\" selected=\"true\"><small>{{contact.Status}}\n</small></md-chip><md-chip class=\"md-grey-500-bg white-fg\" ng-show=\"contact.Status == \'Annulé\'\" selected=\"true\"><small>\n{{contact.Status}}</small></md-chip><md-chip class=\"md-red-500-bg white-fg\" \nng-show=\"contact.Status == \'Ancien client\'\" selected=\"true\"><small>{{contact.Status}}</small></md-chip><md-chip \nclass=\"md-green-bg white-fg\" ng-show=\"contact.Status == \'Client\'\" class=\"mat-teal-bg\" selected=\"true\"><small>\n{{contact.Status}} </small></md-chip><md-chip class=\"md-cyan-700-bg white-fg\" ng-show=\"contact.Status == \'Prospect\'\" \nselected=\"true\"><small>{{contact.Status}}</small></md-chip></md-chips></p><div class=\"actions\" layout=\"row\" \nlayout-align=\"end center\" flex-gt-sm=\"10\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.restaurerContact(contact, $event)\">Restaurer</md-button></md-menu-item><md-divider></md-divider>\n<md-menu-item><md-button ng-click=\"vm.supprimerContact(contact, $event)\">Supprimer définitivement</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/contacts/liste_produits/liste_produits.html","<div id=\"liste_produits\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/contacts/liste_produits/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"search-wrapper\" flex \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"search md-whiteframe-2dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"liste_produits-search\" class=\"search\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"Rechercher\" flex> <button ng-if=\"vm.search\" \nng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');\"><md-icon class=\"material-icons-outlined\">cancel</md-icon>\n</button></div></div></div><div class=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table \nclass=\"dataTable dataTableListeProduits row-border hover\" datatable dt-instance=\"vm.dtInstanceListeProduits\" \ndt-columns=\"vm.dtColumnsListeProduits\" dt-options=\"vm.dtOptionsListeProduits\"></table></div></div></div>");
$templateCache.put("app/main/contacts/nouveau/nouveau.html","<div id=\"nouveau\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"material-icons-outlined mr-16 s28 white-fg\">person_add</md-icon><div layout=\"column\" layout-align=\"start start\">\n<div class=\"h1\">Ajouter un contact</div><div class=\"subtitle secondary-text\"><span>Raison sociale : </span><strong \nng-if=\"!vm.contact.RaisonSocial\">Non définie</strong> <strong ng-if=\"vm.contact.RaisonSocial\">\n{{vm.contact.RaisonSocial}}</strong></div></div></div></div><div class=\"content\" layout-wrap><form \nname=\"horizontalStepper\" ms-horizontal-stepper ng-submit=\"vm.sendForm()\" flex-lg=\"100\" layout-gt-lg=\"80\" flex \nnovalidate><ms-horizontal-stepper-step ng-form=\"horizontalStep1\" step=\"1\" step-title=\"\'Identité\'\"><div \nng-include=\"\'app/main/contacts/nouveau/stepper-steps/horizontal/step-1.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"2\" step-title=\"\'Activités\'\"><div \nng-include=\"\'app/main/contacts/nouveau/stepper-steps/horizontal/step-2.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep3\" step=\"3\" step-title=\"\'Sites web\'\"><div \nng-include=\"\'app/main/contacts/nouveau/stepper-steps/horizontal/step-3.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep4\" step=\"4\" step-title=\"\'Horaires\'\" optional-step><div \nng-include=\"\'app/main/contacts/nouveau/stepper-steps/horizontal/step-4.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep5\" step=\"5\" step-title=\"\'Contact\'\"><div \nng-include=\"\'app/main/contacts/nouveau/stepper-steps/horizontal/step-5.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep6\" step=\"6\" step-title=\"\'Adresses\'\"><div \nng-include=\"\'app/main/contacts/nouveau/stepper-steps/horizontal/step-6.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep7\" step=\"7\" step-title=\"\'Légales\'\"><div \nng-include=\"\'app/main/contacts/nouveau/stepper-steps/horizontal/step-7.html\'\"></div></ms-horizontal-stepper-step><div \nclass=\"createloader\" ng-show=\"vm.createloader\" layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular><div>Création du contact en cours...</div></div></form></div></div>");
$templateCache.put("app/main/contacts/profil/profil-dialog.html","<md-dialog id=\"profil-dialog\"><md-toolbar style=\"border-bottom: 1px solid\"><div \nclass=\"md-toolbar-tools md-background-bg\"><h2 class=\"user-info\" layout=\"column\" layout-align=\"center center\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div class=\"name\" editable-text=\"vm.contact.RaisonSocial\" \nonaftersave=\"vm.updateRaisonSociale()\">{{vm.contact.RaisonSocial}}</div></h2><div class=\"ml-24\" hide-xs><md-button \neditable-select=\"vm.contact.Status\" onaftersave=\"vm.updateStatus()\" \ne-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-blue-grey-500-bg white-fg\" \nng-show=\"vm.contact.Status == \'Suspect\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"grey-500-bg white-fg\" \nng-show=\"vm.contact.Status == \'Fin d\\\'activité\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"grey-500-bg white-fg\" \nng-show=\"vm.contact.Status == \'Annulé\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-warn-bg\" \nng-show=\"vm.contact.Status == \'Ancien client\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-green-bg white-fg\" \nng-show=\"vm.contact.Status == \'Client\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-accent-bg\" \nng-show=\"vm.contact.Status == \'Prospect\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button></div><span flex></span><md-button \nclass=\"md-raised hide-sm hide-xs\" ng-click=\"vm.toggleSidenav(\'commentaires\')\" hide-gt-md hide-xs><md-icon \nclass=\"material-icons-outlined\">chat</md-icon><span>Commentaires <sup class=\"blue-grey-200-bg badge\" \nng-if=\"vm.contact.Notes.length\">{{vm.contact.Notes.length}}</sup></span></md-button><md-button \nclass=\"md-raised hide hide-xs show-sm\" ng-click=\"vm.toggleSidenav(\'commentaires\')\" hide-gt-md hide-xs><md-icon \nclass=\"material-icons-outlined\">chat</md-icon><sup class=\"blue-grey-200-bg badge\" ng-if=\"vm.contact.Notes.length\">\n{{vm.contact.Notes.length}}</sup></md-button><div hide-md hide-sm hide-xs><md-button class=\"md-raised\" \nlayout-align=\"end end\" ng-click=\"vm.ajouterCommande()\"><md-icon class=\"material-icons-outlined\">add_box</md-icon><span>\nAjouter une commande</span></md-button></div><div hide show-md show-sm hide-xs><md-button class=\"md-raised\" \nlayout-align=\"end end\" ng-click=\"vm.ajouterCommande()\"><md-icon class=\"material-icons-outlined\">add_box</md-icon><span>\nCommande</span></md-button></div><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon class=\"grey-900-fg\" \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"padding:0\" layout-wrap>\n<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around center\" ng-show=\"vm.loader\" style=\"min-height: 100%\">\n<md-progress-linear class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-linear></div><div id=\"profil\" \nclass=\"page-layout simple tabbed\" flex ng-hide=\"vm.loader\"><div layout=\"row\"><div class=\"ml-24\" show-xs hide><md-button\n editable-select=\"vm.contact.Status\" onaftersave=\"vm.updateStatus()\" \ne-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-green-bg white-fg\" \nng-show=\"vm.contact.Status == \'Client\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-cyan-700-bg\" \nng-show=\"vm.contact.Status == \'Prospect\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" \nclass=\"md-blue-grey-500-bg white-fg\" ng-show=\"vm.contact.Status == \'Suspect\'\" selected=\"true\"><md-icon \nclass=\"material-icons-outlined\">drive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip \nmd-direction=\"bottom\">Cliquez pour modifier le status du client</md-tooltip></md-button><md-button \neditable-select=\"vm.contact.Status\" onaftersave=\"vm.updateStatus()\" \ne-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"grey-500-bg white-fg\" \nng-show=\"vm.contact.Status == \'Fin d\\\'activité\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-warn-bg\" \nng-show=\"vm.contact.Status == \'Ancien client\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"grey-500-bg white-fg\" \nng-show=\"vm.contact.Status == \'Annulé\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button></div><md-button class=\"md-raised\" \nng-click=\"vm.toggleSidenav(\'commentaires\')\" hide-gt-md show-xs hide><md-icon class=\"material-icons-outlined\">chat\n</md-icon><span>Commentaires</span></md-button></div><div class=\"content grey-100-bg\" layout=\"row\" flex layout-wrap \nstyle=\"min-height: calc(100vh - 63px)\"><md-tabs md-dynamic-height flex md-selected=\"vm.selectedIndex\"><md-tab>\n<md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">account_box</md-icon>A propos</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">shopping_cart</md-icon>Commandes</span>\n</md-tab-label><md-tab-body><md-content class=\"commandes-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/commandes/commandes.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">inventory</md-icon>Produits <small \nng-if=\"vm.recordsProduitsEnCours>0\" class=\"md-blue-bg white-fg brad-12 p-5 ml-8\">{{vm.recordsProduitsEnCours}}</small>\n</span></md-tab-label><md-tab-body><md-content class=\"commandes-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/produits/produits.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">announcement</md-icon>Notifications <small \nng-if=\"vm.recordsLogsNonTraiteTotal>0\" class=\"md-amber-bg white-fg brad-12 p-5 ml-8\">{{vm.recordsLogsNonTraiteTotal}}\n</small></span></md-tab-label><md-tab-body><md-content class=\"log-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/alertes/alertes.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">timeline</md-icon>Historique</span>\n</md-tab-label><md-tab-body><md-content class=\"log-tab\" ng-include=\"\'app/main/contacts/profil/tabs/logs/logs.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">\nemail</md-icon>Courriers</span></md-tab-label><md-tab-body><md-content class=\"courriers-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/courriers/courriers.html\'\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"Permission === \'Super Admin\' || (droits || []).indexOf(\'gestion.contacts.documents\') !== -1\"><md-tab-label>\n<span><md-icon class=\"material-icons-outlined font-size-20\">description</md-icon>Documents</span></md-tab-label>\n<md-tab-body><md-content class=\"documents-tab\" ng-include=\"\'app/main/contacts/profil/tabs/documents/documents.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">\nquestion_answer</md-icon>Echanges</span></md-tab-label><md-tab-body><md-content class=\"echanges-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/echanges/echanges.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n<md-sidenav class=\"md-sidenav-right bl\" md-component-id=\"commentaires\" md-is-locked-open=\"$mdMedia(\'gt-md\')\"><div \nclass=\"add-post bb p-8 pl-16 pr-16\"><md-input-container class=\"md-block\"><label>Ajouter une commentaire</label>\n<textarea ng-model=\"vm.text_add_post\"></textarea></md-input-container><footer layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.add_post()\" class=\"post-button md-raised\" aria-label=\"Ajouter\">Ajouter</md-button></footer>\n</div><div class=\"invoice-notes scrollable p-16 md-background-bg mt-5\" ms-scroll><h3 \nng-hide=\"vm.contact.Notes.length>0\"><strong>Aucun commentaire pour ce contact.</strong></h3><h3 \nng-show=\"vm.contact.Notes.length>0\"><strong>{{vm.contact.Notes.length}} commentaire(s) pour ce contact :</strong></h3>\n<div ng-repeat=\"note in vm.contact.Notes\"><div ng-show=\"note.Edit == 1\" \nng-if=\"!note.Commandes && note.IDEmploye == vm.idUser\" class=\"pt-8 pb-8 mb-16 add-post\" \nstyle=\"border-top:2px solid #f44336; border-bottom:2px solid #f44336\"><md-input-container class=\"md-block\"><label>\nModifier votre commentaire</label><textarea ng-model=\"note.Note\" md-detect-hidden=\"true\"></textarea>\n</md-input-container><footer layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"note.Edit = 0; note.Note = note.Temp\" class=\"post-button\" aria-label=\"Annuler\">Annuler</md-button><md-button \nng-click=\"vm.edit_post(note)\" class=\"post-button md-raised md-accent\" aria-label=\"Modifier\">Modifier</md-button>\n</footer></div><div class=\"p-8 pl-16 pr-16 mb-16 brad-16\" ng-hide=\"note.Edit == 1\" \nng-class=\"(note.Commandes) ? \'blue-grey-50-bg\' : \'blue-50-bg\'\"><blockquote><p class=\"mt-0\" \nstyle=\"white-space: pre-line;word-wrap: break-word\"><strong ng-if=\"note.Commandes\">\nNote sur commande {{note.Commandes.NumeroCommande}} <span ng-if=\"note.Commandes.NumeroFacture\"><br>\nFacture {{note.Commandes.NumeroFacture}}</span><br><br></strong>{{note.Note}}</p><footer layout=\"row\" \nlayout-align=\"start start\"><md-truncate flex>{{note.Utilisateur}}<br><small>{{note.DateCreation}}</small><br \nng-if=\"note.DateModification\"><small ng-if=\"note.DateModification\">{{note.DateModification}}</small></md-truncate>\n<md-button class=\"edit-post p-0 m-0 md-primary font-size-12\" aria-label=\"Modifier\" \nng-if=\"!note.Commandes  && note.IDEmploye == vm.idUser\" ng-click=\"note.Edit = 1; note.Temp = note.Note\"><md-icon \nclass=\"material-icons-outlined font-size-12\">edit</md-icon>Modifier</md-button></footer></blockquote></div></div></div>\n</md-sidenav></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/contacts/profil/profil.html","<div id=\"profil\" class=\"page-layout simple tabbed scrollable\" layout-fill ms-scroll><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\"><div layout=\"column\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"space-between end\" layout-align=\"space-between end\" flex layout-fill><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start start\" layout-align-gt-xs=\"space-between center\" layout-align-gt-md=\"start end\" \nlayout-fill><div layout=\"row\"><md-button ng-click=\"vm.go(\'/contacts\')\"><md-icon md-font-icon=\"icon-keyboard-backspace\" \nclass=\"icon\"></md-icon></md-button><div class=\"user-info\" layout=\"column\" layout-align=\"center center\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div class=\"name\" editable-text=\"vm.contact.RaisonSocial\" \nonaftersave=\"vm.updateRaisonSociale()\">{{vm.contact.RaisonSocial}}</div></div></div><div class=\"ml-24\" hide-xs>\n<md-button editable-select=\"vm.contact.Status\" onaftersave=\"vm.updateStatus()\" \ne-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-green-bg white-fg\" \nng-show=\"vm.contact.Status == \'Client\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-cyan-700-bg\" \nng-show=\"vm.contact.Status == \'Prospect\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" \nclass=\"md-blue-grey-500-bg white-fg\" ng-show=\"vm.contact.Status == \'Suspect\'\" selected=\"true\"><md-icon \nclass=\"material-icons-outlined\">drive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip \nmd-direction=\"bottom\">Cliquez pour modifier le status du client</md-tooltip></md-button><md-button \neditable-select=\"vm.contact.Status\" onaftersave=\"vm.updateStatus()\" \ne-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"grey-500-bg white-fg\" \nng-show=\"vm.contact.Status == \'Fin d\\\'activité\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-warn-bg\" \nng-show=\"vm.contact.Status == \'Ancien client\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"grey-500-bg white-fg\" \nng-show=\"vm.contact.Status == \'Annulé\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button></div></div><div layout=\"row\"><div class=\"ml-24\" \nshow-xs hide><md-button editable-select=\"vm.contact.Status\" onaftersave=\"vm.updateStatus()\" \ne-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-green-bg white-fg\" \nng-show=\"vm.contact.Status == \'Client\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-cyan-700-bg\" \nng-show=\"vm.contact.Status == \'Prospect\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" \nclass=\"md-blue-grey-500-bg white-fg\" ng-show=\"vm.contact.Status == \'Suspect\'\" selected=\"true\"><md-icon \nclass=\"material-icons-outlined\">drive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip \nmd-direction=\"bottom\">Cliquez pour modifier le status du client</md-tooltip></md-button><md-button \neditable-select=\"vm.contact.Status\" onaftersave=\"vm.updateStatus()\" \ne-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"grey-500-bg white-fg\" \nng-show=\"vm.contact.Status == \'Fin d\\\'activité\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-warn-bg\" \nng-show=\"vm.contact.Status == \'Ancien client\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button><md-button editable-select=\"vm.contact.Status\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"grey-500-bg white-fg\" \nng-show=\"vm.contact.Status == \'Annulé\'\" selected=\"true\"><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon>{{vm.contact.Status}}<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status du client</md-tooltip></md-button></div><md-button class=\"md-raised\" \nng-click=\"vm.toggleSidenav(\'commentaires\')\" hide-gt-md><md-icon class=\"material-icons-outlined\">chat</md-icon><span>\nCommentaires</span></md-button><md-button class=\"md-raised\" layout-align=\"end end\" ng-click=\"vm.ajouterCommande()\" \nhide-xs><md-icon class=\"material-icons-outlined\">add_box</md-icon><span>Ajouter une commande</span></md-button></div>\n</div></div><div class=\"content\" layout=\"row\" layout-wrap ms-scroll style=\"min-height: calc(100vh - 63px)\"><md-tabs \nmd-dynamic-height flex md-selected=\"vm.selectedIndex\"><md-tab><md-tab-label><span><md-icon \nclass=\"material-icons-outlined font-size-20\">account_box</md-icon>A propos</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" ng-include=\"\'app/main/contacts/profil/tabs/about/about.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">shopping_cart</md-icon>\nCommandes</span></md-tab-label><md-tab-body><md-content class=\"commandes-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/commandes/commandes.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">inventory</md-icon>Produits <small \nng-if=\"vm.recordsProduitsEnCours>0\" class=\"md-blue-bg white-fg brad-12 p-5 ml-8\">{{vm.recordsProduitsEnCours}}</small>\n</span></md-tab-label><md-tab-body><md-content class=\"commandes-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/produits/produits.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">announcement</md-icon>Notifications <small \nng-if=\"vm.recordsLogsNonTraiteTotal>0\" class=\"md-amber-bg white-fg brad-12 p-5 ml-8\">{{vm.recordsLogsNonTraiteTotal}}\n</small></span></md-tab-label><md-tab-body><md-content class=\"log-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/alertes/alertes.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">timeline</md-icon>Historique</span>\n</md-tab-label><md-tab-body><md-content class=\"log-tab\" ng-include=\"\'app/main/contacts/profil/tabs/logs/logs.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">\nemail</md-icon>Courriers</span></md-tab-label><md-tab-body><md-content class=\"courriers-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/courriers/courriers.html\'\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"Permission === \'Super Admin\' || (droits || []).indexOf(\'gestion.contacts.documents\') !== -1\"><md-tab-label>\n<span><md-icon class=\"material-icons-outlined font-size-20\">description</md-icon>Documents</span></md-tab-label>\n<md-tab-body><md-content class=\"documents-tab\" ng-include=\"\'app/main/contacts/profil/tabs/documents/documents.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">\nquestion_answer</md-icon>Echanges</span></md-tab-label><md-tab-body><md-content class=\"echanges-tab\" \nng-include=\"\'app/main/contacts/profil/tabs/echanges/echanges.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n<md-sidenav class=\"md-sidenav-right bl\" md-component-id=\"commentaires\" md-is-locked-open=\"$mdMedia(\'gt-md\')\"><div \nclass=\"add-post bb p-8 pl-16 pr-16\"><md-input-container class=\"md-block\"><label>Ajouter une commentaire</label>\n<textarea ng-model=\"vm.text_add_post\"></textarea></md-input-container><footer layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.add_post()\" class=\"post-button md-raised\" aria-label=\"Ajouter\">Ajouter</md-button></footer>\n</div><div class=\"invoice-notes scrollable p-16 md-background-bg mt-5\" ms-scroll><h3 \nng-hide=\"vm.contact.Notes.length>0\"><strong>Aucun commentaire pour ce contact.</strong></h3><h3 \nng-show=\"vm.contact.Notes.length>0\"><strong>{{vm.contact.Notes.length}} commentaire(s) pour ce contact :</strong></h3>\n<div ng-repeat=\"note in vm.contact.Notes\"><div ng-show=\"note.Edit == 1\" \nng-if=\"!note.Commandes && note.IDEmploye == id\" class=\"pt-8 pb-8 mb-16 add-post\" \nstyle=\"border-top:2px solid #f44336; border-bottom:2px solid #f44336\"><md-input-container class=\"md-block\"><label>\nModifier votre commentaire</label><textarea ng-model=\"note.Note\" md-detect-hidden=\"true\"></textarea>\n</md-input-container><footer layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"note.Edit = 0; note.Note = note.Temp\" class=\"post-button\" aria-label=\"Annuler\">Annuler</md-button><md-button \nng-click=\"vm.edit_post(note)\" class=\"post-button md-raised md-accent\" aria-label=\"Modifier\">Modifier</md-button>\n</footer></div><div class=\"p-8 pl-16 pr-16 mb-16 brad-16\" ng-hide=\"note.Edit == 1\" \nng-class=\"(note.Commandes) ? \'blue-grey-50-bg\' : \'blue-50-bg\'\"><blockquote><p class=\"mt-0\" \nstyle=\"white-space: pre-line;word-wrap: break-word\"><strong ng-if=\"note.Commandes\">\nNote sur commande {{note.Commandes.NumeroCommande}} <span ng-if=\"note.Commandes.NumeroFacture\"><br>\nFacture {{note.Commandes.NumeroFacture}}</span><br><br></strong>{{note.Note}}</p><footer layout=\"row\" \nlayout-align=\"start start\"><md-truncate flex>{{note.Utilisateur}}<br><small>{{note.DateCreation}}</small><br \nng-if=\"note.DateModification\"><small ng-if=\"note.DateModification\">{{note.DateModification}}</small></md-truncate>\n<md-button class=\"edit-post p-0 m-0 md-primary font-size-12\" aria-label=\"Modifier\" \nng-if=\"!note.Commandes  && note.IDEmploye == id\" ng-click=\"note.Edit = 1; note.Temp = note.Note\"><md-icon \nclass=\"material-icons-outlined font-size-12\">edit</md-icon>Modifier</md-button></footer></blockquote></div></div></div>\n</md-sidenav></div></div>");
$templateCache.put("app/main/courriers/courrier/courrier.html","<div id=\"courrier\" class=\"compact page-layout blank simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout-gt-md=\"row\" layout-align-gt-md=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" \nflex><md-button hide-sm hide-xs class=\"md-fab goto-produits-button\" aria-label=\"Aller aux courriers\" \nng-click=\"vm.gotoCourriers()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" \nng-show=\"vm.courrier.IDCourrier\">Courrier : <span ng-bind-html=\"vm.courrier.Objet\"></span></div><div class=\"h2\" \nhide-sm hide-xs ng-hide=\"vm.courrier.IDCourrier\"><span>Création d\'un courrier</span></div><div hide-sm hide-xs \nclass=\"subtitle secondary-text\" ng-show=\"vm.courrier.IDCourrier\"><span>Modification</span></div></div></div></div><div \nlayout=\"row\" hide-sm hide-xs layout-align=\"center center\" layout-align-gt-md=\"start center\"><div class=\"ml-24\" \nng-hide=\"!vm.courrier.IDCourrier\" style=\"max-width:200px\"><md-button editable-select=\"vm.courrier.Envoye\" \nng-disabled=\"vm.courrier.destinataires.Total<=0\" onaftersave=\"vm.statutCourrier($event)\" \ne-ng-options=\"s.value as s.text for s in vm.Etat\" class=\"md-grey-500-bg white-fg\" \nng-show=\"vm.courrier.Envoye == \'0\' && !vm.deplacer\" selected=\"true\"><md-icon md-font-icon=\"icon icon-pencil-box\">\n</md-icon>En attente<md-tooltip md-direction=\"bottom\">Cliquez pour modifier le statut de la courrier</md-tooltip>\n</md-button><md-button editable-select=\"vm.courrier.Envoye\" ng-disabled=\"vm.courrier.destinataires.Total<=0\" \nonaftersave=\"vm.statutCourrier($event)\" e-ng-options=\"s.value as s.text for s in vm.Etat\" \nclass=\"md-green-500-bg white-fg\" ng-show=\"vm.courrier.Envoye == \'1\' && !vm.deplacer\" selected=\"true\"><md-icon \nmd-font-icon=\"icon icon-pencil-box\"></md-icon>Envoyé<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le statut de la courrier</md-tooltip></md-button></div><md-button \nclass=\"send-button md-raised md-primary\" ng-click=\"vm.apercuCourrier($event)\" ng-show=\"vm.courrier.IDCourrier\" \nng-disabled=\"vm.courrier.destinataires.Total<=0\"><md-icon ng-show=\"!vm.showSpinner\" md-font-icon=\"icon icon-file-pdf\">\n</md-icon><span ng-show=\"!vm.showSpinner\">Aperçu</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button><md-button class=\"send-button md-raised md-primary\" \nng-click=\"vm.generateCourrier($event)\" ng-show=\"vm.courrier.IDCourrier\" \nng-disabled=\"vm.courrier.destinataires.Total<=0\"><md-icon ng-show=\"!vm.showSpinner\" md-font-icon=\"icon icon-file-pdf\">\n</md-icon><span ng-show=\"!vm.showSpinner\">Générer le courrier</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular></md-button></div></div><div \nclass=\"courrier-container\" ms-scroll><div hide-gt-sm class=\"md-red-500-bg md-whiteframe-2dp p-16\"><h3 class=\"m-t-0\">\nImpossible d\'écrire ou de modifier un courrier sur tablette ou smartphone.</h3><md-button \nclass=\"goto-produits-button md-raised ml-0\" aria-label=\"Aller aux courriers\" ng-click=\"vm.gotoCourriers()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon>Retour</md-button></div><div class=\"card md-whiteframe-8dp\" hide show-gt-sm>\n<div class=\"header\"><div ng-hide=\"vm.editHeader\" id=\"header\"><div ng-bind-html=\"trustAsHtml(vm.courrier.Header)\"></div>\n<md-button ng-click=\"vm.editCourrier($event,vm.courrier.Header, \'Header\', \'Modifier l\\\'en-tête du courrier\')\" \nclass=\"md-raised btn-edit\">Editer</md-button></div></div><div class=\"content\"><div layout=\"row\" layout-wrap><div \nflex=\"50\"></div><div flex=\"50\"><div id=\"adresse\"><div layout=\"row\" layout-wrap layout-align=\"start center\"><p \nclass=\"mt-0 mb-0 ml-16\"><md-checkbox ng-model=\"vm.courrier.AttentionDe\" ng-change=\"vm.saveCourrier($event)\" \nclass=\"mb-0\">A l\'attention de Prénom Nom</md-checkbox></p><md-button id=\"selectDestinataire\" \nng-click=\"vm.addDestinataire($event)\"><strong>{{vm.courrier.destinataires.Total}} Destinataire(s)</strong><br><div \nng-hide=\"vm.courrier.destinataires.Type==\'Saisir\' || vm.courrier.destinataires.Type==\'Aucune\'\">Entreprise<br>Adresse\n<br>Code postal - Ville<br></div><div ng-show=\"vm.courrier.destinataires.Type==\'Saisir\'\"><span \nstyle=\"white-space: pre-line\">{{vm.courrier.destinataires.Adresse}}</span></div></md-button></div></div></div></div>\n<div layout=\"row\" layout-wrap layout-align=\"end\"><div flex=\"50\"></div><div flex=\"50\"><p class=\"mt-0 mb-8\"><a href=\"#\" \neditable-text=\"vm.courrier.Ville\" e-required onaftersave=\"vm.saveCourrier($event)\">\nA {{vm.courrier.Ville || \'Aucune localité\' }}</a>, <a href=\"#\" editable-date=\"vm.courrier.Date\" e-required \nonaftersave=\"vm.saveCourrier($event)\">le {{vm.courrier.Date || \'(saisir une date)\' |date:\'EEEE dd LLLL yyyy\' }}</a></p>\n</div></div><div layout=\"column\" layout-wrap><div flex=\"100\"><br><p class=\"mt-0 mb-8\"><strong><u>Objet</u> : </strong>\n<a href=\"#\" editable-text=\"vm.courrier.Objet\" e-required onbeforesave=\"vm.saveCourrier($event)\"><span \nng-bind-html=\"vm.courrier.Objet\" ng-show=\"vm.courrier.Objet\"></span><span ng-hide=\"vm.courrier.Objet\">aucun</span></a>\n</p><p class=\"mt-0 mb-8\"><strong><u>Référence(s)</u> : </strong><a href=\"#\" editable-text=\"vm.courrier.Pj\" \nonbeforesave=\"vm.saveCourrier($event)\">{{ vm.courrier.Pj || \'aucune\' }}</a></p><p class=\"mt-0 mb-8\"><md-checkbox \nng-model=\"vm.courrier.LRAR\">Lettre recommandée avec accusé de réception</md-checkbox></p></div></div><div \nng-hide=\"vm.editContenu\" class=\"contenu\"><div ng-bind-html=\"trustAsHtml(vm.courrier.Contenu)\"></div><md-button \nng-click=\"vm.editCourrier($event,vm.courrier.Contenu, \'Contenu\', \'Modifier le corps du courrier\')\" \nclass=\"md-raised btn-edit\">Editer</md-button></div></div><div class=\"footer\"><div id=\"footer\" ng-hide=\"vm.editFooter\">\n<div ng-bind-html=\"trustAsHtml(vm.courrier.Footer)\"></div><md-button \nng-click=\"vm.editCourrier($event,vm.courrier.Footer, \'Footer\', \'Modifier le pied de page du courrier\')\" \nclass=\"md-raised btn-edit\">Editer</md-button></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/courriers/courriers/courriers.html","<div id=\"courriers\" class=\"page-layout simple inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-xs=\"column\" layout-align-xs=\"start start\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start\"><div class=\"h1\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-email\" \nclass=\"ml-0 mr-8\"></md-icon><span>Courriers</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Rechercher\" flex ng-model=\"vm.search\"></div><div hide \nshow-gt-md><md-button class=\"md-raised md-primary\" ng-click=\"vm.go(\'/courriers/edition/0\')\"><md-icon \nmd-font-icon=\"icon icon-plus-box\"></md-icon><span>Ajouter un courrier</span></md-button></div></div><div \nclass=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-button id=\"btn-smartphone\" hide-gt-md \nclass=\"md-fab\" ng-click=\"vm.go(\'/courriers/edition/0\')\"><md-icon md-font-icon=\"icon icon-plus\"></md-icon></md-button>\n<div class=\"main scrollable\" ms-scroll><div class=\"courriers-list border brad-16\"><md-subheader \nclass=\"md-no-sticky md-white-bg\"><div layout=\"row\" layout-align=\"space-between center\"><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"Tri\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort-alphabetical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.listOrder = \'Objet\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'Objet\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span>Objet </span><small>\n(De A à Z)</small></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.listOrder = \'Objet\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'Objet\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span>Objet </span><small>\n(De Z à A)</small></md-button></md-menu-item></md-menu-content></md-menu></div></md-subheader><div \nng-repeat=\"courrier in vm.courriers | filter: vm.search   | orderBy: vm.listOrder :vm.listOrderAsc\" \nclass=\"md-white-bg border-bottom contact-list\"><div layout=\"column\" layout-fill><div layout=\"row\" class=\"pl-16 pr-16\" \nlayout-align=\"start center\"><div flex-xs=\"95\" flex-gt-xs=\"60\" layout=\"column\" class=\"pt-16 pb-16\" \nlayout-align=\"start start\"><span class=\"font-weight-600\" ng-bind-html=\"courrier.Objet\"></span><div><span \nng-show=\"courrier.LRAR\" class=\"orange-500-fg\">Lettre recommandée avec accusé de réception</span> <span \nng-hide=\"courrier.LRAR\" class=\"blue-500-fg\">Envoi normal</span><br><small>\nDernière modification le {{courrier.DateModification | DateFormat}}</small><br><md-chips hide show-xs show-sm><md-chip \nclass=\"grey-500-bg white-fg\" ng-show=\"courrier.Envoye == \'0\'\" selected=\"true\"><small>En attente</small></md-chip>\n<md-chip class=\"md-green-bg white-fg\" ng-show=\"courrier.Envoye == \'1\'\" class=\"mat-teal-bg\" selected=\"true\"><small>\nEnvoyé le {{courrier.DateEnvoie | date:\'dd/MM/yyyy\'}}</small></md-chip></md-chips><md-button hide show-xs \nng-click=\"vm.apercuDestinataires($event,courrier)\">{{courrier.NbrDestinataires}} destinataires</md-button></div></div>\n<p class=\"mt-0 mt-16\" hide-xs flex-gt-xs=\"30\"><md-button ng-click=\"vm.apercuDestinataires($event,courrier)\">\n{{courrier.NbrDestinataires}} destinataires</md-button></p><p class=\"\" hide-xs hide-sm flex-gt-xs=\"25\"><md-chips>\n<md-chip class=\"grey-500-bg white-fg\" ng-show=\"courrier.Envoye == \'0\'\" selected=\"true\"><small>En attente</small>\n</md-chip><md-chip class=\"md-green-bg white-fg\" ng-show=\"courrier.Envoye == \'1\'\" class=\"mat-teal-bg\" selected=\"true\">\n<small>Envoyé le {{courrier.DateEnvoie | date:\'dd/MM/yyyy\'}}</small></md-chip></md-chips></p><div class=\"actions\" \nlayout=\"row\" layout-align=\"end center\" flex-gt-xs=\"5\"><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.apercuCourrier($event,courrier)\">Aperçu</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.go(\'/courriers/edition/\'+courrier.IDCourrier)\" ng-disabled=\"courrier.Envoye\">\nModifier</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.generateCourrier(courrier)\" \nng-disabled=\"courrier.NbrDestinataires==0\">Générer le courrier</md-button></md-menu-item><md-divider></md-divider>\n<md-menu-item><md-button ng-click=\"vm.dupliquerCourrier(courrier)\">Dupliquer</md-button></md-menu-item><md-divider>\n</md-divider><md-menu-item><md-button ng-click=\"vm.supprimercourriers($event, courrier)\" ng-disabled=\"courrier.Envoye\">\nSupprimer</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>Aucun résultat...</p></md-list-item></div>\n</div></div></div>");
$templateCache.put("app/main/parametres/regles_bancaires/regles-bancaires.html","<div id=\"regles-bancaires\" class=\"page-layout simple inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Configuration</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Règles bancaires</span></div>\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"material-icons-outlined ml-0 mr-8\">rule\n</md-icon><span>Catégorisation bancaire</span></div></div><md-button class=\"md-raised\" ng-if=\"vm.droits(\'edition\')\" \nng-click=\"vm.editer($event)\"><md-icon class=\"material-icons-outlined\">add_box</md-icon><span>Ajouter une règle</span>\n</md-button></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><div class=\"main\"><div \nclass=\"rules-help md-white-bg border brad-16 mb-16\">\nLes règles actives sont testées par priorité décroissante. La première correspondance propose une catégorie et un statut ; une validation humaine reste requise pour les opérations sensibles.\n</div><div class=\"rule-list card border brad-16\"><md-list class=\"p-0\"><md-list-item ng-repeat=\"regle in vm.regles\" \nclass=\"pt-16 pb-16 md-3-line md-white-bg border-bottom contact-list\"><md-icon class=\"material-icons-outlined mr-16\" \nng-class=\"{\'grey-500-fg\': !regle.Actif}\">{{regle.Actif ? \'rule\' : \'rule_folder\'}}</md-icon><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{regle.Libelle}} <span class=\"rule-priority\">Priorité {{regle.Priorite}}\n</span></h3><h4>{{regle.Champ}} {{regle.Correspondance.toLowerCase()}} « {{regle.Motif}} »</h4><p>\n{{regle.Categorie}} · {{regle.StatutPropose}} <span ng-if=\"!regle.Actif\">· Désactivée</span></p></div><md-menu \nclass=\"md-secondary\" ng-if=\"vm.droits(\'edition\') || vm.droits(\'suppression\')\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Actions\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item ng-if=\"vm.droits(\'edition\')\"><md-button ng-click=\"vm.editer($event, regle)\">\nModifier</md-button></md-menu-item><md-divider ng-if=\"vm.droits(\'edition\') && vm.droits(\'suppression\')\"></md-divider>\n<md-menu-item ng-if=\"vm.droits(\'suppression\')\"><md-button ng-click=\"vm.supprimer($event, regle)\">Supprimer</md-button>\n</md-menu-item></md-menu-content></md-menu></md-list-item><md-list-item class=\"no-results md-white-bg\" \nng-show=\"vm.regles.length === 0\"><p>Aucune règle configurée.</p></md-list-item></md-list></div></div></div></div>");
$templateCache.put("app/main/sites/details/details.html","<div id=\"detailsSite\" class=\"compact page-layout blank simple\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-produits-button md-icon-button\" \naria-label=\"Retour aux produits\" ng-click=\"vm.returnSitesWeb()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\">Site internet :<md-button ng-href=\"{{vm.detailsSite.URL}}\" target=\"_blank\" class=\"md-raised\"><md-icon \nclass=\"material-icons-outlined mr-0\">link</md-icon>\n{{vm.detailsSite.URL.replace(\'http://\', \'\').replace(\'https://\', \'\').replace(\'www.\', \'\')}}</md-button></div><div \nclass=\"subtitle secondary-text\"><span>Statistiques</span></div></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"ml-8\"><md-button ng-click=\"vm.openContactDialog(vm.detailsSite.IDContact)\" \nclass=\"md-raised\"><md-icon class=\"material-icons-outlined\">person</md-icon>Fiche client</md-button><md-menu \nmd-offset=\"0 48\"><md-button class=\"ph-16 md-raised\" ng-click=\"$mdMenu.open()\" md-menu-origin md-menu-align-target>\n<md-icon class=\"material-icons-outlined\">calendar_month</md-icon>{{vm.annee}}<md-icon md-font-icon=\"icon-chevron-down\" \nstyle=\"margin-top: -5px\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item \nng-repeat=\"range in vm.listeAnnees\"><md-button ng-click=\"vm.changeAnne(range)\" aria-label=\"{{range}}\"><span \nng-class=\"{\'secondary-text\': vm.annee == range}\">{{range}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu><div ng-if=\"vm.annee == \'Personnalisé\'\" layout=\"row\"><div class=\"range_perso mr-8\" layout=\"row\"><md-menu \nmd-offset=\"0 48\"><md-button class=\"ph-16 md-raised\" ng-click=\"$mdMenu.open()\" md-menu-origin md-menu-align-target>\n<md-icon class=\"material-icons-outlined\">calendar_month</md-icon>{{vm.month_start}}<md-icon \nmd-font-icon=\"icon-chevron-down\" style=\"margin-top: -5px\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"range in vm.monthNames\"><md-button \nng-click=\"vm.chanegPeriode(range); vm.month_start = range;\" aria-label=\"{{range}}\"><span \nng-class=\"{\'secondary-text\': vm.month_start == range}\">{{range}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-menu md-offset=\"0 48\"><md-button class=\"ph-16 md-raised\" ng-click=\"$mdMenu.open()\" md-menu-origin \nmd-menu-align-target>{{vm.year_start}}<md-icon md-font-icon=\"icon-chevron-down\" style=\"margin-top: -5px\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"range in vm.listeAnnees\">\n<md-button ng-click=\"vm.chanegPeriode(range); vm.year_start = range;\" aria-label=\"{{range}}\"><span \nng-class=\"{\'secondary-text\': vm.year_start == range}\">{{range}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div><div class=\"range_perso\" layout=\"row\"><md-menu md-offset=\"0 48\"><md-button class=\"ph-16 md-raised\" \nng-click=\"$mdMenu.open()\" md-menu-origin md-menu-align-target><md-icon class=\"material-icons-outlined\">calendar_month\n</md-icon>{{vm.month_end}}<md-icon md-font-icon=\"icon-chevron-down\" style=\"margin-top: -5px\"></md-icon></md-button>\n<md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"range in vm.monthNames\"><md-button \nng-click=\"vm.chanegPeriode(range); vm.month_end = range;\" aria-label=\"{{range}}\"><span \nng-class=\"{\'secondary-text\': vm.month_end == range}\">{{range}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-menu md-offset=\"0 48\"><md-button class=\"ph-16 md-raised\" ng-click=\"$mdMenu.open()\" md-menu-origin \nmd-menu-align-target>{{vm.year_end}}<md-icon md-font-icon=\"icon-chevron-down\" style=\"margin-top: -5px\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"range in vm.listeAnnees\">\n<md-button ng-click=\"vm.chanegPeriode(range); vm.year_end = range;\" aria-label=\"{{range}}\"><span \nng-class=\"{\'secondary-text\': vm.year_end == range}\">{{range}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div><div layout=\"row\" layout-align=\"space-between stretch\"><div \nclass=\"content md-block flex\"><div class=\"pt-24 pl-16 font-size-18 font-weight-300\">\nCombien avez-vous eu de contacts en {{vm.annee}} ?</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-lg=\"25\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"pb-8\" layout=\"row\" \nlayout-xs=\"column\" layout-align-xs=\"start start\" layout-align=\"start end\"><div class=\"pr-16\"><div class=\"h3\">Téléphones\n</div><div class=\"font-size-54 font-weight-600 line-height-1 mt-8\">\n{{vm.detailsSite.Contacts[vm.annee].Telephones.total}}</div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"py-4 font-size-16\" ng-if=\"vm.detailsSite.Contacts[vm.annee].Telephones.pourcentage\"><div \nng-class=\"(vm.detailsSite.Contacts[vm.annee].Telephones.pourcentage > 0) ? \'green-fg\' :\'red-fg\'\"><md-icon \nmd-font-icon=\"icon-trending-up\" class=\"green-fg\" \nng-if=\" vm.detailsSite.Contacts[vm.annee].Telephones.pourcentage > 0 \"></md-icon><md-icon \nmd-font-icon=\"icon-trending-down\" class=\"red-fg\" \nng-if=\" vm.detailsSite.Contacts[vm.annee].Telephones.pourcentage < 0 \"></md-icon><div layout=\"row\" \nclass=\"font-size-14\"><span>{{ vm.detailsSite.Contacts[vm.annee].Telephones.pourcentage}} %</span><div \nclass=\"ml-8 text-nowrap blue-grey-fg\">par rapport à {{vm.annee-1}}</div></div></div></div></div><div \nclass=\"text-center\" ng-if=\"!vm.Contacts.Telephones.data\">Aucune donnée</div><div><nvd3 class=\"\" hide show-gt-md \nconfig=\"vm.Contacts.config\" options=\"vm.Contacts.options.Telephones\" data=\"vm.Contacts.Telephones.data\"></nvd3></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-lg=\"25\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"p-16 white-bg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"pb-8\" \nlayout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" layout-align=\"start end\"><div class=\"pr-16\"><div \nclass=\"h3\">E-mails</div><div class=\"font-size-54 font-weight-600 line-height-1 mt-8\">\n{{vm.detailsSite.Contacts[vm.annee].Emails.total}}</div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"py-4 font-size-16\" ng-if=\"vm.detailsSite.Contacts[vm.annee].Emails.pourcentage\"><div \nng-class=\"(vm.detailsSite.Contacts[vm.annee].Emails.pourcentage > 0) ? \'green-fg\' :\'red-fg\'\"><md-icon \nmd-font-icon=\"icon-trending-up\" class=\"green-fg\" ng-if=\" vm.detailsSite.Contacts[vm.annee].Emails.pourcentage > 0 \">\n</md-icon><md-icon md-font-icon=\"icon-trending-down\" class=\"red-fg\" \nng-if=\" vm.detailsSite.Contacts[vm.annee].Emails.pourcentage < 0 \"></md-icon><div layout=\"row\" class=\"font-size-14\">\n<span>{{ vm.detailsSite.Contacts[vm.annee].Emails.pourcentage}} %</span><div class=\"ml-8 text-nowrap blue-grey-fg\">\npar rapport à {{vm.annee-1}}</div></div></div></div></div><div class=\"text-center\" ng-if=\"!vm.Contacts.Emails.data\">\nAucune donnée</div><div><nvd3 class=\"\" hide show-gt-md config=\"vm.Contacts.config\" \noptions=\"vm.Contacts.options.Emails\" data=\"vm.Contacts.Emails.data\"></nvd3></div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-lg=\"25\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"pb-8\" layout=\"row\" \nlayout-xs=\"column\" layout-align-xs=\"start start\" layout-align=\"start end\"><div class=\"pr-16\"><div class=\"h3\">\nFormulaires</div><div class=\"font-size-54 font-weight-600 line-height-1 mt-8\">\n{{vm.detailsSite.Contacts[vm.annee].Formulaires.total}}</div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"py-4 font-size-16\" ng-if=\"vm.detailsSite.Contacts[vm.annee].Formulaires.pourcentage\"><div \nng-class=\"(vm.detailsSite.Contacts[vm.annee].Formulaires.pourcentage > 0) ? \'green-fg\' :\'red-fg\'\"><md-icon \nmd-font-icon=\"icon-trending-up\" class=\"green-fg\" \nng-if=\" vm.detailsSite.Contacts[vm.annee].Formulaires.pourcentage > 0 \"></md-icon><md-icon \nmd-font-icon=\"icon-trending-down\" class=\"red-fg\" \nng-if=\" vm.detailsSite.Contacts[vm.annee].Formulaires.pourcentage < 0 \"></md-icon><div layout=\"row\" \nclass=\"font-size-14\"><span>{{ vm.detailsSite.Contacts[vm.annee].Formulaires.pourcentage}} %</span><div \nclass=\"ml-8 text-nowrap blue-grey-fg\">par rapport à {{vm.annee-1}}</div></div></div></div></div><div \nclass=\"text-center\" ng-if=\"!vm.Contacts.Formulaires.data\">Aucune donnée</div><div><nvd3 class=\"\" hide show-gt-md \nconfig=\"vm.Contacts.config\" options=\"vm.Contacts.options.Formulaires\" data=\"vm.Contacts.Formulaires.data\"></nvd3></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-lg=\"25\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"p-16 white-bg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"pb-8\" \nlayout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" layout-align=\"start end\"><div class=\"pr-16\"><div \nclass=\"h3\">Adresses</div><div class=\"font-size-54 font-weight-600 line-height-1 mt-8\">\n{{vm.detailsSite.Contacts[vm.annee].Adresses.total}}</div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"py-4 font-size-16\" ng-if=\"vm.detailsSite.Contacts[vm.annee].Adresses.pourcentage\"><div \nng-class=\"(vm.detailsSite.Contacts[vm.annee].Adresses.pourcentage > 0) ? \'green-fg\' :\'red-fg\'\"><md-icon \nmd-font-icon=\"icon-trending-up\" class=\"green-fg\" ng-if=\" vm.detailsSite.Contacts[vm.annee].Adresses.pourcentage > 0 \">\n</md-icon><md-icon md-font-icon=\"icon-trending-down\" class=\"red-fg\" \nng-if=\" vm.detailsSite.Contacts[vm.annee].Adresses.pourcentage < 0 \"></md-icon><div layout=\"row\" class=\"font-size-14\">\n<span>{{ vm.detailsSite.Contacts[vm.annee].Adresses.pourcentage}} %</span><div class=\"ml-8 text-nowrap blue-grey-fg\">\npar rapport à {{vm.annee-1}}</div></div></div></div></div><div class=\"text-center\" ng-if=\"!vm.Contacts.Adresses.data\">\nAucune donnée</div><div><nvd3 class=\"\" hide show-gt-md config=\"vm.Contacts.config\" \noptions=\"vm.Contacts.options.Adresses\" data=\"vm.Contacts.Adresses.data\"></nvd3></div></ms-widget-front></ms-widget>\n</div><div class=\"pt-24 pl-16 font-size-18 font-weight-300\">Quel est votre visibilité sur les moteurs de recherches ?\n</div><ms-widget layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap=\"\"><div class=\"pv-8 h3\">Votre positionnement sur Google.fr</div><div \nclass=\"h5 secondary-text\">Source <a href=\"https://ranks.fr\" target=\"_blank\">Ranks.fr</a></div></div><h3 \nng-if=\"vm.detailsSite.SEO==\'\'\" class=\"deep-orange-900-fg pl-16 pr-16\">Aucun outil de suivi n\'a été détecté.<br>\nLa mise à jour des positions se fait toutes les 24h.</h3><table class=\"simple\" ms-responsive-table \nng-if=\"vm.detailsSite.SEO!=\'\'\"><thead><tr><th>Requête</th><th>Date vérification</th><th>Destination</th><th>Position\n</th><th>Variation</th></tr></thead><tbody><tr ng-repeat=\"SEO in vm.detailsSite.SEO\"><td>{{SEO.Requete}}</td><td>\n{{SEO.DateCrawlSEO|date}}</td><td><a href=\"{{SEO.Url}}\" target=\"_blank\">{{SEO.Url}}</a></td><td>{{SEO.Position}}</td>\n<td><span ng-if=\"SEO.Position==\'100+\'\">-</span> <span ng-if=\"SEO.Variation==0 && SEO.Position!=\'100+\'\">=</span> <span \nng-if=\"SEO.Variation>0 && SEO.Position!=\'100+\'\">{{SEO.Variation}}</span> <span \nng-if=\"SEO.Variation<0 && SEO.Position!=\'100+\'\">{{SEO.Variation}}</span></td></tr></tbody></table></ms-widget-front>\n</ms-widget></div></div></div>");
$templateCache.put("app/main/sites/sites/sites.html","<div id=\"sites\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"white-fg pr-32\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-web\"></md-icon><span class=\"ml-5\">\nSites internet</span></div><div class=\"log-count secondary-text\"><span>{{vm.recordsTotal}} sites</span></div></div><div\n class=\"search md-whiteframe-2dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input id=\"sites-search\" class=\"search\" type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"Rechercher\" flex> <button ng-if=\"vm.search\" ng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></button></div></div><div layout=\"row\" flex layout-align=\"space-between \">\n<div class=\"content-card\" flex=\"100\" layout=\"column\" flex><div class=\"content-card main scrollable\" flex=\"100\" \nlayout=\"column\" flex><table class=\"dataTable dataTableSites row-border hover\" datatable dt-instance=\"vm.dtInstance\" \ndt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"></table></div></div></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<md-progress-linear id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\"></md-progress-linear>\n<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" \nng-hide=\"$mdMedia(\'min-width: 1400px\')\" aria-label=\"Menu\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"toolbar-separator\"></div><span class=\"pl-16\" \nng-hide=\"$mdMedia(\'xs\') || $mdMedia(\'min-width: 1400px\')\"><img class=\"height-50\" \nsrc=\"/assets/images/logos/logo-ExodreamN2021.svg\"></span></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\"><md-icon ng-show=\"vm.nbrNotifications.total\" md-font-icon=\"material-icons-outlined\" \nclass=\"icon s26\">notifications_active</md-icon><md-icon ng-hide=\"vm.nbrNotifications.total\" \nmd-font-icon=\"material-icons-outlined\" class=\"icon s26\">notifications</md-icon><span id=\"labelnotification\" \nng-show=\"vm.nbrNotifications.total\" \nclass=\"{{vm.nbrNotifications.errors>0 ? \' md-warn-bg\' : vm.nbrNotifications.warnings>0 ? \'orange-800-bg white-fg\' : vm.nbrNotifications.total>0 ? \'blue-500-bg white-fg\' : \'\'}}\">\n{{vm.nbrNotifications.total}}</span></md-button><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\">\n<md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"{{Avatar ? Avatar : \'assets/images/avatars/profile.jpg\'}}\"></div><span class=\"username\" hide show-gt-sm>\n{{Prenom}} {{Nom}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-click=\"vm.profile()\"><md-icon \nmd-font-icon=\"material-icons-outlined\" class=\"icon\">manage_accounts</md-icon><md-button>Mon compte</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"material-icons-outlined\" class=\"icon\">logout</md-icon><md-button ng-click=\"vm.logout()\">Déconnexion\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s24 material-icons-outlined\" ng-if=\"node.icon\">{{node.icon}}</i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s24 material-icons-outlined\" ng-if=\"node.icon\">{{node.icon}}</i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/achats/factures/dialogs/edition.html","<md-dialog class=\"factures-achats-dialog\" flex=\"80\" aria-label=\"Facture fournisseur\"><form name=\"editionForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.enregistrer(editionForm)\" novalidate enctype=\"multipart/form-data\">\n<md-dialog-content ms-scroll><span class=\"md-title\">\n{{vm.lectureSeule ? \'Détail\' : vm.statutSeulement ? \'Validation du document\' : (vm.document.IDFactureAchat ? \'Modifier le document\' : \'Facture fournisseur / avoir\')}}\n</span><p></p><div ng-if=\"vm.lectureSeule\"><table class=\"full-width\"><tr><td class=\"secondary-text pr-16 pb-8\">Numéro\n</td><td class=\"pb-8\">{{vm.document.NumeroFacture || \'—\'}}</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">\nFournisseur</td><td class=\"pb-8\">{{vm.document.Fournisseur || \'—\'}}</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">\nDocument</td><td class=\"pb-8\">{{vm.document.TypeDocument || \'—\'}}</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">\nDate</td><td class=\"pb-8\">{{vm.document.DateFacture | date:\'dd/MM/yyyy\'}}</td></tr><tr><td \nclass=\"secondary-text pr-16 pb-8\">Échéance</td><td class=\"pb-8\">{{vm.document.DateEcheance | date:\'dd/MM/yyyy\'}}</td>\n</tr><tr><td class=\"secondary-text pr-16 pb-8\">HT</td><td class=\"pb-8\">{{vm.document.TotalHT | number:2}} €</td></tr>\n<tr><td class=\"secondary-text pr-16 pb-8\">TVA</td><td class=\"pb-8\">{{vm.document.TotalTVA | number:2}} €</td></tr><tr>\n<td class=\"secondary-text pr-16 pb-8\">TTC</td><td class=\"pb-8\">{{vm.document.TotalTTC | number:2}} €</td></tr><tr \nng-if=\"vm.document.Devise !== \'EUR\'\"><td class=\"secondary-text pr-16 pb-8\">Montant d’origine</td><td class=\"pb-8\">\n{{vm.document.TotalTTCDevise | number:2}} {{vm.document.Devise}}</td></tr><tr ng-if=\"vm.document.Devise !== \'EUR\'\"><td \nclass=\"secondary-text pr-16 pb-8\">Cours comptable</td><td class=\"pb-8\">\n1 EUR = {{vm.document.TauxConversion | number:8}} {{vm.document.Devise}} ({{vm.document.SourceTaux}}, {{vm.document.DateTaux | date:\'dd/MM/yyyy\'}})\n</td></tr><tr ng-if=\"vm.document.Devise !== \'EUR\'\"><td class=\"secondary-text pr-16 pb-8\">Écart de change</td><td \nclass=\"pb-8\">{{vm.document.EcartChange | number:2}} €</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">Solde</td><td \nclass=\"pb-8\">{{vm.document.Solde | number:2}} €</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">Validation</td><td \nclass=\"pb-8\">{{vm.document.EtatValidation || \'—\'}}</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">Règlement</td><td\n class=\"pb-8\">{{vm.document.Statut || \'—\'}}</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">Origine</td><td \nclass=\"pb-8\">{{vm.document.Origine || \'—\'}}</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">SuperPDP</td><td \nclass=\"pb-8\">{{vm.document.StatutPDP || \'—\'}}</td></tr></table></div><div \nng-if=\"!vm.lectureSeule && vm.statutSeulement\"><p>{{vm.document.NumeroFacture}} — {{vm.document.Fournisseur}}</p><div \nlayout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Validation</label><md-select \nng-model=\"vm.document.EtatValidation\" name=\"EtatValidation\" required><md-option \nng-repeat=\"statut in vm.etatsValidation\" ng-value=\"statut\">{{statut}}</md-option></md-select><div \nng-messages=\"editionForm[\'EtatValidation\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"valid\">Date invalide</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Règlement</label><md-select ng-model=\"vm.document.Statut\" name=\"Statut\" \nrequired><md-option ng-repeat=\"statut in vm.etatsReglement\" ng-value=\"statut\">{{statut}}</md-option></md-select><div \nng-messages=\"editionForm[\'Statut\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div></div><div ng-if=\"!vm.lectureSeule && !vm.statutSeulement\"><div layout=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Fournisseur</label><md-select \nng-model=\"vm.document.IDFabricant\" name=\"IDFabricant\" required><md-option ng-repeat=\"fournisseur in vm.fournisseurs\" \nng-value=\"fournisseur.IDFabricant\">{{fournisseur.Fabricant}}</md-option></md-select><div \nng-messages=\"editionForm[\'IDFabricant\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"valid\">Date invalide</div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Type de document</label><md-select \nng-model=\"vm.document.TypeDocument\" name=\"TypeDocument\" required><md-option value=\"Facture\">Facture</md-option>\n<md-option value=\"Avoir\">Avoir</md-option></md-select><div ng-messages=\"editionForm[\'TypeDocument\'].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"valid\">Date invalide</div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>Numéro fournisseur</label><input \nng-model=\"vm.document.NumeroFacture\" name=\"NumeroFacture\" required maxlength=\"100\"><div \nng-messages=\"editionForm[\'NumeroFacture\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"valid\">Date invalide</div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Devise</label><input ng-model=\"vm.document.Devise\" \nname=\"Devise\" required maxlength=\"3\" ng-change=\"vm.document.Devise = (vm.document.Devise || \'\').toUpperCase()\"><div \nclass=\"hint\">Code ISO : EUR, USD, GBP…</div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.document.Devise !== \'EUR\'\"><md-input-container class=\"md-block\" md-no-float flex><label>\nMontant HT ({{vm.document.Devise}})</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.document.TotalHTDevise\" \nname=\"TotalHTDevise\" required></md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>\nTVA ({{vm.document.Devise}})</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.document.TotalTVADevise\" \nname=\"TotalTVADevise\" required></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.document.Devise !== \'EUR\'\"><md-input-container class=\"md-block\" md-no-float flex><label>\nCours : {{vm.document.Devise}} pour 1 EUR</label><input type=\"number\" min=\"0.00000001\" step=\"0.00000001\" \nng-model=\"vm.document.TauxConversion\" name=\"TauxConversion\" ng-change=\"vm.document.SourceTaux = \'Manuel\'\" required><div\n class=\"hint\">Source : {{vm.document.SourceTaux}}</div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float flex><label>Date du cours</label><md-datepicker ng-model=\"vm.dates.DateTaux\" name=\"DateTaux\" \nmd-open-on-focus required></md-datepicker></md-input-container><md-button type=\"button\" class=\"md-accent\" \nng-click=\"vm.actualiserTaux()\" ng-disabled=\"vm.busy\">Cours BCE</md-button></div><p \nng-if=\"vm.document.Devise !== \'EUR\'\">\nTotal d’origine : {{vm.totalOrigine() | number:2}} {{vm.document.Devise}} · Valeur comptable : {{vm.total() | currency:\'€\'}}\n</p><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" md-no-float flex><label>Date</label>\n<md-datepicker ng-model=\"vm.dates.DateFacture\" name=\"DateFacture\" md-open-on-focus required></md-datepicker><div \nng-messages=\"editionForm[\'DateFacture\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"valid\">Date invalide</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float flex>\n<label>Échéance</label><md-datepicker ng-model=\"vm.dates.DateEcheance\" name=\"DateEcheance\" md-open-on-focus>\n</md-datepicker><div ng-messages=\"editionForm[\'DateEcheance\'].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div><div ng-message=\"valid\">Date invalide</div></div></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\" ng-if=\"vm.document.Devise === \'EUR\'\"><md-input-container class=\"md-block\" md-no-float \nflex><label>Montant HT (€)</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.document.TotalHT\" name=\"TotalHT\" \nrequired><div ng-messages=\"editionForm[\'TotalHT\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div\n ng-message=\"valid\">Date invalide</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float \nflex><label>TVA (€)</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.document.TotalTVA\" name=\"TotalTVA\" required>\n<div ng-messages=\"editionForm[\'TotalTVA\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"valid\">Date invalide</div></div></md-input-container></div><p ng-if=\"vm.document.Devise === \'EUR\'\">\nTotal TTC : {{vm.total() | currency:\'€\'}}</p><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex>\n<label>Justificatif</label><input type=\"file\" ngf-select ng-model=\"vm.file\" name=\"file\" accept=\".pdf\"><div \nclass=\"hint font-size-14\">PDF, 20 Mo maximum. Laisser vide si inchangé.</div></md-input-container></div></div><p \nclass=\"md-warn-fg\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.annuler()\" ng-disabled=\"vm.busy\">{{vm.lectureSeule ? \'Fermer\' : \'Annuler\'}}</md-button>\n<md-button ng-if=\"!vm.lectureSeule\" type=\"submit\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.busy || editionForm.$invalid || !vm.autorise() || (!vm.statutSeulement && !vm.modifiable)\" \naria-label=\"Appliquer\"><span ng-show=\"!vm.busy\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20\" ng-show=\"vm.busy\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/achats/factures/dialogs/fournisseur-validation.html","<md-dialog class=\"factures-achats-dialog\" flex=\"80\" aria-label=\"Fournisseurs SUPER PDP à valider\"><form \nname=\"validationFournisseurForm\" class=\"md-inline-form\" ng-submit=\"vm.appliquer(validationFournisseurForm)\" novalidate>\n<md-dialog-content ms-scroll><span class=\"md-title\">Valider le fournisseur reçu de SUPER PDP</span><p \nclass=\"secondary-text\" ng-if=\"vm.proposition\">\nProposition {{vm.index + 1}} sur {{vm.propositions.length}} — {{vm.proposition.NombreFactures}} document(s) en attente\n</p><div ng-if=\"vm.proposition\"><table class=\"full-width mb-16\"><tr><td class=\"secondary-text pr-16 pb-8\">\nRaison sociale</td><td class=\"pb-8\">{{vm.proposition.NomFournisseur || \'—\'}}</td></tr><tr \nng-if=\"vm.proposition.NomCommercial\"><td class=\"secondary-text pr-16 pb-8\">Nom commercial</td><td class=\"pb-8\">\n{{vm.proposition.NomCommercial}}</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">SIREN / SIRET</td><td class=\"pb-8\">\n{{vm.proposition.SIREN || \'—\'}} / {{vm.proposition.SIRET || \'—\'}}</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">\nTVA</td><td class=\"pb-8\">{{vm.proposition.NumeroTVA || \'—\'}}</td></tr><tr><td class=\"secondary-text pr-16 pb-8\">Adresse\n</td><td class=\"pb-8\">{{vm.proposition.Adresse1 || \'—\'}} {{vm.proposition.Adresse2}}<br \nng-if=\"vm.proposition.Adresse1\">{{vm.proposition.CodePostal}} {{vm.proposition.Ville}} {{vm.proposition.Pays}}</td>\n</tr><tr><td class=\"secondary-text pr-16 pb-8\">Contact</td><td class=\"pb-8\">\n{{vm.proposition.Email || vm.proposition.AdresseElectronique || \'—\'}} <span ng-if=\"vm.proposition.Telephone\">\n— {{vm.proposition.Telephone}}</span></td></tr></table><div class=\"mb-16\" ng-if=\"vm.proposition.FournisseurSuggere\">\n<md-icon class=\"material-icons-outlined md-accent-fg\">info</md-icon>Correspondance suggérée : <b>\n{{vm.proposition.FournisseurSuggere}}</b> ({{vm.proposition.ConfianceSuggestion}} %). Elle doit être confirmée.</div>\n<md-radio-group ng-model=\"vm.choix.Mode\" layout=\"row\" layout-xs=\"column\" class=\"mb-16\"><md-radio-button \nvalue=\"creation\">Créer un fournisseur</md-radio-button><md-radio-button value=\"rattachement\">\nRattacher à un fournisseur existant</md-radio-button></md-radio-group><div ng-if=\"vm.choix.Mode === \'creation\'\"><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" md-no-float flex><label>Nom affiché</label><input \nname=\"Fabricant\" ng-model=\"vm.choix.Fabricant\" required maxlength=\"64\"><div \nng-messages=\"validationFournisseurForm[\'Fabricant\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>Métier / activité</label><input\n name=\"Metier\" ng-model=\"vm.choix.Metier\" required maxlength=\"255\"><div \nng-messages=\"validationFournisseurForm[\'Metier\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n</div></md-input-container></div><p class=\"secondary-text\">\nLa création enregistrera aussi les identifiants et coordonnées ci-dessus. Aucun fournisseur n’est créé avant de cliquer sur « Créer et importer ».\n</p></div><div ng-if=\"vm.choix.Mode === \'rattachement\'\"><md-input-container class=\"md-block\" md-no-float><label>\nFournisseur existant</label><md-select ng-model=\"vm.choix.IDFabricant\" name=\"IDFabricant\" \nng-required=\"vm.choix.Mode === \'rattachement\'\"><md-option ng-repeat=\"fournisseur in vm.fournisseurs\" \nng-value=\"fournisseur.IDFabricant\">{{fournisseur.Fabricant}}</md-option></md-select><div \nng-messages=\"validationFournisseurForm[\'IDFabricant\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n</div></md-input-container><p class=\"secondary-text\">\nLe fournisseur existant ne sera pas modifié. Les documents en attente lui seront rattachés.</p></div><p \nclass=\"md-subhead mt-16\">Documents concernés</p><table class=\"simple full-width\"><thead><tr><th>Document</th><th>Date\n</th><th class=\"text-right\">TTC</th></tr></thead><tbody><tr ng-repeat=\"facture in vm.proposition.Factures\"><td>\n{{facture.TypeDocument}} {{facture.NumeroFacture}}</td><td>{{facture.DateFacture | date:\'dd/MM/yyyy\'}}</td><td \nclass=\"text-right\">{{facture.TotalTTC | number:2}} €</td></tr></tbody></table></div><p class=\"md-warn-fg\" role=\"alert\" \nng-if=\"vm.error\">{{vm.error}}</p></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div><md-button ng-click=\"vm.precedent()\" ng-disabled=\"vm.busy || vm.index === 0\">\nPrécédent</md-button><md-button ng-click=\"vm.suivant()\" \nng-disabled=\"vm.busy || vm.index >= vm.propositions.length - 1\">Suivant</md-button></div><div><md-button \nng-click=\"vm.annuler()\" ng-disabled=\"vm.busy\">Fermer</md-button><md-button type=\"submit\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.busy || validationFournisseurForm.$invalid\" \naria-label=\"Valider le fournisseur\"><span ng-show=\"!vm.busy\">\n{{vm.choix.Mode === \'creation\' ? \'Créer et importer\' : \'Rattacher et importer\'}}</span><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.busy\"></md-progress-circular></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/achats/factures/dialogs/import.html","<md-dialog class=\"factures-achats-dialog\" aria-label=\"Importer des factures\" flex=\"80\"><form class=\"md-inline-form\" \nenctype=\"multipart/form-data\" name=\"importForm\" ng-submit=\"vm.importer(importForm)\" novalidate><md-dialog-content \nms-scroll><span class=\"md-title\">Importer des factures</span><p></p><div ng-if=\"!vm.resultat\"><md-input-container \nmd-no-float class=\"md-block\"><label>Format</label><md-select ng-model=\"vm.format\" ng-change=\"vm.changerFormat()\" \nrequired><md-option ng-repeat=\"format in vm.formats\" ng-value=\"format\">{{format}}</md-option></md-select>\n</md-input-container><md-input-container md-no-float class=\"md-block\"><label>Fichier</label><input type=\"file\" \nname=\"file\" ngf-select ng-model=\"vm.file\" aria-label=\"Fichier à importer\" \nng-attr-accept=\"{{vm.format === \'CSV\' ? \'.csv\' : \'.pdf\'}}\" required><div class=\"hint font-size-14\">20 Mo maximum</div>\n</md-input-container><div ng-if=\"vm.format === \'PDF\'\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.busyAnalyse\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" class=\"mr-12\">\n</md-progress-circular><span>Analyse du PDF…</span></div><p class=\"md-accent-fg\" ng-if=\"vm.analyse && !vm.busyAnalyse\">\nChamps préremplis automatiquement depuis le PDF. Ils restent à contrôler avant l’import.</p><p class=\"md-warn-fg\" \nng-repeat=\"avertissement in vm.avertissements\">{{avertissement}}</p><div \nng-if=\"vm.fournisseurDetecte && !vm.document.IDFabricant\" class=\"mb-16\"><p>Fournisseur détecté : <strong>\n{{vm.fournisseurDetecte.Fabricant}}</strong></p><p>\nSélectionnez un fournisseur existant ci-dessous pour le rattacher à cette facture.</p><md-button type=\"button\" \nclass=\"md-accent md-raised\" ng-if=\"vm.peutCreerFournisseur()\" ng-click=\"vm.creerFournisseur($event)\" \nng-disabled=\"vm.busyAnalyse\">Créer ce fournisseur</md-button><p class=\"md-warn-fg\" ng-if=\"!vm.peutCreerFournisseur()\">\nLa création doit être validée par un utilisateur disposant du droit de validation des fournisseurs.</p></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Fournisseur</label><md-select \nng-model=\"vm.document.IDFabricant\" name=\"IDFabricant\" required><md-option ng-repeat=\"fournisseur in vm.fournisseurs\" \nng-value=\"fournisseur.IDFabricant\">{{fournisseur.Fabricant}}</md-option></md-select><div class=\"hint\" \nng-if=\"vm.confiance(\'IDFabricant\')\">Reconnaissance : {{vm.confiance(\'IDFabricant\')}} %</div><div \nng-messages=\"importForm.IDFabricant.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" md-no-float flex>\n<label>Type de document</label><md-select ng-model=\"vm.document.TypeDocument\" name=\"TypeDocument\" required><md-option \nvalue=\"Facture\">Facture</md-option><md-option value=\"Avoir\">Avoir</md-option></md-select><div \nng-messages=\"importForm.TypeDocument.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>Numéro</label><input \nng-model=\"vm.document.NumeroFacture\" name=\"NumeroFacture\" required maxlength=\"100\"><div \nng-messages=\"importForm.NumeroFacture.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" md-no-float flex>\n<label>Date</label><md-datepicker ng-model=\"vm.dates.DateFacture\" name=\"DateFacture\" md-open-on-focus required>\n</md-datepicker><div ng-messages=\"importForm.DateFacture.$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div><div ng-message=\"valid\">Date invalide</div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float flex><label>Échéance</label><md-datepicker ng-model=\"vm.dates.DateEcheance\" name=\"DateEcheance\" \nmd-open-on-focus></md-datepicker><div ng-messages=\"importForm.DateEcheance.$error\"><div ng-message=\"valid\">\nDate invalide</div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Devise</label><input ng-model=\"vm.document.Devise\" name=\"Devise\" required \nmaxlength=\"3\" ng-change=\"vm.document.Devise = (vm.document.Devise || \'\').toUpperCase()\"><div class=\"hint\">\nCode ISO : EUR, USD, GBP…</div><div ng-messages=\"importForm.Devise.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.document.Devise !== \'EUR\'\"><md-input-container class=\"md-block\" md-no-float flex><label>\nMontant HT ({{vm.document.Devise}})</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.document.TotalHTDevise\" \nname=\"TotalHTDevise\" required><div ng-messages=\"importForm.TotalHTDevise.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>\nTVA ({{vm.document.Devise}})</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.document.TotalTVADevise\" \nname=\"TotalTVADevise\" required><div ng-messages=\"importForm.TotalTVADevise.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.document.Devise !== \'EUR\'\"><md-input-container class=\"md-block\" md-no-float flex><label>\nCours : {{vm.document.Devise}} pour 1 EUR</label><input type=\"number\" min=\"0.00000001\" step=\"0.00000001\" \nng-model=\"vm.document.TauxConversion\" name=\"TauxConversion\" ng-change=\"vm.document.SourceTaux = \'Manuel\'\" required><div\n class=\"hint\">Source : {{vm.document.SourceTaux || \'Manuel\'}}</div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float flex><label>Date du cours</label><md-datepicker ng-model=\"vm.dates.DateTaux\" \nname=\"DateTaux\" md-open-on-focus required></md-datepicker></md-input-container><md-button type=\"button\" \nclass=\"md-accent\" ng-click=\"vm.actualiserTaux()\" ng-disabled=\"vm.busyAnalyse\">Cours BCE</md-button></div><p \nng-if=\"vm.document.Devise !== \'EUR\'\">\nTotal d’origine : {{vm.totalOrigine() | number:2}} {{vm.document.Devise}} · Valeur comptable : {{vm.total() | currency:\'€\'}}\n</p><div layout=\"row\" layout-xs=\"column\" ng-if=\"vm.document.Devise === \'EUR\'\"><md-input-container class=\"md-block\" \nmd-no-float flex><label>Montant HT (€)</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.document.TotalHT\" \nname=\"TotalHT\" required><div ng-messages=\"importForm.TotalHT.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>\nTVA (€)</label><input type=\"number\" step=\"0.01\" ng-model=\"vm.document.TotalTVA\" name=\"TotalTVA\" required><div \nng-messages=\"importForm.TotalTVA.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><p ng-if=\"vm.document.Devise === \'EUR\'\">Total TTC : {{vm.total() | currency:\'€\'}}</p></div>\n<p ng-if=\"vm.format === \'CSV\'\">\nColonnes CSV (séparateur ;) : IDFabricant;TypeDocument;NumeroFacture;DateFacture;DateEcheance;TotalHT;TotalTVA. Dates AAAA-MM-JJ, montants décimaux avec un point.\n</p></div><div ng-if=\"vm.resultat\"><p>\n{{vm.resultat.Importes}} élément(s) importé(s), {{vm.resultat.Doublons}} doublon(s), {{vm.resultat.Rejetes.length}} rejet(s).\n</p><p ng-repeat=\"rejet in vm.resultat.Rejetes\">Ligne {{rejet.Ligne}} : {{rejet.Message}}</p></div><p \nclass=\"md-warn-fg\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.fermer()\" ng-disabled=\"vm.busy || vm.busyAnalyse\">{{vm.resultat ? \'Fermer\' : \'Annuler\'}}\n</md-button><md-button ng-if=\"!vm.resultat\" type=\"submit\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.busy || vm.busyAnalyse || importForm.$invalid || !vm.autorise()\" aria-label=\"Importer\"><span \nng-show=\"!vm.busy\">Importer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.busy\">\n</md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/achats/factures/dialogs/statuts-masse.html","<md-dialog class=\"factures-achats-dialog\" flex=\"80\" aria-label=\"Modifier les statuts\"><form name=\"statutsMasseForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.enregistrer()\" novalidate><md-dialog-content ms-scroll><span class=\"md-title\">\nModifier {{vm.ids.length}} document(s)</span><p class=\"secondary-text\">\nLaisser un champ sur « Ne pas modifier » pour conserver sa valeur actuelle.</p><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Validation</label><md-select ng-model=\"vm.etatValidation\"><md-option value=\"\">\nNe pas modifier</md-option><md-option ng-repeat=\"etat in vm.etatsValidation\" ng-value=\"etat\">{{etat}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>\nRèglement</label><md-select ng-model=\"vm.statut\"><md-option value=\"\">Ne pas modifier</md-option><md-option \nng-repeat=\"statut in vm.etatsReglement\" ng-value=\"statut\">{{statut}}</md-option></md-select><div class=\"hint\">\nLe règlement choisi doit être compatible avec tous les documents sélectionnés : facture ou avoir.</div>\n</md-input-container></div><p class=\"md-warn-fg\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"button\" ng-click=\"vm.annuler()\" ng-disabled=\"vm.busy\">Annuler\n</md-button><md-button type=\"submit\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.busy || (!vm.etatValidation && !vm.statut)\"><span ng-show=\"!vm.busy\">Appliquer</span>\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.busy\"></md-progress-circular></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/analyse/emails_tracking/dialogs/emails_tracking-dialog.html","<md-dialog class=\"tracking-dialog\" flex=\"80\"><form name=\"trackingForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content ms-scroll><span class=\"md-title\">Configuration de l\'email</span><p></p><div layout=\"row\" \nclass=\"mb-16\"><md-input-container class=\"md-block\" md-no-float flex><label>Etat</label><md-select \nng-model=\"vm.Tracking.Actif\" required name=\"Actif\"><md-option ng-value=\"1\">Activé</md-option><md-option ng-value=\"0\">\nDésactivé</md-option></md-select><div ng-messages=\"trackingForm[\'Actif\'].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" class=\"mb-16\"><md-input-container \nmd-no-float flex><label>E-mail</label><input name=\"Email\" type=\"email\" ng-model=\"vm.Tracking.Email\" required \nng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,6}$/\"><div ng-messages=\"trackingForm[\'Email\'].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"pattern\">Adresse e-mail invalide</div></div>\n</md-input-container></div><div layout=\"row\" class=\"mb-16\"><md-input-container md-no-float flex><label>Imap</label>\n<input name=\"Imap\" ng-model=\"vm.Tracking.Imap\" required><div ng-messages=\"trackingForm[\'Imap\'].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" class=\"mb-16\">\n<md-input-container md-no-float flex><label>Port</label><input name=\"Port\" ng-model=\"vm.Tracking.Port\" required><div \nng-messages=\"trackingForm[\'Port\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" class=\"mb-16\"><md-input-container md-no-float flex><label>Certificat\n</label><md-select ng-model=\"vm.Tracking.certificat\" name=\"certificat\" required><md-option value=\"/ssl\">SSL/TLS\n</md-option><md-option value=\"/tls\">TLS/STARTTLS</md-option><md-option value=\"/service=service\">Aucun</md-option>\n</md-select><div ng-messages=\"trackingForm[\'certificat\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div></div></md-input-container></div><div layout=\"row\" class=\"mb-16\"><md-input-container md-no-float flex><label>\nIdentifiant</label><input name=\"User\" ng-model=\"vm.Tracking.User\" required><div \nng-messages=\"trackingForm[\'User\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" class=\"mb-16\"><md-input-container md-no-float flex><label>Mot de passe\n</label><input name=\"Identifiant\" ng-model=\"vm.Tracking.Pass\" type=\"password\" \nng-required=\"!vm.Tracking.IDEmploye_Emails_Tracking\" \nplaceholder=\"{{vm.Tracking.IDEmploye_Emails_Tracking ? \'Laisser vide si inchangé\' : \'\'}}\"><div \nng-messages=\"trackingForm[\'Pass\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" \nclass=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveTracking()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"trackingForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\">\n<span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/analyse/notifications/dialogs/dialog-bilan.html","<md-dialog class=\"md-default-theme\"><md-dialog-content ms-scroll><span class=\"md-title\">\nSouhaitez-vous passer cette notification en traitée ?</span><p ng-bind-html=\"notification.Alerte\"></p>\n<md-input-container class=\"md-block\"><label>Comment c\'est passé le bilan ?</label><textarea \nng-model=\"notification.Note\" rows=\"3\" md-select-on-focus></textarea></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><div><md-button ng-click=\"cancel();\">Annuler</md-button>\n<md-button ng-click=\"reponse(notification);\" ng-disabled=\"!notification.Note\">Valider</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/analyse/notifications/dialogs/dialog-default.html","<md-dialog class=\"md-default-theme\"><md-dialog-content ms-scroll><span class=\"md-title\">\nSouhaitez-vous passer cette notification en traitée ?</span><p ng-bind-html=\"notification.Alerte\"></p>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div><md-button ng-click=\"cancel();\">Non\n</md-button><md-button ng-click=\"reponse(notification);\">Oui</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/analyse/notifications/dialogs/dialog-devis.html","<md-dialog class=\"notifications-dialog\" class=\"md-default-theme\"><md-dialog-content ms-scroll><span class=\"md-title\">\nSouhaitez-vous passer cette notification en traitée ?</span><p>{{notification.Alerte}}</p><md-input-container \nclass=\"md-block\"><label>Ajouter une note à la commande</label><textarea ng-model=\"notification.Note\" rows=\"3\" \nmd-select-on-focus></textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"cancel();\">Pas encore</md-button><div><md-button \nng-click=\"notification.commande = \'attendre\'; reponse(notification);\">Reporter son traitement</md-button><md-button \nng-click=\"reponse(notification);\">C\'est traité</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/analyse/notifications/dialogs/dialog-renouvellement.html","<md-dialog class=\"notifications-dialog\" class=\"md-default-theme\"><md-dialog-content ms-scroll><span class=\"md-title\">\nSouhaitez-vous passer cette notification en traitée ?</span><p>{{notification.Alerte}}</p><md-input-container \nclass=\"md-block\"><label>Ajouter une note à la commande</label><textarea ng-model=\"notification.Note\" rows=\"3\" \nmd-select-on-focus></textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"cancel();\">Fermer</md-button><div><md-button ng-click=\"notification.renouvele = -1; reponse(notification);\">\nRenouvellement reporté</md-button><md-button ng-click=\"notification.renouvele = 0; reponse(notification);\">\nContrat non-renouvelé</md-button><md-button ng-click=\"notification.renouvele = 1; reponse(notification);\">\nContrat renouvelé</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/banque/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"column\" \nlayout-align=\"start start\"><span class=\"logo-icon\"><md-icon class=\"material-icons-outlined s28\">account_balance\n</md-icon><span class=\"logo-text ml-10\">Banque</span> </span><span class=\"secondary-text\">\n{{vm.recordsTotal}} opérations</span></div><md-button class=\"md-raised m-0\" ng-if=\"vm.droits(\'edition\')\" \nng-disabled=\"vm.busy\" ng-click=\"vm.editer($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span>Opération</span>\n</md-button></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" ng-class=\"{\'blue-600-bg white-fg\':vm.filterStatus === \'\'}\" ng-click=\"vm.filterChange(\'\')\"><md-icon \nclass=\"material-icons-outlined s21\">view_list</md-icon><span class=\"title\">Toutes les opérations</span></md-button><div\n class=\"item subheader mb-0\">Filtrer</div><md-button class=\"item\" \nng-repeat=\"statut in [\'À rapprocher\', \'À valider\', \'Rejet à attribuer\', \'Rapprochée\', \'À rembourser\', \'Remboursé\', \'Rejetée\', \'En attente de pièce\', \'Justifiée hors facture\', \'Non justifiée\', \'Ignorée\']\" \nng-click=\"vm.filterChange(statut)\" ng-class=\"{\'blue-600-bg white-fg\':vm.filterStatus === statut}\"><md-icon \nclass=\"material-icons-outlined s21\" \nng-bind=\"statut === \'Rapprochée\' ? \'link\' : (statut === \'À rembourser\' ? \'swap_horiz\' : (statut === \'Remboursé\' ? \'check_circle\' : (statut === \'Rejet à attribuer\' ? \'assignment_late\' : (statut === \'Rejetée\' ? \'undo\' : (statut === \'Justifiée hors facture\' ? \'check_circle\' : (statut === \'En attente de pièce\' ? \'attach_file\' : (statut === \'À valider\' ? \'help_outline\' : (statut === \'Non justifiée\' ? \'warning\' : (statut === \'Ignorée\' ? \'block\' : \'link_off\')))))))))\">\n</md-icon><span class=\"title\">{{statut}}</span> <span class=\"blue-grey-600-bg white-fg pull-right badge\" \nng-if=\"vm.compteurs[statut]\">{{vm.compteurs[statut]}}</span></md-button></div></md-content>");
$templateCache.put("app/main/collaborateurs/activites/dialogs/activites-dialog.html","<md-dialog class=\"activiteCollab-dialog\" flex=\"80\"><form name=\"activiteColabForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content><span class=\"md-title\">Votre activité du {{vm.convertDate(vm.activite.Date)}} <small \nng-if=\"vm.activite.Ferie || vm.activite.Weekend\">(<span ng-if=\"vm.activite.Ferie\">Férié</span><span \nng-if=\"vm.activite.Ferie && vm.activite.Weekend\"> - </span><span ng-if=\"vm.activite.Weekend\">Weekend</span>)</small>\n</span><p></p><p ng-if=\"vm.congeApresMidi\" class=\"orange-500-fg\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"material-icons-outlined\">report_problem</span> Vous êtes absent l\'après-midi de ce jour</p><p \nng-if=\"vm.congeMatin\" class=\"orange-500-fg\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"material-icons-outlined\">report_problem</span>Vous êtes absent le matin de ce jour</p><div layout=\"row\" \nclass=\"mb-16\" ng-repeat=\"TranchesHeures in vm.activite.TranchesHeures track by $index\" \nlayout-align=\"space-between center\"><md-input-container md-no-float flex><label>De</label><input \nng-model=\"vm.activite.TranchesHeures[$index].start\" name=\"TranchesHeuresS{{$index}}\" type=\"time\" \nmin=\"{{(vm.activite.TranchesHeures[$index-1].end) ? vm.convertHour(vm.activite.TranchesHeures[$index-1].end) : (vm.congeMatin?\'12:00:00\':\'\')}}\" \nmax=\"{{vm.congeApresMidi?\'13:00:00\':\'\'}}\" required><div \nng-messages=\"activiteColabForm[\'TranchesHeuresS\'+$index].$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div><div ng-message=\"min\">\nDoit être supérieur à {{(vm.activite.TranchesHeures[$index-1].end) ? vm.convertHour(vm.activite.TranchesHeures[$index-1].end) : (vm.congeMatin?\'12:00:00\':\'\')}}\n</div><div ng-message=\"max\">Doit être inférieur à 13:00</div></div></md-input-container>-<md-input-container \nmd-no-float flex><label>à</label><input ng-model=\"vm.activite.TranchesHeures[$index].end\" \nname=\"TranchesHeuresE{{$index}}\" type=\"time\" min=\"{{vm.activite.TranchesHeures[$index].start}}\" \nmax=\"{{vm.congeApresMidi?\'13:00:00\':\'\'}}\" required><div \nng-messages=\"activiteColabForm[\'TranchesHeuresE\'+$index].$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div><div ng-message=\"min\">Doit être supérieur à {{vm.convertHour(vm.activite.TranchesHeures[$index].start)}}</div>\n<div ng-message=\"max\">Doit être inférieur à 13:00</div></div></md-input-container><md-button \nclass=\"md-secondary md-icon-button mt-16\" ng-click=\"vm.activite.TranchesHeures.splice($index, 1)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div layout=\"row\"><md-button class=\"ml-0\" \nng-click=\"vm.activite.TranchesHeures.push(null)\">+ Ajouter une tranche horaire</md-button></div><div layout=\"row\" \nclass=\"mt-16\"><md-input-container md-no-float flex><label>Commentaire</label><textarea ng-model=\"vm.activite.Note\" \nrows=\"4\" md-detect-hidden=\"true\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button>\n<md-button type=\"submit\" ng-click=\"vm.saveActivite()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"activiteColabForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">\nAppliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\">\n</md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/collaborateurs/conges/dialogs/conges-dialog.html","<md-dialog class=\"conge-dialog\" flex=\"80\"><form name=\"congesForm\" class=\"md-inline-form\" novalidate><md-dialog-content \nms-scroll><span class=\"md-title\">Votre absence</span><p></p><div layout=\"row\" ng-if=\"vm.employesSimple.data.length>0\" \nclass=\"mb-16\"><md-input-container class=\"md-block\" md-no-float flex><label>Collaborateur</label><md-select \nng-model=\"vm.conge.IDEmploye\" required name=\"IDEmploye\" ng-disabled=\"vm.conge.IDEmploye && vm.conge.IDEmployes_Conge\">\n<md-option value=\"0\">Tous</md-option><md-option ng-repeat=\"employe in vm.employesSimple.data\" \nvalue=\"{{employe.value}}\">{{employe.label}}</md-option></md-select><div ng-messages=\"congesForm[\'IDEmploye\'].$error\">\n<div ng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" \nclass=\"mb-16\"><md-input-container class=\"md-block\" md-no-float flex><label>Type d\'absence</label><md-select \nng-model=\"vm.conge.Type\" name=\"Type\" required><md-option value=\"Congés payés\">Congés payés</md-option><md-option \nvalue=\"Congés sans solde\">Congés sans solde</md-option><md-option value=\"Maladie ou à l’accident non professionnel\">\nMaladie ou à l’accident non professionnel</md-option><md-option value=\"Accident ou maladie professionnelle\">\nAccident ou maladie professionnelle</md-option><md-option value=\"Compte Epargne Temps\">Compte Epargne Temps</md-option>\n<md-option value=\"Congés d\'ancienneté\">Congés d\'ancienneté</md-option><md-option value=\"Congés d’adoption\">\nCongés d’adoption</md-option><md-option value=\"Congés de proche aidant\">Congés de proche aidant</md-option><md-option \nvalue=\"Congés de solidarité familiale\">Congés de solidarité familiale</md-option><md-option \nvalue=\"Congés liées à la maternité ou à l’adoption\">Congés liées à la maternité ou à l’adoption</md-option><md-option \nvalue=\"Congés maternité\">Congés maternité</md-option><md-option value=\"Congés parental d\'éducation\">\nCongés parental d\'éducation</md-option><md-option value=\"Congés paternité\">Congés paternité</md-option><md-option \nvalue=\"Congés pour enfant malade\">Congés pour enfant malade</md-option><md-option \nvalue=\"Congés pour évènements familiaux\">Congés pour évènements familiaux</md-option><md-option \nvalue=\"Congés sabbatiques\">Congés sabbatiques</md-option><md-option value=\"Récupération\">Récupération</md-option>\n<md-option value=\"Repos compensateur\">Repos compensateur</md-option></md-select><div \nng-messages=\"congesForm[\'Type\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" class=\"\"><md-input-container flex><label>Début</label><md-datepicker \nng-model=\"vm.conge.DateDebut\" ng-change=\"vm.testCongesExist(vm.conge)\" name=\"DateDebut\" ng-init=\"\" \nmd-min-date=\"vm.dateMin\" md-max-date=\"vm.conge.DateFin\" md-open-on-focus required></md-datepicker><div \nng-messages=\"congesForm[\'DateDebut\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float flex><md-select ng-model=\"vm.conge.HeureDebut\" \nng-change=\"vm.testCongesExist(vm.conge)\" aria-label=\"Horraire\" name=\"HeureDebut\" required><md-option value=\"Matin\">\nMatin</md-option><md-option value=\"Midi\">Midi</md-option></md-select><div \nng-messages=\"congesForm[\'HeureDebut\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" class=\"mb-16\"><md-input-container flex><label>Fin</label><md-datepicker \nng-model=\"vm.conge.DateFin\" ng-change=\"vm.testCongesExist(vm.conge)\" md-min-date=\"vm.conge.DateDebut\" md-open-on-focus \nname=\"DateFin\" required></md-datepicker><div ng-messages=\"congesForm[\'DateFin\'].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float flex>\n<md-select ng-model=\"vm.conge.HeureFin\" ng-change=\"vm.testCongesExist(vm.conge)\" aria-label=\"Horraire\" name=\"HeureFin\" \nrequired><md-option value=\"Midi\">Midi</md-option><md-option value=\"Soir\">Soir</md-option></md-select><div \nng-messages=\"congesForm[\'HeureFin\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div class=\"md-warn-bg ng-binding ng-scope p-8 brad-16\" \nng-if=\"!vm.congesValide && vm.congesTrouve != \'\'\"><p class=\"m-0\">\nCette absence empiète sur une autre (du {{vm.convertDate(vm.congesTrouve.DateDebut)}} {{vm.congesTrouve.HeureDebut}} au {{vm.convertDate(vm.congesTrouve.DateFin)}} {{vm.congesTrouve.HeureFin}})\n</p></div><div layout=\"row\" class=\"mt-16 mb-16\"><md-input-container md-no-float flex><label>Commentaire</label>\n<textarea ng-model=\"vm.conge.CommentaireSalarie\" rows=\"4\" md-detect-hidden=\"true\"></textarea></md-input-container>\n</div><md-divider ng-if=\"vm.Permission==\'Super Admin\'\"></md-divider><div layout=\"row\" \nng-if=\"vm.Permission==\'Super Admin\'\" class=\"mt-16\"><md-input-container class=\"md-block\" md-no-float flex><label>Statut\n</label><md-select ng-model=\"vm.conge.Statut\" required><md-option value=\"A valider\">A valider</md-option><md-option \nvalue=\"Validés\">Validés</md-option><md-option value=\"Refusés\">Refusés</md-option></md-select></md-input-container>\n</div><div layout=\"row\" class=\"mt-16 mb-16\" ng-if=\"vm.Permission==\'Super Admin\'\"><md-input-container md-no-float flex>\n<label>Commentaire du responsable</label><textarea ng-model=\"vm.conge.CommentaireResponsable\" rows=\"4\" \nmd-detect-hidden=\"true\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button \ntype=\"submit\" ng-click=\"vm.saveConge()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"congesForm.$invalid || (!vm.congesValide && vm.congesTrouve != \'\') || vm.showSpinner\" \naria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/collaborateurs/documents/dialogs/document-dialog.html","<md-dialog class=\"document-dialog\" flex=\"80\"><form name=\"documentForm\" class=\"md-inline-form\" novalidate \nenctype=\"multipart/form-data\"><md-dialog-content><span class=\"md-title\">Votre document</span><p></p><div layout=\"row\">\n<md-input-container md-no-float flex><label>Label</label><input ng-model=\"vm.document.Label\" name=\"label\" type=\"text\" \nrequired><div ng-messages=\"documentForm[\'label\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n</div></md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Type</label><input \nng-model=\"vm.document.Type\" name=\"Type\" type=\"text\" required><div ng-messages=\"documentForm[\'Type\'].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Collaborateur</label><md-select \nng-model=\"vm.document.IDEmploye\" name=\"IDEmploye\" required><md-option ng-value=\"0\">Tous</md-option><md-option \nng-repeat=\"employe in vm.employesSimple.data\" ng-value=\"{{employe.value}}\">{{employe.label}}</md-option></md-select>\n<div ng-messages=\"documentForm[\'IDEmploye\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Accès</label>\n<md-select ng-model=\"vm.document.Acces\" name=\"Acces\" required><md-option value=\"Fichier\">Fichier</md-option><md-option \nvalue=\"Lien\">Lien</md-option></md-select><div ng-messages=\"documentForm[\'Acces\'].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" \nng-show=\"vm.document.Acces==\'Fichier\'\"><md-input-container md-no-float flex><label>Fichier</label><input \nng-model=\"vm.files\" ngf-select id=\"file\" type=\"file\"><div class=\"hint font-size-14\">Laisser vide si inchangé</div>\n</md-input-container></div><div layout=\"row\" ng-show=\"vm.document.Acces==\'Lien\'\"><md-input-container md-no-float flex>\n<label>Lien</label><input ng-model=\"vm.document.Lien\" name=\"Lien\" type=\"text\" ng-required=\"vm.document.Acces==\'Lien\'\">\n<div ng-messages=\"documentForm[\'Lien\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" \nclass=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveDocument()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"documentForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\">\n<span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/collaborateurs/frais/edition/editionfrais.html","<div id=\"note\" class=\"page-layout simple inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-produits-button md-icon-button\" aria-label=\"Go to produits\" ng-click=\"vm.gotoNotesDeFrais()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\" ng-if=\"!vm.Listefrais\">Nouvelle note de frais</div><div \nclass=\"h2\" ng-if=\"vm.Listefrais\">\nNote du {{vm.convertDate(vm.Listefrais.DateDebut)}} au {{vm.convertDate(vm.Listefrais.DateFin)}}</div><div \nclass=\"subtitle secondary-text\" ng-if=\"vm.Listefrais\"><span>Modification d\'une note de frais</span></div></div><span \nclass=\"p-8 pr-16 pl-16 brad-16 ml-24 md-green-bg white-fg\" ng-if=\"vm.Listefrais.Statut == \'Remboursée\'\" \nstyle=\"text-transform:capitalize; display:inline-block\">Remboursée</span> <span \nclass=\"p-8 pr-16 pl-16 brad-16 ml-24 md-orange-bg white-fg\" ng-if=\"vm.Listefrais.Statut == \'À Rembourser\'\" \nstyle=\"text-transform:capitalize;display:inline-block\">À Rembourser</span></div></div><div hide-xs layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.editerNote($event)\" \nng-if=\"id == vm.Listefrais.IDEmploye || !vm.Listefrais.IDEmploye\" ng-disabled=\"vm.Listefrais.Statut == \'Remboursée\'\">\n<md-icon class=\"material-icons-outlined\">add_box</md-icon><span>Ajouter une dépense</span></md-button></div></div><div \nclass=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><div class=\"main\"><div \nclass=\"note-list card border brad-16\" flex-gt-md=\"80\" flex-gt-lg=\"60\" flex><md-list class=\"p-0\"><md-list-item \nng-repeat=\"Note in vm.Listefrais.Notes\" \nclass=\"pt-16 pb-16 md-3-line md-white-bg border-bottom contact-list md-no-proxy\"><div class=\"md-list-item-text\" \nlayout=\"column\"><div layout=\"row\" layout-align=\" space-between center\"><h2>{{Note.Type}} <small ng-if=\"Note.Distance\">\n({{Note.Distance}} km)</small> <span ng-if=\"Note.Label\">- {{Note.Label}}</span><br><small>\nLe {{vm.convertDate(Note.Date)}}</small></h2><div layout=\"column\" layout-align=\"center end\"><h1 \nclass=\"font-size-30 m-0\">{{Note.TotalTTC}} € TTC <small class=\"font-size-20\" \nng-if=\"(Note.TVA055 + Note.TVA10 + Note.TVA20) > 0\">({{Note.TotalTTC - Note.TVA055 - Note.TVA10 - Note.TVA20}} € HT)\n</small></h1><p ng-if=\"Note.SansTVA\">TVA non indiquée sur le justificatif</p><p ng-if=\"Note.TVAInconnue\">\nTaux de la TVA inconnue</p><p ng-if=\"Note.Refacturables\">Refacturable au client</p></div></div><div \nng-if=\"Note.Type==\'Frais kilométriques\' || Note.Type==\'Frais kilométriques vélo\'\"><h4 layout=\"row\" \nlayout-align=\"left center\"><span class=\"material-icons-outlined m-8\" ng-if=\"Note.VehiculeLabel.Type == \'Cyclomoteur\'\">\ndelivery_dining</span> <span class=\"material-icons-outlined\" ng-if=\"Note.VehiculeLabel.Type == \'Moto / Scooter\'\">\ntwo_wheeler</span> <span class=\"material-icons-outlined\" ng-if=\"Note.VehiculeLabel.Type == \'Vélo\'\">pedal_bike</span> \n<span class=\"material-icons-outlined mr-8\" ng-if=\"Note.VehiculeLabel.Type == \'Automobile / Utilitaire\'\">directions_car\n</span><div>{{Note.VehiculeLabel.Marque}} {{Note.VehiculeLabel.Modele}} {{Note.VehiculeLabel.Immatriculation}} <span \nng-if=\"Note.VehiculeLabel.Energie\">{{Note.VehiculeLabel.Energie}}</span> <span ng-if=\"Note.VehiculeLabel.Fiscale\">\n({{Note.VehiculeLabel.Fiscale}})</span></div></h4><div><div layout=\"row\" layout-align=\"left center\"><span \nclass=\"material-icons-outlined pr-16 green-fg\">place</span><div class=\"p-8\"><h4 \nng-if=\"Note.AdresseDepartType==\'manuelle\'\">{{Note.AdresseDepart}}</h4><h4 \nng-if=\"Note.AdresseDepartType==\'personnelle\'\">\n{{Note.LabelMonAdresseDepart.Adresse}} {{Note.LabelMonAdresseDepart.Ville.CodePostal}} {{Note.LabelMonAdresseDepart.Ville.NomVille}} ({{Note.LabelMonAdresseDepart.NomAdresse}})\n</h4><h4 ng-if=\"Note.AdresseDepartType==\'contact\'\">\n{{Note.LabelClientDepart.Adresse}} {{Note.LabelClientDepart.Ville.CodePostal}} {{Note.LabelClientDepart.Ville.NomVille}} ({{Note.LabelClientDepart.NomAdresse}})\n</h4></div></div><div ng-if=\"!Note.allerretour\"><span class=\"material-icons-outlined\">south</span></div><div \nng-if=\"Note.allerretour\" layout=\"row\" layout-align=\"left center\"><span class=\"material-icons-outlined mr-8\" \nstyle=\"transform: rotate(90deg)\">sync_alt</span><h4>Aller-retour</h4></div><div layout=\"row\" \nlayout-align=\"left center\"><span class=\"material-icons-outlined pr-16 red-fg\">place</span><div class=\"p-8\"><h4 \nng-if=\"Note.AdresseArriveeType==\'manuelle\'\">{{Note.AdresseArrivee}}</h4><h4 \nng-if=\"Note.AdresseArriveeType==\'personnelle\'\">\n{{Note.LabelMonAdresseArrivee.Adresse}} {{Note.LabelMonAdresseArrivee.Ville.CodePostal}} {{Note.LabelMonAdresseArrivee.Ville.NomVille}} ({{Note.LabelMonAdresseArrivee.NomAdresse}})\n</h4><h4 ng-if=\"Note.AdresseArriveeType==\'contact\'\">\n{{Note.LabelClientArrivee.Adresse}} {{Note.LabelClientArrivee.Ville.CodePostal}} {{Note.LabelClientArrivee.Ville.NomVille}} ({{Note.LabelClientArrivee.NomAdresse}})\n</h4></div></div></div></div><p \nng-if=\"Note.Type==\'Métro\' || Note.Type==\'Avion\' || Note.Type==\'Bus\' || Note.Type==\'Taxi\' || Note.Type==\'Train\' || Note.Type==\'Hôtel\' || Note.Type==\'Restaurant midi\' || Note.Type==\'Restaurant soir\'\">\n</p><h3 ng-if=\"Note.ContactsResponsablesLabel.length > 0\" class=\"mb-0\">Contact(s) :</h3><ul \nng-if=\"Note.ContactsResponsablesLabel.length > 0\"><li \nng-repeat=\"(key, ContactsResponsablesLabel) in Note.ContactsResponsablesLabel track by $index\">\n{{ContactsResponsablesLabel.Prenom}} {{ContactsResponsablesLabel.Nom}} ({{ContactsResponsablesLabel.Fonction}} chez {{ContactsResponsablesLabel.RaisonSocial}})\n</li></ul><p></p><p \nng-if=\"Note.Type==\'Métro\' || Note.Type==\'Avion\' || Note.Type==\'Bus\' || Note.Type==\'Taxi\' || Note.Type==\'Train\' || Note.Type==\'Hôtel\' || Note.Type==\'Restaurant midi\' || Note.Type==\'Restaurant soir\'\">\n</p><h3 ng-if=\"Note.EmployesLabel.length > 0\" class=\"mb-0\">Invité(s) interne :</h3><ul \nng-if=\"Note.EmployesLabel.length > 0\"><li ng-repeat=\"(key, EmployesLabel) in Note.EmployesLabel track by $index\">\n{{EmployesLabel.Prenom}} {{EmployesLabel.Nom}}</li></ul><p></p><p \nng-if=\"Note.Type==\'Hôtel\' || Note.Type==\'Restaurant midi\' || Note.Type==\'Restaurant soir\'\"></p><h3 \nng-if=\"Note.InvitesExterne.length > 0\" class=\"mb-0\">Invité(s) externe :</h3><ul ng-if=\"Note.InvitesExterne.length > 0\">\n<li ng-repeat=\"(key, InvitesExterne) in Note.InvitesExterne track by $index\">\n{{InvitesExterne.nom}} ({{InvitesExterne.societe}})</li></ul><p></p><h3 ng-if=\"Note.Justificatifs.length > 0\" \nclass=\"mb-0\">Justificatif(s) :</h3><ul ng-if=\"Note.Justificatifs.length > 0\"><li \nng-repeat=\"(key, Justificatif) in Note.Justificatifs track by $index\"><a \nhref=\"/datas/files/frais/{{Justificatif.file}}\" target=\"_blank\">{{Justificatif.name}}</a></li></ul></div><md-menu \nclass=\"md-secondary\" ng-if=\"id == vm.Listefrais.IDEmploye && vm.Listefrais.Statut != \'Remboursée\'\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.editerNote($event, Note)\">Modifier\n</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=\"vm.supprimerNote($event, Note)\">\nSupprimer définitivement</md-button></md-menu-item></md-menu-content></md-menu></md-list-item><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"!vm.Listefrais || vm.Listefrais.Notes.length <= 0\"><p>\nAucune dépense pour le moment...</p></md-list-item></md-list></div></div></div></div>");
$templateCache.put("app/main/collaborateurs/frais/liste/frais.html","<div id=\"colabfrais\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start start\" \nlayout-align=\"space-between center\"><div class=\"white-fg pr-32\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"material-icons-outlined s28\">receipt\n</md-icon><span class=\"ml-10\">Frais</span></div><div class=\"notification-count secondary-text\"><span>\n{{vm.recordsTotal}} frais</span></div></div><div><md-button class=\"md-raised\" ng-click=\"vm.ajouterFrais()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><span>Ajouter</span></md-button><md-button class=\"md-raised\" \nng-click=\"vm.exportFrais($event, \'select\')\"><md-icon class=\"material-icons-outlined\">file_download</md-icon>\nExporter la sélection</md-button></div></div><div layout=\"row\" flex layout-align=\"space-between \"><div \nclass=\"content-card\" flex=\"100\" layout=\"column\" flex><div class=\"content-card main scrollable\" flex=\"100\" \nlayout=\"column\" flex><table class=\"dataTable dataTableColabFrais row-border hover\" datatable \ndt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"></table></div></div></div></div></div>");
$templateCache.put("app/main/commandes/cdc/dialogs/cdc-dialog.html","<md-dialog class=\"cdc-dialog\" flex=\"80\"><form name=\"cdcForm\" class=\"md-inline-form\" novalidate><md-dialog-content \nms-scroll><span class=\"md-title\">Edition d\'un bloc de cahier des charges</span><p></p><div layout=\"row\" class=\"mb-16\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Etat</label><md-select ng-model=\"vm.Bloc.Actif\" required \nname=\"Actif\"><md-option ng-value=\"1\">Activé</md-option><md-option ng-value=\"0\">Désactivé</md-option></md-select><div \nng-messages=\"cdcForm[\'Actif\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" class=\"mb-16\"><md-input-container md-no-float flex><label>Titre</label>\n<input name=\"Titre\" ng-model=\"vm.Bloc.Titre\" required><div ng-messages=\"cdcForm[\'Titre\'].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" class=\"mb-16\">\n<md-input-container md-no-float flex><textarea aria-label=\"Description du produit\" ui-tinymce=\"tinymceOptions\" \nng-model=\"vm.Bloc.Bloc\" rows=\"5\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button>\n<md-button type=\"submit\" ng-click=\"vm.saveBloc()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"cdcForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/commandes/commande/trees/products-tree2.html","<section ng-show=\"value.Produits\"><md-divider></md-divider><md-subheader class=\"md-primary blue-grey-50-bg\"><h2 \nstyle=\"cursor:\'cursor\'\">{{indent}} <small style=\"float:right\">{{value.Produits.length}} Produit(s)</small></h2>\n</md-subheader><md-list ng-show=\"value.Produits\"><md-list-item class=\"md-2-line md-long-text white-bg mt-0 mb-0\" \nstyle=\"border-bottom:1px solid #eceff1\" ng-if=\"selectproduit.AchatSeul\" ng-repeat=\"selectproduit in value.Produits\" \nng-click=\"vm.changeProduit(selectproduit, selectproduit.NbrSousProduits)\"><div class=\"md-list-item-text pb-5\" \nlayout=\"column\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div><strong class=\"grey-900-fg\">\n{{selectproduit.Produit}}</strong><p ng-bind-html=\"selectproduit.NoteCommande\">\n{{ selectproduit.NoteCommande | htmlToPlaintext }}</p></div><div flex=\"40\" layout=\"column\" layout-align=\"end end\">\n<strong ng-if=\"selectproduit.ModePrixVente == \'fixe\'\" class=\"light-blue-900-fg\">\n{{selectproduit.PrixVenteHT | currency:\'\'}} €</strong><p ng-if=\"selectproduit.ModePrixVente == \'pourcent\'\" \nclass=\"brown-900-fg text-right\">\n{{selectproduit.PourcentageVentePrixHTAutreProduit}} % du budget de {{selectproduit.ProduitReference}}<br><small>\n(min {{selectproduit.PrixVenteHT | currency:\'\'}} €)</small></p><strong \nng-if=\"selectproduit.ModePrixVente == \'sur-mesure\'\" class=\"deep-orange-900-fg\">Budget à définir</strong><p \nclass=\"mb-8\" \nng-if=\"selectproduit.Renouvellement>0 || selectproduit.PrixSpecifiques.length>0 || selectproduit.Reconduction\"><span \nng-if=\"selectproduit.Renouvellement>0\" class=\"orange-100-bg font-size-10 grey-900-fg p-5 ng-bindin brad-16\">\nEngagement sur {{selectproduit.Renouvellement}} mois</span> <span ng-if=\"selectproduit.PrixSpecifiques.length>0\" \nclass=\"green-100-bg font-size-10 grey-900-fg p-5 ng-bindin brad-16 ml-5\">Prix dégressifs</span> <span \nng-if=\"selectproduit.Reconduction\" class=\"red-100-bg font-size-10 grey-900-fg p-5 ng-bindin brad-16 ml-5\">\nReconduction automatique</span></p></div></div></div></md-list-item></md-list></section><div \nng-repeat=\"item in value.SousCategories\" ng-include=\"\'app/main/commandes/commande/trees/products-tree2.html\'\" \nonload=\"value=item; indent= indent + \' > \' + value.Categorie\"></div>");
$templateCache.put("app/main/commandes/commande/trees/products-tree_old.html","<md-optgroup label=\"{{indent}}\" ng-show=\"value.Produits\"><md-option \nng-repeat=\"selectproduit in value.Produits | filter:searchTerm\" ng-value=\"{{selectproduit.IDProduit}}\" \nng-click=\"vm.changeProduit(produit,selectproduit, selectproduit.NbrSousProduits)\">\n{{selectproduit.Produit}} - {{selectproduit.PrixVenteHT | currency:\'\'}} €</md-option></md-optgroup><div \nng-repeat=\"item in value.SousCategories\" ng-include=\"\'app/main/commandes/commande/trees/products-tree.html\'\" \nonload=\"value=item; indent= indent + \' > \' + value.Categorie\"></div>");
$templateCache.put("app/main/commandes/commande/dialogs/devis-dialog.html","<md-dialog class=\"devis-dialog\" aria-label=\"Devis\"><form><md-dialog-content class=\"pb-0\"><span \nclass=\"md-title ng-binding\">Que souhaitez-vous comme option sur votre devis ?</span><div \nclass=\"md-dialog-content-body mt-24\"><div flex=\"100\" ng-repeat=\"item in items\"><md-checkbox \nng-checked=\"exists(item, selected)\" aria-label=\"item\" ng-click=\"toggle(item, selected)\"><span ng-bind-html=\"item\">\n</span></md-checkbox></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">\nAnnuler</md-button><md-button class=\"md-accent\" ng-click=\"answer(selected)\">Générer le devis</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/commandes/commande/dialogs/facture-dialog.html","<md-dialog class=\"facturation-dialog\" aria-label=\"Facturation\"><form name=\"factureCommandeForm\"><md-dialog-content \nclass=\"pb-0\"><span class=\"md-title ng-binding\">Souhaitez-vous facturer cette commande ?</span><p><strong \nclass=\"red-800-fg\">Une fois facturée, cette commande ne pourra plus être modifiée.</strong></p><md-divider \nstyle=\"margin: 0px -23px\"></md-divider><md-list><md-subheader class=\"md-no-sticky\" style=\"padding:0\">\nProduit(s) de la commande concerné(s) par une date de fin</md-subheader><div \nng-repeat=\"produit in produit_a_renouveler\"><md-list-item class=\"secondary-button-padding\" style=\"padding:0\"><p \nclass=\"font-size-14\">{{produit.Produit}}</p><span \nclass=\"tag p-5 pr-8 pl-8 brad-16 ml-32 font-size-12 md-blue-700-bg white-fg md-secondary\">\n{{produit.Renouvellement}} mois</span></md-list-item></div></md-list><md-divider style=\"margin: 0px -23px\">\n</md-divider><p><strong>Quelle sera la date de renouvellement/fin du contrat : </strong></p><div layout=\"row\">\n<md-input-container flex=\"50\" class=\"m-0\"><md-datepicker ng-model=\"result\" required md-current-view=\"year\" \nname=\"DateRenouvellement\" md-min-date=\"date\" md-open-on-focus md-placeholder=\"Pas de renouvellement\"></md-datepicker>\n<small>Saisir la date la plus courte</small><div ng-messages=\"factureCommandeForm.DateRenouvellement.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\" ng-disabled=\"vm.showSpinner\">Annuler</md-button>\n<md-button ng-click=\"answer(result)\" class=\"md-warn\" ng-disabled=\"factureCommandeForm.$invalid || vm.showSpinner\"><span\n ng-show=\"!vm.showSpinner\">Générer la facture</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog><style>\n.md-datepicker-button {\r\n	display: none;\r\n}\r\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon .md-input-message-animation{margin-left:0}\r\n._md-datepicker-floating-label > md-datepicker .md-datepicker-input-container{width:100%}\r\n._md-datepicker-floating-label > md-datepicker .md-datepicker-input-container{margin:0}\r\n.md-subheader .md-subheader-inner {padding: 16px 0;font-weight: 600;color: #1e293b;}\n</style>");
$templateCache.put("app/main/commandes/commande/dialogs/iban-dialog.html","<md-dialog class=\"paiement-dialog\" flex=\"80\"><form name=\"ibanForm\" class=\"md-inline-form\" novalidate><md-toolbar \nng-hide=\"vm.addIBAN\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2>\nSélectionner l\'IBAN associé à cette commande</h2></div></md-toolbar><div ng-hide=\"vm.addIBAN\"><md-list-item \nclass=\"secondary-button-padding md-3-line md-long-text mt-0 mb-0\" ng-click=\"vm.selectIBAN(IBAN)\" \nng-repeat=\"IBAN in vm.IBAN track by $index\"><div class=\"md-list-item-text pt-16 pb-16\"><p><strong>Date création : \n</strong>{{IBAN.DateCreation| date : format : shortDate}}</p><p><strong>IBAN client : </strong>{{IBAN.IBAN}}</p><p>\n<strong>BIC : </strong>{{IBAN.BIC}}</p><p><strong>Domiciliation : </strong>{{IBAN.Domiciliation}}</p><p><strong>\nTitulaire : </strong>{{IBAN.Titulaire}}</p></div><md-button class=\"md-secondary\" ng-click=\"vm.selectIBAN(IBAN)\">\nSélectionner</md-button><md-divider ng-hide=\"$last\"></md-divider></md-list-item></div><md-dialog-content ms-scroll \nng-show=\"vm.addIBAN\" class=\"pb-32\"><span class=\"md-title\">Ajouter un nouvel IBAN</span><p></p><div layout=\"row\">\n<md-input-container md-no-float flex><label>IBAN</label><input ng-model=\"vm.newIBAN.IBAN\" name=\"IBAN\" \nng-pattern=\"/^([A-Z]{2}[ \\-]?[0-9]{2})(?=(?:[ \\-]?[A-Z0-9]){9,30}$)((?:[ \\-]?[A-Z0-9]{3,5}){2,7})([ \\-]?[A-Z0-9]{1,3})?$/\" \nrequired><div ng-messages=\"ibanForm.IBAN.$error\"><div ng-message=\"pattern\">L\'IBAN saisie est invalide</div><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>BIC</label><input ng-model=\"vm.newIBAN.BIC\" name=\"BIC\" \nng-pattern=\"/([a-zA-Z]{4})([a-zA-Z]{2})(([2-9a-zA-Z]{1})([0-9a-np-zA-NP-Z]{1}))((([0-9a-wy-zA-WY-Z]{1})([0-9a-zA-Z]{2}))|([xX]{3})|)/\" \nrequired><div ng-messages=\"ibanForm.BIC.$error\"><div ng-message=\"pattern\">Le BIC saisie est invalide</div><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>Domiciliation</label><input name=\"Domiciliation\" \nng-model=\"vm.newIBAN.Domiciliation\"></md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex>\n<label>Titulaire du compte</label><input name=\"Titulaire\" ng-model=\"vm.newIBAN.Titulaire\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" \nng-hide=\"vm.addIBAN && vm.IBAN.length\">Annuler</md-button><md-button aria-label=\"Retour\" class=\"md-raised\" \nng-click=\"vm.addIBAN=0\" ng-show=\"vm.addIBAN && vm.IBAN.length\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\nRetour à la liste</md-button><md-button ng-click=\"vm.addIBAN=1\" class=\"md-raised\" ng-hide=\"vm.addIBAN\">Ajouter un IBAN\n</md-button><md-button type=\"submit\" ng-click=\"vm.saveIBAN()\" ng-show=\"vm.addIBAN\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"ibanForm.$invalid\" aria-label=\"Appliquer\"><span \nng-show=\"!vm.showSpinner\">Enregistrer l\'IBAN</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/commandes/commande/dialogs/logs-dialog.html","<md-dialog class=\"logs-dialog\" flex=\"80\" style=\"max-width: 500px;max-height: 800px\"><form name=\"ibanForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h2>Historique de la commande {{vm.commande.NumeroCommande}}</h2></div>\n</md-toolbar><md-dialog-content ms-scroll class=\"pt-0 pb-0 pl-0 pr-0\"><md-list class=\"p-0\"><md-list-item \nclass=\"md-long-text height-120 border-bottom pl-16 pr-16\" ng-repeat=\"log in vm.commande.logs track by $index\"><div \nlayout=\"column\" flex><div layout=\"row\" flex layout-align=\"space-between center\"><h4 \nclass=\"font-weight-500 m-0 line-height-24\">{{log.Utilisateur}}<md-icon ng-if=\"log.Type==\'danger\'\" \nclass=\"md-warn mr-16 material-icons-outlined ml-8 s18\">report_problem</md-icon><md-icon ng-if=\"log.Type==\'warning\'\" \nclass=\"amber-500-fg mr-16 material-icons-outlined ml-8 s18\">report_problem</md-icon><md-icon ng-if=\"log.Type==\'info\'\" \nclass=\"md-accent mr-16 material-icons-outlined ml-8 s18\">info</md-icon><md-icon ng-if=\"log.Type==\'success\'\" \nclass=\"green-800-fg mr-16 material-icons-outlined ml-8 s18\">check_circle</md-icon></h4><p \nclass=\"m-0 line-height-24 blue-grey-300-fg font-size-12\">{{convertDate(log.Date)}}</p></div><p \nclass=\"m-0 line-height-24 blue-grey-700-fg\"><strong class=\"md-subhead font-weight-600\">{{log.Titre}}</strong><br>\n{{log.Message}}</p></div></md-list-item></md-list></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeDialog();\">Fermer</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/commandes/commande/dialogs/options-dialog.html","<md-dialog class=\"produits-options-dialog\" flex=\"80\" ng-cloak><form name=\"produitForm\" class=\"md-inline-form\" \nnovalidate><md-dialog-content class=\"pl-0 pr-0\" ms-scroll><h1 class=\"md-title pl-24 pr-24\">Le produit <em \nclass=\"light-blue-900-fg\">{{vm.produit.Produit}}</em> à des options</h1><p></p><div layout=\"row\" layout-wrap flex><div \nflex=\"100\"><div flex-xs flex=\"50\" class=\"pl-24 pr-24\"><md-checkbox aria-label=\"Tout sélectionner\" \nng-checked=\"isChecked()\" md-indeterminate=\"isIndeterminate()\" ng-click=\"toggleAll()\"><span ng-if=\"isChecked()\">\nTout déselectionner</span> <span ng-if=\"!isChecked()\">Tout sélectionner</span></md-checkbox></div><md-divider>\n</md-divider></div><div class=\"{{exists(item, selected) ? \'line-checked\' :\'\'}}\" flex=\"100\" \nng-repeat=\"item in vm.produit.SousProduits track by $index\"><div layout=\"row\" layout-align=\"space-between center\" \nflex=\"100\" class=\"pl-24 pr-24\"><md-checkbox ng-checked=\"exists(item, selected)\" class=\"\" \nng-click=\"toggle(item, selected)\" flex=\"80\" layout=\"row\" layout-align=\"start start\"><strong>{{ item.Produit }} \n</strong><br><small ng-bind-html=\"item.NoteCommande\">{{ item.NoteCommande }}</small></md-checkbox><div flex=\"20\" \nflex-sm=\"40\" flex-xs=\"100\" layout=\"column\" layout-align=\"end end\"><strong ng-if=\"item.ModePrixVente == \'fixe\'\" \nclass=\"light-blue-900-fg\">{{item.PrixVenteHT | currency:\'\'}} €</strong><p ng-if=\"item.ModePrixVente == \'pourcent\'\" \nclass=\"brown-900-fg text-right mb-0\"><span ng-if=\"vm.produit.IDProduit == item.PourcentageIDProduit\">\n{{item.PourcentageVentePrixHTAutreProduit}} % du budget</span> <span \nng-if=\"vm.produit.IDProduit != item.PourcentageIDProduit\">\n{{item.PourcentageVentePrixHTAutreProduit}} % du budget de {{item.ProduitReference}}</span><br><small>\n(min {{item.PrixVenteHT | currency:\'\'}} €)</small></p><strong ng-if=\"item.ModePrixVente == \'sur-mesure\'\" \nclass=\"deep-orange-900-fg\">Budget à définir</strong><p class=\"mb-24 mt-5\" \nng-if=\"item.Renouvellement>0 || item.PrixSpecifiques.length>0 || item.Reconduction\"><span \nng-if=\"item.Renouvellement>0\" class=\"orange-100-bg font-size-10 grey-900-fg p-5 ng-bindin brad-16\">\nEngagement sur {{item.Renouvellement}} mois</span> <span ng-if=\"item.PrixSpecifiques.length>0\" \nclass=\"green-100-bg font-size-10 grey-900-fg p-5 ng-bindin brad-16 ml-5\">Prix dégressifs</span> <span \nng-if=\"item.Reconduction\" class=\"red-100-bg font-size-10 grey-900-fg p-5 ng-bindin brad-16 ml-5\">\nReconduction automatique</span></p></div></div><md-divider></md-divider></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"vm.saveProduit()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"produitForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\">\n<span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form><style>\nmd-checkbox {\r\n    margin-top: 10px !important;\r\n}</style></md-dialog>");
$templateCache.put("app/main/commandes/commande/dialogs/paiement-dialog.html","<md-dialog class=\"paiement-dialog\" flex=\"80\"><form name=\"paiementForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content ms-scroll><span class=\"md-title\">Ajouter un mode de de paiement</span><p></p><div layout=\"row\">\n<md-input-container md-no-float flex><label>Type de paiement</label><md-select ng-model=\"vm.paiement.Type\" name=\"Type\" \nplaceholder=\"Mode de paiement\" required><md-option value=\"Acompte\" \nng-click=\"vm.paiement.DateMode=\'signature\';vm.paiement.Mode=\'\';\">Acompte : <small>\néchéancier avec date ou étape d\'avancement (<u>déclenche une facture d\'acompte</u>)</small></md-option><md-option \nvalue=\"Mensualité\" ng-click=\"vm.paiement.DateMode=\'spécifique\'; vm.paiement.Mode=\'Prélèvement\'; \">Mensualités : <small>\npaiement sur plusieurs mois à date fixe</small></md-option><md-option value=\"Financement\" \nng-click=\"vm.paiement.DateMode=\'facturation\';vm.paiement.Mode=\'Grenke\';\">Financement : <small>\npaiement mensuel via l\'organisme Grenke</small></md-option><md-option value=\"Solde\" \nng-click=\"vm.paiement.DateMode=\'facturation\';vm.paiement.Mode=\'\';\">Solde : <small>\npaiement de la totalité des montants restants</small></md-option></md-select><div \nng-messages=\"paiementForm.Type.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" ng-show=\"vm.paiement.Type\"><md-input-container md-no-float flex><label>\nMode de paiement</label><md-select ng-model=\"vm.paiement.Mode\" name=\"Mode\" placeholder=\"Mode de paiement\" required>\n<md-option value=\"Prélèvement\" ng-disabled=\"vm.paiement.Type==\'Financement\'\">Prélèvement</md-option><md-option \nvalue=\"Grenke\" ng-disabled=\"vm.paiement.Type!=\'Financement\'\">Prélèvement par l\'organisme Grenke</md-option><md-option \nvalue=\"Virement\" ng-disabled=\"vm.paiement.Type==\'Mensualité\' || vm.paiement.Type==\'Financement\'\">Virement</md-option>\n<md-option value=\"Virement / Chèque\" ng-disabled=\"vm.paiement.Type==\'Mensualité\' || vm.paiement.Type==\'Financement\'\">\nVirement / Chèque</md-option><md-option ng-show=\"0\" value=\"Virement automatique\">Virement automatique</md-option>\n</md-select><div ng-messages=\"paiementForm.Mode.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" \nng-show=\"vm.paiement.Mode && (vm.paiement.Type==\'Mensualité\'  || vm.paiement.Type==\'Financement\')\"><md-input-container \nmd-no-float flex><label>Nombre de mensualité</label><md-select ng-model=\"vm.paiement.NbrMensualites\" \nname=\"NbrMensualites\" placeholder=\"Nombre de mensualité\" \nng-required=\"vm.paiement.Type==\'Mensualité\' || vm.paiement.Type==\'Financement\'\"><md-option ng-value=\"2\" \nng-hide=\"vm.paiement.Type==\'Financement\'\">2</md-option><md-option ng-value=\"3\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\">3</md-option><md-option \nng-value=\"4\" ng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\">4</md-option><md-option ng-value=\"5\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\">5</md-option><md-option \nng-value=\"6\" ng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\">6</md-option><md-option ng-value=\"7\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\">7</md-option><md-option ng-value=\"8\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\">8</md-option><md-option ng-value=\"9\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\">9</md-option><md-option \nng-value=\"10\" ng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\">10</md-option><md-option ng-value=\"11\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\" \nng-hide=\"vm.paiement.Type==\'Financement\'\" ng-hide=\"vm.paiement.Type==\'Financement\'\">11</md-option><md-option \nng-value=\"12\" ng-hide=\"vm.paiement.Type==\'Financement\'\">12</md-option><md-option ng-value=\"24\" \nng-show=\"vm.paiement.Type==\'Financement\'\">24</md-option><md-option ng-value=\"36\" \nng-show=\"vm.paiement.Type==\'Financement\'\">36</md-option><md-option ng-value=\"48\" \nng-show=\"vm.paiement.Type==\'Financement\'\">48</md-option></md-select><div \nng-messages=\"paiementForm.NbrMensualites.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.paiement.Type==\'Financement\'\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Montant HT facturé à Grenke</label><input \nng-model=\"vm.paiement.MontantGrenkeHT\" type=\"number\" name=\"MontantGrenkeHT\" min=\"0.01\" step=\"0.01\" required><md-icon \nmd-font-icon=\"icon-currency-eur\"></md-icon><div ng-messages=\"paiementForm.MontantGrenkeHT.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"min\">Le montant doit être supérieur à zéro</div>\n</div><div class=\"md-caption secondary-text\">Montant hors taxes communiqué par Grenke.</div></md-input-container></div>\n<div layout=\"row\" \nng-show=\"vm.paiement.Mode && vm.paiement.Type!=\'Solde\' && vm.paiement.Type!=\'Mensualité\' && vm.paiement.Type!=\'Financement\'\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Pourcentage</label><input ng-model=\"vm.paiement.Percent\" \nmin=\"0\" name=\"Percent\" max=\"100\" ng-change=\"vm.percenttoeuro()\" type=\"number\" \nng-required=\"vm.paiement.Type!=\'Solde\' && vm.paiement.Type!=\'Financement\' && vm.paiement.Type!=\'Mensualité\'\"><md-icon \nmd-font-icon=\"icon-percent\"></md-icon><div ng-messages=\"paiementForm.Percent.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>\nMontant</label><input ng-model=\"vm.paiement.Montant\" type=\"number\" name=\"Montant\" ng-change=\"vm.eurotoppercent()\" \nng-required=\"vm.paiement.Type!=\'Solde\' && vm.paiement.Type!=\'Financement\' && vm.paiement.Type!=\'Mensualité\'\"><md-icon \nmd-font-icon=\"icon-currency-eur\"></md-icon><div ng-messages=\"paiementForm.Montant.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"column\" \nng-show=\"vm.paiement.Type && vm.paiement.Mode\"><md-input-container class=\"md-block mt-0\" md-no-float flex>\n<md-radio-group ng-model=\"vm.paiement.DateMode\" layout=\"column\" flex><div flex layout=\"row\" layout-padding \nlayout-align=\"start\" class=\"pl-0 pr-0\" \nng-hide=\"vm.paiement.Type==\'Mensualité\' || vm.paiement.Type==\'Solde\' || vm.paiement.Type==\'Financement\'\">\n<md-radio-button value=\"signature\" ng-disabled=\"vm.paiement.Type==\'Mensualité\' || vm.paiement.Type==\'Solde\'\">\nPaiement à la signature du devis</md-radio-button></div><div flex layout=\"row\" layout-padding \nlayout-align=\"space-between center\" class=\"p-0\" \nng-hide=\"vm.paiement.Type==\'Mensualité\' || vm.paiement.Type==\'Echéance\' || vm.paiement.Type==\'Financement\'\">\n<md-radio-button value=\"étape\" ng-disabled=\"vm.paiement.Type==\'Mensualité\'|| vm.paiement.Type==\'Echéance\'\">\nPaiement à une étape spécifique</md-radio-button><md-input-container flex=\"50\" class=\"p-0\"><input \nng-model=\"vm.paiement.Etape\" name=\"Etape\" placeholder=\"Etape de paiement\" ng-required=\"vm.paiement.DateMode==\'étape\'\" \nng-disabled=\"vm.paiement.DateMode!=\'étape\'\" ng-disabled=\"vm.paiement.DateMode!=\'étape\'\"><div \nng-messages=\"paiementForm.Etape.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div flex layout=\"row\" layout-padding layout-align=\"start center\" class=\"mt-0 pl-0 pr-0\" \nng-hide=\"vm.paiement.Type==\'Mensualité\' || vm.paiement.Type==\'Acompte\'\"><md-radio-button value=\"facturation\" \nng-disabled=\"vm.paiement.Type==\'Mensualité\' || vm.paiement.Type==\'Acompte\'\">Paiement à la facturation</md-radio-button>\n</div><div flex layout=\"row\" layout-padding layout-align=\"space-between center\" class=\"p-0\" \nng-hide=\" vm.paiement.Type==\'Solde\' || vm.paiement.Type==\'Financement\'\"><md-radio-button value=\"spécifique\" \nng-disabled=\" vm.paiement.Type==\'Solde\'\">Paiement à une date spécifique</md-radio-button><md-input-container flex=\"50\" \nclass=\"p-0\"><md-datepicker ng-model=\"vm.paiement.DatePaiement\" name=\"DatePaiement\" md-open-on-focus \nmd-date-filter=\"vm.onlyDateAllow\" ng-disabled=\"vm.paiement.DateMode!=\'spécifique\'\" placeholder=\"Date de paiement\" \nmd-current-view=\"year\" ng-required=\"vm.paiement.DateMode==\'spécifique\'\" \nng-disabled=\"vm.paiement.DateMode!=\'spécifique\'\"><input md-open-on-focus></md-datepicker><div \nng-messages=\"paiementForm.DatePaiement.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div></md-radio-group></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"mt-16\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler\n</md-button><md-button type=\"submit\" ng-click=\"vm.savePaiement()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"paiementForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/commandes/commande/dialogs/plugin-dialog.html","<md-dialog class=\"produits-plugin-dialog\" flex=\"80\" ng-cloak><md-dialog-content class=\"pl-0 pr-0 pt-0\" ms-scroll><div \nclass=\"header md-accent-bg p-16\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.produit.Produit}}</div><md-switch ng-model=\"vm.produit.Parametres.ComplementDeCommande\" \nng-change=\"vm.calculatePrice()\" aria-label=\"Premiere Commande\" class=\"md-primary mb-0 mt-0\">\nComplément de commande : {{vm.produit.Parametres.ComplementDeCommande ? \"Oui\" : \"Non\"}}</md-switch></div><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h4\">\nNombre de combinaisons : {{vm.produit.Parametres.total.nbrRequetes}}</div><div class=\"h4\">\nNombre de localités : {{vm.produit.Parametres.total.nbrLocalites.regions.length +vm.produit.Parametres.total.nbrLocalites.departements.length + vm.produit.Parametres.total.nbrLocalites.veryhard.length + vm.produit.Parametres.total.nbrLocalites.challenging.length + vm.produit.Parametres.total.nbrLocalites.hard.length + vm.produit.Parametres.total.nbrLocalites.medium.length + vm.produit.Parametres.total.nbrLocalites.easy.length}}\n</div></div><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.produit.PrixVenteHT / vm.produit.Renouvellement | number:2}} € HT / mois</div><div class=\"h6\">\n{{vm.produit.PrixVenteHT}} € HT / {{vm.produit.Renouvellement}} mois</div></div></div></div><div layout=\"row\" \nlayout-wrap flex><form name=\"horizontalStepper\" ms-horizontal-stepper ng-submit=\"vm.sendForm()\" flex novalidate>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep1\" step=\"1\" step-title=\"\'Requêtes\'\" ng-show=\"!vm.createloader\"><div \nlayout=\"column\"><div flex=\"100\" layout=\"column\" class=\"summary-card\" \nng-repeat=\"service in vm.produit.Parametres.requetes track by $index\"><div class=\"summary-header\" layout=\"row\" \nlayout-align=\"space-between center\"><h3>Requêtes ciblées #{{$index + 1}}</h3><div><md-button class=\"md-icon-button\" \nng-click=\"vm.duplicateService(service)\"><md-icon class=\"material-icons-outlined\">content_copy</md-icon><md-tooltip \nmd-direction=\"top\">Dupliquer</md-tooltip></md-button><md-button class=\"md-icon-button md-warn\" \nng-show=\"vm.produit.Parametres.requetes.length>1\" \nng-click=\"vm.produit.Parametres.requetes.splice($index, 1); vm.updateRequetesCount()\"><md-icon \nclass=\"material-icons-outlined\">delete</md-icon><md-tooltip md-direction=\"top\">Supprimer</md-tooltip></md-button></div>\n</div><div layout=\"row\" class=\"request-summary\" ayout-align=\"space-between center\"><div flex=\"50\" layout=\"column\">\n<md-input-container flex class=\"mr-16\"><label>Produit / Service</label><input ng-model=\"service.service\" \nname=\"produitService{{$index}}\" type=\"text\" placeholder=\"Ex: Fenêtre, Portail, etc.\" required \nng-change=\"vm.updateRequetesCount()\"><div \nng-messages=\"horizontalStepper.horizontalStep1[\'produitService\' + $index].$error\" role=\"alert\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div flex=\"50\"><div \nlayout=\"column\" layout-align=\"start end\" layout-wrap><div layout=\"row\" layout-align=\"start start\" flex \nclass=\"action-row mb-0\" ng-repeat=\"action in service.action track by $index\"><md-input-container flex class=\"mb-0\">\n<label>Action / Prestation {{$index + 1}}</label><input ng-model=\"service.action[$index]\" \nname=\"produitAction{{$index}}\" type=\"text\" placeholder=\"Ex: Pose, Installation, etc.\" required \nng-change=\"vm.updateRequetesCount()\"><div \nng-messages=\"horizontalStepper.horizontalStep1[\'produitAction\' + $index].$error\" role=\"alert\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container><md-button \nclass=\"md-icon-button md-warn mt-16\" ng-click=\"service.action.splice($index, 1); vm.updateRequetesCount()\"><md-icon \nclass=\"material-icons-outlined\">delete</md-icon><md-tooltip md-direction=\"left\">Supprimer</md-tooltip></md-button>\n</div><div><md-button class=\"md-raised md-primary mt-16\" ng-click=\"service.action.push(\'\'); vm.updateRequetesCount()\">\n+ Ajouter une action/prestation</md-button></div></div></div></div><div class=\"summary-footer\"><strong>\nTotal : {{1 + service.action.length}} requête(s)</strong></div></div><div layout=\"row\" layout-align=\"start end\" \nclass=\"ml-16 mt-16\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.produit.Parametres.requetes.push({\'service\':null, \'action\':[]}); vm.updateRequetesCount()\">\n+ Ajouter un produit/service</md-button></div></div></ms-horizontal-stepper-step><ms-horizontal-stepper-step \nng-form=\"horizontalStep2\" step=\"2\" step-title=\"\'Localités\'\" ng-show=\"!vm.createloader\"><div layout=\"row\"><div \nlayout=\"column\" flex=\"40\" class=\"scrollable-column\"><div class=\"pr-16\"><div layout=\"row\" layout-wrap flex \nlayout-align=\"start center\"><div layout=\"column\" flex><md-radio-group ng-model=\"vm.zone\" name=\"zone\" \nng-change=\"vm.clearRayonIfLieu()\" layout=\"row\" class=\"mt-8\"><md-radio-button value=\"lieu\">Ville</md-radio-button>\n<md-radio-button value=\"rayon\">Rayon</md-radio-button><md-radio-button value=\"departement\">Département\n</md-radio-button><md-radio-button value=\"region\">Région</md-radio-button></md-radio-group><div layout=\"row\" \nclass=\"mt-16\" flex><md-input-container md-no-float flex class=\"mb-20 md-block\" ng-show=\"vm.zone == \'departement\'\">\n<label>Département</label><md-select ng-model=\"vm.departement\" name=\"departement\" \nmd-on-open=\"vm.openSelectSearch(\'#header-searchDepartement\')\" md-on-close=\"vm.clearSearchTerm()\" \nplaceholder=\"Choisir un département\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" \ntype=\"search\" placeholder=\"Chercher un département\" class=\"header-searchDepartement md-text\" \nid=\"header-searchDepartement\" md-autofocus ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"departement in vm.departements | filter:vm.departementFilter\" ng-value=\"departement\">\n{{departement.NomDepartement}} - {{departement.CodeDepartement}}</md-option></md-select></md-input-container>\n<md-input-container md-no-float flex class=\"mb-20 md-block\" ng-show=\"vm.zone == \'region\'\"><label>Région</label>\n<md-select ng-model=\"vm.region\" name=\"region\" md-on-open=\"vm.openSelectSearch(\'#header-searchRegion\')\" \nmd-on-close=\"vm.clearSearchTerm()\" placeholder=\"Choisir une région\"><md-select-header class=\"demo-select-header\"><input\n ng-model=\"vm.searchTerm\" type=\"search\" placeholder=\"Chercher une région\" class=\"header-searchRegion md-text\" \nid=\"header-searchRegion\" md-autofocus ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"Anciennes régions\"><md-option ng-repeat=\"regionAnciennes in vm.regions.Anciennes | filter:vm.regionFilter\" \nng-value=\"regionAnciennes\">{{regionAnciennes.NomRegion}}</md-option></md-optgroup><md-optgroup label=\"Régions\">\n<md-option ng-repeat=\"region in vm.regions.Actuelles | filter:vm.regionFilter\" ng-value=\"region\">{{region.NomRegion}}\n</md-option></md-optgroup></md-select></md-input-container><md-autocomplete flex \nng-show=\"vm.zone != \'departement\' && vm.zone != \'region\'\" class=\"mr-8\" md-no-cache=\"true\" md-selected-item=\"vm.ville\" \nmd-items=\"item in vm.querySearch(searchText)\" md-select-on-match=\"true\" md-search-text=\"searchText\" \nmd-autofocus=\"true\" md-min-length=\"3\" md-clear-button=\"true\" md-require-match=\"true\" md-floating-label=\"Ville\" \nmd-input-name=\"villes\" md-item-text=\"item.NomVille\"><md-item-template><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><span md-highlight-text=\"searchText\" md-highlight-flags=\"i\">\n{{item.CodePostal}} - {{item.NomVille}} </span><span style=\"text-align: right; flex: 0 0 auto\">\n{{item.Population | number:0}} hab.</span></div></md-item-template><md-not-found>Aucune localité trouvée pour <b>\n\"{{searchText}}\"</b>.</md-not-found></md-autocomplete><md-input-container md-no-float class=\"md-block\" flex=\"20\" \nng-show=\"vm.zone == \'rayon\'\"><input ng-model=\"vm.rayon\" value=\"10\" type=\"text\" aria-label=\"Rayon\" \nng-disabled=\"vm.zone !== \'rayon\'\"><md-icon class=\"\" style=\"display:inline-block\">km</md-icon></md-input-container>\n</div><div layout=\"row\" class=\"mb-16\" layout-align=\"space-between center\"><md-button ng-click=\"vm.addLocalites(false)\" \nclass=\"send-button md-raised ml-0\" aria-label=\"Exclure\"><md-icon class=\"material-icons-outlined\">remove</md-icon>\nExclure</md-button><md-button ng-click=\"vm.addLocalites(true)\" class=\"send-button md-raised md-accent mr-0\" \naria-label=\"Inclure\"><md-icon class=\"material-icons-outlined\">add</md-icon>Inclure</md-button></div></div></div><input \nng-model=\"vm.totalLocalites\" name=\"totalLocalites\" type=\"hidden\" required><table class=\"md-table\" \nng-if=\"vm.produit.Parametres.localites.length>0\"><thead><tr><th>Localités</th><th>Habitants</th><th><md-icon \nclass=\"material-icons-outlined md-warn\" ng-if=\"vm.produit.Parametres.localites.length>0\" \nng-click=\"vm.produit.Parametres.localites = []\">delete</md-icon></th></tr></thead><tbody><tr \nng-repeat-start=\"localite in vm.produit.Parametres.localites\"><td class=\"font-size-14\" \nng-if=\"!localite.NomDepartement && !localite.NomRegion\"><span \nng-click=\"$event.stopPropagation(); localite.rayon.distance > 0 && (localite.isExpanded = !localite.isExpanded)\" \nstyle=\"{{(localite.rayon.distance > 0) ? \'cursor: pointer;\' : \'\'}}\" layout=\"row\"><md-icon \nclass=\"material-icons-outlined\" flex=\"15\" ng-if=\"localite.rayon.distance>0\">\n{{ localite.isExpanded ? \'expand_less\' : \'expand_more\' }}</md-icon><div flex>\n{{localite.CodePostal}} - {{localite.NomVille}} <span ng-if=\"localite.inclus\">- Inclus</span> <span \nng-if=\"!localite.inclus\">- Exclus</span> <small ng-if=\"localite.rayon.distance>0\"><br>\nRayon de {{localite.rayon.distance}} km</small></div></span></td><td class=\"font-size-14\" \nng-if=\"localite.NomDepartement\"><span layout=\"row\"><div flex>\n{{localite.CodeDepartement}} - {{localite.NomDepartement}} <span ng-if=\"localite.inclus\">- Inclus</span> <span \nng-if=\"!localite.inclus\">- Exclus</span></div></span></td><td class=\"font-size-14\" ng-if=\"localite.NomRegion\"><span \nlayout=\"row\"><div flex>{{localite.CodeRegion}} - {{localite.NomRegion}} <span ng-if=\"localite.inclus\">- Inclus</span> \n<span ng-if=\"!localite.inclus\">- Exclus</span></div></span></td><td \nng-if=\"!localite.NomDepartement && !localite.NomRegion\">{{vm.getCumulativePopulation(localite) | thousandsSeparator}}\n</td><td ng-if=\"localite.NomDepartement || localite.NomRegion\">--</td><td><md-icon \nclass=\"material-icons-outlined md-warn\" ng-click=\"vm.removeLocalite(localite)\">delete</md-icon></td></tr><tr \nng-if=\"localite.isExpanded && localite.rayon.distance>0\" ng-repeat-end class=\"expanded\"><td colspan=\"3\" \nstyle=\"padding-left: 20px\"><ul><li ng-repeat=\"rayon in localite.rayon.villes\" class=\"font-size-14\">\n{{rayon.CodePostal.join(\", \")}} - {{rayon.NomVille}} ({{rayon.Population | thousandsSeparator}} hab.)</li></ul></td>\n</tr></tbody></table></div></div><div flex=\"60\" id=\"original-container\"><div id=\"map\" \nstyle=\"width: 100%; height: 800px\"></div></div></div></ms-horizontal-stepper-step><ms-horizontal-stepper-step \nng-form=\"horizontalStep3\" step=\"3\" step-title=\"\'Résumé\'\" ng-show=\"!vm.createloader\"><div layout=\"row\" layout-wrap><div \nflex=\"40\"><div layout=\"column\" class=\"summary-card\"><h2>Requêtes SEO ciblées</h2><div \nng-repeat=\"requete in vm.produit.Parametres.requetes\" class=\"request-summary\"><h3 class=\"mt-0\">{{requete.service}}</h3>\n<ul ng-if=\"requete.action.length > 0\"><li ng-repeat=\"action in requete.action\">{{action}}</li></ul></div><div \nclass=\"summary-footer\"><strong>Total : {{vm.produit.Parametres.total.nbrRequetes}} requêtes</strong></div></div></div>\n<div flex=\"60\"><div layout=\"column\" class=\"summary-card\"><h2 class=\"mb-0\">Zones géographiques ciblées</h2><ul \nclass=\"mt-0\"><li ng-if=\"vm.produit.Parametres.total.nbrLocalites.veryhard.length > 0\"><h3 class=\"deep-orange-fg mb-0\">\n{{vm.produit.Parametres.total.nbrLocalites.veryhard.length}} Très grandes villes (> 200 000 hab.) : {{vm.produit.Parametres.total.price.veryhard}} € HT / {{vm.produit.Renouvellement}} mois\n</h3><span class=\"font-size-14\" ng-if=\"!vm.showMore.veryhard\">\n{{vm.getLocaliteNames(vm.produit.Parametres.total.nbrLocalites.veryhard.slice(0, 5))}} <span \nng-if=\"vm.produit.Parametres.total.nbrLocalites.veryhard.length > 5\">... <a href=\"#\" \nng-click=\"vm.showMore.veryhard = true\">Lire la suite</a> </span></span><span class=\"font-size-14\" \nng-if=\"vm.showMore.veryhard\">{{vm.getLocaliteNames(vm.produit.Parametres.total.nbrLocalites.veryhard)}} <a href=\"#\" \nng-click=\"vm.showMore.veryhard = false\">Réduire</a></span></li><li \nng-if=\"vm.produit.Parametres.total.nbrLocalites.challenging.length > 0\"><h3 class=\"orange-fg mb-0\">\n{{vm.produit.Parametres.total.nbrLocalites.challenging.length}} Grandes villes (> 100 000 hab.) : {{vm.produit.Parametres.total.price.challenging}} € HT / {{vm.produit.Renouvellement}} mois\n</h3><span class=\"font-size-14\" ng-if=\"!vm.showMore.challenging\">\n{{vm.getLocaliteNames(vm.produit.Parametres.total.nbrLocalites.challenging.slice(0, 5))}} <span \nng-if=\"vm.produit.Parametres.total.nbrLocalites.challenging.length > 5\">... <a href=\"#\" \nng-click=\"vm.showMore.challenging = true\">Lire la suite</a> </span></span><span class=\"font-size-14\" \nng-if=\"vm.showMore.challenging\">{{vm.getLocaliteNames(vm.produit.Parametres.total.nbrLocalites.challenging)}} <a \nhref=\"#\" ng-click=\"vm.showMore.challenging = false\">Réduire</a></span></li><li \nng-if=\"vm.produit.Parametres.total.nbrLocalites.hard.length > 0\"><h3 class=\"amber-fg mb-0\">\n{{vm.produit.Parametres.total.nbrLocalites.hard.length}} Villes moyennes (> 20 000 hab.) : {{vm.produit.Parametres.total.price.hard}} € HT / {{vm.produit.Renouvellement}} mois\n</h3><span class=\"font-size-14\" ng-if=\"!vm.showMore.hard\">\n{{vm.getLocaliteNames(vm.produit.Parametres.total.nbrLocalites.hard.slice(0, 5))}} <span \nng-if=\"vm.produit.Parametres.total.nbrLocalites.hard.length > 5\">... <a href=\"#\" ng-click=\"vm.showMore.hard = true\">\nLire la suite</a> </span></span><span class=\"font-size-14\" ng-if=\"vm.showMore.hard\">\n{{vm.getLocaliteNames(vm.produit.Parametres.total.nbrLocalites.hard)}} <a href=\"#\" ng-click=\"vm.showMore.hard = false\">\nRéduire</a></span></li><li ng-if=\"vm.produit.Parametres.total.nbrLocalites.medium.length > 0\"><h3 class=\"teal-fg mb-0\">\n{{vm.produit.Parametres.total.nbrLocalites.medium.length}} Petites villes (> 5 000 hab.) : {{vm.produit.Parametres.total.price.medium}} € HT / {{vm.produit.Renouvellement}} mois\n</h3><span class=\"font-size-14\" ng-if=\"!vm.showMore.medium\">\n{{vm.getLocaliteNames(vm.produit.Parametres.total.nbrLocalites.medium.slice(0, 5))}} <span \nng-if=\"vm.produit.Parametres.total.nbrLocalites.medium.length > 5\">... <a href=\"#\" \nng-click=\"vm.showMore.medium = true\">Lire la suite</a> </span></span><span class=\"font-size-14\" \nng-if=\"vm.showMore.medium\">{{vm.getLocaliteNames(vm.produit.Parametres.total.nbrLocalites.medium)}} <a href=\"#\" \nng-click=\"vm.showMore.medium = false\">Réduire</a></span></li><li \nng-if=\"vm.produit.Parametres.total.nbrLocalites.easy.length > 0\"><h3 class=\"green-fg mb-0\">\n{{vm.produit.Parametres.total.nbrLocalites.easy.length}} Villages (≤ 5 000 hab.) : {{vm.produit.Parametres.total.price.easy}} € HT / {{vm.produit.Renouvellement}} mois\n</h3><span class=\"font-size-14\" ng-if=\"!vm.showMore.easy\">\n{{vm.getLocaliteNames(vm.produit.Parametres.total.nbrLocalites.easy.slice(0, 5))}} <span \nng-if=\"vm.produit.Parametres.total.nbrLocalites.easy.length > 5\">... <a href=\"#\" ng-click=\"vm.showMore.easy = true\">\nLire la suite</a> </span></span><span class=\"font-size-14\" ng-if=\"vm.showMore.easy\">\n{{vm.getLocaliteNames(vm.produit.Parametres.total.nbrLocalites.easy)}} <a href=\"#\" ng-click=\"vm.showMore.easy = false\">\nRéduire</a></span></li><li ng-if=\"vm.produit.Parametres.total.nbrLocalites.regions.length > 0\"><h3 \nclass=\"accent-fg mb-0\">\n{{vm.produit.Parametres.total.nbrLocalites.regions.length}} Régions : {{vm.produit.Parametres.total.price.regions}} € HT / {{vm.produit.Renouvellement}} mois\n</h3><span class=\"font-size-14\" ng-if=\"!vm.showMore.regions\">\n{{vm.getRegionsNames(vm.produit.Parametres.total.nbrLocalites.regions.slice(0, 5))}} <span \nng-if=\"vm.produit.Parametres.total.nbrLocalites.departements.length > 5\">... <a href=\"#\" \nng-click=\"vm.showMore.regions = true\">Lire la suite</a> </span></span><span class=\"font-size-14\" \nng-if=\"vm.showMore.regions\">{{vm.getRegionsNames(vm.produit.Parametres.total.nbrLocalites.regions)}} <a href=\"#\" \nng-click=\"vm.showMore.regions = false\">Réduire</a></span></li><li \nng-if=\"vm.produit.Parametres.total.nbrLocalites.departements.length > 0\"><h3 class=\"accent-fg mb-0\">\n{{vm.produit.Parametres.total.nbrLocalites.departements.length}} Départements : {{vm.produit.Parametres.total.price.departements}} € HT / {{vm.produit.Renouvellement}} mois\n</h3><span class=\"font-size-14\" ng-if=\"!vm.showMore.departements\">\n{{vm.getDepartementsNames(vm.produit.Parametres.total.nbrLocalites.departements.slice(0, 5))}} <span \nng-if=\"vm.produit.Parametres.total.nbrLocalites.departements.length > 5\">... <a href=\"#\" \nng-click=\"vm.showMore.departements = true\">Lire la suite</a> </span></span><span class=\"font-size-14\" \nng-if=\"vm.showMore.departements\">{{vm.getDepartementsNames(vm.produit.Parametres.total.nbrLocalites.departements)}} <a \nhref=\"#\" ng-click=\"vm.showMore.departements = false\">Réduire</a></span></li></ul><div class=\"summary-footer\"><strong>\nPopulation ciblée : {{vm.produit.Parametres.total.nbrPopulation | number}} habitants</strong> <small>\n(hors noms départements/régions)</small></div></div></div></div></ms-horizontal-stepper-step><div id=\"clone-container\">\n</div><div class=\"createloader\" ng-show=\"vm.createloader\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><div>Génération des rendus...</div></div></form>\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/commandes/commande/dialogs/produits-dialog.html","<md-dialog class=\"produits-dialog\" flex=\"80\"><form name=\"produitForm\" class=\"md-inline-form\" novalidate><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>Sélectionnez un produit à ajouter</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"{{selectCategorie.Categorie}}\" ng-repeat=\"selectCategorie in vm.listeProduits.SousCategories\"><md-content \nstyle=\"height: 75vh\" class=\"grey-50-bg\"><div flex ng-include=\"\'app/main/commandes/commande/trees/products-tree2.html\'\" \nonload=\"value=selectCategorie; indent=selectCategorie.Categorie\"></div></md-content></md-tab><md-tab label=\"Autres\">\n<md-content style=\"height: 75vh\" class=\"grey-50-bg\"><section><md-list><md-list-item ng-click=\"vm.changeProduit(0,0)\">\n<strong class=\"grey-900-fg\">Ajouter un produit personnalisé</strong></md-list-item></md-list></section></md-content>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"\" ng-click=\"vm.closeDialog()\">\nAnnuler</md-button></md-dialog-actions></form><style>md-checkbox {\r\n    margin-top: 10px !important;\r\n}</style>\n</md-dialog>");
$templateCache.put("app/main/commandes/commande/dialogs/signature-dialog.html","<md-dialog class=\"signature-commande-dialog\" aria-label=\"Signature\" style=\"max-width:795px\"><form \nname=\"signatureCommandeForm\" enctype=\"multipart/form-data\"><md-dialog-content class=\"pb-0\"><span \nclass=\"md-title ng-binding\">Souhaitez-vous confirmer cette commande ?</span><p><strong class=\"red-800-fg\">\nUne fois validée, cette commande ne pourra plus être modifiée.</strong><br><br>\nSi vous n\'avez pas encore eu de signature du client. Vous pouvez mettre cette commande à l\'état <strong>\"validée\"\n</strong> pour pouvoir la modifier si une extension venait à s\'ajouter.</p><div layout=\"row\"><div flex=\"50\"><p \nclass=\"mb-0\"><strong>Date de signature de la commande : </strong></p><div layout=\"row\"><md-input-container flex=\"80\" \nclass=\"m-0\"><md-datepicker ng-model=\"vm.commande.DateSignature\" name=\"DateSignature\" md-max-date=\"dateSignature\" \nmd-open-on-focus required aria-label=\"Date de signature\"></md-datepicker><div \nng-messages=\"signatureCommandeForm.DateSignature.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n</div></md-input-container></div></div><div flex><p class=\"mb-0\"><strong>Devis signé :	</strong></p><div layout=\"row\">\n<md-input-container flex=\"80\" class=\"m-0\"><input ng-model=\"vm.commande.Devis\" id=\"file\" \nng-required=\"{{vm.commande.DevisSigne == true ? 0 : 1}}\" valid-file name=\"DevisSigne\" accept=\".pdf\" type=\"file\" \naria-label=\"Sélectionner votre fichier\"><div ng-messages=\"signatureCommandeForm.DevisSigne.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div></div></div><br><strong class=\"\" \nng-if=\"vm.commande.DevisSigne==true\">Il y a déjà un devis signé d\'importer : <a \nhref=\"/datas/files/devis_signes/{{vm.commande.IDCommande}}-{{vm.commande.NumeroCommande}}.pdf\" target=\"_blank\">\nle consulter</a>.<br>Si vous en importez un nouveau, celui-ci sera remplacé.</strong></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\" ng-disabled=\"vm.showSpinner\">Annuler</md-button>\n<md-button type=\"submit\" ng-click=\"vm.saveSignature()\" class=\"send-button md-warn md-raised\" \nng-disabled=\"signatureCommandeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">\nValider la commande</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\">\n</md-progress-circular></md-button></md-dialog-actions></form></md-dialog><style>\n.md-datepicker-button {\r\n	display: none;\r\n}\r\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon .md-input-message-animation{margin-left:0}\r\n._md-datepicker-floating-label > md-datepicker .md-datepicker-input-container{width:100%}\r\n._md-datepicker-floating-label > md-datepicker .md-datepicker-input-container{margin:0}\n</style>");
$templateCache.put("app/main/commandes/commande/dialogs/valide-dialog.html","<md-dialog class=\"validation-commande-dialog\" aria-label=\"Validation\" style=\"max-width:795px\"><form \nname=\"validationCommandeForm\"><md-dialog-content class=\"pb-0\"><span class=\"md-title ng-binding\">\nSouhaitez-vous confirmer cette commande ?</span><p><strong class=\"orange-800-fg\">\nUne fois validée, cette commande pourra toujours être modifiée.</strong><br><br>\nCet état peut être utilisé si la commande n\'est pas définitive, si la signature est en attente ou si l\'accord s\'est fait sans signature.\n<br>Ces commandes n\'ont <strong>aucune valeur en cas de litige sans justificatif</strong>\n. C\'est pourquoi il est demandé de donner un maximum d\'information sur sa validation.<br></p><p class=\"mb-0 mt-32\">\n<strong>Date de validation de la commande : </strong></p><div layout=\"row\"><md-input-container flex=\"50\" class=\"m-0\">\n<md-datepicker ng-model=\"vm.commande.DateValidation\" name=\"DateValidation\" md-max-date=\"date\" required \naria-label=\"Date de validation\"></md-datepicker><div ng-messages=\"validationCommandeForm.DateValidation.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><p class=\"mb-0\"><strong>\nModalité de la validation : </strong></p><md-input-container class=\"md-block\" md-no-float><label></label><textarea \nng-model=\"vm.commande.NoteValidation\" \nplaceholder=\"Veuillez indiquer les modalités de la validation (email, téléphone, nom/prénom/statut du validant, lieu,...)\" \nmd-no-asterisk=\"true\" name=\"NoteValidation\" rows=\"3\" md-detect-hidden=\"true\" required \naria-label=\"Modalité de validation\"></textarea><div ng-messages=\"validationCommandeForm.NoteValidation.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"cancel()\">Annuler</md-button><md-button type=\"submit\" ng-click=\"answer()\" \nclass=\"md-raised md-accent\" ng-disabled=\"validationCommandeForm.$invalid\" aria-label=\"Confirmer\"><span \nng-show=\"!vm.showSpinner\">Valider la commande</span></md-button></md-dialog-actions></form></md-dialog><style>\n.md-datepicker-button {\r\n	display: none;\r\n}\r\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon .md-input-message-animation{margin-left:0}\r\n._md-datepicker-floating-label > md-datepicker .md-datepicker-input-container{width:100%}\r\n._md-datepicker-floating-label > md-datepicker .md-datepicker-input-container{margin:0}\n</style>");
$templateCache.put("app/main/commandes/commandes/dialogs/acompte-dialog.html","<md-dialog class=\"acomptes-commande-dialog compact\" flex=\"80\" id=\"invoice\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>{{vm.commande.RaisonSocial}} - {{vm.commande.NumeroCommande}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"grey-fg\" \naria-label=\"Fermer\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"acompte-container\">\n<div class=\"card\"><md-list class=\"p-0\"><md-list-item class=\"secondary-button-padding md-long-text border-bottom\" \nng-repeat=\"(key,paiement) in vm.paiements\" ng-switch=\"paiement.Type\" \nng-disabled=\"paiement.FactureAc == 0 && vm.paiements[key-1].FactureAc == 0\" \nng-click=\"(paiement.Type == \'Solde\' || (paiement.Type == \'Mensualité\' && paiement.DatePaiement!=\'0000-00-00\' && (vm.isDateBefore(vm.commande.dateSignature) || vm.isDateBefore(vm.commande.dateValidation)))) ? vm.getFacture($event,vm.commande, paiement) : vm.generateAcompteFacture($event,paiement, vm.commande)\">\n<div ng-switch-default class=\"line-height-22 mr-16\"><h4 class=\"blue-900-fg mb-0\">Facture d\'acompte ({{key+1}})</h4><p \nclass=\"mt-8\">{{paiement.Type}} de <strong>{{paiement.Montant | currency:\'\'}}€ TTC</strong> par <strong>\n{{paiement.Mode}}</strong> <strong ng-show=\"paiement.DateMode == \'signature\'\">à la signature du devis</strong> <strong \nng-show=\"paiement.DateMode == \'facturation\'\">à la facturation</strong> <span \nng-show=\"paiement.DateMode == \'spécifique\'\">le <strong>{{paiement.DatePaiement | date : format : shortDate}}</strong>\n</span> <span ng-show=\"paiement.DateMode == \'étape\'\">- <strong>{{paiement.Etape}}</strong></span></p></div><div \nng-switch-when=\"Solde\" flex=\"100\" class=\"line-height-22 mr-16\"><h4 class=\"blue-900-fg mb-0\">Facture finale</h4><p \nclass=\"mt-8\">Solde de <strong>{{paiement.Montant | currency:\'\'}}€ TTC</strong> par <strong>{{paiement.Mode}}</strong> \n<strong ng-show=\"paiement.DateMode == \'facturation\'\">à la facturation</strong> <span \nng-show=\"paiement.DateMode == \'spécifique\'\">le <strong>{{paiement.DatePaiement | date : format : shortDate}}</strong>\n</span> <span ng-show=\"paiement.DateMode == \'étape\'\">- <strong>{{paiement.Etape}}</strong></span></p></div><div \nclass=\"md-secondary\" ng-switch-default><md-chips><md-chip class=\"grey-500-bg white-fg\" \nng-show=\"paiement.FactureAc == 0\" selected=\"true\"><small>Non facturé</small></md-chip><md-chip \nclass=\"md-green-bg white-fg\" ng-show=\"paiement.FactureAc == 1\" class=\"mat-teal-bg\" selected=\"true\"><small>\nFacturé le {{paiement.DateFactureAc | date:\'dd/MM/yyyy\'}}</small></md-chip></md-chips></div><div class=\"md-secondary\" \nng-switch-when=\"Solde\" class=\"line-height-22\"><md-chips><md-chip class=\"grey-500-bg white-fg\" \nng-show=\"vm.commande.Etat != \'Facturée\'\" selected=\"true\"><small>Non facturé</small></md-chip><md-chip \nclass=\"md-green-bg white-fg\" ng-show=\"vm.commande.Etat == \'Facturée\'\" class=\"mat-teal-bg\" selected=\"true\"><small>\nFacturé le {{vm.commande.DateFacturation | date:\'dd/MM/yyyy\'}}</small></md-chip></md-chips></div></md-list-item>\n<md-list-item class=\"secondary-button-padding\" ng-disabled=\"vm.paiements[vm.paiements.length-1].FactureAc == 0\" \nng-hide=\"vm.commande.TotalTTC<=vm.TotalPaiement\" ng-click=\"vm.getFacture($event,vm.commande)\"><div flex=\"100\"><h4 \nclass=\"blue-900-fg mb-0\">Facture finale</h4><p>Solde de <strong>\n{{vm.commande.TotalTTC-vm.TotalPaiement | currency:\'\'}}€ TTC</strong> à régler à la facturation</p></div><p \nclass=\"md-secondary\"><md-chips><md-chip class=\"grey-500-bg white-fg\" ng-show=\"vm.commande.Etat != \'Facturée\'\" \nselected=\"true\"><small>Non facturé</small></md-chip><md-chip class=\"md-green-bg white-fg\" \nng-show=\"vm.commande.Etat == \'Facturée\'\" class=\"mat-teal-bg\" selected=\"true\"><small>\n{{vm.commande.Etat}} le {{vm.commande.DateFacturation | date:\'dd/MM/yyyy\'}}</small></md-chip></md-chips></p>\n</md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Fermer</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/commandes/commandes/dialogs/details-dialog.html","<md-dialog class=\"details-commande-dialog compact\" flex=\"80\" id=\"invoice\"><md-dialog-content ms-scroll \nclass=\"invoice-container\"><div class=\"card\" layout=\"column\"><div class=\"header\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between stretch\"><div layout=\"column\" layout-align=\"start start\" class=\"mt-16\"><span \nclass=\"p-5 pr-8 pl-8 brad-16 md-amber-600-bg white-fg\" ng-show=\"vm.commande.Etat == \'Brouillon\'\">{{vm.commande.Etat}}\n</span> <span class=\"p-5 pr-8 pl-8 brad-16 grey-500-bg white-fg\" ng-show=\"vm.commande.Etat == \'Annulée\'\">\n{{vm.commande.Etat}}</span> <span class=\"p-5 pr-8 pl-8 brad-16 red-600-bg white-fg\" \nng-show=\"vm.commande.Etat == \'En attente\'\">{{vm.commande.Etat}}</span> <span \nclass=\"p-5 pr-8 pl-8 brad-16 md-cyan-700-bg white-fg\" ng-show=\"vm.commande.Etat == \'Validée\'\">{{vm.commande.Etat}}\n</span> <span class=\"p-5 pr-8 pl-8 brad-16 md-teal-600-bg white-fg\" ng-show=\"vm.commande.Etat == \'Signée\'\">\n{{vm.commande.Etat}}</span> <span class=\"p-5 pr-8 pl-8 brad-16 md-green-600-bg white-fg\" \nng-show=\"vm.commande.Etat == \'Facturée\'\">{{vm.commande.Etat}} le {{vm.commande.DateFacturation | date:\'dd/MM/yyyy\'}}\n</span><h4 class=\"mb-0\" \nng-show=\"vm.commande.Etat != \'Signée\' || vm.commande.Etat != \'Validée\' || vm.commande.Etat != \'Facturée\'\">\nCréée le {{vm.commande.DateCreation | date : format : shortDate}}</h4><h4 class=\"mb-0 mt-0\">\nSignature prévisionnelle : {{vm.commande.DatePrevisionSignature | date : format : shortDate}}</h4><h4 \nclass=\"mb-0 mt-0\" ng-if=\"vm.commande.DateValidation && vm.commande.DateValidation!=\'0000-00-00\'\" layout=\"row\">\nValidation : {{vm.commande.DateValidation | date : format : shortDate}}<md-icon ng-hdie=\"!vm.commande.NoteValidation\" \nclass=\"material-icons-outlined s18 md-accent-fg ml-8\">help_outline</md-icon><md-tooltip md-direction=\"right\" \nmd-visible=\"false\" ng-bind-html=\"vm.nl2br(vm.commande.NoteValidation, false)\">{{vm.commande.NoteValidation}}\n</md-tooltip></h4><h4 class=\"mb-0 mt-0\" \nng-if=\"vm.commande.DateSignature && vm.commande.DateSignature!=\'0000-00-00\' && (vm.commande.Etat==\'Facturée\' || vm.commande.Etat==\'Signée\')\">\nSignature : {{vm.commande.DateSignature | date : format : shortDate}}</h4><h4 class=\"mb-0 mt-0\" \nng-if=\"vm.commande.DateSignature && vm.commande.DateSignature!=\'0000-00-00\' && vm.commande.Etat!=\'Facturée\' && vm.commande.Etat!=\'Signée\'\">\nEstimation signature : {{vm.commande.DateSignature | date : format : shortDate}}</h4><h4 class=\"mb-0 mt-0\" \nng-if=\"vm.commande.NumeroFacture\">Facture N° {{vm.commande.NumeroFacture}}</h4><h4 class=\"mb-0 mt-0\" \nng-if=\"vm.commande.DateRenouvellement && vm.commande.DateRenouvellement!=\'0000-00-00\'\">\nRenouvellement : {{vm.commande.DateRenouvellement | date : format : shortDate}}</h4><h4 class=\"mb-0 mt-0\" \nng-if=\"vm.commande.Projet == \'avec\'\">Sites internet : <span ng-repeat=\"url in vm.commande.sitesUrl\"><a \nng-href=\"{{url.URL}}\" target=\"_blank\">{{url.URL}}</a>{{$last ? \'\' : \",\"}} </span></h4><h4 class=\"mb-0 mt-0\" \nng-if=\"vm.commande.Projet == \'inconnu\'\">Sites internet : inconnu / indéfini</h4><div class=\"mt-16\"><md-menu><md-button \nclass=\"md-raised ml-0\" ng-click=\"$mdMenu.open()\"><md-icon ng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">\ndescription</md-icon>Documents</md-button><md-menu-content><md-menu-item \nng-if=\"vm.commande.Etat!=\'Facturée\' && vm.commande.Etat!=\'Signée\' && vm.commande.Etat!=\'Brouillon\' && vm.commande.TotalTTC>=0\">\n<md-button ng-click=\"vm.getDevis($event,vm.commande.IDCommande, vm.prelevement)\">Générer le devis</md-button>\n</md-menu-item><md-menu-item ng-if=\"((vm.commande.Etat==\'Facturée\' || vm.commande.Etat==\'Signée\'))\"><md-button \ntarget=\" _blank\" ng-click=\"vm.getDevisSigne($event,vm.commande.IDCommande, vm.commande.NumeroCommande)\" \nng-disabled=\"vm.commande.DevisSigne!=true\">Voir le devis signé</md-button></md-menu-item><md-menu-item \nng-if=\"vm.commande.Etat!=\'Facturée\' && vm.commande.paiements.length<= 1 && vm.commande.Etat!=\'Brouillon\' && vm.commande.TotalTTC<0\">\n<md-button ng-disabled=\"((vm.commande.Etat!=\'Signée\' && vm.commande.Etat!=\'Validée\'))\" \nng-click=\"vm.getFacture(event, vm.commande.IDCommande, vm.commande.DateRenouvellement, vm.commande.Etat, vm.commande.DateFacturation, vm.commande.TotalTTC)\">\nGénérer l\'avoir</md-button></md-menu-item><md-menu-item \nng-if=\"vm.commande.Etat!=\'Facturée\' && vm.commande.paiements.length <= 1 && vm.commande.Etat!=\'Brouillon\'  && vm.commande.TotalTTC>=0\">\n<md-button ng-disabled=\"((vm.commande.Etat!=\'Signée\' && vm.commande.Etat!=\'Validée\'))\" \nng-click=\"vm.getFacture(event, vm.commande.IDCommande, vm.commande.DateRenouvellement, vm.commande.Etat, vm.commande.DateFacturation, vm.commande.TotalTTC)\">\nGénérer la facture</md-button></md-menu-item><md-menu-item \nng-if=\"vm.commande.paiements.length > 1 && vm.commande.Etat!=\'Brouillon\'\"><md-button \nng-disabled=\"((vm.commande.Etat!=\'Signée\' && vm.commande.Etat!=\'Validée\' && vm.commande.Etat!=\'Facturée\'))\" \nng-click=\"vm.getFactureAcompte(event, vm.commande.IDCommande, vm.prelevement)\">Facturations</md-button></md-menu-item>\n<md-menu-item \nng-if=\"vm.commande.Etat==\'Facturée\' && vm.commande.paiements.length <= 1 && vm.commande.Etat!=\'Brouillon\'\"><md-button \nng-click=\"vm.getFacture(event, vm.commande.IDCommande, vm.commande.DateRenouvellement, vm.commande.Etat, vm.commande.DateFacturation)\">\nTélécharger la facture</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-raised ml-0\" \nng-click=\"vm.showLogs($event, vm.commande)\" ng-disabled=\"!vm.commande.IDContact\" ng-show=\"vm.commande.logs.length>0\">\n<md-icon ng-show=\"!vm.showSpinner\" class=\"material-icons-outlined\">timeline</md-icon>Historique</md-button><md-button \nclass=\"md-raised ml-0\" ng-click=\"vm.showMarges = !vm.showMarges\"><md-icon ng-show=\"!vm.showMarges\" \nclass=\"material-icons-outlined\">visibility_off</md-icon><md-icon ng-show=\"vm.showMarges\" \nclass=\"material-icons-outlined\">visibility</md-icon>Charges externes</md-button></div></div><div \nclass=\"issuer md-accent-bg mt-16\" layout=\"row\" layout-align=\"start center\"><h1 class=\"p-40 pt-24 pb-24 border-right\">\nCLIENT</h1><div class=\"info line-height-22\"><strong ng-hide=\"vm.commande.NumeroCommande\">Nouvelle Commande</strong> \n<strong ng-show=\"vm.commande.NumeroCommande\">Commande N° {{vm.commande.NumeroCommande}}</strong><div class=\"address\" \nng-show=\"vm.commande.RaisonSocial\">{{vm.commande.RaisonSocial}}</div><div class=\"address\" \nng-show=\"vm.commande.adresse.NomAdresse && vm.commande.adresse.NomAdresse!=vm.commande.RaisonSocial\">\n{{vm.commande.adresse.NomAdresse}}</div><div class=\"address\" ng-show=\"vm.commande.adresse.Adresse\">\n{{vm.commande.adresse.Adresse}}</div><div class=\"address\" ng-show=\"vm.commande.adresse.Adresse2\">\n{{vm.commande.adresse.Adresse2}}</div><div class=\"address\" ng-show=\"vm.commande.adresse.Ville\">\n{{vm.commande.adresse.Ville.CodePostal}} {{vm.commande.adresse.Ville.NomVille}} - {{vm.commande.adresse.Pays.NomPays}}\n</div><div class=\"siret\" ng-show=\"vm.commande.adresse.Siret\">SIRET : {{vm.commande.adresse.Siret}}</div></div></div>\n</div></div><div class=\"content p-0\" ng-show=\"vm.commande.IDAdresseFacturation\"><form name=\"fabricantsForm\" \nid=\"fabricantsForm\"><div class=\"grey-50-bg mt-24\" \nng-if=\"vm.showMarges && vm.permission==\'Super Admin\' && (vm.commande.Etat == \'Facturée\' || vm.commande.Etat == \'Signée\')\">\n<table class=\"simple\"><thead><tr><th style=\"width:25%\">PRODUIT</th><th style=\"width:30%\">FOURNISSEUR</th><th \nstyle=\"width:25%; text-align:center\">PU D\'ACHAT HT</th><th style=\"width:20%; text-align:center\">QUANTITÉ</th><th \nstyle=\"width:15%\" ng-show=\"vm.FabEdit\"></th></tr></thead><tbody><tr \nng-repeat=\"Fabricant in vm.commande.Fabricants track by $index\"><td style=\"width:30%\"><span ng-show=\"!vm.FabEdit\">\n{{Fabricant.Produit}}</span><md-input-container class=\"md-block mt-8\" md-no-float style=\"width:200px\" \nng-show=\"vm.FabEdit\"><md-select ng-model=\"Fabricant.IDCommandes_Produit\" name=\"IDCommandes_Produit{{$index}}\" \nplaceholder=\"Produit\" required><md-option ng-repeat-start=\"produit in vm.commande.produits\" \nng-value=\"{{produit.IDCommandes_Produit}}\">{{produit.Produit}}</md-option><md-option ng-repeat-end \nng-repeat=\"SousProduits in produit.SousProduitsSelect\" ng-value=\"{{SousProduits.IDCommandes_Produit}}\">\n-- {{SousProduits.Produit}}</md-option></md-select><div \nng-messages=\"fabricantsForm[\'IDCommandes_Produit\'+$index].$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div></div></md-input-container></td><td style=\"width:25%\"><span ng-show=\"!vm.FabEdit\">{{Fabricant.Fabricant}}<small \nng-if=\"Fabricant.Metier\"> ({{Fabricant.Metier}})</small></span><md-input-container class=\"md-block mt-8\" md-no-float \nstyle=\"width:200px\" ng-show=\"vm.FabEdit\"><md-select ng-model=\"Fabricant.IDFabricant\" name=\"IDFabricant{{$index}}\" \nplaceholder=\"Fournisseur\" required><md-option ng-repeat=\"fabSelect in vm.Fabricants \" \nng-value=\"{{fabSelect.IDFabricant}}\">{{fabSelect.Fabricant}}<small ng-if=\"fabSelect.Metier\"> ({{fabSelect.Metier}})\n</small></md-option></md-select><div ng-messages=\"fabricantsForm[\'IDFabricant\'+$index].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></td><td \nstyle=\"width:25%;text-align:center\"><span ng-show=\"!vm.FabEdit\">{{Fabricant.PrixAchatHT | currency:\'\'}} €</span>\n<md-input-container class=\"md-block\" md-no-float ng-show=\"vm.FabEdit\"><input ng-model=\"Fabricant.PrixAchatHT\" \nname=\"PrixAchatHT{{$index}}\" type=\"number\" ng-min=\"0\" placeholder=\"Prix d\'achat\" required><div \nng-messages=\"fabricantsForm[\'PrixAchatHT\'+$index].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div\n ng-message=\"min\">Le montant doit être supérieur à 0</div></div></md-input-container></td><td \nstyle=\"width:20%;text-align:center\"><span ng-show=\"!vm.FabEdit\">{{Fabricant.Quantite}}</span><md-input-container \nclass=\"md-block\" md-no-float ng-show=\"vm.FabEdit\"><input ng-model=\"Fabricant.Quantite\" name=\"Quantite{{$index}}\" \ntype=\"number\" ng-min=\"0\" placeholder=\"Quantité\" required><div ng-messages=\"fabricantsForm[\'Quantite\'+$index].$error\">\n<div ng-message=\"required\">Champ obligatoire</div><div ng-message=\"min\">Le montant doit être supérieur à 0</div></div>\n</md-input-container></td><td style=\"width:15%; text-align:right\" ng-show=\"vm.FabEdit\"><div layout=\"row\"><md-button \nng-click=\"vm.commande.Fabricants.splice(vm.commande.Fabricants.indexOf(Fabricant), 1);\" class=\"md-icon-button\"><md-icon\n class=\"material-icons-outlined red-900-fg\">delete</md-icon></md-button></div></td></tr><tr><td colspan=\"5\" \nstyle=\"text-align:right\"><md-button class=\"md-raised\" ng-click=\"vm.commande.Fabricants.push({null});\" \nng-show=\"vm.FabEdit\">Ajouter</md-button><md-button class=\"md-raised\" ng-click=\"vm.fabEdit(true)\" ng-show=\"!vm.FabEdit\">\nEditer les fournisseurs</md-button><md-button class=\"md-raised\" ng-click=\"vm.updateFabricants();vm.FabEdit = 0\" \nng-show=\"vm.FabEdit\" ng-disabled=\"!vm.isFormValid(\'fabricantsForm\')\">Valider</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.fabEdit(false)\" ng-show=\"vm.FabEdit\">Annuler</md-button></td></tr></tbody>\n</table></div></form><table class=\"simple invoice-table\" wt-responsive-table id=\"invoice-table\"><thead><th \nstyle=\"width:50%\">PRODUIT</th><th class=\"text-center\">QUANTITÉ</th><th class=\"text-center\">PU HT</th><th \nclass=\"text-center md-red-50-bg\" ng-if=\"vm.showMarges\">PA HT</th><th class=\"text-right\">TOTAL</th></thead><tbody><tr \nng-repeat-start=\"produit in vm.commande.produits\"><td \nng-class=\"produit.SousProduitsSelect.length > 0 ? \'noborder\' : \'\'\"><div class=\"title\"><span ng-if=\"produit.Reference\">\n{{produit.Reference}}<br></span><strong>{{produit.Produit}}</strong><br><small hide-xs \nng-bind-html=\"produit.NoteCommande\">{{produit.NoteCommande}}</small> <small \nng-if=\"produit.Plugin==\'plg_ref\' && !produit.Parametres.ComplementDeCommande\"><ul><li>\nMise à jour du contenu statique et informations importantes (congés, déménagement...)</li><li>\nMaintenance corrective du site internet</li></ul></small><small ng-if=\"produit.Plugin==\'plg_ref\'\"><strong>\nParamètres de la campagne :</strong><ul><li><strong>Combinaisons :</strong>\n {{produit.Parametres.total.nbrRequetes}} mots-clés pertinents</li><li><strong>Localités :</strong>\n {{produit.Parametres.total.nbrLocalites.regions.length + produit.Parametres.total.nbrLocalites.departements.length + produit.Parametres.total.nbrLocalites.challenging.length + produit.Parametres.total.nbrLocalites.veryhard.length + produit.Parametres.total.nbrLocalites.hard.length + produit.Parametres.total.nbrLocalites.medium.length + produit.Parametres.total.nbrLocalites.easy.length}} zones géographiques stratégiques\n</li><li><strong>Population ciblées :</strong>\n {{produit.Parametres.total.nbrPopulation | number}} habitants (hors noms départements)</li></ul></small><p \nclass=\"mb-24 mt-5\" ng-if=\"produit.Renouvellement>0 || produit.PrixSpecifiques.length>0 || produit.Reconduction\"><span \nng-if=\"produit.Renouvellement>0\" class=\"orange-100-bg font-size-10 grey-900-fg p-5 ng-bindin brad-16\">\nEngagement sur {{produit.Renouvellement}} mois</span><span ng-if=\"produit.Reconduction\" \nclass=\"red-100-bg font-size-10 grey-900-fg p-5 ng-bindin brad-16 ml-5\">Reconduction automatique</span></p></div></td>\n<td ng-class=\"produit.SousProduitsSelect.length > 0 ? \'noborder\' : \'\'\" class=\"text-center\">{{produit.Quantite}}</td><td\n ng-class=\"produit.SousProduitsSelect.length > 0 ? \'noborder\' : \'\'\" class=\"text-center\">\n{{produit.PrixVenteFinalHT | currency:\'\'}} € <small \nng-show=\"produit.PrixVenteHT!=0 && produit.PrixVenteHT != produit.PrixVenteFinalHT && vm.commande.affichageRemiseProduits == \'Affichée\'\" \nclass=\"red-600-fg\"><br><del>{{produit.PrixVenteHT | currency:\'\'}} €</del></small></td><td ng-if=\"vm.showMarges\" \nng-class=\"produit.SousProduitsSelect.length > 0 ? \'noborder\' : \'\'\" class=\"text-center md-red-50-bg\"><span \nng-if=\"produit.PrixAchatHT>0 && (vm.permission!=\'Super Admin2\' || vm.commande.Etat != \'Facturée\')\">\n{{produit.PrixAchatHT | currency:\'\'}} €	</span><a href=\"#\" \nng-if=\"vm.permission==\'Super Admin2\' && vm.commande.Etat == \'Facturée\'\" e-single e-required \neditable-number=\"produit.PrixAchatHT\" onaftersave=\"vm.updateFabricants()\">\n{{(produit.PrixAchatHT ? produit.PrixAchatHT : 0) | currency:\'\'}} €<md-tooltip md-direction=\"top\">Modifier</md-tooltip>\n</a></td><td ng-class=\"produit.SousProduitsSelect.length > 0 ? \'noborder\' : \'\'\" class=\"text-right\">\n{{produit.PrixVenteFinalHT * produit.Quantite | currency:\'\'}} € <small \nng-show=\"produit.PrixVenteHT!=0 && produit.PrixVenteHT != produit.PrixVenteFinalHT && vm.commande.affichageRemiseProduits == \'Affichée\'\" \nclass=\"red-600-fg\"><br><del>{{produit.PrixVenteHT * produit.Quantite | currency:\'\'}} €</del></small></td></tr><tr \nng-repeat-end ng-repeat=\"SousProduits in produit.SousProduitsSelect\" class=\"SousProduits\"><td \nng-class=\"!$last ? \'noborder\' : \'\'\" layout=\"row\" layout-align=\"start start\" style=\"width:100%\"><md-icon \nclass=\"material-icons-outlined blue-grey-900-fg mt-0\" flex=\"10\">check_box</md-icon><span class=\"\" flex>\n{{SousProduits.Produit}}</span></td><td ng-class=\"!$last ? \'noborder\' : \'\'\" class=\"text-center\">{{produit.Quantite}}\n</td><td ng-class=\"!$last ? \'noborder\' : \'\'\" class=\"text-center\">{{SousProduits.PrixVenteFinalHT | currency:\'\'}} € \n<small \nng-show=\"SousProduits.PrixVenteHT!=0 && SousProduits.PrixVenteHT != SousProduits.PrixVenteFinalHT && vm.commande.affichageRemiseProduits == \'Affichée\'\" \nclass=\"red-600-fg\"><br><del>{{SousProduits.PrixVenteHT | currency:\'\'}} €</del></small></td><td ng-if=\"vm.showMarges\" \nng-class=\"!$last ? \'noborder\' : \'\'\" class=\"text-center md-red-50-bg\"><span \nng-if=\"SousProduits.PrixAchatHT>0 && (vm.permission!=\'Super Admin2\' || vm.commande.Etat != \'Facturée\')\">\n{{SousProduits.PrixAchatHT | currency:\'\'}} €	</span><a href=\"#\" \nng-if=\"vm.permission==\'Super Admin2\' && vm.commande.Etat == \'Facturée\'\" e-single e-required \neditable-number=\"SousProduits.PrixAchatHT\" onaftersave=\"vm.updatePrixAchat()\">\n{{(SousProduits.PrixAchatHT ? SousProduits.PrixAchatHT : 0) | currency:\'\'}} €<md-tooltip md-direction=\"top\">Modifier\n</md-tooltip></a></td><td ng-class=\"!$last ? \'noborder\' : \'\'\" class=\"text-right\">\n{{SousProduits.PrixVenteFinalHT * produit.Quantite | currency:\'\'}} € <small \nng-show=\"SousProduits.PrixVenteHT!=0 && SousProduits.PrixVenteHT != SousProduits.PrixVenteFinalHT && vm.commande.affichageRemiseProduits == \'Affichée\'\" \nclass=\"red-600-fg\"><br><del>{{SousProduits.PrixVenteHT * produit.Quantite | currency:\'\'}} €</del></small></td></tr><tr \nclass=\"lastinfo\" ng-if=\"vm.commande.Complementaires\"><td colspan=\"5\"><p ng-bind-html=\"vm.commande.Complementaires\">\n{{vm.commande.Complementaires}}</p></td></tr></tbody></table><table class=\"simple invoice-table-footer pt-20\"><tbody>\n<tr class=\"subtotal md-red-50-bg\" ng-if=\"vm.showMarges\"><td class=\"pl-8\">TOTAL Charges</td><td class=\"pr-8\"><span>\n{{vm.commande.TotalChargesHT | currency:\'\'}} €</span></td></tr><tr class=\"subtotal\"><td class=\"\">TOTAL HT <span \nng-show=\"vm.commande.affichageRemiseProduits == \'Affichée\' && vm.commande.TotalHT < vm.commande.TotalOriginalHT\">\nAVANT REMISES PRODUITS</span></td><td class=\"\"><span ng-show=\"vm.commande.affichageRemiseProduits == \'Affichée\'\">\n{{vm.commande.TotalOriginalHT | currency:\'\'}} €</span> <span \nng-hide=\"vm.commande.affichageRemiseProduits == \'Affichée\'\">{{vm.commande.TotalHT | currency:\'\'}} €</span></td></tr><tr\n class=\"subtotal\" \nng-show=\"vm.commande.TotalHT != vm.commande.TotalOriginalHT && vm.commande.affichageRemiseProduits == \'Affichée\'\"><td>\n<span ng-hide=\"vm.commande.TotalHT > vm.commande.TotalOriginalHT\">REMISE PRODUITS HT</span><span \nng-hide=\"vm.commande.TotalHT < vm.commande.TotalOriginalHT\">PLUSVALUE HT</span></td><td class=\"red-600-fg\">\n{{vm.commande.TotalHT - vm.commande.TotalOriginalHT | currency:\'\'}} €</td></tr><tr class=\"subtotal\" \nng-show=\"vm.commande.TotalHT != vm.commande.TotalOriginalHT  && vm.commande.affichageRemiseProduits == \'Affichée\'\"><td>\nTOTAL HT</td><td>{{vm.commande.TotalHT | currency:\'\'}} €</td></tr><tr class=\"subtotal\" \nng-show=\"vm.commande.RemiseActive && vm.commande.Remise != 0\"><td><span>REMISE</span></td><td class=\"red-600-fg\"><span \nng-if=\"vm.commande.RemiseEuroPourcent == \'%\'\">\n{{vm.commande.Remise}}{{vm.commande.RemiseEuroPourcent}} (-{{vm.commande.TotalHT - vm.commande.TotalHTRemise | currency:\'\'}} €) \n</span><span ng-if=\"vm.commande.RemiseEuroPourcent != \'%\'\">-{{vm.commande.Remise}}{{vm.commande.RemiseEuroPourcent}}\n</span></td></tr><tr class=\"subtotal\" ng-show=\"vm.commande.RemiseActive && vm.commande.Remise != 0\"><td>\nNOUVEAU TOTAL HT</td><td>{{vm.commande.TotalHTRemise | currency:\'\'}} €</td></tr><tr class=\"subtotal md-green-50-bg\" \nng-if=\"vm.showMarges\"><td class=\"pl-8\">TOTAL Marges brutes</td><td class=\"pr-8\"><span>\n{{vm.commande.MargeBrutHT | currency:\'\'}} €</span></td></tr><tr class=\"tax\"><td>TVA 20%</td><td>\n{{vm.commande.TotalTTC - vm.commande.TotalHTRemise | currency:\'\'}} €</td></tr><tr class=\"total\"><td><strong>TOTAL TTC\n</strong></td><td><strong>{{vm.commande.TotalTTC | currency:\'\'}} €</strong></td></tr></tbody></table></div><div \nclass=\"footer\" ng-hide=\"vm.commande.TotalTTC<=0\"><md-divider class=\"mb-24\" ng-show=\"vm.commande.IBAN\"></md-divider><p \nng-show=\"vm.commande.IBAN\"><strong>IBAN client : </strong>{{vm.commande.IBAN}}</p><p ng-show=\"vm.commande.IBAN\">\n<strong>BIC : </strong>{{vm.commande.BIC}}</p><p ng-show=\"vm.commande.IBAN\"><strong>Domiciliation : </strong>\n{{vm.commande.Domiciliation}}</p><p ng-show=\"vm.commande.IBAN\"><strong>Titulaire : </strong>{{vm.commande.Titulaire}}\n</p><md-divider class=\"mb-24\"></md-divider><div class=\"note mb-16\"><strong>Echéanciers de paiements :</strong></div>\n<div layout=\"column\" class=\"mb-16\" layout-align=\"start none\" flex=\"100\"><div \nng-repeat=\"paiement in vm.commande.paiements\" \nng-if=\"paiement.Type!=\'Mensualité\' || (!vm.isDateBefore(vm.commande.dateValidation) && !vm.isDateBefore(vm.commande.DateSignature))\">\n<h4 class=\"mt-0 mb-0\">{{paiement.Type}} de <strong>{{paiement.Montant}} €</strong> par <strong>{{paiement.Mode}}\n</strong> <strong ng-show=\"paiement.DateMode == \'signature\'\">à la signature du devis</strong> <strong \nng-show=\"paiement.DateMode == \'facturation\'\">à la facturation</strong> <span \nng-show=\"paiement.DateMode == \'spécifique\'\">le <strong>{{paiement.DatePaiement | date : format : shortDate}}</strong>\n</span> <span ng-show=\"paiement.DateMode == \'étape\'\">- <strong>{{paiement.Etape}}</strong></span></h4></div><div \nng-repeat=\"paiement in vm.commande.paiements\" \nng-if=\"paiement.Type==\'Mensualité\' && (vm.isDateBefore(vm.commande.dateValidation) || vm.isDateBefore(vm.commande.DateSignature))\">\n<h4 class=\"mt-5 mb-5\" ng-repeat=\"i in vm.getNumber(paiement.NbrMensualites) track by $index\">{{paiement.Type}} de \n<strong>{{paiement.Montant/paiement.NbrMensualites | currency:\'\'}} €</strong> par <strong>{{paiement.Mode}}</strong> \n<strong ng-show=\"paiement.DateMode == \'signature\'\">à partir de la signature du devis</strong> <strong \nng-show=\"paiement.DateMode == \'facturation\'\">à partir de la facturation</strong> <span \nng-show=\"paiement.DateMode == \'spécifique\'\">le <strong>\n{{vm.add_months(paiement.DatePaiement, $index) | date : format : shortDate}}</strong></span> <span \nng-show=\"paiement.DateMode == \'étape\'\">à partir de <strong>{{paiement.Etape}}</strong></span></h4></div><div \nng-hide=\"vm.commande.TotalTTC<=vm.TotalPaiement\"><h4 flex=\"100\" class=\"mt-5 mb-5\">Solde de <strong>\n{{vm.commande.TotalTTC-vm.TotalPaiement | currency:\'\'}} €</strong> à régler à la facturation</h4></div><div flex=\"100\">\n<h4 class=\"red-500-fg\" ng-show=\"vm.commande.TotalTTC<vm.TotalPaiement && vm.TotalTTC>=0\"><md-icon \nmd-font-icon=\"icon icon-alert\" class=\"red-500-fg\"></md-icon>\nLe total des paiements est supérieur au montant de la commande de <strong>\n{{vm.TotalPaiement - vm.commande.TotalTTC | currency:\'\'}} €</strong> !</h4></div></div></div><div id=\"notes\" \nclass=\"bt\"><div class=\"invoice-notes scrollable md-background-bg mt-5\" ms-scroll><h4 \nng-hide=\"vm.commande.notes.length>0\"><strong>Aucun commentaire pour cette commande.</strong></h4><h4 \nng-show=\"vm.commande.notes.length>0\"><strong>{{vm.commande.notes.length}} commentaire(s) pour cette commande :</strong>\n</h4><div ng-repeat=\"note in vm.commande.notes\"><div ng-show=\"note.Edit == 1\" \nng-if=\"!note.Commandes && note.IDEmploye == vm.idUser\" class=\"pt-8 pb-8 mb-16 add-post\" \nstyle=\"border-top:2px solid #f44336; border-bottom:2px solid #f44336\"><md-input-container class=\"md-block\"><label>\nModifier votre commentaire</label><textarea ng-model=\"note.Note\" md-detect-hidden=\"true\"></textarea>\n</md-input-container><footer layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"note.Edit = 0; note.Note = note.Temp\" class=\"post-button\" aria-label=\"Annuler\">Annuler</md-button><md-button \nng-click=\"vm.edit_post(note)\" class=\"post-button md-raised md-accent\" aria-label=\"Modifier\">Modifier</md-button>\n</footer></div><div class=\"p-8 pl-16 pr-16 mb-16 brad-16\" ng-hide=\"note.Edit == 1\" \nng-class=\"(note.IDListe == vm.commande.IDListe_NotesContact) ? \'blue-grey-50-bg\' : \'blue-50-bg\'\"><blockquote><p \nclass=\"mt-0\" style=\"white-space: pre-line;word-wrap: break-word\"><strong \nng-if=\"note.IDListe == vm.commande.IDListe_NotesContact\">Note générale du contact<br><br></strong>{{note.Note}}</p>\n<footer layout=\"row\" layout-align=\"start start\"><md-truncate flex>{{note.Utilisateur}}<br><small>{{note.DateCreation}}\n</small><br ng-if=\"note.DateModification\"><small ng-if=\"note.DateModification\">{{note.DateModification}}</small>\n</md-truncate><md-button class=\"edit-post p-0 m-0 md-primary font-size-12\" aria-label=\"Modifier\" \nng-if=\"note.IDListe != vm.commande.IDListe_NotesContact  && note.IDEmploye == vm.idUser\" \nng-click=\"note.Edit = 1; note.Temp = note.Note\"><md-icon class=\"material-icons-outlined font-size-12\">edit</md-icon>\nModifier</md-button></footer></blockquote></div></div></div><div class=\"add-post bt pt-16 pb-16\"><md-input-container \nclass=\"md-block\"><label>Ajouter une note</label><textarea ng-model=\"vm.text_add_post\"></textarea></md-input-container>\n<footer layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.add_post()\" class=\"post-button md-raised\" \naria-label=\"Ajouter\">Ajouter</md-button></footer></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<div></div><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Fermer</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/commandes/commandes/dialogs/options-commande-dialog.html","<md-dialog class=\"options-commande-dialog compact\" flex=\"80\" id=\"invoice\"><form name=\"optionsCommandeForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nOptions : {{vm.commande.RaisonSocial}} - {{vm.commande.NumeroCommande}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"grey-fg\" \naria-label=\"Fermer\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"acompte-container\">\n<div layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Etat</label><md-select \nng-model=\"vm.commande.Etat\" name=\"Etat\" placeholder=\"Etat\" required><md-option value=\"Brouillon\">Brouillon</md-option>\n<md-option value=\"Annulée\">Annulée</md-option><md-option value=\"En attente\">En attente</md-option><md-option \nvalue=\"Validée\">Validée</md-option><md-option value=\"Signée\">Signée</md-option><md-option value=\"Facturée\">Facturée\n</md-option></md-select><div ng-messages=\"optionsCommandeForm.Etat.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" \nmd-no-float flex><label>Remises suplémentaires autorisées</label><md-select ng-model=\"vm.commande.AutoriseRemiseSup\" \nname=\"AutoriseRemiseSup\" placeholder=\"Remises suplémentaires autorisées\" required><md-option ng-value=\"0\">Non\n</md-option><md-option ng-value=\"1\">Oui</md-option></md-select><div \nng-messages=\"optionsCommandeForm.AutoriseRemiseSup.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n</div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" class=\"mt-8\"><label>\nDate de validation</label><md-datepicker ng-model=\"vm.commande.DateValidation\" md-current-view=\"year\" md-open-on-focus>\n</md-datepicker></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" class=\"mt-8\"><label>\nDate de signature</label><md-datepicker ng-model=\"vm.commande.DateSignature\" md-current-view=\"year\" md-open-on-focus>\n</md-datepicker></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" class=\"mt-8\"><label>\nDate de renouvellement</label><md-datepicker ng-model=\"vm.commande.DateRenouvellement\" md-current-view=\"year\" \nmd-open-on-focus md-placeholder=\"Pas de renouvellement\"></md-datepicker></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Etat du renouvellement</label><md-select \nng-model=\"vm.commande.Renouvellement\" name=\"Renouvellement\" \nng-disabled=\"!vm.commande.DateRenouvellement || vm.commande.DateRenouvellement==\'0000-00-00\' || vm.commande.DateRenouvellement==\'1970-01-01\'\" \nplaceholder=\"Etat du renouvellement\" required><md-option ng-value=\"0\">A renouveler</md-option><md-option ng-value=\"1\">\nRenouvelée</md-option><md-option ng-value=\"2\">Non renouvelée</md-option></md-select><div \nng-messages=\"optionsCommandeForm.Renouvellement.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Projet\n</label><md-select ng-model=\"vm.commande.Projet\" name=\"Projet\" required><md-option value=\"avec\">\nConcerne un site internet</md-option><md-option value=\"inconnu\">Concerne un site internet inconnu / indéfini\n</md-option><md-option value=\"sans\">Sans rapport avec un site internet</md-option></md-select><div \nng-messages=\"optionsCommandeForm.Projet.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.commande.Projet == \'avec\'\"><md-input-container class=\"md-block\" \nmd-no-float flex><label>Site(s)</label><md-select ng-model=\"vm.commande.sites\" multiple=\"multiple\" name=\"sites\" \nng-required=\"vm.commande.Projet == \'avec\'\"><md-option ng-value=\"site.IDSiteWeb\" ng-repeat=\"site in vm.sites\">\n{{site.URL.replace(\"http://\",\"\").replace(\"https://\",\"\").replace(\"www.\",\"\")}}</md-option></md-select><div \nng-messages=\"optionsCommandeForm.sites.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><md-button class=\"md-fab md-mini md-primary mt-16\" aria-label=\"Ajouter\" ng-if=\"!vm.addsite\" \nng-click=\"vm.addsite = 1\"><md-tooltip md-direction=\"right\">Ajouter un site</md-tooltip><md-icon \nmd-font-icon=\"icon icon-plus\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"space-between start\" \nng-if=\"vm.addsite\"><md-input-container class=\"md-block\" md-no-float flex><label>URL du site internet à ajouter</label>\n<input ng-model=\"vm.newURL\" name=\"newURL\" type=\"url\" ng-required=\"vm.addsite\" ng-pattern=\"vm.webregex\"><div \nng-messages=\"optionsCommandeForm.newURL.$error\" role=\"alert\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n<div ng-message=\"pattern\">Le format votre l\'URL est incorrecte</div><div ng-message=\"newURLFailed\"><span>{{status}}\n</span></div></div></md-input-container><md-button class=\"mt-16 md-raised\" ng-click=\"vm.addwebsite(vm.newURL); \" \nng-disabled=\"!vm.newURL\">Ajouter</md-button><md-button class=\"mt-16\" ng-click=\"vm.addsite = 0; vm.newURL = \'\'\">Annuler\n</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" \nng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveCommande()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"optionsCommandeForm.$invalid\" aria-label=\"Appliquer\">Appliquer\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/commandes/factures/dialogs/contacts-sendfactures-dialog.html","<md-dialog class=\"acomptes-commande-dialog compact\" flex=\"80\" id=\"invoice\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>{{vm.RaisonSocial}} - {{vm.NumeroFacture}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"grey-fg\" aria-label=\"Fermer\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"acompte-container\"><div class=\"card\"><div \nlayout=\"row\" layout-wrap class=\"p-16 pb-0\"><md-checkbox ng-model=\"vm.EnvoiEmail\" aria-label=\"Envoyer par email\">Email\n</md-checkbox><md-checkbox ng-model=\"vm.EnvoiPlateforme\" aria-label=\"Envoyer à SuperPDP\">SuperPDP</md-checkbox></div>\n<md-list class=\"p-0\" ng-if=\"vm.EnvoiEmail\"><md-list-item class=\"secondary-button-padding md-long-text border-bottom\" \nng-repeat=\"(key,contact) in vm.contacts\" ng-click=\"vm.generateAcompteFacture(contact)\" \nng-disabled=\"vm.confirmationEnCours || !contact.Email\"><div class=\"line-height-22 mr-16\"><h4 class=\"blue-900-fg mb-0\">\n{{contact.Civilite}} {{contact.Prenom}} {{contact.Nom}} ({{contact.Fonction}})</h4><p class=\"mt-8\">Contact <strong>\n{{contact.PrincipalOuSecondaire}}</strong> : {{contact.Email}}</p></div></md-list-item></md-list><p class=\"p-16\" \nng-if=\"vm.EnvoiEmail && !vm.contacts.length\">Aucun destinataire email disponible.</p></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler\n</md-button><md-button class=\"send-button md-accent md-raised\" ng-if=\"!vm.EnvoiEmail && vm.EnvoiPlateforme\" \nng-click=\"vm.generateAcompteFacture()\" ng-disabled=\"vm.confirmationEnCours\">Envoyer à SuperPDP</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/commandes/factures/dialogs/transmission.html","<md-dialog aria-label=\"Envoyer la facture ou l’avoir\" flex=\"60\" flex-xs=\"100\"><form name=\"envoiForm\" \nng-submit=\"vm.envoyer(envoiForm)\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nEnvoyer {{vm.document.NumeroFacture}}</h2></div></md-toolbar><md-dialog-content class=\"p-24\"><p>\n{{vm.document.RaisonSocial}}</p><div ng-if=\"!vm.resultat\"><md-input-container class=\"md-block\"><label>Envoyer par\n</label><md-select ng-model=\"vm.canal\" ng-disabled=\"vm.busy\" required><md-option value=\"email\">Email</md-option>\n<md-option value=\"plateforme\">SuperPDP</md-option><md-option value=\"email_plateforme\">Email et SuperPDP</md-option>\n</md-select></md-input-container><div ng-if=\"vm.avecEmail()\"><md-input-container class=\"md-block\"><label>Destinataire\n</label><md-select ng-model=\"vm.IDContact_Responsables\" ng-disabled=\"vm.busy\" required><md-option \nng-repeat=\"contact in vm.contacts\" ng-value=\"contact.IDContact_Responsables\">\n{{contact.Prenom}} {{contact.Nom}} — {{contact.Email}}</md-option></md-select></md-input-container><p \nng-if=\"vm.contactError\" class=\"md-warn-fg\">{{vm.contactError}}</p><p ng-if=\"!vm.contacts.length\">\nAucun destinataire email disponible.</p><md-checkbox ng-if=\"vm.dejaEnvoye\" ng-model=\"vm.confirmerRenvoi\">\nCette facture a déjà été envoyée par email. Confirmer le renvoi.</md-checkbox></div><p ng-if=\"vm.canal !== \'email\'\">\nLa plateforme et le serveur contrôlent l’éligibilité du document et les doublons de transmission.</p></div><div \nng-if=\"vm.resultat\"><p ng-repeat=\"canal in vm.resultat.Canaux\">{{canal.Canal}} : {{canal.Statut}}<span \nng-if=\"canal.Message\"> — {{canal.Message}}</span></p><p>Fermer pour actualiser la liste et consulter les statuts.</p>\n</div><p ng-if=\"vm.error\" class=\"md-warn-fg\" role=\"alert\">{{vm.error}}</p><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.busy\"></md-progress-linear></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.fermer()\" \nng-disabled=\"vm.busy\">{{vm.resultat ? \'Fermer\' : \'Annuler\'}}</md-button><md-button ng-if=\"!vm.resultat\" type=\"submit\" \nclass=\"md-raised md-accent\" \nng-disabled=\"vm.busy || envoiForm.$invalid || !vm.autorise() || (vm.avecEmail() && (!vm.IDContact_Responsables || (vm.dejaEnvoye && !vm.confirmerRenvoi)))\">\nEnvoyer</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/commandes/fournisseurs/dialogs/fournisseurs-dialog.html","<md-dialog class=\"fournisseur-dialog\" flex=\"80\"><form name=\"fournisseurForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content ms-scroll><span class=\"md-title\">Fournisseur/fabricant</span><p></p><div layout=\"row\" class=\"mb-16\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Etat</label><md-select ng-model=\"vm.Fournisseur.Actif\" \nrequired name=\"Actif\"><md-option ng-value=\"1\">Activé</md-option><md-option ng-value=\"0\">Désactivé</md-option>\n</md-select><div ng-messages=\"fournisseurForm[\'Actif\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div></div></md-input-container></div><div layout=\"row\" class=\"mb-16\"><md-input-container md-no-float flex><label>\nFabricant</label><input name=\"Imap\" ng-model=\"vm.Fournisseur.Fabricant\" required><div \nng-messages=\"fournisseurForm[\'Fabricant\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" class=\"mb-16\"><md-input-container md-no-float flex><label>\nMétier / activité</label><input name=\"Metier\" ng-model=\"vm.Fournisseur.Metier\" required><div \nng-messages=\"fournisseurForm[\'Metier\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" \nclass=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveFournisseur()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"fournisseurForm.$invalid || vm.showSpinner\" \naria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/commandes/produits/dialogs/categorie-dialog.html","<md-dialog class=\"categorie-dialog\" flex=\"80\"><form name=\"categorieForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content ms-scroll><span class=\"md-title\">Editer une catégorie</span><p></p><div layout=\"row\">\n<md-input-container md-no-float flex><label>Nom de la catégorie</label><input ng-model=\"vm.categorie.Categorie\" \ntype=\"text\" required></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nflex><label>Catégorie parente</label><md-select ng-model=\"vm.categorie.IDParent\" \nmd-on-open=\"openSelectSearch(\'#header-searchbox\')\" placeholder=\"Catégorie parente\" required required \nmd-on-close=\"clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" \nid=\"header-searchbox\" force-select-focus type=\"search\" placeholder=\"Chercher une catégorie\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option ng-value=\"0\">\nPas de parent</md-option><div ng-repeat=\"categorie in vm.categories\" \nng-include=\"\'app/main/commandes/produits/dialogs/tree-renderer.html\'\" onload=\"value=categorie; indent=0\"></div>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" \nng-click=\"vm.saveCategorie()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"categorieForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/commandes/produits/dialogs/tree-renderer.html","<md-option ng-value=\"{{categorie.IDCategorie}}\"><span class=\"muted\" \nng-repeat=\"item in vm.getNumber(indent) track by $index\">┊&nbsp;&nbsp;</span> {{categorie.Categorie}}</md-option><div \nng-repeat=\"categorie in categorie.SousCategories\" \nng-include=\"\'app/main/commandes/produits/dialogs/tree-renderer.html\'\" onload=\"value=categorie; indent=indent+1\"></div>");
$templateCache.put("app/main/courriers/courrier/dialogs/courrier-dialog.html","<md-dialog class=\"courrier-dialog\" flex=\"80\"><form name=\"paiementForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content ms-scroll><span class=\"md-title\">{{vm.titre}}</span><p></p><textarea ui-tinymce=\"tinymceOptions\" \nng-model=\"vm.contenu\" md-detect-hidden=\"true\"></textarea><input type=\"file\" name=\"fileupload\" id=\"fileupload\" \nstyle=\"display: none\"></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" \nclass=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveContenu()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"paiementForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\">\n<span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/courriers/courrier/dialogs/destinataires-dialog.html","<md-dialog class=\"destinataires-dialog\" flex=\"80\"><form name=\"paiementForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content ms-scroll><span class=\"md-title\">\nDéfinissez les destinataires ({{vm.destinataires.Total}} sélectionné(s))</span><p></p><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-input-container><label>Type de destinataire</label>\n<md-select ng-model=\"vm.destinataires.Type\" ng-change=\"vm.totalSelect();\"><md-option value=\"Saisir\">Saisir une adresse\n</md-option><md-option value=\"Contacts\">Adresses des contacts</md-option></md-select></md-input-container><div \nng-show=\"vm.destinataires.Type==\'Saisir\'\" layout=\"column\" flex><md-input-container class=\"md-block\"><label>Adresse\n</label><textarea ng-click=\"vm.totalSelect();\" ng-model=\"vm.destinataires.Adresse\" rows=\"5\" md-select-on-focus>\n</textarea></md-input-container></div><div ng-hide=\"vm.destinataires.Type==\'Saisir\'\" layout=\"column\" flex>\n<md-input-container><label>Filtrer par contacts</label><md-select ng-model=\"vm.destinataires.IDContacts\" \nmd-on-open=\"openSelectSearch(\'#header-searchcontact\')\" multiple=\"multiple\" ng-change=\"vm.totalSelect();\" \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" \nng-disabled=\"vm.destinataires.IDEmployes.length>0 || vm.destinataires.Statuts.length>0 || vm.destinataires.Villes.length>0\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" id=\"header-searchcontact\" force-select-focus \ntype=\"search\" placeholder=\"Rechercher...\" class=\"demo-header-searchbox md-text\"></md-select-header><md-option \nng-value=\"contact.IDContact\" ng-repeat=\"contact in vm.contacts | filter:searchTerm\">{{contact.RaisonSocial}}\n</md-option></md-select></md-input-container><md-input-container ng-hide=\"vm.courrier.IDContacts\"><label>\nFiltrer par commerciaux</label><md-select ng-model=\"vm.destinataires.IDEmployes\" multiple=\"multiple\" \nng-change=\"vm.totalSelect();\" ng-disabled=\"vm.destinataires.IDContacts.length>0\"><md-option \nng-value=\"employe.IDEmploye\" ng-repeat=\"employe in vm.employes\">{{employe.Civilite}} {{employe.Prenom}} {{employe.Nom}}\n</md-option></md-select></md-input-container><md-input-container ng-hide=\"vm.courrier.IDContacts\"><label>\nFiltrer par statuts</label><md-select ng-model=\"vm.destinataires.Statuts\" multiple=\"multiple\" \nng-change=\"vm.totalSelect();\" ng-disabled=\"vm.destinataires.IDContacts.length>0\"><md-option value=\"Client\">Client\n</md-option><md-option value=\"Prospect\">Prospect</md-option><md-option value=\"Suspect\">Suspect</md-option><md-option \nvalue=\"Ancien client\">Ancien client</md-option><md-option value=\"Annulé\">Annulé</md-option></md-select>\n</md-input-container><md-input-container ng-hide=\"vm.courrier.IDContacts\"><label>Filtrer par villes</label><md-select \nng-model=\"vm.destinataires.Villes\" md-on-open=\"openSelectSearch(\'#header-searchville\')\" multiple=\"multiple\" \nng-change=\"vm.totalSelect();\" md-on-close=\"clearSearchVille()\" data-md-container-class=\"selectdemoSelectHeader\" \nng-disabled=\"vm.destinataires.IDContacts.length>0\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchVille\" id=\"header-searchville\" type=\"search\" placeholder=\"Rechercher...\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"ville.IDVille\" \nng-repeat=\"ville in vm.villes | filter:searchVille\">{{ville.CodePostal}} - {{ville.NomVille}}</md-option></md-select>\n</md-input-container><md-input-container ng-hide=\"vm.courrier.IDContacts\"><label>Type de responsables</label><md-select\n ng-model=\"vm.destinataires.TypeResponsable\" multiple=\"multiple\" ng-change=\"vm.totalSelect();\"><md-option \nvalue=\"Principal\">Principal</md-option><md-option value=\"Secondaire\">Secondaire</md-option><md-option \nvalue=\"Sélection\">Sélection</md-option></md-select></md-input-container><div flex-xs flex=\"50\" class=\"mt-16\" \nng-show=\"vm.destinataires.TypeResponsable.indexOf(\'Sélection\') > -1\"><md-checkbox aria-label=\"Select All\" \nng-checked=\"isChecked()\" md-indeterminate=\"isIndeterminate()\" ng-click=\"toggleAll()\">Tout <span ng-if=\"isChecked()\">\ndése</span><span ng-if=\"!isChecked()\">sé</span>lectionner</md-checkbox></div><div flex=\"100\" \nng-repeat=\"item in vm.destinataires.SelectResponsables\" \nng-show=\"vm.destinataires.TypeResponsable.indexOf(\'Sélection\') > -1\"><md-checkbox \nng-checked=\"exists(item.IDContact_Responsables, vm.destinataires.IDSelectResponsables)\" \nng-click=\"toggle(item.IDContact_Responsables, vm.destinataires.IDSelectResponsables)\">{{ item.RaisonSociale }}<br>\n<small>{{ item.Civilite }} {{ item.Prenom }} {{ item.Nom }} ({{ item.Fonction }} - {{ item.PrincipalOuSecondaire }})\n</small></md-checkbox></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" \nng-click=\"vm.saveDestinataires()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"paiementForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/courriers/courriers/dialogs/apercu-dialog.html","<md-dialog class=\"details-courrier-dialog compact\" flex=\"80\" id=\"invoice\"><md-dialog-content ms-scroll \nclass=\"courrier-container\"><div class=\"header\"><div id=\"header\"><div ng-bind-html=\"vm.courrier.Header\"></div></div>\n</div><div class=\"content\"><div layout=\"row\" layout-wrap layout-align=\"end center\"><div flex=\"50\"></div><div flex=\"50\" \nflex-xs=\"100\" flex-sm=\"55\"><div id=\"adresse\"><div layout=\"column\" layout-wrap layout-align=\"start start\"><strong>\n{{vm.courrier.NbrDestinataires}} Destinataire(s)</strong><br><div \nng-hide=\"vm.courrier.Type==\'Saisir\' || vm.courrier.Type==\'Aucune\'\">Entreprise<br>Adresse<br>Code postal - Ville<br>\n</div><div ng-show=\"vm.courrier.Type==\'Saisir\'\"><span style=\"white-space: pre-line\">{{vm.courrier.Adresse}}</span>\n</div></div></div></div></div><div layout=\"row\" layout-wrap layout-align=\"end\"><div flex=\"50\"></div><div flex=\"50\" \nflex-xs=\"100\" flex-sm=\"55\"><p class=\"mt-0 mb-8\">\nA {{vm.courrier.Ville}}, le {{vm.courrier.Date || \'(saisir une date)\' |date:\'EEEE dd LLLL yyyy\' }}</p></div></div><div \nlayout=\"column\" layout-wrap><div flex=\"100\"><br><p class=\"mt-0 mb-8\"><strong><u>Objet</u> : </strong><span \nng-bind-html=\"vm.courrier.Objet\" ng-show=\"vm.courrier.Objet\"></span><span ng-hide=\"vm.courrier.Objet\">aucun</span></p>\n<p class=\"mt-0 mb-8\" ng-show=\"vm.courrier.Pj\"><strong><u>Référence(s)</u> : </strong>{{ vm.courrier.Pj || \'aucune\' }}\n</p><p class=\"mt-0 mb-8\" ng-show=\"vm.courrier.LRAR\">Lettre recommandée avec accusé de réception</p></div></div><div \nclass=\"contenu\"><div ng-bind-html=\"vm.courrier.Contenu\"></div></div></div><div class=\"footer\"><div id=\"footer\"><div \nng-bind-html=\"vm.courrier.Footer\"></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><div></div>\n<md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Fermer</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/courriers/courriers/dialogs/destinataires-dialog.html","<md-dialog class=\"destinataires-courrier-dialog compact\" flex=\"80\" id=\"invoice\"><md-dialog-content ms-scroll \nclass=\"courrier-container\"><div flex \nng-show=\"vm.destinataires.Type!=\'Saisir\' && (vm.destinataires.employes.length>0 || vm.destinataires.Statuts || vm.destinataires.villes.length>0)\">\n<md-toolbar layout=\"row\" class=\"md-hue-3\"><div class=\"md-toolbar-tools\"><span>Filtres</span></div></md-toolbar><md-list\n flex><md-list-item class=\"secondary-button-padding\" ng-repeat=\"employe in vm.destinataires.employes\"><strong>\nContacts de : </strong>{{employe.Civilite}} {{employe.Prenom}} {{employe.Nom}}</md-list-item><md-list-item \nclass=\"md-1-line\" ng-repeat=\"ville in vm.destinataires.villes\"><strong>Contacts à : </strong>{{ville.NomVille}}\n</md-list-item><md-list-item class=\"md-1-line\" ng-show=\"vm.destinataires.Statuts\"><strong>Status : </strong>\n{{vm.destinataires.Statuts}}</md-list-item></md-list></div><div flex ng-hide=\"vm.destinataires.Type==\'Saisir\'\">\n<md-toolbar layout=\"row\" class=\"md-hue-3\"><div class=\"md-toolbar-tools\"><span>\n{{vm.destinataires.NbrDestinataires}} destinataires sélectionné(s)</span></div></md-toolbar><md-list flex><md-list-item\n class=\"md-1-line\" ng-repeat=\"contact in vm.destinataires.responsables\"><p>{{ contact.contacts.RaisonSocial }}</p>\n<small>\n{{ contact.Civilite }} {{ contact.Prenom }} {{ contact.Nom }} ({{ contact.Fonction }} - {{ contact.PrincipalOuSecondaire }})\n</small></md-list-item></md-list></div><div flex ng-show=\"vm.destinataires.Type==\'Saisir\'\"><md-toolbar layout=\"row\" \nclass=\"md-hue-3\"><div class=\"md-toolbar-tools\"><span>Adresse</span></div></md-toolbar><md-list flex><md-list-item \nclass=\"md-1-line\"><span style=\"white-space: pre-line\">{{vm.destinataires.Adresse}}</span></md-list-item></md-list>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><div></div><md-button ng-click=\"vm.closeDialog();\" class=\"\" \nng-disabled=\"vm.showSpinner\">Fermer</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/parametres/employes/profil/profil.html","<div id=\"profil\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start end\"><div layout=\"column\" layout-align=\"space-between start\" flex><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"vm.go(\'/administration/employes\')\" ng-if=\"Permission==\'Super Admin\'\">\n<md-icon md-font-icon=\"icon-keyboard-backspace\" class=\"icon\"></md-icon></md-button><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" \nsrc=\"{{vm.employe.Avatar ? vm.employe.Avatar : \'assets/images/avatars/profile.jpg\'}}\"><div class=\"name\">\n{{vm.employe.Civilite}} {{vm.employe.Prenom}} {{vm.employe.Nom| uppercase}}</div></div><div class=\"ml-24\" \nng-show=\"vm.IDEmploye != vm.employe.IDEmploye\"><md-button editable-select=\"vm.employe.Active\" \nonaftersave=\"vm.updateStatus()\" e-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-grey-500-bg white-fg\" \nng-show=\"vm.employe.Active == 2\" selected=\"true\"><md-icon md-font-icon=\"icon icon-pencil-box\"></md-icon>Corbeille\n<md-tooltip md-direction=\"bottom\">Cliquez pour modifier le status de l\'employé</md-tooltip></md-button><md-button \neditable-select=\"vm.employe.Active\" onaftersave=\"vm.updateStatus()\" \ne-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-green-500-bg white-fg\" \nng-show=\"vm.employe.Active == 1\" selected=\"true\"><md-icon md-font-icon=\"icon icon-pencil-box\"></md-icon>Activé\n<md-tooltip md-direction=\"bottom\">Cliquez pour modifier le status de l\'employé</md-tooltip></md-button><md-button \neditable-select=\"vm.employe.Active\" onaftersave=\"vm.updateStatus()\" \ne-ng-options=\"s.value as s.text for s in vm.statuses\" class=\"md-warn-bg\" ng-show=\"vm.employe.Active == 0\" \nselected=\"true\"><md-icon md-font-icon=\"icon icon-pencil-box\"></md-icon>Bloqué<md-tooltip md-direction=\"bottom\">\nCliquez pour modifier le status de l\'employé</md-tooltip></md-button></div></div></div><md-button class=\"md-raised\" \nng-click=\"vm.avatar($event, vm.employe)\"><md-icon md-font-icon=\"icon-file-image-box \"></md-icon>Photo de profil\n</md-button></div><div class=\"content\" layout=\"row\" layout-wrap ms-scroll style=\"min-height: calc(100vh - 63px)\">\n<md-tabs md-dynamic-height flex><md-tab><md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">\naccount_box</md-icon>A propos</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/parametres/employes/profil/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span><md-icon class=\"material-icons-outlined font-size-20\">timeline</md-icon>Historique</span>\n</md-tab-label><md-tab-body><md-content class=\"log-tab\" \nng-include=\"\'app/main/parametres/employes/profil/tabs/logs/logs.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</div></div>");
$templateCache.put("app/main/parametres/images/dialogs/images-dialog.html","<md-dialog class=\"image-dialog\" flex=\"66\"><form name=\"imageForm\" class=\"md-inline-form\" novalidate><md-dialog-content \nms-scroll><div ngf-drop ngf-select ng-model=\"files\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" \nngf-multiple=\"{{vm.multipleUpload}}\" ngf-allow-dir=\"true\" accept=\"image/*\" ngf-pattern=\"\'image/*\'\" layout=\"column\" \nlayout-align=\"center center\"><h2 ng-if=\"!vm.progress && vm.multipleUpload == true\">Faites glisser les photos ici</h2>\n<h2 ng-if=\"!vm.progress && vm.multipleUpload == false\">Faites glisser une photo ici</h2><p ng-if=\"!vm.progress\">\nVous pouvez également...</p><span ng-if=\"!vm.progress && vm.multipleUpload == true\" class=\"p-8 md-primary-bg\" \nstyle=\"cursor:pointer\">Sélectionner des photos sur votre ordinateur</span> <span \nng-if=\"!vm.progress && vm.multipleUpload == false\" class=\"p-8 md-primary-bg\" style=\"cursor:pointer\">\nSélectionner une photo sur votre ordinateur</span><h2 ng-if=\"vm.progress\">Importation en cours...</h2>\n<md-progress-linear md-mode=\"determinate\" ng-if=\"vm.progress\" value=\"{{vm.progress}}\"></md-progress-linear></div><div \nngf-no-file-drop>Le glisser/déposé n\'est pas utilisable sur ce navigateur</div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.closeDialog()\" class=\"md-raised\">Annuler</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/parametres/droits/droits/droits.html","<div id=\"droits\" class=\"page-layout simple inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Configurations</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Employés</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Permissions</span></div><div \nclass=\"h1\" layout=\"row\" layout-align=\"start start\"><md-icon class=\"material-icons-outlined ml-0 mr-8\">badge</md-icon>\n<span>Permissions</span></div></div><div hide-xs><md-button class=\"md-raised\" ng-click=\"vm.editerPermission($event)\">\n<md-icon class=\"material-icons-outlined\">add_box</md-icon><span>Ajouter une permission</span></md-button></div></div>\n<div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><div class=\"main\"><div \nclass=\"permission-list card border brad-16\" flex-gt-md=\"80\" flex-gt-lg=\"60\" flex><md-list class=\"p-0\"><md-list-item \nng-repeat=\"permission in vm.permissions\" class=\"pt-16 pb-16 md-3-line md-white-bg border-bottom contact-list\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{permission.Permission}}</h3><h4 style=\"white-space: unset\">\n{{permission.Droits.toString().split(\',\').join(\', \')}}</h4></div><md-menu class=\"md-secondary\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.editerPermission($event, permission)\">\nEditer</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button \nng-click=\"vm.supprimerPermission($event, permission)\">Supprimer définitivement</md-button></md-menu-item>\n</md-menu-content></md-menu></md-list-item><md-list-item class=\"no-results md-white-bg\" \nng-show=\"vm.permissions.length === 0\"><p>Aucun résultat...</p></md-list-item></md-list></div><md-button hide-gt-xs \nid=\"btn-smartphone\" class=\"md-fab\" ng-click=\"vm.editerPermission()\"><md-icon md-font-icon=\"icon icon-plus\"></md-icon>\n</md-button></div></div></div>");
$templateCache.put("app/main/parametres/employes/employes/employes.html","<div id=\"employes\" class=\"page-layout simple inner-sidenav\"><div class=\"header\" layout=\"row\" layout-xs=\"column\" \nlayout-align-xs=\"start start\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start\" \nflex-xs=\"100\" class=\"mr-16\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">Configurations</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">Employés</span></div><div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start start\">\n<md-icon md-font-icon=\"icon-worker\" class=\"ml-0 mr-8\"></md-icon><md-icon class=\"material-icons-outlined ml-0 mr-8\">\nengineering</md-icon><span>Employés</span></div></div><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"search\" \nclass=\"search\" type=\"text\" ng-model=\"vm.search\" placeholder=\"Rechercher\" flex> <button ng-if=\"vm.search\" \nng-click=\"vm.search=\'\';vm.searchBox.trigger(\'keyup\');\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></div><div\n hide show-gt-md><md-button class=\"md-raised\" ng-click=\"vm.go(\'/administration/employes/profil/0\')\"><md-icon \nmd-font-icon=\"icon icon-plus\"></md-icon><span>Ajouter un compte</span></md-button></div></div><div class=\"content\" \nmd-background-bg layout=\"row\" layout-align=\"start start\"><md-button id=\"btn-smartphone\" hide-gt-md class=\"md-fab\" \nng-click=\"vm.go(\'/administration/employes/profil/0\')\"><md-icon md-font-icon=\"icon icon-plus\"></md-icon></md-button><div\n class=\"main\"><div class=\"employe-list border brad-16\" flex-gt-md=\"100\" flex-gt-lg=\"70\" flex><md-subheader \nclass=\"md-no-sticky md-white-bg\"><div layout=\"row\" layout-align=\"space-between center\"><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"Tri\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-sort-alphabetical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.listOrder = \'RaisonSocial\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'RaisonSocial\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span>Contact</span> \n<small>(De A à Z)</small></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.listOrder = \'RaisonSocial\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'RaisonSocial\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span>Contact</span> \n<small>(De Z à A)</small></md-button></md-menu-item></md-menu-content></md-menu></div></md-subheader><div \nng-repeat=\"employe in vm.employes | filter: vm.search   | orderBy: vm.listOrder :vm.listOrderAsc\" \nclass=\"md-white-bg border-bottom contact-list\"><div layout=\"column\" layout-fill><div layout=\"row\" class=\"pl-16 pr-16\" \nlayout-align=\"start start\" layout-align-gt-sm=\"start center\"><div flex-gt-sm=\"40\" flex-md=\"50\" flex-sm=\"90\" \nflex-xs=\"90\" layout=\"row\" class=\"pt-16 pb-16\" layout-align=\"start start\"><div class=\"pr-8\"><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"employe.Active == 1\"></i> <i \nclass=\"icon-close-circle red-500-fg\" ng-hide=\"employe.Active == 1\"></i></div><div><strong>\n{{employe.Civilite}} {{employe.Prenom}} {{employe.Nom | uppercase}} </strong>({{employe.Permission}})<br>\nDernière connexion : {{employe.DerniereConnexion}}<div hide-gt-sm ng-show=\"employe.NomAdresse\"><br><strong>\n{{employe.NomAdresse}}</strong><br><a \nhref=\"https://www.google.fr/maps/place/{{employe.Adresse}}+{{employe.CodePostal}}+{{employe.Ville}}\" target=\"_blank\">\n{{employe.Adresse}} - {{employe.CodePostal}} {{employe.Ville}}</a></div><div hide-gt-md \nng-show=\"employe.Telephones.length>0\"><br><strong>Téléphone(s) :</strong><br><a \nng-repeat=\" telephone in employe.Telephones \" class=\"phone-contact mr-10\" href=\"tel:{{telephone}}\">\n{{telephone|phoneNumber}}<br></a></div></div></div><p class=\"mt-0 mt-16\" flex-gt-sm=\"30\" hide-sm hide-xs flex-md=\"40\">\n<strong>{{employe.NomAdresse}}</strong><br><a \nhref=\"https://www.google.fr/maps/place/{{employe.Adresse}}+{{employe.CodePostal}}+{{employe.Ville}}\" target=\"_blank\">\n{{employe.Adresse}} - {{employe.CodePostal}} {{employe.Ville}}</a></p><p class=\"phone\" hide-md hide-sm hide-xs \nflex-gt-sm=\"20\"><strong>Téléphone(s) :</strong><br><a ng-repeat=\" telephone in employe.Telephones \" \nclass=\"phone-contact mr-10\" href=\"tel:{{telephone}}\">{{telephone|phoneNumber}}<br></a></p><div \nclass=\"actions pt-16 pb-16\" layout=\"row\" layout-align=\"end center\" flex-gt-sm=\"10\"><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.detailsEmployes(employe)\">Détails\n</md-button></md-menu-item><md-divider></md-divider><md-menu-item ng-if=\"vm.IDEmploye!=employe.IDEmploye\"><md-button \nng-click=\"vm.supprimerEmployes($event, employe)\">Supprimer définitivement</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\">\n<p>Aucun résultat...</p></md-list-item></div></div></div></div>");
$templateCache.put("app/main/parametres/regles_bancaires/dialogs/regle-dialog.html","<md-dialog aria-label=\"Règle de catégorisation bancaire\" class=\"regle-bancaire-dialog\"><form name=\"regleForm\" \nng-submit=\"vm.enregistrer(regleForm)\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{vm.regle.IDRegleCategorisationBancaire ? \'Modifier la règle\' : \'Ajouter une règle\'}}</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.annuler()\" type=\"button\" aria-label=\"Fermer\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\">\n<md-input-container><label>Libellé</label><input ng-model=\"vm.regle.Libelle\" name=\"Libelle\" maxlength=\"100\" required>\n<div ng-messages=\"regleForm.Libelle.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><md-input-container><label>Mot-clé ou texte recherché</label><input ng-model=\"vm.regle.Motif\" \nname=\"Motif\" maxlength=\"191\" required><div class=\"hint\">\nLa recherche ne tient pas compte des majuscules, accents ou ponctuations.</div><div \nng-messages=\"regleForm.Motif.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container><div layout=\"row\" layout-xs=\"column\" layout-gap=\"16\"><md-input-container flex><label>Champ analysé\n</label><md-select ng-model=\"vm.regle.Champ\" required><md-option ng-repeat=\"champ in vm.champs\" value=\"{{champ}}\">\n{{champ}}</md-option></md-select></md-input-container><md-input-container flex><label>Correspondance</label><md-select \nng-model=\"vm.regle.Correspondance\" required><md-option ng-repeat=\"correspondance in vm.correspondances\" \nvalue=\"{{correspondance}}\">{{correspondance}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\" layout-gap=\"16\"><md-input-container flex><label>Catégorie proposée</label><md-select \nng-model=\"vm.regle.Categorie\" required><md-option ng-repeat=\"categorie in vm.categories\" value=\"{{categorie}}\">\n{{categorie}}</md-option></md-select></md-input-container><md-input-container flex><label>Statut proposé</label>\n<md-select ng-model=\"vm.regle.StatutPropose\" required><md-option ng-repeat=\"statut in vm.statuts\" value=\"{{statut}}\">\n{{statut}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\" \nlayout-gap=\"24\"><md-input-container flex=\"40\"><label>Priorité</label><input type=\"number\" min=\"0\" max=\"1000\" \nng-model=\"vm.regle.Priorite\" name=\"Priorite\" required></md-input-container><md-checkbox ng-model=\"vm.regle.Actif\" \nng-true-value=\"1\" ng-false-value=\"0\">Règle active</md-checkbox></div><div class=\"md-warn-fg\" ng-if=\"vm.erreur\">\n{{vm.erreur}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \ntype=\"button\" ng-click=\"vm.annuler()\">Annuler</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" \nng-disabled=\"regleForm.$invalid || vm.busy\">Enregistrer</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites/sites/dialogs/site-options-dialog.html","<md-dialog class=\"site-options-dialog\" flex=\"80\"><form name=\"siteOptionsForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content ms-scroll><span class=\"md-title\">Edition d\'un site internet</span><p></p><md-input-container \nmd-no-float flex class=\"mt-8 mb-24 md-block\"><label>URL du site internet</label><input ng-model=\"vm.SiteWeb.URL\" \nng-keyup=\"vm.testSiteExist(vm.SiteWeb.URL)\" name=\"URL\" type=\"url\" required class=\"mb-5\" placeholder=\"https://\"><div \nng-messages=\"siteOptionsForm.URL.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"newURLFailed\"><span>{{status}}</span></div></div></md-input-container><md-input-container md-no-float flex \nclass=\"mt-8 mb-24 md-block\"><label>Contact</label><md-select ng-model=\"vm.SiteWeb.IDContact\" name=\"IDContact\" \nmd-on-open=\"openSelectSearch(\'#header-searchbox\', 1000)\" placeholder=\"Choisir un client\" \nmd-on-close=\"clearSearchTerm()\" required ng-change=\"vm.SiteWeb.ListeIDCommandes = []\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" force-select-focus type=\"search\" \nplaceholder=\"Chercher un client\" class=\"header-searchbox md-text\" id=\"header-searchbox\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"contact in vm.contacts | filter:searchTerm\" ng-value=\"{{contact.IDContact}}\">{{contact.RaisonSocial}}\n</md-option></md-select><div ng-messages=\"siteOptionsForm.IDContact.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-input-container class=\"mt-8 mb-24 md-block\" md-no-float \nflex><label>{{vm.SiteWeb.ListeIDCommandes.length}} Commande(s) associée(s)</label><md-select \nng-model=\"vm.SiteWeb.ListeIDCommandes\" multiple=\"multiple\" name=\"sites\"><md-option ng-value=\"commande.IDCommande\" \nng-repeat=\"commande in vm.commandes | filter: vm.customFilter | orderBy: vm.sortByNumber\">{{commande.NumeroCommande}} \n<span ng-if=\"commande.NomCommande\">- {{commande.NomCommande}}</span></md-option></md-select></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" \nng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveSiteWeb()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"siteOptionsForm.$invalid || vm.showSpinner\" \naria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"column\" layout-gt-md=\"row\" \nlayout-align=\"start center\"><div class=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start center\" \nlayout-align-gt-md=\"start start\"><div class=\"title\" translate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div>\n<div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optionnel</div></div></md-button></div></div>\n<div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Précédent</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Suivant\n</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\"><span ng-show=\"MsStepper.isFormValid()\">Terminer\n</span> <span ng-show=\"!MsStepper.isFormValid()\">Des étapes sont incomplètes</span></md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/achats/factures/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"column\" \nlayout-align=\"start start\"><span class=\"logo-icon\"><md-icon class=\"material-icons-outlined s28\">receipt_long</md-icon>\n<span class=\"logo-text ml-10\">Factures & avoirs</span> </span><span class=\"secondary-text\">\n{{vm.recordsTotal}} documents</span></div><md-button class=\"md-raised m-0\" ng-if=\"vm.droits(\'edition\')\" \nng-disabled=\"vm.busy\" ng-click=\"vm.editer($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span>Facture / avoir\n</span></md-button></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" layout=\"column\">\n<md-button class=\"item\" ng-class=\"{\'blue-600-bg white-fg\':vm.filterStatus === \'\'}\" ng-click=\"vm.filterChange(\'\')\">\n<md-icon class=\"material-icons-outlined s21\">view_list</md-icon><span class=\"title\">Tous les documents</span>\n</md-button><div class=\"item subheader mb-0\">Filtrer</div><md-button class=\"item\" \nng-repeat=\"statut in [\'À payer\', \'Partiellement réglée\', \'Échue\', \'Réglée\', \'À imputer\', \'Imputé\', \'Partiellement remboursé\', \'Remboursé\']\" \nng-click=\"vm.filterChange(statut)\" ng-class=\"{\'blue-600-bg white-fg\':vm.filterStatus === statut}\"><md-icon \nclass=\"material-icons-outlined s21\" \nng-bind=\"statut === \'Réglée\' ? \'check_circle\' : (statut === \'Échue\' ? \'event_busy\' : \'schedule\')\"></md-icon><span \nclass=\"title\">{{statut}}</span> <span class=\"blue-grey-600-bg white-fg pull-right badge\" ng-if=\"vm.compteurs[statut]\">\n{{vm.compteurs[statut]}}</span></md-button></div></md-content>");
$templateCache.put("app/main/collaborateurs/frais/edition/dialogs/note-dialog.html","<md-dialog class=\"note-dialog\" flex=\"80\"><form name=\"notesForm\" class=\"md-inline-form\" novalidate \nenctype=\"multipart/form-data\"><md-dialog-content ms-scroll><span class=\"md-title\">Votre dépense</span><p></p><div \nlayout=\"row\"><md-input-container flex><label>Date</label><md-datepicker ng-model=\"vm.note.Date\" name=\"Date\" \nmd-open-on-focus required></md-datepicker><div ng-messages=\"notesForm[\'Date\'].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex>\n<label>Libellé</label><input ng-model=\"vm.note.Label\" type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Type</label><md-select ng-model=\"vm.note.Type\" \nname=\"Type\" required ng-change=\"vm.note.TVA20 = 0; vm.note.TVA10 = 0; vm.note.TVA055 = 0; \"><md-optgroup \nlabel=\"Déplacements\"><md-option value=\"Avion\">Avion</md-option><md-option value=\"Bus\">Bus</md-option><md-option \nvalue=\"Frais kilométriques\">Frais kilométriques</md-option><md-option value=\"Métro\">Métro</md-option><md-option \nvalue=\"Parking\">Parking</md-option><md-option value=\"Péage\">Péage</md-option><md-option value=\"Taxi\">Taxi</md-option>\n<md-option value=\"Train\">Train</md-option></md-optgroup><md-optgroup label=\"Hébergement / restauration\"><md-option \nvalue=\"Hôtel\">Hôtel</md-option><md-option value=\"Restaurant midi\">Restaurant midi</md-option><md-option \nvalue=\"Restaurant soir\">Restaurant soir</md-option></md-optgroup><md-optgroup label=\"Carburant\"><md-option \nvalue=\"Carburant (essence)\">Carburant (essence)</md-option><md-option value=\"Carburant (Gazole)\">Carburant (gazole)\n</md-option></md-optgroup><md-optgroup label=\"Autres\"><md-option value=\"Avance sur frais\">Avance sur frais</md-option>\n<md-option value=\"Divers\">Divers</md-option><md-option value=\"Fourniture\">Petit équipement / Fourniture</md-option>\n<md-option value=\"Téléphone portable\">Téléphone portable</md-option></md-optgroup></md-select><div \nng-messages=\"notesForm[\'Type\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div ng-show=\"vm.note.Type!=\'\'\"><fieldset \nng-show=\"vm.note.Type!=\'Frais kilométriques\' && vm.note.Type!=\'Frais kilométriques vélo\'\" class=\"p-16 mt-16\"><legend>\nMontants de la dépense</legend><div layout=\"row\" \nng-show=\"vm.note.Type!=\'Frais kilométriques\' && vm.note.Type!=\'Frais kilométriques vélo\'\"><md-input-container \nmd-no-float flex><label>Total TTC</label><input ng-model=\"vm.note.TotalTTC\" type=\"number\" name=\"TotalTTC\" \nmin=\"{{+vm.note.TVA20 + +vm.note.TVA10 + +vm.note.TVA055}}\" \nng-required=\"vm.note.Type!=\'Frais kilométriques\' && vm.note.Type!=\'Frais kilométriques vélo\'\"><md-icon \nmd-font-icon=\"icon icon-currency-eur\"></md-icon><div ng-messages=\"notesForm[\'TotalTTC\'].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"min\">\nLe total TTC doit être supérieur aux montants de la TVA</div></div></md-input-container></div><div layout=\"row\" \nng-show=\"!vm.note.SansTVA && !vm.note.TVAInconnue && vm.note.Type!=\'Frais kilométriques\' && vm.note.Type!=\'Frais kilométriques vélo\' && vm.note.Type!=\'Avance sur frais\'\">\n<md-input-container md-no-float flex><label>TVA 20%</label><input ng-model=\"vm.note.TVA20\" type=\"number\"><md-icon \nmd-font-icon=\"icon icon-currency-eur \"></md-icon></md-input-container><md-input-container md-no-float flex \nclass=\"ml-8 mr-8\"><label>TVA 10%</label><input ng-model=\"vm.note.TVA10\" type=\"number\"><md-icon \nmd-font-icon=\"icon icon-currency-eur \"></md-icon></md-input-container><md-input-container md-no-float flex><label>\nTVA 5.5%</label><input ng-model=\"vm.note.TVA055\" type=\"number\"><md-icon md-font-icon=\"icon icon-currency-eur \">\n</md-icon></md-input-container></div><div layout=\"row\" \nng-show=\"!vm.note.TVAInconnue && vm.note.Type!=\'Frais kilométriques\' && vm.note.Type!=\'Frais kilométriques vélo\' && vm.note.Type!=\'Avance sur frais\'\">\n<md-input-container class=\"md-block\" md-no-float flex><md-checkbox ng-model=\"vm.note.SansTVA\" \nng-change=\"vm.note.TVA20 = 0; vm.note.TVA10 = 0; vm.note.TVA055 = 0; \" aria-label=\"Sans TVA\" class=\"m-0\">\nLa TVA n\'est pas indiquée sur mon justificatif</md-checkbox></md-input-container></div><div layout=\"row\" \nng-show=\"vm.note.Type!=\'Frais kilométriques && !vm.note.SansTVA\' && vm.note.Type!=\'Frais kilométriques vélo\' && vm.note.Type!=\'Avance sur frais\'\">\n<md-input-container class=\"md-block\" md-no-float flex><md-checkbox ng-model=\"vm.note.TVAInconnue\" \naria-label=\"Sans TVA\" ng-change=\"vm.note.TVA20 = 0; vm.note.TVA10 = 0; vm.note.TVA055 = 0; \" class=\"m-0\">\nJe ne connais pas le taux</md-checkbox></md-input-container></div></fieldset><fieldset \nng-show=\"vm.note.Type==\'Frais kilométriques\' || vm.note.Type==\'Frais kilométriques vélo\'\" class=\"p-16 mt-16\"><legend>\nVotre trajet</legend><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>\nMoyen de transport personnel</label><md-select ng-model=\"vm.note.IDEmployes_Vehicule\" name=\"IDEmployes_Vehicule\" \nng-required=\"vm.note.Type==\'Frais kilométriques\' || vm.note.Type==\'Frais kilométriques vélo\'\"><md-option \nng-repeat=\"vehicule in vm.vehicules\" value=\"{{vehicule.IDEmployes_Vehicule}}\">{{vehicule.Marque}} {{vehicule.Modele}} \n<span ng-if=\"vehicule.Immatriculation\">- {{vehicule.Immatriculation}}</span></md-option></md-select><div \nng-messages=\"notesForm[\'IDEmployes_Vehicule\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div class=\"grey-50-bg p-8 brad-16\"><div layout=\"row\"><md-input-container class=\"md-block\" \nmd-no-float flex><label>Adresse de départ</label><md-select name=\"AdresseDepartType\" \nng-model=\"vm.note.AdresseDepartType\" \nng-required=\"vm.note.Type==\'Frais kilométriques\' || vm.note.Type==\'Frais kilométriques vélo\'\"><md-option \nvalue=\"personnelle\">Une de mes adresses</md-option><md-option value=\"contact\">Adresse d\'un contact</md-option>\n<md-option value=\"manuelle\">Saisie manuelle</md-option></md-select><div \nng-messages=\"notesForm[\'AdresseDepartType\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.note.AdresseDepartType==\'manuelle\'\"><md-input-container \nmd-no-float flex><label>Saisir votre adresse de départ</label><input ng-model=\"vm.note.AdresseDepart\" \ng-places-autocomplete autocomplete=\"off\" type=\"text\" name=\"AdresseDepart\" \nng-required=\"vm.note.Type==\'Frais kilométriques\' || vm.note.Type==\'Frais kilométriques vélo\'\" \nng-required=\"vm.note.AdresseDepartType==\'manuelle\'\"><div ng-messages=\"notesForm[\'AdresseDepart\'].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" \nng-if=\"vm.note.AdresseDepartType==\'personnelle\'\"><md-input-container class=\"md-block\" md-no-float flex><label>\nMon adresse</label><md-select ng-model=\"vm.note.IDMonAdresseDepart\" name=\"IDMonAdresseDepart\" \nmd-on-open=\"openSelectSearch(\'#header-searchbox\', 1000)\" placeholder=\"Sélectionner mon adresse\" \nmd-on-close=\"clearSearchTerm()\" ng-required=\"vm.note.AdresseDepartType==\'personnelle\'\"><md-option \nng-repeat=\"adresse in vm.adressesEmploye\" value=\"{{adresse.IDAdresse}}\">\n{{adresse.NomAdresse}} : {{adresse.Adresse}} - {{adresse.Ville.CodePostal}} {{adresse.Ville.NomVille}}</md-option>\n</md-select><div ng-messages=\"notesForm[\'IDMonAdresseDepart\'].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" \nng-if=\"vm.note.AdresseDepartType==\'contact\'\"><md-input-container class=\"md-block\" md-no-float flex><label>Contact\n</label><md-select ng-model=\"vm.note.IDClientDepart\" name=\"IDClientDepart\" \nmd-on-open=\"openSelectSearch(\'#header-searchbox\', 1000)\" placeholder=\"Sélectionner l\'adresse du client\" \nmd-on-close=\"clearSearchTerm()\" ng-required=\"vm.note.AdresseDepartType==\'contact\'\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" force-select-focus type=\"search\" \nplaceholder=\"Chercher un client\" class=\"header-searchbox md-text\" id=\"header-searchbox\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"{{adresses.RaisonSocial}}\" \nng-repeat=\"adresses in vm.adressesContacts | filter:searchTerm\"><md-option ng-repeat=\"adresse in adresses.adresses \" \nvalue=\"{{adresse.IDAdresse}}\">{{adresse.Adresse}} - {{adresse.Ville.CodePostal}} {{adresse.Ville.NomVille}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"notesForm[\'IDClientDepart\'].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\">\n<md-icon class=\"material-icons-outlined s48\">download</md-icon></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Adresse d\'arrivée</label><md-select name=\"AdresseArriveeType\" \nng-model=\"vm.note.AdresseArriveeType\" \nng-required=\"vm.note.Type==\'Frais kilométriques\' || vm.note.Type==\'Frais kilométriques vélo\'\"><md-option \nvalue=\"personnelle\">Une de mes adresses</md-option><md-option value=\"contact\">Adresse d\'un contact</md-option>\n<md-option value=\"manuelle\">Saisie manuelle</md-option></md-select><div \nng-messages=\"notesForm[\'AdresseArriveeType\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.note.AdresseArriveeType==\'manuelle\'\"><md-input-container \nmd-no-float flex><label>Saisir votre adresse d\'arrivée</label><input ng-model=\"vm.note.AdresseArrivee\" \ng-places-autocomplete autocomplete=\"off\" type=\"text\" name=\"AdresseArrivee\" \nng-required=\"vm.note.Type==\'Frais kilométriques\' || vm.note.Type==\'Frais kilométriques vélo\'\" \nng-required=\"vm.note.AdresseArriveeType==\'manuelle\'\"><div ng-messages=\"notesForm[\'AdresseArrivee\'].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" \nng-if=\"vm.note.AdresseArriveeType==\'personnelle\'\"><md-input-container class=\"md-block\" md-no-float flex><label>\nMon adresse</label><md-select ng-model=\"vm.note.IDMonAdresseArrivee\" name=\"IDMonAdresseArrivee\" \nmd-on-open=\"openSelectSearch(\'#header-searchbox\', 1000)\" placeholder=\"Sélectionner mon adresse\" \nmd-on-close=\"clearSearchTerm()\" ng-required=\"vm.note.AdresseArriveeType==\'personnelle\'\"><md-option \nng-repeat=\"adresse in vm.adressesEmploye\" value=\"{{adresse.IDAdresse}}\">\n{{adresse.NomAdresse}} : {{adresse.Adresse}} - {{adresse.Ville.CodePostal}} {{adresse.Ville.NomVille}}</md-option>\n</md-select><div ng-messages=\"notesForm[\'IDMonAdresseArrivee\'].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" \nng-if=\"vm.note.AdresseArriveeType==\'contact\'\"><md-input-container class=\"md-block\" md-no-float flex><label>Contact\n</label><md-select ng-model=\"vm.note.IDClientArrivee\" name=\"IDClientArrivee\" \nmd-on-open=\"openSelectSearch(\'#header-searchbox\', 1000)\" placeholder=\"Sélectionner l\'adresse du client\" \nmd-on-close=\"clearSearchTerm()\" ng-required=\"vm.note.AdresseArriveeType==\'contact\'\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" force-select-focus type=\"search\" \nplaceholder=\"Chercher un client\" class=\"header-searchbox md-text\" id=\"header-searchbox\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"{{adresses.RaisonSocial}}\" \nng-repeat=\"adresses in vm.adressesContacts | filter:searchTerm\"><md-option ng-repeat=\"adresse in adresses.adresses \" \nvalue=\"{{adresse.IDAdresse}}\">{{adresse.Adresse}} - {{adresse.Ville.CodePostal}} {{adresse.Ville.NomVille}}</md-option>\n</md-optgroup></md-select><div ng-messages=\"notesForm[\'IDClientArrivee\'].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><md-checkbox ng-model=\"vm.note.allerretour\" aria-label=\"Sans TVA\" class=\"m-0\">\nAller-retour</md-checkbox></md-input-container></div></fieldset><fieldset class=\"p-16 mt-16\" \nng-show=\"vm.note.Type==\'Métro\' || vm.note.Type==\'Avion\' || vm.note.Type==\'Bus\' || vm.note.Type==\'Taxi\' || vm.note.Type==\'Train\' || vm.note.Type==\'Hôtel\' || vm.note.Type==\'Restaurant midi\' || vm.note.Type==\'Restaurant soir\'\">\n<legend>Participation</legend><div layout=\"row\" \nng-show=\"vm.note.Type==\'Hôtel\' ||vm.note.Type==\'Restaurant midi\' || vm.note.Type==\'Restaurant soir\'\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Contacts</label><md-select \nng-model=\"vm.note.ContactsResponsables\" name=\"Contacts\" md-on-open=\"openSelectSearch(\'#header-searchbox\', 1000)\" \nplaceholder=\"Sélectionner les clients\" md-on-close=\"clearSearchTerm()\" multiple=\"multiple\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"searchTerm\" force-select-focus type=\"search\" \nplaceholder=\"Chercher un client\" class=\"header-searchbox md-text\" id=\"header-searchbox\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"{{contact.RaisonSocial}}\" \nng-repeat=\"contact in vm.responsables | filter:searchTerm\"><md-option ng-repeat=\"responsable in contact.Responsables \" \nvalue=\"{{responsable.IDContact_Responsables}}\">{{responsable.Civilite}} {{responsable.Prenom}} {{responsable.Nom}} \n<small ng-if=\"responsable.Fonction\">({{responsable.Fonction}})</small></md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"row\" \nng-show=\"vm.note.Type==\'Métro\' || vm.note.Type==\'Avion\' || vm.note.Type==\'Bus\' || vm.note.Type==\'Taxi\' || vm.note.Type==\'Train\' || vm.note.Type==\'Hôtel\' || vm.note.Type==\'Restaurant midi\' || vm.note.Type==\'Restaurant soir\'\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Invités internes</label><md-select \nng-model=\"vm.note.Employes\" name=\"Employes \" multiple=\"multiple\"><md-option \nng-repeat=\"employe in vm.employesSimple.data\" value=\"{{employe.value}}\">{{employe.label}}</md-option></md-select>\n</md-input-container></div><p \nng-show=\"vm.note.InvitesExterne.length>0 && (vm.note.Type==\'Hôtel\' || vm.note.Type==\'Restaurant midi\' || vm.note.Type==\'Restaurant soir\')\">\nInvité(s) externe(s) :</p><div layout=\"row\" class=\"mb-8\" \nng-repeat=\"InvitesExterne in vm.note.InvitesExterne track by $index\" layout-align=\"space-between center\" \nng-show=\"vm.note.Type==\'Hôtel\' ||vm.note.Type==\'Restaurant midi\' || vm.note.Type==\'Restaurant soir\'\">\n<md-input-container md-no-float flex><label>Nom/Prénom</label><input ng-model=\"vm.note.InvitesExterne[$index].nom\" \nname=\"InvitesExterne{{$index}}\" type=\"text\" required><div ng-messages=\"notesForm[\'InvitesExterne\'+$index].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container>-<md-input-container md-no-float flex>\n<label>Société</label><input ng-model=\"vm.note.InvitesExterne[$index].societe\" name=\"InvitesExterne{{$index}}\" \ntype=\"text\" required><div ng-messages=\"notesForm[\'InvitesExterne\'+$index].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.note.InvitesExterne.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n layout=\"row\" ng-show=\"vm.note.Type==\'Hôtel\' ||vm.note.Type==\'Restaurant midi\' || vm.note.Type==\'Restaurant soir\'\">\n<md-button class=\"ml-0\" ng-click=\"vm.note.InvitesExterne.push({nom:null,societe:null})\">+ Ajouter un invité externe\n</md-button></div></fieldset><fieldset class=\"p-16 mt-16\" \nng-show=\"vm.note.Type!=\'Frais kilométriques\' && vm.note.Type!=\'Frais kilométriques vélo\'\"><legend>Justificatifs\n</legend><div layout=\"row\"><md-input-container md-no-float flex><label>Justificatifs</label><input \nng-model=\"vm.note.fileInput\" ngf-select id=\"file\" type=\"file\" multiple=\"multiple\"></md-input-container></div><md-list>\n<md-list-item class=\"secondary-button-padding\" \nng-repeat=\"(key, Justificatif) in vm.note.Justificatifs track by $index\"><a \nhref=\"/datas/files/frais/{{Justificatif.file}}\" target=\"_blank\">{{Justificatif.name}}</a><md-button \nclass=\"md-secondary md-icon-button mt-16\" ng-click=\"vm.note.Justificatifs.splice($index, 1)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-list-item></md-list></fieldset><div layout=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><md-checkbox ng-model=\"vm.note.Refacturables\" \naria-label=\"Refacturable\">A refacturer au contact final</md-checkbox></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" \nng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.savenote()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"notesForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span\n ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/commandes/commandes/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"column\" \nlayout-align=\"start start\"><span class=\"logo-icon\"><md-icon class=\"material-icons-outlined s28\">shopping_cart</md-icon>\n<span class=\"logo-text ml-10\">Commandes</span> </span><span class=\"secondary-text\">{{vm.recordsTotal}} commandes</span>\n</div><md-button class=\"md-raised m-0\" ng-click=\"vm.ajouterCommande()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<span>Commande</span></md-button></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" \nlayout=\"column\"><md-button class=\"item\" ng-class=\"{\'blue-600-bg white-fg\':vm.filterStatus ===\'\'}\" \nng-click=\"vm.filterChange(\'\')\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"material-icons-outlined S21\">view_list</md-icon><span class=\"title\">Toutes les commandes</span></div>\n</md-button><div class=\"item subheader mb-0\">Filtrer</div><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'Facturée\')\" ng-class=\"{\'green-600-bg white-fg\':vm.filterStatus ===\'Facturée\'}\"><md-icon \nmd-font-icon=\"icon-check-all\" class=\"S21\"></md-icon><span class=\"title\">Facturées</span></md-button><md-button \nclass=\"item\" aria-label=\"Starred\" ng-click=\"vm.filterChange(\'Renouvelée\')\" \nng-class=\"{\'green-900-bg md-hue-2  white-fg\':vm.filterStatus ===\'Renouvelée\'}\"><md-icon \nclass=\"material-icons-outlined S21\">event_available</md-icon><span class=\"title\">Renouvelées</span></md-button>\n<md-button class=\"item\" aria-label=\"Starred\" ng-click=\"vm.filterChange(\'Non renouvelée\')\" \nng-class=\"{\'md-red-900-bg md-hue-2 white-fg\':vm.filterStatus ===\'Non renouvelée\'}\"><md-icon \nclass=\"material-icons-outlined S21\">event_busy</md-icon><span class=\"title\">Non renouvelées</span></md-button>\n<md-button class=\"item\" aria-label=\"Starred\" ng-click=\"vm.filterChange(\'A renouveler\')\" \nng-class=\"{\'md-orange-600-bg white-fg\':vm.filterStatus ===\'A renouveler\'}\"><md-icon \nclass=\"material-icons-outlined S21\">restore</md-icon><span class=\"title\">A renouveler</span> <span \nclass=\"md-orange-900-bg white-fg pull-right badge\" ng-if=\"vm.nbrCommandesParEtats[\'A renouveler\']\">\n{{vm.nbrCommandesParEtats[\'A renouveler\']}}</span></md-button><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'Signée\')\" ng-class=\"{\'md-teal-600-bg white-fg\':vm.filterStatus ===\'Signée\'}\"><md-icon \nclass=\"material-icons-outlined S21\">draw</md-icon><span class=\"title\">Signées</span> <span \nclass=\"md-teal-900-bg white-fg pull-right badge\" ng-if=\"vm.nbrCommandesParEtats[\'Signées\']\">\n{{vm.nbrCommandesParEtats[\'Signées\']}}</span></md-button><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'Validée\')\" ng-class=\"{\'md-cyan-700-bg white-fg\':vm.filterStatus ===\'Validée\'}\"><md-icon \nmd-font-icon=\"icon-check\" class=\"S21\"></md-icon><span class=\"title\">Validées</span> <span \nclass=\"md-cyan-900-bg white-fg pull-right badge\" ng-if=\"vm.nbrCommandesParEtats[\'Validées\']\">\n{{vm.nbrCommandesParEtats[\'Validées\']}}</span></md-button><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'En attente\')\" ng-class=\"{\'red-600-bg white-fg\':vm.filterStatus ===\'En attente\'}\"><md-icon \nmd-font-icon=\"icon-timer-sand\" class=\"S21\"></md-icon><span class=\"title\">En attentes</span> <span \nclass=\"red-900-bg white-fg pull-right badge\" ng-if=\"vm.nbrCommandesParEtats[\'En attentes\']\">\n{{vm.nbrCommandesParEtats[\'En attentes\']}}</span></md-button><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'Brouillon\')\" ng-class=\"{\'md-amber-600-bg white-fg\':vm.filterStatus ===\'Brouillon\'}\"><md-icon\n class=\"material-icons-outlined S21\">inventory_2</md-icon><span class=\"title\">Brouillons</span> <span \nclass=\"yellow-900-bg white-fg pull-right badge\" ng-if=\"vm.nbrCommandesParEtats[\'Brouillons\']\">\n{{vm.nbrCommandesParEtats[\'Brouillons\']}}</span></md-button><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'Annulée\')\" ng-class=\"{\'md-grey-500-bg white-fg\':vm.filterStatus ===\'Annulée\'}\"><md-icon \nclass=\"material-icons-outlined S21\">cancel</md-icon><span class=\"title\">Annulées</span></md-button></div></md-content>");
$templateCache.put("app/main/commandes/factures/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"column\" \nlayout-align=\"start start\"><span class=\"logo-icon\"><md-icon class=\"material-icons-outlined s28\">credit_score</md-icon>\n<span class=\"logo-text ml-10\">Factures</span> </span><span class=\"secondary-text\">{{vm.recordsTotal}} factures</span>\n</div></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" ng-class=\"{\'blue-600-bg white-fg\':vm.filterStatus ===\'\'}\" ng-click=\"vm.filterChange(\'\')\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"material-icons-outlined S21\">view_list</md-icon><span \nclass=\"title\">Toutes les factures</span></div></md-button><div class=\"item subheader mb-0\">Filtrer</div><md-button \nclass=\"item\" aria-label=\"Non contrôlées\" ng-click=\"vm.filterChange(\'Non contrôlée\')\" \nng-class=\"{\'grey-600-bg white-fg\':vm.filterStatus ===\'Non contrôlée\'}\"><md-icon class=\"material-icons-outlined S21\">\nhistory</md-icon><span class=\"title\">Non contrôlées</span> <span class=\"grey-600-bg white-fg pull-right badge\" \nng-if=\"vm.nbrFacturesParEtats[\'Non contrôlée\']\">{{vm.nbrFacturesParEtats[\'Non contrôlée\']}}</span></md-button>\n<md-button class=\"item\" aria-label=\"Starred\" ng-click=\"vm.filterChange(\'Soldée\')\" \nng-class=\"{\'green-600-bg white-fg\':vm.filterStatus ===\'Soldée\'}\"><md-icon md-font-icon=\"icon-check-all\" class=\"S21\">\n</md-icon><span class=\"title\">Soldées</span></md-button><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'En cours\')\" ng-class=\"{\'md-orange-600-bg white-fg\':vm.filterStatus ===\'En cours\'}\"><md-icon \nclass=\"material-icons-outlined S21\">restore</md-icon><span class=\"title\">En cours</span> <span \nclass=\"md-orange-900-bg white-fg pull-right badge\" ng-if=\"vm.nbrFacturesParEtats[\'En cours\']\">\n{{vm.nbrFacturesParEtats[\'En cours\']}}</span></md-button><md-button class=\"item\" aria-label=\"Partiellement réglées\" \nng-click=\"vm.filterChange(\'Partiellement réglée\')\" \nng-class=\"{\'md-orange-bg white-fg\':vm.filterStatus ===\'Partiellement réglée\'}\"><md-icon \nclass=\"material-icons-outlined S21\">timelapse</md-icon><span class=\"title\">Partiellement réglées</span> <span \nclass=\"md-orange-bg white-fg pull-right badge\" ng-if=\"vm.nbrFacturesParEtats[\'Partiellement réglée\']\">\n{{vm.nbrFacturesParEtats[\'Partiellement réglée\']}}</span></md-button><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'Impayée\')\" ng-class=\"{\'md-red-900-bg md-hue-2 white-fg\':vm.filterStatus ===\'Impayée\'}\">\n<md-icon class=\"material-icons-outlined S21\">event_busy</md-icon><span class=\"title\">Impayées</span> <span \nclass=\"md-orange-900-bg white-fg pull-right badge\" ng-if=\"vm.nbrFacturesParEtats[\'Impayée\']\">\n{{vm.nbrFacturesParEtats[\'Impayée\']}}</span></md-button></div></md-content>");
$templateCache.put("app/main/contacts/contacts/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"column\" \nlayout-align=\"start start\"><span class=\"logo-icon\"><md-icon class=\"material-icons-outlined s28\">people</md-icon><span \nclass=\"logo-text ml-10\">Contacts</span> </span><span class=\"secondary-text\">{{vm.recordsTotal}} contacts</span></div>\n<md-button class=\"md-raised m-0\" ng-click=\"vm.go(\'/contacts/nouveau\')\"><md-icon class=\"material-icons-outlined\">\nperson_add</md-icon><span>Contact</span></md-button></div><md-content class=\"content\" flex ms-scroll><div \nclass=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" \nng-class=\"{\'blue-600-bg white-fg\':vm.filterStatus ===\'\'}\" ng-click=\"vm.filterChange(\'\')\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"material-icons-outlined s21\">groups</md-icon><span class=\"title\">\nTous les contacts</span></div></md-button><div class=\"item subheader mb-0\">Filtrer</div><md-button class=\"item\" \naria-label=\"Starred\" ng-click=\"vm.filterChange(\'Client\')\" \nng-class=\"{\'md-green-500-bg white-fg\':vm.filterStatus ===\'Client\'}\"><md-icon class=\"material-icons-outlined s21\">\nhow_to_reg</md-icon><span class=\"title\">Les clients</span> <span class=\"md-green-700-bg white-fg pull-right badge\" \nng-if=\"vm.nbrContactsParEtats[\'Les clients\']\">{{vm.nbrContactsParEtats[\'Les clients\']}}</span></md-button><md-button \nclass=\"item\" aria-label=\"Starred\" ng-click=\"vm.filterChange(\'Prospect\')\" \nng-class=\"{\'md-cyan-700-bg white-fg\':vm.filterStatus ===\'Prospect\'}\"><md-icon class=\"material-icons-outlined s21\">\npush_pin</md-icon><span class=\"title\">Les prospects</span> <span class=\"md-cyan-900-bg white-fg pull-right badge\" \nng-if=\"vm.nbrContactsParEtats[\'Les prospects\']\">{{vm.nbrContactsParEtats[\'Les prospects\']}}</span></md-button>\n<md-button class=\"item\" aria-label=\"Starred\" ng-click=\"vm.filterChange(\'Suspect\')\" \nng-class=\"{\'md-blue-grey-500-bg white-fg\':vm.filterStatus ===\'Suspect\'}\"><md-icon class=\"material-icons-outlined s21\">\nperson_search</md-icon><span class=\"title\">Les suspects</span> <span \nclass=\"md-blue-grey-700-bg white-fg pull-right badge\" ng-if=\"vm.nbrContactsParEtats[\'Les suspects\']\">\n{{vm.nbrContactsParEtats[\'Les suspects\']}}</span></md-button><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'Fin d\\\'activité\')\" \nng-class=\"{\'md-grey-500-bg white-fg\':vm.filterStatus ===\'Fin d\\\'activité\'}\"><md-icon \nclass=\"material-icons-outlined s21\">door_back</md-icon><span class=\"title\">Fin d\'activité</span> <span \nclass=\"md-grey-700-bg white-fg pull-right badge\" ng-if=\"vm.nbrContactsParEtats[\'Fin activité\']\">\n{{vm.nbrContactsParEtats[\'Fin activité\']}}</span></md-button><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'Ancien client\')\" ng-class=\"{\'md-red-500-bg white-fg\':vm.filterStatus ===\'Ancien client\'}\">\n<md-icon class=\"material-icons-outlined s21\">person_remove</md-icon><span class=\"title\">Anciens clients</span> <span \nclass=\"md-red-700-bg white-fg pull-right badge\" ng-if=\"vm.nbrContactsParEtats[\'Anciens clients\']\">\n{{vm.nbrContactsParEtats[\'Anciens clients\']}}</span></md-button><md-button class=\"item\" aria-label=\"Starred\" \nng-click=\"vm.filterChange(\'Annulé\')\" ng-class=\"{\'md-grey-500-bg white-fg\':vm.filterStatus ===\'Annulé\'}\"><md-icon \nclass=\"material-icons-outlined s21\">person_remove</md-icon><span class=\"title\">Annulés</span> <span \nclass=\"md-grey-700-bg white-fg pull-right badge\" ng-if=\"vm.nbrContactsParEtats[\'Annulés\']\">\n{{vm.nbrContactsParEtats[\'Annulés\']}}</span></md-button></div></md-content>");
$templateCache.put("app/main/contacts/liste_produits/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"column\" \nlayout-align=\"start start\"><span class=\"logo-icon\"><md-icon class=\"material-icons-outlined s28\">inventory</md-icon>\n<span class=\"logo-text ml-10\">Produits</span> </span><span class=\"secondary-text\">{{vm.recordsTotal}} produits</span>\n</div></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" ng-class=\"{\'blue-600-bg white-fg\':vm.filterStatus ===\'\'}\" ng-click=\"vm.filterChange(\'\')\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"material-icons-outlined S21\">view_list</md-icon><span \nclass=\"title\">Tous les produits</span></div></md-button><div class=\"item subheader mb-0\">Filtrer</div><md-button \nclass=\"item\" aria-label=\"Starred\" ng-click=\"vm.filterChange(\'0\')\" \nng-class=\"{\'md-blue-bg white-fg\':vm.filterStatus ===\'0\'}\"><md-icon class=\"material-icons-outlined S21\">restore\n</md-icon><span class=\"title\">En cours</span> <span class=\"md-blue-900-bg white-fg pull-right badge\" \nng-if=\"vm.recordsProduitsEnCours\">{{vm.recordsProduitsEnCours}}</span></md-button><md-button class=\"item\" \naria-label=\"Starred\" ng-click=\"vm.filterChange(\'1\')\" \nng-class=\"{\'md-grey-bg md-hue-2 white-fg\':vm.filterStatus ===\'1\'}\"><md-icon md-font-icon=\"icon-check-all\" class=\"S21\">\n</md-icon><span class=\"title\">Terminés</span></md-button></div></md-content>");
$templateCache.put("app/main/contacts/nouveau/stepper-steps/horizontal/step-1.html","<div class=\"md-inline-form\"><p>Qui est votre <span class=\"text-bold\">nouveau contact</span> ?</p><div layout=\"column\" \nlayout-gt-xs=\"column\" flex flex=\"100\" flex-gt-sm=\"70\"><md-input-container md-no-float flex=\"100\" flex-gt-xs=\"50\">\n<label>Raison Social / Identité</label><input type=\"text\" ng-model=\"vm.contact.RaisonSocial\" name=\"RaisonSocial\" \nrequired><div ng-messages=\"horizontalStepper.horizontalStep1.RaisonSocial.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container><p>Quel <span class=\"text-bold\">la forme juridique</span>\n de ce contact ?</p><div layout=\"row\" class=\"\"><md-input-container class=\"md-block\" md-no-float flex><label>Structure\n</label><md-select ng-model=\"vm.contact.Structure.IDEntreprises_Structure\" name=\"Structure\" placeholder=\"Structure\" \nrequired><md-option ng-repeat=\"structure in vm.structures\" ng-value=\"{{structure.IDEntreprises_Structure}}\" \nng-click=\"vm.select_structure(structure)\">{{structure.Acronyme}} <small ng-if=\"structure.Label\">: {{structure.Label}}\n</small></md-option></md-select><div ng-messages=\"horizontalStepper.horizontalStep1.Structure.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" \nng-if=\"vm.structures_selected.SIREN\"><md-input-container md-no-float flex><label>SIREN</label><input \nng-model=\"vm.contact.Structure.SIREN\" ng-change=\"vm.testSirenExist(vm.contact.Structure.SIREN)\" name=\"SIREN\" \ntype=\"text\" ng-pattern=\"/^[0-9]*$/\" md-minlength=\"9\" minlength=\"9\" md-maxlength=\"9\" maxlength=\"9\" \nng-required=\"vm.structures_selected.SIREN\"><div ng-messages=\"horizontalStepper.horizontalStep1.SIREN.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"pattern\">\nLe SIREN doit être composé uniquement de chiffre</div><div ng-message=\"minlength\">Le SIREN est formé de 9 chiffres\n</div></div></md-input-container></div><md-input-container md-no-float flex><input ng-model=\"se\" type=\"hidden\" \nng-required=\"!vm.sirenValide  && vm.structures_selected.SIREN\"></md-input-container><div \nclass=\"md-warn-bg ng-binding ng-scope p-16 font-size-12 brad-16\" ng-if=\"!vm.sirenValide && vm.sirenTrouve != \'\'\"><p \nclass=\"m-0\">Ce numéro de SIREN est déjà utilisé par le contact : <a class=\"white-fg\" \nhref=\"/contacts/profil/{{vm.sirenTrouve.IDContact}}\"><md-tooltip md-direction=\"bottom\">Accéder à sa fiche</md-tooltip>\n{{vm.sirenTrouve.RaisonSocial}}</a></p></div></div></div>");
$templateCache.put("app/main/contacts/nouveau/stepper-steps/horizontal/step-2.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"column\" flex flex=\"100\" flex-gt-sm=\"70\"><p>\nA t-il une ou plusieurs <span class=\"text-bold\">activités</span> ?</p><div class=\"listes-activites\"><div layout=\"row\" \nng-repeat=\"Activites in vm.contact.Activites track by $index\" class=\"{{$index}}activite activites\"><md-input-container \nmd-no-float flex class=\"\"><md-autocomplete required md-no-cache=\"true\" md-selected-item=\"vm.contact.Activites[$index]\" \nmd-items=\"item in vm.querySearch(searchText)\" md-select-on-match=\"true\" md-search-text=\"searchText\" \nmd-autofocus=\"true\" md-min-length=\"0\" md-clear-button=\"false\" md-no-cache=\"true\" md-require-match=\"true\" \nmd-floating-label=\"Activité\" md-input-name=\"activites-{{$index}}\" md-item-text=\"item.display\"><md-item-template><span \nmd-highlight-text=\"searchText\" md-highlight-flags=\"i\">{{item.display}}</span></md-item-template><md-not-found>\nAucune activité trouvée pour <b>\"{{searchText}}\"</b>. <a ng-click=\"vm.newActivity(searchText, $event)\">\nL\'ajouter à la base</a></md-not-found><div ng-messages=\"horizontalStepper.horizontalStep2[\'activites-0\'].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-autocomplete></md-input-container><md-button \nng-if=\"$index != 0\" class=\"md-secondary md-icon-button mt-24\" ng-click=\"vm.contact.Activites.splice($index, 1)\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div layout=\"row\"><md-button \naria-label=\"+ Ajouter un site\" class=\"mt-24\" ng-click=\"vm.contact.Activites.push(null)\">+ Ajouter une activité\n</md-button></div></div></div></div>");
$templateCache.put("app/main/contacts/nouveau/stepper-steps/horizontal/step-3.html","<div class=\"md-inline-form\"><p>A t-il un ou plusieurs <span class=\"text-bold\">sites internets</span> ?</p><div \nlayout=\"column\" layout-gt-xs=\"column\" flex flex=\"100\" flex-gt-sm=\"70\"><div layout=\"row\" \nng-repeat=\"Sites in vm.contact.Sites track by $index\"><md-input-container md-no-float flex class=\"\"><label>\nSite internet {{($index == 0) ? \"principal\":\"suplémentaire\"}}</label><input ng-model=\"vm.contact.Sites[$index]\" \ntype=\"text\" required ng-keyup=\"vm.testSiteExist(vm.contact.Sites[$index], $index)\" name=\"Sites[{{$index}}]\" \nng-pattern=\"vm.webregex\"><div ng-messages=\"horizontalStepper.horizontalStep3[vm.siteArray[$index]].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"pattern\">Le format votre l\'URL est incorrecte\n</div><div ng-message=\"newURLFailed\"><span>{{status[$index]}}</span></div></div></md-input-container><md-button \nclass=\"md-secondary md-icon-button mt-16\" ng-click=\"vm.contact.Sites.splice($index, 1); vm.initSiteArray();\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div layout=\"row\"><md-button \nng-click=\"vm.contact.Sites.push(null); vm.initSiteArray();\">+ Ajouter un site</md-button></div></div></div>");
$templateCache.put("app/main/contacts/nouveau/stepper-steps/horizontal/step-4.html","<div class=\"md-inline-form\"><p>Votre contact a t-il des <span class=\"text-bold\">horaires spécifiques</span>\n pour être contacté ?</p><div layout=\"column\" layout-gt-xs=\"column\" flex flex=\"100\" flex-gt-sm=\"70\"><table><tr><td>\n<md-switch ng-model=\"vm.contact.Horaires.Lundi.Etat\" aria-label=\"Lundi\" ng-true-value=\"\'Ouvert\'\" \nng-false-value=\"\'Fermé\'\">Lundi</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Lundi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Lundi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Lundi.Heures[$index].de\" name=\"Lundi_Heures_{{$index}}_de\" placeholder=\"De\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Lundi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Lundi.Heures[$index].a\" name=\"Lundi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Lundi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Lundi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Lundi.Heures.push(null)\">+ Ajouter un horaire</md-button></td></tr></table><md-divider \nng-if=\"vm.contact.Horaires.Lundi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td><md-switch \nng-model=\"vm.contact.Horaires.Mardi.Etat\" aria-label=\"Mardi\" ng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">Mardi\n</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Mardi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Mardi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Mardi.Heures[$index].de\" name=\"Mardi_Heures_{{$index}}_de\" placeholder=\"De\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Mardi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Mardi.Heures[$index].a\" name=\"Mardi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Mardi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Mardi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Mardi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table><md-divider \nng-if=\"vm.contact.Horaires.Mardi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td><md-switch \nng-model=\"vm.contact.Horaires.Mercredi.Etat\" aria-label=\"Mercredi\" ng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">\nMercredi</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Mercredi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Mercredi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Mercredi.Heures[$index].de\" name=\"Mercredi_Heures_{{$index}}_de\" placeholder=\"De\">\n<md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Mercredi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Mercredi.Heures[$index].a\" name=\"Mercredi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option\n ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Mercredi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Mercredi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Mercredi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table>\n<md-divider ng-if=\"vm.contact.Horaires.Mercredi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td>\n<md-switch ng-model=\"vm.contact.Horaires.Jeudi.Etat\" aria-label=\"Jeudi\" ng-true-value=\"\'Ouvert\'\" \nng-false-value=\"\'Fermé\'\">Jeudi</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Jeudi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Jeudi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Jeudi.Heures[$index].de\" name=\"Jeudi_Heures_{{$index}}_de\" placeholder=\"De\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Jeudi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Jeudi.Heures[$index].a\" name=\"Jeudi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Jeudi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Jeudi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Jeudi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table><md-divider \nng-if=\"vm.contact.Horaires.Jeudi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td><md-switch \nng-model=\"vm.contact.Horaires.Vendredi.Etat\" aria-label=\"Vendredi\" ng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">\nVendredi</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Vendredi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Vendredi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Vendredi.Heures[$index].de\" name=\"Vendredi_Heures_{{$index}}_de\" placeholder=\"De\">\n<md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Vendredi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Vendredi.Heures[$index].a\" name=\"Vendredi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option\n ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Vendredi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Vendredi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Vendredi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table>\n<md-divider ng-if=\"vm.contact.Horaires.Vendredi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td>\n<md-switch ng-model=\"vm.contact.Horaires.Samedi.Etat\" aria-label=\"Samedi\" ng-true-value=\"\'Ouvert\'\" \nng-false-value=\"\'Fermé\'\">Samedi</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Samedi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Samedi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Samedi.Heures[$index].de\" name=\"Lundi_Heures_{{$index}}_de\" placeholder=\"De\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Lundi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Samedi.Heures[$index].a\" name=\"Lundi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Lundi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Samedi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Samedi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table><md-divider \nng-if=\"vm.contact.Horaires.Samedi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td><md-switch \nng-model=\"vm.contact.Horaires.Dimanche.Etat\" aria-label=\"Dimanche\" ng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">\nDimanche</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Dimanche.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Dimanche.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Dimanche.Heures[$index].de\" name=\"Dimanche_Heures_{{$index}}_de\" placeholder=\"De\">\n<md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Dimanche_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Dimanche.Heures[$index].a\" name=\"Dimanche_Heures_{{$index}}_a\" placeholder=\"à\"><md-option\n ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep4[\'Dimanche_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">\nObligatoire</div></div></md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Dimanche.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Dimanche.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table>\n<md-divider ng-if=\"vm.contact.Horaires.Dimanche.Etat == \'Ouvert\'\"></md-divider></td></tr></table></div></div>");
$templateCache.put("app/main/contacts/nouveau/stepper-steps/horizontal/step-5.html","<div class=\"md-inline-form\"><p>Qui est <span class=\"text-bold\">l\'interlocuteur principale</span> de ce contact ?</p>\n<div layout=\"column\" layout-gt-xs=\"row\" flex flex=\"100\" flex-gt-sm=\"70\"><md-input-container flex=\"100\" flex-gt-xs=\"20\" \nclass=\"pb-24\"><md-select ng-model=\"vm.contact.Civilite\" name=\"Civilite\" placeholder=\"Civilité\" required><md-option \nvalue=\"Mme\">Mme</md-option><md-option value=\"M.\">M.</md-option></md-select><div \nng-messages=\"horizontalStepper.horizontalStep5.Civilite.$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"40\"><input ng-model=\"vm.contact.Prenom\" \nplaceholder=\"Prénom\" type=\"text\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"40\"><input \nng-model=\"vm.contact.Nom\" placeholder=\"Nom\" name=\"Nom\" type=\"text\" required><div \nng-messages=\"horizontalStepper.horizontalStep5.Nom.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n</div></md-input-container></div><div layout=\"row\" flex flex=\"100\" flex-gt-sm=\"70\"><md-input-container md-no-float \nflex><label>Fonction / Mêtier / Rôle</label><input ng-model=\"vm.contact.Fonction\" name=\"Fonction\" type=\"text\" required>\n<div ng-messages=\"horizontalStepper.horizontalStep5.Fonction.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><p></p><span class=\"md-title\">Téléphone(s)</span><p></p>\n<div layout=\"column\" layout-gt-xs=\"column\" flex flex=\"100\" flex-gt-sm=\"70\"><div layout=\"row\" \nng-repeat=\"Telephones in vm.contact.Telephones track by $index\"><md-input-container md-no-float flex class=\"mb-8\">\n<label>{{($index == 0) ? \"Principal\":\"Suplémentaire\"}}</label><input ng-model=\"vm.contact.Telephones[$index]\" \nname=\"Telephones{{$index}}\" type=\"phone\" minlength=\"10\" maxlength=\"16\" \nng-pattern=\"/^(0|\\+33)[1-9]([-. ]?[0-9]{2}){4}$/\" required><div \nng-messages=\"horizontalStepper.horizontalStep5[\'Telephones\'+$index].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div><div ng-message=\"pattern\">Ce format de numéro n\'est pas accepté</div></div>\n</md-input-container><md-button ng-if=\"$index != 0\" class=\"md-secondary md-icon-button mt-8\" \nng-click=\"vm.contact.Telephones.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nlayout=\"row\"><md-button ng-click=\"vm.contact.Telephones.push(null)\">+ Ajouter un numéro</md-button></div></div><p></p>\n<p></p><span class=\"md-title\">E-mail(s)</span><p></p><div layout=\"column\" layout-gt-xs=\"column\" flex flex=\"100\" \nflex-gt-sm=\"70\"><div layout=\"row\" ng-repeat=\"Emails in vm.contact.Emails track by $index\"><md-input-container \nmd-no-float flex class=\"mb-8\"><label>{{($index == 0) ? \"Principale\":\"Suplémentaire\"}}</label><input \nng-model=\"vm.contact.Emails[$index]\" type=\"email\" name=\"Emails{{$index}}\" \nng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,6}$/\"><div \nng-messages=\"horizontalStepper.horizontalStep5[\'Emails\'+$index].$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div><div ng-message=\"pattern\">Adresse e-mail invalide</div></div></md-input-container>\n<md-button class=\"md-secondary md-icon-button mt-8\" ng-click=\"vm.contact.Emails.splice($index, 1)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div layout=\"row\"><md-button \nng-click=\"vm.contact.Emails.push(null)\">+ Ajouter une adresse e-mail</md-button></div></div></div>");
$templateCache.put("app/main/contacts/nouveau/stepper-steps/horizontal/step-6.html","<div class=\"md-inline-form\"><p>Quelle est <span class=\"text-bold\">l\'adresse</span> principal de ce contact ?</p><div \nlayout=\"column\" layout-gt-xs=\"column\" flex flex=\"100\" flex-gt-sm=\"70\"><div layout=\"row\"><md-input-container \nclass=\"mb-0\" md-no-float flex><label>Nom de l\'adresse</label><input ng-model=\"vm.contact.NomAdresse\" name=\"NomAdresse\" \ntype=\"text\" required md-autofocus><div ng-messages=\"horizontalStepper.horizontalStep6.NomAdresse.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"mb-0\" md-no-float flex><label>Numéro de SIRET</label><input ng-model=\"vm.contact.SIRET\" \nname=\"SIRET\" type=\"text\" ng-pattern=\"/^[0-9]*$/\" maxlength=\"14\" minlength=\"14\" md-maxlength=\"14\"><div \nng-messages=\"horizontalStepper.horizontalStep6.SIRET.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n<div ng-message=\"pattern\">Le SIRET doit être composé uniquement de chiffre</div><div ng-message=\"minlength\">\nLe SIRET est formé de 14 chiffres</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"mb-0\" md-no-float flex><label>Saisissez une adresse complète</label><input \nng-model=\"vm.contact.AdresseComplete\" name=\"AdresseComplete\" g-places-autocomplete autocomplete=\"off\" type=\"text\" \nrequired><div ng-messages=\"horizontalStepper.horizontalStep6.AdresseComplete.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"mb-0\" \nmd-no-float flex><label>Adresse</label><input ng-model=\"vm.contact.Adresse\" name=\"Adresse\" type=\"text\" required><div \nng-messages=\"horizontalStepper.horizontalStep6.Adresse.$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"mb-0\" md-no-float flex><label>\nAdresse2</label><input ng-model=\"vm.contact.Adresse2\" name=\"Adresse2\" type=\"text\"></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"mb-0\" md-no-float flex><label>Code postal</label><input \nng-model=\"vm.contact.CP\" type=\"text\" name=\"CP\" required><div ng-messages=\"horizontalStepper.horizontalStep6.CP.$error\">\n<div ng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"mb-0\" md-no-float flex><label>Ville</label><input ng-model=\"vm.contact.Ville\" type=\"text\" \nname=\"Ville\" required><div ng-messages=\"horizontalStepper.horizontalStep6.Ville.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"mb-0\" \nmd-no-float flex><label>Pays</label><input ng-model=\"vm.contact.Pays\" type=\"text\" name=\"Pays\" required><div \nng-messages=\"horizontalStepper.horizontalStep6.Pays.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n</div></md-input-container></div></div></div>");
$templateCache.put("app/main/contacts/nouveau/stepper-steps/horizontal/step-7.html","<div class=\"md-inline-form\"><p>Quelles <span class=\"text-bold\">les informations légales</span> de ce contact ?</p><div \nlayout=\"column\" layout-gt-xs=\"column\" flex flex=\"100\" flex-gt-sm=\"70\"><h2 \nng-if=\"!vm.structures_selected.RCS && !vm.structures_selected.APE && !vm.structures_selected.TVA && !vm.structures_selected.Capital\" \nclass=\"green-900-fg\">Aucune autre information n\'est nécessaire pour ce type de contact</h2><div layout=\"row\" \nng-if=\"vm.structures_selected.RCS\"><md-input-container md-no-float flex><label>RCS</label><input \nng-model=\"vm.contact.Structure.RCS\" type=\"text\"></md-input-container></div><div layout=\"row\" \nng-if=\"vm.structures_selected.APE\" class=\"mb-24\"><md-input-container md-no-float flex><label>Code APE</label><md-select\n ng-model=\"vm.contact.Structure.IDCodeAPE\" md-on-open=\"openSelectSearch(\'#header-searchbox\')\" placeholder=\"Code APE\" \nmd-on-close=\"clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchTerm\" \nid=\"header-searchbox\" force-select-focus type=\"search\" placeholder=\"Chercher un code APE\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"APE in vm.APE | filter:searchTerm\" ng-value=\"{{APE.IDCodeAPE}}\">{{APE.APE}} : <small>{{APE.APELabel}}\n</small></md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"vm.structures_selected.TVA\">\n<md-input-container md-no-float flex><label>N°TVA Intracommunautaire</label><input ng-model=\"vm.contact.Structure.TVA\" \ntype=\"text\"></md-input-container></div><div layout=\"row\" ng-if=\"vm.structures_selected.Capital\"><md-input-container \nmd-no-float flex><label>Capital Social</label><input ng-model=\"vm.contact.Structure.Capital\" name=\"Capital\" \ntype=\"number\"><div ng-messages=\"horizontalStepper.horizontalStep7.Capital.$error\"><div ng-message=\"number\">\nLe capital social n\'est composé que de chiffres</div></div></md-input-container></div></div></div>");
$templateCache.put("app/main/commandes/produits/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"column\" \nlayout-align=\"start start\"><span class=\"logo-icon\"><md-icon class=\"material-icons-outlined s28\">inventory</md-icon>\n<span class=\"logo-text ml-10\">Produits</span> </span><span class=\"secondary-text\">{{vm.recordsTotal}} produits</span>\n</div><md-button class=\"md-raised m-0\" ng-click=\"vm.ajouterProduit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<span>Produit</span></md-button></div><md-content class=\"content\" flex ms-scroll><div class=\"navigation-simple\" \nlayout=\"column\"><md-button class=\"item\" ng-class=\"{\'blue-600-bg white-fg\':vm.filterStatus ===\'\'}\" \nng-click=\"vm.filterChange(\'\')\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"material-icons-outlined S21\">view_list</md-icon><span class=\"title\">Toutes les catégories</span></div>\n</md-button><div class=\"item subheader mb-0\" layout=\"row\" layout-align=\"space-between \">Catégories <span flex></span>\n<md-button class=\"md-icon-button\" ng-show=\"vm.editCategories\" ng-click=\"vm.editCategories = 0\"><md-tooltip \nmd-direction=\"right\">Terminer</md-tooltip><md-icon class=\"green-500-fg\" \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon></md-button><md-menu ng-hide=\"vm.editCategories\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-tooltip md-direction=\"right\">\nModifier les catégories</md-tooltip><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.editCategorie($event)\">Ajouter</md-button></md-menu-item><md-divider>\n</md-divider><md-menu-item><md-button ng-click=\"vm.editCategories = 1\">Modifier</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div ng-repeat=\"categorie in vm.categories\" \nng-include=\"\'app/main/commandes/produits/sidenavs/main/tree-renderer.html\'\" onload=\"value=categorie; indent=0\"></div>\n</div></md-content>");
$templateCache.put("app/main/commandes/produits/sidenavs/main/tree-renderer.html","<div layout=\"row\" layout-align=\"space-between \"><md-button ng-if=\"!vm.editCategories\" flex=\"grow\" class=\"item\" \nng-class=\"{\'blue-600-bg white-fg\':vm.filterStatus == value.IDCategorie}\" ng-click=\"vm.filterChange(value.IDCategorie)\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"muted\" \nng-repeat=\"item in vm.getNumber(indent) track by $index\">┊&nbsp;&nbsp;</span> <span class=\"title\">{{value.Categorie}}\n</span></div></md-button><div class=\"mb-8\" layout=\"row\" flex layout-align=\" space-between center\"><div \nng-if=\"vm.editCategories\" class=\"pl-16 pr-8\"><span class=\"muted\" \nng-repeat=\"item in vm.getNumber(indent) track by $index\">┊&nbsp;&nbsp;</span> {{value.Categorie}}</div><md-menu \nng-if=\"vm.editCategories\" class=\"md-secondary\" ng-disabled=\"vm.editCategories\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.editCategorie($event, value)\">Modifier</md-button></md-menu-item>\n<md-divider></md-divider><md-menu-item><md-button ng-click=\"vm.deleteCategorie($event, value)\">Supprimer</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div ng-repeat=\"item in value.SousCategories\" \nng-include=\"\'app/main/commandes/produits/sidenavs/main/tree-renderer.html\'\" onload=\"value=item; indent=indent+1\"></div>");
$templateCache.put("app/main/contacts/profil/dialogs/about/activites-dialog.html","<md-dialog class=\"about-dialog activites\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content><span class=\"md-title\">Activités</span><p>Indiquez les activités et/ou les mêtiers du contact.</p>\n<div layout=\"row\" ng-repeat=\"Activites in vm.contact.Activites track by $index\"><md-input-container md-no-float flex>\n<md-autocomplete required md-no-cache=\"true\" md-selected-item=\"vm.contact.Activites[$index]\" \nmd-items=\"item in vm.querySearch(searchText)\" md-select-on-match=\"true\" md-search-text=\"searchText\" md-min-length=\"0\" \nmd-clear-button=\"false\" md-require-match=\"true\" md-floating-label=\"Activité\" md-input-name=\"activites-{{$index}}\" \nmd-item-text=\"item.display\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">\n{{item.display}}</span></md-item-template><md-not-found>Aucune activité trouvée pour <b>\"{{searchText}}\"</b>. <a \nng-click=\"vm.newActivity(searchText, $index)\">L\'ajouter à la base</a></md-not-found><div \nng-messages=\"employeForm[\'activites-0\'].$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-autocomplete></md-input-container><md-button ng-if=\"$index != 0\" class=\"md-secondary md-icon-button mt-24\" \nng-click=\"vm.contact.Activites.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nlayout=\"row\"><md-button aria-label=\"+ Ajouter un site\" ng-click=\"vm.contact.Activites.push(null)\">\n+ Ajouter une activité</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" \nng-click=\"vm.saveContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contacts/profil/dialogs/about/adresses-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Adresse</span><p></p><div layout=\"row\"><md-input-container class=\"md-block\" \nmd-no-float flex><label>Ordre</label><md-select ng-model=\"vm.datastoEdit.PrincipalOuSecondaire\" \nname=\"PrincipalOuSecondaire\" placeholder=\"Ordre\" required><md-option value=\"Secondaire\">Secondaire</md-option>\n<md-option value=\"Principale\">Principale</md-option></md-select><div \nng-messages=\"employeForm.PrincipalOuSecondaire.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Nom de l\'adresse</label><input\n ng-model=\"vm.datastoEdit.NomAdresse\" name=\"NomAdresse\" type=\"text\" required md-autofocus><div \nng-messages=\"employeForm.NomAdresse.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Numéro de SIRET</label><input \nng-model=\"vm.datastoEdit.SIRET\" type=\"text\" name=\"SIRET\" ng-pattern=\"/^[0-9]*$/\" maxlength=\"14\" minlength=\"14\" \nmd-maxlength=\"14\"><div ng-messages=\"employeForm.SIRET.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n<div ng-message=\"pattern\">Le SIRET doit être composé uniquement de chiffre</div><div ng-message=\"minlength\">\nLe SIRET est formé de 14 chiffres</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nmd-no-float flex><label>Saisissez une adresse complète</label><input ng-model=\"vm.datastoEdit.AdresseComplete\" \nname=\"AdresseComplete\" g-places-autocomplete autocomplete=\"off\" type=\"text\" required><div \nng-messages=\"employeForm.AdresseComplete.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Adresse</label><input \nng-model=\"vm.datastoEdit.Adresse\" name=\"Adresse\" type=\"text\" required><div ng-messages=\"employeForm.Adresse.$error\">\n<div ng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>Adresse2</label><input ng-model=\"vm.datastoEdit.Adresse2\" type=\"text\">\n</md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Code postal</label><input \nng-model=\"vm.datastoEdit.CP\" name=\"CP\" type=\"text\" required><div ng-messages=\"employeForm.CP.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>Ville</label><input ng-model=\"vm.datastoEdit.Ville\" name=\"Ville\" \ntype=\"text\" required><div ng-messages=\"employeForm.Ville.$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Pays</label><input\n ng-model=\"vm.datastoEdit.Pays\" name=\"Pays\" type=\"text\" required><div ng-messages=\"employeForm.Pays.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler\n</md-button><md-button type=\"submit\" ng-click=\"vm.saveAdresses()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contacts/profil/dialogs/about/contacts-dialog.html","<md-dialog class=\"about-dialog\" flex=\"80\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Informations du contact</span><p></p><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Ordre</label><md-select ng-model=\"vm.datastoEdit.PrincipalOuSecondaire\" \nname=\"PrincipalOuSecondaire\" placeholder=\"Ordre\" required><md-option value=\"Principal\">Principal</md-option><md-option \nvalue=\"Secondaire\">Secondaire</md-option></md-select><div ng-messages=\"employeForm.PrincipalOuSecondaire.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Civilité</label><md-select \nng-model=\"vm.datastoEdit.Civilite\" name=\"Civilite\" placeholder=\"Civilité\" required><md-option value=\"Mme\">Mme\n</md-option><md-option value=\"M.\">M.</md-option></md-select><div ng-messages=\"employeForm.Civilite.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>Prénom</label><input ng-model=\"vm.datastoEdit.Prenom\" name=\"Prenom\" \ntype=\"text\" required><div ng-messages=\"employeForm.Prenom.$error\"><div ng-message=\"required\">Ce champ est obligatoire\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Nom</label><input \nng-model=\"vm.datastoEdit.Nom\" name=\"Nom\" type=\"text\" required><div ng-messages=\"employeForm.Nom.$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>Fonction / Mêtier / Rôle</label><input ng-model=\"vm.datastoEdit.Fonction\" \nname=\"Fonction\" type=\"text\" required><div ng-messages=\"employeForm.Fonction.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><p></p><p></p><span class=\"md-title\">Téléphone(s)</span>\n<p></p><div layout=\"row\" ng-repeat=\"Telephones in vm.datastoEdit.Telephones track by $index\"><md-input-container \nmd-no-float flex><label>{{($index == 0) ? \"Principal\":\"Suplémentaire\"}}</label><input \nng-model=\"vm.datastoEdit.Telephones[$index]\" name=\"Telephones{{$index}}\" type=\"phone\" minlength=\"10\" maxlength=\"16\" \nng-pattern=\"/^(0|\\+33)[1-9]([-. ]?[0-9]{2}){4}$/\" required><div ng-messages=\"employeForm[\'Telephones\'+$index].$error\">\n<div ng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"pattern\">\nCe format de numéro n\'est pas accepté</div></div></md-input-container><md-button ng-if=\"$index != 0\" \nclass=\"md-secondary md-icon-button mt-16\" ng-click=\"vm.datastoEdit.Telephones.splice($index, 1)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div layout=\"row\"><md-button class=\"ml-0\" \nng-click=\"vm.datastoEdit.Telephones.push(null)\">+ Ajouter un numéro</md-button></div><p></p><p></p><span \nclass=\"md-title\">E-mail(s)</span><p></p><div layout=\"row\" ng-repeat=\"Emails in vm.datastoEdit.Emails track by $index\">\n<md-input-container md-no-float flex><label>{{($index == 0) ? \"Principale\":\"Suplémentaire\"}}</label><input \nng-model=\"vm.datastoEdit.Emails[$index]\" type=\"email\" required name=\"Emails{{$index}}\" \nng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,6}$/\"><div ng-messages=\"employeForm[\'Emails\'+$index].$error\"><div \nng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"pattern\">Adresse e-mail invalide</div></div>\n</md-input-container><md-button class=\"md-secondary md-icon-button mt-16\" \nng-click=\"vm.datastoEdit.Emails.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nlayout=\"row\"><md-button class=\"ml-0\" ng-click=\"vm.datastoEdit.Emails.push(null)\">+ Ajouter une adresse email\n</md-button></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" \nng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveCoordonnees()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\">\n<span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contacts/profil/dialogs/about/echanges-dialog.html","<md-dialog class=\"details-echange-dialog\" flex=\"100\"><md-dialog-content><div class=\"thread-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div><span class=\"md-title\">{{vm.echange.Subject}}</span></div></div><div \nclass=\"details mt-16 mb-16\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\"><strong \nclass=\"detail font-size-16\">{{vm.echange.De|split:\',\':0}}</strong><p class=\"detail mt-0 blue-grey-600-fg\">\n{{vm.echange.Date|DateFormat}}</p><p class=\"detail mt-0 blue-grey-600-fg font-size-12\"><span \nclass=\"blue-grey-900-fg font-size-14\">À :</span> {{vm.echange.A|split}}</p></div><div class=\"actions layout-row\" \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"material-icons-outlined font-size-20 red-800-fg m-8\" \nng-show=\"vm.echange.Unseen\">visibility_off<md-tooltip>non lu</md-tooltip></md-icon><md-icon \nclass=\"material-icons-outlined font-size-20 green-800-fg m-8\" ng-show=\"vm.echange.Answered\">mark_chat_read<md-tooltip>\nrépondu</md-tooltip></md-icon><md-icon class=\"material-icons-outlined font-size-20 red-800-fg m-8\" \nng-show=\"vm.echange.Flagged\">flag<md-tooltip>en suivi</md-tooltip></md-icon><md-icon \nclass=\"material-icons-outlined font-size-20\" ng-show=\"vm.echange.Attachments.length > 0\">attach_file<md-tooltip>\n\'+full.Attachments+\' pièce(s) jointe(s)</md-tooltip></md-icon></div></div><div style=\"overflow: auto\" \nclass=\"mb-16 pb-16\" ng-if=\"vm.echange.Attachments.length > 0\"><div layout=\"row mb-8 mt-8\"><a layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"Attachment in vm.echange.Attachments\" ng-href=\"{{Attachment.link}}\" \ntarget=\"_blank\" class=\"w-200 brad-16 blue-grey-50-bg blue-grey-fg p-8 pl-16 pr-24 mr-8\"><div><img \nsrc=\"{{Attachment.link}}\" style=\"max-width: 80px; max-height:40px\" class=\"mr-8\" ng-if=\"Attachment.mime == \'images\'\">\n<md-icon class=\"material-icons-outlined font-size-40 mr-8\" style=\"width: auto\" ng-if=\"Attachment.mime == \'archives\'\">\nfolder_zip</md-icon><md-icon class=\"material-icons-outlined font-size-40 mr-8\" style=\"width: auto\" \nng-if=\"Attachment.mime == \'audio/video\'\">live_tv</md-icon><md-icon class=\"material-icons-outlined font-size-40 mr-8\" \nstyle=\"width: auto\" ng-if=\"Attachment.mime == \'pdf\'\">picture_as_pdf</md-icon><md-icon \nclass=\"material-icons-outlined font-size-40 mr-8\" style=\"width: auto\" \nng-if=\"Attachment.mime != \'images\' && Attachment.mime != \'pdf\' && Attachment.mime != \'archives\' && Attachment.mime != \'pdf\' && Attachment.mime != \'audio/video\'\">\ndescription</md-icon></div><div layout=\"column\" flex><md-truncate>{{Attachment.name}}.{{Attachment.extension}}\n</md-truncate><md-truncate>{{Attachment.size/1000}} ko</md-truncate></div></a></div></div><div layout=\"row\"><iframe \nflex=\"100\" onload=\"resizeIframe(\'Iframe\')\" id=\"Iframe\" style=\"border: none;margin: 0 -8px\" ng-src=\"{{vm.link}}\">\n</iframe></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" \nng-disabled=\"vm.showSpinner\">Fermer</md-button></md-dialog-actions></md-dialog><script>\nfunction resizeIframe(obj) {\r\n	var newheight;\r\n	var newwidth;\r\n\r\n	if(document.getElementById){\r\n		newheight = document.getElementById(obj).contentWindow.document.body.scrollHeight+100;\r\n		<!-- newwidth = document.getElementById(obj).contentWindow.document.body.scrollWidth; -->\r\n	}\r\n	\r\n	document.getElementById(obj).height = (newheight) + \"px\";\r\n	<!-- document.getElementById(obj).width = (newwidth) + \"px\"; -->\r\n\r\n}\n</script>");
$templateCache.put("app/main/contacts/profil/dialogs/about/horaires-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Horaires de disponibilités</span><p></p><table><tr><td><md-switch \nng-model=\"vm.contact.Horaires.Lundi.Etat\" aria-label=\"Lundi\" ng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">Lundi\n</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Lundi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Lundi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Lundi.Heures[$index].de\" name=\"Lundi_Heures_{{$index}}_de\" placeholder=\"De\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Lundi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Lundi.Heures[$index].a\" name=\"Lundi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Lundi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Lundi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Lundi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table><md-divider \nng-if=\"vm.contact.Horaires.Lundi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td><md-switch \nng-model=\"vm.contact.Horaires.Mardi.Etat\" aria-label=\"Mardi\" ng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">Mardi\n</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Mardi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Mardi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Mardi.Heures[$index].de\" name=\"Mardi_Heures_{{$index}}_de\" placeholder=\"De\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Mardi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Mardi.Heures[$index].a\" name=\"Mardi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Mardi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Mardi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Mardi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table><md-divider \nng-if=\"vm.contact.Horaires.Mardi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td><md-switch \nng-model=\"vm.contact.Horaires.Mercredi.Etat\" aria-label=\"Mercredi\" ng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">\nMercredi</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Mercredi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Mercredi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Mercredi.Heures[$index].de\" name=\"Mercredi_Heures_{{$index}}_de\" placeholder=\"De\">\n<md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Mercredi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Mercredi.Heures[$index].a\" name=\"Mercredi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option\n ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Mercredi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Mercredi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Mercredi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table>\n<md-divider ng-if=\"vm.contact.Horaires.Mercredi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td>\n<md-switch ng-model=\"vm.contact.Horaires.Jeudi.Etat\" aria-label=\"Jeudi\" ng-true-value=\"\'Ouvert\'\" \nng-false-value=\"\'Fermé\'\">Jeudi</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Jeudi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Jeudi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Jeudi.Heures[$index].de\" name=\"Jeudi_Heures_{{$index}}_de\" placeholder=\"De\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Jeudi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Jeudi.Heures[$index].a\" name=\"Jeudi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Jeudi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Jeudi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Jeudi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table><md-divider \nng-if=\"vm.contact.Horaires.Jeudi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td><md-switch \nng-model=\"vm.contact.Horaires.Vendredi.Etat\" aria-label=\"Vendredi\" ng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">\nVendredi</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Vendredi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Vendredi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Vendredi.Heures[$index].de\" name=\"Vendredi_Heures_{{$index}}_de\" placeholder=\"De\">\n<md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Vendredi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Vendredi.Heures[$index].a\" name=\"Vendredi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option\n ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Vendredi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Vendredi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Vendredi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table>\n<md-divider ng-if=\"vm.contact.Horaires.Vendredi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td>\n<md-switch ng-model=\"vm.contact.Horaires.Samedi.Etat\" aria-label=\"Samedi\" ng-true-value=\"\'Ouvert\'\" \nng-false-value=\"\'Fermé\'\">Samedi</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Samedi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Samedi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Samedi.Heures[$index].de\" name=\"Lundi_Heures_{{$index}}_de\" placeholder=\"De\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Lundi_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Samedi.Heures[$index].a\" name=\"Lundi_Heures_{{$index}}_a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Lundi_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Samedi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Samedi.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table><md-divider \nng-if=\"vm.contact.Horaires.Samedi.Etat == \'Ouvert\'\"></md-divider></td></tr></table><table><tr><td><md-switch \nng-model=\"vm.contact.Horaires.Dimanche.Etat\" aria-label=\"Dimanche\" ng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">\nDimanche</md-switch></td><td><table ng-if=\"vm.contact.Horaires.Dimanche.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.contact.Horaires.Dimanche.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Dimanche.Heures[$index].de\" name=\"Dimanche_Heures_{{$index}}_de\" placeholder=\"De\">\n<md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Dimanche_Heures_\'+$index+\'_de\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container>-<md-input-container><md-select class=\"mt-0\" required \nng-model=\"vm.contact.Horaires.Dimanche.Heures[$index].a\" name=\"Dimanche_Heures_{{$index}}_a\" placeholder=\"à\"><md-option\n ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><div \nng-messages=\"employeForm[\'Dimanche_Heures_\'+$index+\'_a\'].$error\"><div ng-message=\"required\">Obligatoire</div></div>\n</md-input-container><md-button ng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.contact.Horaires.Dimanche.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.contact.Horaires.Dimanche.Heures.push(null);\">+ Ajouter un horaire</md-button></td></tr></table>\n<md-divider ng-if=\"vm.contact.Horaires.Dimanche.Etat == \'Ouvert\'\"></md-divider></td></tr></table></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler\n</md-button><md-button type=\"submit\" ng-click=\"vm.saveContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contacts/profil/dialogs/about/iban-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content><span class=\"md-title\">IBAN</span><p>\nAjouter ou modifier un IBAN utilisé par ce contact sur une ou plusieurs de ses commandes.</p><div layout=\"row\">\n<md-input-container md-no-float flex><label>IBAN</label><input name=\"IBAN\" ng-model=\"vm.datastoEdit.IBAN\" \nng-pattern=\"/^([A-Z]{2}[ \\-]?[0-9]{2})(?=(?:[ \\-]?[A-Z0-9]){9,30}$)((?:[ \\-]?[A-Z0-9]{3,5}){2,7})([ \\-]?[A-Z0-9]{1,3})?$/\" \nrequired><div ng-messages=\"employeForm.IBAN.$error\"><div ng-message=\"pattern\">L\'IBAN saisie est invalide</div><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>BIC</label><input name=\"BIC\" ng-model=\"vm.datastoEdit.BIC\" \nng-pattern=\"/([a-zA-Z]{4})([a-zA-Z]{2})(([2-9a-zA-Z]{1})([0-9a-np-zA-NP-Z]{1}))((([0-9a-wy-zA-WY-Z]{1})([0-9a-zA-Z]{2}))|([xX]{3})|)/\" \nrequired><div ng-messages=\"employeForm.BIC.$error\"><div ng-message=\"pattern\">Le BIC saisie est invalide</div><div \nng-message=\"required\">Ce champ est obligatoire</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>Domiciliation</label><input name=\"domiciliation\" \nng-model=\"vm.datastoEdit.Domiciliation\"></md-input-container></div><div layout=\"row\"><md-input-container md-no-float \nflex><label>Titulaire du compte</label><input name=\"titulaire\" ng-model=\"vm.datastoEdit.Titulaire\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" \nclass=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveIBAN()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\">\n<span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contacts/profil/dialogs/about/internet-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content><span class=\"md-title\">Sites internet</span><p>\nIndiquez les différents sites internet que possède ce contact.</p><div layout=\"row\" \nng-repeat=\"Sites in vm.contact.Sites track by $index\"><md-input-container md-no-float flex><label>\nSite internet {{($index == 0) ? \"Principal\":\"Suplémentaire\"}}</label><input ng-model=\"vm.contact.Sites[$index].URL\" \nng-keyup=\"vm.testSiteExist(vm.contact.Sites[$index].URL, $index)\" name=\"Sites[{{$index}}]\" type=\"url\" required \nclass=\"mb-5\" placeholder=\"https://\" ng-disabled=\"vm.contact.Sites[$index].Utilise==1\"><div \nclass=\"font-size-12 text-italic grey-500-fg\" ng-show=\"vm.contact.Sites[$index].Utilise==1\">\nNe peut pas être modifié (attribué à une commande)</div><div ng-messages=\"employeForm[vm.siteArray[$index]].$error\">\n<div ng-message=\"required\">Ce champ est obligatoire</div><div ng-message=\"newURLFailed\"><span>{{status[$index]}}</span>\n</div></div></md-input-container><md-button class=\"md-secondary md-icon-button mt-16\" \nng-if=\"vm.contact.Sites[$index].Utilise!=1\" ng-click=\"vm.contact.Sites.splice($index, 1); vm.initSiteArray();\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div><div layout=\"row\"><md-button \nng-click=\"vm.contact.Sites.push([]); vm.initSiteArray();\">+ Ajouter un site</md-button></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler\n</md-button><md-button type=\"submit\" ng-click=\"vm.saveContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contacts/profil/dialogs/about/legales-dialog.html","<md-dialog class=\"about-dialog\" flex=\"80\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Données légales</span><p></p><div layout=\"row\"><md-input-container class=\"md-block\" \nmd-no-float flex><label>Structure</label><md-select ng-model=\"vm.contact.legales.IDEntreprises_Structure\" \nname=\"IDEntreprises_Structure\" placeholder=\"Structure\" required><md-option ng-repeat=\"structure in vm.structures\" \nng-value=\"{{structure.IDEntreprises_Structure}}\" ng-click=\"vm.select_structure(structure)\">{{structure.Acronyme}} \n<small ng-if=\"structure.Label\">: {{structure.Label}}</small></md-option></md-select><div \nng-messages=\"employeForm.IDEntreprises_Structure.$error\"><div ng-message=\"required\">Ce champ est obligatoire</div>\n</div></md-input-container></div><div layout=\"row\" ng-show=\"vm.structures_selected.RCS==1\"><md-input-container \nmd-no-float flex><label>RCS</label><input ng-model=\"vm.contact.legales.RCS\" type=\"text\"></md-input-container></div><div\n layout=\"row\" ng-show=\"vm.structures_selected.APE==1\"><md-input-container md-no-float flex><label>Code APE</label>\n<md-select ng-model=\"vm.contact.legales.IDCodeAPE\" md-on-open=\"openSelectSearch(\'#header-searchbox\')\" \nplaceholder=\"Code APE\" md-on-close=\"clearSearchTerm()\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchTerm\" id=\"header-searchbox\" force-select-focus type=\"search\" placeholder=\"Chercher un code APE\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"APE in vm.APE | filter:searchTerm\" ng-value=\"{{APE.IDCodeAPE}}\">{{APE.APE}} : {{APE.APELabel}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" ng-show=\"vm.structures_selected.SIREN==1\"><md-input-container \nmd-no-float flex><label>SIREN</label><input ng-model=\"vm.contact.legales.SIREN\" name=\"SIREN\" type=\"text\" \nng-pattern=\"/^[0-9]*$/\" md-maxlength=\"9\" maxlength=\"9\" minlength=\"9\"><div ng-messages=\"employeForm.SIREN.$error\"><div \nng-message=\"pattern\">Le SIREN doit être composé uniquement de chiffre</div><div ng-message=\"minlength\">\nLe SIREN est formé de 9 chiffres</div></div></md-input-container></div><div layout=\"row\" \nng-show=\"vm.structures_selected.TVA==1\"><md-input-container md-no-float flex><label>N°TVA Intracommunautaire</label>\n<input ng-model=\"vm.contact.legales.TVA\" type=\"text\"></md-input-container></div><div layout=\"row\" \nng-show=\"vm.structures_selected.Capital==1\"><md-input-container md-no-float flex><label>Capital Social</label><input \nng-model=\"vm.contact.legales.Capital\" type=\"number\" name=\"Capital\"><div ng-messages=\"employeForm.Capital.$error\"><div \nng-message=\"number\">Le capital social n\'est composé que de chiffres</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" \nng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveContact()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\">\n<span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contacts/profil/dialogs/about/site-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content><span class=\"md-title\">Sites internet</span><p>\nIndiquez une URL d\'un site internet que possède ce contact.</p><div layout=\"row\" layout-align=\"space-between start\">\n<md-input-container class=\"md-block\" md-no-float flex><label>URL du site internet</label><input \nng-model=\"vm.datastoEdit.URL\" name=\"URL\" type=\"url\" required \nng-change=\"employeForm.URL.$setValidity(\'URLFailed\', true)\" md-autofocus ng-pattern=\"vm.webregex\"><div \nng-messages=\"employeForm.URL.$error\" role=\"alert\"><div ng-message=\"required\">Ce champ est obligatoire</div><div \nng-message=\"pattern\">Le format votre l\'URL est incorrecte</div><div ng-message=\"URLFailed\"><span>{{status}}</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" \nng-click=\"vm.saveSiteInternet()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contacts/profil/tabs/about/about.html","<div layout=\"row\" layout-wrap layout-align=\"space-between stretch\"><div layout=\"row\" layout-wrap flex-gt-lg=\"80\" \nflex-lg=\"100\" flex=\"100\"><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"60\" flex-gt-md=\"65\" flex-order=\"1\" \nflex-order-gt-sm=\"1\"><div class=\"profil-box coord-box info-box general brad-16 border\" layout=\"column\"><header \nclass=\"md-blue-600-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\">Informations générales</div>\n</header><div class=\"content\"><md-list class=\"p-0\"><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>\n<strong>Date de création :</strong> {{vm.contact.DateCreation}}</h4><h4><strong>Dernière modification :</strong>\n {{vm.contact.DateModification}}</h4><h4><strong>Suivi par :</strong><md-tooltip md-direction=\"left\" \nng-if=\"vm.contact.CommercialSupprime==1\">Compte supprimé</md-tooltip><span class=\"grey-600-fg\" \nng-if=\"vm.contact.CommercialSupprime==1\">{{vm.contact.Commercial}}</span> <a href=\"#\" \neditable-select=\"vm.contact.IDEmploye\" edit-disabled=\"vm.idUser!=1\" ng-if=\"vm.contact.CommercialSupprime!=1\" \nonaftersave=\"vm.updateCommercial(vm.contact)\" \ne-ng-options=\"s.IDEmploye as s.Civilite+\' \'+s.Prenom+\' \'+s.Nom for s in vm.employes\">\n{{vm.showEmployesProfil(vm.contact)}}</a></h4><h4><strong>Fréquence des bilans :</strong><md-tooltip \nmd-direction=\"bottom\" ng-if=\"vm.contact.Status!=\'Client\'\">\nLe contact doit être client pour modifier la fréquence des bilans</md-tooltip><a href=\"#\" \neditable-select=\"vm.contact.Bilan\" edit-disabled=\"vm.contact.Status!=\'Client\'\" \nonaftersave=\"vm.updateBilanFrequence(vm.contact)\" e-ng-options=\"s.value as s.text for s in frequences\">\n{{showBilanFrequence()}}</a></h4></div></md-list-item></md-list><md-list><md-list-item class=\"md-2-line\"><div \nclass=\"md-list-item-text\"><h4><strong>Activité(s)</strong></h4><p class=\"info\" \nng-repeat=\"activite in vm.contact.Activites track by $index\">{{activite}}</p></div><md-button \nclass=\"md-icon-button md-secondary\" ng-click=\"vm.editer($event, \'activites\')\"><md-tooltip md-direction=\"left\">\nModifier les activités</md-tooltip><md-icon class=\"material-icons-outlined\">drive_file_rename_outline</md-icon>\n</md-button></md-list-item></md-list><md-list><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>\n<strong>Horaires</strong></h4><div class=\"info\" ng-repeat=\"(key,Horaires) in vm.contact.Horaires track by $index\" \nng-show=\"vm.contact.Horaires\" class=\"animate-if\"><p class=\"font-weight-500 jour-horaire\">{{key}}:</p><span \nng-if=\"Horaires.Etat == \'Fermé\'\">Fermé </span><span ng-repeat=\"Heures in Horaires.Heures\" \nng-if=\"Horaires.Etat == \'Ouvert\'\">{{Heures.de}} à {{Heures.a}} <span ng-if=\"!$last\">-</span></span></div></div>\n<md-button class=\"md-icon-button md-secondary\" ng-click=\"vm.editer($event, \'horaires\')\"><md-tooltip \nmd-direction=\"left\">Modifier les horaires</md-tooltip><md-icon class=\"material-icons-outlined\">\ndrive_file_rename_outline</md-icon></md-button></md-list-item></md-list></div></div><div \nclass=\"profil-box coord-box info-box work brad-16 border\" layout=\"column\"><header class=\"md-blue-600-bg p-8 pl-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title\">Site(s) internet</div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.editer($event, \'site\')\"><md-tooltip md-direction=\"left\">Ajouter</md-tooltip>\n<md-icon class=\"material-icons-outlined white-fg\">add_box</md-icon></md-button></header><div class=\"content\"><md-list>\n<md-list-item class=\"md-3-line md-no-proxy\" ng-repeat=\"site in vm.contact.Sites\"><div class=\"md-list-item-text\"><h4><a \nhref=\"{{site.URL}}\" target=\"_blank\">{{site.URL}}</a></h4><small \nclass=\"md-green-bg white-fg mt-5 p-5 pl-8 pr-8 brad-16\" style=\"float: left\" ng-show=\"site.Utilise\">\nAssocié à une commande</small> <small class=\"md-amber-bg black-fg mt-5 p-5 pl-8 pr-8 brad-16\" style=\"float: left\" \nlayout=\"row\" ng-hide=\"site.Utilise\">Pas de projet associé</small></div><md-menu class=\"md-secondary\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-tooltip md-direction=\"left\">Modifier</md-tooltip><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.go(\'/sites/details/\'+site.IDSiteWeb)\" ng-disabled=\"site.Utilise==0\">Statistiques</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.editer($event, \'site\', site)\" ng-disabled=\"site.Utilise==1\">\nModifier</md-button></md-menu-item><md-divider ng-if=\"vm.user.groups\"></md-divider><md-menu-item><md-button \nng-click=\"vm.deleteSiteInternet($event, site)\" ng-disabled=\"site.Utilise==1\">Supprimer</md-button></md-menu-item>\n</md-menu-content></md-menu><md-divider ng-hide=\"$last\"></md-divider></md-list-item></md-list></div></div><div \nclass=\"profil-box coord-box info-box work brad-16 border\" layout=\"column\"><header class=\"md-blue-600-bg p-8 pl-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title\">Adresse(s)</div><md-button class=\"md-icon-button\" \nng-click=\"vm.editer($event, \'adresses\')\"><md-tooltip md-direction=\"left\">Ajouter</md-tooltip><md-icon \nclass=\"material-icons-outlined white-fg\">add_box</md-icon></md-button></header><div class=\"content\"><md-list>\n<md-list-item class=\"md-3-line md-no-proxy\" ng-repeat=\"adresse in vm.contact.Adresses\"><div class=\"md-list-item-text\">\n<h4>{{adresse.NomAdresse}} <small>({{adresse.PrincipalOuSecondaire}})</small></h4><p layout=\"row\"><a \nhref=\"https://www.google.com/maps/search/{{vm.contact.RaisonSocial}}+{{adresse.AdresseComplete}}/@{{adresse.Latitude}},{{adresse.Longitude}},z=13\" \ntarget=\"_blank\">{{adresse.AdresseComplete}}</a></p><p layout=\"row\" ng-show=\"adresse.SIRET\">SIRET : {{adresse.SIRET}}\n</p></div><md-menu class=\"md-secondary\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-tooltip \nmd-direction=\"left\">Modifier</md-tooltip><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.editer($event, \'adresses\', adresse)\">Modifier\n</md-button></md-menu-item><md-divider ng-if=\"vm.user.groups\"></md-divider><md-menu-item><md-button \nng-click=\"vm.deleteAdresse($event, adresse)\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu>\n<md-divider ng-hide=\"$last\"></md-divider></md-list-item></md-list></div></div><div \nclass=\"profil-box coord-box info-box work brad-16 border\" layout=\"column\"><header class=\"md-blue-600-bg p-8 pl-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title\">Contact(s)</div><md-button class=\"md-icon-button\" \nng-click=\"vm.editer($event, \'contacts\')\"><md-tooltip md-direction=\"left\">Ajouter</md-tooltip><md-icon \nclass=\"material-icons-outlined white-fg\">person_add</md-icon></md-button></header><div class=\"content\"><md-list>\n<md-list-item class=\"md-2-line md-no-proxy\" ng-repeat=\"contact in vm.contact.Contacts\"><div class=\"md-list-item-text\">\n<h4 class=\"pt-16\">{{contact.Civilite}} {{contact.Prenom}} {{contact.Nom}} <small>({{contact.Fonction}})</small> <small \nclass=\"ml-10 tag p-5 pr-8 pl-8 brad-16 md-green-bg white-fg\" ng-show=\"contact.PrincipalOuSecondaire==\'Principal\'\">\nPrincipal</small> <small class=\"ml-10 tag p-5 pr-8 pl-8 brad-16 md-amber-bg black-fg\" \nng-show=\"contact.PrincipalOuSecondaire!=\'Principal\'\">Secondaire</small></h4><br><p>Téléphone(s) :</p><a \nng-repeat=\" telephone in contact.Telephones \" class=\"phone-contact mr-10\" href=\"tel:{{telephone}}\">\n{{telephone|phoneNumber}}<br></a><br><p ng-show=\"contact.Emails\">E-mail(s) :</p><a \nng-repeat=\" email in contact.Emails\" class=\"email-contact mr-10\" href=\"mailto:{{email}}\">{{email}}<br></a><br></div>\n<md-menu class=\"pt-16\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-tooltip \nmd-direction=\"left\">Modifier</md-tooltip><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.editer($event, \'contacts\', contact)\">Modifier\n</md-button></md-menu-item><md-divider ng-if=\"vm.user.groups\"></md-divider><md-menu-item><md-button \nng-click=\"vm.deleteContact($event, contact)\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu>\n<md-divider ng-hide=\"$last\"></md-divider></md-list-item></md-list></div></div><div \nclass=\"profil-box coord-box info-box work brad-16 border\" layout=\"column\"><header class=\"md-blue-600-bg p-8 pl-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title\">IBAN</div><md-button class=\"md-icon-button\" \nng-click=\"vm.editer($event, \'iban\')\"><md-tooltip md-direction=\"left\">Ajouter</md-tooltip><md-icon \nclass=\"material-icons-outlined white-fg\">add_box</md-icon></md-button></header><div class=\"content\"><md-list>\n<md-list-item class=\"md-3-line md-no-proxy\" ng-repeat=\"IBAN in vm.contact.IBAN\"><div class=\"md-list-item-text\"><p>\n<strong>Date création : </strong>{{IBAN.DateCreation| date : format : shortDate}}</p><p><strong>IBAN client : </strong>\n{{IBAN.IBAN}}</p><p><strong>BIC : </strong>{{IBAN.BIC}}</p><p><strong>Domiciliation : </strong>{{IBAN.Domiciliation}}\n</p><p><strong>Titulaire : </strong>{{IBAN.Titulaire}}</p></div><md-menu class=\"md-secondary\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-tooltip md-direction=\"left\">Modifier</md-tooltip><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.editer($event, \'iban\', IBAN)\">Modifier</md-button></md-menu-item><md-divider ng-if=\"vm.user.groups\">\n</md-divider><md-menu-item><md-button ng-click=\"vm.deleteIBAN($event, IBAN)\">Supprimer</md-button></md-menu-item>\n</md-menu-content></md-menu><md-divider ng-hide=\"$last\"></md-divider></md-list-item></md-list></div></div><div \nclass=\"profil-box info-box contact brad-16 border\" layout=\"column\"><header class=\"md-blue-600-bg p-8 pl-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title\">Données légales</div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.editer($event, \'legales\')\"><md-tooltip md-direction=\"left\">Modifier</md-tooltip>\n<md-icon class=\"material-icons-outlined white-fg\">drive_file_rename_outline</md-icon></md-button></header><div \nclass=\"content\"><div class=\"info-line\"><div class=\"title\">Forme juridique</div><div class=\"info\" \nng-hide=\"vm.contact.legales.Acronyme\" class=\"animate-if\"><em style=\"color:red\">Non renseigné</em></div><div \nclass=\"info\" ng-show=\"vm.contact.legales.Acronyme\">{{vm.contact.legales.Acronyme}} <small \nng-if=\"vm.contact.legales.Structure.Label\">({{vm.contact.legales.Label}})</small></div></div><div class=\"info-line\" \nng-if=\"vm.contact.legales.Structure.SIREN==1\"><div class=\"title\">SIREN</div><div class=\"info\" \nng-hide=\"vm.contact.legales.SIREN\" class=\"animate-if\"><em style=\"color:red\">Non renseigné</em></div><div class=\"info\" \nng-show=\"vm.contact.legales.SIREN\">{{vm.contact.legales.SIREN}}</div></div><div class=\"info-line\" \nng-if=\"vm.contact.legales.Structure.APE==1\"><div class=\"title\">CODE APE</div><div class=\"info\" \nng-hide=\"vm.contact.legales.APE\" class=\"animate-if\"><em style=\"color:red\">Non renseigné</em></div><div class=\"info\" \nng-show=\"vm.contact.legales.APE\">{{vm.contact.legales.APE}} <small>({{vm.contact.legales.APELabel}})</small></div>\n</div><div class=\"info-line\" ng-if=\"vm.contact.legales.Structure.RCS==1\"><div class=\"title\">RCS</div><div class=\"info\" \nng-hide=\"vm.contact.legales.RCS\" class=\"animate-if\"><em style=\"color:red\">Non renseigné</em></div><div class=\"info\" \nng-show=\"vm.contact.legales.RCS\">{{vm.contact.legales.RCS}}</div></div><div class=\"info-line\" \nng-if=\"vm.contact.legales.Structure.TVA==1\"><div class=\"title\">N°TVA Intracommunautaire</div><div class=\"info\" \nng-hide=\"vm.contact.legales.TVA\" class=\"animate-if\"><em style=\"color:red\">Non renseigné</em></div><div class=\"info\" \nng-show=\"vm.contact.legales.TVA\">{{vm.contact.legales.TVA}}</div></div><div class=\"info-line\" \nng-if=\"vm.contact.legales.Structure.Capital==1\"><div class=\"title\">Capital Social</div><div class=\"info\" \nng-hide=\"vm.contact.legales.Capital\" class=\"animate-if\"><em style=\"color:red\">Non renseigné</em></div><div \nclass=\"info\" ng-show=\"vm.contact.legales.Capital\">{{vm.contact.legales.Capital |currency:\'\'}} €</div></div></div></div>\n</div><div class=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"40\" flex-gt-md=\"35\" flex-order=\"0\" \nflex-order-gt-sm=\"2\"><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front md-ink-ripple=\"true\" class=\"p-8\" ng-class=\"(vm.contact.CAHT>0) ? \'green-bg\':\'white-bg\'\" layout=\"row\" \nflex ng-click=\"vm.selectedIndex=1\" style=\"cursor:pointer\"><div class=\"pt-8 pb-8\" \nng-class=\"(vm.contact.CAHT>0) ? \'white-fg\':\'\'\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1\">{{vm.contact.CAHT |currency:\'\'}} €</div><div class=\"font-weight-500 secondary-text pb-8\">\nChiffre d\'affaire HT</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front md-ink-ripple=\"true\" class=\"p-8\" \nng-class=\"(vm.contact.Opportunites>0) ? \'md-orange-800-bg\':\'white-bg\'\" layout=\"row\" flex ng-click=\"vm.selectedIndex=1\" \nstyle=\"cursor:pointer\"><div class=\"pt-8 pb-8\" ng-class=\"(vm.contact.Opportunites>0) ? \'white-fg\':\'\'\" layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-1\">{{vm.contact.Opportunites |currency:\'\'}} €</div><div \nclass=\"font-weight-500 secondary-text pb-8\">Opportunité(s)</div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/contacts/profil/tabs/commandes/commandes.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profil-box coord-box info-box general border brad-16\" layout=\"column\" style=\"overflow:hidden\"><div \nclass=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \nid=\"tableCommandes\" datatable dt-instance=\"vm.dtInstanceCommandesProfils\" dt-columns=\"vm.dtColumnsCommandesProfils\" \ndt-options=\"vm.dtOptionsCommandesProfils\"></table></div></div></div></div>");
$templateCache.put("app/main/contacts/profil/tabs/courriers/courriers.html","<div layout=\"row\" layout-wrap><div class=\"courriers\" layout=\"column\" flex=\"100\"><div \nclass=\"content-card border brad-16\" layout=\"column\" flex style=\"overflow:hidden\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div \nng-repeat=\"courrier in vm.courriers | filter: vm.search   | orderBy: vm.listOrder :vm.listOrderAsc\" \nclass=\"md-white-bg border-bottom contact-list\"><div layout=\"column\" layout-fill><div layout=\"row\" class=\"pl-16 pr-16\" \nlayout-align=\"start center\"><div flex-xs=\"95\" flex-gt-xs=\"60\" layout=\"column\" class=\"pt-16 pb-16\" \nlayout-align=\"start start\"><span class=\"font-weight-600\" ng-bind-html=\"courrier.Objet\"></span><div><span \nng-show=\"courrier.LRAR\" class=\"orange-500-fg\">Lettre recommandée avec accusé de réception</span> <span \nng-hide=\"courrier.LRAR\" class=\"blue-500-fg\">Envoi normal</span><br><small>\nDernière modification le {{courrier.DateModification | DateFormat}}</small><br><md-chips hide show-xs show-sm><md-chip \nclass=\"grey-500-bg white-fg\" ng-show=\"courrier.Envoye == \'0\'\" selected=\"true\"><small>En attente</small></md-chip>\n<md-chip class=\"md-green-bg white-fg\" ng-show=\"courrier.Envoye == \'1\'\" class=\"mat-teal-bg\" selected=\"true\"><small>\nEnvoyé le {{courrier.DateEnvoie | date:\'dd/MM/yyyy\'}}</small></md-chip></md-chips><md-button hide show-xs \nng-click=\"vm.apercuDestinataires($event,courrier)\">{{courrier.NbrDestinataires}} destinataires</md-button></div></div>\n<p class=\"mt-0 mt-16\" hide-xs flex-gt-xs=\"30\"><md-button ng-click=\"vm.apercuDestinataires($event,courrier)\">\n{{courrier.NbrDestinataires}} destinataires</md-button></p><p class=\"\" hide-xs hide-sm flex-gt-xs=\"25\"><md-chips>\n<md-chip class=\"grey-500-bg white-fg\" ng-show=\"courrier.Envoye == \'0\'\" selected=\"true\"><small>En attente</small>\n</md-chip><md-chip class=\"md-green-bg white-fg\" ng-show=\"courrier.Envoye == \'1\'\" class=\"mat-teal-bg\" selected=\"true\">\n<small>Envoyé le {{courrier.DateEnvoie | date:\'dd/MM/yyyy\'}}</small></md-chip></md-chips></p><div class=\"actions\" \nlayout=\"row\" layout-align=\"end center\" flex-gt-xs=\"5\"><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.apercuCourrier($event,courrier)\">Aperçu</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.go(\'/courriers/edition/\'+courrier.IDCourrier);vm.cancel();\" \nng-disabled=\"courrier.Envoye\">Modifier</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/contacts/profil/tabs/documents/documents.html","<div class=\"documents-contact\" ng-controller=\"ContactDocumentsController as documentsVm\" layout=\"column\" flex=\"100\">\n<div class=\"documents-contact-actions\" layout=\"row\" layout-align=\"space-between center\"><div class=\"secondary-text\">\n{{documentsVm.recordsTotal}} document<span ng-if=\"documentsVm.recordsTotal > 1\">s</span></div><md-button \nclass=\"md-raised\" ng-click=\"documentsVm.editer($event)\" ng-if=\"documentsVm.droits(\'edition\')\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><span>Ajouter</span></md-button></div><div class=\"content-card border brad-16\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable dataTableDocumentsContact row-border hover\" datatable dt-instance=\"documentsVm.dtInstance\" \ndt-columns=\"documentsVm.dtColumns\" dt-options=\"documentsVm.dtOptions\"></table></div></div></div>");
$templateCache.put("app/main/contacts/profil/tabs/echanges/echanges.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profil-box coord-box info-box general border brad-16\" layout=\"column\" style=\"overflow:hidden\"><div \nclass=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable dt-instance=\"vm.dtInstanceEchanges\" dt-columns=\"vm.dtColumnsEchanges\" dt-options=\"vm.dtOptionsEchanges\">\n</table></div></div></div></div>");
$templateCache.put("app/main/contacts/profil/tabs/produits/produits.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profil-box coord-box info-box general border brad-16\" layout=\"column\" style=\"overflow:hidden\"><div \nclass=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \nid=\"tableCommandes\" datatable dt-instance=\"vm.dtInstanceProduitsProfils\" dt-columns=\"vm.dtColumnsProduitsProfils\" \ndt-options=\"vm.dtOptionsProduitsProfils\"></table></div></div></div></div>");
$templateCache.put("app/main/contacts/profil/tabs/logs/logs.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profil-box coord-box info-box general border brad-16\" layout=\"column\" style=\"overflow:hidden\"><div \nclass=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable dt-instance=\"vm.dtInstanceLogs\" dt-columns=\"vm.dtColumnsLogs\" dt-options=\"vm.dtOptionsLogs\"></table></div>\n</div></div></div>");
$templateCache.put("app/main/contacts/profil/tabs/alertes/alertes.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profil-box coord-box info-box general border brad-16\" layout=\"column\" style=\"overflow:hidden\"><div \nclass=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \nid=\"tableAlertes\" datatable dt-instance=\"vm.dtInstanceAlertes\" dt-columns=\"vm.dtColumnsAlertes\" \ndt-options=\"vm.dtOptionsAlertes\"></table></div></div></div></div>");
$templateCache.put("app/main/parametres/employes/employes/dialogs/delete-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Voulez-vous vraiment supprimer ce compte ?</span><p>Le compte de <strong>\n{{vm.employe.Prenom}} {{vm.employe.Nom}}</strong> va être effacé et ne sera plus utilisable</p><div layout=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label>A quel compte ses données doivent-elles être rattachées ?\n</label><md-select ng-model=\"vm.employe.IDCompteRatache\" required><md-option ng-repeat=\"employe in vm.employes\" \nng-disabled=\"employe.IDEmploye == vm.employe.IDEmploye\" value=\"{{employe.IDEmploye}}\">\n{{employe.Civilite}} {{employe.Prenom}} {{employe.Nom}}</md-option></md-select></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" \nng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.deleteEmploye()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"employeForm.$invalid\" aria-label=\"Appliquer\"><span \nng-show=\"!vm.showSpinner\">Supprimer ce compte</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/droits/droits/dialogs/droit-dialog.html","<md-dialog class=\"about-dialog\" flex=\"80\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Données légales</span><p></p><div layout=\"row\"><md-input-container md-no-float flex>\n<label>IsOnglet</label><input ng-model=\"vm.droit.IsOnglet\" type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>Path</label><input ng-model=\"vm.droit.Path\" type=\"text\">\n</md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>title</label><input \nng-model=\"vm.droit.title\" type=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container md-no-float \nflex><label>group</label><input ng-model=\"vm.droit.group\" type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>icon</label><input ng-model=\"vm.droit.icon\" type=\"text\">\n</md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>state</label><input \nng-model=\"vm.droit.state\" type=\"text\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button \ntype=\"submit\" ng-click=\"vm.saveDroit()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/droits/droits/dialogs/permission-dialog.html","<md-dialog class=\"about-dialog\" flex=\"80\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Données légales</span><p></p><div layout=\"row\"><md-input-container md-no-float flex>\n<label>Permission</label><input ng-model=\"vm.permission.Permission\" type=\"text\"></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Parent</label><md-select \nng-model=\"vm.permission.IDParent\" required><md-option ng-value=\"0\">--</md-option><md-option \nng-repeat=\"permission in vm.permissions\" ng-disabled=\"permission.IDPermission==vm.permission.IDPermission\" \nng-value=\"{{permission.IDPermission}}\">{{permission.Permission}}</md-option></md-select></md-input-container></div><div\n layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Droits</label><md-select \nng-model=\"vm.permission.Droits\" required multiple=\"multiple\"><md-option ng-repeat=\"droit in vm.droits\" \nvalue=\"{{droit.Path}}\">{{droit.Path}}</md-option></md-select></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler\n</md-button><md-button type=\"submit\" ng-click=\"vm.savePermission()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/contacts/profil/tabs/documents/dialogs/document-dialog.html","<md-dialog class=\"document-dialog\" flex=\"80\" aria-label=\"Document du contact\"><form name=\"documentForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.enregistrer(documentForm)\" novalidate enctype=\"multipart/form-data\">\n<md-dialog-content ms-scroll><span class=\"md-title\">\n{{vm.document.IDDocument ? \'Modifier le document\' : \'Ajouter un document\'}}</span><p></p><div layout=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Titre</label><input ng-model=\"vm.document.Titre\" \nname=\"Titre\" maxlength=\"255\" required><div ng-messages=\"documentForm.Titre.$error\"><div ng-message=\"required\">\nCe champ est obligatoire</div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container\n class=\"md-block\" md-no-float flex><label>Catégorie</label><md-select ng-model=\"vm.document.Categorie\" \nname=\"Categorie\" required><md-option ng-repeat=\"categorie in vm.categories\" ng-value=\"categorie\">{{categorie}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" md-no-float flex><label>\nDate du document</label><md-datepicker ng-model=\"vm.dateDocument\" name=\"DateDocument\" md-open-on-focus></md-datepicker>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Référence\n</label><input ng-model=\"vm.document.Reference\" name=\"Reference\" maxlength=\"191\"></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>Description</label><textarea \nng-model=\"vm.document.Description\" name=\"Description\" rows=\"3\"></textarea></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" md-no-float flex><label>\n{{vm.document.IDDocument ? \'Remplacer le fichier\' : \'Fichier\'}}</label><input type=\"file\" ngf-select \nng-model=\"vm.file\" name=\"file\" accept=\".pdf,.jpg,.jpeg,.png,.txt,.csv,.doc,.docx,.xls,.xlsx,.odt,.ods\"><div \nclass=\"hint font-size-14\"><span ng-if=\"vm.document.NomOriginal\">Fichier actuel : {{vm.document.NomOriginal}}. </span>\n20 Mo maximum.</div></md-input-container></div><p class=\"md-warn-fg\" role=\"alert\" ng-if=\"vm.error\">{{vm.error}}</p>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"button\" ng-click=\"vm.annuler()\" \nng-disabled=\"vm.busy\">Annuler</md-button><md-button type=\"submit\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.busy || documentForm.$invalid\" aria-label=\"Appliquer\"><span ng-show=\"!vm.busy\">Appliquer</span>\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.busy\"></md-progress-circular></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/employes/profil/dialogs/about/adresses-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Adresse</span><p></p><div layout=\"row\"><md-input-container class=\"md-block\" \nmd-no-float flex><label>Ordre</label><md-select ng-model=\"vm.datastoEdit.PrincipalOuSecondaire\" placeholder=\"Ordre\" \nrequired><md-option value=\"Secondaire\">Secondaire</md-option><md-option value=\"Principale\">Principale</md-option>\n</md-select></md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Nom de l\'adresse\n</label><input ng-model=\"vm.datastoEdit.NomAdresse\" type=\"text\" required md-autofocus></md-input-container></div><div \nlayout=\"row\"><md-input-container md-no-float flex><label>Numéro de SIRET</label><input ng-model=\"vm.datastoEdit.SIRET\" \ntype=\"text\" ng-pattern=\"/^[0-9]*$/\" md-maxlength=\"14\"></md-input-container></div><div layout=\"row\"><md-input-container \nmd-no-float flex><label>Saisissez une adresse complète</label><input ng-model=\"vm.datastoEdit.AdresseComplete\" \ng-places-autocomplete autocomplete=\"off\" type=\"text\" required></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>Adresse</label><input ng-model=\"vm.datastoEdit.Adresse\" type=\"text\" \nrequired readonly=\"readonly\"></md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>\nAdresse2</label><input ng-model=\"vm.datastoEdit.Adresse2\" type=\"text\" readonly=\"readonly\"></md-input-container></div>\n<div layout=\"row\"><md-input-container md-no-float flex><label>Code postal</label><input ng-model=\"vm.datastoEdit.CP\" \ntype=\"text\" required readonly=\"readonly\"></md-input-container></div><div layout=\"row\"><md-input-container md-no-float \nflex><label>Ville</label><input ng-model=\"vm.datastoEdit.Ville\" type=\"text\" required readonly=\"readonly\">\n</md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Pays</label><input \nng-model=\"vm.datastoEdit.Pays\" type=\"text\" required readonly=\"readonly\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler\n</md-button><md-button type=\"submit\" ng-click=\"vm.saveAdresses()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/employes/profil/dialogs/about/commissions-dialog.html","<md-dialog class=\"about-dialog\" flex=\"80\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content><span class=\"md-title\">Commissions</span></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button \ntype=\"submit\" ng-click=\"vm.saveEmploye()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/employes/profil/dialogs/about/generales-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Informations générales</span><p></p><div layout=\"row\"><md-input-container \nclass=\"md-block\" md-no-float flex><label>Civilité</label><md-select ng-model=\"vm.employe.Civilite\" \nplaceholder=\"Civilité\" required><md-option value=\"M.\">M.</md-option><md-option value=\"Mme\">Mme</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"\"><md-input-container md-no-float flex><label>Prénom</label><input \nng-model=\"vm.employe.Prenom\" type=\"text\" required></md-input-container></div><div layout=\"row\" class=\"\">\n<md-input-container md-no-float flex><label>Nom</label><input ng-model=\"vm.employe.Nom\" type=\"text\" required>\n</md-input-container></div><div layout=\"row\" class=\"mt-8\"><md-input-container md-no-float flex><label>E-mail</label>\n<input ng-model=\"vm.employe.Email\" type=\"email\" required></md-input-container></div><div layout=\"row\" class=\"mt-8\">\n<md-input-container md-no-float flex><label>Mot de passe</label><input ng-model=\"vm.employe.MotDePasse\" \ntype=\"password\" name=\"MotDePasse\" \nplaceholder=\"{{(vm.employe.IDEmploye) ? \'Laisser vide si inchangé\' : \'Minimum 8 caractères\'}}\" ng-minlength=\"8\" \nng-required=\"!vm.employe.IDEmploye\"><div ng-messages=\"employeForm.MotDePasse.$error\"><div ng-message=\"minlength\">\nMinimum 8 caractères</div></div></md-input-container></div><div layout=\"row\" ng-if=\"vm.Permission==\'Super Admin\'\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Page par défaut</label><md-select \nng-model=\"vm.employe.PageDefault\" placeholder=\"Page par défaut\" required><md-optgroup label=\"{{droit.title}}\" \nng-repeat=\"droit in vm.droits\"><md-option value=\"{{key}}\" ng-repeat=\"(key, value) in droit.value\">{{value}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"row\" ng-if=\"vm.Permission==\'Super Admin\'\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Activités et présence</label><md-select \nng-model=\"vm.employe.Presence\" required><md-option value=\"Forfait\">Forfait</md-option><md-option value=\"Réelles\">\nRéelles</md-option></md-select></md-input-container></div><div layout=\"row\" class=\"mt-8 date-100\"><md-input-container \nmd-no-float flex><label>Date de naissance</label><md-datepicker ng-model=\"vm.employe.DateNaissance\" \nmd-placeholder=\"Facultatif\" md-open-on-focus md-current-view=\"year\"></md-datepicker></md-input-container></div><div \nlayout=\"row\" class=\"mt-8\" ng-if=\"vm.IDEmploye != vm.employe.IDEmploye\"><md-input-container class=\"md-block\" \nmd-no-float flex><label>Rôle</label><md-select ng-model=\"vm.employe.IDPermission\" placeholder=\"Rôle\" required>\n<md-option ng-repeat=\"permission in vm.permissions\" ng-value=\"permission.IDPermission\">{{permission.Permission}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" class=\"mt-8\" \nng-if=\"vm.IDEmploye != vm.employe.IDEmploye\"><md-checkbox md-no-ink ng-model=\"vm.employe.UniquementSesValeurs\" \nclass=\"md-primary\" ng-true-value=\"1\" ng-false-value=\"0\" class=\"md-primary\">\nNe peut voir que les données le concernant parmi ses permissions</md-checkbox></div><div layout=\"row\" class=\"mt-8\" \nng-if=\"vm.IDEmploye != vm.employe.IDEmploye\"><md-checkbox md-no-ink ng-model=\"vm.employe.VoirNotificationsAutres\" \nng-true-value=\"1\" ng-false-value=\"0\" class=\"md-primary\">Voir également les notifications des permissions inférieures\n</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.go(\'/administration/employes\');\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button \ntype=\"submit\" ng-click=\"vm.saveEmploye()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/employes/profil/dialogs/about/horaires-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Horaires de disponibilités</span><p></p><table><tr><td><md-switch \nng-model=\"vm.employe.Horaires.Lundi.Etat\" aria-label=\"Lundi\" ng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">Lundi\n</md-switch></td><td><table ng-if=\"vm.employe.Horaires.Lundi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.employe.Horaires.Lundi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-select required ng-model=\"vm.employe.Horaires.Lundi.Heures[$index].de\" \nplaceholder=\"De\"><md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option>\n</md-select>-<md-select required ng-model=\"vm.employe.Horaires.Lundi.Heures[$index].a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><md-button \nng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.employe.Horaires.Lundi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.employe.Horaires.Lundi.Heures.push({})\">+ Ajouter un horaire</md-button></td></tr></table></td></tr>\n</table><table><tr><td><md-switch ng-model=\"vm.employe.Horaires.Mardi.Etat\" aria-label=\"Mardi\" \nng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">Mardi</md-switch></td><td><table \nng-if=\"vm.employe.Horaires.Mardi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.employe.Horaires.Mardi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-select required ng-model=\"vm.employe.Horaires.Mardi.Heures[$index].de\" \nplaceholder=\"De\"><md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option>\n</md-select>-<md-select required ng-model=\"vm.employe.Horaires.Mardi.Heures[$index].a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><md-button \nng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.employe.Horaires.Mardi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.employe.Horaires.Mardi.Heures.push({})\">+ Ajouter un horaire</md-button></td></tr></table></td></tr>\n</table><table><tr><td><md-switch ng-model=\"vm.employe.Horaires.Mercredi.Etat\" aria-label=\"Mercredi\" \nng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">Mercredi</md-switch></td><td><table \nng-if=\"vm.employe.Horaires.Mercredi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.employe.Horaires.Mercredi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-select required ng-model=\"vm.employe.Horaires.Mercredi.Heures[$index].de\" \nplaceholder=\"De\"><md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option>\n</md-select>-<md-select required ng-model=\"vm.employe.Horaires.Mercredi.Heures[$index].a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><md-button \nng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.employe.Horaires.Mercredi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.employe.Horaires.Mercredi.Heures.push({})\">+ Ajouter un horaire</md-button></td></tr></table></td></tr>\n</table><table><tr><td><md-switch ng-model=\"vm.employe.Horaires.Jeudi.Etat\" aria-label=\"Jeudi\" \nng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">Jeudi</md-switch></td><td><table \nng-if=\"vm.employe.Horaires.Jeudi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.employe.Horaires.Jeudi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-select required ng-model=\"vm.employe.Horaires.Jeudi.Heures[$index].de\" \nplaceholder=\"De\"><md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option>\n</md-select>-<md-select required ng-model=\"vm.employe.Horaires.Jeudi.Heures[$index].a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><md-button \nng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.employe.Horaires.Jeudi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.employe.Horaires.Jeudi.Heures.push({})\">+ Ajouter un horaire</md-button></td></tr></table></td></tr>\n</table><table><tr><td><md-switch ng-model=\"vm.employe.Horaires.Vendredi.Etat\" aria-label=\"Vendredi\" \nng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">Vendredi</md-switch></td><td><table \nng-if=\"vm.employe.Horaires.Vendredi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.employe.Horaires.Vendredi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-select required ng-model=\"vm.employe.Horaires.Vendredi.Heures[$index].de\" \nplaceholder=\"De\"><md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option>\n</md-select>-<md-select required ng-model=\"vm.employe.Horaires.Vendredi.Heures[$index].a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><md-button \nng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.employe.Horaires.Vendredi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.employe.Horaires.Vendredi.Heures.push({})\">+ Ajouter un horaire</md-button></td></tr></table></td></tr>\n</table><table><tr><td><md-switch ng-model=\"vm.employe.Horaires.Samedi.Etat\" aria-label=\"Samedi\" \nng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">Samedi</md-switch></td><td><table \nng-if=\"vm.employe.Horaires.Samedi.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.employe.Horaires.Samedi.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-select required ng-model=\"vm.employe.Horaires.Samedi.Heures[$index].de\" \nplaceholder=\"De\"><md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option>\n</md-select>-<md-select required ng-model=\"vm.employe.Horaires.Samedi.Heures[$index].a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><md-button \nng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.employe.Horaires.Samedi.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.employe.Horaires.Samedi.Heures.push({})\">+ Ajouter un horaire</md-button></td></tr></table></td></tr>\n</table><table><tr><td><md-switch ng-model=\"vm.employe.Horaires.Dimanche.Etat\" aria-label=\"Dimanche\" \nng-true-value=\"\'Ouvert\'\" ng-false-value=\"\'Fermé\'\">Dimanche</md-switch></td><td><table \nng-if=\"vm.employe.Horaires.Dimanche.Etat == \'Ouvert\'\"><tr \nng-repeat=\"Heures in vm.employe.Horaires.Dimanche.Heures track by $index\"><td><div layout=\"row\" \nlayout-align=\"space-between center\"><md-select required ng-model=\"vm.employe.Horaires.Dimanche.Heures[$index].de\" \nplaceholder=\"De\"><md-option ng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option>\n</md-select>-<md-select required ng-model=\"vm.employe.Horaires.Dimanche.Heures[$index].a\" placeholder=\"à\"><md-option \nng-repeat=\"horaires in vm.horaires\" value=\"{{horaires}}\" required>{{horaires}}</md-option></md-select><md-button \nng-disabled=\"$index == 0\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.employe.Horaires.Dimanche.Heures.splice($index, 1)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></td></tr><tr><td><md-button aria-label=\"+ Ajouter un numéro\" \nng-click=\"vm.employe.Horaires.Dimanche.Heures.push({})\">+ Ajouter un horaire</md-button></td></tr></table></td></tr>\n</table></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" \nng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveEmploye()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\">\n<span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/employes/profil/dialogs/about/internet-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content><span class=\"md-title\">Sites internet</span><p>\nIndiquez les différents sites internet que possède cette personne.</p><div layout=\"row\" \nng-repeat=\"Sites in vm.employe.Sites track by $index\"><md-input-container md-no-float flex><label ng-if=\"$index == 0\">\nSite internet principal</label><label ng-if=\"$index != 0\">Site internet suplémentaire</label><input \nng-model=\"vm.employe.Sites[$index]\" type=\"url\" required placeholder=\"http://\"></md-input-container><md-button \nng-if=\"$index != 0\" class=\"md-secondary md-icon-button\" ng-click=\"vm.employe.Sites.splice($index, 1)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div layout=\"row\"><md-button \nng-click=\"vm.employe.Sites.push([])\">+ Ajouter un site</md-button></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button>\n<md-button type=\"submit\" ng-click=\"vm.saveEmploye()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/employes/profil/dialogs/about/telephones-dialog.html","<md-dialog class=\"about-dialog\" flex=\"80\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content><span class=\"md-title\">Téléphones</span><p>\nIndiquez les différents numéros de téléphone que possède cette personne.</p><div layout=\"row\" \nng-repeat=\"telephone in vm.employe.Telephones track by $index\"><md-input-container md-no-float flex><label \nng-if=\"$index == 0\">Téléphone principal</label><label ng-if=\"$index != 0\">Téléphone suplémentaire</label><input \nng-model=\"vm.employe.Telephones[$index]\" type=\"phone\" minlength=\"10\" maxlength=\"16\" \nng-pattern=\"/^(0|\\+33)[1-9]([-. ]?[0-9]{2}){4}$/\" required></md-input-container><md-button ng-if=\"$index != 0\" \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.employe.Telephones.splice($index, 1)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div layout=\"row\"><md-button \nng-click=\"vm.employe.Telephones.push([])\">+ Ajouter un numéro</md-button></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button>\n<md-button type=\"submit\" ng-click=\"vm.saveEmploye()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/employes/profil/dialogs/about/vehicules-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><form name=\"employeForm\" class=\"md-inline-form\" novalidate><md-dialog-content\n ms-scroll><span class=\"md-title\">Votre véhicule</span><p></p><div layout=\"row\"><md-input-container class=\"md-block\" \nmd-no-float flex><label>Ordre</label><md-select ng-model=\"vm.datastoEdit.PrincipalOuSecondaire\" placeholder=\"Ordre\" \nrequired><md-option value=\"Principal\">Principal</md-option><md-option value=\"Secondaire\">Secondaire</md-option>\n</md-select></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float flex><label>\nType de véhicule</label><md-select ng-model=\"vm.datastoEdit.Type\" placeholder=\"Type de véhicule\" required><md-option \nvalue=\"Automobile / Utilitaire\">Automobile / Utilitaire</md-option><md-option value=\"Moto / Scooter\">Moto / Scooter\n</md-option><md-option value=\"Cyclomoteur\">Cyclomoteur</md-option><md-option value=\"Vélo\">Vélo</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Marque</label><input \nng-model=\"vm.datastoEdit.Marque\" type=\"text\" ng-required=\"vm.datastoEdit.Type\"></md-input-container></div><div \nlayout=\"row\"><md-input-container md-no-float flex><label>Modèle</label><input ng-model=\"vm.datastoEdit.Modele\" \ntype=\"text\" ng-required=\"vm.datastoEdit.Type && vm.datastoEdit.Type!=\'Vélo\' && vm.datastoEdit.Type!=\'Cyclomoteur\'\">\n</md-input-container></div><div layout=\"row\" ng-show=\"vm.datastoEdit.Type && vm.datastoEdit.Type!=\'Vélo\'\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Energie</label><md-select \nng-model=\"vm.datastoEdit.Energie\" placeholder=\"Energie\" \nng-required=\"vm.datastoEdit.Type && vm.datastoEdit.Type!=\'Vélo\'\"><md-option value=\"Diesel\">Diesel</md-option><md-option\n value=\"Electrique\">Electrique</md-option><md-option value=\"Essence\">Essence</md-option><md-option value=\"Hydrogène\">\nHydrogène</md-option><md-option value=\"Autre\">Autre</md-option></md-select></md-input-container></div><div \nlayout=\"row\" ng-show=\"vm.datastoEdit.Type && vm.datastoEdit.Type!=\'Vélo\' && vm.datastoEdit.Type!=\'Cyclomoteur\'\">\n<md-input-container class=\"md-block\" md-no-float flex><label>Puissance fiscale</label><md-select \nng-model=\"vm.datastoEdit.Fiscale\" placeholder=\"Puissance fiscale\" \nng-required=\"vm.datastoEdit.Type && vm.datastoEdit.Type!=\'Vélo\' && vm.datastoEdit.Type!=\'Cyclomoteur\'\"><md-option \nvalue=\"1 CV\">1 CV</md-option><md-option value=\"2 CV\">2 CV</md-option><md-option value=\"3 CV\">3 CV</md-option><md-option\n value=\"4 CV\">4 CV</md-option><md-option value=\"5 CV\">5 CV</md-option><md-option value=\"6 CV\">6 CV</md-option>\n<md-option value=\"7 CV\">7 CV</md-option><md-option value=\"8 CV\">8 CV</md-option><md-option value=\"9 CV\">9 CV\n</md-option><md-option value=\"10 CV\">10 CV</md-option><md-option value=\">10 CV\">> 10 CV</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container md-no-float flex><label>Immatriculation</label><input \nng-model=\"vm.datastoEdit.Immatriculation\" type=\"text\"></md-input-container></div><div layout=\"row\" \nng-show=\"vm.datastoEdit.Type && vm.datastoEdit.Type!=\'Vélo\'\"><md-input-container md-no-float flex><label>\nTaux de CO² (g/km)</label><input ng-model=\"vm.datastoEdit.CO2\" type=\"text\" \nng-required=\"vm.datastoEdit.Type && vm.datastoEdit.Type!=\'Vélo\'\"></md-input-container></div><div layout=\"row\">\n<md-input-container md-no-float flex><label>Commentaires</label><textarea ng-model=\"vm.datastoEdit.Commentaires\" \ntype=\"text\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeDialog();\" class=\"\" ng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" \nng-click=\"vm.saveVehicules()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\"><span ng-show=\"!vm.showSpinner\">Appliquer\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.showSpinner\"></md-progress-circular>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/employes/profil/dialogs/image/avatar-dialog.html","<md-dialog class=\"about-dialog\" flex=\"66\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Votre photo de profil</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"icon\"></md-icon></md-button></div></md-toolbar><form name=\"employeForm\" class=\"md-inline-form\" novalidate>\n<md-dialog-content ms-scroll><md-button ng-click=\"vm.selectImage($event)\" ng-hide=\"vm.employe.Avatar\" \nclass=\"border md-accent mb-16 ml-0\" layout=\"column\" layout-align=\"center center\" style=\"height:310px;width:100%\">\n<md-icon style=\"margin:0\" class=\"s50\" md-font-icon=\"icon-camera\"></md-icon><p>Mettez votre profil en valeur<br>\navec une photo</p></md-button><div ng-show=\"vm.employe.Avatar\" class=\"border md-accent mb-16\" layout=\"column\" \nlayout-align=\"center center\" style=\"height:310px;width:100%;overflow:hidden;position:relative\"><img \nsrc=\"{{vm.employe.Avatar}}\" style=\"width:auto; max-width:100%; height:auto\"><div \nstyle=\"position:absolute;right:5px; bottom:5px\"><md-button class=\"md-fab md-mini\" ng-click=\"vm.selectImage($event)\">\n<md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button class=\"md-fab md-mini\" \nng-click=\"vm.employe.Avatar=\'\'\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.closeDialog()\" class=\"\" \nng-disabled=\"vm.showSpinner\">Annuler</md-button><md-button type=\"submit\" ng-click=\"vm.saveAvatar()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"employeForm.$invalid || vm.showSpinner\" aria-label=\"Appliquer\">\n<span ng-show=\"!vm.showSpinner\">Appliquer</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.showSpinner\"></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/parametres/employes/profil/tabs/logs/logs.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profil-box coord-box info-box general border brad-16\" layout=\"column\" style=\"overflow:hidden\"><div \nclass=\"content-card main scrollable\" flex=\"100\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable dt-instance=\"vm.dtInstance\" dt-columns=\"vm.dtColumns\" dt-options=\"vm.dtOptions\"></table></div></div></div>\n</div>");
$templateCache.put("app/main/parametres/employes/profil/tabs/about/about.html","<div layout=\"row\" layout-wrap layout-align=\"space-between stretch\"><div layout=\"row\" layout-wrap flex-gt-lg=\"80\" \nflex-lg=\"100\" flex=\"100\"><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"60\" flex-gt-md=\"65\" flex-order=\"1\" \nflex-order-gt-sm=\"1\"><div class=\"profil-box coord-box info-box general brad-16 border\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\">Informations générales</div>\n</header><div class=\"content\"><md-list class=\"p-0\"><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>\n<strong>Date de création :</strong> {{vm.employe.DateCreation}}</h4><h4><strong>Dernière connection :</strong>\n {{vm.employe.DerniereConnexion}}</h4></div></md-list-item></md-list><md-list><md-list-item class=\"md-2-line\"><div \nclass=\"md-list-item-text\"><h4><strong>Données générales</strong></h4><div class=\"info\"><p \nclass=\"font-weight-500 generales\">Identité :</p><span>\n{{vm.employe.Civilite}} {{vm.employe.Prenom}} {{vm.employe.Nom|uppercase}}</span></div><div class=\"info\"><p \nclass=\"font-weight-500 generales\">E-mail :</p><span>{{vm.employe.Email}}</span></div><div class=\"info\"><p \nclass=\"font-weight-500 generales\">Mot de passe :</p><span>&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;\n</span></div><div class=\"info\" ng-show=\"vm.employe.DateNaissance\"><p class=\"font-weight-500 generales\">\nDate de naissance :</p><span>{{vm.convertDate(vm.employe.DateNaissance)}}</span></div><div class=\"info\"><p \nclass=\"font-weight-500 generales\">Rôle :</p><span>{{vm.employe.Permission}}</span></div><div class=\"info\"><p \nclass=\"font-weight-500 generales\">Activités et présence :</p><span>{{vm.employe.Presence}}</span></div><div \nclass=\"info\" ng-if=\"vm.IDEmploye != vm.employe.IDEmploye\"><p class=\"font-weight-500 generales\">Données visibles :</p>\n<span ng-show=\"vm.employe.UniquementSesValeurs\">Ne peut voir que les données le concernant parmi ses permissions</span>\n<span ng-hide=\"vm.employe.UniquementSesValeurs\">\nPeut voir toutes les données parmi ses permissions et celles inférieures</span></div><div class=\"info\" \nng-if=\"vm.IDEmploye != vm.employe.IDEmploye\"><p class=\"font-weight-500 generales\">Notifications visibles :</p><span \nng-show=\"vm.employe.VoirNotificationsAutres\">Peut voir toutes les notifications</span><span \nng-hide=\"vm.employe.VoirNotificationsAutres\">Ne peut voir que ses notifications</span></div></div><md-button \nclass=\"md-icon-button md-secondary\" ng-click=\"vm.editer($event, \'generales\')\"><md-tooltip md-direction=\"left\">\nModifier les paramètres généraux</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\" class=\"icon\"></md-icon>\n</md-button></md-list-item></md-list><md-list \nng-if=\"(vm.employe.Commission!=0 && vm.employe.Commission!=\'\') || vm.IDEmploye != vm.employe.IDEmploye\"><md-list-item \nclass=\"md-2-line\"><div class=\"md-list-item-text\"><h4><strong>Commissions</strong></h4><div class=\"info\"><span \nng-show=\"vm.employe.Commission!=0\">{{vm.employe.Commission}} %</span> <span ng-show=\"vm.employe.Commission==\'\'\">\nPas de commission</span></div></div><md-button class=\"md-icon-button md-secondary\" \nng-click=\"vm.editer($event, \'commissions\')\" ng-if=\"vm.IDEmploye != vm.employe.IDEmploye\"><md-tooltip \nmd-direction=\"left\">Modifier les commissions</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\" class=\"icon\">\n</md-icon></md-button></md-list-item></md-list><md-list><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\">\n<h4><strong>Horaires</strong></h4><div class=\"info\" ng-repeat=\"(key,Horaires) in vm.employe.Horaires track by $index\" \nng-show=\"vm.employe.Horaires\" class=\"animate-if\"><p class=\"font-weight-500 jour-horaire\">{{key}}:</p><span \nng-if=\"Horaires.Etat == \'Fermé\'\">Fermé </span><span ng-repeat=\"Heures in Horaires.Heures\" \nng-if=\"Horaires.Etat == \'Ouvert\'\">{{Heures.de}} à {{Heures.a}} <span ng-if=\"!$last\">-</span></span></div></div>\n<md-button class=\"md-icon-button md-secondary\" ng-click=\"vm.editer($event, \'horaires\')\"><md-tooltip \nmd-direction=\"left\">Modifier les horaires</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\" class=\"icon\"></md-icon>\n</md-button></md-list-item></md-list><md-list><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4>\n<strong>Site(s) internet</strong></h4><div class=\"info\" ng-show=\"vm.employe.Sites.length<=0\" class=\"animate-if\"><em \nstyle=\"color:red\">Non renseigné</em></div><div class=\"info\" ng-show=\"vm.employe.Sites\" \nng-repeat=\"site in vm.employe.Sites\"><a href=\"{{site}}\" target=\"_blank\">{{site}}</a></div></div><md-button \nclass=\"md-icon-button md-secondary\" ng-click=\"vm.editer($event, \'internet\')\"><md-tooltip md-direction=\"left\">\nModifier les sites</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\" class=\"icon\"></md-icon></md-button>\n</md-list-item></md-list><md-list><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h4><strong>\nTéléphone(s)</strong></h4><div class=\"info\" ng-show=\"vm.employe.Telephones.length<=0\" class=\"animate-if\"><em \nstyle=\"color:red\">Non renseigné</em></div><div class=\"info\" ng-show=\"vm.employe.Telephones\" \nng-repeat=\"telephone in vm.employe.Telephones\"><a href=\"tel:{{telephone}}\" target=\"_blank\">{{telephone|phoneNumber}}\n</a></div></div><md-button class=\"md-icon-button md-secondary\" ng-click=\"vm.editer($event, \'telephones\')\"><md-tooltip \nmd-direction=\"left\">Modifier les numéros</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\" class=\"icon\"></md-icon>\n</md-button></md-list-item></md-list></div></div><div class=\"profil-box coord-box info-box work brad-16 border\" \nlayout=\"column\"><header class=\"md-accent-bg pb-8 pt-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"title\">Adresse(s)</div><md-button class=\"md-icon-button\" ng-click=\"vm.editer($event, \'adresses\')\"><md-tooltip \nmd-direction=\"left\">Ajouter</md-tooltip><md-icon md-font-icon=\"icon-plus-box\" class=\"icon\"></md-icon></md-button>\n</header><div class=\"content\"><md-list><md-list-item class=\"md-3-line md-no-proxy\" \nng-repeat=\"adresse in vm.employe.Adresses\"><div class=\"md-list-item-text\"><h4>{{adresse.NomAdresse}} <small>\n({{adresse.PrincipalOuSecondaire}})</small></h4><p layout=\"row\"><a \nhref=\"https://www.google.com/maps/search/{{adresse.AdresseComplete}}/@{{adresse.Latitude}},{{adresse.Longitude}},z=13\" \ntarget=\"_blank\">{{adresse.AdresseComplete}}</a></p><p layout=\"row\" ng-show=\"adresse.SIRET\">SIRET : {{adresse.SIRET}}\n</p></div><md-menu class=\"md-secondary\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-tooltip \nmd-direction=\"left\">Modifier</md-tooltip><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.editer($event, \'adresses\', adresse)\">Modifier\n</md-button></md-menu-item><md-divider ng-if=\"vm.user.groups\"></md-divider><md-menu-item><md-button \nng-click=\"vm.deleteAdresse($event, adresse)\">Supprimer</md-button></md-menu-item></md-menu-content></md-menu>\n<md-divider ng-hide=\"$last\"></md-divider></md-list-item></md-list></div></div><div \nclass=\"profil-box coord-box info-box work brad-16 border\" layout=\"column\"><header class=\"md-accent-bg pb-8 pt-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title\">Véhicule(s)</div><md-button class=\"md-icon-button\" \nng-click=\"vm.editer($event, \'vehicules\')\"><md-tooltip md-direction=\"left\">Ajouter</md-tooltip><md-icon \nmd-font-icon=\"icon-plus-box\" class=\"icon\"></md-icon></md-button></header><div class=\"content\"><md-list><md-list-item \nclass=\"md-3-line md-no-proxy\" ng-repeat=\"vehicule in vm.employe.Vehicules\"><div class=\"md-list-item-text\"><h4>\n{{vehicule.Type}} {{vehicule.Marque}} {{vehicule.Modele}} <small>({{vehicule.PrincipalOuSecondaire}})</small></h4><p \nlayout=\"row\" ng-show=\"vehicule.Immatriculation\">Immatriculation : {{vehicule.Immatriculation}}</p><p layout=\"row\" \nng-show=\"vehicule.Energie\">Energie : {{vehicule.Energie}}</p><p layout=\"row\" ng-show=\"vehicule.Puissance\">\nPuissance fiscale : {{vehicule.Puissance}}</p><p layout=\"row\" ng-show=\"vehicule.CO2\">\nTaux de CO² : {{vehicule.CO2}} g/km</p><p layout=\"row\" ng-show=\"vehicule.Commentaires\">\nCommentaires : {{vehicule.Commentaires}}</p></div><md-menu class=\"md-secondary\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-tooltip md-direction=\"left\">Modifier</md-tooltip><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.editer($event, \'vehicules\', vehicule)\">Modifier</md-button></md-menu-item><md-divider \nng-if=\"vm.user.groups\"></md-divider><md-menu-item><md-button ng-click=\"vm.deleteVehicule($event, vehicule)\">Supprimer\n</md-button></md-menu-item></md-menu-content></md-menu><md-divider ng-hide=\"$last\"></md-divider></md-list-item>\n</md-list></div></div></div><div class=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"40\" flex-gt-md=\"35\" \nflex-order=\"0\" flex-order-gt-sm=\"2\"></div></div></div>");}]);